import { Attachment as e, Avatar as t, Badge as n, Banner as r, Box as i, Button as a, Checkbox as o, CollapseCard as s, CopyToClipboardButton as c, Divider as l, EmptyState as u, ErrorBoundary as d, ErrorBoundaryContext as f, FieldLabel as p, FieldSwitch as m, FieldText as h, FieldTextarea as g, FieldWrapper as _, FlexBox as v, FormField as y, FormGrid as b, Icon as x, IconButton as S, Image as C, InputSelectionList as w, InputText as T, List as E, Modal as D, ModalBody as O, ModalFoot as k, ModalHead as A, NavigationButton as j, Select as M, SelectionList as N, Spinner as P, Switch as ee, Table as F, Tag as I, TagsInput as te, Text as L, TextWithHighlight as ne, Textarea as re, Timestamp as ie, Tooltip as R, getSelectionListContext as ae } from "@dixa/lib-shared-habla";
import { DisplayErrors as z, IntegrationModal as oe, MisconfigurationBanner as se, OAuthSettings as ce, PartnerHookFormBasicAuth as le, PartnerHookFormSecretText as ue, PartnerSettingsWrapper as de, WidgetContextProvider as fe, WidgetSettingsFormFooter as pe, capitalizeFirstCharacter as me, defaultDateFormat as he, displayAttributeValue as ge, getCountryNameFromCountryCode as _e, getPartnerDevApiHeaders as ve, handleWidgetSubmit as ye, hasDownstreamApiAuthorizationError as be, hasDownstreamApiForbiddenError as xe, hasDownstreamApiNotFoundError as Se, hasDownstreamApiPermissionError as Ce, hasDownstreamApiTooManyRequestsError as we, humanizeKey as Te, isDownstreamApiAuthorizationError as Ee, isDownstreamApiNotFoundError as De, isDownstreamApiPermissionError as Oe, isRunningLocalPartnerApi as ke, makeExecuteQuery as Ae, makeUseLazyQuery as je, makeUseMutation as Me, makeUseQuery as Ne, mapLabels as Pe, parseBoolean as Fe, parseString as Ie, settingsToFormValues as Le, useCopyWithDelay as Re, useData as ze, useInboundOAuthContext as Be, useTracking as Ve, useWidgetContext as B, useWidgetSettingsMutations as He, useWidgetSettingsQuery as Ue, validateApiHostName as We } from "lib-integrations-partner-support";
import V, { Fragment as Ge, createContext as Ke, createElement as qe, isValidElement as Je, useCallback as Ye, useContext as Xe, useEffect as H, useLayoutEffect as Ze, useMemo as Qe, useReducer as $e, useRef as et, useState as U } from "react";
import { ApolloClient as tt, ApolloConsumer as nt, ApolloError as rt, ApolloLink as it, ApolloProvider as at, InMemoryCache as ot, NetworkStatus as st, Observable as ct, createHttpLink as lt, gql as ut, isApolloError as dt, useApolloClient as ft } from "@apollo/client";
import pt from "cross-fetch";
import { config as mt } from "lib-shared-backend-config";
import { Fragment as W, jsx as G, jsxs as K } from "react/jsx-runtime";
import ht from "classnames";
import gt from "moment";
import _t from "lodash/pick";
import "moment-timezone";
import "lodash/omit";
import vt from "lodash/identity";
import { __assign as yt, __rest as bt } from "tslib";
export * from "lib-integrations-partner-support";
//#region \0rolldown/runtime.js
var xt = Object.create, St = Object.defineProperty, Ct = Object.getOwnPropertyDescriptor, wt = Object.getOwnPropertyNames, Tt = Object.getPrototypeOf, Et = Object.prototype.hasOwnProperty, Dt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Ot = (e, t) => {
	let n = {};
	for (var r in e) St(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || St(n, Symbol.toStringTag, { value: "Module" }), n;
}, kt = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = wt(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Et.call(e, s) && s !== n && St(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Ct(t, s)) || r.enumerable
	});
	return e;
}, At = (e, t, n) => (n = e == null ? {} : xt(Tt(e)), kt(t || !e || !e.__esModule ? St(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region ../../../node_modules/axios/lib/helpers/bind.js
function jt(e, t) {
	return function() {
		return e.apply(t, arguments);
	};
}
//#endregion
//#region ../../../node_modules/axios/lib/utils.js
var { toString: Mt } = Object.prototype, { getPrototypeOf: Nt } = Object, { iterator: Pt, toStringTag: Ft } = Symbol, It = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Lt = (e) => typeof e == "string" && (e === "__proto__" || e === "constructor" || e === "prototype"), Rt = (e, t, n) => e === Object.prototype || !n && t === null, zt = (e) => {
	if (!Object.isExtensible(e)) return !1;
	let t = Object.getOwnPropertyNames(e);
	return Object.getOwnPropertySymbols && t.push(...Object.getOwnPropertySymbols(e)), t.every((t) => {
		if (Lt(t)) return !1;
		let n = Object.getOwnPropertyDescriptor(e, t);
		return !!n && n.configurable && n.writable === !0;
	});
}, Bt = (e, t) => {
	let n = e, r = [];
	for (; n != null;) {
		if (r.indexOf(n) !== -1) return !1;
		r.push(n);
		let i = Nt(n);
		if (Rt(n, i, n === e)) return !1;
		if (It(n, t)) return !0;
		n = i;
	}
	return !1;
}, Vt = (e, t) => e != null && Bt(e, t) ? e[t] : void 0, Ht = (e) => {
	if (e == null || typeof e != "object" && typeof e != "function") return e;
	let t = Nt(e);
	if (t === null && zt(e)) return e;
	let n = Object.create(null), r = Object.create(null), i = [], a = e;
	for (; a != null && i.indexOf(a) === -1;) {
		i.push(a);
		let o = a === e ? t : Nt(a);
		if (Rt(a, o, a === e)) break;
		let s = Object.getOwnPropertyNames(a);
		Object.getOwnPropertySymbols && s.push(...Object.getOwnPropertySymbols(a));
		for (let t of s) Lt(t) || It(r, t) || (n[t] = e[t], r[t] = !0);
		a = o;
	}
	return n;
}, Ut = ((e) => (t) => {
	let n = Mt.call(t);
	return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(Object.create(null)), Wt = (e) => (e = e.toLowerCase(), (t) => Ut(t) === e), Gt = (e) => (t) => typeof t === e, { isArray: Kt } = Array, qt = Gt("undefined");
function Jt(e) {
	return e !== null && !qt(e) && e.constructor !== null && !qt(e.constructor) && Qt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Yt = Wt("ArrayBuffer");
function Xt(e) {
	let t;
	return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Yt(e.buffer), t;
}
var Zt = Gt("string"), Qt = Gt("function"), $t = Gt("number"), en = (e) => typeof e == "object" && !!e, tn = (e) => e === !0 || e === !1, nn = (e) => {
	if (!en(e)) return !1;
	let t = Nt(e);
	return (t === null || t === Object.prototype || Nt(t) === null) && !Bt(e, Ft) && !Bt(e, Pt);
}, rn = (e) => {
	if (!en(e) || Jt(e)) return !1;
	try {
		return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
	} catch {
		return !1;
	}
}, an = Wt("Date"), on = Wt("File"), sn = (e) => !!(e && e.uri !== void 0), cn = (e) => e && e.getParts !== void 0, ln = Wt("Blob"), un = Wt("FileList"), dn = Wt("Set"), fn = (e) => en(e) && Qt(e.pipe);
function pn() {
	return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var mn = pn(), hn = mn.FormData === void 0 ? void 0 : mn.FormData, gn = (e) => {
	if (!e) return !1;
	if (hn && e instanceof hn) return !0;
	let t = Nt(e);
	if (!t || t === Object.prototype || !Qt(e.append)) return !1;
	let n = Ut(e);
	return n === "formdata" || n === "object" && Qt(e.toString) && e.toString() === "[object FormData]";
}, _n = Wt("URLSearchParams"), [vn, yn, bn, xn] = [
	"ReadableStream",
	"Request",
	"Response",
	"Headers"
].map(Wt), Sn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Cn(e, t, { allOwnKeys: n = !1 } = {}) {
	if (e == null) return;
	let r, i;
	if (typeof e != "object" && (e = [e]), Kt(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
	else {
		if (Jt(e)) return;
		let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
		for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
	}
}
function wn(e, t) {
	if (Jt(e)) return null;
	t = t.toLowerCase();
	let n = Object.keys(e), r = n.length, i;
	for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
	return null;
}
var Tn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, En = (e) => !qt(e) && e !== Tn;
function Dn(...e) {
	let { caseless: t, skipUndefined: n } = En(this) && this || {}, r = {}, i = (e, i) => {
		if (i === "__proto__" || i === "constructor" || i === "prototype") return;
		let a = t && typeof i == "string" && wn(r, i) || i, o = It(r, a) ? r[a] : void 0;
		nn(o) && nn(e) ? r[a] = Dn(o, e) : nn(e) ? r[a] = Dn({}, e) : Kt(e) ? r[a] = e.slice() : (!n || !qt(e)) && (r[a] = e);
	};
	for (let t = 0, n = e.length; t < n; t++) {
		let n = e[t];
		if (!n || Jt(n) || (Cn(n, i), typeof n != "object" || Kt(n))) continue;
		let r = Object.getOwnPropertySymbols(n);
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			zn.call(n, t) && i(n[t], t);
		}
	}
	return r;
}
var On = (e, t, n, { allOwnKeys: r } = {}) => (Cn(t, (t, r) => {
	n && Qt(t) ? Object.defineProperty(e, r, {
		__proto__: null,
		value: jt(t, n),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : Object.defineProperty(e, r, {
		__proto__: null,
		value: t,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}, { allOwnKeys: r }), e), kn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), An = (e, t, n, r) => {
	e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
		__proto__: null,
		value: e,
		writable: !0,
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e, "super", {
		__proto__: null,
		value: t.prototype
	}), n && Object.assign(e.prototype, n);
}, jn = (e, t, n, r) => {
	let i, a, o, s = {};
	if (t ||= {}, e == null) return t;
	do {
		for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;) o = i[a], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
		e = n !== !1 && Nt(e);
	} while (e && (!n || n(e, t)) && e !== Object.prototype);
	return t;
}, Mn = (e, t, n) => {
	e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
	let r = e.indexOf(t, n);
	return r !== -1 && r === n;
}, Nn = (e) => {
	if (!e) return null;
	if (Kt(e)) return e;
	let t = e.length;
	if (!$t(t)) return null;
	let n = Array(t);
	for (; t-- > 0;) n[t] = e[t];
	return n;
}, Pn = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Nt(Uint8Array)), Fn = (e, t) => {
	let n = (e && e[Pt]).call(e), r;
	for (; (r = n.next()) && !r.done;) {
		let n = r.value;
		t.call(e, n[0], n[1]);
	}
}, In = (e, t) => {
	let n, r = [];
	for (; (n = e.exec(t)) !== null;) r.push(n);
	return r;
}, Ln = Wt("HTMLFormElement"), Rn = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
	return t.toUpperCase() + n;
}), { propertyIsEnumerable: zn } = Object.prototype, Bn = Wt("RegExp"), Vn = (e, t) => {
	let n = Object.getOwnPropertyDescriptors(e), r = {};
	Cn(n, (n, i) => {
		let a;
		(a = t(n, i, e)) !== !1 && (r[i] = a || n);
	}), Object.defineProperties(e, r);
}, Hn = (e) => {
	Vn(e, (t, n) => {
		if (Qt(e) && [
			"arguments",
			"caller",
			"callee"
		].includes(n)) return !1;
		let r = e[n];
		if (Qt(r)) {
			if (t.enumerable = !1, "writable" in t) {
				t.writable = !1;
				return;
			}
			t.set ||= () => {
				throw Error("Can not rewrite read-only method '" + n + "'");
			};
		}
	});
}, Un = (e, t) => {
	let n = {}, r = (e) => {
		e.forEach((e) => {
			n[e] = !0;
		});
	};
	return Kt(e) ? r(e) : r(String(e).split(t)), n;
}, Wn = () => {}, Gn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Kn(e) {
	return !!(e && Qt(e.append) && e[Ft] === "FormData" && e[Pt]);
}
var qn = (e) => {
	let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
		if (en(e)) {
			if (t.has(e)) return;
			if (Jt(e)) return e;
			if (!("toJSON" in e)) {
				t.add(e);
				let r;
				if (dn(e)) {
					r = [];
					for (let t of e) {
						let e = n(t);
						!qt(e) && r.push(e);
					}
				} else r = Kt(e) ? [] : {}, Cn(e, (e, t) => {
					let i = n(e);
					!qt(i) && (r[t] = i);
				});
				return t.delete(e), r;
			}
		}
		return e;
	};
	return n(e);
}, Jn = Wt("AsyncFunction"), Yn = (e) => e && (en(e) || Qt(e)) && Qt(e.then) && Qt(e.catch), Xn = ((e, t) => e ? setImmediate : t ? ((e, t) => (Tn.addEventListener("message", ({ source: n, data: r }) => {
	n === Tn && r === e && t.length && t.shift()();
}, !1), (n) => {
	t.push(n), Tn.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", Qt(Tn.postMessage)), Zn = typeof queueMicrotask < "u" ? queueMicrotask.bind(Tn) : typeof process < "u" && process.nextTick || Xn, Qn = (e) => e != null && Qt(e[Pt]), q = {
	isArray: Kt,
	isArrayBuffer: Yt,
	isBuffer: Jt,
	isFormData: gn,
	isArrayBufferView: Xt,
	isString: Zt,
	isNumber: $t,
	isBoolean: tn,
	isObject: en,
	isPlainObject: nn,
	isEmptyObject: rn,
	isReadableStream: vn,
	isRequest: yn,
	isResponse: bn,
	isHeaders: xn,
	isUndefined: qt,
	isDate: an,
	isFile: on,
	isReactNativeBlob: sn,
	isReactNative: cn,
	isBlob: ln,
	isRegExp: Bn,
	isFunction: Qt,
	isStream: fn,
	isURLSearchParams: _n,
	isTypedArray: Pn,
	isFileList: un,
	forEach: Cn,
	merge: Dn,
	extend: On,
	trim: Sn,
	stripBOM: kn,
	inherits: An,
	toFlatObject: jn,
	kindOf: Ut,
	kindOfTest: Wt,
	endsWith: Mn,
	toArray: Nn,
	forEachEntry: Fn,
	matchAll: In,
	isHTMLForm: Ln,
	hasOwnProperty: It,
	hasOwnProp: It,
	hasOwnInPrototypeChain: Bt,
	getSafeProp: Vt,
	toSafeFlatObject: Ht,
	reduceDescriptors: Vn,
	freezeMethods: Hn,
	toObjectSet: Un,
	toCamelCase: Rn,
	noop: Wn,
	toFiniteNumber: Gn,
	findKey: wn,
	global: Tn,
	isContextDefined: En,
	isSpecCompliantForm: Kn,
	toJSONObject: qn,
	isAsyncFn: Jn,
	isThenable: Yn,
	setImmediate: Xn,
	asap: Zn,
	isIterable: Qn,
	isSafeIterable: (e) => e != null && Bt(e, Pt) && Qn(e)
}, $n = q.toObjectSet([
	"age",
	"authorization",
	"content-length",
	"content-type",
	"etag",
	"expires",
	"from",
	"host",
	"if-modified-since",
	"if-unmodified-since",
	"last-modified",
	"location",
	"max-forwards",
	"proxy-authorization",
	"referer",
	"retry-after",
	"user-agent"
]), er = (e) => {
	let t = {}, n, r, i;
	return e && e.split("\n").forEach(function(e) {
		i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim();
		let a = q.hasOwnProp(t, n);
		!n || a && q.hasOwnProp($n, n) || (n === "set-cookie" ? a ? t[n].push(r) : t[n] = [r] : t[n] = a ? t[n] + ", " + r : r);
	}), t;
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/sanitizeHeaderValue.js
function tr(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
var nr = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), rr = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function ir(e, t) {
	return q.isArray(e) ? e.map((e) => ir(e, t)) : tr(String(e).replace(t, ""));
}
var ar = (e) => ir(e, nr), or = (e) => ir(e, rr);
function sr(e) {
	let t = Object.create(null);
	return q.forEach(e.toJSON(), (e, n) => {
		t[n] = or(e);
	}), t;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/AxiosHeaders.js
var cr = Symbol("internals");
function lr(e) {
	return e && String(e).trim().toLowerCase();
}
function ur(e) {
	return e === !1 || e == null ? e : q.isArray(e) ? e.map(ur) : ar(String(e));
}
function dr(e) {
	let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
	for (; r = n.exec(e);) t[r[1]] = r[2];
	return t;
}
var fr = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function pr(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
function mr(e) {
	let t = e.length - 1;
	if (t < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(t) !== 34) return e;
	let n = "";
	for (let r = 1; r < t; r++) {
		let i = e.charCodeAt(r);
		if (i === 34 || i === 92 && (r += 1, r >= t)) return e;
		n += e[r];
	}
	return n;
}
function hr(e) {
	let t = Object.create(null), n = String(e), r = 0, i = !1, a = !1;
	function o(e) {
		let i = pr(n.slice(r, e)), a = i.indexOf("=");
		if (a < 1) return;
		let o = pr(i.slice(0, a));
		if (!fr.test(o)) return;
		let s = o.toLowerCase();
		if (s === "__proto__" || s === "constructor" || s === "prototype") return;
		let c = pr(i.slice(a + 1));
		t[s] = mr(c);
	}
	for (let e = 0; e < n.length; e++) {
		let t = n.charCodeAt(e);
		i ? a ? a = !1 : t === 92 ? a = !0 : t === 34 && (i = !1) : t === 34 ? i = !0 : (t === 44 || t === 59) && (o(e), r = e + 1);
	}
	return o(n.length), t;
}
var gr = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function _r(e, t, n, r, i) {
	if (q.isFunction(r)) return r.call(this, t, n);
	if (i && (t = n), q.isString(t)) {
		if (q.isString(r)) return t.indexOf(r) !== -1;
		if (q.isRegExp(r)) return r.test(t);
	}
}
function vr(e) {
	return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function yr(e, t) {
	let n = q.toCamelCase(" " + t);
	[
		"get",
		"set",
		"has"
	].forEach((r) => {
		Object.defineProperty(e, r + n, {
			__proto__: null,
			value: function(e, n, i) {
				return this[r].call(this, t, e, n, i);
			},
			configurable: !0
		});
	});
}
var br = class {
	constructor(e) {
		e && this.set(e);
	}
	set(e, t, n) {
		let r = this;
		function i(e, t, n) {
			let i = lr(t);
			if (!i) return;
			let a = q.findKey(r, i);
			(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = ur(e));
		}
		let a = (e, t) => q.forEach(e, (e, n) => i(e, n, t));
		if (q.isPlainObject(e) || e instanceof this.constructor) a(e, t);
		else if (q.isString(e) && (e = e.trim()) && !gr(e)) a(er(e), t);
		else if (q.isObject(e) && q.isSafeIterable(e)) {
			let n = Object.create(null), r, i;
			for (let t of e) {
				if (!q.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
				i = t[0], q.hasOwnProp(n, i) ? (r = n[i], n[i] = q.isArray(r) ? [...r, t[1]] : [r, t[1]]) : n[i] = t[1];
			}
			a(n, t);
		} else e != null && i(t, e, n);
		return this;
	}
	get(e, t) {
		if (e = lr(e), e) {
			let n = q.findKey(this, e);
			if (n) {
				let e = this[n];
				if (!t) return e;
				if (t === !0) return dr(e);
				if (q.isFunction(t)) return t.call(this, e, n);
				if (q.isRegExp(t)) return t.exec(e);
				throw TypeError("parser must be boolean|regexp|function");
			}
		}
	}
	has(e, t) {
		if (e = lr(e), e) {
			let n = q.findKey(this, e);
			return !!(n && this[n] !== void 0 && (!t || _r(this, this[n], n, t)));
		}
		return !1;
	}
	delete(e, t) {
		let n = this, r = !1;
		function i(e) {
			if (e = lr(e), e) {
				let i = q.findKey(n, e);
				i && (!t || _r(n, n[i], i, t)) && (delete n[i], r = !0);
			}
		}
		return q.isArray(e) ? e.forEach(i) : i(e), r;
	}
	clear(e) {
		let t = Object.keys(this), n = t.length, r = !1;
		for (; n--;) {
			let i = t[n];
			(!e || _r(this, this[i], i, e, !0)) && (delete this[i], r = !0);
		}
		return r;
	}
	normalize(e) {
		let t = this, n = {};
		return q.forEach(this, (r, i) => {
			let a = q.findKey(n, i);
			if (a) {
				t[a] = ur(r), delete t[i];
				return;
			}
			let o = e ? vr(i) : String(i).trim();
			o !== i && delete t[i], t[o] = ur(r), n[o] = !0;
		}), this;
	}
	concat(...e) {
		return this.constructor.concat(this, ...e);
	}
	toJSON(e) {
		let t = Object.create(null);
		return q.forEach(this, (n, r) => {
			n != null && n !== !1 && (t[r] = e && q.isArray(n) ? n.join(", ") : n);
		}), t;
	}
	[Symbol.iterator]() {
		return Object.entries(this.toJSON())[Symbol.iterator]();
	}
	toString() {
		return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
	}
	getSetCookie() {
		let e = this.get("set-cookie");
		return q.isArray(e) ? e : e == null || e === !1 ? [] : [e];
	}
	get [Symbol.toStringTag]() {
		return "AxiosHeaders";
	}
	static from(e) {
		return e instanceof this ? e : new this(e);
	}
	static parseParameters(e) {
		return hr(e);
	}
	static concat(e, ...t) {
		let n = new this(e);
		return t.forEach((e) => n.set(e)), n;
	}
	static accessor(e) {
		let t = (this[cr] = this[cr] = { accessors: {} }).accessors, n = this.prototype;
		function r(e) {
			let r = lr(e);
			t[r] || (yr(n, e), t[r] = !0);
		}
		return q.isArray(e) ? e.forEach(r) : r(e), this;
	}
};
br.accessor([
	"Content-Type",
	"Content-Length",
	"Accept",
	"Accept-Encoding",
	"User-Agent",
	"Authorization"
]), q.reduceDescriptors(br.prototype, ({ value: e }, t) => {
	let n = t[0].toUpperCase() + t.slice(1);
	return {
		get: () => e,
		set(e) {
			this[n] = e;
		}
	};
}), q.freezeMethods(br);
//#endregion
//#region ../../../node_modules/axios/lib/core/AxiosError.js
var xr = "[REDACTED ****]";
function Sr(e) {
	if (q.hasOwnProp(e, "toJSON")) return !0;
	let t = Object.getPrototypeOf(e);
	for (; t && t !== Object.prototype;) {
		if (q.hasOwnProp(t, "toJSON")) return !0;
		t = Object.getPrototypeOf(t);
	}
	return !1;
}
function Cr(e, t) {
	let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
		if (typeof e != "object" || !e || q.isBuffer(e)) return e;
		if (r.indexOf(e) !== -1) return;
		e instanceof br && (e = e.toJSON()), r.push(e);
		let t;
		if (q.isArray(e)) t = [], e.forEach((e, n) => {
			let r = i(e);
			q.isUndefined(r) || (t[n] = r);
		});
		else {
			if (!q.isPlainObject(e) && Sr(e)) return r.pop(), e;
			t = Object.create(null);
			for (let [r, a] of Object.entries(e)) {
				let e = n.has(r.toLowerCase()) ? xr : i(a);
				q.isUndefined(e) || (t[r] = e);
			}
		}
		return r.pop(), t;
	};
	return i(e);
}
function wr(e) {
	try {
		return String(e);
	} catch {
		return "";
	}
}
function Tr(e) {
	return e.errors.map((e) => {
		try {
			return e && e.message ? wr(e.message) : wr(e);
		} catch {
			return "";
		}
	}).filter(Boolean).join("; ") || e.name || "AggregateError";
}
var J = class e extends Error {
	static from(t, n, r, i, a, o) {
		let s = t.message;
		!s && q.isArray(t.errors) && t.errors.length && (s = Tr(t));
		let c = new e(s, n || t.code, r, i, a);
		return Object.defineProperty(c, "cause", {
			__proto__: null,
			value: t,
			writable: !0,
			enumerable: !1,
			configurable: !0
		}), c.name = t.name, t.status != null && c.status == null && (c.status = t.status), o && Object.assign(c, o), c;
	}
	constructor(e, t, n, r, i) {
		super(e), Object.defineProperty(this, "message", {
			__proto__: null,
			value: e,
			enumerable: !0,
			writable: !0,
			configurable: !0
		}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
	}
	toJSON() {
		let e = this.config, t = e && q.hasOwnProp(e, "redact") ? e.redact : void 0, n = q.isArray(t) && t.length > 0 ? Cr(e, t) : q.toJSONObject(e);
		return {
			message: this.message,
			name: this.name,
			description: this.description,
			number: this.number,
			fileName: this.fileName,
			lineNumber: this.lineNumber,
			columnNumber: this.columnNumber,
			stack: this.stack,
			config: n,
			code: this.code,
			status: this.status
		};
	}
};
J.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", J.ERR_BAD_OPTION = "ERR_BAD_OPTION", J.ECONNABORTED = "ECONNABORTED", J.ETIMEDOUT = "ETIMEDOUT", J.ECONNREFUSED = "ECONNREFUSED", J.ERR_NETWORK = "ERR_NETWORK", J.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", J.ERR_DEPRECATED = "ERR_DEPRECATED", J.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", J.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", J.ERR_CANCELED = "ERR_CANCELED", J.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", J.ERR_INVALID_URL = "ERR_INVALID_URL", J.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
function Er(e) {
	return q.isPlainObject(e) || q.isArray(e);
}
function Dr(e) {
	return q.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Or(e, t, n) {
	return e ? e.concat(t).map(function(e, t) {
		return e = Dr(e), !n && t ? "[" + e + "]" : e;
	}).join(n ? "." : "") : t;
}
function kr(e) {
	return q.isArray(e) && !e.some(Er);
}
var Ar = q.toFlatObject(q, {}, null, function(e) {
	return /^is[A-Z]/.test(e);
});
function jr(e, t, n) {
	if (!q.isObject(e)) throw TypeError("target must be an object");
	t ||= new FormData();
	let r = (e, t) => {
		let r = q.getSafeProp(n, e);
		return q.isUndefined(r) ? t : r;
	}, i = r("metaTokens", !0), a = r("visitor") || h, o = r("dots", !1), s = r("indexes", !1), c = r("Blob") || typeof Blob < "u" && Blob, l = r("maxDepth", 100), u = c && q.isSpecCompliantForm(t), d = [];
	if (!q.isFunction(a)) throw TypeError("visitor must be a function");
	function f(e) {
		if (e === null) return "";
		if (q.isDate(e)) return e.toISOString();
		if (q.isBoolean(e)) return e.toString();
		if (!u && q.isBlob(e)) throw new J("Blob is not supported. Use a Buffer instead.");
		if (q.isArrayBuffer(e) || q.isTypedArray(e)) {
			if (u && typeof c == "function") return new c([e]);
			throw new J("Blob is not supported. Use a Buffer instead.", J.ERR_NOT_SUPPORT);
		}
		return e;
	}
	function p(e) {
		if (e > l) throw new J("Object is too deeply nested (" + e + " levels). Max depth: " + l, J.ERR_FORM_DATA_DEPTH_EXCEEDED);
	}
	function m(e, t) {
		if (l === Infinity) return JSON.stringify(e);
		let n = [];
		return JSON.stringify(e, function(e, r) {
			if (!q.isObject(r)) return r;
			for (; n.length && n[n.length - 1] !== this;) n.pop();
			return n.push(r), p(t + n.length - 1), r;
		});
	}
	function h(e, n, r) {
		let a = e;
		if (q.isReactNative(t) && q.isReactNativeBlob(e)) return t.append(Or(r, n, o), f(e)), !1;
		if (e && !r && typeof e == "object") {
			if (q.endsWith(n, "{}")) n = i ? n : n.slice(0, -2), e = m(e, 1);
			else if (q.isArray(e) && kr(e) || (q.isFileList(e) || q.endsWith(n, "[]")) && (a = q.toArray(e))) return n = Dr(n), a.forEach(function(e, r) {
				!(q.isUndefined(e) || e === null) && t.append(s === !0 ? Or([n], r, o) : s === null ? n : n + "[]", f(e));
			}), !1;
		}
		return Er(e) ? !0 : (t.append(Or(r, n, o), f(e)), !1);
	}
	let g = Object.assign(Ar, {
		defaultVisitor: h,
		convertValue: f,
		isVisitable: Er
	});
	function _(e, n, r = 0) {
		if (!q.isUndefined(e)) {
			if (p(r), d.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
			d.push(e), q.forEach(e, function(e, i) {
				(!(q.isUndefined(e) || e === null) && a.call(t, e, q.isString(i) ? i.trim() : i, n, g)) === !0 && _(e, n ? n.concat(i) : [i], r + 1);
			}), d.pop();
		}
	}
	if (!q.isObject(e)) throw TypeError("data must be an object");
	return _(e), t;
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js
function Mr(e) {
	let t = {
		"!": "%21",
		"'": "%27",
		"(": "%28",
		")": "%29",
		"~": "%7E",
		"%20": "+"
	};
	return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
		return t[e];
	});
}
function Nr(e, t) {
	this._pairs = [], e && jr(e, this, t);
}
var Pr = Nr.prototype;
Pr.append = function(e, t) {
	this._pairs.push([e, t]);
}, Pr.toString = function(e) {
	let t = e ? (t) => e.call(this, t, Mr) : Mr;
	return this._pairs.map(function(e) {
		return t(e[0]) + "=" + t(e[1]);
	}, "").join("&");
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/buildURL.js
function Fr(e) {
	return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ir(e, t, n) {
	if (!t) return e;
	e ||= "";
	let r = q.isFunction(n) ? { serialize: n } : n, i = q.getSafeProp(r, "encode") || Fr, a = q.getSafeProp(r, "serialize"), o;
	if (o = a ? a(t, r) : q.isURLSearchParams(t) ? t.toString() : new Nr(t, r).toString(i), o) {
		let t = e.indexOf("#");
		t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
	}
	return e;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/InterceptorManager.js
var Lr = Symbol("internals");
function Rr(e) {
	return e ? e.length : 0;
}
function zr(e) {
	if (e) for (; e.length && e[e.length - 1] === null;) e.pop();
}
function Br(e, t) {
	let n = e.handlers, r = Rr(n);
	n === t.handlersRef ? r !== t.handlersLength && (r ? t.handlerEntries.forEach(function(e, r) {
		n[e.index] !== e.handler && t.handlerEntries.delete(r);
	}) : t.handlerEntries.clear()) : (t.handlersRef = n, t.handlerEntries.clear()), t.handlersLength = r;
}
var Vr = class {
	constructor() {
		this.handlers = [], this[Lr] = {
			handlersRef: this.handlers,
			handlersLength: this.handlers.length,
			handlerEntries: /* @__PURE__ */ new Map(),
			iterationDepth: 0,
			nextId: 0
		};
	}
	use(e, t, n) {
		let r = {
			fulfilled: e,
			rejected: t,
			synchronous: n ? n.synchronous : !1,
			runWhen: n ? n.runWhen : null
		}, i = this[Lr];
		this.handlers ??= [], Br(this, i);
		let a = i.nextId++;
		return this.handlers.push(r), i.handlerEntries.set(a, {
			handler: r,
			index: this.handlers.length - 1
		}), i.handlersLength = this.handlers.length, a;
	}
	eject(e) {
		let t = this[Lr];
		Br(this, t);
		let n = t.handlerEntries.get(e);
		if (n) {
			if (t.handlerEntries.delete(e), this.handlers[n.index] !== n.handler) return;
			this.handlers[n.index] = null, t.iterationDepth || (zr(this.handlers), t.handlersLength = this.handlers.length);
		}
	}
	clear() {
		this.handlers && (this.handlers = [], Br(this, this[Lr]));
	}
	forEach(e) {
		let t = this[Lr];
		Br(this, t), t.iterationDepth++;
		try {
			q.forEach(this.handlers, function(t) {
				t !== null && e(t);
			});
		} finally {
			--t.iterationDepth || (Br(this, t), zr(this.handlers), t.handlersLength = Rr(this.handlers));
		}
	}
}, Hr = {
	silentJSONParsing: !0,
	forcedJSONParsing: !0,
	clarifyTimeoutError: !1,
	legacyInterceptorReqResOrdering: !0,
	advertiseZstdAcceptEncoding: !1,
	validateStatusUndefinedResolves: !0
}, Ur = {
	isBrowser: !0,
	classes: {
		URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Nr,
		FormData: typeof FormData < "u" ? FormData : null,
		Blob: typeof Blob < "u" ? Blob : null
	},
	protocols: [
		"http",
		"https",
		"file",
		"blob",
		"url",
		"data"
	]
}, Wr = /* @__PURE__ */ Ot({
	hasBrowserEnv: () => Gr,
	hasStandardBrowserEnv: () => qr,
	hasStandardBrowserWebWorkerEnv: () => Jr,
	navigator: () => Kr,
	origin: () => Yr
}), Gr = typeof window < "u" && typeof document < "u", Kr = typeof navigator == "object" && navigator || void 0, qr = Gr && (!Kr || [
	"ReactNative",
	"NativeScript",
	"NS"
].indexOf(Kr.product) < 0), Jr = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Yr = Gr && window.location.href || "http://localhost", Xr = {
	...Wr,
	...Ur
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/toURLEncodedForm.js
function Zr(e, t) {
	return jr(e, new Xr.classes.URLSearchParams(), {
		visitor: function(e, t, n, r) {
			return Xr.isNode && q.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
		},
		...t
	});
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/formDataToJSON.js
var Qr = 100;
function $r(e) {
	if (e > Qr) throw new J("FormData field is too deeply nested (" + e + " levels). Max depth: " + Qr, J.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function ei(e) {
	let t = [], n = /[^.[\]]+|\[([^.[\]]*)]/g, r;
	for (; (r = n.exec(e)) !== null;) $r(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
	return t;
}
function ti(e) {
	let t = {}, n = Object.keys(e), r, i = n.length, a;
	for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
	return t;
}
function ni(e) {
	function t(e, n, r, i) {
		$r(i);
		let a = e[i++];
		if (a === "__proto__") return !0;
		let o = Number.isFinite(+a), s = i >= e.length;
		return a = !a && q.isArray(r) ? r.length : a, s ? (q.hasOwnProp(r, a) ? r[a] = q.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : ((!q.hasOwnProp(r, a) || !q.isObject(r[a])) && (r[a] = []), t(e, n, r[a], i) && q.isArray(r[a]) && (r[a] = ti(r[a])), !o);
	}
	if (q.isFormData(e) && q.isFunction(e.entries)) {
		let n = {};
		return q.forEachEntry(e, (e, r) => {
			t(ei(e), r, n, 0);
		}), n;
	}
	return null;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/methodList.js
var ri = Object.freeze([
	"get",
	"delete",
	"head",
	"options",
	"post",
	"put",
	"patch",
	"purge",
	"link",
	"unlink",
	"query"
]), ii = (e, t) => e != null && q.hasOwnProp(e, t) ? e[t] : void 0;
function ai(e, t, n) {
	if (q.isString(e)) try {
		return (t || JSON.parse)(e), q.trim(e);
	} catch (e) {
		if (e.name !== "SyntaxError") throw e;
	}
	return (n || JSON.stringify)(e);
}
var oi = {
	transitional: Hr,
	adapter: [
		"xhr",
		"http",
		"fetch"
	],
	transformRequest: [function(e, t) {
		let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = q.isObject(e);
		if (i && q.isHTMLForm(e) && (e = new FormData(e)), q.isFormData(e)) return r ? JSON.stringify(ni(e)) : e;
		if (q.isArrayBuffer(e) || q.isBuffer(e) || q.isStream(e) || q.isFile(e) || q.isBlob(e) || q.isReadableStream(e)) return e;
		if (q.isArrayBufferView(e)) return e.buffer;
		if (q.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
		let a;
		if (i) {
			let t = ii(this, "formSerializer");
			if (n.indexOf("application/x-www-form-urlencoded") > -1) return Zr(e, t).toString();
			if ((a = q.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
				let n = ii(this, "env"), r = n && n.FormData;
				return jr(a ? { "files[]": e } : e, r && new r(), t);
			}
		}
		return i || r ? (t.setContentType("application/json", !1), ai(e)) : e;
	}],
	transformResponse: [function(e) {
		let t = ii(this, "transitional") || oi.transitional, n = t && t.forcedJSONParsing, r = ii(this, "responseType"), i = r === "json";
		if (q.isResponse(e) || q.isReadableStream(e)) return e;
		if (e && q.isString(e) && (n && !r || i)) {
			let n = !(t && t.silentJSONParsing) && i;
			try {
				return JSON.parse(e, ii(this, "parseReviver"));
			} catch (e) {
				if (n) throw e.name === "SyntaxError" ? J.from(e, J.ERR_BAD_RESPONSE, this, null, ii(this, "response")) : e;
			}
		}
		return e;
	}],
	timeout: 0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN",
	maxContentLength: -1,
	maxBodyLength: -1,
	env: {
		FormData: Xr.classes.FormData,
		Blob: Xr.classes.Blob
	},
	validateStatus: function(e) {
		return e >= 200 && e < 300;
	},
	headers: { common: {
		Accept: "application/json, text/plain, */*",
		"Content-Type": void 0
	} }
};
q.forEach(ri, (e) => {
	oi.headers[e] = {};
});
//#endregion
//#region ../../../node_modules/axios/lib/core/transformData.js
function si(e, t) {
	let n = this || oi, r = t || n, i = br.from(r.headers), a = r.data;
	return q.forEach(e, function(e) {
		a = e.call(n, a, i.normalize(), t ? t.status : void 0);
	}), i.normalize(), a;
}
//#endregion
//#region ../../../node_modules/axios/lib/cancel/isCancel.js
function ci(e) {
	return !!(e && e.__CANCEL__);
}
//#endregion
//#region ../../../node_modules/axios/lib/cancel/CanceledError.js
var li = class extends J {
	constructor(e, t, n) {
		super(e ?? "canceled", J.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
	}
};
//#endregion
//#region ../../../node_modules/axios/lib/core/settle.js
function ui(e, t, n) {
	let r = n.config.validateStatus;
	!n.status || !r || r(n.status) ? e(n) : t(new J("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? J.ERR_BAD_REQUEST : J.ERR_BAD_RESPONSE, n.config, n.request, n));
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/normalizeURLForProtocolCheck.js
var di = /[\t\n\r]/g;
function fi(e) {
	if (typeof e != "string") return e;
	let t = 0;
	for (; t < e.length && e.charCodeAt(t) <= 32;) t++;
	return e.slice(t).replace(di, "");
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/parseProtocol.js
function pi(e) {
	let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
	return t && t[1] || "";
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/speedometer.js
function mi(e, t) {
	e ||= 10;
	let n = Array(e), r = Array(e), i = 0, a = 0, o;
	return t = t === void 0 ? 1e3 : t, function(s) {
		let c = Date.now(), l = r[a];
		o ||= c, n[i] = s, r[i] = c;
		let u = a, d = 0;
		for (; u !== i;) d += n[u++], u %= e;
		if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
		let f = l && c - l;
		return f ? Math.round(d * 1e3 / f) : void 0;
	};
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/throttle.js
function hi(e, t) {
	let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
		n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
	};
	return [
		(...e) => {
			let t = Date.now(), s = t - n;
			s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
				a = null, o(i);
			}, r - s));
		},
		() => i && o(i),
		(...e) => o(e)
	];
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/progressEventReducer.js
var gi = (e, t, n = 3) => {
	let r = 0, i = mi(50, 250);
	return hi((n) => {
		if (!n || !q.isNumber(n.loaded)) return;
		let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = Math.max(0, o == null ? a : Math.min(a, o)), c = Math.max(0, s - r), l = i(c);
		r = Math.max(r, s), e({
			loaded: s,
			total: o,
			progress: o ? s / o : void 0,
			bytes: c,
			rate: l || void 0,
			estimated: l && o ? (o - s) / l : void 0,
			event: n,
			lengthComputable: o != null,
			[t ? "download" : "upload"]: !0
		});
	}, n);
}, _i = (e, t) => {
	let n = e != null;
	return [(r) => t[0]({
		lengthComputable: n,
		total: e,
		loaded: r
	}), t[1]];
}, vi = (e, t = q.asap) => (...n) => t(() => e(...n)), yi = Xr.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Xr.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Xr.origin), Xr.navigator && /(msie|trident)/i.test(Xr.navigator.userAgent)) : () => !0, bi = Xr.hasStandardBrowserEnv ? {
	write(e, t, n, r, i, a, o) {
		if (typeof document > "u") return;
		let s = [`${e}=${encodeURIComponent(t)}`];
		q.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), q.isString(r) && s.push(`path=${r}`), q.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), q.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
	},
	read(e) {
		if (typeof document > "u") return null;
		let t = document.cookie.split(";");
		for (let n = 0; n < t.length; n++) {
			let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
			if (i !== -1 && r.slice(0, i) === e) try {
				return decodeURIComponent(r.slice(i + 1));
			} catch {
				return r.slice(i + 1);
			}
		}
		return null;
	},
	remove(e) {
		this.write(e, "", Date.now() - 864e5, "/");
	}
} : {
	write() {},
	read() {
		return null;
	},
	remove() {}
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/isAbsoluteURL.js
function xi(e) {
	return typeof e == "string" && /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/combineURLs.js
function Si(e, t) {
	if (!t) return e;
	let n = e.length;
	for (; n > 0 && e.charCodeAt(n - 1) === 47;) n--;
	return e.slice(0, n) + "/" + t.replace(/^\/+/, "");
}
//#endregion
//#region ../../../node_modules/axios/lib/core/buildFullPath.js
var Ci = /^https?:(?!\/\/)/i;
function wi(e) {
	return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (e, t, n = "") => `${t}${n}${xr}`);
}
function Ti(e) {
	let t = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${xr}@`), n = t.indexOf("#"), r = (n === -1 ? t : t.slice(0, n)).replace(/([?&][^=&#]*=)[^&#]*/g, `$1${xr}`);
	return n === -1 ? r : `${r}#${wi(t.slice(n + 1))}`;
}
function Ei(e, t) {
	if (typeof e == "string") {
		let n = fi(e);
		if (Ci.test(n)) throw new J(`Invalid URL ${JSON.stringify(Ti(n))}: missing "//" after protocol`, J.ERR_INVALID_URL, t);
	}
}
function Di(e, t, n, r) {
	Ei(t, r);
	let i = !xi(t);
	return e && (i || n === !1) ? (Ei(e, r), Si(e, t)) : t;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/mergeConfig.js
var Oi = (e) => e instanceof br ? { ...e } : e, ki = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(Object.getOwnPropertySymbols(e).filter((t) => Object.getOwnPropertyDescriptor(e, t).enumerable)) : Object.keys(e);
function Ai(e, t) {
	e ||= {}, t ||= {};
	let n = Object.create(null);
	Object.defineProperty(n, "hasOwnProperty", {
		__proto__: null,
		value: Object.prototype.hasOwnProperty,
		enumerable: !1,
		writable: !0,
		configurable: !0
	});
	function r(e, t, n, r) {
		return q.isPlainObject(e) && q.isPlainObject(t) ? q.merge.call({ caseless: r }, e, t) : q.isPlainObject(t) ? q.merge({}, t) : q.isArray(t) ? t.slice() : t;
	}
	function i(e, t, n, i) {
		if (!q.isUndefined(t)) return r(e, t, n, i);
		if (!q.isUndefined(e)) return r(void 0, e, n, i);
	}
	function a(e, t) {
		if (!q.isUndefined(t)) return r(void 0, t);
	}
	function o(e, t) {
		if (!q.isUndefined(t)) return r(void 0, t);
		if (!q.isUndefined(e)) return r(void 0, e);
	}
	function s(n) {
		let r = q.hasOwnProp(t, "transitional") ? t.transitional : void 0;
		if (!q.isUndefined(r)) if (q.isPlainObject(r)) {
			if (q.hasOwnProp(r, n)) return r[n];
		} else return;
		let i = q.hasOwnProp(e, "transitional") ? e.transitional : void 0;
		if (q.isPlainObject(i) && q.hasOwnProp(i, n)) return i[n];
	}
	function c(n, i, a) {
		if (q.hasOwnProp(t, a)) return r(n, i);
		if (q.hasOwnProp(e, a)) return r(void 0, n);
	}
	let l = {
		url: a,
		method: a,
		data: a,
		baseURL: o,
		transformRequest: o,
		transformResponse: o,
		paramsSerializer: o,
		timeout: o,
		timeoutErrorMessage: o,
		withCredentials: o,
		withXSRFToken: o,
		adapter: o,
		responseType: o,
		xsrfCookieName: o,
		xsrfHeaderName: o,
		onUploadProgress: o,
		onDownloadProgress: o,
		decompress: o,
		maxContentLength: o,
		maxBodyLength: o,
		beforeRedirect: o,
		transport: o,
		httpAgent: o,
		httpsAgent: o,
		cancelToken: o,
		socketPath: o,
		allowedSocketPaths: o,
		responseEncoding: o,
		validateStatus: c,
		headers: (e, t, n) => i(Oi(e), Oi(t), n, !0)
	};
	return q.forEach(ki({
		...e,
		...t
	}), function(r) {
		if (r === "__proto__" || r === "constructor" || r === "prototype") return;
		let a = q.hasOwnProp(l, r) ? l[r] : i, o = a(q.hasOwnProp(e, r) ? e[r] : void 0, q.hasOwnProp(t, r) ? t[r] : void 0, r);
		q.isUndefined(o) && a !== c || (n[r] = o);
	}), q.hasOwnProp(t, "validateStatus") && q.isUndefined(t.validateStatus) && s("validateStatusUndefinedResolves") === !1 && (q.hasOwnProp(e, "validateStatus") ? n.validateStatus = r(void 0, e.validateStatus) : delete n.validateStatus), n;
}
//#endregion
//#region ../../../node_modules/axios/lib/core/setFormDataHeaders.js
var ji = ["content-type", "content-length"];
function Mi(e, t, n) {
	if (n !== "content-only") {
		e.set(t);
		return;
	}
	Object.entries(t || {}).forEach(([t, n]) => {
		ji.includes(t.toLowerCase()) && e.set(t, n);
	});
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/resolveConfig.js
var Ni = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
function Pi(e) {
	let t = Ai({}, e), n = (e) => q.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
	if (t.headers = s = br.from(s), t.url = Ir(Di(l, d, u, t), n("params"), n("paramsSerializer")), c) {
		let t = q.getSafeProp(c, "username") || "", n = q.getSafeProp(c, "password") || "";
		try {
			s.set("Authorization", "Basic " + btoa(t + ":" + (n ? Ni(n) : "")));
		} catch (t) {
			throw J.from(t, J.ERR_BAD_OPTION_VALUE, e);
		}
	}
	if (q.isFormData(r)) {
		let e = q.getSafeProp(r, "getHeaders");
		Xr.hasStandardBrowserEnv || Xr.hasStandardBrowserWebWorkerEnv || q.isReactNative(r) ? s.setContentType(void 0) : q.isFunction(e) && Mi(s, e.call(r), n("formDataHeaderPolicy"));
	}
	if (Xr.hasStandardBrowserEnv && (q.isFunction(i) && (i = i(t)), i === !0 || i == null && yi(t.url))) {
		let e = a && o && bi.read(o);
		e && s.set(a, e);
	}
	return t;
}
var Fi = typeof XMLHttpRequest < "u" && function(e) {
	return new Promise(function(t, n) {
		let r = Pi(e), i = r.data, a = br.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p, m;
		function h() {
			f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
		}
		let g = new XMLHttpRequest();
		g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
		function _(i) {
			if (!g) return;
			if (g.status === 0 && (pi(fi(r.url)) || pi(Xr.origin)) !== "file" && !(g.responseURL && g.responseURL.startsWith("file:"))) {
				n(new J("Request aborted", J.ECONNABORTED, e, g)), h(), g = null;
				return;
			}
			try {
				i ? m && m(i) : p && p();
			} catch (e) {
				setTimeout(() => {
					throw e;
				});
			}
			if (!g) return;
			let a = br.from("getAllResponseHeaders" in g && g.getAllResponseHeaders());
			ui(function(e) {
				t(e), h();
			}, function(e) {
				n(e), h();
			}, {
				data: !o || o === "text" || o === "json" ? g.responseText : g.response,
				status: g.status,
				statusText: g.statusText,
				headers: a,
				config: e,
				request: g
			}), g = null;
		}
		"onloadend" in g ? g.onloadend = _ : g.onreadystatechange = function() {
			!g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.startsWith("file:")) || setTimeout(_);
		}, g.onabort = function() {
			g &&= (n(new J("Request aborted", J.ECONNABORTED, e, g)), h(), null);
		}, g.onerror = function(t) {
			let r = new J(t && t.message ? t.message : "Network Error", J.ERR_NETWORK, e, g);
			r.event = t || null, n(r), h(), g = null;
		}, g.ontimeout = function() {
			let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || Hr;
			r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new J(t, i.clarifyTimeoutError ? J.ETIMEDOUT : J.ECONNABORTED, e, g)), h(), g = null;
		}, i === void 0 && a.setContentType(null), "setRequestHeader" in g && q.forEach(sr(a), function(e, t) {
			g.setRequestHeader(t, e);
		}), q.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), o && o !== "json" && (g.responseType = r.responseType), c && ([d, p, m] = gi(c, !0), g.addEventListener("progress", d)), s && g.upload && ([u, f] = gi(s), g.upload.addEventListener("progress", u), g.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
			g &&= (n(!t || t.type ? new li(null, e, g) : t), g.abort(), h(), null);
		}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
		let v = pi(r.url);
		if (v && !Xr.protocols.includes(v)) {
			n(new J("Unsupported protocol " + v + ":", J.ERR_BAD_REQUEST, e)), h();
			return;
		}
		g.send(i || null);
	});
}, Ii = (e, t) => {
	if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
	let n = new AbortController(), r = !1, i = function(e) {
		if (!r) {
			r = !0, o();
			let t = e instanceof Error ? e : this.reason;
			n.abort(t instanceof J ? t : new li(t instanceof Error ? t.message : t));
		}
	}, a = t && setTimeout(() => {
		a = null, i(new J(`timeout of ${t}ms exceeded`, J.ETIMEDOUT));
	}, t), o = () => {
		e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
			e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
		}), null);
	};
	e.forEach((e) => {
		if (!r) {
			if (e.aborted) {
				i.call(e);
				return;
			}
			e.addEventListener("abort", i, { once: !0 });
		}
	});
	let { signal: s } = n;
	return s.unsubscribe = () => q.asap(o), s;
}, Li = function* (e, t) {
	let n = e.byteLength;
	if (!t || n < t) {
		yield e;
		return;
	}
	let r = 0, i;
	for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
}, Ri = async function* (e, t) {
	for await (let n of zi(e)) yield* Li(n, t);
}, zi = async function* (e) {
	if (e[Symbol.asyncIterator]) {
		yield* e;
		return;
	}
	let t = e.getReader();
	try {
		for (;;) {
			let { done: e, value: n } = await t.read();
			if (e) break;
			yield n;
		}
	} finally {
		await t.cancel();
	}
}, Bi = (e, t, n, r) => {
	let i = Ri(e, t), a = 0, o, s = (e) => {
		o || (o = !0, r && r(e));
	};
	return new ReadableStream({
		async pull(e) {
			try {
				let { done: t, value: r } = await i.next();
				if (t) {
					s(), e.close();
					return;
				}
				let o = r.byteLength;
				n && n(a += o), e.enqueue(new Uint8Array(r));
			} catch (e) {
				throw s(e), e;
			}
		},
		cancel(e) {
			return s(e), i.return();
		}
	}, { highWaterMark: 2 });
}, Vi = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, Hi = (e, t, n) => t + 2 < n && Vi(e.charCodeAt(t + 1)) && Vi(e.charCodeAt(t + 2)), Ui = (e) => e <= 57 ? e - 48 : (e & 223) - 55, Wi = (e) => e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || e === 43 || e === 47 || e === 45 || e === 95, Gi = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, Ki = (e) => {
	let t = Math.floor(e / 4), n = e % 4;
	return t * 3 + (n === 2 ? 1 : n === 3 ? 2 : 0);
}, qi = (e) => {
	let t = e.length, n = 0;
	return t > 0 && e.charCodeAt(t - 1) === 61 && (n++, t > 1 && e.charCodeAt(t - 2) === 61 && n++), Math.floor((t - n) * 3 / 4);
}, Ji = (e) => {
	let t = e.length, n = 0, r = 0, i = !1;
	for (let a = 0; a < t; a++) {
		let o = e.charCodeAt(a);
		if (o === 37 && Hi(e, a, t) && (o = Ui(e.charCodeAt(a + 1)) * 16 + Ui(e.charCodeAt(a + 2)), a += 2), !Gi(o)) {
			if (o === 61) {
				r++;
				continue;
			}
			if (!Wi(o) || r > 0) {
				i = !0;
				continue;
			}
			n++;
		}
	}
	return i || r > 2 || r > 0 && (n + r) % 4 != 0 || n % 4 == 1 ? qi(e) : Ki(n);
}, Yi = (e, t) => {
	if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
	let n = e.indexOf(",");
	if (n < 0) return 0;
	let r = e.slice(5, n), i = e.slice(n + 1);
	if (/;base64/i.test(r)) return t(i);
	let a = 0;
	for (let e = 0, t = i.length; e < t; e++) {
		let n = i.charCodeAt(e);
		if (n === 37 && Hi(i, e, t)) a += 1, e += 2;
		else if (n < 128) a += 1;
		else if (n < 2048) a += 2;
		else if (n >= 55296 && n <= 56319 && e + 1 < t) {
			let t = i.charCodeAt(e + 1);
			t >= 56320 && t <= 57343 ? (a += 4, e++) : a += 3;
		} else a += 3;
	}
	return a;
};
function Xi(e) {
	let t = typeof e == "string" ? e.indexOf("#") : -1;
	return Yi(t === -1 ? e : e.slice(0, t), Ji);
}
//#endregion
//#region ../../../node_modules/axios/lib/env/data.js
var Zi = "1.20.0", Qi = 64 * 1024, $i = {
	cache: "default",
	redirect: "follow",
	referrer: "about:client",
	referrerPolicy: "",
	mode: "cors",
	integrity: "",
	keepalive: !1,
	priority: "auto",
	window: null
}, { isFunction: ea } = q, ta = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), na = (e) => {
	if (!q.isString(e)) return e;
	try {
		return decodeURIComponent(e);
	} catch {
		return e;
	}
}, ra = (e, ...t) => {
	try {
		return !!e(...t);
	} catch {
		return !1;
	}
}, ia = (e) => {
	let t = e.indexOf("://"), n = e;
	return t !== -1 && (n = n.slice(t + 3)), n.includes("@") || n.includes(":");
}, aa = (e) => {
	let t = q.global !== void 0 && q.global !== null ? q.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
	e = q.merge.call({ skipUndefined: !0 }, {
		Request: t.Request,
		Response: t.Response
	}, e);
	let { fetch: i, Request: a, Response: o } = e, s = i ? ea(i) : typeof fetch == "function", c = ea(a), l = ea(o);
	if (!s) return !1;
	let u = s && ea(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && ra(() => {
		let e = !1, t = new a(Xr.origin, {
			body: new n(),
			method: "POST",
			get duplex() {
				return e = !0, "half";
			}
		}), r = t.headers.has("Content-Type");
		return t.body != null && t.body.cancel(), e && !r;
	}), p = l && u && ra(() => q.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
	s && [
		"text",
		"arrayBuffer",
		"blob",
		"formData",
		"stream"
	].forEach((e) => {
		!m[e] && (m[e] = (t, n) => {
			let r = t && t[e];
			if (r) return r.call(t);
			throw new J(`Response type '${e}' is not supported`, J.ERR_NOT_SUPPORT, n);
		});
	});
	let h = async (e) => {
		if (e == null) return 0;
		if (q.isBlob(e)) return e.size;
		if (q.isSpecCompliantForm(e)) return (await new a(Xr.origin, {
			method: "POST",
			body: e
		}).arrayBuffer()).byteLength;
		if (q.isArrayBufferView(e) || q.isArrayBuffer(e)) return e.byteLength;
		if (q.isURLSearchParams(e) && (e += ""), q.isString(e)) return (await d(e)).byteLength;
	}, g = async (e, t) => q.toFiniteNumber(e.getContentLength()) ?? h(t);
	return async (e) => {
		let { url: t, method: n, data: s, signal: l, cancelToken: d, timeout: _, onDownloadProgress: v, onUploadProgress: y, responseType: b, headers: x, withCredentials: S = "same-origin", fetchOptions: C, maxContentLength: w, maxBodyLength: T, maxRedirects: E } = Pi(e), D = q.isNumber(w) && w > -1, O = q.isNumber(T) && T > -1, k = (t) => q.hasOwnProp(e, t) ? e[t] : void 0, A = i || fetch;
		b = b ? (b + "").toLowerCase() : "text";
		let j = Ii([l, d && d.toAbortSignal()], _), M = null, N = j && j.unsubscribe && (() => {
			j.unsubscribe();
		}), P, ee = null, F = () => new J("Request body larger than maxBodyLength limit", J.ERR_BAD_REQUEST, e, M);
		try {
			let i, l = k("auth");
			if (l && (i = {
				username: q.getSafeProp(l, "username") || "",
				password: q.getSafeProp(l, "password") || ""
			}), ia(t)) {
				let e = new URL(t, Xr.origin);
				!i && (e.username || e.password) && (i = {
					username: na(e.username),
					password: na(e.password)
				}), (e.username || e.password) && (e.username = "", e.password = "", t = e.href);
			}
			if (i && (x.delete("authorization"), x.set("Authorization", "Basic " + btoa(ta((i.username || "") + ":" + (i.password || ""))))), D && typeof t == "string" && t.startsWith("data:") && Xi(t) > w) throw new J("maxContentLength size of " + w + " exceeded", J.ERR_BAD_RESPONSE, e, M);
			if (O && n !== "get" && n !== "head") {
				let e = await h(s);
				if (typeof e == "number" && isFinite(e) && (P = e, e > T)) throw F();
			}
			let d = O && (q.isReadableStream(s) || q.isStream(s)), _ = (e, t, n) => Bi(e, Qi, (e) => {
				if (O && e > T) throw ee = F();
				t && t(e);
			}, n);
			if (f && n !== "get" && n !== "head" && (y || d)) {
				if (P ??= await g(x, s), P !== 0 || d) {
					let e = new a(t, {
						method: "POST",
						body: s,
						duplex: "half"
					}), n;
					if (q.isFormData(s) && (n = e.headers.get("content-type")) && x.setContentType(n), e.body) {
						let [t, n] = y && _i(P, gi(vi(y))) || [];
						s = _(e.body, t, n);
					}
				}
			} else if (d && !c && u && n !== "get" && n !== "head") s = _(s);
			else if (d && c && !f && n !== "get" && n !== "head") throw new J("Stream request bodies are not supported by the current fetch implementation", J.ERR_NOT_SUPPORT, e, M);
			q.isString(S) || (S = S ? "include" : "omit");
			let I = c && "credentials" in a.prototype;
			if (q.isFormData(s)) {
				let e = x.getContentType();
				e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && x.delete("content-type");
			}
			x.set("User-Agent", "axios/" + Zi, !1);
			let te = C == null ? C : Object.assign(Object.create(null), C);
			te && (delete te.body, delete te.headers, delete te.method, delete te.signal, delete te.duplex, delete te.credentials);
			let L = Object.assign(Object.create(null), te, {
				signal: j,
				method: n.toUpperCase(),
				headers: sr(x.normalize()),
				body: s,
				duplex: "half",
				credentials: I ? S : void 0
			});
			c && (q.forEach($i, (e, t) => {
				L[t] === void 0 && (L[t] = e);
			}), L.signal === void 0 && (L.signal = null), L.body === void 0 && (L.body = null)), E === 0 && (L.redirect = "manual", te && (te.redirect = "manual")), M = c && new a(t, L);
			let ne = await (c ? A(M, te) : A(t, L)), re = br.from(ne.headers);
			if (D) {
				let t = q.toFiniteNumber(re.getContentLength());
				if (t != null && t > w) throw new J("maxContentLength size of " + w + " exceeded", J.ERR_BAD_RESPONSE, e, M);
			}
			let ie = p && (b === "stream" || b === "response");
			if (p && ne.body && (v || D || ie && N)) {
				let t = {};
				[
					"status",
					"statusText",
					"headers"
				].forEach((e) => {
					t[e] = ne[e];
				});
				let n = q.toFiniteNumber(re.getContentLength()), [r, i] = v && _i(n, gi(vi(v), !0)) || [], a = 0;
				ne = new o(Bi(ne.body, Qi, (t) => {
					if (D && (a = t, a > w)) throw new J("maxContentLength size of " + w + " exceeded", J.ERR_BAD_RESPONSE, e, M);
					r && r(t);
				}, () => {
					i && i(), N && N();
				}), t);
			}
			b ||= "text";
			let R = await m[q.findKey(m, b) || "text"](ne, e);
			if (D && !p && !ie) {
				let t;
				if (R != null && (typeof R.byteLength == "number" ? t = R.byteLength : typeof R.size == "number" ? t = R.size : typeof R == "string" && (t = typeof r == "function" ? new r().encode(R).byteLength : R.length)), typeof t == "number" && t > w) throw new J("maxContentLength size of " + w + " exceeded", J.ERR_BAD_RESPONSE, e, M);
			}
			return !ie && N && N(), await new Promise((t, n) => {
				ui(t, n, {
					data: R,
					headers: br.from(ne.headers),
					status: ne.status,
					statusText: ne.statusText,
					config: e,
					request: M
				});
			});
		} catch (t) {
			if (N && N(), j && j.aborted && j.reason instanceof J) {
				let n = j.reason;
				throw n.config = e, M && (n.request = M), t !== n && Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			if (ee) throw M && !ee.request && (ee.request = M), ee;
			if (t instanceof J) throw M && !t.request && (t.request = M), t;
			if (t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message)) {
				let n = new J("Network Error", J.ERR_NETWORK, e, M, t && t.response);
				throw Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t.cause || t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			throw J.from(t, t && t.code, e, M, t && t.response);
		}
	};
}, oa = /* @__PURE__ */ new Map(), sa = (e) => {
	let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
		r,
		i,
		n
	], o = a.length, s, c, l = oa;
	for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : aa(t)), l = c;
	return c;
};
sa();
//#endregion
//#region ../../../node_modules/axios/lib/adapters/adapters.js
var ca = {
	http: null,
	xhr: Fi,
	fetch: { get: sa }
};
q.forEach(ca, (e, t) => {
	if (e) {
		try {
			Object.defineProperty(e, "name", {
				__proto__: null,
				value: t
			});
		} catch {}
		Object.defineProperty(e, "adapterName", {
			__proto__: null,
			value: t
		});
	}
});
var la = (e) => `- ${e}`, ua = (e) => q.isFunction(e) || e === null || e === !1;
function da(e, t) {
	e = q.isArray(e) ? e : [e];
	let { length: n } = e, r, i, a = {};
	for (let o = 0; o < n; o++) {
		r = e[o];
		let n;
		if (i = r, !ua(r) && (i = ca[(n = String(r)).toLowerCase()], i === void 0)) throw new J(`Unknown adapter '${n}'`);
		if (i && (q.isFunction(i) || (i = i.get(t)))) break;
		a[n || "#" + o] = i;
	}
	if (!i) {
		let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
		throw new J("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(la).join("\n") : " " + la(e[0]) : "as no adapter specified"), J.ERR_NOT_SUPPORT);
	}
	return i;
}
var fa = {
	getAdapter: da,
	adapters: ca
};
//#endregion
//#region ../../../node_modules/axios/lib/core/dispatchRequest.js
function pa(e) {
	if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new li(null, e);
}
function ma(e) {
	let t = q.toSafeFlatObject(e);
	return pa(t), t.headers = br.from(q.getSafeProp(t, "headers")), t.data = si.call(t, t.transformRequest), [
		"post",
		"put",
		"patch"
	].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), fa.getAdapter(t.adapter || oi.adapter, t)(t).then(function(e) {
		pa(t), t.response = e;
		try {
			e.data = si.call(t, t.transformResponse, e);
		} finally {
			delete t.response;
		}
		return e.headers = br.from(e.headers), e;
	}, function(e) {
		if (!ci(e) && (pa(t), e && e.response)) {
			t.response = e.response;
			try {
				e.response.data = si.call(t, t.transformResponse, e.response);
			} finally {
				delete t.response;
			}
			e.response.headers = br.from(e.response.headers);
		}
		return Promise.reject(e);
	});
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/validator.js
var ha = {};
[
	"object",
	"boolean",
	"number",
	"function",
	"string",
	"symbol"
].forEach((e, t) => {
	ha[e] = function(n) {
		return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
	};
});
var ga = {};
ha.transitional = function(e, t, n) {
	function r(e, t) {
		return "[Axios v" + Zi + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
	}
	return (n, i, a) => {
		if (e === !1) throw new J(r(i, " has been removed" + (t ? " in " + t : "")), J.ERR_DEPRECATED);
		return t && !ga[i] && (ga[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, i, a);
	};
}, ha.spelling = function(e) {
	return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function _a(e, t, n) {
	if (typeof e != "object" || !e) throw new J("options must be an object", J.ERR_BAD_OPTION_VALUE);
	let r = Object.keys(e), i = r.length;
	for (; i-- > 0;) {
		let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
		if (o) {
			let t = e[a], n = t === void 0 || o(t, a, e);
			if (n !== !0) throw new J("option " + a + " must be " + n, J.ERR_BAD_OPTION_VALUE);
			continue;
		}
		if (n !== !0) throw new J("Unknown option " + a, J.ERR_BAD_OPTION);
	}
}
var va = {
	assertOptions: _a,
	validators: ha
}, ya = va.validators, ba = class {
	constructor(e) {
		this.defaults = e || {}, this.interceptors = {
			request: new Vr(),
			response: new Vr()
		};
	}
	async request(e, t) {
		try {
			return await this._request(e, t);
		} catch (e) {
			if (e instanceof Error) try {
				let t = {};
				Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
				let n = t.stack, r = "";
				if (typeof n == "string") {
					let e = n.indexOf("\n");
					r = e === -1 ? "" : n.slice(e + 1);
				}
				if (!e.stack) e.stack = r;
				else if (r) {
					let t = r.indexOf("\n"), n = t === -1 ? -1 : r.indexOf("\n", t + 1), i = n === -1 ? "" : r.slice(n + 1);
					String(e.stack).endsWith(i) || (e.stack += "\n" + r);
				}
			} catch {}
			throw e;
		}
	}
	_request(e, t) {
		typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = Ai(this.defaults, t);
		let { transitional: n, paramsSerializer: r, headers: i } = t;
		n !== void 0 && va.assertOptions(n, {
			silentJSONParsing: ya.transitional(ya.boolean),
			forcedJSONParsing: ya.transitional(ya.boolean),
			clarifyTimeoutError: ya.transitional(ya.boolean),
			legacyInterceptorReqResOrdering: ya.transitional(ya.boolean),
			advertiseZstdAcceptEncoding: ya.transitional(ya.boolean),
			validateStatusUndefinedResolves: ya.transitional(ya.boolean)
		}, !1), r != null && (q.isFunction(r) ? t.paramsSerializer = { serialize: r } : va.assertOptions(r, {
			encode: ya.function,
			serialize: ya.function
		}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), va.assertOptions(t, {
			baseUrl: ya.spelling("baseURL"),
			withXsrfToken: ya.spelling("withXSRFToken")
		}, !0), t.method = (q.getSafeProp(t, "method") || q.getSafeProp(this.defaults, "method") || "get").toLowerCase();
		let a = i && q.merge(i.common, i[t.method]);
		i && q.forEach(ri.concat("common"), (e) => {
			delete i[e];
		}), t.headers = br.concat(a, i);
		let o = [], s = !0;
		this.interceptors.request.forEach(function(e) {
			if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
			s &&= e.synchronous;
			let n = t.transitional || Hr;
			n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
		});
		let c = [];
		this.interceptors.response.forEach(function(e) {
			c.push(e.fulfilled, e.rejected);
		});
		let l, u = 0, d;
		if (!s) {
			let e = [ma.bind(this), void 0];
			for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
			return l;
		}
		d = o.length;
		let f = t;
		for (; u < d;) {
			let e = o[u++], t = o[u++];
			try {
				f = e ? e(f) : f;
			} catch (e) {
				if (!t) {
					l = Promise.reject(e);
					break;
				}
				try {
					let n = t.call(this, e);
					q.isThenable(n) && (l = Promise.resolve(n).then(() => ma.call(this, f)));
				} catch (e) {
					l = Promise.reject(e);
				}
				break;
			}
		}
		if (!l) try {
			l = ma.call(this, f);
		} catch (e) {
			l = Promise.reject(e);
		}
		for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
		return l;
	}
	getUri(e) {
		return e = Ai(this.defaults, e), Ir(Di(e.baseURL, e.url, e.allowAbsoluteUrls, e), e.params, e.paramsSerializer);
	}
};
q.forEach([
	"delete",
	"get",
	"head",
	"options"
], function(e) {
	ba.prototype[e] = function(t, n) {
		return this.request(Ai(n || {}, {
			method: e,
			url: t,
			data: n && q.hasOwnProp(n, "data") ? n.data : void 0
		}));
	};
}), q.forEach([
	"post",
	"put",
	"patch",
	"query"
], function(e) {
	function t(t) {
		return function(n, r, i) {
			return this.request(Ai(i || {}, {
				method: e,
				headers: t ? { "Content-Type": "multipart/form-data" } : {},
				url: n,
				data: r
			}));
		};
	}
	ba.prototype[e] = t(), e !== "query" && (ba.prototype[e + "Form"] = t(!0));
});
//#endregion
//#region ../../../node_modules/axios/lib/cancel/CancelToken.js
var xa = class e {
	constructor(e) {
		if (typeof e != "function") throw TypeError("executor must be a function.");
		let t;
		this.promise = new Promise(function(e) {
			t = e;
		});
		let n = this;
		this.promise.then((e) => {
			if (!n._listeners) return;
			let t = n._listeners.length;
			for (; t-- > 0;) n._listeners[t](e);
			n._listeners = null;
		}), this.promise.then = (e) => {
			let t, r = new Promise((e) => {
				n.subscribe(e), t = e;
			}).then(e);
			return r.cancel = function() {
				n.unsubscribe(t);
			}, r;
		}, e(function(e, r, i) {
			n.reason || (n.reason = new li(e, r, i), t(n.reason));
		});
	}
	throwIfRequested() {
		if (this.reason) throw this.reason;
	}
	subscribe(e) {
		if (this.reason) {
			e(this.reason);
			return;
		}
		this._listeners ? this._listeners.push(e) : this._listeners = [e];
	}
	unsubscribe(e) {
		if (!this._listeners) return;
		let t = this._listeners.indexOf(e);
		t !== -1 && this._listeners.splice(t, 1);
	}
	toAbortSignal() {
		let e = new AbortController(), t = (t) => {
			e.abort(t);
		};
		return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
	}
	static source() {
		let t;
		return {
			token: new e(function(e) {
				t = e;
			}),
			cancel: t
		};
	}
};
//#endregion
//#region ../../../node_modules/axios/lib/helpers/spread.js
function Sa(e) {
	return function(t) {
		return e.apply(null, t);
	};
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/isAxiosError.js
function Ca(e) {
	return q.isObject(e) && e.isAxiosError === !0;
}
//#endregion
//#region ../../../node_modules/axios/lib/helpers/HttpStatusCode.js
var wa = {
	Continue: 100,
	SwitchingProtocols: 101,
	Processing: 102,
	EarlyHints: 103,
	Ok: 200,
	Created: 201,
	Accepted: 202,
	NonAuthoritativeInformation: 203,
	NoContent: 204,
	ResetContent: 205,
	PartialContent: 206,
	MultiStatus: 207,
	AlreadyReported: 208,
	ImUsed: 226,
	MultipleChoices: 300,
	MovedPermanently: 301,
	Found: 302,
	SeeOther: 303,
	NotModified: 304,
	UseProxy: 305,
	Unused: 306,
	TemporaryRedirect: 307,
	PermanentRedirect: 308,
	BadRequest: 400,
	Unauthorized: 401,
	PaymentRequired: 402,
	Forbidden: 403,
	NotFound: 404,
	MethodNotAllowed: 405,
	NotAcceptable: 406,
	ProxyAuthenticationRequired: 407,
	RequestTimeout: 408,
	Conflict: 409,
	Gone: 410,
	LengthRequired: 411,
	PreconditionFailed: 412,
	PayloadTooLarge: 413,
	ContentTooLarge: 413,
	UriTooLong: 414,
	UnsupportedMediaType: 415,
	RangeNotSatisfiable: 416,
	ExpectationFailed: 417,
	ImATeapot: 418,
	MisdirectedRequest: 421,
	UnprocessableEntity: 422,
	UnprocessableContent: 422,
	Locked: 423,
	FailedDependency: 424,
	TooEarly: 425,
	UpgradeRequired: 426,
	PreconditionRequired: 428,
	TooManyRequests: 429,
	RequestHeaderFieldsTooLarge: 431,
	UnavailableForLegalReasons: 451,
	InternalServerError: 500,
	NotImplemented: 501,
	BadGateway: 502,
	ServiceUnavailable: 503,
	GatewayTimeout: 504,
	HttpVersionNotSupported: 505,
	VariantAlsoNegotiates: 506,
	InsufficientStorage: 507,
	LoopDetected: 508,
	NotExtended: 510,
	NetworkAuthenticationRequired: 511,
	WebServerReturnsAnUnknownError: 520,
	WebServerIsDown: 521,
	ConnectionTimedOut: 522,
	OriginIsUnreachable: 523,
	TimeoutOccurred: 524,
	SslHandshakeFailed: 525,
	InvalidSslCertificate: 526
};
Object.entries(wa).forEach(([e, t]) => {
	wa[t] === void 0 && (wa[t] = e);
});
//#endregion
//#region ../../../node_modules/axios/lib/axios.js
function Ta(e) {
	let t = new ba(e), n = jt(ba.prototype.request, t);
	return q.extend(n, ba.prototype, t, { allOwnKeys: !0 }), q.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(t) {
		return Ta(Ai(e, t));
	}, n;
}
var Ea = Ta(oi);
Ea.Axios = ba, Ea.CanceledError = li, Ea.CancelToken = xa, Ea.isCancel = ci, Ea.VERSION = Zi, Ea.toFormData = jr, Ea.AxiosError = J, Ea.Cancel = Ea.CanceledError, Ea.all = function(e) {
	return Promise.all(e);
}, Ea.spread = Sa, Ea.isAxiosError = Ca, Ea.mergeConfig = Ai, Ea.AxiosHeaders = br, Ea.formToJSON = (e) => ni(q.isHTMLForm(e) ? new FormData(e) : e), Ea.getAdapter = fa.getAdapter, Ea.HttpStatusCode = wa, Ea.default = Ea;
//#endregion
//#region ../../../node_modules/axios/index.js
var { Axios: Da, AxiosError: Oa, CanceledError: ka, isCancel: Aa, CancelToken: ja, VERSION: Ma, all: Na, Cancel: Pa, isAxiosError: Fa, spread: Ia, toFormData: La, AxiosHeaders: Ra, HttpStatusCode: za, formToJSON: Ba, getAdapter: Va, mergeConfig: Ha, create: Ua } = Ea, Wa = new class {
	isElectron() {
		return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
	}
	async getVersion() {
		return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
	}
	async isStandaloneBuild() {
		return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
	}
	async isMsiBuild() {
		return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
	}
}();
//#endregion
//#region ../../shared/semver/dist/index.es.js
function Ga(e, t) {
	return Ka(e), Ka(t), e.localeCompare(t, void 0, { numeric: !0 });
}
function Ka(e) {
	if (e.split(".").length !== 3) throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/debug-build.js
var qa = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Ja = globalThis, Ya = "10.75.3";
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/carrier.js
function Xa() {
	return Za(Ja), Ja;
}
function Za(e) {
	let t = e.__SENTRY__ = e.__SENTRY__ || {};
	return t.version = t.version || "10.75.3", t[Ya] = t["10.75.3"] || {};
}
function Qa(e, t, n = Ja) {
	let r = n.__SENTRY__ = n.__SENTRY__ || {}, i = r[Ya] = r["10.75.3"] || {};
	return i[e] || (i[e] = t());
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/debug-logger.js
var $a = "Sentry Logger ", eo = {};
function to(e) {
	if (!("console" in Ja)) return e();
	let t = Ja.console, n = {}, r = Object.keys(eo);
	r.forEach((e) => {
		let r = eo[e];
		n[e] = t[e], t[e] = r;
	});
	try {
		return e();
	} finally {
		r.forEach((e) => {
			t[e] = n[e];
		});
	}
}
function no() {
	lo().enabled = !0;
}
function ro() {
	lo().enabled = !1;
}
function io() {
	return lo().enabled;
}
function ao(...e) {
	co("log", ...e);
}
function oo(...e) {
	co("warn", ...e);
}
function so(...e) {
	co("error", ...e);
}
function co(e, ...t) {
	qa && io() && to(() => {
		Ja.console[e](`${$a}[${e}]:`, ...t);
	});
}
function lo() {
	return qa ? Qa("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
var uo = {
	enable: no,
	disable: ro,
	isEnabled: io,
	log: ao,
	warn: oo,
	error: so
}, fo = Object.prototype.toString;
function po(e, t) {
	return fo.call(e) === `[object ${t}]`;
}
function mo(e) {
	return po(e, "Object");
}
function ho(e) {
	return !!(e?.then && typeof e.then == "function");
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/object.js
function go(e, t, n) {
	try {
		Object.defineProperty(e, t, {
			value: n,
			writable: !0,
			configurable: !0
		});
	} catch {
		qa && uo.log(`Failed to add non-enumerable property "${String(t)}" to object`, e);
	}
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/randomSafeContext.js
var _o;
function vo(e) {
	if (_o !== void 0) return _o ? _o(e) : e();
	let t = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__"), n = Ja;
	return t in n && typeof n[t] == "function" ? (_o = n[t], _o(e)) : (_o = null, e());
}
function yo() {
	return vo(() => Math.random());
}
function bo() {
	return vo(() => Date.now());
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/string.js
function xo(e, t = 0) {
	return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/misc.js
function So() {
	let e = Ja;
	return e.crypto || e.msCrypto;
}
var Co;
function wo() {
	return yo() * 16;
}
function To(e = So()) {
	try {
		if (e?.randomUUID) return vo(() => e.randomUUID()).replace(/-/g, "");
	} catch {}
	return Co ||= "10000000100040008000100000000000", Co.replace(/[018]/g, (e) => (e ^ (wo() & 15) >> e / 4).toString(16));
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/time.js
var Eo = 1e3;
function Do() {
	return bo() / Eo;
}
function Oo() {
	let { performance: e } = Ja;
	if (!e?.now || !e.timeOrigin) return Do;
	let t = e.timeOrigin;
	return () => (t + vo(() => e.now())) / Eo;
}
var ko;
function Ao() {
	return (ko ??= Oo())();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/session.js
function jo(e, t = {}) {
	if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Ao(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : To()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration) e.duration = void 0;
	else if (typeof t.duration == "number") e.duration = t.duration;
	else {
		let t = e.timestamp - e.started;
		e.duration = t >= 0 ? t : 0;
	}
	t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/merge.js
function Mo(e, t, n = 2) {
	if (!t || typeof t != "object" || n <= 0) return t;
	if (e && Object.keys(t).length === 0) return e;
	let r = { ...e };
	for (let e in t) Object.prototype.hasOwnProperty.call(t, e) && (r[e] = Mo(r[e], t[e], n - 1));
	return r;
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/propagationContext.js
function No() {
	return To();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/weakRef.js
function Po(e) {
	try {
		let t = Ja.WeakRef;
		if (typeof t == "function") return new t(e);
	} catch {}
	return e;
}
function Fo(e) {
	if (e) {
		if (typeof e == "object" && "deref" in e && typeof e.deref == "function") try {
			return e.deref();
		} catch {
			return;
		}
		return e;
	}
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var Io = "_sentrySpan";
function Lo(e, t) {
	t ? go(e, Io, Po(t)) : delete e[Io];
}
function Ro(e) {
	return Fo(e[Io]);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/scope.js
var zo = 100, Bo = class e {
	constructor() {
		this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._attributes = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
			traceId: No(),
			sampleRand: yo()
		};
	}
	clone() {
		let t = new e();
		return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._attributes = { ...this._attributes }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = { values: [...this._contexts.flags.values] }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, t._conversationId = this._conversationId, Lo(t, Ro(this)), t;
	}
	setClient(e) {
		this._client = e;
	}
	setLastEventId(e) {
		this._lastEventId = e;
	}
	getClient() {
		return this._client;
	}
	lastEventId() {
		return this._lastEventId;
	}
	addScopeListener(e) {
		this._scopeListeners.push(e);
	}
	addEventProcessor(e) {
		return this._eventProcessors.push(e), this;
	}
	setUser(e) {
		return this._user = e || {
			email: void 0,
			id: void 0,
			ip_address: void 0,
			username: void 0
		}, this._session && jo(this._session, { user: e }), this._notifyScopeListeners(), this;
	}
	getUser() {
		return this._user;
	}
	setConversationId(e) {
		return this._conversationId = e || void 0, this._notifyScopeListeners(), this;
	}
	setTags(e) {
		return this._tags = {
			...this._tags,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setTag(e, t) {
		return this.setTags({ [e]: t });
	}
	setAttributes(e) {
		return this._attributes = {
			...this._attributes,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setAttribute(e, t) {
		return this.setAttributes({ [e]: t });
	}
	removeAttribute(e) {
		return e in this._attributes && (delete this._attributes[e], this._notifyScopeListeners()), this;
	}
	setExtras(e) {
		return this._extra = {
			...this._extra,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setExtra(e, t) {
		return this._extra = {
			...this._extra,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setFingerprint(e) {
		return this._fingerprint = e, this._notifyScopeListeners(), this;
	}
	setLevel(e) {
		return this._level = e, this._notifyScopeListeners(), this;
	}
	setTransactionName(e) {
		return this._transactionName = e, this._notifyScopeListeners(), this;
	}
	setContext(e, t) {
		return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
	}
	setSession(e) {
		return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
	}
	getSession() {
		return this._session;
	}
	update(t) {
		if (!t) return this;
		let n = typeof t == "function" ? t(this) : t, { tags: r, attributes: i, extra: a, user: o, contexts: s, level: c, fingerprint: l = [], propagationContext: u, conversationId: d } = (n instanceof e ? n.getScopeData() : mo(n) ? t : void 0) || {};
		return this._tags = {
			...this._tags,
			...r
		}, this._attributes = {
			...this._attributes,
			...i
		}, this._extra = {
			...this._extra,
			...a
		}, this._contexts = {
			...this._contexts,
			...s
		}, o && Object.keys(o).length && (this._user = o), c && (this._level = c), l.length && (this._fingerprint = l), u && (this._propagationContext = u), d && (this._conversationId = d), this;
	}
	clear() {
		return this._breadcrumbs = [], this._tags = {}, this._attributes = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, this._conversationId = void 0, Lo(this, void 0), this._attachments = [], this.setPropagationContext({
			traceId: No(),
			sampleRand: yo()
		}), this._notifyScopeListeners(), this;
	}
	addBreadcrumb(e, t) {
		let n = typeof t == "number" ? t : zo;
		if (n <= 0) return this;
		let r = {
			timestamp: Do(),
			...e,
			message: e.message ? xo(e.message, 2048) : e.message
		};
		return this._breadcrumbs.push(r), this._breadcrumbs.length > n && (this._breadcrumbs = this._breadcrumbs.slice(-n), this._client?.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
	}
	getLastBreadcrumb() {
		return this._breadcrumbs[this._breadcrumbs.length - 1];
	}
	clearBreadcrumbs() {
		return this._breadcrumbs = [], this._notifyScopeListeners(), this;
	}
	addAttachment(e) {
		return this._attachments.push(e), this;
	}
	clearAttachments() {
		return this._attachments = [], this;
	}
	getScopeData() {
		return {
			breadcrumbs: this._breadcrumbs,
			attachments: this._attachments,
			contexts: this._contexts,
			tags: this._tags,
			attributes: this._attributes,
			extra: this._extra,
			user: this._user,
			level: this._level,
			fingerprint: this._fingerprint || [],
			eventProcessors: this._eventProcessors,
			propagationContext: this._propagationContext,
			sdkProcessingMetadata: this._sdkProcessingMetadata,
			transactionName: this._transactionName,
			span: Ro(this),
			conversationId: this._conversationId
		};
	}
	setSDKProcessingMetadata(e) {
		return this._sdkProcessingMetadata = Mo(this._sdkProcessingMetadata, e, 2), this;
	}
	setPropagationContext(e) {
		return this._propagationContext = e, this;
	}
	getPropagationContext() {
		return this._propagationContext;
	}
	captureException(e, t) {
		let n = t?.event_id || To();
		if (!this._client) return qa && uo.warn("No client configured on scope - will not capture exception!"), n;
		let r = /* @__PURE__ */ Error("Sentry syntheticException");
		return this._client.captureException(e, {
			originalException: e,
			syntheticException: r,
			...t,
			event_id: n
		}, this), n;
	}
	captureMessage(e, t, n) {
		let r = n?.event_id || To();
		if (!this._client) return qa && uo.warn("No client configured on scope - will not capture message!"), r;
		let i = n?.syntheticException ?? Error(e);
		return this._client.captureMessage(e, t, {
			originalException: e,
			syntheticException: i,
			...n,
			event_id: r
		}, this), r;
	}
	captureEvent(e, t) {
		let n = e.event_id || t?.event_id || To();
		return this._client ? (this._client.captureEvent(e, {
			...t,
			event_id: n
		}, this), n) : (qa && uo.warn("No client configured on scope - will not capture event!"), n);
	}
	_notifyScopeListeners() {
		this._notifyingListeners ||= (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
			e(this);
		}), !1);
	}
};
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/defaultScopes.js
function Vo() {
	return Qa("defaultCurrentScope", () => new Bo());
}
function Ho() {
	return Qa("defaultIsolationScope", () => new Bo());
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/chain-and-copy-promiselike.js
var Uo = (e) => e instanceof Promise && !e[Wo], Wo = /* @__PURE__ */ Symbol("chained PromiseLike"), Go = (e, t, n) => {
	let r = e.then((e) => (t(e), e), (e) => {
		throw n(e), e;
	});
	return Uo(r) && Uo(e) ? r : Ko(e, r);
}, Ko = (e, t) => {
	if (!t) return e;
	let n = !1;
	for (let r in e) {
		if (r in t) continue;
		n = !0;
		let i = e[r];
		typeof i == "function" ? Object.defineProperty(t, r, {
			value: (...t) => i.apply(e, t),
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : t[r] = i;
	}
	return n && Object.assign(t, { [Wo]: !0 }), t;
}, qo = class {
	constructor(e, t) {
		let n;
		n = e || new Bo();
		let r;
		r = t || new Bo(), this._stack = [{ scope: n }], this._isolationScope = r;
	}
	withScope(e) {
		let t = this._pushScope(), n;
		try {
			n = e(t);
		} catch (e) {
			throw this._popScope(), e;
		}
		return ho(n) ? Go(n, () => this._popScope(), () => this._popScope()) : (this._popScope(), n);
	}
	getClient() {
		return this.getStackTop().client;
	}
	getScope() {
		return this.getStackTop().scope;
	}
	getIsolationScope() {
		return this._isolationScope;
	}
	getStackTop() {
		return this._stack[this._stack.length - 1];
	}
	_pushScope() {
		let e = this.getScope().clone();
		return this._stack.push({
			client: this.getClient(),
			scope: e
		}), e;
	}
	_popScope() {
		return this._stack.length <= 1 ? !1 : !!this._stack.pop();
	}
};
function Jo() {
	let e = Za(Xa());
	return e.stack = e.stack || new qo(Vo(), Ho());
}
function Yo(e) {
	return Jo().withScope(e);
}
function Xo(e, t) {
	let n = Jo();
	return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function Zo(e) {
	return Jo().withScope(() => e(Jo().getIsolationScope()));
}
function Qo() {
	return {
		withIsolationScope: Zo,
		withScope: Yo,
		withSetScope: Xo,
		withSetIsolationScope: (e, t) => Zo(t),
		getCurrentScope: () => Jo().getScope(),
		getIsolationScope: () => Jo().getIsolationScope()
	};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/asyncContext/index.js
function $o(e) {
	let t = Za(e);
	return t.acs ? t.acs : Qo();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/currentScopes.js
function es() {
	return $o(Xa()).getCurrentScope();
}
function ts() {
	return $o(Xa()).getIsolationScope();
}
function ns() {
	return es().getClient();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/prepareEvent.js
function rs(e) {
	if (e) return is(e) || os(e) ? { captureContext: e } : e;
}
function is(e) {
	return e instanceof Bo || typeof e == "function";
}
var as = [
	"user",
	"level",
	"extra",
	"contexts",
	"tags",
	"fingerprint",
	"propagationContext"
];
function os(e) {
	return Object.keys(e).some((e) => as.includes(e));
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/exports.js
function ss(e, t) {
	return es().captureException(e, rs(t));
}
function cs(e, t) {
	let n = typeof t == "string" ? t : void 0, r = typeof t == "string" ? void 0 : { captureContext: t };
	return es().captureMessage(e, n, r);
}
function ls(e, t) {
	ts().setContext(e, t);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/breadcrumbs.js
var us = 100;
function ds(e, t) {
	let n = ns(), r = ts();
	if (!n) return;
	let { beforeBreadcrumb: i = null, maxBreadcrumbs: a = us } = n.getOptions();
	if (a <= 0) return;
	let o = {
		timestamp: Do(),
		...e
	}, s = i ? to(() => i(o, t)) : o;
	s !== null && (n.emit && n.emit("beforeAddBreadcrumb", s, t), r.addBreadcrumb(s, a));
}
//#endregion
//#region ../../shared/sentry/dist/index.js
var fs;
(function(e) {
	e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation", e.Knowledge = "knowledge";
})(fs ||= {});
//#endregion
//#region ../../shared/auth/dist/jwt/jwt.js
function ps(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(Buffer.from(n, "base64").toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
//#endregion
//#region ../../shared/auth/dist/redirect/redirect.js
var ms = mt.backendDomain ? { "backend-domain": mt.backendDomain } : void 0;
function hs() {
	let e = new URLSearchParams({
		noToken: "true",
		...ms
	}).toString();
	document.location.href = `${mt.url.logIn}?${e}`;
}
//#endregion
//#region ../../shared/auth/dist/authManager/authStorageConfig.js
var gs = "authData", _s = 600, vs = 5, ys = new class {
	authData = null;
	accessTokenExpiresAt = 0;
	clientServerTimeDiff = 0;
	estimatedServerTime() {
		let e = Date.now() / 1e3;
		return this.clientServerTimeDiff >= vs || this.clientServerTimeDiff <= -5 ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
	}
	setAuthData(e) {
		this.authData = e;
		let t = Math.ceil(Date.now() / 1e3) + _s, n = ps(e.access_token).exp;
		if (this.clientServerTimeDiff = n - t, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > vs) {
			let e = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
			console.info(`Client time is ${e} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
		}
		this.accessTokenExpiresAt = n, localStorage.setItem(gs, JSON.stringify(e));
	}
	getAuthData() {
		if (this.authData) return this.authData;
		let e = localStorage.getItem(gs), t = e ? JSON.parse(e) : null;
		return this.validateAuthDataComplete(t) && (this.authData = t), t;
	}
	removeAuthData() {
		this.authData = null, localStorage.removeItem(gs);
	}
	getAccessToken() {
		return this.authData?.access_token || null;
	}
	getRefreshToken() {
		return this.authData?.refresh_token || null;
	}
	validateAuthDataComplete(e) {
		return e ? [
			"access_token",
			"refresh_token",
			"expires_in"
		].every((t) => e[t] !== void 0) : !1;
	}
	isAccessTokenExpired() {
		if (!this.getAccessToken()) return !0;
		let e = this.accessTokenExpiresAt - 30;
		return this.estimatedServerTime() >= e;
	}
	isRefreshTokenExpired(e) {
		if (!e) return !0;
		let t = ps(e), n = t.exp - 30;
		return !t || this.estimatedServerTime() >= n;
	}
	accessTokenExpiresInMs() {
		return (this.accessTokenExpiresAt - 30 - this.estimatedServerTime()) * 1e3;
	}
}();
//#endregion
//#region ../../shared/auth/dist/authManager/interceptor.js
async function bs(e) {
	let t = window.location.origin.replace(/^https?:\/\//, "");
	if (!(!e.response || ["localhost:8080", "uptrends-monitor"].some((e) => t.includes(e)))) {
		try {
			let t = e.response.config.headers.Authorization ?? "", n = t ? t.toString()?.split("Basic ")[1] : "", r = n ? atob(n).split("token:")[1] : "", i = r ? ps(r).exp : "None", a = await As.getAuthData({ localStorageOnly: !0 }), o = Math.floor(Date.now() / 1e3), s = a?.access_token, c = a?.refresh_token, l = s ? ps(s).exp : "None", u = c ? ps(c).exp : "None", d = typeof i == "number" ? o - i : "Unknown", f = typeof l == "number" ? o - l : "Unknown", p = typeof u == "number" ? o - u : "Unknown", m = e.response.headers["x-dixa-rid"];
			ls("Expires", {
				currentTimestamp: o,
				accessTokenFromHeader: i,
				accessTokenFromHeaderDiff: d,
				accessTokenFromLocalStorage: l,
				accessTokenFromLocalStorageDiff: f,
				refreshTokenFromLocalStorage: u,
				refreshTokenFromLocalStorageDiff: p,
				xDixaRid: m,
				navigatorOnline: navigator.onLine
			});
		} catch (e) {
			console.error("Error adding Sentry error context", e);
		}
		cs("401 unauthorized interceptor", {
			level: "debug",
			tags: {
				team: fs.Platform,
				domain: t
			}
		});
	}
}
var xs = /* @__PURE__ */ new Map(), Ss = 3;
function Cs(e) {
	e.interceptors.response.use((e) => (xs.delete(e.config.url), e), (t) => {
		if (t.response) {
			let { status: n } = t.response;
			switch (n) {
				case js.Unauthorized:
					if (!As.isRefreshTokenExpired() && t.config) {
						ds({
							category: "errorInterceptor",
							message: "Access token expired after request",
							level: "debug"
						});
						let n = xs.get(t.config.url) ?? 0;
						if (console.log(`Retrying request (${n + 1}): ${t.config.url}`), n <= Ss) return xs.set(t.config.url, n + 1), e(t.config);
					}
					bs(t), console.error("401 unauthorized interceptor"), hs();
					break;
			}
		}
		return Promise.reject(t);
	});
}
//#endregion
//#region ../../shared/auth/dist/authManager/authManager.js
var ws = Ea.create();
Cs(ws);
var Ts = console.log;
async function Es(e) {
	return new Promise((t) => setTimeout(t, e * 1e3));
}
var Ds = class extends Error {
	constructor(e, t) {
		super(e, t);
	}
};
function Os(e = 0) {
	return Math.min(Math.round((Math.random() + 1) * 1.5 ** e), 30);
}
var ks = 5, As = new class {
	authDataPromise = null;
	retryCount = 0;
	async init(e) {
		let t = await this.refresh(e);
		if (t) ys.setAuthData(t);
		else throw new Ds("Failed to init refresh token", { cause: ys.isRefreshTokenExpired(e) ? "expired" : "unknown" });
	}
	getDebugInfo() {
		let e = ys.getAccessToken();
		if (!e) return {};
		let { exp: t } = ps(e);
		return {
			expire: t ? (/* @__PURE__ */ new Date(t * 1e3)).toISOString() : null,
			now: (/* @__PURE__ */ new Date()).toISOString()
		};
	}
	async getAuthData({ localStorageOnly: e = !1 } = {}) {
		if (e) return ys.getAuthData();
		if (this.authDataPromise) return await this.authDataPromise;
		let t = ys.getAuthData();
		return t ? ys.isAccessTokenExpired() ? (ds({
			category: "refreshToken",
			message: "expired or about to expire",
			level: "debug",
			data: this.getDebugInfo()
		}), this.authDataPromise = this.refresh(t.refresh_token).then((e) => (e && ys.setAuthData(e), this.authDataPromise = null, e)), await this.authDataPromise) : t : null;
	}
	removeAuthData() {
		return ys.removeAuthData();
	}
	validateAuthDataComplete(e) {
		return ys.validateAuthDataComplete(e);
	}
	isAccessTokenExpired() {
		return ys.isAccessTokenExpired();
	}
	isRefreshTokenExpired() {
		let e = ys.getAuthData();
		return !e || ys.isRefreshTokenExpired(e.refresh_token);
	}
	async isSupported() {
		return !Wa.isElectron() || Ga(await Wa.getVersion(), "3.7.0") === 1;
	}
	async refresh(e, t = ks) {
		try {
			return await ws.post(`${mt.url.rest}/v2/login/refresh`, { refreshToken: e }).then((e) => (this.retryCount = 0, e.data.data));
		} catch (n) {
			return await this.handleRefreshError(n, e, t);
		}
	}
	async waitUntilOnline() {
		let e = navigator.onLine === !1;
		for (e && (Ts("AUTH", "Network connection offline - waiting..."), ds({
			category: "refreshToken",
			message: "Network connection offline - waiting...",
			level: "debug"
		})); navigator.onLine === !1;) await Es(5);
		e && (Ts("AUTH", "Network connection restored"), ds({
			category: "refreshToken",
			message: "Network connection restored",
			level: "debug"
		}));
	}
	async retryRefresh(e, t) {
		await this.waitUntilOnline(), this.retryCount++;
		let n = Os(this.retryCount);
		return Ts("AUTH", `Retrying in ${n} seconds`), await Es(n), await this.refresh(e, t);
	}
	async handleRefreshError(e, t, n) {
		if (ys.isRefreshTokenExpired(t)) return Ts("AUTH", "Refresh token expired"), ds({
			category: "refreshToken",
			message: "Refresh token expired",
			level: "debug"
		}), ys.removeAuthData(), hs(), null;
		if (Fa(e)) {
			if (e.message === "timeout exceeded") return Ts("AUTH", "Timeout exceeded"), ds({
				category: "refreshToken",
				message: "Timeout exceeded",
				level: "debug"
			}), await this.retryRefresh(t, n);
			if (e.message === "Network Error") return Ts("AUTH", "Network error"), ds({
				category: "refreshToken",
				message: "Network error",
				level: "debug"
			}), await this.retryRefresh(t, n);
			if (e.response?.status === 401) return Ts("AUTH", "Refresh token invalid (401)"), ys.removeAuthData(), hs(), null;
			ss(e, {
				level: "error",
				tags: {
					team: fs.Platform,
					errorSource: "authManager.refresh"
				}
			});
		}
		return n <= 0 ? (Ts("AUTH", "Retries exhausted, logging out"), ss(e, {
			level: "error",
			tags: {
				team: fs.Platform,
				errorSource: "authManager.refresh"
			}
		}), ys.removeAuthData(), hs(), null) : (Ts("AUTH", `Retrying ${n} more times`), await this.retryRefresh(t, n - 1));
	}
	accessTokenExpiresInMs() {
		return ys.accessTokenExpiresInMs();
	}
}(), js;
(function(e) {
	e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(js ||= {});
//#endregion
//#region src/helpers/graphQLClient/utils/authorizationLink.ts
var Ms = new it((e, t) => new ct((n) => {
	As.getAuthData().then((r) => {
		let i = r?.access_token, a = e.getContext().headers;
		return e.setContext({
			...a,
			headers: { Authorization: i ? `Bearer ${i}` : "" }
		}), t(e).subscribe(n);
	}).catch((e) => n.error(e));
})), Ns = new it((e, t) => new ct((n) => {
	let r = e.getContext(), { headers: i, widgetId: a, widgetType: o, operationName: s } = r;
	As.getAuthData().then((c) => (e.setContext({
		...r,
		headers: {
			...i,
			...a && { "x-integration-widget-id": a },
			...o && { "x-integration-widget-type": o },
			...s && { "x-integration-widget-operation": s },
			...ke(mt.url.partnerIntegrations) && c?.access_token && ve(c.access_token)
		}
	}), t(e).subscribe(n))).catch((e) => n.error(e));
})), Ps = new AbortController(), Fs = (e) => new tt({
	queryDeduplication: !1,
	cache: new ot(),
	link: it.from([
		Ms,
		Ns,
		lt({
			uri: `${e}/graphql`,
			fetch: pt,
			fetchOptions: {
				mode: "cors",
				signal: Ps.signal
			}
		})
	]),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: "no-cache",
			errorPolicy: "all"
		},
		query: {
			fetchPolicy: "no-cache",
			errorPolicy: "all"
		},
		mutate: {
			fetchPolicy: "no-cache",
			errorPolicy: "all"
		}
	}
}), Is = ({ configuration: e, children: t }) => /* @__PURE__ */ G(at, {
	client: Qe(() => Fs(e.baseUrl), [e.baseUrl]),
	children: t
});
//#endregion
//#region src/hooks/useHasApolloClient/useHasApolloClient.ts
function Ls() {
	try {
		return ft(), !0;
	} catch {
		return !1;
	}
}
//#endregion
//#region src/helpers/withWidgetContextProvider/withWidgetContextProvider.tsx
var Rs = ({ configuration: e, children: t }) => Ls() ? t : /* @__PURE__ */ G(Is, {
	configuration: e,
	children: t
}), zs = ({ integrationId: e, type: t, showNotification: n, showModal: r, children: i }) => /* @__PURE__ */ G(nt, { children: (a) => /* @__PURE__ */ G(fe, {
	value: {
		useMutation: Me(e, t),
		useQuery: Ne(e, t),
		useLazyQuery: je(e, t),
		executeQuery: Ae(e, t, a),
		showNotification: n,
		showModal: r ?? (() => null)
	},
	children: i
}) }), Bs = ({ integrationId: e, type: t, configuration: n, showNotification: r, showModal: i, children: a }) => /* @__PURE__ */ G(Rs, {
	configuration: n,
	children: e && t ? /* @__PURE__ */ G(zs, {
		integrationId: e,
		type: t,
		showNotification: r,
		showModal: i,
		children: a
	}) : a
}), Vs = Ke(() => void 0), Hs = () => Xe(Vs), Us = ({ children: e }) => {
	let [t, n] = U(!1), r = {
		headline: "",
		text: "",
		onConfirm: () => n(!1),
		confirmLabel: "Confirm",
		confirmVariant: "primary"
	}, [i, a] = U(r), o = (e) => {
		n(!0), a(e);
	}, s = () => {
		n(!1), a(r);
	};
	return /* @__PURE__ */ K(Vs.Provider, {
		value: o,
		children: [e, /* @__PURE__ */ G(oe, {
			isOpen: t,
			setIsOpen: n,
			headline: i.headline,
			text: i.text,
			confirmLabel: i.confirmLabel,
			confirmVariant: i.confirmVariant,
			cancelLabel: i.cancelLabel,
			cancelVariant: i.cancelVariant,
			onConfirm: i.onConfirm ? () => {
				try {
					i.onConfirm && i.onConfirm();
				} finally {
					s();
				}
			} : void 0,
			onCancel: i.onCancel ? () => {
				try {
					i.onCancel && i.onCancel();
				} finally {
					s();
				}
			} : void 0,
			children: i.children
		})]
	});
}, Ws = gt, Gs = _t, Ks = (e) => e.type === "checkbox", qs = (e) => e instanceof Date, Js = (e) => e == null, Ys = (e) => typeof e == "object", Xs = (e) => !Js(e) && !Array.isArray(e) && Ys(e) && !qs(e), Zs = (e) => Xs(e) && e.target ? Ks(e.target) ? e.target.checked : e.target.value : e, Qs = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, $s = (e, t) => e.has(Qs(t)), ec = (e) => {
	let t = e.constructor && e.constructor.prototype;
	return Xs(t) && t.hasOwnProperty("isPrototypeOf");
}, tc = typeof window < "u" && window.HTMLElement !== void 0 && typeof document < "u";
function nc(e) {
	let t, n = Array.isArray(e), r = typeof FileList < "u" && e instanceof FileList;
	if (e instanceof Date) t = new Date(e);
	else if (e instanceof Set) t = new Set(e);
	else if (!(tc && (e instanceof Blob || r)) && (n || Xs(e))) if (t = n ? [] : {}, !n && !ec(e)) t = e;
	else for (let n in e) e.hasOwnProperty(n) && (t[n] = nc(e[n]));
	else return e;
	return t;
}
var rc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ic = (e) => e === void 0, Y = (e, t, n) => {
	if (!t || !Xs(e)) return n;
	let r = rc(t.split(/[,[\].]+?/)).reduce((e, t) => Js(e) ? e : e[t], e);
	return ic(r) || r === e ? ic(e[t]) ? n : e[t] : r;
}, ac = (e) => typeof e == "boolean", oc = (e) => /^\w*$/.test(e), sc = (e) => rc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), cc = (e, t, n) => {
	let r = -1, i = oc(t) ? [t] : sc(t), a = i.length, o = a - 1;
	for (; ++r < a;) {
		let t = i[r], a = n;
		if (r !== o) {
			let n = e[t];
			a = Xs(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
		}
		if (t === "__proto__" || t === "constructor" || t === "prototype") return;
		e[t] = a, e = e[t];
	}
}, lc = {
	BLUR: "blur",
	FOCUS_OUT: "focusout",
	CHANGE: "change"
}, uc = {
	onBlur: "onBlur",
	onChange: "onChange",
	onSubmit: "onSubmit",
	onTouched: "onTouched",
	all: "all"
}, dc = {
	max: "max",
	min: "min",
	maxLength: "maxLength",
	minLength: "minLength",
	pattern: "pattern",
	required: "required",
	validate: "validate"
}, fc = V.createContext(null), pc = () => V.useContext(fc), mc = (e) => {
	let { children: t, ...n } = e;
	return V.createElement(fc.Provider, { value: n }, t);
}, hc = (e, t, n, r = !0) => {
	let i = { defaultValues: t._defaultValues };
	for (let a in e) Object.defineProperty(i, a, { get: () => {
		let i = a;
		return t._proxyFormState[i] !== uc.all && (t._proxyFormState[i] = !r || uc.all), n && (n[i] = !0), e[i];
	} });
	return i;
};
function gc(e) {
	let t = pc(), { control: n = t.control, disabled: r, name: i, exact: a } = e || {}, [o, s] = V.useState(n._formState), c = V.useRef({
		isDirty: !1,
		isLoading: !1,
		dirtyFields: !1,
		touchedFields: !1,
		validatingFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}), l = V.useRef(i);
	return l.current = i, V.useEffect(() => n._subscribe({
		name: l.current,
		formState: c.current,
		exact: a,
		callback: (e) => {
			!r && s({
				...n._formState,
				...e
			});
		}
	}), [
		n,
		r,
		a
	]), V.useEffect(() => {
		c.current.isValid && n._setValid(!0);
	}, [n]), V.useMemo(() => hc(o, n, c.current, !1), [o, n]);
}
var _c = (e) => typeof e == "string", vc = (e, t, n, r, i) => _c(e) ? (r && t.watch.add(e), Y(n, e, i)) : Array.isArray(e) ? e.map((e) => (r && t.watch.add(e), Y(n, e))) : (r && (t.watchAll = !0), n);
function yc(e) {
	let t = pc(), { control: n = t.control, name: r, defaultValue: i, disabled: a, exact: o } = e || {}, s = V.useRef(r), c = V.useRef(i);
	s.current = r, V.useEffect(() => n._subscribe({
		name: s.current,
		formState: { values: !0 },
		exact: o,
		callback: (e) => !a && u(vc(s.current, n._names, e.values || n._formValues, !1, c.current))
	}), [
		n,
		a,
		o
	]);
	let [l, u] = V.useState(n._getWatch(r, i));
	return V.useEffect(() => n._removeUnmounted()), l;
}
function bc(e) {
	let t = pc(), { name: n, disabled: r, control: i = t.control, shouldUnregister: a } = e, o = $s(i._names.array, n), s = yc({
		control: i,
		name: n,
		defaultValue: Y(i._formValues, n, Y(i._defaultValues, n, e.defaultValue)),
		exact: !0
	}), c = gc({
		control: i,
		name: n,
		exact: !0
	}), l = V.useRef(e), u = V.useRef(i.register(n, {
		...e.rules,
		value: s,
		...ac(e.disabled) ? { disabled: e.disabled } : {}
	})), d = V.useMemo(() => Object.defineProperties({}, {
		invalid: {
			enumerable: !0,
			get: () => !!Y(c.errors, n)
		},
		isDirty: {
			enumerable: !0,
			get: () => !!Y(c.dirtyFields, n)
		},
		isTouched: {
			enumerable: !0,
			get: () => !!Y(c.touchedFields, n)
		},
		isValidating: {
			enumerable: !0,
			get: () => !!Y(c.validatingFields, n)
		},
		error: {
			enumerable: !0,
			get: () => Y(c.errors, n)
		}
	}), [c, n]), f = V.useCallback((e) => u.current.onChange({
		target: {
			value: Zs(e),
			name: n
		},
		type: lc.CHANGE
	}), [n]), p = V.useCallback(() => u.current.onBlur({
		target: {
			value: Y(i._formValues, n),
			name: n
		},
		type: lc.BLUR
	}), [n, i._formValues]), m = V.useCallback((e) => {
		let t = Y(i._fields, n);
		t && e && (t._f.ref = {
			focus: () => e.focus(),
			select: () => e.select(),
			setCustomValidity: (t) => e.setCustomValidity(t),
			reportValidity: () => e.reportValidity()
		});
	}, [i._fields, n]), h = V.useMemo(() => ({
		name: n,
		value: s,
		...ac(r) || c.disabled ? { disabled: c.disabled || r } : {},
		onChange: f,
		onBlur: p,
		ref: m
	}), [
		n,
		r,
		c.disabled,
		f,
		p,
		m,
		s
	]);
	return V.useEffect(() => {
		let e = i._options.shouldUnregister || a;
		i.register(n, {
			...l.current.rules,
			...ac(l.current.disabled) ? { disabled: l.current.disabled } : {}
		});
		let t = (e, t) => {
			let n = Y(i._fields, e);
			n && n._f && (n._f.mount = t);
		};
		if (t(n, !0), e) {
			let e = nc(Y(i._options.defaultValues, n));
			cc(i._defaultValues, n, e), ic(Y(i._formValues, n)) && cc(i._formValues, n, e);
		}
		return !o && i.register(n), () => {
			(o ? e && !i._state.action : e) ? i.unregister(n) : t(n, !1);
		};
	}, [
		n,
		i,
		o,
		a
	]), V.useEffect(() => {
		i._setDisabledField({
			disabled: r,
			name: n
		});
	}, [
		r,
		n,
		i
	]), V.useMemo(() => ({
		field: h,
		formState: c,
		fieldState: d
	}), [
		h,
		c,
		d
	]);
}
var xc = (e) => e.render(bc(e)), Sc = (e, t, n, r, i) => t ? {
	...n[e],
	types: {
		...n[e] && n[e].types ? n[e].types : {},
		[r]: i || !0
	}
} : {}, Cc = (e) => Array.isArray(e) ? e : [e], wc = () => {
	let e = [];
	return {
		get observers() {
			return e;
		},
		next: (t) => {
			for (let n of e) n.next && n.next(t);
		},
		subscribe: (t) => (e.push(t), { unsubscribe: () => {
			e = e.filter((e) => e !== t);
		} }),
		unsubscribe: () => {
			e = [];
		}
	};
}, Tc = (e) => Js(e) || !Ys(e);
function Ec(e, t) {
	if (Tc(e) || Tc(t)) return e === t;
	if (qs(e) && qs(t)) return e.getTime() === t.getTime();
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let i of n) {
		let n = e[i];
		if (!r.includes(i)) return !1;
		if (i !== "ref") {
			let e = t[i];
			if (qs(n) && qs(e) || Xs(n) && Xs(e) || Array.isArray(n) && Array.isArray(e) ? !Ec(n, e) : n !== e) return !1;
		}
	}
	return !0;
}
var Dc = (e) => Xs(e) && !Object.keys(e).length, Oc = (e) => e.type === "file", kc = (e) => typeof e == "function", Ac = (e) => {
	if (!tc) return !1;
	let t = e ? e.ownerDocument : 0;
	return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, jc = (e) => e.type === "select-multiple", Mc = (e) => e.type === "radio", Nc = (e) => Mc(e) || Ks(e), Pc = (e) => Ac(e) && e.isConnected;
function Fc(e, t) {
	let n = t.slice(0, -1).length, r = 0;
	for (; r < n;) e = ic(e) ? r++ : e[t[r++]];
	return e;
}
function Ic(e) {
	for (let t in e) if (e.hasOwnProperty(t) && !ic(e[t])) return !1;
	return !0;
}
function Lc(e, t) {
	let n = Array.isArray(t) ? t : oc(t) ? [t] : sc(t), r = n.length === 1 ? e : Fc(e, n), i = n.length - 1, a = n[i];
	return r && delete r[a], i !== 0 && (Xs(r) && Dc(r) || Array.isArray(r) && Ic(r)) && Lc(e, n.slice(0, -1)), e;
}
var Rc = (e) => {
	for (let t in e) if (kc(e[t])) return !0;
	return !1;
};
function zc(e, t = {}) {
	let n = Array.isArray(e);
	if (Xs(e) || n) for (let n in e) Array.isArray(e[n]) || Xs(e[n]) && !Rc(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, zc(e[n], t[n])) : Js(e[n]) || (t[n] = !0);
	return t;
}
function Bc(e, t, n) {
	let r = Array.isArray(e);
	if (Xs(e) || r) for (let r in e) Array.isArray(e[r]) || Xs(e[r]) && !Rc(e[r]) ? ic(t) || Tc(n[r]) ? n[r] = Array.isArray(e[r]) ? zc(e[r], []) : { ...zc(e[r]) } : Bc(e[r], Js(t) ? {} : t[r], n[r]) : n[r] = !Ec(e[r], t[r]);
	return n;
}
var Vc = (e, t) => Bc(e, t, zc(t)), Hc = {
	value: !1,
	isValid: !1
}, Uc = {
	value: !0,
	isValid: !0
}, Wc = (e) => {
	if (Array.isArray(e)) {
		if (e.length > 1) {
			let t = e.filter((e) => e && e.checked && !e.disabled).map((e) => e.value);
			return {
				value: t,
				isValid: !!t.length
			};
		}
		return e[0].checked && !e[0].disabled ? e[0].attributes && !ic(e[0].attributes.value) ? ic(e[0].value) || e[0].value === "" ? Uc : {
			value: e[0].value,
			isValid: !0
		} : Uc : Hc;
	}
	return Hc;
}, Gc = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => ic(e) ? e : t ? e === "" ? NaN : e && +e : n && _c(e) ? new Date(e) : r ? r(e) : e, Kc = {
	isValid: !1,
	value: null
}, qc = (e) => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
	isValid: !0,
	value: t.value
} : e, Kc) : Kc;
function Jc(e) {
	let t = e.ref;
	return Oc(t) ? t.files : Mc(t) ? qc(e.refs).value : jc(t) ? [...t.selectedOptions].map(({ value: e }) => e) : Ks(t) ? Wc(e.refs).value : Gc(ic(t.value) ? e.ref.value : t.value, e);
}
var Yc = (e, t, n, r) => {
	let i = {};
	for (let n of e) {
		let e = Y(t, n);
		e && cc(i, n, e._f);
	}
	return {
		criteriaMode: n,
		names: [...e],
		fields: i,
		shouldUseNativeValidation: r
	};
}, Xc = (e) => e instanceof RegExp, Zc = (e) => ic(e) ? e : Xc(e) ? e.source : Xs(e) ? Xc(e.value) ? e.value.source : e.value : e, Qc = (e) => ({
	isOnSubmit: !e || e === uc.onSubmit,
	isOnBlur: e === uc.onBlur,
	isOnChange: e === uc.onChange,
	isOnAll: e === uc.all,
	isOnTouch: e === uc.onTouched
}), $c = "AsyncFunction", el = (e) => !!e && !!e.validate && !!(kc(e.validate) && e.validate.constructor.name === $c || Xs(e.validate) && Object.values(e.validate).find((e) => e.constructor.name === $c)), tl = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), nl = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((t) => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))), rl = (e, t, n, r) => {
	for (let i of n || Object.keys(e)) {
		let n = Y(e, i);
		if (n) {
			let { _f: e, ...a } = n;
			if (e) {
				if (e.refs && e.refs[0] && t(e.refs[0], i) && !r || e.ref && t(e.ref, e.name) && !r) return !0;
				if (rl(a, t)) break;
			} else if (Xs(a) && rl(a, t)) break;
		}
	}
};
function il(e, t, n) {
	let r = Y(e, n);
	if (r || oc(n)) return {
		error: r,
		name: n
	};
	let i = n.split(".");
	for (; i.length;) {
		let r = i.join("."), a = Y(t, r), o = Y(e, r);
		if (a && !Array.isArray(a) && n !== r) return { name: n };
		if (o && o.type) return {
			name: r,
			error: o
		};
		i.pop();
	}
	return { name: n };
}
var al = (e, t, n, r) => {
	n(e);
	let { name: i, ...a } = e;
	return Dc(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((e) => t[e] === (!r || uc.all));
}, ol = (e, t, n) => !e || !t || e === t || Cc(e).some((e) => e && (n ? e === t : e.startsWith(t) || t.startsWith(e))), sl = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, cl = (e, t) => !rc(Y(e, t)).length && Lc(e, t), ll = (e, t, n) => {
	let r = Cc(Y(e, n));
	return cc(r, "root", t[n]), cc(e, n, r), e;
}, ul = (e) => _c(e);
function dl(e, t, n = "validate") {
	if (ul(e) || Array.isArray(e) && e.every(ul) || ac(e) && !e) return {
		type: n,
		message: ul(e) ? e : "",
		ref: t
	};
}
var fl = (e) => Xs(e) && !Xc(e) ? e : {
	value: e,
	message: ""
}, pl = async (e, t, n, r, i, a) => {
	let { ref: o, refs: s, required: c, maxLength: l, minLength: u, min: d, max: f, pattern: p, validate: m, name: h, valueAsNumber: g, mount: _ } = e._f, v = Y(n, h);
	if (!_ || t.has(h)) return {};
	let y = s ? s[0] : o, b = (e) => {
		i && y.reportValidity && (y.setCustomValidity(ac(e) ? "" : e || ""), y.reportValidity());
	}, x = {}, S = Mc(o), C = Ks(o), w = S || C, T = (g || Oc(o)) && ic(o.value) && ic(v) || Ac(o) && o.value === "" || v === "" || Array.isArray(v) && !v.length, E = Sc.bind(null, h, r, x), D = (e, t, n, r = dc.maxLength, i = dc.minLength) => {
		let a = e ? t : n;
		x[h] = {
			type: e ? r : i,
			message: a,
			ref: o,
			...E(e ? r : i, a)
		};
	};
	if (a ? !Array.isArray(v) || !v.length : c && (!w && (T || Js(v)) || ac(v) && !v || C && !Wc(s).isValid || S && !qc(s).isValid)) {
		let { value: e, message: t } = ul(c) ? {
			value: !!c,
			message: c
		} : fl(c);
		if (e && (x[h] = {
			type: dc.required,
			message: t,
			ref: y,
			...E(dc.required, t)
		}, !r)) return b(t), x;
	}
	if (!T && (!Js(d) || !Js(f))) {
		let e, t, n = fl(f), i = fl(d);
		if (!Js(v) && !isNaN(v)) {
			let r = o.valueAsNumber || v && +v;
			Js(n.value) || (e = r > n.value), Js(i.value) || (t = r < i.value);
		} else {
			let r = o.valueAsDate || new Date(v), a = (e) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + e), s = o.type == "time", c = o.type == "week";
			_c(n.value) && v && (e = s ? a(v) > a(n.value) : c ? v > n.value : r > new Date(n.value)), _c(i.value) && v && (t = s ? a(v) < a(i.value) : c ? v < i.value : r < new Date(i.value));
		}
		if ((e || t) && (D(!!e, n.message, i.message, dc.max, dc.min), !r)) return b(x[h].message), x;
	}
	if ((l || u) && !T && (_c(v) || a && Array.isArray(v))) {
		let e = fl(l), t = fl(u), n = !Js(e.value) && v.length > +e.value, i = !Js(t.value) && v.length < +t.value;
		if ((n || i) && (D(n, e.message, t.message), !r)) return b(x[h].message), x;
	}
	if (p && !T && _c(v)) {
		let { value: e, message: t } = fl(p);
		if (Xc(e) && !v.match(e) && (x[h] = {
			type: dc.pattern,
			message: t,
			ref: o,
			...E(dc.pattern, t)
		}, !r)) return b(t), x;
	}
	if (m) {
		if (kc(m)) {
			let e = dl(await m(v, n), y);
			if (e && (x[h] = {
				...e,
				...E(dc.validate, e.message)
			}, !r)) return b(e.message), x;
		} else if (Xs(m)) {
			let e = {};
			for (let t in m) {
				if (!Dc(e) && !r) break;
				let i = dl(await m[t](v, n), y, t);
				i && (e = {
					...i,
					...E(t, i.message)
				}, b(i.message), r && (x[h] = e));
			}
			if (!Dc(e) && (x[h] = {
				ref: y,
				...e
			}, !r)) return x;
		}
	}
	return b(!0), x;
}, ml = {
	mode: uc.onSubmit,
	reValidateMode: uc.onChange,
	shouldFocusError: !0
};
function hl(e = {}) {
	let t = {
		...ml,
		...e
	}, n = {
		submitCount: 0,
		isDirty: !1,
		isLoading: kc(t.defaultValues),
		isValidating: !1,
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		touchedFields: {},
		dirtyFields: {},
		validatingFields: {},
		errors: t.errors || {},
		disabled: t.disabled || !1
	}, r = {}, i = (Xs(t.defaultValues) || Xs(t.values)) && nc(t.values || t.defaultValues) || {}, a = t.shouldUnregister ? {} : nc(i), o = {
		action: !1,
		mount: !1,
		watch: !1
	}, s = {
		mount: /* @__PURE__ */ new Set(),
		disabled: /* @__PURE__ */ new Set(),
		unMount: /* @__PURE__ */ new Set(),
		array: /* @__PURE__ */ new Set(),
		watch: /* @__PURE__ */ new Set()
	}, c, l = 0, u = {
		isDirty: !1,
		dirtyFields: !1,
		validatingFields: !1,
		touchedFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}, d = { ...u }, f = {
		array: wc(),
		state: wc()
	}, p = Qc(t.mode), m = Qc(t.reValidateMode), h = t.criteriaMode === uc.all, g = (e) => (t) => {
		clearTimeout(l), l = setTimeout(e, t);
	}, _ = async (e) => {
		if (!t.disabled && (u.isValid || d.isValid || e)) {
			let e = t.resolver ? Dc((await T()).errors) : await D(r, !0);
			e !== n.isValid && f.state.next({ isValid: e });
		}
	}, v = (e, r) => {
		!t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((e || Array.from(s.mount)).forEach((e) => {
			e && (r ? cc(n.validatingFields, e, r) : Lc(n.validatingFields, e));
		}), f.state.next({
			validatingFields: n.validatingFields,
			isValidating: !Dc(n.validatingFields)
		}));
	}, y = (e, s = [], c, l, p = !0, m = !0) => {
		if (l && c && !t.disabled) {
			if (o.action = !0, m && Array.isArray(Y(r, e))) {
				let t = c(Y(r, e), l.argA, l.argB);
				p && cc(r, e, t);
			}
			if (m && Array.isArray(Y(n.errors, e))) {
				let t = c(Y(n.errors, e), l.argA, l.argB);
				p && cc(n.errors, e, t), cl(n.errors, e);
			}
			if ((u.touchedFields || d.touchedFields) && m && Array.isArray(Y(n.touchedFields, e))) {
				let t = c(Y(n.touchedFields, e), l.argA, l.argB);
				p && cc(n.touchedFields, e, t);
			}
			(u.dirtyFields || d.dirtyFields) && (n.dirtyFields = Vc(i, a)), f.state.next({
				name: e,
				isDirty: k(e, s),
				dirtyFields: n.dirtyFields,
				errors: n.errors,
				isValid: n.isValid
			});
		} else cc(a, e, s);
	}, b = (e, t) => {
		cc(n.errors, e, t), f.state.next({ errors: n.errors });
	}, x = (e) => {
		n.errors = e, f.state.next({
			errors: n.errors,
			isValid: !1
		});
	}, S = (e, t, n, s) => {
		let c = Y(r, e);
		if (c) {
			let r = Y(a, e, ic(n) ? Y(i, e) : n);
			ic(r) || s && s.defaultChecked || t ? cc(a, e, t ? r : Jc(c._f)) : M(e, r), o.mount && _();
		}
	}, C = (e, r, a, o, s) => {
		let c = !1, l = !1, p = { name: e };
		if (!t.disabled) {
			if (!a || o) {
				(u.isDirty || d.isDirty) && (l = n.isDirty, n.isDirty = p.isDirty = k(), c = l !== p.isDirty);
				let t = Ec(Y(i, e), r);
				l = !!Y(n.dirtyFields, e), t ? Lc(n.dirtyFields, e) : cc(n.dirtyFields, e, !0), p.dirtyFields = n.dirtyFields, c ||= (u.dirtyFields || d.dirtyFields) && l !== !t;
			}
			if (a) {
				let t = Y(n.touchedFields, e);
				t || (cc(n.touchedFields, e, a), p.touchedFields = n.touchedFields, c ||= (u.touchedFields || d.touchedFields) && t !== a);
			}
			c && s && f.state.next(p);
		}
		return c ? p : {};
	}, w = (e, r, i, a) => {
		let o = Y(n.errors, e), s = (u.isValid || d.isValid) && ac(r) && n.isValid !== r;
		if (t.delayError && i ? (c = g(() => b(e, i)), c(t.delayError)) : (clearTimeout(l), c = null, i ? cc(n.errors, e, i) : Lc(n.errors, e)), (i ? !Ec(o, i) : o) || !Dc(a) || s) {
			let t = {
				...a,
				...s && ac(r) ? { isValid: r } : {},
				errors: n.errors,
				name: e
			};
			n = {
				...n,
				...t
			}, f.state.next(t);
		}
	}, T = async (e) => {
		v(e, !0);
		let n = await t.resolver(a, t.context, Yc(e || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
		return v(e), n;
	}, E = async (e) => {
		let { errors: t } = await T(e);
		if (e) for (let r of e) {
			let e = Y(t, r);
			e ? cc(n.errors, r, e) : Lc(n.errors, r);
		}
		else n.errors = t;
		return t;
	}, D = async (e, r, i = { valid: !0 }) => {
		for (let o in e) {
			let c = e[o];
			if (c) {
				let { _f: e, ...l } = c;
				if (e) {
					let l = s.array.has(e.name), d = c._f && el(c._f);
					d && u.validatingFields && v([o], !0);
					let f = await pl(c, s.disabled, a, h, t.shouldUseNativeValidation && !r, l);
					if (d && u.validatingFields && v([o]), f[e.name] && (i.valid = !1, r)) break;
					!r && (Y(f, e.name) ? l ? ll(n.errors, f, e.name) : cc(n.errors, e.name, f[e.name]) : Lc(n.errors, e.name));
				}
				!Dc(l) && await D(l, r, i);
			}
		}
		return i.valid;
	}, O = () => {
		for (let e of s.unMount) {
			let t = Y(r, e);
			t && (t._f.refs ? t._f.refs.every((e) => !Pc(e)) : !Pc(t._f.ref)) && z(e);
		}
		s.unMount = /* @__PURE__ */ new Set();
	}, k = (e, n) => !t.disabled && (e && n && cc(a, e, n), !Ec(te(), i)), A = (e, t, n) => vc(e, s, { ...o.mount ? a : ic(t) ? i : _c(e) ? { [e]: t } : t }, n, t), j = (e) => rc(Y(o.mount ? a : i, e, t.shouldUnregister ? Y(i, e, []) : [])), M = (e, t, n = {}) => {
		let i = Y(r, e), o = t;
		if (i) {
			let n = i._f;
			n && (!n.disabled && cc(a, e, Gc(t, n)), o = Ac(n.ref) && Js(t) ? "" : t, jc(n.ref) ? [...n.ref.options].forEach((e) => e.selected = o.includes(e.value)) : n.refs ? Ks(n.ref) ? n.refs.length > 1 ? n.refs.forEach((e) => (!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(o) ? !!o.find((t) => t === e.value) : o === e.value)) : n.refs[0] && (n.refs[0].checked = !!o) : n.refs.forEach((e) => e.checked = e.value === o) : Oc(n.ref) ? n.ref.value = "" : (n.ref.value = o, n.ref.type || f.state.next({
				name: e,
				values: nc(a)
			})));
		}
		(n.shouldDirty || n.shouldTouch) && C(e, o, n.shouldTouch, n.shouldDirty, !0), n.shouldValidate && I(e);
	}, N = (e, t, n) => {
		for (let i in t) {
			let a = t[i], o = `${e}.${i}`, c = Y(r, o);
			(s.array.has(e) || Xs(a) || c && !c._f) && !qs(a) ? N(o, a, n) : M(o, a, n);
		}
	}, P = (e, t, c = {}) => {
		let l = Y(r, e), p = s.array.has(e), m = nc(t);
		cc(a, e, m), p ? (f.array.next({
			name: e,
			values: nc(a)
		}), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && c.shouldDirty && f.state.next({
			name: e,
			dirtyFields: Vc(i, a),
			isDirty: k(e, m)
		})) : l && !l._f && !Js(m) ? N(e, m, c) : M(e, m, c), nl(e, s) && f.state.next({ ...n }), f.state.next({
			name: o.mount ? e : void 0,
			values: nc(a)
		});
	}, ee = async (e) => {
		o.mount = !0;
		let i = e.target, l = i.name, g = !0, y = Y(r, l), b = (e) => {
			g = Number.isNaN(e) || qs(e) && isNaN(e.getTime()) || Ec(e, Y(a, l, e));
		};
		if (y) {
			let o, x, S = i.type ? Jc(y._f) : Zs(e), E = e.type === lc.BLUR || e.type === lc.FOCUS_OUT, O = !tl(y._f) && !t.resolver && !Y(n.errors, l) && !y._f.deps || sl(E, Y(n.touchedFields, l), n.isSubmitted, m, p), k = nl(l, s, E);
			cc(a, l, S), E ? (y._f.onBlur && y._f.onBlur(e), c && c(0)) : y._f.onChange && y._f.onChange(e);
			let A = C(l, S, E), j = !Dc(A) || k;
			if (!E && f.state.next({
				name: l,
				type: e.type,
				values: nc(a)
			}), O) return (u.isValid || d.isValid) && (t.mode === "onBlur" ? E && _() : E || _()), j && f.state.next({
				name: l,
				...k ? {} : A
			});
			if (!E && k && f.state.next({ ...n }), t.resolver) {
				let { errors: e } = await T([l]);
				if (b(S), g) {
					let t = il(n.errors, r, l), i = il(e, r, t.name || l);
					o = i.error, l = i.name, x = Dc(e);
				}
			} else v([l], !0), o = (await pl(y, s.disabled, a, h, t.shouldUseNativeValidation))[l], v([l]), b(S), g && (o ? x = !1 : (u.isValid || d.isValid) && (x = await D(r, !0)));
			g && (y._f.deps && I(y._f.deps), w(l, x, o, A));
		}
	}, F = (e, t) => {
		if (Y(n.errors, t) && e.focus) return e.focus(), 1;
	}, I = async (e, i = {}) => {
		let a, o, c = Cc(e);
		if (t.resolver) {
			let t = await E(ic(e) ? e : c);
			a = Dc(t), o = e ? !c.some((e) => Y(t, e)) : a;
		} else e ? (o = (await Promise.all(c.map(async (e) => {
			let t = Y(r, e);
			return await D(t && t._f ? { [e]: t } : t);
		}))).every(Boolean), !(!o && !n.isValid) && _()) : o = a = await D(r);
		return f.state.next({
			...!_c(e) || (u.isValid || d.isValid) && a !== n.isValid ? {} : { name: e },
			...t.resolver || !e ? { isValid: a } : {},
			errors: n.errors
		}), i.shouldFocus && !o && rl(r, F, e ? c : s.mount), o;
	}, te = (e) => {
		let t = { ...o.mount ? a : i };
		return ic(e) ? t : _c(e) ? Y(t, e) : e.map((e) => Y(t, e));
	}, L = (e, t) => ({
		invalid: !!Y((t || n).errors, e),
		isDirty: !!Y((t || n).dirtyFields, e),
		error: Y((t || n).errors, e),
		isValidating: !!Y(n.validatingFields, e),
		isTouched: !!Y((t || n).touchedFields, e)
	}), ne = (e) => {
		e && Cc(e).forEach((e) => Lc(n.errors, e)), f.state.next({ errors: e ? n.errors : {} });
	}, re = (e, t, i) => {
		let a = (Y(r, e, { _f: {} })._f || {}).ref, { ref: o, message: s, type: c, ...l } = Y(n.errors, e) || {};
		cc(n.errors, e, {
			...l,
			...t,
			ref: a
		}), f.state.next({
			name: e,
			errors: n.errors,
			isValid: !1
		}), i && i.shouldFocus && a && a.focus && a.focus();
	}, ie = (e, t) => kc(e) ? f.state.subscribe({ next: (n) => e(A(void 0, t), n) }) : A(e, t, !0), R = (e) => f.state.subscribe({ next: (t) => {
		ol(e.name, t.name, e.exact) && al(t, e.formState || u, he, e.reRenderRoot) && e.callback({
			values: { ...a },
			...n,
			...t
		});
	} }).unsubscribe, ae = (e) => (o.mount = !0, d = {
		...d,
		...e.formState
	}, R({
		...e,
		formState: d
	})), z = (e, o = {}) => {
		for (let c of e ? Cc(e) : s.mount) s.mount.delete(c), s.array.delete(c), o.keepValue || (Lc(r, c), Lc(a, c)), !o.keepError && Lc(n.errors, c), !o.keepDirty && Lc(n.dirtyFields, c), !o.keepTouched && Lc(n.touchedFields, c), !o.keepIsValidating && Lc(n.validatingFields, c), !t.shouldUnregister && !o.keepDefaultValue && Lc(i, c);
		f.state.next({ values: nc(a) }), f.state.next({
			...n,
			...o.keepDirty ? { isDirty: k() } : {}
		}), !o.keepIsValid && _();
	}, oe = ({ disabled: e, name: t }) => {
		(ac(e) && o.mount || e || s.disabled.has(t)) && (e ? s.disabled.add(t) : s.disabled.delete(t));
	}, se = (e, n = {}) => {
		let a = Y(r, e), c = ac(n.disabled) || ac(t.disabled);
		return cc(r, e, {
			...a || {},
			_f: {
				...a && a._f ? a._f : { ref: { name: e } },
				name: e,
				mount: !0,
				...n
			}
		}), s.mount.add(e), a ? oe({
			disabled: ac(n.disabled) ? n.disabled : t.disabled,
			name: e
		}) : S(e, !0, n.value), {
			...c ? { disabled: n.disabled || t.disabled } : {},
			...t.progressive ? {
				required: !!n.required,
				min: Zc(n.min),
				max: Zc(n.max),
				minLength: Zc(n.minLength),
				maxLength: Zc(n.maxLength),
				pattern: Zc(n.pattern)
			} : {},
			name: e,
			onChange: ee,
			onBlur: ee,
			ref: (c) => {
				if (c) {
					se(e, n), a = Y(r, e);
					let t = ic(c.value) && c.querySelectorAll && c.querySelectorAll("input,select,textarea")[0] || c, o = Nc(t), s = a._f.refs || [];
					if (o ? s.find((e) => e === t) : t === a._f.ref) return;
					cc(r, e, { _f: {
						...a._f,
						...o ? {
							refs: [
								...s.filter(Pc),
								t,
								...Array.isArray(Y(i, e)) ? [{}] : []
							],
							ref: {
								type: t.type,
								name: e
							}
						} : { ref: t }
					} }), S(e, !1, void 0, t);
				} else a = Y(r, e, {}), a._f && (a._f.mount = !1), (t.shouldUnregister || n.shouldUnregister) && !($s(s.array, e) && o.action) && s.unMount.add(e);
			}
		};
	}, ce = () => t.shouldFocusError && rl(r, F, s.mount), le = (e) => {
		ac(e) && (f.state.next({ disabled: e }), rl(r, (t, n) => {
			let i = Y(r, n);
			i && (t.disabled = i._f.disabled || e, Array.isArray(i._f.refs) && i._f.refs.forEach((t) => {
				t.disabled = i._f.disabled || e;
			}));
		}, 0, !1));
	}, ue = (e, i) => async (o) => {
		let c;
		o && (o.preventDefault && o.preventDefault(), o.persist && o.persist());
		let l = nc(a);
		if (f.state.next({ isSubmitting: !0 }), t.resolver) {
			let { errors: e, values: t } = await T();
			n.errors = e, l = t;
		} else await D(r);
		if (s.disabled.size) for (let e of s.disabled) cc(l, e, void 0);
		if (Lc(n.errors, "root"), Dc(n.errors)) {
			f.state.next({ errors: {} });
			try {
				await e(l, o);
			} catch (e) {
				c = e;
			}
		} else i && await i({ ...n.errors }, o), ce(), setTimeout(ce);
		if (f.state.next({
			isSubmitted: !0,
			isSubmitting: !1,
			isSubmitSuccessful: Dc(n.errors) && !c,
			submitCount: n.submitCount + 1,
			errors: n.errors
		}), c) throw c;
	}, de = (e, t = {}) => {
		Y(r, e) && (ic(t.defaultValue) ? P(e, nc(Y(i, e))) : (P(e, t.defaultValue), cc(i, e, nc(t.defaultValue))), t.keepTouched || Lc(n.touchedFields, e), t.keepDirty || (Lc(n.dirtyFields, e), n.isDirty = t.defaultValue ? k(e, nc(Y(i, e))) : k()), t.keepError || (Lc(n.errors, e), u.isValid && _()), f.state.next({ ...n }));
	}, fe = (e, c = {}) => {
		let l = e ? nc(e) : i, d = nc(l), p = Dc(e), m = p ? i : d;
		if (c.keepDefaultValues || (i = l), !c.keepValues) {
			if (c.keepDirtyValues) {
				let e = /* @__PURE__ */ new Set([...s.mount, ...Object.keys(Vc(i, a))]);
				for (let t of Array.from(e)) Y(n.dirtyFields, t) ? cc(m, t, Y(a, t)) : P(t, Y(m, t));
			} else {
				if (tc && ic(e)) for (let e of s.mount) {
					let t = Y(r, e);
					if (t && t._f) {
						let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
						if (Ac(e)) {
							let t = e.closest("form");
							if (t) {
								t.reset();
								break;
							}
						}
					}
				}
				for (let e of s.mount) P(e, Y(m, e));
			}
			a = nc(m), f.array.next({ values: { ...m } }), f.state.next({ values: { ...m } });
		}
		s = {
			mount: c.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
			unMount: /* @__PURE__ */ new Set(),
			array: /* @__PURE__ */ new Set(),
			disabled: /* @__PURE__ */ new Set(),
			watch: /* @__PURE__ */ new Set(),
			watchAll: !1,
			focus: ""
		}, o.mount = !u.isValid || !!c.keepIsValid || !!c.keepDirtyValues, o.watch = !!t.shouldUnregister, f.state.next({
			submitCount: c.keepSubmitCount ? n.submitCount : 0,
			isDirty: p ? !1 : c.keepDirty ? n.isDirty : !!(c.keepDefaultValues && !Ec(e, i)),
			isSubmitted: c.keepIsSubmitted ? n.isSubmitted : !1,
			dirtyFields: p ? {} : c.keepDirtyValues ? c.keepDefaultValues && a ? Vc(i, a) : n.dirtyFields : c.keepDefaultValues && e ? Vc(i, e) : c.keepDirty ? n.dirtyFields : {},
			touchedFields: c.keepTouched ? n.touchedFields : {},
			errors: c.keepErrors ? n.errors : {},
			isSubmitSuccessful: c.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
			isSubmitting: !1
		});
	}, pe = (e, t) => fe(kc(e) ? e(a) : e, t), me = (e, t = {}) => {
		let n = Y(r, e), i = n && n._f;
		if (i) {
			let e = i.refs ? i.refs[0] : i.ref;
			e.focus && (e.focus(), t.shouldSelect && kc(e.select) && e.select());
		}
	}, he = (e) => {
		n = {
			...n,
			...e
		};
	}, ge = {
		control: {
			register: se,
			unregister: z,
			getFieldState: L,
			handleSubmit: ue,
			setError: re,
			_subscribe: R,
			_runSchema: T,
			_getWatch: A,
			_getDirty: k,
			_setValid: _,
			_setFieldArray: y,
			_setDisabledField: oe,
			_setErrors: x,
			_getFieldArray: j,
			_reset: fe,
			_resetDefaultValues: () => kc(t.defaultValues) && t.defaultValues().then((e) => {
				pe(e, t.resetOptions), f.state.next({ isLoading: !1 });
			}),
			_removeUnmounted: O,
			_disableForm: le,
			_subjects: f,
			_proxyFormState: u,
			get _fields() {
				return r;
			},
			get _formValues() {
				return a;
			},
			get _state() {
				return o;
			},
			set _state(e) {
				o = e;
			},
			get _defaultValues() {
				return i;
			},
			get _names() {
				return s;
			},
			set _names(e) {
				s = e;
			},
			get _formState() {
				return n;
			},
			get _options() {
				return t;
			},
			set _options(e) {
				t = {
					...t,
					...e
				};
			}
		},
		subscribe: ae,
		trigger: I,
		register: se,
		handleSubmit: ue,
		watch: ie,
		setValue: P,
		getValues: te,
		reset: pe,
		resetField: de,
		clearErrors: ne,
		unregister: z,
		setError: re,
		setFocus: me,
		getFieldState: L
	};
	return {
		...ge,
		formControl: ge
	};
}
function gl(e = {}) {
	let t = V.useRef(void 0), n = V.useRef(void 0), [r, i] = V.useState({
		isDirty: !1,
		isValidating: !1,
		isLoading: kc(e.defaultValues),
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		submitCount: 0,
		dirtyFields: {},
		touchedFields: {},
		validatingFields: {},
		errors: e.errors || {},
		disabled: e.disabled || !1,
		defaultValues: kc(e.defaultValues) ? void 0 : e.defaultValues
	});
	t.current || (t.current = {
		...e.formControl ? e.formControl : hl(e),
		formState: r
	}, e.formControl && e.defaultValues && !kc(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
	let a = t.current.control;
	return a._options = e, V.useLayoutEffect(() => a._subscribe({
		formState: a._proxyFormState,
		callback: () => i({ ...a._formState }),
		reRenderRoot: !0
	}), [a]), V.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), V.useEffect(() => {
		if (a._proxyFormState.isDirty) {
			let e = a._getDirty();
			e !== r.isDirty && a._subjects.state.next({ isDirty: e });
		}
	}, [a, r.isDirty]), V.useEffect(() => {
		e.values && !Ec(e.values, n.current) ? (a._reset(e.values, a._options.resetOptions), n.current = e.values, i((e) => ({ ...e }))) : a._resetDefaultValues();
	}, [e.values, a]), V.useEffect(() => {
		e.errors && !Dc(e.errors) && a._setErrors(e.errors);
	}, [e.errors, a]), V.useEffect(() => {
		a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
	}), V.useEffect(() => {
		e.shouldUnregister && a._subjects.state.next({ values: a._getWatch() });
	}, [e.shouldUnregister, a]), t.current.formState = hc(r, a), t.current;
}
//#endregion
//#region \0callable-external:lodash/identity
var _l = vt;
//#endregion
//#region ../../shared/hook-form/dist/index.js
function vl(e) {
	return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var yl = Gs, bl = [
	"control",
	"defaultValue",
	"name",
	"rules",
	"shouldUnregister"
];
function xl(e) {
	let t = yl(e, bl);
	return {
		controller: bc(t),
		controllerProps: t
	};
}
var Sl = [
	"className",
	"description",
	"disabled",
	"helpIcon",
	"label",
	"noAlert",
	"noLabel",
	"style"
];
function Cl(e) {
	let { controller: t, controllerProps: n } = xl(e);
	return {
		controller: t,
		controllerProps: n,
		fieldWrapperProps: {
			...yl(e, Sl),
			required: vl(n.rules?.required),
			meta: {
				touched: t.fieldState.isTouched,
				error: t.fieldState.error?.message,
				success: e.meta?.success,
				warning: e.meta?.warning
			},
			labelFor: n.name,
			noLabel: e.noLabel,
			noAlert: e.noAlert
		}
	};
}
var wl = ({ children: e, ...t }) => {
	let { controller: n, controllerProps: r, fieldWrapperProps: i } = Cl(t), { name: a, onBlur: o, onChange: s, ...c } = n.field;
	return /* @__PURE__ */ G(_, {
		...i,
		children: /* @__PURE__ */ G(w, {
			...t.componentProps,
			...c,
			multiple: !1,
			value: c.value ? [c.value] : [],
			onBlur: (e) => {
				t.componentProps?.onBlur?.(e), o();
			},
			onChange: (e) => {
				t.componentProps?.onChange?.(e), s(e.selectedValues[0] ?? null);
			},
			id: r.name,
			"aria-disabled": i.disabled,
			disabled: i.disabled,
			"aria-required": i.required,
			required: i.required,
			status: _.getStatus(i.meta),
			children: e
		})
	});
}, Tl = _l, X = ({ transformValue: e = Tl, label: t, helpIcon: n, className: r, ...i }) => {
	let { controller: { field: a }, controllerProps: { name: o } } = xl(i);
	return /* @__PURE__ */ K(v, {
		gap: "200",
		alignItems: "center",
		className: r,
		children: [/* @__PURE__ */ G(ee, {
			...a,
			id: o,
			checked: e(a.value),
			disabled: i.componentProps?.disabled,
			onChange: (t) => {
				i.componentProps?.onChange?.(t), a.onChange(e(t.target.checked));
			}
		}), t && /* @__PURE__ */ G(p, {
			htmlFor: o,
			helpIcon: n,
			children: t
		})]
	});
}, El = (e) => {
	let { controller: t, controllerProps: n, fieldWrapperProps: r } = Cl(e);
	return /* @__PURE__ */ G(_, {
		...r,
		children: /* @__PURE__ */ G(T, {
			...e.componentProps,
			...t.field,
			value: e.componentProps?.type === "number" && isNaN(t.field.value) ? "" : t.field.value ?? "",
			onBlur: (n) => {
				e.componentProps?.onBlur?.(n), t.field.onBlur();
			},
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(e.componentProps?.type === "number" ? n.target.valueAsNumber : n);
			},
			id: n.name,
			"aria-disabled": r.disabled,
			disabled: r.disabled,
			"aria-required": r.required,
			required: r.required,
			status: _.getStatus(r.meta)
		})
	});
};
//#endregion
//#region ../widget-braze/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:250px;padding:0;overflow-y:auto}._listItem_10dvk_69{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);background-color:#0000}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var Dl = {
	"\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "getCustomerDetails"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Braze_exportUserDetails_request_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Braze"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "exportUserDetails"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Braze_exportUserDetails_response"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Braze_ExportedUserDetails"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "message"
													}
												}, {
													kind: "Field",
													name: {
														kind: "Name",
														value: "users"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "external_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "braze_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "created_at"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "first_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "last_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "dob"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "home_city"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "country"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "phone"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "language"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "time_zone"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "total_revenue"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "push_subscribe"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email_subscribe"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "custom_attributes"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "apps"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "platform"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "version"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "sessions"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first_used"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last_used"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "devices"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "model"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "os"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "carrier"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "idfv"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "idfa"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "google_ad_id"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "roku_ad_id"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "ad_tracking_enabled"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "custom_events"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "count"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "purchases"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "count"
																			}
																		}
																	]
																}
															}
														]
													}
												}]
											}
										}, {
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Braze_BasicResponse"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "message"
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateEmailSubscriptionStatus"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Braze_updateEmailSubscriptionStatus_request_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Braze"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "updateEmailSubscriptionStatus"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "message"
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Ol(e) {
	return Dl[e] ?? {};
}
var kl = Ol("\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n"), Al = Ol("\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n"), jl = Ws, Ml = {
	copyIcon: "_copyIcon_10dvk_54",
	list: "_list_10dvk_59",
	listItem: "_listItem_10dvk_69",
	collapsible: "_collapsible_10dvk_78",
	collapsibleIsOpen: "_collapsibleIsOpen_10dvk_86",
	collapsibleHeader: "_collapsibleHeader_10dvk_89",
	collapsibleIconTrue: "_collapsibleIconTrue_10dvk_92",
	collapsibleIconFalse: "_collapsibleIconFalse_10dvk_95"
}, Nl = ({ app: e, openByDefault: t }) => {
	let [n, r] = U(t);
	if (!e) return null;
	let { name: i, platform: a, version: o, sessions: s, first_used: c, last_used: l } = e;
	return /* @__PURE__ */ K(v, {
		className: ht(Ml.collapsible, { [Ml.collapsibleIsOpen]: n }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: Ml.collapsibleHeader,
			onClick: () => r(!n),
			children: [/* @__PURE__ */ G(L.Paragraph, {
				variant: "1",
				children: i
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: n ? "angle-down" : "angle-right"
			})]
		}), n && /* @__PURE__ */ K(E, {
			className: Ml.list,
			children: [
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Platform"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: a
						})]
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Version"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: o
						})]
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Sessions"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: s
						})]
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "First used"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: jl(c).format(he)
						})]
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Last used"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: jl(l).format(he)
						})]
					})
				})
			]
		})]
	});
}, Pl = ({ apps: e }) => {
	let t = e && e?.length > 0;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		margin: "200 0 0",
		children: [
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Apps"
				}), t && /* @__PURE__ */ G(n, {
					size: "small",
					variant: "success",
					children: e.length
				})]
			}),
			!t && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				margin: "200 0 300 0",
				color: "secondary",
				align: "center",
				children: "There are no apps associated with this customer"
			}),
			e?.map((e, t) => /* @__PURE__ */ G(Nl, {
				app: e,
				openByDefault: t === 0
			}, t))
		]
	});
}, Fl = ({ customerDetails: e }) => {
	if (!e) return null;
	let { custom_attributes: t } = e, n = !!t && Object.keys(t).length > 0;
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Custom attributes"
			}),
			!n && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No custom attributes available"
			}),
			n && /* @__PURE__ */ G(E, {
				className: Ml.list,
				children: Object.entries(t).map(([e, t], n) => (typeof t == "boolean" || typeof t == "string" || typeof t == "number") && /* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						justifyContent: "space-between",
						alignItems: "center",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: e
						}), ge(t)]
					})
				}, n))
			})
		]
	}) });
}, Il = ({ customerDetails: e }) => {
	if (!e) return null;
	let { custom_events: t } = e, n = t?.sort((e, t) => t?.count - e?.count), r = n && n.length > 0;
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Custom events"
			}),
			!r && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No custom events available"
			}),
			r && /* @__PURE__ */ G(E, {
				className: Ml.list,
				children: n.map((e, t) => /* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						justifyContent: "space-between",
						children: [/* @__PURE__ */ G(R, {
							content: /* @__PURE__ */ K(v, {
								flexDirection: "column",
								children: [/* @__PURE__ */ G(v, { children: `First ${jl(e?.first).format(he)}` }), /* @__PURE__ */ G(v, { children: `Last ${jl(e?.last).format(he)}` })]
							}),
							children: /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: e?.name
							})
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							children: e?.count
						})]
					})
				}, t))
			})
		]
	}) });
}, Ll = ({ state: e, noTooltip: t = !1, isPush: n = !1 }) => {
	if (!e) return null;
	let r = e === "subscribed", i = e === "unsubscribed";
	return /* @__PURE__ */ G(R, {
		content: t ? null : (() => {
			let e = n ? "push notifications" : "emails";
			return r ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${e}. This is the default subscription state when a user profile is created.` : i ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${e}.` : `Opted in: The user has explicitly confirmed they want to receive ${e}.`;
		})(),
		children: /* @__PURE__ */ G(v, {
			alignItems: "center",
			children: /* @__PURE__ */ G(x, {
				size: 14,
				name: r ? "exclamation" : i ? "close-circle-filled" : "check-circle-filled",
				color: r ? "neutral.500" : i ? "red.500" : "green.500"
			})
		})
	});
}, Rl = {
	wrapper: "_wrapper_1xucg_1",
	externalLink: "_externalLink_1xucg_7"
}, zl = ({ customerDetails: e }) => {
	let { isCopied: t, copy: n } = Re(), { isCopied: r, copy: i } = Re(), { isCopied: a, copy: o } = Re(), { isCopied: s, copy: c } = Re(), { isCopied: l, copy: u } = Re();
	if (!e) return null;
	let { external_id: d, braze_id: f, first_name: p, last_name: m, home_city: h, country: g, email: _, phone: y, dob: b, created_at: S, email_subscribe: C, push_subscribe: w } = e, T = `${p || ""} ${m || ""}`.trim() || "A customer has no name", E = `${h ? `${h} /` : ""} ${g || ""}`.trim(), D = b ? jl(b).isSame(Date.now(), "day") : !1;
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			className: Rl.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					className: Rl.block,
					alignItems: "center",
					children: [/* @__PURE__ */ G(L.Heading, {
						variant: "heading-2",
						children: T
					}), D && /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: "... has birthday today 🥳"
					})]
				}),
				S && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					margin: "0 0 200",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Member since"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: jl(S).format(he)
					})]
				}),
				E && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "map-pin"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: E
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy location",
						children: /* @__PURE__ */ G(v, {
							alignItems: "center",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: a ? "done" : "copy",
								onClick: () => o(E),
								className: Ml.copyIcon
							})
						})
					})]
				}),
				_ && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ G("span", {
							className: Rl.externalLink,
							children: _
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy email",
						children: /* @__PURE__ */ G(v, {
							alignItems: "center",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: t ? "done" : "copy",
								onClick: () => n(_),
								className: Ml.copyIcon
							})
						})
					})]
				}),
				y && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: y
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ G(v, {
							alignItems: "center",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: r ? "done" : "copy",
								onClick: () => i(y),
								className: Ml.copyIcon
							})
						})
					})]
				}),
				f && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ G(x, {
								size: 14,
								name: "user"
							}),
							/* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: "Braze ID"
							}),
							/* @__PURE__ */ K(L.Paragraph, {
								variant: "5",
								subdued: !0,
								color: "tertiary",
								children: [
									"(",
									f,
									")"
								]
							})
						]
					}), /* @__PURE__ */ G(R, {
						content: "Copy Braze ID",
						children: /* @__PURE__ */ G(v, {
							alignItems: "center",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: s ? "done" : "copy",
								onClick: () => c(f),
								className: Ml.copyIcon
							})
						})
					})]
				}),
				d && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ G(x, {
								size: 14,
								name: "tag"
							}),
							/* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: "External ID"
							}),
							/* @__PURE__ */ K(L.Paragraph, {
								variant: "5",
								subdued: !0,
								color: "tertiary",
								children: [
									"(",
									d,
									")"
								]
							})
						]
					}), /* @__PURE__ */ G(R, {
						content: "Copy External ID",
						children: /* @__PURE__ */ G(v, {
							alignItems: "center",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: l ? "done" : "copy",
								onClick: () => u(d),
								className: Ml.copyIcon
							})
						})
					})]
				}),
				C && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "sync"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: "Email subscription state"
						})]
					}), /* @__PURE__ */ G(Ll, { state: C })]
				}),
				w && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "bell"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: "Push notification subscription state"
						})]
					}), /* @__PURE__ */ G(Ll, {
						isPush: !0,
						state: w
					})]
				})
			]
		})
	});
}, Bl = ({ device: e, openByDefault: t }) => {
	let [n, r] = U(t);
	if (!e) return null;
	let { model: i, os: a, carrier: o, ad_tracking_enabled: s, idfa: c, idfv: l, google_ad_id: u, roku_ad_id: d } = e;
	return /* @__PURE__ */ K(v, {
		className: ht(Ml.collapsible, { [Ml.collapsibleIsOpen]: n }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: Ml.collapsibleHeader,
			onClick: () => r(!n),
			children: [/* @__PURE__ */ G(L.Paragraph, {
				variant: "1",
				children: i
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: n ? "angle-down" : "angle-right"
			})]
		}), n && /* @__PURE__ */ K(E, {
			className: Ml.list,
			children: [
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "OS"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: a
						})]
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Carrier"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: o
						})]
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Ad tracking enabled"
						}), /* @__PURE__ */ G(x, {
							size: 14,
							className: ht({
								[Ml.collapsibleIconTrue]: s,
								[Ml.collapsibleIconFalse]: !s
							}),
							name: s ? "check-circle-filled" : "close-circle-filled"
						})]
					})
				}),
				/* @__PURE__ */ G(R, {
					content: "The Apple Identifier for Vendor (iOS)",
					children: /* @__PURE__ */ G(E.Text, {
						variant: "dense",
						className: Ml.listItem,
						children: /* @__PURE__ */ K(v, {
							gap: "200",
							justifyContent: "space-between",
							width: "100%",
							flexWrap: "wrap",
							children: [/* @__PURE__ */ G(L.Paragraph, {
								variant: "3",
								children: "Braze device identifier"
							}), /* @__PURE__ */ G(L.Paragraph, {
								variant: "5",
								color: "secondary",
								children: l
							})]
						})
					})
				}),
				/* @__PURE__ */ G(R, {
					content: "For iOS",
					children: /* @__PURE__ */ G(E.Text, {
						variant: "dense",
						className: Ml.listItem,
						children: /* @__PURE__ */ K(v, {
							gap: "200",
							justifyContent: "space-between",
							width: "100%",
							flexWrap: "wrap",
							children: [/* @__PURE__ */ G(L.Paragraph, {
								variant: "3",
								children: "Identifier for Advertising"
							}), /* @__PURE__ */ G(L.Paragraph, {
								variant: "5",
								color: "secondary",
								children: c
							})]
						})
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						flexWrap: "wrap",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Roku Advertising id"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: d
						})]
					})
				}),
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						width: "100%",
						flexWrap: "wrap",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Google Play Advertising id"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: u
						})]
					})
				})
			]
		})]
	});
}, Vl = ({ devices: e }) => {
	let t = e && e?.length > 0;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		margin: "200 0 0",
		children: [
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Devices"
				}), t && /* @__PURE__ */ G(n, {
					size: "small",
					variant: "success",
					children: e.length
				})]
			}),
			!t && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				margin: "200 0 300 0",
				color: "secondary",
				align: "center",
				children: "There are no devices associated with this customer"
			}),
			e?.map((e, t) => /* @__PURE__ */ G(Bl, {
				device: e,
				openByDefault: t === 0
			}, t))
		]
	});
}, Hl = {
	optIn: {
		label: "Opt in",
		icon: "check-circle-filled",
		color: "var(--dixa-color-green-500)",
		tooltipContent: "Opt in to receive emails",
		parameter: "opted_in"
	},
	unsubscribe: {
		label: "Unsubscribe",
		icon: "close-circle-filled",
		color: "var(--dixa-color-red-500)",
		tooltipContent: "Unsubscribe from emails",
		parameter: "unsubscribed"
	}
}, Ul = ({ email: e, updateTo: t, refetchCustomerDetails: n }) => {
	let { track: r } = Ve(), { useMutation: i } = B(), [o, s] = U(!1), [c] = i(Al, { onCompleted: (e) => {
		e?.Braze?.updateEmailSubscriptionStatus?.message === "success" && r(t === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
	} }), l = async () => {
		s(!0), await c({ variables: { input: {
			email: e,
			subscription_state: Hl[t].parameter
		} } }), setTimeout(async () => {
			await n().finally(() => s(!1));
		}, 500);
	};
	return /* @__PURE__ */ G(R, {
		content: Hl[t].tooltipContent,
		children: /* @__PURE__ */ G(a, {
			variant: "secondary",
			color: Hl[t].color,
			isLoading: o,
			onClick: () => l(),
			"data-testid": "braze-subscription-button",
			children: /* @__PURE__ */ K(v, {
				gap: "100",
				alignItems: "center",
				children: [/* @__PURE__ */ G(Ll, {
					noTooltip: !0,
					state: Hl[t].parameter
				}), Hl[t].label]
			})
		})
	});
}, Wl = ({ customerDetails: e, showCustomerDetails: t, refetchCustomerDetails: n }) => {
	if (!e) return null;
	let { email: r, email_subscribe: i } = e;
	if (!r) return null;
	let a = i === "subscribed", o = i === "unsubscribed", s = i === "opted_in";
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Update Email subscription state"
				}),
				!t && /* @__PURE__ */ G(E, {
					className: Ml.list,
					children: /* @__PURE__ */ G(E.Text, {
						variant: "dense",
						className: Ml.listItem,
						children: /* @__PURE__ */ K(v, {
							justifyContent: "space-between",
							children: [/* @__PURE__ */ K(v, {
								gap: "200",
								alignItems: "center",
								children: [/* @__PURE__ */ G(x, {
									size: 14,
									name: "sync"
								}), /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: "Email subscription state"
								})]
							}), /* @__PURE__ */ G(Ll, { state: i })]
						})
					})
				}),
				/* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [
						a && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(Ul, {
							email: r,
							updateTo: "optIn",
							refetchCustomerDetails: n
						}), /* @__PURE__ */ G(Ul, {
							email: r,
							updateTo: "unsubscribe",
							refetchCustomerDetails: n
						})] }),
						o && /* @__PURE__ */ G(Ul, {
							email: r,
							updateTo: "optIn",
							refetchCustomerDetails: n
						}),
						s && /* @__PURE__ */ G(Ul, {
							email: r,
							updateTo: "unsubscribe",
							refetchCustomerDetails: n
						})
					]
				})
			]
		})
	});
}, Gl = ({ customerDetails: e }) => {
	if (!e) return null;
	let { purchases: t } = e, n = t?.sort((e, t) => t?.count - e?.count), r = n && n.length > 0;
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Purchases"
			}),
			!r && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No purchases available"
			}),
			r && /* @__PURE__ */ G(E, {
				className: Ml.list,
				children: n.map((e, t) => /* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ml.listItem,
					children: /* @__PURE__ */ K(v, {
						justifyContent: "space-between",
						children: [/* @__PURE__ */ G(R, {
							content: /* @__PURE__ */ K(v, {
								flexDirection: "column",
								children: [/* @__PURE__ */ G(v, { children: `First ${jl(e?.first).format(he)}` }), /* @__PURE__ */ G(v, { children: `Last ${jl(e?.last).format(he)}` })]
							}),
							children: /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: e?.name
							})
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							children: e?.count
						})]
					})
				}, t))
			})
		]
	}) });
}, Kl = ({ conversationContext: e, settings: t }) => {
	let { track: n } = Ve(), { useMutation: r } = B(), [i, a] = U(), [o, s] = U(!1), [c, l] = U(!1), u = e?.customer?.email, d = e?.customer?.phone_number, f = t.displayCustomerDetails ?? !1, p = t.updateEmailSubscriptionState ?? !1, m = t.displayCustomAttributes ?? !1, h = t.displayCustomEvents ?? !1, g = t.displayPuchases ?? !1, _ = t.displayDevices ?? !1, y = t.displayApps ?? !1, b = !f && !p && !m && !h && !g, [x, { error: S }] = r(kl, {
		onError: () => {},
		onCompleted: (e) => {
			let t = (e?.Braze?.exportUserDetails)?.users?.[0];
			t ? (a(t), s(!1), n("braze:profile:received")) : (a(void 0), s(!0));
		}
	}), C = async () => {
		u || d ? await x({ variables: { input: {
			...u ? { email_address: u } : { phone: d },
			fields_to_export: [
				"external_id",
				"braze_id",
				"created_at",
				"email",
				"first_name",
				"last_name",
				"dob",
				"home_city",
				"country",
				"phone",
				"language",
				"time_zone",
				"total_revenue",
				"push_subscribe",
				"email_subscribe",
				"custom_attributes",
				"custom_events",
				"purchases",
				"apps",
				"devices"
			]
		} } }) : s(!0);
	};
	if (H(() => {
		async function e() {
			l(!0), await C();
		}
		e().finally(() => l(!1));
	}, [u, d]), S) {
		let e = S.graphQLErrors;
		return xe({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Braze. Please contact your administrator."
		}) : /* @__PURE__ */ G(z, { error: S });
	}
	return c ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ G(P, {})
	}) : b ? /* @__PURE__ */ G(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-no-features",
		children: "All features toggles in the settings are disabled."
	}) : o ? /* @__PURE__ */ G(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-no-customer-found",
		children: "No customer found with this email or phone number."
	}) : /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		margin: "0 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			f && /* @__PURE__ */ G(zl, { customerDetails: i }),
			p && !!i && /* @__PURE__ */ G(Wl, {
				customerDetails: i,
				showCustomerDetails: f,
				refetchCustomerDetails: async () => await C()
			}),
			m && !!i && /* @__PURE__ */ G(Fl, { customerDetails: i }),
			h && !!i && /* @__PURE__ */ G(Il, { customerDetails: i }),
			g && !!i && /* @__PURE__ */ G(Gl, { customerDetails: i }),
			_ && !!i && /* @__PURE__ */ G(Vl, { devices: i?.devices }),
			y && !!i && /* @__PURE__ */ G(Pl, { apps: i?.apps })
		]
	});
}, ql = [
	{
		key: "apiHostName",
		label: "API endpoint",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "brazeApiKey",
		label: "API key",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "displayCustomerDetails",
		label: "Display customer details",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "updateEmailSubscriptionState",
		label: "Display the button to change the email subscription state",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCustomAttributes",
		label: "Display a list of custom attributes",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCustomEvents",
		label: "Display a list of custom events",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayPuchases",
		label: "Display a list of purchases",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDevices",
		label: "Display customer devices",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayApps",
		label: "Display customer apps",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], Jl = Pe(ql), Yl = {
	enabled: !1,
	name: "",
	brazeApiKey: "",
	...Le([], ql)
}, Xl = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r }) => {
	let i = !e, a = gl({
		mode: "onChange",
		defaultValues: Yl
	}), { create: o, update: s, remove: c, isLoading: l, error: u, misconfigurationCause: d, setMisconfigurationCause: f } = He({
		integrationId: e,
		integrationType: "BRAZE",
		handleRedirect: t,
		showNotification: n
	}), { isLoading: p, error: m, isWidgetUnknown: h, refetch: g } = Ue({
		integrationId: e,
		fieldDefinitions: ql,
		form: a,
		onMisconfigured: f
	}), v = (e) => ye(e, {
		fieldDefinitions: ql,
		isCreationMode: i,
		create: o,
		update: s
	}), x = a.watch("name");
	return /* @__PURE__ */ K(de, {
		form: a,
		integrationId: e,
		onValidSubmit: v,
		error: m ?? u,
		onRetry: m ? g : void 0,
		isLoading: l || p,
		isWidgetUnknown: h,
		children: [
			d && /* @__PURE__ */ G(se, { cause: d }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: a.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: a.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "apiHostName",
						label: Jl.apiHostName,
						control: a.control,
						rules: {
							required: "API endpoint is required",
							validate: (e) => We(e) || !0
						},
						componentProps: {
							placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "brazeApiKey",
						label: Jl.brazeApiKey,
						control: a.control,
						isCreationMode: i,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "Insert your API key",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Jl.displayCustomerDetails,
						children: /* @__PURE__ */ G(X, {
							name: "displayCustomerDetails",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Jl.updateEmailSubscriptionState,
						children: /* @__PURE__ */ G(X, {
							name: "updateEmailSubscriptionState",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Jl.displayCustomAttributes,
						children: /* @__PURE__ */ G(X, {
							name: "displayCustomAttributes",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Jl.displayCustomEvents,
						children: /* @__PURE__ */ G(X, {
							name: "displayCustomEvents",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Jl.displayPuchases,
						children: /* @__PURE__ */ G(X, {
							name: "displayPuchases",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Jl.displayDevices,
						children: /* @__PURE__ */ G(X, {
							name: "displayDevices",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Jl.displayApps,
						children: /* @__PURE__ */ G(X, {
							name: "displayApps",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 })
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: "BRAZE",
				integrationId: e,
				widgetName: x,
				isCreationMode: i,
				isSubmitting: a.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => c()
			})
		]
	});
};
//#endregion
//#region ../../../node_modules/react-use/esm/useMountedState.js
function Zl() {
	var e = et(!1), t = Ye(function() {
		return e.current;
	}, []);
	return H(function() {
		return e.current = !0, function() {
			e.current = !1;
		};
	}, []), t;
}
//#endregion
//#region ../../../node_modules/react-use/esm/useSetState.js
var Ql = function(e) {
	e === void 0 && (e = {});
	var t = U(e), n = t[0], r = t[1];
	return [n, Ye(function(e) {
		r(function(t) {
			return Object.assign({}, t, e instanceof Function ? e(t) : e);
		});
	}, [])];
}, $l = function(e, t) {
	return typeof t == "boolean" ? t : !e;
}, eu = function(e) {
	return $e($l, e);
}, tu = /* @__PURE__ */ Dt(((e, t) => {
	t.exports = function() {
		var e = document.getSelection();
		if (!e.rangeCount) return function() {};
		for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) n.push(e.getRangeAt(r));
		switch (t.tagName.toUpperCase()) {
			case "INPUT":
			case "TEXTAREA":
				t.blur();
				break;
			default:
				t = null;
				break;
		}
		return e.removeAllRanges(), function() {
			e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(t) {
				e.addRange(t);
			}), t && t.focus();
		};
	};
})), nu = /* @__PURE__ */ At((/* @__PURE__ */ Dt(((e, t) => {
	var n = tu(), r = {
		"text/plain": "Text",
		"text/html": "Url",
		default: "Text"
	}, i = "Copy to clipboard: #{key}, Enter";
	function a(e) {
		var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
		return e.replace(/#{\s*key\s*}/g, t);
	}
	function o(e, t) {
		var o, s, c, l, u, d, f = !1;
		t ||= {}, o = t.debug || !1;
		try {
			if (c = n(), l = document.createRange(), u = document.getSelection(), d = document.createElement("span"), d.textContent = e, d.ariaHidden = "true", d.style.all = "unset", d.style.position = "fixed", d.style.top = 0, d.style.clip = "rect(0, 0, 0, 0)", d.style.whiteSpace = "pre", d.style.webkitUserSelect = "text", d.style.MozUserSelect = "text", d.style.msUserSelect = "text", d.style.userSelect = "text", d.addEventListener("copy", function(n) {
				if (n.stopPropagation(), t.format) if (n.preventDefault(), n.clipboardData === void 0) {
					o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
					var i = r[t.format] || r.default;
					window.clipboardData.setData(i, e);
				} else n.clipboardData.clearData(), n.clipboardData.setData(t.format, e);
				t.onCopy && (n.preventDefault(), t.onCopy(n.clipboardData));
			}), document.body.appendChild(d), l.selectNodeContents(d), u.addRange(l), !document.execCommand("copy")) throw Error("copy command was unsuccessful");
			f = !0;
		} catch (n) {
			o && console.error("unable to copy using execCommand: ", n), o && console.warn("trying IE specific stuff");
			try {
				window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), f = !0;
			} catch (n) {
				o && console.error("unable to copy using clipboardData: ", n), o && console.error("falling back to prompt"), s = a("message" in t ? t.message : i), window.prompt(s, e);
			}
		} finally {
			u && (typeof u.removeRange == "function" ? u.removeRange(l) : u.removeAllRanges()), d && document.body.removeChild(d), c();
		}
		return f;
	}
	t.exports = o;
})))()), ru = function() {
	var e = Zl(), t = Ql({
		value: void 0,
		error: void 0,
		noUserInteraction: !0
	}), n = t[0], r = t[1];
	return [n, Ye(function(t) {
		if (e()) {
			var n, i;
			try {
				if (typeof t != "string" && typeof t != "number") {
					var a = /* @__PURE__ */ Error("Cannot copy typeof " + typeof t + " to clipboard, must be a string");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				} else if (t === "") {
					var a = /* @__PURE__ */ Error("Cannot copy empty string to clipboard.");
					process.env.NODE_ENV === "development" && console.error(a), r({
						value: t,
						error: a,
						noUserInteraction: !0
					});
					return;
				}
				i = t.toString(), n = (0, nu.default)(i), r({
					value: i,
					error: void 0,
					noUserInteraction: n
				});
			} catch (e) {
				r({
					value: i,
					error: e,
					noUserInteraction: n
				});
			}
		}
	}, [])];
};
//#endregion
//#region ../../../node_modules/react-use/esm/useTimeoutFn.js
function iu(e, t) {
	t === void 0 && (t = 0);
	var n = et(!1), r = et(), i = et(e), a = Ye(function() {
		return n.current;
	}, []), o = Ye(function() {
		n.current = !1, r.current && clearTimeout(r.current), r.current = setTimeout(function() {
			n.current = !0, i.current();
		}, t);
	}, [t]), s = Ye(function() {
		n.current = null, r.current && clearTimeout(r.current);
	}, []);
	return H(function() {
		i.current = e;
	}, [e]), H(function() {
		return o(), s;
	}, [t]), [
		a,
		s,
		o
	];
}
//#endregion
//#region ../../../node_modules/react-use/esm/useDebounce.js
function au(e, t, n) {
	t === void 0 && (t = 0), n === void 0 && (n = []);
	var r = iu(e, t), i = r[0], a = r[1], o = r[2];
	return H(o, n), [i, a];
}
//#endregion
//#region ../../../node_modules/react-use/esm/useEffectOnce.js
var ou = function(e) {
	H(e, []);
}, su = function(e, t) {
	var n = et(function() {});
	H(function() {
		n.current = e;
	}), H(function() {
		if (t !== null) {
			var e = setInterval(function() {
				return n.current();
			}, t || 0);
			return function() {
				return clearInterval(e);
			};
		}
	}, [t]);
}, cu = function(e) {
	e === void 0 && (e = {});
	var t = U(e), n = t[0], r = t[1], i = Qe(function() {
		return {
			set: function(e, t) {
				r(function(n) {
					var r;
					return yt(yt({}, n), (r = {}, r[e] = t, r));
				});
			},
			setAll: function(e) {
				r(e);
			},
			remove: function(e) {
				r(function(t) {
					var n = t, r = e;
					return n[r], bt(n, [typeof r == "symbol" ? r : r + ""]);
				});
			},
			reset: function() {
				return r(e);
			}
		};
	}, [r]);
	return [n, yt({ get: Ye(function(e) {
		return n[e];
	}, [n]) }, i)];
}, lu = function(e) {
	var t = et(e);
	t.current = e, ou(function() {
		return function() {
			return t.current();
		};
	});
};
//#endregion
//#region ../widget-github/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{width:var(--dixa-size-spacer-300);vertical-align:middle;border-radius:50%}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_8dnbe_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_8dnbe_8>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_8dnbe_8>div>div>p{white-space:unset!important}._collapseHeader_8dnbe_8>div:first-child,._collapseHeader_8dnbe_8>div:first-child div:first-child{width:100%}._collapseHeader_8dnbe_8>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_8dnbe_8{padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500);background-color:#0000!important}._collapseHeaderKey_8dnbe_33{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_8dnbe_38{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_8dnbe_43{text-decoration:none}._collapseHeaderIcon_8dnbe_46{margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom;padding-top:.35em}._collapseHeaderTitle_8dnbe_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_8dnbe_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_8dnbe_62{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_8dnbe_65{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;font-size:12px;line-height:32px;display:flex;position:relative}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-semibold);overflow:hidden}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{text-align:left;width:100%;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em;overflow:hidden}._resultLinkIcon_1uaom_46{background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);color:var(--dixa-color-neutral-500);border-radius:5px;position:absolute;right:5px}._tooltip_1uaom_55{text-overflow:ellipsis;width:500px;max-height:60vh;overflow:hidden}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;font-size:var(--dixa-typography-size-200);cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;line-height:32px;display:flex;position:relative}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-normal);overflow:hidden}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200);border-radius:50%}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);display:grid}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var uu = {
	"\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getGithubOrganizationMembersByName"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "organizationQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "usersQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "maxResults"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Int"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "organization"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "login"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "organizationQuery"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "teams"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "first"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "maxResults"
											}
										}
									}],
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "edges"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "node"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "members"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "first"
																	},
																	value: {
																		kind: "Variable",
																		name: {
																			kind: "Name",
																			value: "maxResults"
																		}
																	}
																}, {
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "query"
																	},
																	value: {
																		kind: "Variable",
																		name: {
																			kind: "Name",
																			value: "usersQuery"
																		}
																	}
																}],
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "edges"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "node"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "id"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "name"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "login"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "avatarUrl"
																							}
																						}
																					]
																				}
																			}]
																		}
																	}]
																}
															}
														]
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createGithubIssue"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "GitHub_CreateIssueInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "createIssue"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issue"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "repository"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getGithubRepositoriesByName"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "maxResults"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "search"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "type"
									},
									value: {
										kind: "EnumValue",
										value: "REPOSITORY"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxResults"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "repositoryCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "InlineFragment",
													typeCondition: {
														kind: "NamedType",
														name: {
															kind: "Name",
															value: "GitHub_Repository"
														}
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														}]
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "IssueFields"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "GitHub_Issue"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "id"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "number"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "title"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "body"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "bodyText"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "author"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "avatarUrl"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "login"
								}
							}]
						}
					},
					{
						kind: "Field",
						alias: {
							kind: "Name",
							value: "issueState"
						},
						name: {
							kind: "Name",
							value: "state"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "assignees"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrl"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "labels"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "color"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "repository"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "name"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "owner"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "login"
										}
									}]
								}
							}]
						}
					}
				]
			}
		}]
	},
	"\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "PullRequestFields"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "GitHub_PullRequest"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "id"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "number"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "title"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "body"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "bodyText"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "author"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "avatarUrl"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "login"
								}
							}]
						}
					},
					{
						kind: "Field",
						alias: {
							kind: "Name",
							value: "prState"
						},
						name: {
							kind: "Name",
							value: "state"
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "assignees"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrl"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "labels"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "first"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "nodes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "color"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									}]
								}
							}]
						}
					},
					{
						kind: "Field",
						name: {
							kind: "Name",
							value: "repository"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "name"
								}
							}, {
								kind: "Field",
								name: {
									kind: "Name",
									value: "owner"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "login"
										}
									}]
								}
							}]
						}
					}
				]
			}
		}]
	},
	"\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchItems"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "prQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "maxIssueResults"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "maxPRResults"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							alias: {
								kind: "Name",
								value: "issues"
							},
							name: {
								kind: "Name",
								value: "search"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "issueQuery"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "type"
									},
									value: {
										kind: "EnumValue",
										value: "ISSUE"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxIssueResults"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issueCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "GitHub_Issue"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "number"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "body"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "bodyText"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "author"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignees"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avatarUrl"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "color"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "repository"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "owner"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "login"
																		}
																	}]
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}, {
							kind: "Field",
							alias: {
								kind: "Name",
								value: "pullRequests"
							},
							name: {
								kind: "Name",
								value: "search"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "prQuery"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "type"
									},
									value: {
										kind: "EnumValue",
										value: "ISSUE"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxPRResults"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issueCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "GitHub_PullRequest"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "number"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "body"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "bodyText"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "author"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignees"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avatarUrl"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "10"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "nodes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "color"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "repository"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "owner"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "login"
																		}
																	}]
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getIssue"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "owner"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "repositoryName"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueNumber"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Int"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "repository"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "owner"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "owner"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "name"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "repositoryName"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issue"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "number"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "issueNumber"
											}
										}
									}],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "body"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "bodyText"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "author"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "avatarUrl"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "login"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "state"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "assignees"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "labels"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "color"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "repository"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "owner"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getPullRequest"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "owner"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "repositoryName"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "prNumber"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Int"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "GitHub"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "repository"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "owner"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "owner"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "name"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "repositoryName"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "pullRequest"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "number"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "prNumber"
											}
										}
									}],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "body"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "bodyText"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "author"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "avatarUrl"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "login"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "state"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "assignees"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "avatarUrl"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "labels"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "10"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "color"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "repository"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "owner"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "login"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function du(e) {
	return uu[e] ?? {};
}
var fu = du("\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), pu = du("\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n"), mu = du("\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n"), hu = ({ owner: e, repository: t, number: n }) => `https://github.com/${e}/${t}/issues/${n}`, gu = ({ owner: e, repository: t, number: n }) => `${e}/${t} #${n}`, _u = ({ number: e, repository: t }) => ({
	number: e,
	repository: t.name,
	owner: t.owner.login
}), vu = (e) => {
	switch (e) {
		case "ISSUE": return "issue";
		case "PR": return "pull request";
		default: return e;
	}
}, yu = (e, t, n) => e === "ISSUE" ? {
	OPEN: /* @__PURE__ */ K("svg", {
		className: n,
		fill: "#3fb950",
		height: "16",
		width: "16",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ G("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }), /* @__PURE__ */ G("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })]
	}),
	CLOSED: /* @__PURE__ */ K("svg", {
		className: n,
		fill: "#a371f7",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ G("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }), /* @__PURE__ */ G("path", {
			fillRule: "evenodd",
			d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
		})]
	})
}[t] : {
	OPEN: /* @__PURE__ */ G("svg", {
		className: n,
		fill: "#3fb950",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: /* @__PURE__ */ G("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
	}),
	MERGED: /* @__PURE__ */ G("svg", {
		className: n,
		fill: "#a371f7",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: /* @__PURE__ */ G("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
	}),
	CLOSED: /* @__PURE__ */ G("svg", {
		className: n,
		fill: "#f85149",
		width: "16",
		height: "16",
		"aria-hidden": "true",
		children: /* @__PURE__ */ G("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
	})
}[t];
function bu({ conversationId: e, githubOrganization: t }) {
	let n = { github: {
		issues: [],
		pullRequests: []
	} }, [r, i] = U([]), [a, o] = U([]), [s, c] = U([]), [l, u] = U([]), [d, f] = U(), { showNotification: p, showModal: m, executeQuery: h } = B(), { track: g } = Ve(), { loading: _, data: v, error: y, store: b } = ze(e ?? null), x = v?.github?.issues || [], S = v?.github?.pullRequests || [], [C, w] = U(!1), [T, E] = U();
	H(() => f(y || T || void 0), [y, T]), H(() => {
		!_ && (x?.length || S?.length) ? (i(x), o(S), O(x, S)) : (i([]), o([]), c([]), u([]));
	}, [v]);
	let D = async (e, t) => {
		await b(e).then(() => {
			p({
				icon: "check-circle-filled",
				severity: "success",
				title: t.success.title,
				text: t.success.text
			});
		}).catch((e) => {
			p({
				title: t.error.title,
				text: `${t.error.text} ${e.message && " (" + e.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, O = (e, t) => {
		if (!e?.length && !t?.length) {
			c([]), u([]);
			return;
		}
		let n = (e || []).map((e) => h(pu, {
			owner: e.owner,
			repositoryName: e.repository,
			issueNumber: e.number
		})), r = (t || []).map((e) => h(mu, {
			owner: e.owner,
			repositoryName: e.repository,
			prNumber: e.number
		})), i = [...n, ...r];
		w(!0), Promise.all(i).then((e) => {
			let t = [], n = [];
			e.forEach((e) => {
				let r = e?.data?.GitHub;
				if (!r) {
					c([]), u([]);
					return;
				}
				Object.keys(r).forEach((e) => {
					if (e.startsWith("repository")) {
						let i = r[e];
						Object.keys(i).forEach((e) => {
							let r = i[e], a = {
								number: r?.number,
								owner: r?.repository?.owner?.login,
								repository: r?.repository?.name
							};
							e.startsWith("issue") && t.push({
								...r,
								type: "ISSUE",
								key: a
							}), e.startsWith("pullRequest") && n.push({
								...r,
								type: "PR",
								key: a
							});
						});
					}
				});
			}), c(t), u(n);
		}).catch(E).finally(() => {
			w(!1);
		});
	}, k = ({ key: e, type: r }) => {
		g("github:link:issue:clicked", { githubOrganization: t });
		let i = v && (x.length || S.length) ? v : n, a = r === "ISSUE" ? "issues" : "pullRequests";
		i.github[a] = Array.from(new Set(i.github[a]).add(e)), D(i, {
			success: {
				title: "GitHub issue linked",
				text: `You linked the GitHub issue ${gu(e)} to this conversation.`
			},
			error: {
				title: "Linking failed",
				text: `Linking ${gu(e)} failed. Please try again.`
			}
		});
	}, A = async ({ key: e, type: r }) => {
		g("github:link:issue:clicked", { githubOrganization: t });
		let i = v && (x.length || S.length) ? v : n, a = r === "ISSUE" ? "issues" : "pullRequests";
		i.github[a] = Array.from(new Set(i.github[a]).add(e)), await b(i).catch((t) => {
			p({
				title: "Linking failed",
				text: `Linking ${e} failed. Please try again. ${t.message && " (" + t.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, j = ({ key: e, type: n }) => {
		g("github:unlink:issue:clicked", { githubOrganization: t });
		let r = n === "ISSUE" ? "issue" : "pull request";
		m({
			headline: `Unlink ${r} ${gu(e)}?`,
			text: `You are about to unlink the ${r} ${gu(e)}. Do you want to proceed?`,
			confirmLabel: `Unlink GitHub ${r}`,
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				let i = n === "ISSUE" ? "issues" : "pullRequests";
				if (!v) return;
				let a = {
					...v,
					github: {
						...v?.github,
						[i]: v?.github?.[i].filter((t) => t.number !== e.number || t.owner !== e.owner || t.repository !== e.repository)
					}
				};
				g("github:unlink:issue:confirmed", { githubOrganization: t }), D(a, {
					success: {
						title: `GitHub ${r} unlinked`,
						text: `You unlinked the GitHub ${r} ${gu(e)}`
					},
					error: {
						title: "Unlinking failed",
						text: `Unlinking ${gu(e)} failed.`
					}
				});
			},
			onCancel: () => {
				g("github:unlink:issue:canceled", { githubOrganization: t });
			}
		});
	}, M = () => {
		g("github:unlink:all:clicked", { githubOrganization: t }), m({
			headline: "Unlink all GitHub issues/pull requests?",
			text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
			confirmLabel: "Unlink ALL issues/pull requests",
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				g("github:unlink:all:confirmed", { githubOrganization: t }), D(n, {
					success: {
						title: "Unlinking successful",
						text: "All GitHub issues/pull requests were unlinked"
					},
					error: {
						title: "Unlinking failed",
						text: "Unlinking all issues/pull requests failed."
					}
				});
			},
			onCancel: () => {
				g("github:unlink:all:canceled", { githubOrganization: t });
			}
		});
	}, N = x.filter((e) => !r?.includes(e)) || [], P = S.filter((e) => !a?.includes(e)) || [];
	return {
		linkGithubItem: k,
		linkGithubItemQuietly: A,
		unlinkGithubItem: j,
		loadGithubItems: O,
		removeDanglingGithubItemLinks: () => {
			let e = {
				...v,
				github: {
					...v?.github,
					issues: x.filter((e) => !N.includes(e)) || [],
					pullRequests: S.filter((e) => !P.includes(e)) || []
				}
			};
			b(e);
		},
		unlinkAllGithubItems: M,
		isLoadingGithubItemLinks: _,
		danglingIssueLinks: N,
		danglingPullRequestLinks: P,
		isLoadingGithubItems: C,
		issues: s,
		pullRequests: l,
		error: d
	};
}
var xu = {
	contentWrapper: "_contentWrapper_1vx3c_1",
	contentWrapperHeadline: "_contentWrapperHeadline_1vx3c_4",
	contentWrapperBody: "_contentWrapperBody_1vx3c_11",
	contentWrapperAssigneeIcon: "_contentWrapperAssigneeIcon_1vx3c_15",
	contentWrapperStatusTag: "_contentWrapperStatusTag_1vx3c_20"
}, Su = ({ description: e, assignees: t, labels: n }) => /* @__PURE__ */ K(W, { children: [
	e && /* @__PURE__ */ K(i, {
		className: xu.contentWrapper,
		children: [/* @__PURE__ */ G(i, {
			className: xu.contentWrapperHeadline,
			children: "Description"
		}), /* @__PURE__ */ G(i, {
			className: xu.contentWrapperBody,
			children: e
		})]
	}),
	t?.nodes && t.nodes.length > 0 && /* @__PURE__ */ K(i, {
		className: xu.contentWrapper,
		children: [/* @__PURE__ */ G(i, {
			className: xu.contentWrapperHeadline,
			children: "Assignees"
		}), /* @__PURE__ */ G(i, {
			className: xu.contentWrapperBody,
			children: t.nodes.map((e) => e && /* @__PURE__ */ K(i, {
				margin: "100 0",
				children: [
					/* @__PURE__ */ G("img", {
						className: xu.contentWrapperAssigneeIcon,
						src: e.avatarUrl,
						alt: e.name || ""
					}),
					" ",
					e.name
				]
			}, e.name))
		})]
	}),
	n?.nodes && n?.nodes.length > 0 && /* @__PURE__ */ G(i, {
		className: xu.contentWrapper,
		children: n.nodes.map((e) => e && /* @__PURE__ */ G(I, {
			className: xu.contentWrapperStatusTag,
			children: e.name
		}, e.name))
	})
] }), Cu = {
	collapse: "_collapse_8dnbe_1",
	collapseHeader: "_collapseHeader_8dnbe_8",
	collapseHeaderKey: "_collapseHeaderKey_8dnbe_33",
	collapseHeaderKeyIcon: "_collapseHeaderKeyIcon_8dnbe_38",
	collapseHeaderKeyLink: "_collapseHeaderKeyLink_8dnbe_43",
	collapseHeaderIcon: "_collapseHeaderIcon_8dnbe_46",
	collapseHeaderTitle: "_collapseHeaderTitle_8dnbe_51",
	collapseContent: "_collapseContent_8dnbe_59",
	collapseContentButtonSpacer: "_collapseContentButtonSpacer_8dnbe_62",
	collapseContentButtonLink: "_collapseContentButtonLink_8dnbe_65"
}, wu = ({ items: e, unlinkGithubItem: t, githubOrganization: n }) => {
	let [r, o] = U(e.reduce((e, t) => ({
		...e,
		[t.id]: !1
	}), {})), { track: c } = Ve(), l = (e, t) => {
		o({
			...r,
			[e]: t
		});
	};
	return /* @__PURE__ */ G(v, {
		flexDirection: "column",
		gap: "250",
		children: e?.length ? e.map((e) => {
			let { id: o, number: u, key: d, title: f, bodyText: p, repository: m, type: h, state: g, assignees: _, labels: y } = e, b = r[o];
			return /* @__PURE__ */ K(s, {
				onToggle: () => l(o, !r[o]),
				isOpen: b,
				className: Cu.collapse,
				children: [/* @__PURE__ */ G(s.Header, {
					className: Cu.collapseHeader,
					children: /* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ G(i, { children: /* @__PURE__ */ K(i, {
							as: "span",
							className: Cu.collapseHeaderKey,
							children: [yu(h, g, Cu.collapseHeaderKeyIcon), /* @__PURE__ */ K("a", {
								href: hu(d),
								className: Cu.collapseHeaderKeyLink,
								target: "_blank",
								rel: "noreferrer",
								onClick: (e) => {
									e.stopPropagation();
								},
								children: [gu(d), /* @__PURE__ */ G(x, {
									className: Cu.collapseHeaderIcon,
									name: "external-link",
									size: 16
								})]
							})]
						}) }), /* @__PURE__ */ G(i, {
							className: Cu.collapseHeaderTitle,
							children: f
						})]
					})
				}), /* @__PURE__ */ G(s.Content, {
					className: Cu.collapseContent,
					children: /* @__PURE__ */ K(v, {
						flexDirection: "column",
						margin: "0 0 200 0",
						children: [
							/* @__PURE__ */ G(Su, {
								description: p,
								assignees: _,
								labels: y
							}),
							/* @__PURE__ */ K(a, {
								icon: "link-slash",
								variant: "secondary",
								className: Cu.collapseContentButtonSpacer,
								onClick: () => t({
									key: {
										number: u,
										owner: m?.owner.login,
										repository: e.repository.name
									},
									type: h
								}),
								children: ["Unlink ", vu(h)]
							}),
							/* @__PURE__ */ K(j, {
								slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
								variant: "tertiary",
								className: Cu.collapseContentButtonLink,
								navigate: () => {
									c("github:view:link:clicked", { githubOrganization: n }), window.open(hu(d), "_blank")?.focus();
								},
								children: [
									"View ",
									vu(h),
									" in GitHub"
								]
							})
						]
					})
				})]
			}, o);
		}) : /* @__PURE__ */ G(W, {})
	});
}, Tu = {
	result: "_result_1uaom_1",
	resultName: "_resultName_1uaom_21",
	resultItemIcon: "_resultItemIcon_1uaom_29",
	resultDescription: "_resultDescription_1uaom_34",
	resultLinkIcon: "_resultLinkIcon_1uaom_46",
	tooltip: "_tooltip_1uaom_55",
	tooltipName: "_tooltipName_1uaom_61",
	tooltipNameIcon: "_tooltipNameIcon_1uaom_66",
	tooltipTag: "_tooltipTag_1uaom_71"
}, Eu = ({ item: e, onSelect: t }) => {
	let { key: n, title: r, type: a, state: o, labels: s, bodyText: c, assignees: l } = e, [u, d] = U(!1);
	return /* @__PURE__ */ G(R, {
		className: Tu.tooltip,
		content: /* @__PURE__ */ K(v, {
			flexDirection: "column",
			justifyContent: "center",
			width: "100%",
			children: [/* @__PURE__ */ K(v, {
				flexDirection: "row",
				justifyContent: "space-between",
				width: "100%",
				alignItems: "center",
				margin: "0 0 300 0",
				children: [/* @__PURE__ */ K(i, {
					as: "span",
					className: Tu.tooltipName,
					children: [yu(a, o, Tu.resultItemIcon), r]
				}), /* @__PURE__ */ G(I, {
					className: Tu.tooltipTag,
					children: o
				})]
			}), /* @__PURE__ */ G(Su, {
				description: c,
				assignees: l,
				labels: s
			})]
		}),
		side: "left",
		light: !0,
		children: /* @__PURE__ */ K("button", {
			className: Tu.result,
			type: "button",
			onClick: () => {
				t(e);
			},
			onMouseEnter: () => d(!0),
			onMouseLeave: () => d(!1),
			children: [/* @__PURE__ */ K(v, {
				flexDirection: "column",
				justifyContent: "center",
				width: "100%",
				style: { width: u ? "calc(100% - 32px)" : "100%" },
				children: [/* @__PURE__ */ G(v, {
					flexDirection: "row",
					children: /* @__PURE__ */ K(i, {
						as: "span",
						className: Tu.resultName,
						children: [yu(a, o, Tu.resultItemIcon), gu(n)]
					})
				}), /* @__PURE__ */ G(i, {
					className: Tu.resultDescription,
					children: r
				})]
			}), u && /* @__PURE__ */ G(x, {
				className: Tu.resultLinkIcon,
				name: "plus",
				size: 32
			})]
		})
	});
}, Du = ({ className: e, searched: t, githubOrganization: n }) => /* @__PURE__ */ G(j, {
	slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
	variant: "tertiary",
	style: { width: "100%" },
	className: e,
	navigate: () => {
		window.open(`https://github.com/search?q=is:issue+org:${n}+${t}`, "_blank")?.focus();
	},
	children: "View matching items on GitHub"
}), Ou = "[a-zA-z0-9_.-]+", ku = "[0-9]+", Au = RegExp(`(${Ou})/(${Ou})/(?:issues|pull)/(${ku})`, "i"), ju = RegExp(`^${Au.source}$`), Mu = RegExp(`https://github.com/(${Ou})/(${Ou})/(?:issues|pull)/(${ku})`, "i"), Nu = ({ onSelectItem: e, githubOrganization: t, linkedIssues: n, linkedPullRequests: r }) => {
	let i = Qe(() => n?.map((e) => e.id) || [], [n]), a = Qe(() => r?.map((e) => e.id) || [], [r]), [o, s] = U([]), { useLazyQuery: c } = B(), [l, u] = U(), [d, { loading: f, error: p, data: m, networkStatus: h }] = c(fu, { notifyOnNetworkStatusChange: !0 }), [g, _] = au(() => {
		!f && l && h === st.ready ? d({ variables: {
			issueQuery: `${l} type:issue`,
			prQuery: `${l} type:pr`,
			maxIssueResults: 12,
			maxPRResults: 12
		} }) : s([]);
	}, 500, [l]);
	H(() => {
		let e = m?.GitHub?.issues?.nodes || [], t = m?.GitHub?.pullRequests.nodes || [];
		i.length > 0 && (e = e.filter((e) => !i.includes(e.id))), a.length > 0 && (t = t.filter((e) => !a.includes(e.id))), s([...e.map((e) => ({
			...e,
			type: "ISSUE",
			key: {
				number: e.number,
				owner: e.repository.owner.login,
				repository: e.repository.name
			}
		})), ...t.map((e) => ({
			...e,
			type: "PR",
			key: {
				number: e.number,
				owner: e.repository.owner.login,
				repository: e.repository.name
			}
		}))]);
	}, [
		m,
		i,
		a
	]);
	function v(e) {
		let n = e?.trim();
		if (ju.test(n)) {
			let [e, r, i, a] = n.match(ju) || [];
			return r === t ? {
				owner: t,
				repository: i,
				number: parseInt(a)
			} : void 0;
		}
		if (Mu.test(n)) {
			let [e, r, i, a] = n.match(Mu) || [];
			return r === t ? {
				owner: t,
				repository: i,
				number: parseInt(a)
			} : void 0;
		}
	}
	return !f && p ? /* @__PURE__ */ G(z, { error: p }) : /* @__PURE__ */ G(M, {
		items: o?.map((e) => ({
			name: e.title,
			...e
		})),
		loading: f,
		onSearch: (e) => {
			let n = v(e);
			u(n ? `org:${n.owner} repo:${n.repository} ${n.number}` : `org:${t} ${e}`);
		},
		onSelect: (t) => {
			e({
				key: _u(t),
				type: t.type
			}), u(void 0);
		},
		onClear: () => {
			u(void 0);
		},
		emptyMessage: l ? f ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
		suggestionComponent: ({ className: e, searched: n }) => /* @__PURE__ */ G(Du, {
			className: e,
			searched: n,
			githubOrganization: t
		}),
		itemComponent: ({ item: e, onSelect: t }) => /* @__PURE__ */ G(Eu, {
			item: e,
			onSelect: t
		}),
		placeholder: "Search GitHub items",
		searchable: !0,
		clearable: !0
	});
}, Pu = {
	itemButton: "_itemButton_3sxfy_1",
	result: "_result_3sxfy_6",
	resultIcon: "_resultIcon_3sxfy_26",
	resultName: "_resultName_3sxfy_30",
	resultCheckIcon: "_resultCheckIcon_3sxfy_38",
	resultAssigneeIcon: "_resultAssigneeIcon_3sxfy_41"
}, Fu = ({ item: e, checked: t = !1, onSelectItem: n }) => /* @__PURE__ */ G(v, {
	flexDirection: "column",
	justifyContent: "center",
	width: "100%",
	"data-testid": "github-select-item-component",
	children: /* @__PURE__ */ G("button", {
		onClick: () => {
			n(e);
		},
		className: Pu.itemButton,
		children: /* @__PURE__ */ K(v, {
			className: Pu.result,
			flexDirection: "row",
			width: "100%",
			children: [
				e.iconUrl && /* @__PURE__ */ G(i, {
					margin: "100 0",
					children: /* @__PURE__ */ G("img", {
						className: Pu.resultAssigneeIcon,
						src: e.iconUrl,
						alt: e.name
					})
				}, e.name),
				/* @__PURE__ */ G(i, {
					className: Pu.resultName,
					children: e.name
				}),
				t && /* @__PURE__ */ G(i, {
					className: Pu.resultCheckIcon,
					children: /* @__PURE__ */ G(x, { name: "done" })
				})
			]
		})
	})
}), Iu = du("\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), Lu = ({ githubOrganization: e, selectedItems: t, onChange: n, multiple: r = !1 }) => {
	let { useLazyQuery: i } = B(), [a, o] = U([]), [s, c] = U(""), [l, { loading: u, error: d, data: f, networkStatus: p }] = i(Iu, { notifyOnNetworkStatusChange: !0 }), [m, h] = au(() => {
		!u && s && s.length >= 2 && p === st.ready ? l({ variables: {
			usersQuery: s,
			organizationQuery: e,
			maxResults: 10
		} }) : o([]);
	}, 500, [s]);
	return H(() => {
		let e = f?.GitHub?.organization?.teams || { edges: [] }, t = [];
		e?.edges?.forEach((e) => {
			let n = e?.node?.members?.edges;
			(n?.length || 0) > 0 && n?.forEach((e) => {
				let n = e?.node;
				n && (n?.id && t.find((e) => e.id === n.id) || t.push(n));
			});
		}), o(t.sort((e, t) => {
			let n = e.name?.toLowerCase() || e.login?.toLowerCase(), r = t.name?.toLowerCase() || t.login?.toLowerCase();
			return n.localeCompare(r, void 0, { sensitivity: "base" });
		}));
	}, [f]), !u && d ? /* @__PURE__ */ G(z, { error: d }) : /* @__PURE__ */ G(M, {
		clearable: !0,
		searchable: !0,
		multiple: r,
		items: a?.map(({ id: e, name: t, login: n, avatarUrl: r }) => ({
			id: e,
			name: t || n,
			iconUrl: r
		})) || [],
		loading: u,
		onSearch: (e) => c(e),
		onChange: (e, i) => {
			let a = e.id;
			r ? (i && !t.find((e) => e.id === a) && t.push(e), i || (t = t.filter((e) => e.id !== a))) : t = i ? [e] : [], n(t);
		},
		onClear: () => c(""),
		selectedItems: t,
		emptyMessage: s ? u ? "" : "No user found" : "Search users",
		itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ G(Fu, {
			item: e,
			checked: n,
			onSelectItem: t
		}),
		placeholder: "Search GitHub users"
	});
}, Ru = ({ field: e, value: t, onChange: n, githubOrganization: r }) => {
	let { multiple: i, type: a } = e;
	switch (a) {
		case "any": return /* @__PURE__ */ G(T, {
			onChange: n,
			value: t
		});
		case "array": return e?.allowedValues ? /* @__PURE__ */ G(M, {
			onSelect: n,
			selectedItems: Array.isArray(t) ? t : [],
			items: e?.allowedValues.map(({ id: e, name: t, value: n }) => ({
				id: e,
				name: t || n
			}))
		}) : /* @__PURE__ */ G(te, {
			onChange: n,
			selectedTags: Array.isArray(t) ? t : []
		});
		case "number": return /* @__PURE__ */ G(T, {
			type: "number",
			onChange: n,
			value: t
		});
		case "option": return /* @__PURE__ */ G(M, {
			onSelect: n,
			selectedItems: Array.isArray(t) ? t : [],
			items: (e?.allowedValues)?.map(({ id: e, name: t, value: n }) => ({
				id: e,
				name: t || n
			})) || []
		});
		case "string": return /* @__PURE__ */ G(T, {
			onChange: n,
			value: t || ""
		});
		case "textarea": return /* @__PURE__ */ G(re, {
			onChange: n,
			value: t || ""
		});
		case "user": return /* @__PURE__ */ G(Lu, {
			githubOrganization: r,
			onChange: n,
			selectedItems: Array.isArray(t) ? t : [],
			multiple: i
		});
		default: return /* @__PURE__ */ G(W, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
	}
}, zu = ({ issueTypeFields: e, control: t, githubOrganization: n, conversationContext: r, errors: i }) => /* @__PURE__ */ G(W, { children: e.filter(({ key: e }) => e !== "repository").map((e) => /* @__PURE__ */ G(xc, {
	control: t,
	render: ({ field: { onChange: t, value: a } }) => /* @__PURE__ */ G(_, {
		meta: { error: i && e.key in i ? i[e.key].message : null },
		label: e.name,
		required: e.required,
		children: Ru({
			field: e,
			value: a,
			onChange: t,
			githubOrganization: n,
			conversationContext: r
		})
	}, e.key),
	name: e.key,
	rules: { required: e.required ? "This field is required" : !1 }
}, e.key)) }), Bu = ({ createdIssue: e, issueBaseLink: t, issueLinkCopied: n, setIssueLinkCopied: r, copyToClipboard: i }) => {
	let a = `${t}/${e.repository.name}/issues/${e.number}`;
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "400",
		"data-testid": "github-create-issue-success-message",
		children: [/* @__PURE__ */ K(L.Paragraph, { children: [
			"You can visit your new issue by following",
			" ",
			/* @__PURE__ */ K(L.ExternalLink, {
				href: a,
				target: "_blank",
				children: ["this link ", /* @__PURE__ */ G(x, { name: "external-link" })]
			}),
			" ",
			"or copy it from the field below."
		] }), /* @__PURE__ */ G(_, {
			label: "GitHub issue link",
			children: /* @__PURE__ */ G(T, {
				readOnly: !0,
				value: a,
				suffix: {
					type: "button",
					button: {
						icon: n ? "done" : "copy",
						onClick: () => {
							r(!0), i(a);
						}
					}
				}
			})
		})]
	});
}, Vu = {
	modalBody: "_modalBody_1hk1o_1",
	modalBodyFormFields: "_modalBodyFormFields_1hk1o_4"
}, Hu = du("\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n"), Uu = du("\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n"), Wu = [
	{
		key: "title",
		name: "Title",
		type: "string",
		required: !0
	},
	{
		key: "assignees",
		name: "Assignees",
		type: "user",
		required: !1,
		multiple: !0
	},
	{
		key: "body",
		name: "Description",
		type: "textarea",
		required: !1
	}
], Gu = ({ isOpen: e, onClose: t, linkGithubIssueQuietly: n, conversationContext: r, githubOrganization: i }) => {
	let { showNotification: a, useLazyQuery: o, useMutation: s } = B(), { track: c } = Ve(), { control: l, handleSubmit: u, formState: { errors: d }, reset: f, getValues: p } = gl(), [m, h] = U(""), [g, v] = U([]), [x, S] = U(), [C, w] = U(!1), [T, E] = U(!1), [j, N] = ru(), [ee, { loading: F, error: I, networkStatus: te }] = o(Hu, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			v(e.GitHub.search?.edges?.map((e) => e?.node));
		},
		onError: () => {
			a({
				title: "Could not get repository list",
				text: "We could not fetch the list of your repositories. Please try again later.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), v([]);
		}
	}), [L, ne] = au(() => {
		!F && m && te === st.ready ? ee({ variables: {
			query: m,
			maxResults: 10
		} }) : v([]);
	}, 500, [m]), [re, { error: ie }] = s(Uu, {
		onError: (e) => {
			w(!1), a({
				title: "Creation was not successful",
				text: "Please try again later or contact your admin.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), console.warn("Error in createMutation", e);
		},
		onCompleted: (e) => {
			w(!1);
			let t = e.GitHub.createIssue?.issue;
			S(t), a({
				title: "Success",
				text: `GitHub issue '${t.number}' created`,
				icon: "check-circle-filled",
				severity: "success"
			}), n({
				owner: i,
				repository: t.repository.name,
				number: t.number
			});
		}
	}), R = (e) => {
		h(`org:${i} ${e}`);
	}, ae = (e, t) => {
		t(e), h("");
	}, oe = () => {
		h("");
	}, se = (e) => {
		c("github:create:issue:confirmed", { githubOrganization: i }), w(!0), re({ variables: { input: {
			repositoryId: e.repository.id,
			title: e.title,
			body: e.body,
			assigneeIds: e.assignees?.length > 0 ? e.assignees.map((e) => e.id) : void 0
		} } });
	};
	H(() => {
		let e = T ? window.setTimeout(() => E(!1), 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [T]);
	let ce = () => {
		h(""), v([]), S(void 0), w(!1), E(!1);
	}, le = () => {
		c("github:create:issue:canceled", { githubOrganization: i }), ce(), f(), t();
	};
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		"data-testid": "github-create-issue-modal",
		onClose: le,
		children: [
			/* @__PURE__ */ G(A, {
				title: x ? "Issue creation successful" : "Create new GitHub issue",
				onClose: le
			}),
			/* @__PURE__ */ K(O, {
				className: Vu.modalBody,
				children: [
					!F && I && /* @__PURE__ */ G(z, { error: I }),
					!C && ie && /* @__PURE__ */ G(z, { error: ie }),
					x ? /* @__PURE__ */ G(Bu, {
						createdIssue: x,
						issueBaseLink: `https://github.com/${i}`,
						issueLinkCopied: T,
						setIssueLinkCopied: E,
						copyToClipboard: N
					}) : /* @__PURE__ */ G("form", {
						"data-testid": "github-create-issue-form",
						onSubmit: u(se),
						children: /* @__PURE__ */ K(b, { children: [/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
							label: "Repository",
							required: !0,
							children: /* @__PURE__ */ G(xc, {
								control: l,
								name: "repository",
								rules: { required: "Please select a repository" },
								render: ({ field: { onChange: e, value: t } }) => /* @__PURE__ */ G(M, {
									className: Vu.modalBodyRepository,
									searchable: !0,
									clearable: !0,
									loading: F,
									onSearch: R,
									onSelect: (t) => ae(t, e),
									onClear: oe,
									selectedItems: [t],
									placeholder: "Search GitHub repositories",
									emptyMessage: I ? "No repositories found" : "No repositories available",
									items: g || [],
									itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ G(Fu, {
										item: e,
										checked: n,
										onSelectItem: t
									})
								})
							})
						}) }), /* @__PURE__ */ G(y, {
							className: Vu.modalBodyFormFields,
							children: /* @__PURE__ */ G(zu, {
								control: l,
								errors: d,
								getValues: p,
								githubOrganization: i,
								conversationContext: r,
								issueTypeFields: Wu
							})
						})] })
					})
				]
			}),
			/* @__PURE__ */ G(k, {
				confirmOnClick: x ? le : u(se),
				confirmProps: {
					isLoading: C,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmName: x ? "Close" : "Save",
				cancelOnClick: x ? void 0 : le
			})
		]
	});
}, Ku = {
	wrapper: "_wrapper_19v8w_1",
	inputWrapper: "_inputWrapper_19v8w_6",
	inputField: "_inputField_19v8w_15",
	buttonLink: "_buttonLink_19v8w_19",
	noItemsFound: "_noItemsFound_19v8w_23",
	createIssueButton: "_createIssueButton_19v8w_28"
}, qu = ({ conversationContext: e, settings: t }) => {
	let [n, r] = U(!1), { track: i } = Ve(), o = t?.githubOrganization, s = !!t?.enableRemoveAllLinks, { linkGithubItem: c, linkGithubItemQuietly: l, unlinkGithubItem: u, loadGithubItems: d, removeDanglingGithubItemLinks: f, unlinkAllGithubItems: p, isLoadingGithubItemLinks: m, danglingIssueLinks: h, danglingPullRequestLinks: g, isLoadingGithubItems: _, issues: y, pullRequests: b, error: S } = bu({
		conversationId: e?.conversationId || null,
		githubOrganization: o
	}), C = (e) => l({
		key: e,
		type: "ISSUE"
	}), w = !(!!y?.length).valueOf() && !(!!b?.length).valueOf() && !(!!h?.length).valueOf() && !(!!g?.length).valueOf(), T = !m && !_ && !!h?.length && !!g?.length && !!t?.showDanglingLinks, E = t?.enableCreateIssue, D = !!y?.length || !!b?.length;
	return !_ && S ? /* @__PURE__ */ G(z, {
		error: S,
		retry: () => d()
	}) : /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
		className: Ku.wrapper,
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				className: Ku.inputWrapper,
				flexDirection: "column",
				children: [E && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(a, {
					variant: "primary",
					onClick: () => {
						i("github:create:issue:clicked", { githubOrganization: t?.githubOrganization }), r(!0);
					},
					className: Ku.createIssueButton,
					children: "Create new issue"
				}), /* @__PURE__ */ G("div", {
					className: Ku.inputSeparator,
					children: "or"
				})] }), /* @__PURE__ */ G(Nu, {
					onSelectItem: c,
					githubOrganization: o,
					linkedIssues: y,
					linkedPullRequests: b
				})]
			}),
			_ ? /* @__PURE__ */ G(v, {
				justifyContent: "center",
				children: /* @__PURE__ */ G(P, { "data-testid": "github-widget-item-spinner" })
			}) : D ? /* @__PURE__ */ G(wu, {
				items: [...y, ...b],
				unlinkGithubItem: u,
				githubOrganization: o
			}) : /* @__PURE__ */ G(L.Paragraph, {
				align: "center",
				className: Ku.noItemsFound,
				children: "No linked items found."
			}),
			T && /* @__PURE__ */ K(v, {
				background: "neutral.100",
				padding: "300",
				borderRadius: "100",
				flexDirection: "column",
				gap: "200",
				children: [
					/* @__PURE__ */ G(L.Heading, {
						variant: "heading-3",
						children: "Unresolved linked issues and/or pull requests"
					}),
					/* @__PURE__ */ K(v, {
						flexDirection: "row",
						flexWrap: "wrap",
						gap: "100",
						children: [h.map((e) => /* @__PURE__ */ G(I, {
							onDelete: () => u({
								key: e,
								type: "ISSUE"
							}),
							children: gu(e)
						}, gu(e))), g.map((e) => /* @__PURE__ */ G(I, {
							onDelete: () => u({
								key: e,
								type: "PR"
							}),
							children: gu(e)
						}, gu(e)))]
					}),
					/* @__PURE__ */ G(a, {
						variant: "secondary",
						onClick: () => f(),
						icon: "link-slash",
						children: "Remove all"
					})
				]
			}),
			s && D && /* @__PURE__ */ G(a, {
				variant: "secondary",
				disabled: w,
				onClick: p,
				children: "Remove all links"
			}),
			/* @__PURE__ */ G(j, {
				slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
				variant: "tertiary",
				className: Ku.buttonLink,
				navigate: () => {
					window.open(`https://github.com/${o}`, "_blank")?.focus();
				},
				children: "Open GitHub"
			})
		]
	}), /* @__PURE__ */ G(Gu, {
		isOpen: n,
		onClose: () => r(!1),
		linkGithubIssueQuietly: C,
		conversationContext: e,
		githubOrganization: o
	})] });
}, Ju = [
	{
		key: "githubOrganization",
		label: "GitHub organization or user",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "enableRemoveAllLinks",
		label: "Enable the \"Remove all links\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showDanglingLinks",
		label: "Show unresolved links to GitHub items",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableCreateIssue",
		label: "Enable the \"Create issue\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], Yu = Pe(Ju), Xu = "GITHUB", Zu = {
	enabled: !1,
	name: "",
	githubOrganization: "",
	enableRemoveAllLinks: !1,
	showDanglingLinks: !1,
	enableCreateIssue: !0
}, Qu = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i }) => {
	let a = !e, o = gl({
		mode: "onChange",
		defaultValues: Zu
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = He({
		integrationId: e,
		integrationType: Xu,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: m, error: h, isWidgetUnknown: g, refetch: S } = Ue({
		integrationId: e,
		fieldDefinitions: Ju,
		form: o,
		onMisconfigured: p
	}), C = (e) => ye(e, {
		fieldDefinitions: Ju,
		isCreationMode: a,
		create: s,
		update: c
	}), w = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: C,
		error: h ?? d,
		onRetry: h ? S : void 0,
		isLoading: u || m,
		isWidgetUnknown: g,
		children: [
			f && /* @__PURE__ */ G(se, { cause: f }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "githubOrganization",
						label: Yu.githubOrganization,
						control: o.control,
						rules: { required: "GitHub organization or user is required" },
						componentProps: {
							placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Yu.enableRemoveAllLinks,
						children: /* @__PURE__ */ G(X, {
							name: "enableRemoveAllLinks",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Yu.showDanglingLinks,
						children: /* @__PURE__ */ G(X, {
							name: "showDanglingLinks",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Yu.enableCreateIssue,
						children: /* @__PURE__ */ G(X, {
							name: "enableCreateIssue",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!a && e && /* @__PURE__ */ G(ce, {
					configuration: t,
					integrationId: e,
					integrationType: Xu,
					label: "Authorize with OAuth"
				})
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: Xu,
				integrationId: e,
				widgetName: w,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => l(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ K(v, {
					gap: "400",
					children: [/* @__PURE__ */ G(x, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ K(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									Xu,
									" integration, all links between Dixa and ",
									Xu,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"All data in ",
								Xu,
								" stays untouched."
							] }),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								Xu,
								" ",
								"integration \"",
								w,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-ingrid/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._list_1sdc5_1{padding:0}._listItem_1sdc5_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1sdc5_4:last-child{border-bottom:none}._listItemEdit_1sdc5_11{cursor:pointer}._clickableIcon_1sdc5_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productImage_1sdc5_20{max-height:40px}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var $u = /* @__PURE__ */ function(e) {
	return e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e;
}({}), ed = /* @__PURE__ */ function(e) {
	return e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e;
}({}), td = /* @__PURE__ */ function(e) {
	return e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e;
}({}), nd = { "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": {
	kind: "Document",
	definitions: [{
		kind: "OperationDefinition",
		operation: "query",
		name: {
			kind: "Name",
			value: "getOrders"
		},
		variableDefinitions: [{
			kind: "VariableDefinition",
			variable: {
				kind: "Variable",
				name: {
					kind: "Name",
					value: "email"
				}
			},
			type: {
				kind: "NonNullType",
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}
		}, {
			kind: "VariableDefinition",
			variable: {
				kind: "Variable",
				name: {
					kind: "Name",
					value: "locale"
				}
			},
			type: {
				kind: "NonNullType",
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}
		}],
		selectionSet: {
			kind: "SelectionSet",
			selections: [{
				kind: "Field",
				name: {
					kind: "Name",
					value: "Ingrid"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "DeliveryTracking_GetTrackingOrders"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "email"
							},
							value: {
								kind: "Variable",
								name: {
									kind: "Name",
									value: "email"
								}
							}
						}, {
							kind: "Argument",
							name: {
								kind: "Name",
								value: "locale"
							},
							value: {
								kind: "Variable",
								name: {
									kind: "Name",
									value: "locale"
								}
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "InlineFragment",
								typeCondition: {
									kind: "NamedType",
									name: {
										kind: "Name",
										value: "Ingrid_GetTrackingOrdersResponse"
									}
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "orders"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "analytics_id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "external_id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "preselected_parcel_index"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "sender_name"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "site_name"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "tos_id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "tracking_links"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "links"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "url"
																	}
																}]
															}
														}]
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "items"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "discount"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "image"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "price"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "quantity"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "sku"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "total_price"
																}
															}
														]
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "cart"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currency"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "items"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "attributes"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "cancelled_quantity"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "cancelled_total_price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "discount"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "image"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "quantity"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "sku"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "total_price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "variant"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "color"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "size"
																					}
																				}]
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "prices"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "shipping_components"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "price"
																					}
																				}
																			]
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "items_discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "items_price"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "price"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "shipping_discount"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "shipping_price"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "tax"
																					}
																				}
																			]
																		}
																	}]
																}
															}
														]
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "parcels"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "alerts"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "created_at"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "type"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "awaiting_supplier"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "earliest"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "latest"
																							}
																						}]
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time_range"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "end"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "start"
																							}
																						}]
																					}
																				}]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "delivery_attempt_failed"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "delivery_delayed"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "delivery_delayed_from_carrier"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "estimated_delivery_time_updated"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "linehaul"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "earliest"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "latest"
																							}
																						}]
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "estimated_time_range"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "end"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "start"
																							}
																						}]
																					}
																				}]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "out_for_delivery"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "submission_delayed"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_fallback_enabled"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_link"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_logo_pattern"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_product_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "carrier_product_ref"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "delivery_type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "direction_type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "display_carrier_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "estimated_delivery_time"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "end"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "start"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "exceptions"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "created_at"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "status"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "index"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "line_items"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "currency"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "discount"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "image"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "price"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "properties"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "quantity"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "sku"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "total_price"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "location"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "address"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "address_lines"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "apartment_number"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "attn"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "building_name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "care_of"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "city"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "coordinates"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "lat"
																								}
																							}, {
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "lng"
																								}
																							}]
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "country"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "door_code"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "floor_number"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "po_box_id"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "postal_code"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "region"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "street"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "street_number"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "subregion"
																						}
																					}
																				]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "location_external_id"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "location_type"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "operational_hours"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "free_text"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "fri"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "mon"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "sat"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "sun"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "thu"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "tue"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "wed"
																						}
																					}
																				]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "pickup_instructions"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "progress"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "estimated_time"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "end"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "start"
																					}
																				}]
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "step"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "time"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "requested_shipping_method"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "sender_name"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "tracking_link"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "tracking_number"
																}
															}
														]
													}
												}
											]
										}
									}]
								}
							}, {
								kind: "InlineFragment",
								typeCondition: {
									kind: "NamedType",
									name: {
										kind: "Name",
										value: "Ingrid_Error"
									}
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "code"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "details"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}
									]
								}
							}]
						}
					}]
				}
			}]
		}
	}]
} };
function rd(e) {
	return nd[e] ?? {};
}
var id = rd("\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n"), ad = (e) => {
	if (!e) return "";
	try {
		return new Intl.DateTimeFormat(void 0, {
			dateStyle: "medium",
			timeStyle: "short"
		}).format(new Date(e));
	} catch {
		return e;
	}
}, od = (e, t) => {
	try {
		return new Intl.NumberFormat(void 0, {
			style: "currency",
			currency: t
		}).format(e);
	} catch {
		return e.toString();
	}
}, sd = {
	list: "_list_1sdc5_1",
	listItem: "_listItem_1sdc5_4",
	listItemEdit: "_listItemEdit_1sdc5_11",
	clickableIcon: "_clickableIcon_1sdc5_15",
	productImage: "_productImage_1sdc5_20"
}, cd = ({ items: e, title: t, currency: n, openByDefault: r = !1 }) => {
	let [i, a] = U(r);
	return !e || e.length === 0 ? null : /* @__PURE__ */ G(v, {
		gap: "100",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "column",
			children: [/* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ G(x, {
					size: 14,
					name: "list-ul",
					color: "blue.900"
				}), /* @__PURE__ */ G(v, {
					gap: "200",
					flexDirection: "column",
					children: /* @__PURE__ */ K(v, {
						gap: "100",
						flexDirection: "row",
						onClick: () => a(!i),
						className: sd.clickableIcon,
						alignItems: "center",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: t
						}), /* @__PURE__ */ G(x, {
							size: 14,
							name: i ? "angle-down" : "angle-right"
						})]
					})
				})]
			}), i && /* @__PURE__ */ G(E, { children: e.map((e, t) => {
				if (!e) return null;
				let { name: r, quantity: i, price: a, image: o, sku: s } = e, c = e.currency ?? n;
				return /* @__PURE__ */ G(E.Item, {
					contentLeft: /* @__PURE__ */ K(v, {
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, { children: i }), /* @__PURE__ */ G(L.Paragraph, { children: "×" })]
					}),
					title: /* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "050",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: r
						}), a != null && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							color: "tertiary",
							children: od(a / 100, c)
						})]
					}),
					contentRight: o && /* @__PURE__ */ G(C, {
						src: o,
						alt: r ?? "Product image",
						className: sd.productImage
					}),
					className: sd.listItem
				}, `item-${t}-${s}`);
			}) })]
		})
	});
}, ld = {
	boxWrapper: "_boxWrapper_89s7l_1",
	trackButton: "_trackButton_89s7l_10"
}, ud = {
	[td.StepUnknown]: "Unknown",
	[td.StepConfirmedByMerchant]: "Confirmed by merchant",
	[td.StepPreparedByMerchant]: "Prepared by merchant",
	[td.StepSubmittedToCarrier]: "Submitted to carrier",
	[td.StepLinehaulToCarrier]: "Linehaul to carrier",
	[td.StepOnRoute]: "On route",
	[td.StepDeliveredToPickupPoint]: "At pickup point",
	[td.StepDeliveredToConsumer]: "Delivered to customer",
	[td.StepDeliveredToMerchant]: "Returned to merchant",
	[td.StepReturnRequested]: "Return requested",
	[td.StepSentBack]: "Sent back",
	[td.StepTerminated]: "Terminated",
	[td.StepAwaitingSupplier]: "Awaiting supplier"
}, dd = {
	[ed.Delivery]: "Home delivery",
	[ed.Pickup]: "Pickup point",
	[ed.Instore]: "In-store pickup",
	[ed.Mailbox]: "Mailbox",
	[ed.Inwarehouse]: "Warehouse",
	[ed.Unknown]: "Unknown"
}, fd = {
	[$u.Outbound]: "From merchant to customer",
	[$u.Return]: "Return from customer to merchant",
	[$u.Unspecified]: "Unspecified",
	[$u.UnknownDirectionType]: "Unknown"
}, pd = (e) => e ? ud[e] ?? e : "", md = (e) => e ? dd[e] ?? e : "", hd = (e) => e ? fd[e] ?? e : "", gd = (e) => {
	if (!e) return null;
	let t = [e.street, e.street_number].filter(Boolean).join(" ");
	return [
		e.name,
		t,
		e.postal_code,
		e.city,
		e.country
	].filter(Boolean).join("\n");
}, _d = ({ parcel: e }) => {
	let { isCopied: t, copy: n } = Re();
	if (!e) return null;
	let { carrier: r, progress: i, tracking_number: a, line_items: o, carrier_product_ref: s, carrier_link: c, display_carrier_name: l, delivery_type: u, direction_type: d, estimated_delivery_time: f } = e, p = l || s || r, m = i?.filter((e) => e?.time !== ""), h = pd(m?.[0]?.step), g = md(u), _ = hd(d), y = gd(e.location?.address);
	return /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		padding: "250",
		className: ld.boxWrapper,
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-4",
				children: p
			}),
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "magnifying-glass-chart",
						color: "blue.900"
					}), /* @__PURE__ */ K(v, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Carrier tracking ID"
						}), /* @__PURE__ */ K(v, {
							gap: "100",
							flexDirection: "row",
							flexWrap: "wrap",
							children: [!a && /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								color: "tertiary",
								children: "No tracking ID here yet"
							}), a && /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								color: "secondary",
								children: a
							})]
						})]
					})]
				}), a && /* @__PURE__ */ G(v, {
					flexDirection: "row",
					children: /* @__PURE__ */ G(R, {
						content: "Copy tracking ID",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: t ? "done" : "copy",
							className: sd.clickableIcon,
							onClick: () => n(a)
						})
					})
				})]
			}),
			h && /* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ G(x, {
					size: 14,
					name: "chart-donut",
					color: "blue.900"
				}), /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						children: "Status"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: h
					})]
				})]
			}),
			_ && /* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ G(x, {
					size: 14,
					name: "arrow-right",
					color: "blue.900"
				}), /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						children: "Direction"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: _
					})]
				})]
			}),
			f && /* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ G(x, {
					size: 14,
					name: "calendar",
					color: "blue.900"
				}), /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [
						/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Estimated delivery"
						}),
						/* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: [
								ad(f.start),
								" ",
								f.end && " until"
							]
						}),
						f.end && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: ad(f.end)
						})
					]
				})]
			}),
			u && /* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ G(x, {
					size: 14,
					name: "info",
					color: "blue.900"
				}), /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						children: "Delivery type"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: g
					})]
				})]
			}),
			y && /* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				children: [/* @__PURE__ */ G(x, {
					size: 14,
					name: "map-pin",
					color: "blue.900"
				}), /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						children: "Pickup location"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: y
					})]
				})]
			}),
			/* @__PURE__ */ G(cd, {
				title: "Parcel items",
				items: o
			}),
			c && /* @__PURE__ */ K(j, {
				variant: "secondary",
				className: ld.trackButton,
				navigate: () => window.open(c, "_blank")?.focus(),
				slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
				children: [
					"Track on ",
					p ?? "carrier",
					" website"
				]
			})
		]
	});
}, vd = {
	order: "_order_135ze_1",
	orderIsOpen: "_orderIsOpen_135ze_9",
	orderHeader: "_orderHeader_135ze_12"
}, yd = "No order number found", bd = ({ order: e, openByDefault: t }) => {
	let [r, i] = U(t), { isCopied: a, copy: o } = Re(), { isCopied: s, copy: c } = Re();
	if (!e) return null;
	let { cart: l, parcels: u, sender_name: d, tos_id: f } = e, p = e.external_id?.trim(), m = l?.currency || "", h = od((l?.prices?.total?.price ?? 0) / 100, m), g = d && d.trim() !== "" ? d : "unknown sender";
	return /* @__PURE__ */ K(v, {
		className: ht(vd.order, { [vd.orderIsOpen]: r }),
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: vd.orderHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: ["From ", g]
				}), p ? /* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: /* @__PURE__ */ K("span", { children: ["#", p] })
				}) : /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					color: "tertiary",
					children: yd
				})]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: r ? "angle-down" : "angle-right"
			})]
		}), r && /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				/* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "250",
						flexDirection: "row",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "tag",
							color: "blue.900"
						}), /* @__PURE__ */ K(v, {
							gap: "100",
							flexDirection: "column",
							children: [/* @__PURE__ */ G(L.Paragraph, {
								variant: "3",
								children: "Order number"
							}), /* @__PURE__ */ G(v, {
								gap: "100",
								flexDirection: "row",
								flexWrap: "wrap",
								children: p ? /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									color: "secondary",
									children: p
								}) : /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									color: "tertiary",
									children: yd
								})
							})]
						})]
					}), p && /* @__PURE__ */ G(v, {
						flexDirection: "row",
						children: /* @__PURE__ */ G(R, {
							content: "Copy order number",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: s ? "done" : "copy",
								className: sd.clickableIcon,
								onClick: () => c(p)
							})
						})
					})]
				}),
				/* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "250",
						flexDirection: "row",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "magnifying-glass-chart",
							color: "blue.900"
						}), /* @__PURE__ */ K(v, {
							gap: "100",
							flexDirection: "column",
							children: [/* @__PURE__ */ G(L.Paragraph, {
								variant: "3",
								children: "Ingrid tracking ID"
							}), /* @__PURE__ */ K(v, {
								gap: "100",
								flexDirection: "row",
								flexWrap: "wrap",
								children: [!f && /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									color: "tertiary",
									children: "No tracking ID here yet"
								}), f && /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									color: "secondary",
									children: f
								})]
							})]
						})]
					}), f && /* @__PURE__ */ G(v, {
						flexDirection: "row",
						children: /* @__PURE__ */ G(R, {
							content: "Copy tracking ID",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: a ? "done" : "copy",
								className: sd.clickableIcon,
								onClick: () => o(f)
							})
						})
					})]
				}),
				d && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "user",
						color: "blue.900"
					}), /* @__PURE__ */ K(v, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Sender"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: d
						})]
					})]
				}),
				/* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "chart-bar",
						color: "blue.900"
					}), /* @__PURE__ */ K(v, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Order value"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: h
						})]
					})]
				}),
				/* @__PURE__ */ G(cd, {
					openByDefault: !0,
					title: "Order items",
					items: l?.items?.map((e) => e),
					currency: l?.currency
				}),
				u && /* @__PURE__ */ K(v, {
					gap: "200",
					flexDirection: "column",
					margin: "0 0 100 0",
					children: [
						/* @__PURE__ */ K(v, {
							gap: "200",
							flexDirection: "row",
							alignItems: "center",
							children: [/* @__PURE__ */ G(L.Heading, {
								variant: "heading-4",
								children: "Parcels"
							}), u.length > 0 && /* @__PURE__ */ G(n, {
								variant: "success",
								size: "small",
								children: u.length
							})]
						}),
						u.length === 0 && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: "No parcels here"
						}),
						u.map((e, t) => /* @__PURE__ */ G(_d, { parcel: e }, `parcel-${t}-${e?.tracking_number}`))
					]
				})
			]
		})]
	});
}, xd = (e) => {
	let t = [], n = /* @__PURE__ */ new Map();
	for (let r of e) {
		if (!r?.external_id) {
			t.push(r);
			continue;
		}
		let e = n.get(r.external_id);
		if (e) e.parcels = [...e.parcels ?? [], ...r.parcels ?? []];
		else {
			let e = { ...r };
			n.set(r.external_id, e), t.push(e);
		}
	}
	return t;
}, Sd = (e) => {
	let t = Infinity;
	for (let n of e?.parcels ?? []) for (let e of n?.progress ?? []) {
		if (!e?.time) continue;
		let n = new Date(e.time).getTime();
		!Number.isNaN(n) && n < t && (t = n);
	}
	return t === Infinity ? -Infinity : t;
}, Cd = (e) => [...e].sort((e, t) => Sd(t) - Sd(e)), wd = ({ customerEmail: e }) => {
	let { useQuery: t } = B(), [r, i] = U([]), { data: a, loading: o, error: s } = t(id, {
		skip: !e,
		variables: {
			email: e,
			locale: "en-GB"
		}
	}), c = !o && r.length > 0, l = s ? De({ error: s.graphQLErrors?.[0] }) : !1, u = s ? Ee({ error: s.graphQLErrors?.[0] }) : !1;
	return H(() => {
		let e = a?.Ingrid?.DeliveryTracking_GetTrackingOrders;
		e?.orders && i(Cd(xd(e.orders)));
	}, [a?.Ingrid?.DeliveryTracking_GetTrackingOrders]), o ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		children: /* @__PURE__ */ G(P, {})
	}) : l || !c && !s ? /* @__PURE__ */ G(L.Paragraph, {
		color: "tertiary",
		align: "center",
		children: "No orders to track"
	}) : u ? /* @__PURE__ */ G(L.Paragraph, {
		color: "tertiary",
		align: "center",
		children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
	}) : s ? /* @__PURE__ */ G(z, { error: s }) : /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Orders"
			}), /* @__PURE__ */ G(n, {
				variant: "success",
				size: "small",
				children: r.length
			})]
		}), /* @__PURE__ */ G(v, {
			gap: "200",
			flexDirection: "column",
			children: /* @__PURE__ */ G(v, {
				gap: "200",
				flexDirection: "column",
				children: r.map((e, t) => /* @__PURE__ */ G(bd, {
					order: e,
					openByDefault: t === 0
				}, `${t}-${e?.tos_id}`))
			})
		})]
	});
}, Td = ({ conversationContext: e }) => {
	let t = e?.customer?.email;
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300",
		"data-testid": "widget-wrapper",
		children: /* @__PURE__ */ G(wd, { customerEmail: t })
	});
}, Ed = [
	{
		key: "ingridUseStagingEnvironment",
		label: "Use Ingrid staging environment",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "ingridSiteId",
		label: "Site ID",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "ingridApiToken",
		label: "API token",
		type: "string",
		secret: !0,
		defaultValue: ""
	}
], Dd = Pe(Ed), Od = {
	enabled: !1,
	name: "",
	ingridSiteId: "",
	ingridApiToken: "",
	ingridUseStagingEnvironment: !1
}, kd = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r }) => {
	let i = !e, a = gl({
		mode: "onChange",
		defaultValues: Od
	}), { create: o, update: s, remove: c, isLoading: l, error: u, misconfigurationCause: d, setMisconfigurationCause: f } = He({
		integrationId: e,
		integrationType: "INGRID",
		handleRedirect: t,
		showNotification: n
	}), { isLoading: p, error: m, isWidgetUnknown: h, refetch: g } = Ue({
		integrationId: e,
		fieldDefinitions: Ed,
		form: a,
		onMisconfigured: f
	}), v = (e) => ye(e, {
		fieldDefinitions: Ed,
		isCreationMode: i,
		create: o,
		update: s
	}), x = a.watch("name");
	return /* @__PURE__ */ K(de, {
		form: a,
		integrationId: e,
		onValidSubmit: v,
		error: m ?? u,
		onRetry: m ? g : void 0,
		isLoading: l || p,
		isWidgetUnknown: h,
		children: [
			d && /* @__PURE__ */ G(se, { cause: d }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: a.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: a.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Dd.ingridUseStagingEnvironment,
						children: /* @__PURE__ */ G(X, {
							name: "ingridUseStagingEnvironment",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "ingridSiteId",
						label: Dd.ingridSiteId,
						control: a.control,
						rules: { required: "Site ID is required" },
						componentProps: {
							placeholder: "Site ID from Ingrid",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "ingridApiToken",
						label: Dd.ingridApiToken,
						control: a.control,
						isCreationMode: i,
						rules: { required: "API token is required" },
						componentProps: {
							placeholder: "API token from Ingrid",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 })
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: "INGRID",
				integrationId: e,
				widgetName: x,
				isCreationMode: i,
				isSubmitting: a.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => c()
			})
		]
	});
};
//#endregion
//#region ../widget-jira/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._jiraCode_h30p6_1{font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px;padding:2px 4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_19ax5_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_19ax5_8>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_19ax5_8>div>div>p{white-space:unset!important}._collapseHeader_19ax5_8>div:first-child,._collapseHeader_19ax5_8>div:first-child div:first-child{width:100%}._collapseHeader_19ax5_8>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_19ax5_8{padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500);background-color:#0000!important}._collapseHeaderLink_19ax5_33{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_19ax5_33:hover{text-decoration:underline}._collapseHeaderStatus_19ax5_42{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_19ax5_48{margin-left:var(--dixa-size-spacer-100);padding-top:.35em;transform:scale(1.4)}._collapseHeaderTitle_19ax5_53{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_19ax5_61{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_19ax5_64{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_19ax5_70{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_19ax5_73{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_19ax5_76{max-width:10em}._collapseContentDescription_19ax5_79{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;font-size:12px;line-height:32px;display:flex;position:relative}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-semibold);overflow:hidden}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{text-align:left;width:100%;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em;overflow:hidden}._resultLinkIcon_1wiub_99{background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);color:var(--dixa-color-neutral-500);border-radius:5px;position:absolute;right:5px}._tooltip_1wiub_108{text-overflow:ellipsis;width:500px;max-height:60vh;overflow:hidden}._tooltipContent_1wiub_114{flex-direction:column;width:100%;max-height:60dvh;display:flex}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{text-align:left;width:100%;color:var(--dixa-typography-color-secondary);flex-grow:1;padding-top:.5em;overflow-y:auto}._tooltipSummary_1wiub_139{font-weight:var(--dixa-typography-weight-semibold);padding-top:.5em}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;font-size:var(--dixa-typography-size-200);cursor:pointer;border:0;outline:0;align-items:center;width:100%;height:48px;margin:0;line-height:32px;display:flex;position:relative}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{text-align:left;white-space:nowrap;text-overflow:ellipsis;width:100%;font-weight:var(--dixa-typography-weight-semibold);overflow:hidden}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);display:grid}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var Ad = (e, t) => ((n) => (e.marks || []).map((n) => ({
	formatterFunction: t.marks[e.type]?.[n.type],
	mark: n
})).reduce((e, t) => () => t.formatterFunction?.(t.mark, e) || n, () => n)())((t.nodes[e.type] || t.default)(e, ((e, t) => () => e.content ? e.content.map((e) => Ad(e, t)) : [])(e, t))), jd = {
	jiraCode: "_jiraCode_h30p6_1",
	jiraCodeInline: "_jiraCodeInline_h30p6_8"
}, Md = {
	default: (e, t) => t().every((e) => typeof e == "string") ? t().join(" ") : /* @__PURE__ */ G(W, { children: t() }),
	nodes: {
		doc: (e, t) => /* @__PURE__ */ G("div", { children: t() }),
		paragraph: (e, t) => /* @__PURE__ */ G("p", { children: t() }),
		text: (e) => e.text || "",
		hardBreak: () => /* @__PURE__ */ G("br", {}),
		bulletList: (e, t) => /* @__PURE__ */ G("ul", { children: t() }),
		orderedList: (e, t) => /* @__PURE__ */ G("ol", { children: t() }),
		listItem: (e, t) => /* @__PURE__ */ G("li", { children: t() }),
		codeBlock: (e, t) => /* @__PURE__ */ G("pre", { children: /* @__PURE__ */ G("code", {
			className: jd.jiraCode,
			children: t()
		}) }),
		heading: (e, t) => {
			switch (e.attrs?.level) {
				case 1: return /* @__PURE__ */ G("h3", { children: t() });
				case 2: return /* @__PURE__ */ G("h4", { children: t() });
				case 3: return /* @__PURE__ */ G("h5", { children: t() });
				case 4: return /* @__PURE__ */ G("h6", { children: t() });
				case 5: return /* @__PURE__ */ G("b", { children: t() });
				case 6: return /* @__PURE__ */ G("b", { children: t() });
				default: return /* @__PURE__ */ G("h4", { children: t() });
			}
		}
	},
	marks: { text: {
		em: (e, t) => /* @__PURE__ */ G("em", { children: t() }),
		strong: (e, t) => /* @__PURE__ */ G("b", { children: t() }),
		underline: (e, t) => /* @__PURE__ */ G("u", { children: t() }),
		link: (e, t) => /* @__PURE__ */ G("a", {
			href: e.attrs?.href || "",
			target: "_blank",
			rel: "noreferrer",
			children: t()
		}),
		code: (e, t) => /* @__PURE__ */ G("code", {
			className: ht(jd.jiraCode, jd.jiraCodeInline),
			children: t()
		})
	} }
}, Nd = ({ iconUrl: e, className: t, width: n }) => {
	let [r, i] = U(!1);
	return !e || r ? /* @__PURE__ */ G(x, {
		size: n,
		name: "question",
		className: t
	}) : /* @__PURE__ */ G("img", {
		src: e,
		width: n,
		className: t,
		onError: ({ currentTarget: e }) => {
			e.onerror = null, i(!0);
		}
	});
}, Pd = {
	collapse: "_collapse_19ax5_1",
	collapseHeader: "_collapseHeader_19ax5_8",
	collapseHeaderLink: "_collapseHeaderLink_19ax5_33",
	collapseHeaderStatus: "_collapseHeaderStatus_19ax5_42",
	collapseHeaderIcon: "_collapseHeaderIcon_19ax5_48",
	collapseHeaderTitle: "_collapseHeaderTitle_19ax5_53",
	collapseContent: "_collapseContent_19ax5_61",
	collapseContentHeadline: "_collapseContentHeadline_19ax5_64",
	collapseContentButtonSpacer: "_collapseContentButtonSpacer_19ax5_70",
	collapseContentButtonLink: "_collapseContentButtonLink_19ax5_73",
	collapseContentStatusTag: "_collapseContentStatusTag_19ax5_76",
	collapseContentDescription: "_collapseContentDescription_19ax5_79"
}, Fd = ({ jiraInstanceUrl: e, avatarId: t, iconUrl: n }) => t ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${t}?size=medium` : n, Id = ({ issues: e, jiraInstanceUrl: t, unlinkIssue: n }) => {
	let [r, o] = U(e.reduce((e, t) => t?.id ? {
		...e,
		[t.id]: !1
	} : e, {})), { track: c } = Ve(), l = (e, t) => {
		o({
			...r,
			[e]: t
		});
	};
	return /* @__PURE__ */ G(v, {
		flexDirection: "column",
		gap: "250",
		children: e?.length ? e.map((e) => {
			let { summary: o, description: u, status: d, issuetype: f } = e?.fields || {}, p = Fd({
				avatarId: f?.avatarId,
				iconUrl: f?.iconUrl,
				jiraInstanceUrl: t
			});
			return /* @__PURE__ */ K(s, {
				onToggle: () => e?.id && l(e.id, !r[e.id]),
				isOpen: !!(e?.id && r[e.id]),
				className: Pd.collapse,
				children: [/* @__PURE__ */ G(s.Header, {
					className: Pd.collapseHeader,
					children: /* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(v, {
							flexDirection: "row",
							justifyContent: "space-between",
							children: [/* @__PURE__ */ K(v, {
								alignItems: "center",
								gap: "200",
								children: [/* @__PURE__ */ G(Nd, {
									width: 16,
									iconUrl: p
								}), /* @__PURE__ */ G("a", {
									className: Pd.collapseHeaderLink,
									href: `${t}/browse/${e?.key}`,
									target: "_blank",
									rel: "noreferrer",
									onClick: (n) => {
										n.stopPropagation(), e?.key && c("jira:view:issue:clicked", {
											jiraIssueKey: e.key,
											jiraInstanceUrl: t
										});
									},
									children: /* @__PURE__ */ K(v, {
										alignItems: "center",
										gap: "200",
										children: [e?.key, /* @__PURE__ */ G(x, {
											name: "external-link",
											size: 16
										})]
									})
								}, e?.key)]
							}), /* @__PURE__ */ G("span", {
								className: Pd.collapseHeaderStatus,
								children: d?.name && /* @__PURE__ */ G(I, {
									className: Pd.collapseContentStatusTag,
									children: d.name
								})
							})]
						}), /* @__PURE__ */ G("div", {
							className: Pd.collapseHeaderTitle,
							children: o
						})]
					})
				}), /* @__PURE__ */ G(s.Content, {
					className: Pd.collapseContent,
					children: /* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "250",
						margin: "0 0 200 0",
						children: [
							/* @__PURE__ */ G("div", {
								className: Pd.collapseContentHeadline,
								children: "Description"
							}),
							/* @__PURE__ */ G(i, {
								className: Pd.collapseContentDescription,
								children: u ? Ad(u, Md) : ""
							}),
							/* @__PURE__ */ G(a, {
								icon: "link-slash",
								variant: "secondary",
								className: Pd.collapseContentButtonSpacer,
								onClick: () => e?.key && n(e.key),
								children: "Unlink issue from Jira"
							}),
							/* @__PURE__ */ G(j, {
								slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
								variant: "tertiary",
								className: Pd.collapseContentButtonLink,
								navigate: () => {
									e?.key && (c("jira:view:issue:clicked", {
										jiraIssueKey: e.key,
										jiraInstanceUrl: t
									}), window.open(`${t}/browse/${e.key}`, "_blank")?.focus());
								},
								children: "View issue in Jira"
							})
						]
					})
				})]
			}, e?.id);
		}) : /* @__PURE__ */ G(W, {})
	});
}, Ld = {
	"\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: \"Dixa Conversations\"\n            type: \"com.dixa.conversations\"\n          }\n          relationship: \"dixa-backlink\"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: \"https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2\"\n              title: \"Dixa\"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createBacklink"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueKey"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "title"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "url"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "globalId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "createOrUpdateRemoteIssueLink"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "issueIdOrKey"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "issueKey"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "ObjectValue",
									fields: [
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "globalId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "globalId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "application"
											},
											value: {
												kind: "ObjectValue",
												fields: [{
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "name"
													},
													value: {
														kind: "StringValue",
														value: "Dixa Conversations",
														block: !1
													}
												}, {
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "type"
													},
													value: {
														kind: "StringValue",
														value: "com.dixa.conversations",
														block: !1
													}
												}]
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "relationship"
											},
											value: {
												kind: "StringValue",
												value: "dixa-backlink",
												block: !1
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "object"
											},
											value: {
												kind: "ObjectValue",
												fields: [
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "title"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "title"
															}
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "url"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "url"
															}
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "icon"
														},
														value: {
															kind: "ObjectValue",
															fields: [{
																kind: "ObjectField",
																name: {
																	kind: "Name",
																	value: "url16x16"
																},
																value: {
																	kind: "StringValue",
																	value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2",
																	block: !1
																}
															}, {
																kind: "ObjectField",
																name: {
																	kind: "Name",
																	value: "title"
																},
																value: {
																	kind: "StringValue",
																	value: "Dixa",
																	block: !1
																}
															}]
														}
													}
												]
											}
										}
									]
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "__typename"
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "removeBacklink"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "issueKey"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "globalId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "deleteRemoteIssueLinkByGlobalId"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "issueIdOrKey"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "issueKey"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "globalId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "globalId"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createIssue"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Jira_IssueUpdateDetails_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "createIssue"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Jira_CreatedIssue"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "key"
											}
										}]
									}
								}, {
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Jira_ErrorCollection"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "errorMessages"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "errors"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "jira"
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getAllProjects"
							},
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "id"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "key"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrls"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "_24x24"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: \"projects.issuetypes.fields\"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCreateIssueMeta"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "projectKey"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCreateIssueMeta"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "projectKeys"
								},
								value: {
									kind: "ListValue",
									values: [{
										kind: "Variable",
										name: {
											kind: "Name",
											value: "projectKey"
										}
									}]
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "expand"
								},
								value: {
									kind: "StringValue",
									value: "projects.issuetypes.fields",
									block: !1
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "projects"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "key"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "issuetypes"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "iconUrl"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "entityId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "hierarchyLevel"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "subtask"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scope"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "type"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "project"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "key"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				}
																			]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "additionalProperties"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "expand"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "subtask"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "description"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "fields"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "additionalProperties"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "key"
																			}
																		}, {
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "value"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "key"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "required"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "hasDefaultValue"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "schema"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "type"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "system"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "items"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "custom"
																									}
																								},
																								{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "customId"
																									}
																								}
																							]
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "allowedValues"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "defaultValue"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "operations"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "autoCompleteUrl"
																						}
																					}
																				]
																			}
																		}]
																	}
																}]
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          \"summary\"\n          \"description\"\n          \"status\"\n          \"updated\"\n          \"issuetype\"\n          \"project\"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchAndReconsileIssuesUsingJql"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "jql"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "maxResults"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Int"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "searchAndReconsileIssuesUsingJql"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "jql"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "jql"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "maxResults"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "maxResults"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "fields"
									},
									value: {
										kind: "ListValue",
										values: [
											{
												kind: "StringValue",
												value: "summary",
												block: !1
											},
											{
												kind: "StringValue",
												value: "description",
												block: !1
											},
											{
												kind: "StringValue",
												value: "status",
												block: !1
											},
											{
												kind: "StringValue",
												value: "updated",
												block: !1
											},
											{
												kind: "StringValue",
												value: "issuetype",
												block: !1
											},
											{
												kind: "StringValue",
												value: "project",
												block: !1
											}
										]
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "issues"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "key"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "fields"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "findUsers"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Jira"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "findUsers"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "query"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "query"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "accountId"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "displayName"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "self"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "active"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "avatarUrls"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "_24x24"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Rd(e) {
	return Ld[e] ?? {};
}
var zd = Rd("\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          \"summary\"\n          \"description\"\n          \"status\"\n          \"updated\"\n          \"issuetype\"\n          \"project\"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n"), Bd = Rd("\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: \"Dixa Conversations\"\n            type: \"com.dixa.conversations\"\n          }\n          relationship: \"dixa-backlink\"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: \"https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2\"\n              title: \"Dixa\"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n"), Vd = Rd("\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n"), Hd = Rd("\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n"), Ud = Rd("\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: \"projects.issuetypes.fields\"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), Wd = Rd("\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n"), Gd = Rd("\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n"), Kd = /* @__PURE__ */ RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), qd = RegExp(`^${Kd.source}$`), Jd = RegExp(`/${Kd.source}$`), Yd = RegExp(`.+?[&?]selectedIssue=(${Kd.source})[&?]?.*`);
function Xd(e, t) {
	let n = { jira: { issues: [] } }, [r, i] = U([]), [a, o] = U([]), [s, c] = U(), { track: l } = Ve(), { showNotification: u, showModal: d, useLazyQuery: f, useMutation: p } = B(), { loading: m, data: h, error: g, store: _ } = ze(e ?? null), [v, { loading: y, error: b, data: x }] = f(zd, { notifyOnNetworkStatusChange: !0 });
	H(() => {
		let e = x?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
		e?.length && (o(e), i(e.map((e) => e?.key).filter(Boolean)));
	}, [x]), H(() => c(g || b || void 0), [g, b]), H(() => {
		m || O();
	}, [h?.jira?.issues, m]);
	let S = async (e, t) => {
		await _(e).then(() => {
			u({
				icon: "check-circle-filled",
				severity: "success",
				title: t.success.title,
				text: t.success.text
			});
		}).catch((e) => {
			u({
				title: t.error.title,
				text: `${t.error.text} ${e.message && " (" + e.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, [C] = p(Bd, { onError: (e) => {
		u({
			title: "Something went wrong",
			text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${e.message && " (" + e.message + ")"}`,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	} }), w = (t, n) => {
		let r = window.location.href, i = n ? r.replace(e?.toString() ?? "", n?.toString()) : r, a = n ? `# ${n}` : `# ${e}`;
		C({ variables: {
			issueKey: t,
			title: a,
			url: i,
			globalId: `system=${i}`
		} });
	}, [T] = p(Vd, { onError: (e) => {
		u({
			title: "Something went wrong",
			text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${e.message && " (" + e.message + ")"}`,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	} }), E = (e) => {
		let t = window.location.href;
		T({ variables: {
			issueKey: e,
			globalId: `system=${t}`
		} });
	}, D = (e) => ({
		jiraInstanceUrl: t,
		jiraIssueKey: e
	}), O = () => {
		h && h.jira?.issues?.length > 0 ? v({ variables: {
			jql: `key in (${h?.jira?.issues.join(",")})`,
			maxResults: 15
		} }) : o([]);
	}, k = async (e, t) => {
		l("jira:issue:link:clicked", D(e));
		let r = h?.jira?.issues ? h : n;
		r.jira.issues = Array.from(new Set(r.jira.issues).add(e)), await _(r, t?.toString()).then(() => w(e, t)).catch((t) => {
			u({
				title: "Linking failed",
				text: `Linking ${e} failed. Please try again. ${t.message && " (" + t.message + ")"}`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		});
	}, A = (e) => {
		l("jira:issue:link:clicked", D(e));
		let t = h?.jira?.issues ? h : n;
		t.jira.issues = Array.from(new Set(t.jira.issues).add(e)), S(t, {
			success: {
				title: "Jira issue linked",
				text: `You linked the Jira issue ${e} to this conversation.`
			},
			error: {
				title: "Linking failed",
				text: `Linking ${e} failed. Please try again.`
			}
		}).then(() => w(e));
	}, j = (e) => {
		l("jira:issue:unlink:clicked", D(e)), d({
			headline: `Unlink issue ${e}?`,
			text: `You are about to unlink the issue ${e}. Do you want to proceed?`,
			confirmLabel: "Unlink Jira issue",
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				l("jira:issue:unlink:confirmed", D(e));
				let t = {
					...h,
					jira: {
						...h?.jira,
						issues: h?.jira?.issues.filter((t) => t !== e) || []
					}
				};
				S(t, {
					success: {
						title: "Jira issue unlinked",
						text: `You unlinked the Jira issue ${e}`
					},
					error: {
						title: "Unlinking failed",
						text: `Unlinking ${e} failed.`
					}
				}).then(() => E(e));
			},
			onCancel: () => l("jira:issue:unlink:cancelled", D(e))
		});
	}, M = () => {
		l("jira:issue:unlink-all:clicked", { jiraInstanceUrl: t }), d({
			headline: "Unlink all Jira issues?",
			text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
			confirmLabel: "Unlink ALL issues",
			confirmVariant: "danger",
			cancelLabel: "Cancel",
			onConfirm: () => {
				l("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: t }), a?.forEach((e) => e?.key && E(e.key)), S(n, {
					success: {
						title: "Unlinking successful",
						text: "All Jira issues were unlinked"
					},
					error: {
						title: "Unlinking failed",
						text: "Unlinking all issues failed."
					}
				});
			},
			onCancel: () => l("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: t })
		});
	}, N = h?.jira?.issues?.filter((e) => !r?.includes(e)) || [];
	return {
		linkIssue: A,
		linkIssueQuietly: k,
		unlinkIssue: j,
		loadIssues: O,
		removeDanglingIssueLinks: () => {
			l("jira:issue:unlink-all-dangling:clicked", { jiraInstanceUrl: t });
			let e = {
				...h,
				jira: {
					...h?.jira,
					issues: h?.jira?.issues.filter((e) => !N.includes(e)) || []
				}
			};
			_(e);
		},
		unlinkAllIssues: M,
		maybeExtractIssueKey: (e) => {
			let n = e.replace(/\s/g, "");
			if (qd.test(n)) return n;
			if (Yd.test(e)) return e.match(Yd)?.[1];
			if (e.startsWith(t) && Jd.test(e)) return e.substring(e.lastIndexOf("/") + 1);
		},
		isLoadingIssueLinks: m,
		danglingIssueLinks: N,
		isLoadingIssues: y,
		issues: a,
		error: s
	};
}
function Zd(e = !1, t) {
	let [n, r] = U(e);
	return H(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copyToClipboard: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var Qd = {
	result: "_result_1wiub_54",
	resultName: "_resultName_1wiub_74",
	resultNameIcon: "_resultNameIcon_1wiub_82",
	resultDescription: "_resultDescription_1wiub_87",
	resultLinkIcon: "_resultLinkIcon_1wiub_99",
	tooltip: "_tooltip_1wiub_108",
	tooltipContent: "_tooltipContent_1wiub_114",
	tooltipName: "_tooltipName_1wiub_121",
	tooltipNameIcon: "_tooltipNameIcon_1wiub_126",
	tooltipDescription: "_tooltipDescription_1wiub_131",
	tooltipSummary: "_tooltipSummary_1wiub_139",
	tooltipTag: "_tooltipTag_1wiub_143"
}, $d = ({ item: e, jiraInstanceUrl: t, onSelect: n, disableTooltip: r = !1, ...i }) => {
	let { issuetype: a, name: o, status: s, text: c, description: l } = e, [u, d] = U(!1), f = Fd({
		avatarId: a?.avatarId,
		iconUrl: a?.iconUrl,
		jiraInstanceUrl: t
	});
	return /* @__PURE__ */ G(R, {
		disabled: r,
		className: Qd.tooltip,
		content: /* @__PURE__ */ K("div", {
			className: Qd.tooltipContent,
			children: [
				/* @__PURE__ */ K(v, {
					flexDirection: "row",
					justifyContent: "space-between",
					width: "100%",
					children: [/* @__PURE__ */ K("span", {
						className: Qd.tooltipName,
						children: [
							/* @__PURE__ */ G(Nd, {
								width: 16,
								iconUrl: f,
								className: Qd.tooltipNameIcon
							}),
							"\xA0",
							o
						]
					}), /* @__PURE__ */ G(I, {
						className: Qd.tooltipTag,
						children: s.name
					})]
				}),
				l && /* @__PURE__ */ G("div", {
					className: Qd.tooltipSummary,
					children: l
				}),
				c && /* @__PURE__ */ G("div", {
					className: Qd.tooltipDescription,
					children: c
				})
			]
		}),
		side: "left",
		light: !0,
		children: /* @__PURE__ */ K("button", {
			...i,
			className: Qd.result,
			type: "button",
			onClick: () => {
				n(e);
			},
			onMouseEnter: () => d(!0),
			onMouseLeave: () => d(!1),
			children: [/* @__PURE__ */ K(v, {
				flexDirection: "column",
				justifyContent: "center",
				style: { width: u ? "calc(100% - 32px)" : "100%" },
				children: [/* @__PURE__ */ G(v, {
					flexDirection: "row",
					children: /* @__PURE__ */ K("span", {
						className: Qd.resultName,
						children: [
							/* @__PURE__ */ G(Nd, {
								width: 16,
								iconUrl: f,
								className: Qd.resultNameIcon
							}),
							"\xA0",
							o
						]
					})
				}), l && /* @__PURE__ */ G("div", {
					className: Qd.resultDescription,
					children: l
				})]
			}), u && /* @__PURE__ */ G(x, {
				className: Qd.resultLinkIcon,
				name: "plus",
				size: 32
			})]
		})
	});
}, ef = ({ className: e, searched: t, jiraInstanceUrl: n }) => /* @__PURE__ */ G(j, {
	slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
	variant: "tertiary",
	style: { width: "100%" },
	className: e,
	navigate: () => {
		window.open(`${n}/secure/QuickSearch.jspa?searchString=${t}`, "_blank")?.focus();
	},
	children: "View matching issues in Jira"
}), tf = ({ onSelectIssue: e, jiraInstanceUrl: t, filterByProjectKey: n, disableTooltip: r }) => {
	let { useLazyQuery: i } = B(), [a, o] = U([]), [s, c] = U(""), [l, { loading: u, error: d, data: f, networkStatus: p }] = i(zd, { notifyOnNetworkStatusChange: !0 }), { maybeExtractIssueKey: m } = Xd(null, t), [h, g] = au(() => {
		!u && s && p === st.ready ? l({ variables: {
			jql: s,
			maxResults: 25
		} }) : o([]);
	}, 500, [s]);
	return H(() => {
		let e = f?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
		o(e.map((e) => ({
			id: e?.key ?? "",
			name: e?.key ?? "",
			description: e?.fields.summary,
			status: e?.fields.status,
			issuetype: e?.fields.issuetype,
			text: e?.fields.description ? Ad(e?.fields.description, Md) : /* @__PURE__ */ G(W, {})
		})));
	}, [f]), !u && d ? /* @__PURE__ */ G(z, { error: d }) : /* @__PURE__ */ G(M, {
		items: a,
		loading: u,
		onSearch: (e) => {
			let t = e.trim(), r = m(t);
			if (r) {
				let e = r.replaceAll("[-_|]", "\\\\$0");
				c(`key = '${e}'`);
			} else t !== "" && c(`text ~ '${t}'${n ? " and project = " + n : ""}`);
		},
		onSelect: (t) => {
			e(t.id), c("");
		},
		onClear: () => {
			c("");
		},
		emptyMessage: s ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
		suggestionComponent: (e) => /* @__PURE__ */ G(ef, {
			...e,
			jiraInstanceUrl: t
		}),
		itemComponent: (e) => /* @__PURE__ */ G($d, {
			...e,
			jiraInstanceUrl: t,
			disableTooltip: r
		}),
		placeholder: "Search and link existing issue",
		searchable: !0,
		clearable: !0
	});
}, nf = ({ field: e, value: t, onChange: n }) => {
	let [r, i] = U(t ? [t] : []);
	return H(() => {
		n(r);
	}, [r]), /* @__PURE__ */ G(M, {
		multiple: !0,
		onChange: (e, t) => {
			i(t ? [...r, e] : r.filter(({ id: t }) => t !== e.id));
		},
		selectedItems: r,
		items: (e?.allowedValues)?.map(({ id: e, name: t, value: n }) => ({
			id: e,
			name: t || n
		}))
	});
}, rf = {
	itemButton: "_itemButton_1hl53_1",
	result: "_result_1hl53_6",
	resultIcon: "_resultIcon_1hl53_26",
	resultName: "_resultName_1hl53_30",
	resultCheckIcon: "_resultCheckIcon_1hl53_38"
}, af = ({ item: e, checked: t = !1, onSelectItem: n, jiraInstanceUrl: r }) => {
	let a = (e) => {
		let t = e.indexOf("/rest/api/");
		return t >= 0 ? `${r}${e?.substring(t)}` : e;
	}, o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
	return o &&= o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o, /* @__PURE__ */ G(v, {
		flexDirection: "column",
		justifyContent: "center",
		width: "100%",
		"data-testid": "jira-select-item-component",
		children: /* @__PURE__ */ G("button", {
			onClick: () => {
				n(e);
			},
			className: rf.itemButton,
			children: /* @__PURE__ */ K(v, {
				className: rf.result,
				flexDirection: "row",
				width: "100%",
				children: [
					/* @__PURE__ */ G(Nd, {
						width: 36,
						iconUrl: o || "",
						className: rf.resultIcon
					}),
					/* @__PURE__ */ G(i, {
						className: rf.resultName,
						children: e.name
					}),
					t && /* @__PURE__ */ G(i, {
						className: rf.resultCheckIcon,
						children: /* @__PURE__ */ G(x, { name: "done" })
					})
				]
			})
		})
	});
}, of = ({ selectedItems: e, agentEmail: t, onSelect: n, jiraInstanceUrl: r }) => {
	let { useLazyQuery: i } = B(), [a, o] = U([]), [s, c] = U(), [l, { loading: u, error: d, data: f, networkStatus: p }] = i(Gd, { notifyOnNetworkStatusChange: !0 }), [m, h] = au(() => {
		!u && s && s.length >= 2 && p === st.ready ? l({ variables: {
			query: s,
			maxResults: 10
		} }) : o([]);
	}, 500, [s]);
	return H(() => {
		t && l({ variables: {
			query: t,
			maxResults: 1
		} }).then((e) => {
			if (e?.data?.Jira.findUsers?.length === 1) {
				let t = e?.data?.Jira?.findUsers[0];
				n(t.accountId), o([{
					id: t.accountId,
					name: t.displayName
				}]);
			}
		});
	}, []), H(() => {
		let e = f?.Jira?.findUsers || [];
		o(e.filter(({ active: e }) => e).map(({ accountId: e, displayName: t, avatarUrls: n, active: r }) => ({
			id: e,
			name: t,
			avatarUrls: n,
			active: r
		})));
	}, [f]), !u && d ? /* @__PURE__ */ G(z, { error: d }) : /* @__PURE__ */ G(M, {
		clearable: !0,
		searchable: !0,
		items: a,
		loading: u,
		onSearch: (e) => c(e),
		onSelect: n,
		onClear: () => c(void 0),
		selectedItems: e,
		emptyMessage: s ? u ? "" : "No user found" : "Enter keyword to search for user",
		itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ G(af, {
			item: e,
			checked: n,
			onSelectItem: t,
			jiraInstanceUrl: r
		}),
		placeholder: "Search Jira users"
	});
}, sf = ({ field: e }) => {
	let [t, n] = U(!1), [r, i] = ru();
	return H(() => {
		let e = t ? window.setTimeout(() => n(!1), 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t]), /* @__PURE__ */ K(v, {
		alignItems: "center",
		gap: "400",
		justifyContent: "space-between",
		children: [
			/* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(x, {
				size: 24,
				name: "exclamation-triangle-filled",
				color: "red.500"
			}) }),
			/* @__PURE__ */ G(L.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
			/* @__PURE__ */ G(R, {
				content: t ? "Copied" : "Copy field details",
				children: /* @__PURE__ */ G(S, {
					variant: "secondary",
					icon: t ? "done" : "copy",
					onClick: () => {
						i(JSON.stringify(e, null, 2)), n(!0);
					}
				})
			})
		]
	});
}, cf = ({ field: e, onChange: t, value: n, conversationContext: r, jiraInstanceUrl: i }) => {
	let { type: a, system: o } = e.schema;
	if ([
		"array",
		"option",
		"priority"
	].includes(a) && (!e?.allowedValues || e.allowedValues.length === 0)) return /* @__PURE__ */ G(sf, { field: e });
	switch (a) {
		case "issuelink":
		case "environment":
		case "any": return /* @__PURE__ */ G(T, {
			onChange: t,
			value: n
		});
		case "string": return G(o === "description" ? re : T, {
			onChange: t,
			value: n
		});
		case "textarea": return /* @__PURE__ */ G(re, {
			onChange: t,
			value: n
		});
		case "number": return /* @__PURE__ */ G(T, {
			type: "number",
			onChange: t,
			value: n
		});
		case "user": return /* @__PURE__ */ G(of, {
			onSelect: t,
			selectedItems: n ? [n] : [],
			agentEmail: e.key === "reporter" && r?.agent?.email || void 0,
			jiraInstanceUrl: i
		});
		case "option":
		case "priority": return /* @__PURE__ */ G(M, {
			onSelect: t,
			selectedItems: n ? [n] : [],
			items: (e?.allowedValues)?.map(({ id: e, name: t, value: n }) => ({
				id: e,
				name: t || n
			})) || []
		});
		case "array": return /* @__PURE__ */ G(nf, {
			field: e,
			value: n,
			onChange: t
		});
		default: return /* @__PURE__ */ G(sf, { field: e });
	}
}, lf = [
	"description",
	"reporter",
	"summary"
], uf = ({ issueTypeFields: e, control: t, jiraInstanceUrl: n, conversationContext: r, errors: i }) => /* @__PURE__ */ G(W, { children: e.filter(({ key: e }) => e !== "project" && e !== "issuetype").filter(({ key: e, required: t }) => t || lf.includes(e)).map((e) => /* @__PURE__ */ G(xc, {
	control: t,
	render: ({ field: { onChange: t, value: a } }) => /* @__PURE__ */ G(_, {
		meta: { error: i && e.key in i ? i[e.key].message : null },
		label: e.name,
		required: e.required,
		children: cf({
			field: e,
			onChange: t,
			value: a,
			conversationContext: r,
			jiraInstanceUrl: n
		})
	}, e.key),
	name: e.key,
	rules: { required: e.required ? "This field is required" : !1 }
}, e.key)) }), df = ({ createdIssue: e, issueBaseLink: t, issueLinkCopied: n, setIssueLinkCopied: r, copyToClipboard: i }) => /* @__PURE__ */ K(v, {
	flexDirection: "column",
	gap: "400",
	"data-testid": "jira-create-issue-success-message",
	children: [/* @__PURE__ */ K(L.Paragraph, { children: [
		"You can visit your new issue by following",
		" ",
		/* @__PURE__ */ K(L.ExternalLink, {
			href: `${t}/${e.key}`,
			target: "_blank",
			children: ["this link ", /* @__PURE__ */ G(x, { name: "external-link" })]
		}),
		" ",
		"or copy it from the field below."
	] }), /* @__PURE__ */ G(_, {
		label: "Jira issue link",
		children: /* @__PURE__ */ G(T, {
			readOnly: !0,
			value: `${t}/${e.key}`,
			suffix: {
				type: "button",
				button: {
					icon: n ? "done" : "copy",
					onClick: () => {
						r(!0), i(`${t}/${e.key}`);
					}
				}
			}
		})
	})]
}), ff = {
	modalBody: "_modalBody_1hk1o_1",
	modalBodyFormFields: "_modalBodyFormFields_1hk1o_4"
}, pf = (e) => ({
	version: 1,
	type: "doc",
	content: e?.trim()?.split("\n").filter((e) => e !== "").map((e) => ({
		type: "paragraph",
		content: [{
			type: "text",
			text: e
		}]
	}))
}), mf = (e) => e?.custom?.split(":")?.[1] || null, hf = (e, t) => {
	if (e.startsWith("customfield_")) {
		let n = t.find((t) => t.key === e)?.schema;
		if (n) return n;
	}
	return null;
}, gf = (e, t) => {
	let n = [
		"environment",
		"textarea",
		"description"
	];
	return { fields: {
		...Object.entries(e).reduce((r, [i, a]) => {
			if (!a || a === "") return delete e[i], r;
			let o = hf(i, t), s = mf(o) ?? i;
			return n.includes(s) ? r[i] = pf(a) : o?.type === "number" ? r[i] = parseInt(a) : r[i] = a, r;
		}, {}),
		summary: e.summary,
		project: { id: e.project.id },
		issuetype: { id: e.issuetype.id },
		...e?.parent && { parent: { key: e.parent } },
		...e?.reporter && { reporter: { id: e.reporter?.id ?? e.reporter } },
		...e?.assignee && { assignee: { id: e.assignee?.id ?? e.assignee } }
	} };
}, _f = ({ isOpen: e, onClose: t, linkIssueQuietly: n, conversationContext: i, jiraInstanceUrl: o, hasSortIssueTypeByLabelEnabled: s }) => {
	let c = {
		project: void 0,
		issuetype: void 0
	}, [l, u] = U([]), [d, f] = U(), [p, m] = U(0), [h, g] = U([]), [x, S] = U([]), [C, w] = U(!1), [T, E] = U(!1), [j, N] = U({}), { track: ee } = Ve(), { isCopied: F, copyToClipboard: I } = Zd(), te = Qe(() => i?.conversationId, [e]), { useMutation: ne, useLazyQuery: re, showNotification: ie } = B(), { control: R, handleSubmit: ae, formState: { errors: oe }, reset: se, setValue: ce, getValues: le } = gl({ defaultValues: c }), ue = x.length > 0, de = `${o}/browse`, fe = Object.keys(j).length > 0, [pe, { loading: me, error: he }] = re(Hd, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			u(e.Jira.getAllProjects);
		},
		onError: (e) => {
			ie({
				title: "Could not get project list",
				text: "We could not fetch the list of your projects. Please try again later.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), console.warn("Error response when fetching projects", e), u([]);
		}
	}), [ge, { loading: _e, error: ve }] = re(Ud, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			m(0);
			let t = e?.Jira?.getCreateIssueMeta?.projects[0];
			if (t) {
				let e = t?.issuetypes.filter(({ subtask: e }) => !e);
				g(e || []), ce("issuetype", e.length > 0 ? e[0] : void 0);
			} else ie({
				title: "Could not get issue-type list",
				text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), g([]), S([]);
		},
		onError: (e) => {
			ie({
				title: "Could not get issue list",
				text: "We could not fetch the list of issue-types for this project. Please try again later.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), console.warn("Error in getCreateIssueMeta", e), g([]), S([]), m(0);
		}
	}), [ye, { error: be }] = ne(Wd, {
		onError: () => {
			w(!1), ie({
				title: "Creation was not successful",
				text: "Please try again later or contact your admin.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), ee("jira:issue:create:failed", { jiraInstanceUrl: o });
		},
		onCompleted: (e) => {
			if (w(!1), e?.Jira && "key" in e.Jira.createIssue) f(e?.Jira?.createIssue), ie({
				title: "Success",
				text: `Jira issue '${e.Jira.createIssue.key}' created`,
				icon: "check-circle-filled",
				severity: "success"
			}), ee("jira:issue:create:succeeded", {
				jiraInstanceUrl: o,
				jiraIssueKey: e.Jira.createIssue.key
			}), te && n(e.Jira.createIssue.key, te);
			else if ("errorMessages" in e.Jira.createIssue || "errors" in e.Jira.createIssue) {
				let t = e?.Jira?.createIssue?.errors;
				console.warn("There was a problem creating a Jira issue.", t), ie({
					title: "Creation was not successful",
					text: "Something went wrong. Please get in contact with Dixa.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
			}
		}
	}), xe = (e) => {
		w(!0), N({}), ye({ variables: { input: gf(e, x) } });
	};
	H(() => {
		if (e) try {
			pe();
		} catch (e) {
			console.warn("Error when fetching initial projects", e);
		}
	}, [e]), H(() => {
		let e = T ? window.setTimeout(() => E(!1), 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [T]), H(() => {
		if (h?.length > 0) {
			ce("issuetype", h[p]);
			let e = h[p]?.fields?.additionalProperties;
			if (e?.length > 0) {
				let t = e.map(({ value: e }) => e), n = (s ? t.sort(({ name: e }, { name: t }) => e.localeCompare(t)) : t).sort(({ required: e }, { required: t }) => Number(t) - Number(e)), { project: r, issuetype: i } = le();
				se({
					project: r,
					issuetype: i
				}), S(n);
			}
		} else S([]), ce("issuetype", void 0);
	}, [
		h,
		ce,
		p
	]), H(() => {
		if (be && dt(be)) {
			if (be?.graphQLErrors?.length > 0) {
				let { graphQLErrors: e } = be, t = e[0].extensions?.integration?.responseBody;
				try {
					let e = JSON.parse(t);
					if (e?.errors) {
						let t = Object.keys(e.errors).reduce((t, n) => ({
							...t,
							[n]: {
								type: "required",
								message: e.errors[n],
								ref: { name: n }
							}
						}), {});
						N(t);
					}
				} catch {}
			}
		} else N({});
	}, [be]);
	let Se = () => {
		u([]), S([]), g([]), f(void 0), m(0), w(!1), N({});
	}, Ce = () => {
		Se(), se(c), t();
	}, we = (e) => {
		e && ge({ variables: { projectKey: e } });
	}, Te = (e) => {
		let t = h.map((e) => e.id).indexOf(e);
		m(t ?? 0);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		"data-testid": "jira-create-issue-modal",
		onClose: Ce,
		children: [
			/* @__PURE__ */ G(A, {
				title: d ? "Issue creation successful" : "Create new Jira issue",
				onClose: Ce
			}),
			/* @__PURE__ */ K(O, {
				className: ff.modalBody,
				children: [
					!me && he && /* @__PURE__ */ G(z, {
						error: he,
						retry: pe
					}),
					!_e && ve && /* @__PURE__ */ G(z, {
						error: ve,
						retry: ge
					}),
					!C && fe && /* @__PURE__ */ G(v, {
						margin: "0 0 400",
						children: /* @__PURE__ */ G(r, {
							variant: "warning",
							description: /* @__PURE__ */ K(v, {
								gap: "300",
								flexDirection: "column",
								alignItems: "flex-start",
								children: [/* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further."
								}), /* @__PURE__ */ G(a, {
									icon: F ? "done" : "copy",
									variant: "secondary",
									onClick: () => I(JSON.stringify(x, null, 2)),
									children: "Copy form schema"
								})]
							})
						})
					}),
					d ? /* @__PURE__ */ G(df, {
						createdIssue: d,
						issueBaseLink: de,
						issueLinkCopied: T,
						setIssueLinkCopied: E,
						copyToClipboard: I
					}) : /* @__PURE__ */ G("form", {
						"data-testid": "jira-create-issue-form",
						onSubmit: ae(xe),
						children: /* @__PURE__ */ K(b, { children: [
							/* @__PURE__ */ G(y, {
								span: 3,
								children: /* @__PURE__ */ G(_, {
									label: "Project",
									required: !0,
									children: /* @__PURE__ */ G(xc, {
										control: R,
										name: "project",
										rules: { required: "Please select a project" },
										render: ({ field: { onChange: e, value: t } }) => /* @__PURE__ */ G(M, {
											searchable: !0,
											loading: me,
											onSelect: (t) => {
												we(t.key), e(t);
											},
											selectedItems: [t],
											placeholder: "Select Jira project",
											emptyMessage: he ? "No projects found" : "No projects available",
											items: l || [],
											itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ G(af, {
												item: e,
												checked: n,
												onSelectItem: t,
												jiraInstanceUrl: o
											})
										})
									})
								})
							}),
							/* @__PURE__ */ G(y, {
								span: 3,
								children: /* @__PURE__ */ G(_, {
									label: "Issue type",
									required: !0,
									children: /* @__PURE__ */ G(xc, {
										control: R,
										name: "issuetype",
										rules: { required: "Please select an issue type" },
										render: ({ field: { onChange: e, value: t } }) => /* @__PURE__ */ G(M, {
											disabled: h.length === 0,
											loading: _e,
											onSelect: (t) => {
												Te(t.id), e(t);
											},
											selectedItems: [t],
											placeholder: h.length > 0 ? "Select Jira issue type" : "",
											emptyMessage: ve ? "No issues found" : "No issues available",
											items: h,
											itemComponent: ({ item: e, onSelect: t, checked: n }) => /* @__PURE__ */ G(af, {
												item: e,
												checked: n,
												onSelectItem: t,
												jiraInstanceUrl: o
											})
										})
									})
								})
							}),
							ue && /* @__PURE__ */ G(y, {
								className: ff.modalBodyFormFields,
								children: /* @__PURE__ */ G(uf, {
									control: R,
									errors: {
										...oe,
										...j
									},
									getValues: le,
									conversationContext: i,
									jiraInstanceUrl: o,
									issueTypeFields: x
								})
							})
						] })
					})
				]
			}),
			/* @__PURE__ */ G(k, {
				confirmOnClick: d ? Ce : ae(xe),
				confirmProps: {
					disabled: !ue,
					isLoading: C,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmName: d ? "Close" : "Save",
				cancelOnClick: d ? void 0 : Ce
			})
		]
	});
}, vf = (e) => {
	if (!e) return "";
	let t = "https://";
	return `${t}${(e.startsWith(t) ? e.slice(8) : e).split("/")[0]}`;
}, yf = (e) => {
	if (!e?.trim()) return "Please add a value";
	let t = "https://";
	if (e.startsWith(" ") || e.endsWith(" ")) return "Please remove any empty spaces before or after the URL";
	let n = e.startsWith(t);
	if (n) {
		let t = e.slice(8).split("/");
		if (t.length > 1) {
			let r = n ? 8 + t[0].length : t[0].length;
			return t.length === 2 && t[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(r)}\``;
		}
	} else return e.includes("://") ? `The protocol \`${e.substring(0, e.indexOf("://") + 3)}\` is not supported` : `Please add \`${t}\` as protocol`;
}, bf = {
	wrapper: "_wrapper_1bylq_1",
	inputWrapper: "_inputWrapper_1bylq_6",
	inputField: "_inputField_1bylq_14",
	inputSeparator: "_inputSeparator_1bylq_18",
	buttonLink: "_buttonLink_1bylq_23",
	noIssuesFound: "_noIssuesFound_1bylq_27"
}, xf = ({ conversationContext: e, settings: t }) => {
	let { track: n } = Ve(), r = vf(t?.jiraSiteUrl), [i, o] = U(!1), { linkIssue: s, linkIssueQuietly: c, unlinkIssue: l, unlinkAllIssues: u, loadIssues: d, removeDanglingIssueLinks: f, danglingIssueLinks: p, isLoadingIssueLinks: m, isLoadingIssues: h, issues: g, error: _ } = Xd(e?.conversationId ? e.conversationId : null, r), y = !!t?.enableCreateIssue, b = !!t?.enableSortIssueTypeByLabel, S = !!(g?.length || p?.length), C = !!t?.enableRemoveAllLinks && S, w = !m && !h && p?.length > 0 && !!t?.showDanglingLinks;
	return !h && _ ? /* @__PURE__ */ G(z, {
		error: _,
		retry: () => d()
	}) : /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
		className: bf.wrapper,
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				className: bf.inputWrapper,
				flexDirection: "column",
				children: [y && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(a, {
					variant: "primary",
					onClick: () => o(!0),
					style: { minHeight: "38px" },
					children: "Create new issue"
				}), /* @__PURE__ */ G("div", {
					className: bf.inputSeparator,
					children: "or"
				})] }), /* @__PURE__ */ G(tf, {
					onSelectIssue: s,
					jiraInstanceUrl: r
				})]
			}),
			h ? /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "0 0 300 0",
				children: /* @__PURE__ */ G(P, { "data-testid": "jira-widget-issue-spinner" })
			}) : g?.length ? /* @__PURE__ */ G(Id, {
				issues: g,
				jiraInstanceUrl: r,
				unlinkIssue: l
			}) : /* @__PURE__ */ G(L.Paragraph, {
				align: "center",
				className: bf.noIssuesFound,
				children: "No linked issues found"
			}),
			C && g?.length > 0 && /* @__PURE__ */ G(a, {
				variant: "secondary",
				disabled: !g?.length && !p?.length,
				onClick: u,
				children: "Unlink all issues"
			}),
			w && /* @__PURE__ */ K(v, {
				background: "neutral.100",
				padding: "300",
				borderRadius: "100",
				flexDirection: "column",
				gap: "200",
				children: [
					/* @__PURE__ */ G(L.Heading, {
						variant: "heading-3",
						children: "Unresolved linked issues"
					}),
					/* @__PURE__ */ G(v, {
						flexDirection: "row",
						flexWrap: "wrap",
						gap: "100",
						children: p.map((e) => /* @__PURE__ */ G(I, {
							onDelete: () => l(e),
							children: e
						}, e))
					}),
					/* @__PURE__ */ G(a, {
						variant: "secondary",
						onClick: () => f(),
						icon: "link-slash",
						children: "Remove all unresolved issues"
					})
				]
			}),
			/* @__PURE__ */ G(j, {
				slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
				variant: "tertiary",
				className: bf.buttonLink,
				navigate: () => {
					n("jira:view:jira:clicked", { jiraInstanceUrl: r }), window.open(r, "_blank")?.focus();
				},
				children: "Open Jira"
			})
		]
	}), i && /* @__PURE__ */ G(_f, {
		isOpen: i,
		onClose: () => o(!1),
		linkIssueQuietly: c,
		conversationContext: e,
		jiraInstanceUrl: r,
		hasSortIssueTypeByLabelEnabled: b
	})] });
}, Sf = [
	{
		key: "jiraSiteUrl",
		label: "Jira site URL",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "enableRemoveAllLinks",
		label: "Enable the \"Remove all links\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showDanglingLinks",
		label: "Show unresolved links to Jira issues",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableCreateIssue",
		label: "Enable the \"Create issue\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "enableSortIssueTypeByLabel",
		label: "Enable to sort the issue types by label",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	}
], Cf = (e) => {
	let t = yf(e);
	return typeof t != "string" || t;
}, wf = Pe(Sf), Tf = "JIRA", Ef = {
	enabled: !1,
	name: "",
	jiraSiteUrl: "",
	enableRemoveAllLinks: !1,
	showDanglingLinks: !1,
	enableCreateIssue: !0,
	enableSortIssueTypeByLabel: !1
}, Df = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i }) => {
	let a = !e, o = gl({
		mode: "onChange",
		defaultValues: Ef
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = He({
		integrationId: e,
		integrationType: Tf,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: m, error: h, isWidgetUnknown: g, refetch: S } = Ue({
		integrationId: e,
		fieldDefinitions: Sf,
		form: o,
		onMisconfigured: p
	}), C = (e) => ye(e, {
		fieldDefinitions: Sf,
		isCreationMode: a,
		create: s,
		update: c
	}), w = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: C,
		error: h ?? d,
		onRetry: h ? S : void 0,
		isLoading: u || m,
		isWidgetUnknown: g,
		children: [
			f && /* @__PURE__ */ G(se, { cause: f }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "jiraSiteUrl",
						label: wf.jiraSiteUrl,
						control: o.control,
						rules: { validate: (e) => Cf(e) },
						componentProps: {
							placeholder: "Insert your Jira site URL, e.g. \"https://your-site.atlassian.net/\"",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: wf.enableRemoveAllLinks,
						children: /* @__PURE__ */ G(X, {
							name: "enableRemoveAllLinks",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: wf.showDanglingLinks,
						children: /* @__PURE__ */ G(X, {
							name: "showDanglingLinks",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: wf.enableCreateIssue,
						children: /* @__PURE__ */ G(X, {
							name: "enableCreateIssue",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: wf.enableSortIssueTypeByLabel,
						children: /* @__PURE__ */ G(X, {
							name: "enableSortIssueTypeByLabel",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!a && e && /* @__PURE__ */ G(ce, {
					configuration: t,
					integrationId: e,
					integrationType: Tf,
					label: "Authorize with OAuth"
				})
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: Tf,
				integrationId: e,
				widgetName: w,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => l(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ K(v, {
					gap: "400",
					children: [/* @__PURE__ */ G(x, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ K(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									Tf,
									" integration, all links between Dixa and ",
									Tf,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"All data in ",
								Tf,
								" stays untouched."
							] }),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								Tf,
								" ",
								"integration \"",
								w,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-klaviyo/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
function Of({ query: e, options: t, delayMs: n }) {
	let { useLazyQuery: r } = B(), [i, a] = U([]), [o] = r(e, t), [s, c] = U([]);
	return H(() => () => {
		s.forEach((e) => window.clearTimeout(e));
	}, []), [async (e) => {
		let t = [];
		for (let [r, i] of e.entries()) {
			r !== 0 && await new Promise((e) => {
				let t = setTimeout(e, n);
				c([...s, t]);
			});
			let e = await o({ variables: i });
			t.push(e);
		}
		a(t);
	}, i];
}
var kf = /* @__PURE__ */ function(e) {
	return e.List = "list", e;
}({}), Af = /* @__PURE__ */ function(e) {
	return e.Profile = "profile", e;
}({}), jf = /* @__PURE__ */ function(e) {
	return e.Subscribed = "SUBSCRIBED", e;
}({}), Mf = /* @__PURE__ */ function(e) {
	return e.Unsubscribed = "UNSUBSCRIBED", e;
}({}), Nf = {
	"\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getLists"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_lists"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetListListResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "attributes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "created"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "updated"
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "links"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "self"
																		}
																	}]
																}
															}
														]
													}
												}, {
													kind: "Field",
													name: {
														kind: "Name",
														value: "links"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "self"
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "ClientErrorResponseFragment"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "Klaviyo_ClientError_response"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "errors"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "id"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "code"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "title"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "detail"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "source"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "pointer"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "parameter"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "ServerErrorResponseFragment"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "Klaviyo_ServerError_response"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "errors"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "id"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "code"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "title"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "detail"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "source"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "pointer"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "parameter"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "subscribeProfileToChannel"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "attributes"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input"
							}
						}
					}
				}, {
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "relationships"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "bulk_subscribe_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "ObjectValue",
										fields: [{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "data"
											},
											value: {
												kind: "ObjectValue",
												fields: [
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "type"
														},
														value: {
															kind: "EnumValue",
															value: "profile_subscription_bulk_create_job"
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "attributes"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "attributes"
															}
														}
													},
													{
														kind: "ObjectField",
														name: {
															kind: "Name",
															value: "relationships"
														},
														value: {
															kind: "Variable",
															name: {
																kind: "Name",
																value: "relationships"
															}
														}
													}
												]
											}
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ClientError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ClientErrorResponseFragment"
												}
											}]
										}
									}, {
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ServerError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ServerErrorResponseFragment"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "unsubscribeProfileByContact"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "attributes"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "bulk_unsubscribe_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "ObjectValue",
										fields: [{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "data"
											},
											value: {
												kind: "ObjectValue",
												fields: [{
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "type"
													},
													value: {
														kind: "EnumValue",
														value: "profile_subscription_bulk_delete_job"
													}
												}, {
													kind: "ObjectField",
													name: {
														kind: "Name",
														value: "attributes"
													},
													value: {
														kind: "Variable",
														name: {
															kind: "Name",
															value: "attributes"
														}
													}
												}]
											}
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ClientError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ClientErrorResponseFragment"
												}
											}]
										}
									}, {
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Klaviyo_ServerError_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "ServerErrorResponseFragment"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "GetEventResponseFragment"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "data"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "id"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "type"
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "attributes"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "timestamp"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "event_properties"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getEvents"
				},
				variableDefinitions: [
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "receivedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "openedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "clickedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "bouncedEmailEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "receivedSmsEventsFilter"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "String"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "pageSize"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Klaviyo_PositiveInt"
								}
							}
						}
					}
				],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "receivedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "receivedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "openedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "openedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "clickedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "clickedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "bouncedEmail"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "bouncedEmailEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								},
								{
									kind: "Field",
									alias: {
										kind: "Name",
										value: "receivedSms"
									},
									name: {
										kind: "Name",
										value: "get_events"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "filter"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "receivedSmsEventsFilter"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "sort"
											},
											value: {
												kind: "EnumValue",
												value: "_datetime"
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "pageSize"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "GetEventResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ClientError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ClientErrorResponseFragment"
														}
													}]
												}
											},
											{
												kind: "InlineFragment",
												typeCondition: {
													kind: "NamedType",
													name: {
														kind: "Name",
														value: "Klaviyo_ServerError_response"
													}
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "FragmentSpread",
														name: {
															kind: "Name",
															value: "ServerErrorResponseFragment"
														}
													}]
												}
											}
										]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "GetEventResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_GetEventResponseCollectionCompoundDocument"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "data"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "type"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "attributes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "timestamp"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "event_properties"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getFlowMessage"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "messageId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_flow_message"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "messageId"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "type"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "attributes"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "definition"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "InlineFragment",
																				typeCondition: {
																					kind: "NamedType",
																					name: {
																						kind: "Name",
																						value: "Klaviyo_FlowEmail"
																					}
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "preview_text"
																						}
																					}]
																				}
																			}]
																		}
																	}]
																}
															}
														]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getMetrics"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_metrics"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetMetricResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getProfileByFilter"
				},
				variableDefinitions: [
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "emailFilter"
							}
						},
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "phoneNumberFilter"
							}
						},
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "hasEmail"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Boolean"
								}
							}
						}
					},
					{
						kind: "VariableDefinition",
						variable: {
							kind: "Variable",
							name: {
								kind: "Name",
								value: "hasPhoneNumber"
							}
						},
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Boolean"
								}
							}
						}
					}
				],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								alias: {
									kind: "Name",
									value: "profileByEmail"
								},
								name: {
									kind: "Name",
									value: "get_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "filter"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "emailFilter"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "IntValue",
										value: "1"
									}
								}],
								directives: [{
									kind: "Directive",
									name: {
										kind: "Name",
										value: "include"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "if"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "hasEmail"
											}
										}
									}]
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetProfileResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}, {
								kind: "Field",
								alias: {
									kind: "Name",
									value: "profileByPhoneNumber"
								},
								name: {
									kind: "Name",
									value: "get_profiles"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "filter"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "phoneNumberFilter"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "IntValue",
										value: "1"
									}
								}],
								directives: [{
									kind: "Directive",
									name: {
										kind: "Name",
										value: "include"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "if"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "hasPhoneNumber"
											}
										}
									}]
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetProfileResponseCollectionCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getProfileById"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "profileId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_profile"
								},
								arguments: [
									{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "id"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "profileId"
											}
										}
									},
									{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_"
										},
										value: {
											kind: "ListValue",
											values: [
												{
													kind: "EnumValue",
													value: "subscriptions"
												},
												{
													kind: "EnumValue",
													value: "properties"
												},
												{
													kind: "EnumValue",
													value: "predictive_analytics"
												}
											]
										}
									},
									{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_"
										},
										value: {
											kind: "ListValue",
											values: [{
												kind: "EnumValue",
												value: "subscriptions"
											}, {
												kind: "EnumValue",
												value: "predictive_analytics"
											}]
										}
									}
								],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetProfileResponseCompoundDocument"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "email"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "marketing"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "consent"
																								}
																							}]
																						}
																					}]
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "sms"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "marketing"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "consent"
																								}
																							}]
																						}
																					}]
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "properties"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "predictive_analytics"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "average_order_value"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "churn_probability"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "predicted_clv"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "historic_clv"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "total_clv"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "historic_number_of_orders"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "predicted_number_of_orders"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "average_days_between_orders"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "expected_date_of_next_order"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "ranked_channel_affinity"
																					}
																				}
																			]
																		}
																	}
																]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getListsByProfileId"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "profileId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_lists_for_profile"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "profileId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "ListValue",
										values: [{
											kind: "EnumValue",
											value: "name"
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetListResponseCollection"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	},
	"\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getSegmentsByProfileId"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "profileId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "Klaviyo"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "get_segments_for_profile"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "profileId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_"
									},
									value: {
										kind: "ListValue",
										values: [{
											kind: "EnumValue",
											value: "name"
										}]
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_GetSegmentResponseCollection"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "data"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "attributes"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ClientError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ClientErrorResponseFragment"
													}
												}]
											}
										},
										{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Klaviyo_ServerError_response"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerErrorResponseFragment"
													}
												}]
											}
										}
									]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ClientErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ClientError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerErrorResponseFragment"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Klaviyo_ServerError_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "errors"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "code"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "title"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "detail"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "source"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pointer"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "parameter"
											}
										}]
									}
								}
							]
						}
					}]
				}
			}
		]
	}
};
function Pf(e) {
	return Nf[e] ?? {};
}
Pf("\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n");
var Ff = Pf("\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), If = Pf("\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Lf = Pf("\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Rf = Pf("\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), zf = Pf("\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Bf = Pf("\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Vf = Pf("\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Hf = Pf("\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Uf = Pf("\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n");
function Wf(e) {
	return e?.attributes?.event_properties?.$flow !== void 0;
}
function Gf(e) {
	return Wf(e) && e?.attributes?.event_properties?.$message;
}
function Kf(e) {
	return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function qf(e) {
	let t = e?.attributes?.timestamp;
	if (t) return t;
}
function Jf(e) {
	return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function Yf(e) {
	return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function Xf(e) {
	return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((e) => ({
		...e,
		eventType: "SMS"
	}));
}
function Zf(e) {
	return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function Qf(e) {
	return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function $f(e) {
	return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((e) => ({
		...e,
		eventType: "EMAIL"
	}));
}
function ep(e) {
	return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function tp(e) {
	return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function np(e) {
	try {
		return JSON.parse(JSON.stringify(e));
	} catch {
		return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
	}
}
var rp = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function ip(e) {
	return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function ap(e) {
	return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function op({ profileId: e, noOfMessagesToShow: t }) {
	let { useLazyQuery: n, useQuery: r } = B(), { track: i } = Ve(), [a, o] = U(null), [s, c] = U(null), [l, u] = U(null), [d, f] = U(null), [p, m] = U(null), [h, g] = U([]), { data: _, error: v, loading: y, networkStatus: b } = r(Lf, {
		fetchPolicy: "network-only",
		nextFetchPolicy: "cache-first",
		notifyOnNetworkStatusChange: !0
	}), [x, { data: S, error: C, loading: w, networkStatus: T }] = n(Ff, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	return H(() => {
		if (_ && !y && b === st.ready) {
			let e = Jf(_);
			o(e.find((e) => e?.attributes?.name === "Received Email")?.id || null), c(e.find((e) => e?.attributes?.name === "Opened Email")?.id || null), u(e.find((e) => e?.attributes?.name === "Clicked Email")?.id || null), f(e.find((e) => e?.attributes?.name === "Bounced Email")?.id || null), m(e.find((e) => e?.attributes?.name === "Received Text Message")?.id || null);
		} else o(null), c(null), u(null), f(null), m(null);
	}, [_]), H(() => {
		a && s && l && d && p && !w && T === st.ready ? x({ variables: {
			receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${a}")`,
			openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${s}")`,
			clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
			bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${d}")`,
			receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${p}")`,
			pageSize: t
		} }) : g([]);
	}, [
		a,
		s,
		l,
		d,
		p
	]), H(() => {
		if (!w && S) {
			let e = Yf(S), n = Zf(S).map((e) => e?.attributes?.event_properties.$message), r = Qf(S).map((e) => e?.attributes?.event_properties.$message);
			e.forEach((e) => {
				let t = e.attributes?.event_properties.$message;
				e.opened = n.includes(t), e.clicked = r.includes(t);
			});
			let a = Xf(S), o = $f(S), s = [
				...e,
				...o,
				...a
			].sort((e, t) => {
				let n = qf(e), r = qf(t);
				return n == null && r == null ? 0 : n == null ? 1 : r == null ? -1 : r - n;
			}).slice(0, t);
			g(s);
			let c = s.map((e) => e.id);
			i("klaviyo:messages:received", {
				emailsReceived: e.filter((e) => c.includes(e.id)).length,
				emailsBounced: o.filter((e) => c.includes(e.id)).length,
				smsReceived: a.filter((e) => c.includes(e.id)).length,
				total: c.length
			});
		} else g([]);
	}, [w, S]), Qe(() => ({
		receivedMessages: h,
		isLoading: y || w,
		error: v || C
	}), [
		h,
		y,
		w,
		v,
		C
	]);
}
function sp({ profileId: e }) {
	let { useQuery: t } = B(), [n, r] = U(), [i, a] = U(), { data: o, error: s, loading: c, refetch: l } = t(zf, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		variables: { profileId: e }
	});
	H(() => {
		s && a(s);
	}, [s]), H(() => {
		!c && o && r(o.Klaviyo.get_profile);
	}, [c, o]);
	let u = async () => {
		let e = await l();
		e.error ? a(e.error) : e.data && r(e.data.Klaviyo.get_profile);
	};
	return Qe(() => ({
		profile: n,
		refetchProfile: u,
		isLoading: c,
		error: i
	}), [
		n,
		c,
		i
	]);
}
function cp({ email: e, phoneNumber: t }) {
	let { track: n } = Ve(), { useLazyQuery: r } = B(), [i, a] = U(), [o, s] = U(), [c, { data: l, error: u, loading: d }] = r(Rf, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	H(() => {
		if (!d && l) {
			let e = l.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && l.Klaviyo.profileByEmail || void 0, t = l.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && l.Klaviyo.profileByPhoneNumber || void 0;
			f(e, t);
		}
	}, [d, l]);
	let f = (r, i) => {
		let o = r?.data?.length === 1 && r.data[0]?.id || void 0, c = i?.data?.length === 1 && i.data[0]?.id || void 0, l = o || c, u = !o || !c || o === c;
		if (l && u) {
			a(o || c), n("klaviyo:profile:received", { hasProfile: !0 });
			return;
		}
		a(void 0), n("klaviyo:profile:received", { hasProfile: !1 }), u || s(/* @__PURE__ */ Error(`Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${o}) and phone number ${t} (profile ID ${c}).`));
	};
	return Qe(() => ({
		profileId: i,
		getProfileId: c,
		isLoading: d,
		error: u || o
	}), [
		i,
		c,
		d,
		u,
		o
	]);
}
var lp = 800, up = {
	min: 800,
	max: 1200
}, dp = 3, fp = 1.5, pp = ({ query: e, delay: t, delayRange: n, maxCount: r = dp, useDelayRange: i = !1 }) => {
	let a = (e) => Math.floor(Math.random() * (e.max - e.min) + e.min), [o, s] = U(0), [c, l] = U(t || lp), [u, d] = U(n || up), [f, p] = U(!1), [m, h] = U(!1), g = i || !!n, _ = g ? a(u) : t || lp, [v, y] = U(_);
	su(async () => {
		let t = o + 1, n = fp ** t;
		s(t), y((g ? a(u) : c) * n), await e().then(() => {
			h(!0), S();
		});
	}, f ? v : null), lu(() => S());
	let b = Ye(() => {
		s(0), y(_);
	}, [_]), x = Ye((e = {}) => {
		let { delay: t, delayRange: n } = e;
		h(!1), b(), n && (d(n), y(a(n))), t && (l(t), y(t)), p(!0);
	}, [b]), S = Ye(() => {
		p(!1), b();
	}, [b]);
	return H(() => {
		o >= r && S();
	}, [
		o,
		r,
		S
	]), Qe(() => ({
		isRunning: f,
		isSuccessful: m,
		start: x,
		stop: S
	}), [
		f,
		m,
		x,
		S
	]);
}, mp = (e) => {
	let t = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
	return t ? parseInt(t, 10) : void 0;
}, hp = (e) => ({
	min: e * 1e3,
	max: e * 1e3 + 500
});
function gp({ profileId: e, query: t }) {
	let { useQuery: n } = B(), [r, i] = U(), [a, o] = U(), { data: s, error: c, loading: l, refetch: u, networkStatus: d } = n(t === "lists" ? Bf : Vf, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		variables: { profileId: e }
	}), { isRunning: f, start: p, stop: m } = pp({
		query: u,
		useDelayRange: !0
	}), h = l || f;
	return H(() => {
		if (c) if (we({ errors: c.graphQLErrors })) {
			if (!f) {
				let e = mp(c);
				p({ ...e && { delayRange: hp(e) } });
			}
		} else o(c);
	}, [c]), H(() => {
		if (!l && s?.Klaviyo) {
			let e = {}, n = {};
			t === "lists" && (e = s?.Klaviyo?.get_lists_for_profile), t === "segments" && (n = s?.Klaviyo?.get_segments_for_profile), (e?.data || n?.data) && (m(), i((t === "lists" ? e?.data : n?.data)?.map((e) => ({
				...e,
				type: t === "lists" ? "list" : "segment"
			}))));
		}
	}, [l, s]), Qe(() => ({
		listsOrSegments: r,
		refetchListOrSegments: p,
		isLoading: h,
		error: a,
		networkStatus: d
	}), [
		r,
		h,
		a,
		d,
		p
	]);
}
var _p = { notificationText: "_notificationText_1polx_1" }, vp = ({ error: e }) => {
	let { track: t } = Ve(), n = e;
	if (dt(e)) {
		let r = e.graphQLErrors, i = r.length === 1 && Ee({ error: r[0] }), a = r.length === 1 && Oe({ error: r[0] });
		if (i) t("klaviyo:profile:failed", { reason: "Invalid access token" }), n = /* @__PURE__ */ Error("It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator.");
		else if (a) t("klaviyo:profile:failed", { reason: "Insufficient permissions" }), n = /* @__PURE__ */ Error("You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration.");
		else return t("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ G(z, { error: e });
	}
	return /* @__PURE__ */ G(v, {
		margin: "0 0 300",
		children: /* @__PURE__ */ G(E.Item, {
			contentLeft: /* @__PURE__ */ G(x, {
				color: "red.500",
				size: 20,
				name: "exclamation-triangle-filled"
			}),
			titleSecondary: n.message,
			title: "Unable to show Klaviyo profile data",
			variant: "dense"
		})
	});
}, yp = Ws, bp = {
	message: "_message_zrl8q_54",
	messageIsOpen: "_messageIsOpen_zrl8q_62",
	messageHeader: "_messageHeader_zrl8q_65",
	messageUnattended: "_messageUnattended_zrl8q_68",
	messageLabel: "_messageLabel_zrl8q_71",
	messageText: "_messageText_zrl8q_74"
}, xp = ({ event: e, isLoadingPreview: t }) => {
	let n = e?.attributes?.event_properties, r = e.flowMessage && tp(e.flowMessage);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
		flexDirection: "column",
		justifyContent: "space-between",
		gap: "100",
		children: [/* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			className: bp.messageLabel,
			children: "Campaign name"
		}), /* @__PURE__ */ G(L.Paragraph, { children: n["Campaign Name"] })]
	}), t ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "100",
		children: /* @__PURE__ */ G(P, { size: 22 })
	}) : r && r.length > 0 && /* @__PURE__ */ K(v, {
		flexDirection: "column",
		justifyContent: "space-between",
		gap: "100",
		children: [/* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			className: bp.messageLabel,
			children: "Preview text"
		}) }), /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			className: bp.messageText,
			children: r
		})]
	})] });
}, Sp = ({ event: e }) => {
	let t = e?.attributes?.event_properties;
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
		flexDirection: "column",
		justifyContent: "space-between",
		gap: "100",
		children: [/* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(L.Heading, {
			variant: "heading-4",
			children: "Message"
		}) }), /* @__PURE__ */ G(v, { children: t?.extra?.["Message Body"] })]
	}) });
}, Cp = ({ event: e, isLoadingPreview: t, openByDefault: r }) => {
	let [i, a] = U(r), { attributes: o, eventType: s } = e, c = o?.datetime, u = o?.timestamp, d = "DD MMM YYYY @ HH:mm", f = Qe(() => () => c ? yp(c).format(d) : u ? yp.unix(u).format(d) : null, [u, c])(), p = s === "EMAIL", m = s === "SMS", h = p && e.opened, g = p && e.clicked, _ = p && o?.event_properties.Subject, y = m && o?.event_properties["Message Name"], b = p ? "mail" : "sms";
	return /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		className: ht(bp.message, { [bp.messageIsOpen]: i }),
		children: [/* @__PURE__ */ K(v, {
			alignItems: "center",
			justifyContent: "space-between",
			className: bp.messageHeader,
			onClick: () => a(!i),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [
					/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ G(x, {
								size: 16,
								name: b
							}),
							" ",
							rp(s),
							f && /* @__PURE__ */ G(n, {
								size: "small",
								variant: "info",
								children: f
							})
						]
					}),
					_ && _,
					y && y
				]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: i ? "angle-up" : "angle-down"
			})]
		}), i && /* @__PURE__ */ K(v, {
			flexDirection: "column",
			gap: "300",
			children: [
				/* @__PURE__ */ G(l, {}),
				Kf(e) && /* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(n, {
					size: "medium",
					variant: "error",
					children: "Bounced"
				}) }),
				p && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
					gap: "200",
					flexDirection: "row",
					flexWrap: "wrap",
					children: [/* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ G(x, {
								size: 16,
								color: h ? "green.400" : "red.400",
								name: h ? "check-circle-filled" : "close-circle-filled"
							}),
							" ",
							"Opened"
						]
					}) }), /* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ G(x, {
								size: 16,
								color: g ? "green.400" : "red.400",
								name: g ? "check-circle-filled" : "close-circle-filled"
							}),
							" ",
							"Clicked"
						]
					}) })]
				}), /* @__PURE__ */ G(xp, {
					event: e,
					isLoadingPreview: t
				})] }),
				m && /* @__PURE__ */ G(Sp, { event: e })
			]
		})]
	});
}, wp = {
	fetchPolicy: "no-cache",
	notifyOnNetworkStatusChange: !0
}, Tp = ({ profileId: e, noOfMessagesToShow: t }) => {
	let [n, r] = U(!1), { receivedMessages: i, isLoading: a, error: o } = op({
		profileId: e,
		noOfMessagesToShow: t
	}), [s, c] = Of({
		query: If,
		options: wp,
		delayMs: 1e3
	}), [l, u] = U([]);
	H(() => {
		if (i.length > 0) {
			u(i);
			let e = i.filter((e) => Wf(e)).map((e) => Gf(e));
			e.length > 0 && (r(!0), s(e.map((e) => ({ messageId: e }))).finally(() => r(!1)));
		}
	}, [i]), H(() => {
		c.length > 0 && u(i?.map((e) => {
			if (e.eventType === "EMAIL" && Wf(e) && !e.flowMessage) {
				let t = Gf(e), n = c.find((e) => (e.data && ep(e.data))?.id === t), r = n?.data && ep(n.data);
				if (r) return {
					...np(e),
					flowMessage: r
				};
			}
			return e;
		}));
	}, [c]);
	let d = [];
	return o && d.push(o), c.length > 0 && d.push(...c.map((e) => e.error).filter((e) => e)), d && d.length > 0 ? /* @__PURE__ */ G(W, { children: d.map((e, t) => e.graphQLErrors ? /* @__PURE__ */ G(z, { error: e }, `lastMessagesError${t}`) : /* @__PURE__ */ G(vp, { error: e }, `lastMessagesError${t}`)) }) : /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(L.Heading, {
		variant: "heading-3",
		children: "Messages"
	}), a ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: /* @__PURE__ */ G(P, {})
	}) : /* @__PURE__ */ G(W, { children: l?.length > 0 ? /* @__PURE__ */ G(v, {
		gap: "200",
		flexDirection: "column",
		children: l.map((e, t) => /* @__PURE__ */ G(Cp, {
			event: e,
			isLoadingPreview: n,
			openByDefault: t === 0
		}, e.id))
	}) : /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200",
		className: _p.notificationText,
		children: "No messages found for the profile"
	}) })] });
}, Ep = {
	list: "_list_ld0hf_1",
	listItem: "_listItem_ld0hf_4"
}, Dp = ({ profile: e }) => {
	let t = e?.data?.attributes?.properties, n = Object.entries(t ?? {}).filter(([e, t]) => e !== "__typename" && t != null), r = n.length > 0;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Custom properties"
			}),
			!r && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No custom properties available"
			}),
			r && /* @__PURE__ */ G(E, {
				className: Ep.list,
				children: n.map(([e, t]) => typeof t == "boolean" || typeof t == "string" || typeof t == "number" || Array.isArray(t) && t.every((e) => typeof e == "string") ? /* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ep.listItem,
					children: /* @__PURE__ */ K(v, {
						justifyContent: "space-between",
						alignItems: "flex-start",
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: Te(e)
						}), /* @__PURE__ */ G(v, {
							style: {
								flex: 1,
								minWidth: 0
							},
							justifyContent: "flex-end",
							children: ge(t)
						})]
					})
				}, e) : null)
			})
		]
	});
}, Op = ({ profileId: e, type: t }) => {
	let [n, r] = U(!1), { listsOrSegments: i, error: o, isLoading: s, networkStatus: c, refetchListOrSegments: l } = gp({
		profileId: e,
		query: t
	});
	H(() => {
		c === 4 && r(!0);
	}, [c]);
	let u = () => {
		i || l();
	}, d = i || [];
	return o ? /* @__PURE__ */ G(vp, { error: o }) : s ? /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: Ep.listItem,
		children: /* @__PURE__ */ G(P, { size: 14 })
	}, "loading") : d.length > 0 ? /* @__PURE__ */ G(W, { children: d.map(({ attributes: e, type: t }, n) => /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: Ep.listItem,
		children: /* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				children: e?.name
			}), !!t && /* @__PURE__ */ G(I, { children: me(t) })]
		})
	}, n)) }) : n && !i ? /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: Ep.listItem,
		children: /* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ K(v, {
				gap: "200",
				children: [/* @__PURE__ */ G(x, {
					name: "exclamation-triangle-filled",
					color: "red"
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					color: "red.500",
					children: [t === "lists" ? "Lists" : "Segments", " could not be loaded"]
				})]
			}), /* @__PURE__ */ G(R, {
				content: "Refresh lists and segments",
				children: /* @__PURE__ */ G(a, {
					icon: "sync",
					variant: "secondary",
					onClick: () => u(),
					children: "Retry"
				})
			})]
		})
	}, "refetch") : /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: Ep.listItem,
		children: /* @__PURE__ */ G(v, {
			justifyContent: "space-between",
			alignItems: "center",
			children: /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				subdued: !0,
				children: /* @__PURE__ */ G("i", { children: `No ${t === "lists" ? "lists" : "segments"} available` })
			})
		})
	}, "refetch");
}, kp = .7, Ap = .3, jp = (e) => e >= kp ? {
	variant: "error",
	label: "High risk"
} : e >= Ap ? {
	variant: "warning",
	label: "Medium risk"
} : {
	variant: "success",
	label: "Low risk"
}, Mp = (e) => /* @__PURE__ */ G(L.Paragraph, {
	as: "span",
	variant: "4",
	children: e.toFixed(2)
}), Np = (e) => {
	let t = jp(e);
	return /* @__PURE__ */ K(v, {
		alignItems: "center",
		gap: "100",
		children: [/* @__PURE__ */ G(n, {
			size: "small",
			variant: t.variant,
			children: t.label
		}), /* @__PURE__ */ G(L.Paragraph, {
			as: "span",
			variant: "4",
			children: `${(e * 100).toFixed(1)}%`
		})]
	});
}, Pp = (e) => {
	let t = e?.data?.attributes?.predictive_analytics ?? null;
	if (!t) return [];
	let n = [
		["Average order value", t.average_order_value],
		["Historic lifetime value", t.historic_clv],
		["Predicted lifetime value", t.predicted_clv],
		["Total lifetime value", t.total_clv]
	], r = [
		["Historic orders", t.historic_number_of_orders],
		["Predicted orders", t.predicted_number_of_orders],
		["Average days between orders", t.average_days_between_orders],
		["Expected next order", t.expected_date_of_next_order]
	], i = t.churn_probability, a = t.ranked_channel_affinity?.filter(Boolean) ?? null;
	return [
		...n.flatMap(([e, t]) => t ? [{
			label: e,
			content: Mp(t)
		}] : []),
		...r.flatMap(([e, t]) => t ? [{
			label: e,
			content: ge(t)
		}] : []),
		...i ? [{
			label: "Churn probability",
			content: Np(i)
		}] : [],
		...a?.length ? [{
			label: "Channel affinity",
			content: ge(a)
		}] : []
	];
}, Fp = ({ profile: e }) => {
	let t = Pp(e);
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Predictive analytics"
			}),
			t.length === 0 && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				align: "center",
				children: "No predictive analytics available"
			}),
			t.length > 0 && /* @__PURE__ */ G(E, {
				className: Ep.list,
				children: t.map(({ label: e, content: t }) => /* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: Ep.listItem,
					children: /* @__PURE__ */ K(v, {
						justifyContent: "space-between",
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							as: "span",
							variant: "4",
							children: e
						}), t]
					})
				}, e))
			})
		]
	});
}, Ip = {
	tagHover: "_tagHover_kzbzk_1",
	channelUnsubscribed: "_channelUnsubscribed_kzbzk_6"
}, Lp = ({ isSubscribed: e, isLoading: t, channelName: n, channelIcon: r, hasReSubscriptionFeature: i, handleAction: a }) => {
	let o = e ? "Unsubscribe" : "Subscribe", s = !e && !i;
	return /* @__PURE__ */ G(R, {
		content: s ? "You have to select a resubscription list in the settings." : o,
		children: /* @__PURE__ */ G(I, {
			className: Ip.tagHover,
			color: e ? "green.500" : "neutral.200",
			children: /* @__PURE__ */ K(v, {
				"data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
				gap: "200",
				alignItems: "center",
				className: ht({ [Ip.channelUnsubscribed]: !e || s }),
				onClick: () => {
					s || a();
				},
				children: [t ? /* @__PURE__ */ G(P, { size: 16 }) : /* @__PURE__ */ G(x, {
					size: 16,
					name: r
				}), n]
			})
		})
	});
}, Rp = { subscriptionError: "_subscriptionError_1qhhx_1" }, zp = ({ subscriptionListId: e, profile: t, email: n, phoneNumber: r, profileId: i, refetchProfile: a }) => {
	let [o, s] = U(!1), [c, l] = U(!1), [u, d] = U(), { track: f } = Ve(), [p, m] = cu({
		channel: null,
		request: null
	}), h = ip(t), g = ap(t), _ = !!e, { useMutation: y } = B(), [b] = y(Hf), [x] = y(Uf), S = (t) => {
		f("klaviyo:profile:subscribe:clicked", { channel: t }), m.setAll({
			channel: t,
			request: "subscribed"
		}), ((t) => b({ variables: {
			attributes: {
				custom_source: "Dixa integration",
				profiles: { data: [{
					type: Af.Profile,
					id: i,
					attributes: {
						email: n,
						...r ? { phone_number: r } : {},
						subscriptions: {
							...t === "EMAIL" && { email: { marketing: { consent: jf.Subscribed } } },
							...t === "SMS" && { sms: { marketing: { consent: jf.Subscribed } } }
						}
					}
				}] }
			},
			relationships: { list: { data: {
				type: kf.List,
				id: e
			} } }
		} }))(t).then((e) => w({
			channel: t,
			mutationResponse: e,
			isSubscriptionRequest: !0
		})).catch((e) => w({
			channel: t,
			mutationErrorResponse: e,
			isSubscriptionRequest: !0
		}));
	}, C = (e) => {
		f("klaviyo:profile:unsubscribe:clicked", { channel: e }), m.setAll({
			channel: e,
			request: "unsubscribed"
		}), x({ variables: { attributes: { profiles: { data: [{
			type: Af.Profile,
			attributes: {
				...e === "EMAIL" ? { email: n } : {},
				...e === "SMS" ? { phone_number: r } : {},
				subscriptions: {
					...e === "EMAIL" && { email: { marketing: { consent: Mf.Unsubscribed } } },
					...e === "SMS" && { sms: { marketing: { consent: Mf.Unsubscribed } } }
				}
			}
		}] } } } }).then((t) => w({
			channel: e,
			mutationResponse: t,
			isSubscriptionRequest: !1
		})).catch((t) => w({
			channel: e,
			mutationErrorResponse: t,
			isSubscriptionRequest: !1
		}));
	}, w = async ({ channel: e, mutationResponse: t, mutationErrorResponse: n, isSubscriptionRequest: r }) => {
		let i = n?.networkError, o = i ? i?.statusCode : NaN, c = t?.errors, u = !!c && Ce({ errors: c });
		o === 202 ? (f(r ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded", { channel: e }), await a()) : u ? (f(r ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed", {
			channel: e,
			reason: "Insufficient permissions"
		}), d(`Request failed with a permission error. Could not ${r ? "opt-in" : "opt-out"}.`)) : (f(r ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed", {
			channel: e,
			reason: i?.message || "Unexpected error"
		}), d(`Request failed. Could not ${r ? "opt-in" : "opt-out"}.`)), l(!1), s(!1);
	};
	return H(() => {
		if (p.request === "subscribed") {
			let e = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${p.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
			p.channel === "EMAIL" && !o && t?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (d(e), m.reset()), p.channel === "SMS" && !c && t?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (d(e), m.reset());
		}
	}, [
		t?.data?.attributes?.subscriptions?.email?.marketing?.consent,
		t?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
		o,
		c
	]), /* @__PURE__ */ G(v, {
		"data-testid": "subscription-channels",
		gap: "200",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Subscription channels"
				}),
				/* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(Lp, {
						"data-testid": "subscription-channels-email-button",
						isLoading: o,
						isSubscribed: h,
						channelName: "Email",
						channelIcon: "mail",
						hasReSubscriptionFeature: _,
						handleAction: () => {
							s(!0), d(void 0), h ? C("EMAIL") : S("EMAIL");
						}
					}), /* @__PURE__ */ G(Lp, {
						"data-testid": "subscription-channels-sms-button",
						isLoading: c,
						isSubscribed: g,
						channelName: "Sms",
						channelIcon: "sms",
						hasReSubscriptionFeature: _,
						handleAction: () => {
							l(!0), d(void 0), g ? C("SMS") : S("SMS");
						}
					})]
				}),
				u && /* @__PURE__ */ G(v, {
					className: Rp.subscriptionError,
					children: u
				})
			]
		})
	});
}, Bp = ({ profileId: e, email: t, phoneNumber: n, showProfileLists: r, showProfileSegments: i, showSubscriptions: a, showCustomProperties: o, showPredictiveAnalytics: s, noOfMessagesToShow: c, subscriptionListId: l }) => {
	let { profile: u, error: d, isLoading: f, refetchProfile: p } = sp({ profileId: e });
	return d ? /* @__PURE__ */ G(vp, { error: d }) : f ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: /* @__PURE__ */ G(P, {})
	}) : !u && !f ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200",
		className: _p.notificationText,
		children: "No Klaviyo profile data found"
	}) : /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "300",
		margin: "200 0 300",
		children: [
			(r || i) && /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Lists & Segments"
				}), /* @__PURE__ */ K(E, {
					className: Ep.list,
					children: [r && /* @__PURE__ */ G(Op, {
						profileId: e,
						type: "lists"
					}), i && /* @__PURE__ */ G(Op, {
						profileId: e,
						type: "segments"
					})]
				})]
			}),
			u && e && a && /* @__PURE__ */ G(zp, {
				profile: u,
				profileId: e,
				subscriptionListId: l,
				refetchProfile: p,
				email: t,
				phoneNumber: n
			}),
			u && s && /* @__PURE__ */ G(Fp, { profile: u }),
			u && o && /* @__PURE__ */ G(Dp, { profile: u }),
			/* @__PURE__ */ G(Tp, {
				profileId: e,
				noOfMessagesToShow: c
			})
		]
	});
}, Vp = ({ conversationContext: e, settings: t }) => {
	let n = e.customer?.email || void 0, r = e.customer?.phone_number || void 0, i = t?.showProfileLists, a = t?.showProfileSegments, o = t?.showSubscriptions, s = t?.showCustomProperties, c = t?.showPredictiveAnalytics, l = Number(t?.noOfMessagesToShow), u = t?.subscriptionListId, { profileId: d, getProfileId: f, isLoading: p, error: m } = cp({
		email: n,
		phoneNumber: r
	});
	return Ze(() => {
		(n || r) && f({ variables: {
			emailFilter: n ? `equals(email,"${n}")` : void 0,
			phoneNumberFilter: r ? `equals(phone_number,"${r}")` : void 0,
			hasEmail: !!n,
			hasPhoneNumber: !!r
		} });
	}, [n, r]), !n && !r ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: "The customer does not have an email nor a phone number"
	}) : p ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "0 0 300 0",
		children: /* @__PURE__ */ G(P, {})
	}) : m ? /* @__PURE__ */ G(vp, { error: m }) : d ? /* @__PURE__ */ G(Bp, {
		profileId: d,
		email: n,
		phoneNumber: r,
		showProfileLists: i,
		showProfileSegments: a,
		showSubscriptions: o,
		showCustomProperties: s,
		showPredictiveAnalytics: c,
		noOfMessagesToShow: l,
		subscriptionListId: u
	}) : /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "0 0 300 0",
		className: _p.notificationText,
		children: "No profile ID found"
	});
}, Hp = [
	{
		key: "klaviyoApiKey",
		label: "API key",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "showProfileLists",
		label: "Show Klaviyo lists for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showProfileSegments",
		label: "Show Klaviyo segments for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showSubscriptions",
		label: "Show subscription channels for Klaviyo messages",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "showCustomProperties",
		label: "Show custom properties for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showPredictiveAnalytics",
		label: "Show predictive analytics for a profile",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "subscriptionListId",
		label: "Re-/subscription list",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "noOfMessagesToShow",
		label: "Choose how many messages to show",
		type: "string",
		secret: !1,
		defaultValue: "5"
	}
], Up = [{
	key: "authorizeWithOauth",
	label: "Authorize with OAuth",
	secret: !1,
	type: "custom",
	hideOnCreate: !0,
	component: ce
}], Wp = [{
	key: "klaviyoApiKey",
	label: "API key",
	placeholder: "API key from Klaviyo",
	required: !0,
	secret: !0,
	type: "input"
}], Gp = Pe(Hp), Kp = [
	{
		value: "3",
		label: "The three latest messages"
	},
	{
		value: "4",
		label: "The four latest messages"
	},
	{
		value: "5",
		label: "The five latest messages"
	}
], qp = ({ control: e, name: t }) => /* @__PURE__ */ G(wl, {
	name: t,
	control: e,
	label: Gp.noOfMessagesToShow,
	rules: { required: "Please choose how many messages to show" },
	componentProps: {
		placeholder: "Select an option",
		equalityFn: (e, t) => e === t,
		getItemTitleByValue: (e) => {
			let t = Kp.find((t) => t.value === e)?.label;
			return t ? /* @__PURE__ */ G(L.Paragraph, { children: t }) : null;
		}
	},
	children: Kp.map((e) => /* @__PURE__ */ G(N.Item, {
		value: e.value,
		children: e.label
	}, e.value))
}), Jp = { settingsWrapper: "_settingsWrapper_eleyu_1" }, Yp = Pf("\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n"), Xp = [], Zp = ({ value: e, onChange: t }) => {
	let { useQuery: n } = B(), [r, i] = U(Xp), [a, o] = U(!!e), { data: s, error: c, loading: l } = n(Yp, {
		skip: !a,
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	return H(() => {
		e && o(!0);
	}, [e]), H(() => {
		let e = s?.Klaviyo?.get_lists;
		if (a && e && !l && !c) {
			let t = e?.data?.map((e) => ({
				value: e?.id,
				label: e?.attributes?.name
			})) || Xp;
			i(t);
		}
	}, [
		a,
		s,
		l,
		c
	]), /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(y, {
		span: 3,
		children: /* @__PURE__ */ K(v, {
			gap: "300",
			flexDirection: "column",
			className: Jp.settingsWrapper,
			children: [
				/* @__PURE__ */ G(_, {
					label: "Activate re-/subscription list selection",
					children: /* @__PURE__ */ G(m, { input: {
						name: "subscriptionListId-switch",
						value: "switchValueFromComponent",
						checked: a,
						onChange: () => {
							let e = !a;
							e || t(""), o(e);
						}
					} })
				}),
				a && c && !l && /* @__PURE__ */ G(_, { children: /* @__PURE__ */ G(z, { error: c }) }),
				a && !c && l && /* @__PURE__ */ G(_, { children: /* @__PURE__ */ G(v, {
					justifyContent: "center",
					margin: "0 0 300 0",
					children: /* @__PURE__ */ G(P, {})
				}) }),
				a && !c && !l && r && /* @__PURE__ */ G(_, {
					label: "Available lists to subscribe to",
					children: /* @__PURE__ */ G(w, {
						required: !0,
						placeholder: "Select a list",
						onChange: (e) => t(e?.selectedValues?.[0]?.value ?? ""),
						getItemTitleByValue: (e) => e ? /* @__PURE__ */ G(L.Paragraph, { children: e.label }) : null,
						value: e ? [{
							label: (r || []).find((t) => t.value === e)?.label,
							value: e
						}] : [],
						equalityFn: (e, t) => e.value === t.value,
						children: r.map((e) => /* @__PURE__ */ G(N.Item, {
							value: e,
							children: e.label
						}, e.value))
					})
				})
			]
		})
	}), /* @__PURE__ */ G(y, { span: 3 })] });
}, Qp = Pe(Hp), $p = "KLAVIYO", em = {
	enabled: !1,
	name: "",
	...Le([], Hp)
}, tm = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i }) => {
	let a = !e, o = gl({
		mode: "onChange",
		defaultValues: em
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = He({
		integrationId: e,
		integrationType: $p,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: m, error: h, isWidgetUnknown: g, refetch: v, widgetConfiguration: x } = Ue({
		integrationId: e,
		fieldDefinitions: Hp,
		form: o,
		onMisconfigured: p
	}), S = a || !!x?.additionalProperties?.isUsingOAuth, C = (e) => ye(e, {
		fieldDefinitions: Hp,
		isCreationMode: a,
		create: s,
		update: c
	}), w = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: C,
		error: h ?? d,
		onRetry: h ? v : void 0,
		isLoading: u || m,
		isWidgetUnknown: g,
		children: [
			f && /* @__PURE__ */ G(se, { cause: f }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!S && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "klaviyoApiKey",
						label: Qp.klaviyoApiKey,
						control: o.control,
						isCreationMode: a,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "API key from Klaviyo",
							autoComplete: "off"
						}
					})
				}), /* @__PURE__ */ G(y, { span: 3 })] }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Qp.showProfileLists,
						children: /* @__PURE__ */ G(X, {
							name: "showProfileLists",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Qp.showProfileSegments,
						children: /* @__PURE__ */ G(X, {
							name: "showProfileSegments",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Qp.showSubscriptions,
						children: /* @__PURE__ */ G(X, {
							name: "showSubscriptions",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Qp.showCustomProperties,
						children: /* @__PURE__ */ G(X, {
							name: "showCustomProperties",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Qp.showPredictiveAnalytics,
						children: /* @__PURE__ */ G(X, {
							name: "showPredictiveAnalytics",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!a && /* @__PURE__ */ G(xc, {
					name: "subscriptionListId",
					control: o.control,
					render: ({ field: e }) => /* @__PURE__ */ G(Zp, {
						value: e.value,
						onChange: e.onChange
					})
				}),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(qp, {
						name: "noOfMessagesToShow",
						control: o.control
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				S && !a && e && /* @__PURE__ */ G(ce, {
					configuration: t,
					integrationId: e,
					integrationType: $p,
					label: "Authorize with OAuth"
				})
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: $p,
				integrationId: e,
				widgetName: w,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => l()
			})
		]
	});
};
//#endregion
//#region ../../../node_modules/comma-separated-tokens/index.js
function nm(e, t) {
	let n = t || {};
	return (e[e.length - 1] === "" ? [...e, ""] : e).join((n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")).trim();
}
//#endregion
//#region ../../../node_modules/estree-util-is-identifier-name/lib/index.js
var rm = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, im = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, am = {};
function om(e, t) {
	return ((t || am).jsx ? im : rm).test(e);
}
//#endregion
//#region ../../../node_modules/hast-util-whitespace/lib/index.js
var sm = /[ \t\n\f\r]/g;
function cm(e) {
	return typeof e == "object" ? e.type === "text" && lm(e.value) : lm(e);
}
function lm(e) {
	return e.replace(sm, "") === "";
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/schema.js
var um = class {
	constructor(e, t, n) {
		this.property = e, this.normal = t, n && (this.space = n);
	}
};
um.prototype.property = {}, um.prototype.normal = {}, um.prototype.space = null;
//#endregion
//#region ../../../node_modules/property-information/lib/util/merge.js
function dm(e, t) {
	let n = {}, r = {}, i = -1;
	for (; ++i < e.length;) Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
	return new um(n, r, t);
}
//#endregion
//#region ../../../node_modules/property-information/lib/normalize.js
function fm(e) {
	return e.toLowerCase();
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/info.js
var pm = class {
	constructor(e, t) {
		this.property = e, this.attribute = t;
	}
};
pm.prototype.space = null, pm.prototype.boolean = !1, pm.prototype.booleanish = !1, pm.prototype.overloadedBoolean = !1, pm.prototype.number = !1, pm.prototype.commaSeparated = !1, pm.prototype.spaceSeparated = !1, pm.prototype.commaOrSpaceSeparated = !1, pm.prototype.mustUseProperty = !1, pm.prototype.defined = !1;
//#endregion
//#region ../../../node_modules/property-information/lib/util/types.js
var mm = /* @__PURE__ */ Ot({
	boolean: () => gm,
	booleanish: () => _m,
	commaOrSpaceSeparated: () => xm,
	commaSeparated: () => bm,
	number: () => Z,
	overloadedBoolean: () => vm,
	spaceSeparated: () => ym
}), hm = 0, gm = Sm(), _m = Sm(), vm = Sm(), Z = Sm(), ym = Sm(), bm = Sm(), xm = Sm();
function Sm() {
	return 2 ** ++hm;
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/defined-info.js
var Cm = Object.keys(mm), wm = class extends pm {
	constructor(e, t, n, r) {
		let i = -1;
		if (super(e, t), Tm(this, "space", r), typeof n == "number") for (; ++i < Cm.length;) {
			let e = Cm[i];
			Tm(this, Cm[i], (n & mm[e]) === mm[e]);
		}
	}
};
wm.prototype.defined = !0;
function Tm(e, t, n) {
	n && (e[t] = n);
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/create.js
var Em = {}.hasOwnProperty;
function Dm(e) {
	let t = {}, n = {}, r;
	for (r in e.properties) if (Em.call(e.properties, r)) {
		let i = e.properties[r], a = new wm(r, e.transform(e.attributes || {}, r), i, e.space);
		e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[fm(r)] = r, n[fm(a.attribute)] = r;
	}
	return new um(t, n, e.space);
}
//#endregion
//#region ../../../node_modules/property-information/lib/xlink.js
var Om = Dm({
	space: "xlink",
	transform(e, t) {
		return "xlink:" + t.slice(5).toLowerCase();
	},
	properties: {
		xLinkActuate: null,
		xLinkArcRole: null,
		xLinkHref: null,
		xLinkRole: null,
		xLinkShow: null,
		xLinkTitle: null,
		xLinkType: null
	}
}), km = Dm({
	space: "xml",
	transform(e, t) {
		return "xml:" + t.slice(3).toLowerCase();
	},
	properties: {
		xmlLang: null,
		xmlBase: null,
		xmlSpace: null
	}
});
//#endregion
//#region ../../../node_modules/property-information/lib/util/case-sensitive-transform.js
function Am(e, t) {
	return t in e ? e[t] : t;
}
//#endregion
//#region ../../../node_modules/property-information/lib/util/case-insensitive-transform.js
function jm(e, t) {
	return Am(e, t.toLowerCase());
}
//#endregion
//#region ../../../node_modules/property-information/lib/xmlns.js
var Mm = Dm({
	space: "xmlns",
	attributes: { xmlnsxlink: "xmlns:xlink" },
	transform: jm,
	properties: {
		xmlns: null,
		xmlnsXLink: null
	}
}), Nm = Dm({
	transform(e, t) {
		return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
	},
	properties: {
		ariaActiveDescendant: null,
		ariaAtomic: _m,
		ariaAutoComplete: null,
		ariaBusy: _m,
		ariaChecked: _m,
		ariaColCount: Z,
		ariaColIndex: Z,
		ariaColSpan: Z,
		ariaControls: ym,
		ariaCurrent: null,
		ariaDescribedBy: ym,
		ariaDetails: null,
		ariaDisabled: _m,
		ariaDropEffect: ym,
		ariaErrorMessage: null,
		ariaExpanded: _m,
		ariaFlowTo: ym,
		ariaGrabbed: _m,
		ariaHasPopup: null,
		ariaHidden: _m,
		ariaInvalid: null,
		ariaKeyShortcuts: null,
		ariaLabel: null,
		ariaLabelledBy: ym,
		ariaLevel: Z,
		ariaLive: null,
		ariaModal: _m,
		ariaMultiLine: _m,
		ariaMultiSelectable: _m,
		ariaOrientation: null,
		ariaOwns: ym,
		ariaPlaceholder: null,
		ariaPosInSet: Z,
		ariaPressed: _m,
		ariaReadOnly: _m,
		ariaRelevant: null,
		ariaRequired: _m,
		ariaRoleDescription: ym,
		ariaRowCount: Z,
		ariaRowIndex: Z,
		ariaRowSpan: Z,
		ariaSelected: _m,
		ariaSetSize: Z,
		ariaSort: null,
		ariaValueMax: Z,
		ariaValueMin: Z,
		ariaValueNow: Z,
		ariaValueText: null,
		role: null
	}
}), Pm = Dm({
	space: "html",
	attributes: {
		acceptcharset: "accept-charset",
		classname: "class",
		htmlfor: "for",
		httpequiv: "http-equiv"
	},
	transform: jm,
	mustUseProperty: [
		"checked",
		"multiple",
		"muted",
		"selected"
	],
	properties: {
		abbr: null,
		accept: bm,
		acceptCharset: ym,
		accessKey: ym,
		action: null,
		allow: null,
		allowFullScreen: gm,
		allowPaymentRequest: gm,
		allowUserMedia: gm,
		alt: null,
		as: null,
		async: gm,
		autoCapitalize: null,
		autoComplete: ym,
		autoFocus: gm,
		autoPlay: gm,
		blocking: ym,
		capture: null,
		charSet: null,
		checked: gm,
		cite: null,
		className: ym,
		cols: Z,
		colSpan: null,
		content: null,
		contentEditable: _m,
		controls: gm,
		controlsList: ym,
		coords: Z | bm,
		crossOrigin: null,
		data: null,
		dateTime: null,
		decoding: null,
		default: gm,
		defer: gm,
		dir: null,
		dirName: null,
		disabled: gm,
		download: vm,
		draggable: _m,
		encType: null,
		enterKeyHint: null,
		fetchPriority: null,
		form: null,
		formAction: null,
		formEncType: null,
		formMethod: null,
		formNoValidate: gm,
		formTarget: null,
		headers: ym,
		height: Z,
		hidden: gm,
		high: Z,
		href: null,
		hrefLang: null,
		htmlFor: ym,
		httpEquiv: ym,
		id: null,
		imageSizes: null,
		imageSrcSet: null,
		inert: gm,
		inputMode: null,
		integrity: null,
		is: null,
		isMap: gm,
		itemId: null,
		itemProp: ym,
		itemRef: ym,
		itemScope: gm,
		itemType: ym,
		kind: null,
		label: null,
		lang: null,
		language: null,
		list: null,
		loading: null,
		loop: gm,
		low: Z,
		manifest: null,
		max: null,
		maxLength: Z,
		media: null,
		method: null,
		min: null,
		minLength: Z,
		multiple: gm,
		muted: gm,
		name: null,
		nonce: null,
		noModule: gm,
		noValidate: gm,
		onAbort: null,
		onAfterPrint: null,
		onAuxClick: null,
		onBeforeMatch: null,
		onBeforePrint: null,
		onBeforeToggle: null,
		onBeforeUnload: null,
		onBlur: null,
		onCancel: null,
		onCanPlay: null,
		onCanPlayThrough: null,
		onChange: null,
		onClick: null,
		onClose: null,
		onContextLost: null,
		onContextMenu: null,
		onContextRestored: null,
		onCopy: null,
		onCueChange: null,
		onCut: null,
		onDblClick: null,
		onDrag: null,
		onDragEnd: null,
		onDragEnter: null,
		onDragExit: null,
		onDragLeave: null,
		onDragOver: null,
		onDragStart: null,
		onDrop: null,
		onDurationChange: null,
		onEmptied: null,
		onEnded: null,
		onError: null,
		onFocus: null,
		onFormData: null,
		onHashChange: null,
		onInput: null,
		onInvalid: null,
		onKeyDown: null,
		onKeyPress: null,
		onKeyUp: null,
		onLanguageChange: null,
		onLoad: null,
		onLoadedData: null,
		onLoadedMetadata: null,
		onLoadEnd: null,
		onLoadStart: null,
		onMessage: null,
		onMessageError: null,
		onMouseDown: null,
		onMouseEnter: null,
		onMouseLeave: null,
		onMouseMove: null,
		onMouseOut: null,
		onMouseOver: null,
		onMouseUp: null,
		onOffline: null,
		onOnline: null,
		onPageHide: null,
		onPageShow: null,
		onPaste: null,
		onPause: null,
		onPlay: null,
		onPlaying: null,
		onPopState: null,
		onProgress: null,
		onRateChange: null,
		onRejectionHandled: null,
		onReset: null,
		onResize: null,
		onScroll: null,
		onScrollEnd: null,
		onSecurityPolicyViolation: null,
		onSeeked: null,
		onSeeking: null,
		onSelect: null,
		onSlotChange: null,
		onStalled: null,
		onStorage: null,
		onSubmit: null,
		onSuspend: null,
		onTimeUpdate: null,
		onToggle: null,
		onUnhandledRejection: null,
		onUnload: null,
		onVolumeChange: null,
		onWaiting: null,
		onWheel: null,
		open: gm,
		optimum: Z,
		pattern: null,
		ping: ym,
		placeholder: null,
		playsInline: gm,
		popover: null,
		popoverTarget: null,
		popoverTargetAction: null,
		poster: null,
		preload: null,
		readOnly: gm,
		referrerPolicy: null,
		rel: ym,
		required: gm,
		reversed: gm,
		rows: Z,
		rowSpan: Z,
		sandbox: ym,
		scope: null,
		scoped: gm,
		seamless: gm,
		selected: gm,
		shadowRootClonable: gm,
		shadowRootDelegatesFocus: gm,
		shadowRootMode: null,
		shape: null,
		size: Z,
		sizes: null,
		slot: null,
		span: Z,
		spellCheck: _m,
		src: null,
		srcDoc: null,
		srcLang: null,
		srcSet: null,
		start: Z,
		step: null,
		style: null,
		tabIndex: Z,
		target: null,
		title: null,
		translate: null,
		type: null,
		typeMustMatch: gm,
		useMap: null,
		value: _m,
		width: Z,
		wrap: null,
		writingSuggestions: null,
		align: null,
		aLink: null,
		archive: ym,
		axis: null,
		background: null,
		bgColor: null,
		border: Z,
		borderColor: null,
		bottomMargin: Z,
		cellPadding: null,
		cellSpacing: null,
		char: null,
		charOff: null,
		classId: null,
		clear: null,
		code: null,
		codeBase: null,
		codeType: null,
		color: null,
		compact: gm,
		declare: gm,
		event: null,
		face: null,
		frame: null,
		frameBorder: null,
		hSpace: Z,
		leftMargin: Z,
		link: null,
		longDesc: null,
		lowSrc: null,
		marginHeight: Z,
		marginWidth: Z,
		noResize: gm,
		noHref: gm,
		noShade: gm,
		noWrap: gm,
		object: null,
		profile: null,
		prompt: null,
		rev: null,
		rightMargin: Z,
		rules: null,
		scheme: null,
		scrolling: _m,
		standby: null,
		summary: null,
		text: null,
		topMargin: Z,
		valueType: null,
		version: null,
		vAlign: null,
		vLink: null,
		vSpace: Z,
		allowTransparency: null,
		autoCorrect: null,
		autoSave: null,
		disablePictureInPicture: gm,
		disableRemotePlayback: gm,
		prefix: null,
		property: null,
		results: Z,
		security: null,
		unselectable: null
	}
}), Fm = Dm({
	space: "svg",
	attributes: {
		accentHeight: "accent-height",
		alignmentBaseline: "alignment-baseline",
		arabicForm: "arabic-form",
		baselineShift: "baseline-shift",
		capHeight: "cap-height",
		className: "class",
		clipPath: "clip-path",
		clipRule: "clip-rule",
		colorInterpolation: "color-interpolation",
		colorInterpolationFilters: "color-interpolation-filters",
		colorProfile: "color-profile",
		colorRendering: "color-rendering",
		crossOrigin: "crossorigin",
		dataType: "datatype",
		dominantBaseline: "dominant-baseline",
		enableBackground: "enable-background",
		fillOpacity: "fill-opacity",
		fillRule: "fill-rule",
		floodColor: "flood-color",
		floodOpacity: "flood-opacity",
		fontFamily: "font-family",
		fontSize: "font-size",
		fontSizeAdjust: "font-size-adjust",
		fontStretch: "font-stretch",
		fontStyle: "font-style",
		fontVariant: "font-variant",
		fontWeight: "font-weight",
		glyphName: "glyph-name",
		glyphOrientationHorizontal: "glyph-orientation-horizontal",
		glyphOrientationVertical: "glyph-orientation-vertical",
		hrefLang: "hreflang",
		horizAdvX: "horiz-adv-x",
		horizOriginX: "horiz-origin-x",
		horizOriginY: "horiz-origin-y",
		imageRendering: "image-rendering",
		letterSpacing: "letter-spacing",
		lightingColor: "lighting-color",
		markerEnd: "marker-end",
		markerMid: "marker-mid",
		markerStart: "marker-start",
		navDown: "nav-down",
		navDownLeft: "nav-down-left",
		navDownRight: "nav-down-right",
		navLeft: "nav-left",
		navNext: "nav-next",
		navPrev: "nav-prev",
		navRight: "nav-right",
		navUp: "nav-up",
		navUpLeft: "nav-up-left",
		navUpRight: "nav-up-right",
		onAbort: "onabort",
		onActivate: "onactivate",
		onAfterPrint: "onafterprint",
		onBeforePrint: "onbeforeprint",
		onBegin: "onbegin",
		onCancel: "oncancel",
		onCanPlay: "oncanplay",
		onCanPlayThrough: "oncanplaythrough",
		onChange: "onchange",
		onClick: "onclick",
		onClose: "onclose",
		onCopy: "oncopy",
		onCueChange: "oncuechange",
		onCut: "oncut",
		onDblClick: "ondblclick",
		onDrag: "ondrag",
		onDragEnd: "ondragend",
		onDragEnter: "ondragenter",
		onDragExit: "ondragexit",
		onDragLeave: "ondragleave",
		onDragOver: "ondragover",
		onDragStart: "ondragstart",
		onDrop: "ondrop",
		onDurationChange: "ondurationchange",
		onEmptied: "onemptied",
		onEnd: "onend",
		onEnded: "onended",
		onError: "onerror",
		onFocus: "onfocus",
		onFocusIn: "onfocusin",
		onFocusOut: "onfocusout",
		onHashChange: "onhashchange",
		onInput: "oninput",
		onInvalid: "oninvalid",
		onKeyDown: "onkeydown",
		onKeyPress: "onkeypress",
		onKeyUp: "onkeyup",
		onLoad: "onload",
		onLoadedData: "onloadeddata",
		onLoadedMetadata: "onloadedmetadata",
		onLoadStart: "onloadstart",
		onMessage: "onmessage",
		onMouseDown: "onmousedown",
		onMouseEnter: "onmouseenter",
		onMouseLeave: "onmouseleave",
		onMouseMove: "onmousemove",
		onMouseOut: "onmouseout",
		onMouseOver: "onmouseover",
		onMouseUp: "onmouseup",
		onMouseWheel: "onmousewheel",
		onOffline: "onoffline",
		onOnline: "ononline",
		onPageHide: "onpagehide",
		onPageShow: "onpageshow",
		onPaste: "onpaste",
		onPause: "onpause",
		onPlay: "onplay",
		onPlaying: "onplaying",
		onPopState: "onpopstate",
		onProgress: "onprogress",
		onRateChange: "onratechange",
		onRepeat: "onrepeat",
		onReset: "onreset",
		onResize: "onresize",
		onScroll: "onscroll",
		onSeeked: "onseeked",
		onSeeking: "onseeking",
		onSelect: "onselect",
		onShow: "onshow",
		onStalled: "onstalled",
		onStorage: "onstorage",
		onSubmit: "onsubmit",
		onSuspend: "onsuspend",
		onTimeUpdate: "ontimeupdate",
		onToggle: "ontoggle",
		onUnload: "onunload",
		onVolumeChange: "onvolumechange",
		onWaiting: "onwaiting",
		onZoom: "onzoom",
		overlinePosition: "overline-position",
		overlineThickness: "overline-thickness",
		paintOrder: "paint-order",
		panose1: "panose-1",
		pointerEvents: "pointer-events",
		referrerPolicy: "referrerpolicy",
		renderingIntent: "rendering-intent",
		shapeRendering: "shape-rendering",
		stopColor: "stop-color",
		stopOpacity: "stop-opacity",
		strikethroughPosition: "strikethrough-position",
		strikethroughThickness: "strikethrough-thickness",
		strokeDashArray: "stroke-dasharray",
		strokeDashOffset: "stroke-dashoffset",
		strokeLineCap: "stroke-linecap",
		strokeLineJoin: "stroke-linejoin",
		strokeMiterLimit: "stroke-miterlimit",
		strokeOpacity: "stroke-opacity",
		strokeWidth: "stroke-width",
		tabIndex: "tabindex",
		textAnchor: "text-anchor",
		textDecoration: "text-decoration",
		textRendering: "text-rendering",
		transformOrigin: "transform-origin",
		typeOf: "typeof",
		underlinePosition: "underline-position",
		underlineThickness: "underline-thickness",
		unicodeBidi: "unicode-bidi",
		unicodeRange: "unicode-range",
		unitsPerEm: "units-per-em",
		vAlphabetic: "v-alphabetic",
		vHanging: "v-hanging",
		vIdeographic: "v-ideographic",
		vMathematical: "v-mathematical",
		vectorEffect: "vector-effect",
		vertAdvY: "vert-adv-y",
		vertOriginX: "vert-origin-x",
		vertOriginY: "vert-origin-y",
		wordSpacing: "word-spacing",
		writingMode: "writing-mode",
		xHeight: "x-height",
		playbackOrder: "playbackorder",
		timelineBegin: "timelinebegin"
	},
	transform: Am,
	properties: {
		about: xm,
		accentHeight: Z,
		accumulate: null,
		additive: null,
		alignmentBaseline: null,
		alphabetic: Z,
		amplitude: Z,
		arabicForm: null,
		ascent: Z,
		attributeName: null,
		attributeType: null,
		azimuth: Z,
		bandwidth: null,
		baselineShift: null,
		baseFrequency: null,
		baseProfile: null,
		bbox: null,
		begin: null,
		bias: Z,
		by: null,
		calcMode: null,
		capHeight: Z,
		className: ym,
		clip: null,
		clipPath: null,
		clipPathUnits: null,
		clipRule: null,
		color: null,
		colorInterpolation: null,
		colorInterpolationFilters: null,
		colorProfile: null,
		colorRendering: null,
		content: null,
		contentScriptType: null,
		contentStyleType: null,
		crossOrigin: null,
		cursor: null,
		cx: null,
		cy: null,
		d: null,
		dataType: null,
		defaultAction: null,
		descent: Z,
		diffuseConstant: Z,
		direction: null,
		display: null,
		dur: null,
		divisor: Z,
		dominantBaseline: null,
		download: gm,
		dx: null,
		dy: null,
		edgeMode: null,
		editable: null,
		elevation: Z,
		enableBackground: null,
		end: null,
		event: null,
		exponent: Z,
		externalResourcesRequired: null,
		fill: null,
		fillOpacity: Z,
		fillRule: null,
		filter: null,
		filterRes: null,
		filterUnits: null,
		floodColor: null,
		floodOpacity: null,
		focusable: null,
		focusHighlight: null,
		fontFamily: null,
		fontSize: null,
		fontSizeAdjust: null,
		fontStretch: null,
		fontStyle: null,
		fontVariant: null,
		fontWeight: null,
		format: null,
		fr: null,
		from: null,
		fx: null,
		fy: null,
		g1: bm,
		g2: bm,
		glyphName: bm,
		glyphOrientationHorizontal: null,
		glyphOrientationVertical: null,
		glyphRef: null,
		gradientTransform: null,
		gradientUnits: null,
		handler: null,
		hanging: Z,
		hatchContentUnits: null,
		hatchUnits: null,
		height: null,
		href: null,
		hrefLang: null,
		horizAdvX: Z,
		horizOriginX: Z,
		horizOriginY: Z,
		id: null,
		ideographic: Z,
		imageRendering: null,
		initialVisibility: null,
		in: null,
		in2: null,
		intercept: Z,
		k: Z,
		k1: Z,
		k2: Z,
		k3: Z,
		k4: Z,
		kernelMatrix: xm,
		kernelUnitLength: null,
		keyPoints: null,
		keySplines: null,
		keyTimes: null,
		kerning: null,
		lang: null,
		lengthAdjust: null,
		letterSpacing: null,
		lightingColor: null,
		limitingConeAngle: Z,
		local: null,
		markerEnd: null,
		markerMid: null,
		markerStart: null,
		markerHeight: null,
		markerUnits: null,
		markerWidth: null,
		mask: null,
		maskContentUnits: null,
		maskUnits: null,
		mathematical: null,
		max: null,
		media: null,
		mediaCharacterEncoding: null,
		mediaContentEncodings: null,
		mediaSize: Z,
		mediaTime: null,
		method: null,
		min: null,
		mode: null,
		name: null,
		navDown: null,
		navDownLeft: null,
		navDownRight: null,
		navLeft: null,
		navNext: null,
		navPrev: null,
		navRight: null,
		navUp: null,
		navUpLeft: null,
		navUpRight: null,
		numOctaves: null,
		observer: null,
		offset: null,
		onAbort: null,
		onActivate: null,
		onAfterPrint: null,
		onBeforePrint: null,
		onBegin: null,
		onCancel: null,
		onCanPlay: null,
		onCanPlayThrough: null,
		onChange: null,
		onClick: null,
		onClose: null,
		onCopy: null,
		onCueChange: null,
		onCut: null,
		onDblClick: null,
		onDrag: null,
		onDragEnd: null,
		onDragEnter: null,
		onDragExit: null,
		onDragLeave: null,
		onDragOver: null,
		onDragStart: null,
		onDrop: null,
		onDurationChange: null,
		onEmptied: null,
		onEnd: null,
		onEnded: null,
		onError: null,
		onFocus: null,
		onFocusIn: null,
		onFocusOut: null,
		onHashChange: null,
		onInput: null,
		onInvalid: null,
		onKeyDown: null,
		onKeyPress: null,
		onKeyUp: null,
		onLoad: null,
		onLoadedData: null,
		onLoadedMetadata: null,
		onLoadStart: null,
		onMessage: null,
		onMouseDown: null,
		onMouseEnter: null,
		onMouseLeave: null,
		onMouseMove: null,
		onMouseOut: null,
		onMouseOver: null,
		onMouseUp: null,
		onMouseWheel: null,
		onOffline: null,
		onOnline: null,
		onPageHide: null,
		onPageShow: null,
		onPaste: null,
		onPause: null,
		onPlay: null,
		onPlaying: null,
		onPopState: null,
		onProgress: null,
		onRateChange: null,
		onRepeat: null,
		onReset: null,
		onResize: null,
		onScroll: null,
		onSeeked: null,
		onSeeking: null,
		onSelect: null,
		onShow: null,
		onStalled: null,
		onStorage: null,
		onSubmit: null,
		onSuspend: null,
		onTimeUpdate: null,
		onToggle: null,
		onUnload: null,
		onVolumeChange: null,
		onWaiting: null,
		onZoom: null,
		opacity: null,
		operator: null,
		order: null,
		orient: null,
		orientation: null,
		origin: null,
		overflow: null,
		overlay: null,
		overlinePosition: Z,
		overlineThickness: Z,
		paintOrder: null,
		panose1: null,
		path: null,
		pathLength: Z,
		patternContentUnits: null,
		patternTransform: null,
		patternUnits: null,
		phase: null,
		ping: ym,
		pitch: null,
		playbackOrder: null,
		pointerEvents: null,
		points: null,
		pointsAtX: Z,
		pointsAtY: Z,
		pointsAtZ: Z,
		preserveAlpha: null,
		preserveAspectRatio: null,
		primitiveUnits: null,
		propagate: null,
		property: xm,
		r: null,
		radius: null,
		referrerPolicy: null,
		refX: null,
		refY: null,
		rel: xm,
		rev: xm,
		renderingIntent: null,
		repeatCount: null,
		repeatDur: null,
		requiredExtensions: xm,
		requiredFeatures: xm,
		requiredFonts: xm,
		requiredFormats: xm,
		resource: null,
		restart: null,
		result: null,
		rotate: null,
		rx: null,
		ry: null,
		scale: null,
		seed: null,
		shapeRendering: null,
		side: null,
		slope: null,
		snapshotTime: null,
		specularConstant: Z,
		specularExponent: Z,
		spreadMethod: null,
		spacing: null,
		startOffset: null,
		stdDeviation: null,
		stemh: null,
		stemv: null,
		stitchTiles: null,
		stopColor: null,
		stopOpacity: null,
		strikethroughPosition: Z,
		strikethroughThickness: Z,
		string: null,
		stroke: null,
		strokeDashArray: xm,
		strokeDashOffset: null,
		strokeLineCap: null,
		strokeLineJoin: null,
		strokeMiterLimit: Z,
		strokeOpacity: Z,
		strokeWidth: null,
		style: null,
		surfaceScale: Z,
		syncBehavior: null,
		syncBehaviorDefault: null,
		syncMaster: null,
		syncTolerance: null,
		syncToleranceDefault: null,
		systemLanguage: xm,
		tabIndex: Z,
		tableValues: null,
		target: null,
		targetX: Z,
		targetY: Z,
		textAnchor: null,
		textDecoration: null,
		textRendering: null,
		textLength: null,
		timelineBegin: null,
		title: null,
		transformBehavior: null,
		type: null,
		typeOf: xm,
		to: null,
		transform: null,
		transformOrigin: null,
		u1: null,
		u2: null,
		underlinePosition: Z,
		underlineThickness: Z,
		unicode: null,
		unicodeBidi: null,
		unicodeRange: null,
		unitsPerEm: Z,
		values: null,
		vAlphabetic: Z,
		vMathematical: Z,
		vectorEffect: null,
		vHanging: Z,
		vIdeographic: Z,
		version: null,
		vertAdvY: Z,
		vertOriginX: Z,
		vertOriginY: Z,
		viewBox: null,
		viewTarget: null,
		visibility: null,
		width: null,
		widths: null,
		wordSpacing: null,
		writingMode: null,
		x: null,
		x1: null,
		x2: null,
		xChannelSelector: null,
		xHeight: Z,
		y: null,
		y1: null,
		y2: null,
		yChannelSelector: null,
		z: null,
		zoomAndPan: null
	}
}), Im = /^data[-\w.:]+$/i, Lm = /-[a-z]/g, Rm = /[A-Z]/g;
function zm(e, t) {
	let n = fm(t), r = t, i = pm;
	if (n in e.normal) return e.property[e.normal[n]];
	if (n.length > 4 && n.slice(0, 4) === "data" && Im.test(t)) {
		if (t.charAt(4) === "-") {
			let e = t.slice(5).replace(Lm, Vm);
			r = "data" + e.charAt(0).toUpperCase() + e.slice(1);
		} else {
			let e = t.slice(4);
			if (!Lm.test(e)) {
				let n = e.replace(Rm, Bm);
				n.charAt(0) !== "-" && (n = "-" + n), t = "data" + n;
			}
		}
		i = wm;
	}
	return new i(r, t);
}
function Bm(e) {
	return "-" + e.toLowerCase();
}
function Vm(e) {
	return e.charAt(1).toUpperCase();
}
//#endregion
//#region ../../../node_modules/property-information/lib/hast-to-react.js
var Hm = {
	classId: "classID",
	dataType: "datatype",
	itemId: "itemID",
	strokeDashArray: "strokeDasharray",
	strokeDashOffset: "strokeDashoffset",
	strokeLineCap: "strokeLinecap",
	strokeLineJoin: "strokeLinejoin",
	strokeMiterLimit: "strokeMiterlimit",
	typeOf: "typeof",
	xLinkActuate: "xlinkActuate",
	xLinkArcRole: "xlinkArcrole",
	xLinkHref: "xlinkHref",
	xLinkRole: "xlinkRole",
	xLinkShow: "xlinkShow",
	xLinkTitle: "xlinkTitle",
	xLinkType: "xlinkType",
	xmlnsXLink: "xmlnsXlink"
}, Um = dm([
	km,
	Om,
	Mm,
	Nm,
	Pm
], "html"), Wm = dm([
	km,
	Om,
	Mm,
	Nm,
	Fm
], "svg");
//#endregion
//#region ../../../node_modules/space-separated-tokens/index.js
function Gm(e) {
	return e.join(" ").trim();
}
//#endregion
//#region ../../../node_modules/hast-util-to-jsx-runtime/node_modules/inline-style-parser/index.js
var Km = /* @__PURE__ */ Dt(((e, t) => {
	var n = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, r = /\n/g, i = /^\s*/, a = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, o = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, c = /^[;\s]*/, l = /^\s+|\s+$/g;
	t.exports = function(e, t) {
		if (typeof e != "string") throw TypeError("First argument must be a string");
		if (!e) return [];
		t ||= {};
		var l = 1, d = 1;
		function f(e) {
			var t = e.match(r);
			t && (l += t.length);
			var n = e.lastIndexOf("\n");
			d = ~n ? e.length - n : d + e.length;
		}
		function p() {
			var e = {
				line: l,
				column: d
			};
			return function(t) {
				return t.position = new m(e), v(), t;
			};
		}
		function m(e) {
			this.start = e, this.end = {
				line: l,
				column: d
			}, this.source = t.source;
		}
		m.prototype.content = e;
		var h = [];
		function g(n) {
			var r = /* @__PURE__ */ Error(t.source + ":" + l + ":" + d + ": " + n);
			if (r.reason = n, r.filename = t.source, r.line = l, r.column = d, r.source = e, t.silent) h.push(r);
			else throw r;
		}
		function _(t) {
			var n = t.exec(e);
			if (n) {
				var r = n[0];
				return f(r), e = e.slice(r.length), n;
			}
		}
		function v() {
			_(i);
		}
		function y(e) {
			var t;
			for (e ||= []; t = b();) t !== !1 && e.push(t);
			return e;
		}
		function b() {
			var t = p();
			if (!(e.charAt(0) != "/" || e.charAt(1) != "*")) {
				for (var n = 2; e.charAt(n) != "" && (e.charAt(n) != "*" || e.charAt(n + 1) != "/");) ++n;
				if (n += 2, e.charAt(n - 1) === "") return g("End of comment missing");
				var r = e.slice(2, n - 2);
				return d += 2, f(r), e = e.slice(n), d += 2, t({
					type: "comment",
					comment: r
				});
			}
		}
		function x() {
			var e = p(), t = _(a);
			if (t) {
				if (b(), !_(o)) return g("property missing ':'");
				var r = _(s), i = e({
					type: "declaration",
					property: u(t[0].replace(n, "")),
					value: r ? u(r[0].replace(n, "")) : ""
				});
				return _(c), i;
			}
		}
		function S() {
			var e = [];
			y(e);
			for (var t; t = x();) t !== !1 && (e.push(t), y(e));
			return e;
		}
		return v(), S();
	};
	function u(e) {
		return e ? e.replace(l, "") : "";
	}
})), qm = /* @__PURE__ */ At((/* @__PURE__ */ Dt(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = r;
	var n = t(Km());
	function r(e, t) {
		var r = null;
		if (!e || typeof e != "string") return r;
		var i = (0, n.default)(e), a = typeof t == "function";
		return i.forEach(function(e) {
			if (e.type === "declaration") {
				var n = e.property, i = e.value;
				a ? t(n, i, e) : i && (r ||= {}, r[n] = i);
			}
		}), r;
	}
})))(), 1), Jm = qm.default.default || qm.default, Ym = Zm("end"), Xm = Zm("start");
function Zm(e) {
	return t;
	function t(t) {
		let n = t && t.position && t.position[e] || {};
		if (typeof n.line == "number" && n.line > 0 && typeof n.column == "number" && n.column > 0) return {
			line: n.line,
			column: n.column,
			offset: typeof n.offset == "number" && n.offset > -1 ? n.offset : void 0
		};
	}
}
function Qm(e) {
	let t = Xm(e), n = Ym(e);
	if (t && n) return {
		start: t,
		end: n
	};
}
//#endregion
//#region ../../../node_modules/unist-util-stringify-position/lib/index.js
function $m(e) {
	return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? th(e.position) : "start" in e || "end" in e ? th(e) : "line" in e || "column" in e ? eh(e) : "";
}
function eh(e) {
	return nh(e && e.line) + ":" + nh(e && e.column);
}
function th(e) {
	return eh(e && e.start) + "-" + eh(e && e.end);
}
function nh(e) {
	return e && typeof e == "number" ? e : 1;
}
//#endregion
//#region ../../../node_modules/vfile-message/lib/index.js
var rh = class extends Error {
	constructor(e, t, n) {
		super(), typeof t == "string" && (n = t, t = void 0);
		let r = "", i = {}, a = !1;
		if (t && (i = "line" in t && "column" in t || "start" in t && "end" in t ? { place: t } : "type" in t ? {
			ancestors: [t],
			place: t.position
		} : { ...t }), typeof e == "string" ? r = e : !i.cause && e && (a = !0, r = e.message, i.cause = e), !i.ruleId && !i.source && typeof n == "string") {
			let e = n.indexOf(":");
			e === -1 ? i.ruleId = n : (i.source = n.slice(0, e), i.ruleId = n.slice(e + 1));
		}
		if (!i.place && i.ancestors && i.ancestors) {
			let e = i.ancestors[i.ancestors.length - 1];
			e && (i.place = e.position);
		}
		let o = i.place && "start" in i.place ? i.place.start : i.place;
		this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file, this.message = r, this.line = o ? o.line : void 0, this.name = $m(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = a && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
	}
};
rh.prototype.file = "", rh.prototype.name = "", rh.prototype.reason = "", rh.prototype.message = "", rh.prototype.stack = "", rh.prototype.column = void 0, rh.prototype.line = void 0, rh.prototype.ancestors = void 0, rh.prototype.cause = void 0, rh.prototype.fatal = void 0, rh.prototype.place = void 0, rh.prototype.ruleId = void 0, rh.prototype.source = void 0;
//#endregion
//#region ../../../node_modules/hast-util-to-jsx-runtime/lib/index.js
var ih = {}.hasOwnProperty, ah = /* @__PURE__ */ new Map(), oh = /[A-Z]/g, sh = /-([a-z])/g, ch = /* @__PURE__ */ new Set([
	"table",
	"tbody",
	"thead",
	"tfoot",
	"tr"
]), lh = /* @__PURE__ */ new Set(["td", "th"]);
function uh(e, t) {
	if (!t || t.Fragment === void 0) throw TypeError("Expected `Fragment` in options");
	let n = t.filePath || void 0, r;
	if (t.development) {
		if (typeof t.jsxDEV != "function") throw TypeError("Expected `jsxDEV` in options when `development: true`");
		r = xh(n, t.jsxDEV);
	} else {
		if (typeof t.jsx != "function") throw TypeError("Expected `jsx` in production options");
		if (typeof t.jsxs != "function") throw TypeError("Expected `jsxs` in production options");
		r = bh(n, t.jsx, t.jsxs);
	}
	let i = {
		Fragment: t.Fragment,
		ancestors: [],
		components: t.components || {},
		create: r,
		elementAttributeNameCase: t.elementAttributeNameCase || "react",
		evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
		filePath: n,
		ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
		passKeys: t.passKeys !== !1,
		passNode: t.passNode || !1,
		schema: t.space === "svg" ? Wm : Um,
		stylePropertyNameCase: t.stylePropertyNameCase || "dom",
		tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
	}, a = dh(i, e, void 0);
	return a && typeof a != "string" ? a : i.create(e, i.Fragment, { children: a || void 0 }, void 0);
}
function dh(e, t, n) {
	if (t.type === "element") return fh(e, t, n);
	if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression") return ph(e, t);
	if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement") return hh(e, t, n);
	if (t.type === "mdxjsEsm") return mh(e, t);
	if (t.type === "root") return gh(e, t, n);
	if (t.type === "text") return _h(e, t);
}
function fh(e, t, n) {
	let r = e.schema, i = r;
	t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = Wm, e.schema = i), e.ancestors.push(t);
	let a = Dh(e, t.tagName, !1), o = Sh(e, t), s = wh(e, t);
	return ch.has(t.tagName) && (s = s.filter(function(e) {
		return typeof e != "string" || !cm(e);
	})), vh(e, o, a, t), yh(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function ph(e, t) {
	if (t.data && t.data.estree && e.evaluater) {
		let n = t.data.estree.body[0];
		return n.type, e.evaluater.evaluateExpression(n.expression);
	}
	Oh(e, t.position);
}
function mh(e, t) {
	if (t.data && t.data.estree && e.evaluater) return e.evaluater.evaluateProgram(t.data.estree);
	Oh(e, t.position);
}
function hh(e, t, n) {
	let r = e.schema, i = r;
	t.name === "svg" && r.space === "html" && (i = Wm, e.schema = i), e.ancestors.push(t);
	let a = t.name === null ? e.Fragment : Dh(e, t.name, !0), o = Ch(e, t), s = wh(e, t);
	return vh(e, o, a, t), yh(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function gh(e, t, n) {
	let r = {};
	return yh(r, wh(e, t)), e.create(t, e.Fragment, r, n);
}
function _h(e, t) {
	return t.value;
}
function vh(e, t, n, r) {
	typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function yh(e, t) {
	if (t.length > 0) {
		let n = t.length > 1 ? t : t[0];
		n && (e.children = n);
	}
}
function bh(e, t, n) {
	return r;
	function r(e, r, i, a) {
		let o = Array.isArray(i.children) ? n : t;
		return a ? o(r, i, a) : o(r, i);
	}
}
function xh(e, t) {
	return n;
	function n(n, r, i, a) {
		let o = Array.isArray(i.children), s = Xm(n);
		return t(r, i, a, o, {
			columnNumber: s ? s.column - 1 : void 0,
			fileName: e,
			lineNumber: s ? s.line : void 0
		}, void 0);
	}
}
function Sh(e, t) {
	let n = {}, r, i;
	for (i in t.properties) if (i !== "children" && ih.call(t.properties, i)) {
		let a = Th(e, i, t.properties[i]);
		if (a) {
			let [i, o] = a;
			e.tableCellAlignToStyle && i === "align" && typeof o == "string" && lh.has(t.tagName) ? r = o : n[i] = o;
		}
	}
	if (r) {
		let t = n.style ||= {};
		t[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
	}
	return n;
}
function Ch(e, t) {
	let n = {};
	for (let r of t.attributes) if (r.type === "mdxJsxExpressionAttribute") if (r.data && r.data.estree && e.evaluater) {
		let t = r.data.estree.body[0];
		t.type;
		let i = t.expression;
		i.type;
		let a = i.properties[0];
		a.type, Object.assign(n, e.evaluater.evaluateExpression(a.argument));
	} else Oh(e, t.position);
	else {
		let i = r.name, a;
		if (r.value && typeof r.value == "object") if (r.value.data && r.value.data.estree && e.evaluater) {
			let t = r.value.data.estree.body[0];
			t.type, a = e.evaluater.evaluateExpression(t.expression);
		} else Oh(e, t.position);
		else a = r.value === null || r.value;
		n[i] = a;
	}
	return n;
}
function wh(e, t) {
	let n = [], r = -1, i = e.passKeys ? /* @__PURE__ */ new Map() : ah;
	for (; ++r < t.children.length;) {
		let a = t.children[r], o;
		if (e.passKeys) {
			let e = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
			if (e) {
				let t = i.get(e) || 0;
				o = e + "-" + t, i.set(e, t + 1);
			}
		}
		let s = dh(e, a, o);
		s !== void 0 && n.push(s);
	}
	return n;
}
function Th(e, t, n) {
	let r = zm(e.schema, t);
	if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
		if (Array.isArray(n) && (n = r.commaSeparated ? nm(n) : Gm(n)), r.property === "style") {
			let t = typeof n == "object" ? n : Eh(e, String(n));
			return e.stylePropertyNameCase === "css" && (t = kh(t)), ["style", t];
		}
		return [e.elementAttributeNameCase === "react" && r.space ? Hm[r.property] || r.property : r.attribute, n];
	}
}
function Eh(e, t) {
	let n = {};
	try {
		Jm(t, r);
	} catch (t) {
		if (!e.ignoreInvalidStyle) {
			let n = t, r = new rh("Cannot parse `style` attribute", {
				ancestors: e.ancestors,
				cause: n,
				ruleId: "style",
				source: "hast-util-to-jsx-runtime"
			});
			throw r.file = e.filePath || void 0, r.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-parse-style-attribute", r;
		}
	}
	return n;
	function r(e, t) {
		let r = e;
		r.slice(0, 2) !== "--" && (r.slice(0, 4) === "-ms-" && (r = "ms-" + r.slice(4)), r = r.replace(sh, jh)), n[r] = t;
	}
}
function Dh(e, t, n) {
	let r;
	if (!n) r = {
		type: "Literal",
		value: t
	};
	else if (t.includes(".")) {
		let e = t.split("."), n = -1, i;
		for (; ++n < e.length;) {
			let t = om(e[n]) ? {
				type: "Identifier",
				name: e[n]
			} : {
				type: "Literal",
				value: e[n]
			};
			i = i ? {
				type: "MemberExpression",
				object: i,
				property: t,
				computed: !!(n && t.type === "Literal"),
				optional: !1
			} : t;
		}
		r = i;
	} else r = om(t) && !/^[a-z]/.test(t) ? {
		type: "Identifier",
		name: t
	} : {
		type: "Literal",
		value: t
	};
	if (r.type === "Literal") {
		let t = r.value;
		return ih.call(e.components, t) ? e.components[t] : t;
	}
	if (e.evaluater) return e.evaluater.evaluateExpression(r);
	Oh(e);
}
function Oh(e, t) {
	let n = new rh("Cannot handle MDX estrees without `createEvaluater`", {
		ancestors: e.ancestors,
		place: t,
		ruleId: "mdx-estree",
		source: "hast-util-to-jsx-runtime"
	});
	throw n.file = e.filePath || void 0, n.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function kh(e) {
	let t = {}, n;
	for (n in e) ih.call(e, n) && (t[Ah(n)] = e[n]);
	return t;
}
function Ah(e) {
	let t = e.replace(oh, Mh);
	return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function jh(e, t) {
	return t.toUpperCase();
}
function Mh(e) {
	return "-" + e.toLowerCase();
}
//#endregion
//#region ../../../node_modules/html-url-attributes/lib/index.js
var Nh = {
	action: ["form"],
	cite: [
		"blockquote",
		"del",
		"ins",
		"q"
	],
	data: ["object"],
	formAction: ["button", "input"],
	href: [
		"a",
		"area",
		"base",
		"link"
	],
	icon: ["menuitem"],
	itemId: null,
	manifest: ["html"],
	ping: ["a", "area"],
	poster: ["video"],
	src: [
		"audio",
		"embed",
		"iframe",
		"img",
		"input",
		"script",
		"source",
		"track",
		"video"
	]
}, Ph = {};
function Fh(e, t) {
	let n = t || Ph;
	return Ih(e, typeof n.includeImageAlt != "boolean" || n.includeImageAlt, typeof n.includeHtml != "boolean" || n.includeHtml);
}
function Ih(e, t, n) {
	if (Rh(e)) {
		if ("value" in e) return e.type === "html" && !n ? "" : e.value;
		if (t && "alt" in e && e.alt) return e.alt;
		if ("children" in e) return Lh(e.children, t, n);
	}
	return Array.isArray(e) ? Lh(e, t, n) : "";
}
function Lh(e, t, n) {
	let r = [], i = -1;
	for (; ++i < e.length;) r[i] = Ih(e[i], t, n);
	return r.join("");
}
function Rh(e) {
	return !!(e && typeof e == "object");
}
//#endregion
//#region ../../../node_modules/decode-named-character-reference/index.dom.js
var zh = document.createElement("i");
function Bh(e) {
	let t = "&" + e + ";";
	zh.innerHTML = t;
	let n = zh.textContent;
	return n.charCodeAt(n.length - 1) === 59 && e !== "semi" ? !1 : n !== t && n;
}
//#endregion
//#region ../../../node_modules/micromark-util-chunked/index.js
function Vh(e, t, n, r) {
	let i = e.length, a = 0, o;
	if (t = t < 0 ? -t > i ? 0 : i + t : t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4) o = Array.from(r), o.unshift(t, n), e.splice(...o);
	else for (n && e.splice(t, n); a < r.length;) o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function Hh(e, t) {
	return e.length > 0 ? (Vh(e, e.length, 0, t), e) : t;
}
//#endregion
//#region ../../../node_modules/micromark-util-combine-extensions/index.js
var Uh = {}.hasOwnProperty;
function Wh(e) {
	let t = {}, n = -1;
	for (; ++n < e.length;) Gh(t, e[n]);
	return t;
}
function Gh(e, t) {
	let n;
	for (n in t) {
		let r = (Uh.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n], a;
		if (i) for (a in i) {
			Uh.call(r, a) || (r[a] = []);
			let e = i[a];
			Kh(r[a], Array.isArray(e) ? e : e ? [e] : []);
		}
	}
}
function Kh(e, t) {
	let n = -1, r = [];
	for (; ++n < t.length;) (t[n].add === "after" ? e : r).push(t[n]);
	Vh(e, 0, 0, r);
}
//#endregion
//#region ../../../node_modules/micromark-util-decode-numeric-character-reference/index.js
function qh(e, t) {
	let n = Number.parseInt(e, t);
	return n < 9 || n === 11 || n > 13 && n < 32 || n > 126 && n < 160 || n > 55295 && n < 57344 || n > 64975 && n < 65008 || (n & 65535) == 65535 || (n & 65535) == 65534 || n > 1114111 ? "�" : String.fromCodePoint(n);
}
//#endregion
//#region ../../../node_modules/micromark-util-normalize-identifier/index.js
function Jh(e) {
	return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
//#endregion
//#region ../../../node_modules/micromark-util-character/index.js
var Yh = sg(/[A-Za-z]/), Xh = sg(/[\dA-Za-z]/), Zh = sg(/[#-'*+\--9=?A-Z^-~]/);
function Qh(e) {
	return e !== null && (e < 32 || e === 127);
}
var $h = sg(/\d/), eg = sg(/[\dA-Fa-f]/), tg = sg(/[!-/:-@[-`{-~]/);
function ng(e) {
	return e !== null && e < -2;
}
function rg(e) {
	return e !== null && (e < 0 || e === 32);
}
function ig(e) {
	return e === -2 || e === -1 || e === 32;
}
var ag = sg(/\p{P}|\p{S}/u), og = sg(/\s/);
function sg(e) {
	return t;
	function t(t) {
		return t !== null && t > -1 && e.test(String.fromCharCode(t));
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-sanitize-uri/index.js
function cg(e) {
	let t = [], n = -1, r = 0, i = 0;
	for (; ++n < e.length;) {
		let a = e.charCodeAt(n), o = "";
		if (a === 37 && Xh(e.charCodeAt(n + 1)) && Xh(e.charCodeAt(n + 2))) i = 2;
		else if (a < 128) /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
		else if (a > 55295 && a < 57344) {
			let t = e.charCodeAt(n + 1);
			a < 56320 && t > 56319 && t < 57344 ? (o = String.fromCharCode(a, t), i = 1) : o = "�";
		} else o = String.fromCharCode(a);
		o &&= (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, ""), i &&= (n += i, 0);
	}
	return t.join("") + e.slice(r);
}
//#endregion
//#region ../../../node_modules/micromark-factory-space/index.js
function lg(e, t, n, r) {
	let i = r ? r - 1 : Infinity, a = 0;
	return o;
	function o(r) {
		return ig(r) ? (e.enter(n), s(r)) : t(r);
	}
	function s(r) {
		return ig(r) && a++ < i ? (e.consume(r), s) : (e.exit(n), t(r));
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/content.js
var ug = { tokenize: dg };
function dg(e) {
	let t = e.attempt(this.parser.constructs.contentInitial, r, i), n;
	return t;
	function r(n) {
		if (n === null) {
			e.consume(n);
			return;
		}
		return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), lg(e, t, "linePrefix");
	}
	function i(t) {
		return e.enter("paragraph"), a(t);
	}
	function a(t) {
		let r = e.enter("chunkText", {
			contentType: "text",
			previous: n
		});
		return n && (n.next = r), n = r, o(t);
	}
	function o(t) {
		if (t === null) {
			e.exit("chunkText"), e.exit("paragraph"), e.consume(t);
			return;
		}
		return ng(t) ? (e.consume(t), e.exit("chunkText"), a) : (e.consume(t), o);
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/document.js
var fg = { tokenize: mg }, pg = { tokenize: hg };
function mg(e) {
	let t = this, n = [], r = 0, i, a, o;
	return s;
	function s(i) {
		if (r < n.length) {
			let a = n[r];
			return t.containerState = a[1], e.attempt(a[0].continuation, c, l)(i);
		}
		return l(i);
	}
	function c(e) {
		if (r++, t.containerState._closeFlow) {
			t.containerState._closeFlow = void 0, i && v();
			let n = t.events.length, a = n, o;
			for (; a--;) if (t.events[a][0] === "exit" && t.events[a][1].type === "chunkFlow") {
				o = t.events[a][1].end;
				break;
			}
			_(r);
			let s = n;
			for (; s < t.events.length;) t.events[s][1].end = { ...o }, s++;
			return Vh(t.events, a + 1, 0, t.events.slice(n)), t.events.length = s, l(e);
		}
		return s(e);
	}
	function l(a) {
		if (r === n.length) {
			if (!i) return f(a);
			if (i.currentConstruct && i.currentConstruct.concrete) return m(a);
			t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
		}
		return t.containerState = {}, e.check(pg, u, d)(a);
	}
	function u(e) {
		return i && v(), _(r), f(e);
	}
	function d(e) {
		return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, m(e);
	}
	function f(n) {
		return t.containerState = {}, e.attempt(pg, p, m)(n);
	}
	function p(e) {
		return r++, n.push([t.currentConstruct, t.containerState]), f(e);
	}
	function m(n) {
		if (n === null) {
			i && v(), _(0), e.consume(n);
			return;
		}
		return i ||= t.parser.flow(t.now()), e.enter("chunkFlow", {
			_tokenizer: i,
			contentType: "flow",
			previous: a
		}), h(n);
	}
	function h(n) {
		if (n === null) {
			g(e.exit("chunkFlow"), !0), _(0), e.consume(n);
			return;
		}
		return ng(n) ? (e.consume(n), g(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(n), h);
	}
	function g(e, n) {
		let s = t.sliceStream(e);
		if (n && s.push(null), e.previous = a, a && (a.next = e), a = e, i.defineSkip(e.start), i.write(s), t.parser.lazy[e.start.line]) {
			let e = i.events.length;
			for (; e--;) if (i.events[e][1].start.offset < o && (!i.events[e][1].end || i.events[e][1].end.offset > o)) return;
			let n = t.events.length, a = n, s, c;
			for (; a--;) if (t.events[a][0] === "exit" && t.events[a][1].type === "chunkFlow") {
				if (s) {
					c = t.events[a][1].end;
					break;
				}
				s = !0;
			}
			for (_(r), e = n; e < t.events.length;) t.events[e][1].end = { ...c }, e++;
			Vh(t.events, a + 1, 0, t.events.slice(n)), t.events.length = e;
		}
	}
	function _(r) {
		let i = n.length;
		for (; i-- > r;) {
			let r = n[i];
			t.containerState = r[1], r[0].exit.call(t, e);
		}
		n.length = r;
	}
	function v() {
		i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
	}
}
function hg(e, t, n) {
	return lg(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
//#endregion
//#region ../../../node_modules/micromark-util-classify-character/index.js
function gg(e) {
	if (e === null || rg(e) || og(e)) return 1;
	if (ag(e)) return 2;
}
//#endregion
//#region ../../../node_modules/micromark-util-resolve-all/index.js
function _g(e, t, n) {
	let r = [], i = -1;
	for (; ++i < e.length;) {
		let a = e[i].resolveAll;
		a && !r.includes(a) && (t = a(t, n), r.push(a));
	}
	return t;
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/attention.js
var vg = {
	name: "attention",
	resolveAll: yg,
	tokenize: bg
};
function yg(e, t) {
	let n = -1, r, i, a, o, s, c, l, u;
	for (; ++n < e.length;) if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
		for (r = n; r--;) if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
			if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3)) continue;
			c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
			let d = { ...e[r][1].end }, f = { ...e[n][1].start };
			xg(d, -c), xg(f, c), o = {
				type: c > 1 ? "strongSequence" : "emphasisSequence",
				start: d,
				end: { ...e[r][1].end }
			}, s = {
				type: c > 1 ? "strongSequence" : "emphasisSequence",
				start: { ...e[n][1].start },
				end: f
			}, a = {
				type: c > 1 ? "strongText" : "emphasisText",
				start: { ...e[r][1].end },
				end: { ...e[n][1].start }
			}, i = {
				type: c > 1 ? "strong" : "emphasis",
				start: { ...o.start },
				end: { ...s.end }
			}, e[r][1].end = { ...o.start }, e[n][1].start = { ...s.end }, l = [], e[r][1].end.offset - e[r][1].start.offset && (l = Hh(l, [[
				"enter",
				e[r][1],
				t
			], [
				"exit",
				e[r][1],
				t
			]])), l = Hh(l, [
				[
					"enter",
					i,
					t
				],
				[
					"enter",
					o,
					t
				],
				[
					"exit",
					o,
					t
				],
				[
					"enter",
					a,
					t
				]
			]), l = Hh(l, _g(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), l = Hh(l, [
				[
					"exit",
					a,
					t
				],
				[
					"enter",
					s,
					t
				],
				[
					"exit",
					s,
					t
				],
				[
					"exit",
					i,
					t
				]
			]), e[n][1].end.offset - e[n][1].start.offset ? (u = 2, l = Hh(l, [[
				"enter",
				e[n][1],
				t
			], [
				"exit",
				e[n][1],
				t
			]])) : u = 0, Vh(e, r - 1, n - r + 3, l), n = r + l.length - u - 2;
			break;
		}
	}
	for (n = -1; ++n < e.length;) e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
	return e;
}
function bg(e, t) {
	let n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = gg(r), a;
	return o;
	function o(t) {
		return a = t, e.enter("attentionSequence"), s(t);
	}
	function s(o) {
		if (o === a) return e.consume(o), s;
		let c = e.exit("attentionSequence"), l = gg(o), u = !l || l === 2 && i || n.includes(o), d = !i || i === 2 && l || n.includes(r);
		return c._open = !!(a === 42 ? u : u && (i || !d)), c._close = !!(a === 42 ? d : d && (l || !u)), t(o);
	}
}
function xg(e, t) {
	e.column += t, e.offset += t, e._bufferIndex += t;
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/autolink.js
var Sg = {
	name: "autolink",
	tokenize: Cg
};
function Cg(e, t, n) {
	let r = 0;
	return i;
	function i(t) {
		return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(t), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
	}
	function a(t) {
		return Yh(t) ? (e.consume(t), o) : t === 64 ? n(t) : l(t);
	}
	function o(e) {
		return e === 43 || e === 45 || e === 46 || Xh(e) ? (r = 1, s(e)) : l(e);
	}
	function s(t) {
		return t === 58 ? (e.consume(t), r = 0, c) : (t === 43 || t === 45 || t === 46 || Xh(t)) && r++ < 32 ? (e.consume(t), s) : (r = 0, l(t));
	}
	function c(r) {
		return r === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(r), e.exit("autolinkMarker"), e.exit("autolink"), t) : r === null || r === 32 || r === 60 || Qh(r) ? n(r) : (e.consume(r), c);
	}
	function l(t) {
		return t === 64 ? (e.consume(t), u) : Zh(t) ? (e.consume(t), l) : n(t);
	}
	function u(e) {
		return Xh(e) ? d(e) : n(e);
	}
	function d(n) {
		return n === 46 ? (e.consume(n), r = 0, u) : n === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(n), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(n);
	}
	function f(t) {
		if ((t === 45 || Xh(t)) && r++ < 63) {
			let n = t === 45 ? f : d;
			return e.consume(t), n;
		}
		return n(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/blank-line.js
var wg = {
	partial: !0,
	tokenize: Tg
};
function Tg(e, t, n) {
	return r;
	function r(t) {
		return ig(t) ? lg(e, i, "linePrefix")(t) : i(t);
	}
	function i(e) {
		return e === null || ng(e) ? t(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/block-quote.js
var Eg = {
	continuation: { tokenize: Og },
	exit: kg,
	name: "blockQuote",
	tokenize: Dg
};
function Dg(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		if (t === 62) {
			let n = r.containerState;
			return n.open ||= (e.enter("blockQuote", { _container: !0 }), !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(t), e.exit("blockQuoteMarker"), a;
		}
		return n(t);
	}
	function a(n) {
		return ig(n) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(n), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(n));
	}
}
function Og(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return ig(t) ? lg(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : a(t);
	}
	function a(r) {
		return e.attempt(Eg, t, n)(r);
	}
}
function kg(e) {
	e.exit("blockQuote");
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/character-escape.js
var Ag = {
	name: "characterEscape",
	tokenize: jg
};
function jg(e, t, n) {
	return r;
	function r(t) {
		return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(t), e.exit("escapeMarker"), i;
	}
	function i(r) {
		return tg(r) ? (e.enter("characterEscapeValue"), e.consume(r), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/character-reference.js
var Mg = {
	name: "characterReference",
	tokenize: Ng
};
function Ng(e, t, n) {
	let r = this, i = 0, a, o;
	return s;
	function s(t) {
		return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(t), e.exit("characterReferenceMarker"), c;
	}
	function c(t) {
		return t === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(t), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), a = 31, o = Xh, u(t));
	}
	function l(t) {
		return t === 88 || t === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(t), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = eg, u) : (e.enter("characterReferenceValue"), a = 7, o = $h, u(t));
	}
	function u(s) {
		if (s === 59 && i) {
			let i = e.exit("characterReferenceValue");
			return o === Xh && !Bh(r.sliceSerialize(i)) ? n(s) : (e.enter("characterReferenceMarker"), e.consume(s), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
		}
		return o(s) && i++ < a ? (e.consume(s), u) : n(s);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/code-fenced.js
var Pg = {
	partial: !0,
	tokenize: Lg
}, Fg = {
	concrete: !0,
	name: "codeFenced",
	tokenize: Ig
};
function Ig(e, t, n) {
	let r = this, i = {
		partial: !0,
		tokenize: x
	}, a = 0, o = 0, s;
	return c;
	function c(e) {
		return l(e);
	}
	function l(t) {
		let n = r.events[r.events.length - 1];
		return a = n && n[1].type === "linePrefix" ? n[2].sliceSerialize(n[1], !0).length : 0, s = t, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(t);
	}
	function u(t) {
		return t === s ? (o++, e.consume(t), u) : o < 3 ? n(t) : (e.exit("codeFencedFenceSequence"), ig(t) ? lg(e, d, "whitespace")(t) : d(t));
	}
	function d(n) {
		return n === null || ng(n) ? (e.exit("codeFencedFence"), r.interrupt ? t(n) : e.check(Pg, h, b)(n)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", { contentType: "string" }), f(n));
	}
	function f(t) {
		return t === null || ng(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(t)) : ig(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), lg(e, p, "whitespace")(t)) : t === 96 && t === s ? n(t) : (e.consume(t), f);
	}
	function p(t) {
		return t === null || ng(t) ? d(t) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", { contentType: "string" }), m(t));
	}
	function m(t) {
		return t === null || ng(t) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(t)) : t === 96 && t === s ? n(t) : (e.consume(t), m);
	}
	function h(t) {
		return e.attempt(i, b, g)(t);
	}
	function g(t) {
		return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), _;
	}
	function _(t) {
		return a > 0 && ig(t) ? lg(e, v, "linePrefix", a + 1)(t) : v(t);
	}
	function v(t) {
		return t === null || ng(t) ? e.check(Pg, h, b)(t) : (e.enter("codeFlowValue"), y(t));
	}
	function y(t) {
		return t === null || ng(t) ? (e.exit("codeFlowValue"), v(t)) : (e.consume(t), y);
	}
	function b(n) {
		return e.exit("codeFenced"), t(n);
	}
	function x(e, t, n) {
		let i = 0;
		return a;
		function a(t) {
			return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), c;
		}
		function c(t) {
			return e.enter("codeFencedFence"), ig(t) ? lg(e, l, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : l(t);
		}
		function l(t) {
			return t === s ? (e.enter("codeFencedFenceSequence"), u(t)) : n(t);
		}
		function u(t) {
			return t === s ? (i++, e.consume(t), u) : i >= o ? (e.exit("codeFencedFenceSequence"), ig(t) ? lg(e, d, "whitespace")(t) : d(t)) : n(t);
		}
		function d(r) {
			return r === null || ng(r) ? (e.exit("codeFencedFence"), t(r)) : n(r);
		}
	}
}
function Lg(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return t === null ? n(t) : (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), a);
	}
	function a(e) {
		return r.parser.lazy[r.now().line] ? n(e) : t(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/code-indented.js
var Rg = {
	name: "codeIndented",
	tokenize: Bg
}, zg = {
	partial: !0,
	tokenize: Vg
};
function Bg(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.enter("codeIndented"), lg(e, a, "linePrefix", 5)(t);
	}
	function a(e) {
		let t = r.events[r.events.length - 1];
		return t && t[1].type === "linePrefix" && t[2].sliceSerialize(t[1], !0).length >= 4 ? o(e) : n(e);
	}
	function o(t) {
		return t === null ? c(t) : ng(t) ? e.attempt(zg, o, c)(t) : (e.enter("codeFlowValue"), s(t));
	}
	function s(t) {
		return t === null || ng(t) ? (e.exit("codeFlowValue"), o(t)) : (e.consume(t), s);
	}
	function c(n) {
		return e.exit("codeIndented"), t(n);
	}
}
function Vg(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return r.parser.lazy[r.now().line] ? n(t) : ng(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), i) : lg(e, a, "linePrefix", 5)(t);
	}
	function a(e) {
		let a = r.events[r.events.length - 1];
		return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(e) : ng(e) ? i(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/code-text.js
var Hg = {
	name: "codeText",
	previous: Wg,
	resolve: Ug,
	tokenize: Gg
};
function Ug(e) {
	let t = e.length - 4, n = 3, r, i;
	if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
		for (r = n; ++r < t;) if (e[r][1].type === "codeTextData") {
			e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
			break;
		}
	}
	for (r = n - 1, t++; ++r <= t;) i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
	return e;
}
function Wg(e) {
	return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Gg(e, t, n) {
	let r = 0, i, a;
	return o;
	function o(t) {
		return e.enter("codeText"), e.enter("codeTextSequence"), s(t);
	}
	function s(t) {
		return t === 96 ? (e.consume(t), r++, s) : (e.exit("codeTextSequence"), c(t));
	}
	function c(t) {
		return t === null ? n(t) : t === 32 ? (e.enter("space"), e.consume(t), e.exit("space"), c) : t === 96 ? (a = e.enter("codeTextSequence"), i = 0, u(t)) : ng(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), c) : (e.enter("codeTextData"), l(t));
	}
	function l(t) {
		return t === null || t === 32 || t === 96 || ng(t) ? (e.exit("codeTextData"), c(t)) : (e.consume(t), l);
	}
	function u(n) {
		return n === 96 ? (e.consume(n), i++, u) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(n)) : (a.type = "codeTextData", l(n));
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-subtokenize/lib/splice-buffer.js
var Kg = class {
	constructor(e) {
		this.left = e ? [...e] : [], this.right = [];
	}
	get(e) {
		if (e < 0 || e >= this.left.length + this.right.length) throw RangeError("Cannot access index `" + e + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
		return e < this.left.length ? this.left[e] : this.right[this.right.length - e + this.left.length - 1];
	}
	get length() {
		return this.left.length + this.right.length;
	}
	shift() {
		return this.setCursor(0), this.right.pop();
	}
	slice(e, t) {
		let n = t ?? Infinity;
		return n < this.left.length ? this.left.slice(e, n) : e > this.left.length ? this.right.slice(this.right.length - n + this.left.length, this.right.length - e + this.left.length).reverse() : this.left.slice(e).concat(this.right.slice(this.right.length - n + this.left.length).reverse());
	}
	splice(e, t, n) {
		let r = t || 0;
		this.setCursor(Math.trunc(e));
		let i = this.right.splice(this.right.length - r, Infinity);
		return n && qg(this.left, n), i.reverse();
	}
	pop() {
		return this.setCursor(Infinity), this.left.pop();
	}
	push(e) {
		this.setCursor(Infinity), this.left.push(e);
	}
	pushMany(e) {
		this.setCursor(Infinity), qg(this.left, e);
	}
	unshift(e) {
		this.setCursor(0), this.right.push(e);
	}
	unshiftMany(e) {
		this.setCursor(0), qg(this.right, e.reverse());
	}
	setCursor(e) {
		if (!(e === this.left.length || e > this.left.length && this.right.length === 0 || e < 0 && this.left.length === 0)) if (e < this.left.length) {
			let t = this.left.splice(e, Infinity);
			qg(this.right, t.reverse());
		} else {
			let t = this.right.splice(this.left.length + this.right.length - e, Infinity);
			qg(this.left, t.reverse());
		}
	}
};
function qg(e, t) {
	let n = 0;
	if (t.length < 1e4) e.push(...t);
	else for (; n < t.length;) e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
//#endregion
//#region ../../../node_modules/micromark-util-subtokenize/index.js
function Jg(e) {
	let t = {}, n = -1, r, i, a, o, s, c, l, u = new Kg(e);
	for (; ++n < u.length;) {
		for (; n in t;) n = t[n];
		if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, a = 0, a < c.length && c[a][1].type === "lineEndingBlank" && (a += 2), a < c.length && c[a][1].type === "content")) for (; ++a < c.length && c[a][1].type !== "content";) c[a][1].type === "chunkText" && (c[a][1]._isInFirstContentOfListItem = !0, a++);
		if (r[0] === "enter") r[1].contentType && (Object.assign(t, Yg(u, n)), n = t[n], l = !0);
		else if (r[1]._container) {
			for (a = n, i = void 0; a-- && (o = u.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank");) o[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
			i && (r[1].end = { ...u.get(i)[1].start }, s = u.slice(i, n), s.unshift(r), u.splice(i, n - i + 1, s));
		}
	}
	return Vh(e, 0, Infinity, u.slice(0)), !l;
}
function Yg(e, t) {
	let n = e.get(t)[1], r = e.get(t)[2], i = t - 1, a = [], o = n._tokenizer || r.parser[n.contentType](n.start), s = o.events, c = [], l = {}, u, d, f = -1, p = n, m = 0, h = 0, g = [h];
	for (; p;) {
		for (; e.get(++i)[1] !== p;);
		a.push(i), p._tokenizer || (u = r.sliceStream(p), p.next || u.push(null), d && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = p, p = p.next;
	}
	for (p = n; ++f < s.length;) s[f][0] === "exit" && s[f - 1][0] === "enter" && s[f][1].type === s[f - 1][1].type && s[f][1].start.line !== s[f][1].end.line && (h = f + 1, g.push(h), p._tokenizer = void 0, p.previous = void 0, p = p.next);
	for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : g.pop(), f = g.length; f--;) {
		let t = s.slice(g[f], g[f + 1]), n = a.pop();
		c.push([n, n + t.length - 1]), e.splice(n, 2, t);
	}
	for (c.reverse(), f = -1; ++f < c.length;) l[m + c[f][0]] = m + c[f][1], m += c[f][1] - c[f][0] - 1;
	return l;
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/content.js
var Xg = {
	resolve: Qg,
	tokenize: $g
}, Zg = {
	partial: !0,
	tokenize: e_
};
function Qg(e) {
	return Jg(e), e;
}
function $g(e, t) {
	let n;
	return r;
	function r(t) {
		return e.enter("content"), n = e.enter("chunkContent", { contentType: "content" }), i(t);
	}
	function i(t) {
		return t === null ? a(t) : ng(t) ? e.check(Zg, o, a)(t) : (e.consume(t), i);
	}
	function a(n) {
		return e.exit("chunkContent"), e.exit("content"), t(n);
	}
	function o(t) {
		return e.consume(t), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
			contentType: "content",
			previous: n
		}), n = n.next, i;
	}
}
function e_(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), lg(e, a, "linePrefix");
	}
	function a(i) {
		if (i === null || ng(i)) return n(i);
		let a = r.events[r.events.length - 1];
		return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(i) : e.interrupt(r.parser.constructs.flow, n, t)(i);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-destination/index.js
function t_(e, t, n, r, i, a, o, s, c) {
	let l = c || Infinity, u = 0;
	return d;
	function d(t) {
		return t === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(t), e.exit(a), f) : t === null || t === 32 || t === 41 || Qh(t) ? n(t) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", { contentType: "string" }), h(t));
	}
	function f(n) {
		return n === 62 ? (e.enter(a), e.consume(n), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", { contentType: "string" }), p(n));
	}
	function p(t) {
		return t === 62 ? (e.exit("chunkString"), e.exit(s), f(t)) : t === null || t === 60 || ng(t) ? n(t) : (e.consume(t), t === 92 ? m : p);
	}
	function m(t) {
		return t === 60 || t === 62 || t === 92 ? (e.consume(t), p) : p(t);
	}
	function h(i) {
		return !u && (i === null || i === 41 || rg(i)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(i)) : u < l && i === 40 ? (e.consume(i), u++, h) : i === 41 ? (e.consume(i), u--, h) : i === null || i === 32 || i === 40 || Qh(i) ? n(i) : (e.consume(i), i === 92 ? g : h);
	}
	function g(t) {
		return t === 40 || t === 41 || t === 92 ? (e.consume(t), h) : h(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-label/index.js
function n_(e, t, n, r, i, a) {
	let o = this, s = 0, c;
	return l;
	function l(t) {
		return e.enter(r), e.enter(i), e.consume(t), e.exit(i), e.enter(a), u;
	}
	function u(l) {
		return s > 999 || l === null || l === 91 || l === 93 && !c || l === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(l) : l === 93 ? (e.exit(a), e.enter(i), e.consume(l), e.exit(i), e.exit(r), t) : ng(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), u) : (e.enter("chunkString", { contentType: "string" }), d(l));
	}
	function d(t) {
		return t === null || t === 91 || t === 93 || ng(t) || s++ > 999 ? (e.exit("chunkString"), u(t)) : (e.consume(t), c ||= !ig(t), t === 92 ? f : d);
	}
	function f(t) {
		return t === 91 || t === 92 || t === 93 ? (e.consume(t), s++, d) : d(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-title/index.js
function r_(e, t, n, r, i, a) {
	let o;
	return s;
	function s(t) {
		return t === 34 || t === 39 || t === 40 ? (e.enter(r), e.enter(i), e.consume(t), e.exit(i), o = t === 40 ? 41 : t, c) : n(t);
	}
	function c(n) {
		return n === o ? (e.enter(i), e.consume(n), e.exit(i), e.exit(r), t) : (e.enter(a), l(n));
	}
	function l(t) {
		return t === o ? (e.exit(a), c(o)) : t === null ? n(t) : ng(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), lg(e, l, "linePrefix")) : (e.enter("chunkString", { contentType: "string" }), u(t));
	}
	function u(t) {
		return t === o || t === null || ng(t) ? (e.exit("chunkString"), l(t)) : (e.consume(t), t === 92 ? d : u);
	}
	function d(t) {
		return t === o || t === 92 ? (e.consume(t), u) : u(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-factory-whitespace/index.js
function i_(e, t) {
	let n;
	return r;
	function r(i) {
		return ng(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : ig(i) ? lg(e, r, n ? "linePrefix" : "lineSuffix")(i) : t(i);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/definition.js
var a_ = {
	name: "definition",
	tokenize: s_
}, o_ = {
	partial: !0,
	tokenize: c_
};
function s_(e, t, n) {
	let r = this, i;
	return a;
	function a(t) {
		return e.enter("definition"), o(t);
	}
	function o(t) {
		return n_.call(r, e, s, n, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(t);
	}
	function s(t) {
		return i = Jh(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), t === 58 ? (e.enter("definitionMarker"), e.consume(t), e.exit("definitionMarker"), c) : n(t);
	}
	function c(t) {
		return rg(t) ? i_(e, l)(t) : l(t);
	}
	function l(t) {
		return t_(e, u, n, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(t);
	}
	function u(t) {
		return e.attempt(o_, d, d)(t);
	}
	function d(t) {
		return ig(t) ? lg(e, f, "whitespace")(t) : f(t);
	}
	function f(a) {
		return a === null || ng(a) ? (e.exit("definition"), r.parser.defined.push(i), t(a)) : n(a);
	}
}
function c_(e, t, n) {
	return r;
	function r(t) {
		return rg(t) ? i_(e, i)(t) : n(t);
	}
	function i(t) {
		return r_(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(t);
	}
	function a(t) {
		return ig(t) ? lg(e, o, "whitespace")(t) : o(t);
	}
	function o(e) {
		return e === null || ng(e) ? t(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/hard-break-escape.js
var l_ = {
	name: "hardBreakEscape",
	tokenize: u_
};
function u_(e, t, n) {
	return r;
	function r(t) {
		return e.enter("hardBreakEscape"), e.consume(t), i;
	}
	function i(r) {
		return ng(r) ? (e.exit("hardBreakEscape"), t(r)) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/heading-atx.js
var d_ = {
	name: "headingAtx",
	resolve: f_,
	tokenize: p_
};
function f_(e, t) {
	let n = e.length - 2, r = 3, i, a;
	return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
		type: "atxHeadingText",
		start: e[r][1].start,
		end: e[n][1].end
	}, a = {
		type: "chunkText",
		start: e[r][1].start,
		end: e[n][1].end,
		contentType: "text"
	}, Vh(e, r, n - r + 1, [
		[
			"enter",
			i,
			t
		],
		[
			"enter",
			a,
			t
		],
		[
			"exit",
			a,
			t
		],
		[
			"exit",
			i,
			t
		]
	])), e;
}
function p_(e, t, n) {
	let r = 0;
	return i;
	function i(t) {
		return e.enter("atxHeading"), a(t);
	}
	function a(t) {
		return e.enter("atxHeadingSequence"), o(t);
	}
	function o(t) {
		return t === 35 && r++ < 6 ? (e.consume(t), o) : t === null || rg(t) ? (e.exit("atxHeadingSequence"), s(t)) : n(t);
	}
	function s(n) {
		return n === 35 ? (e.enter("atxHeadingSequence"), c(n)) : n === null || ng(n) ? (e.exit("atxHeading"), t(n)) : ig(n) ? lg(e, s, "whitespace")(n) : (e.enter("atxHeadingText"), l(n));
	}
	function c(t) {
		return t === 35 ? (e.consume(t), c) : (e.exit("atxHeadingSequence"), s(t));
	}
	function l(t) {
		return t === null || t === 35 || rg(t) ? (e.exit("atxHeadingText"), s(t)) : (e.consume(t), l);
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-html-tag-name/index.js
var m_ = /* @__PURE__ */ "address.article.aside.base.basefont.blockquote.body.caption.center.col.colgroup.dd.details.dialog.dir.div.dl.dt.fieldset.figcaption.figure.footer.form.frame.frameset.h1.h2.h3.h4.h5.h6.head.header.hr.html.iframe.legend.li.link.main.menu.menuitem.nav.noframes.ol.optgroup.option.p.param.search.section.summary.table.tbody.td.tfoot.th.thead.title.tr.track.ul".split("."), h_ = [
	"pre",
	"script",
	"style",
	"textarea"
], g_ = {
	concrete: !0,
	name: "htmlFlow",
	resolveTo: y_,
	tokenize: b_
}, __ = {
	partial: !0,
	tokenize: S_
}, v_ = {
	partial: !0,
	tokenize: x_
};
function y_(e) {
	let t = e.length;
	for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"););
	return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function b_(e, t, n) {
	let r = this, i, a, o, s, c;
	return l;
	function l(e) {
		return u(e);
	}
	function u(t) {
		return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(t), d;
	}
	function d(s) {
		return s === 33 ? (e.consume(s), f) : s === 47 ? (e.consume(s), a = !0, h) : s === 63 ? (e.consume(s), i = 3, r.interrupt ? t : F) : Yh(s) ? (e.consume(s), o = String.fromCharCode(s), g) : n(s);
	}
	function f(a) {
		return a === 45 ? (e.consume(a), i = 2, p) : a === 91 ? (e.consume(a), i = 5, s = 0, m) : Yh(a) ? (e.consume(a), i = 4, r.interrupt ? t : F) : n(a);
	}
	function p(i) {
		return i === 45 ? (e.consume(i), r.interrupt ? t : F) : n(i);
	}
	function m(i) {
		return i === "CDATA[".charCodeAt(s++) ? (e.consume(i), s === 6 ? r.interrupt ? t : O : m) : n(i);
	}
	function h(t) {
		return Yh(t) ? (e.consume(t), o = String.fromCharCode(t), g) : n(t);
	}
	function g(s) {
		if (s === null || s === 47 || s === 62 || rg(s)) {
			let c = s === 47, l = o.toLowerCase();
			return !c && !a && h_.includes(l) ? (i = 1, r.interrupt ? t(s) : O(s)) : m_.includes(o.toLowerCase()) ? (i = 6, c ? (e.consume(s), _) : r.interrupt ? t(s) : O(s)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(s) : a ? v(s) : y(s));
		}
		return s === 45 || Xh(s) ? (e.consume(s), o += String.fromCharCode(s), g) : n(s);
	}
	function _(i) {
		return i === 62 ? (e.consume(i), r.interrupt ? t : O) : n(i);
	}
	function v(t) {
		return ig(t) ? (e.consume(t), v) : E(t);
	}
	function y(t) {
		return t === 47 ? (e.consume(t), E) : t === 58 || t === 95 || Yh(t) ? (e.consume(t), b) : ig(t) ? (e.consume(t), y) : E(t);
	}
	function b(t) {
		return t === 45 || t === 46 || t === 58 || t === 95 || Xh(t) ? (e.consume(t), b) : x(t);
	}
	function x(t) {
		return t === 61 ? (e.consume(t), S) : ig(t) ? (e.consume(t), x) : y(t);
	}
	function S(t) {
		return t === null || t === 60 || t === 61 || t === 62 || t === 96 ? n(t) : t === 34 || t === 39 ? (e.consume(t), c = t, C) : ig(t) ? (e.consume(t), S) : w(t);
	}
	function C(t) {
		return t === c ? (e.consume(t), c = null, T) : t === null || ng(t) ? n(t) : (e.consume(t), C);
	}
	function w(t) {
		return t === null || t === 34 || t === 39 || t === 47 || t === 60 || t === 61 || t === 62 || t === 96 || rg(t) ? x(t) : (e.consume(t), w);
	}
	function T(e) {
		return e === 47 || e === 62 || ig(e) ? y(e) : n(e);
	}
	function E(t) {
		return t === 62 ? (e.consume(t), D) : n(t);
	}
	function D(t) {
		return t === null || ng(t) ? O(t) : ig(t) ? (e.consume(t), D) : n(t);
	}
	function O(t) {
		return t === 45 && i === 2 ? (e.consume(t), M) : t === 60 && i === 1 ? (e.consume(t), N) : t === 62 && i === 4 ? (e.consume(t), I) : t === 63 && i === 3 ? (e.consume(t), F) : t === 93 && i === 5 ? (e.consume(t), ee) : ng(t) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(__, te, k)(t)) : t === null || ng(t) ? (e.exit("htmlFlowData"), k(t)) : (e.consume(t), O);
	}
	function k(t) {
		return e.check(v_, A, te)(t);
	}
	function A(t) {
		return e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), j;
	}
	function j(t) {
		return t === null || ng(t) ? k(t) : (e.enter("htmlFlowData"), O(t));
	}
	function M(t) {
		return t === 45 ? (e.consume(t), F) : O(t);
	}
	function N(t) {
		return t === 47 ? (e.consume(t), o = "", P) : O(t);
	}
	function P(t) {
		if (t === 62) {
			let n = o.toLowerCase();
			return h_.includes(n) ? (e.consume(t), I) : O(t);
		}
		return Yh(t) && o.length < 8 ? (e.consume(t), o += String.fromCharCode(t), P) : O(t);
	}
	function ee(t) {
		return t === 93 ? (e.consume(t), F) : O(t);
	}
	function F(t) {
		return t === 62 ? (e.consume(t), I) : t === 45 && i === 2 ? (e.consume(t), F) : O(t);
	}
	function I(t) {
		return t === null || ng(t) ? (e.exit("htmlFlowData"), te(t)) : (e.consume(t), I);
	}
	function te(n) {
		return e.exit("htmlFlow"), t(n);
	}
}
function x_(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return ng(t) ? (e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), a) : n(t);
	}
	function a(e) {
		return r.parser.lazy[r.now().line] ? n(e) : t(e);
	}
}
function S_(e, t, n) {
	return r;
	function r(r) {
		return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), e.attempt(wg, t, n);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/html-text.js
var C_ = {
	name: "htmlText",
	tokenize: w_
};
function w_(e, t, n) {
	let r = this, i, a, o;
	return s;
	function s(t) {
		return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(t), c;
	}
	function c(t) {
		return t === 33 ? (e.consume(t), l) : t === 47 ? (e.consume(t), x) : t === 63 ? (e.consume(t), y) : Yh(t) ? (e.consume(t), w) : n(t);
	}
	function l(t) {
		return t === 45 ? (e.consume(t), u) : t === 91 ? (e.consume(t), a = 0, m) : Yh(t) ? (e.consume(t), v) : n(t);
	}
	function u(t) {
		return t === 45 ? (e.consume(t), p) : n(t);
	}
	function d(t) {
		return t === null ? n(t) : t === 45 ? (e.consume(t), f) : ng(t) ? (o = d, N(t)) : (e.consume(t), d);
	}
	function f(t) {
		return t === 45 ? (e.consume(t), p) : d(t);
	}
	function p(e) {
		return e === 62 ? M(e) : e === 45 ? f(e) : d(e);
	}
	function m(t) {
		return t === "CDATA[".charCodeAt(a++) ? (e.consume(t), a === 6 ? h : m) : n(t);
	}
	function h(t) {
		return t === null ? n(t) : t === 93 ? (e.consume(t), g) : ng(t) ? (o = h, N(t)) : (e.consume(t), h);
	}
	function g(t) {
		return t === 93 ? (e.consume(t), _) : h(t);
	}
	function _(t) {
		return t === 62 ? M(t) : t === 93 ? (e.consume(t), _) : h(t);
	}
	function v(t) {
		return t === null || t === 62 ? M(t) : ng(t) ? (o = v, N(t)) : (e.consume(t), v);
	}
	function y(t) {
		return t === null ? n(t) : t === 63 ? (e.consume(t), b) : ng(t) ? (o = y, N(t)) : (e.consume(t), y);
	}
	function b(e) {
		return e === 62 ? M(e) : y(e);
	}
	function x(t) {
		return Yh(t) ? (e.consume(t), S) : n(t);
	}
	function S(t) {
		return t === 45 || Xh(t) ? (e.consume(t), S) : C(t);
	}
	function C(t) {
		return ng(t) ? (o = C, N(t)) : ig(t) ? (e.consume(t), C) : M(t);
	}
	function w(t) {
		return t === 45 || Xh(t) ? (e.consume(t), w) : t === 47 || t === 62 || rg(t) ? T(t) : n(t);
	}
	function T(t) {
		return t === 47 ? (e.consume(t), M) : t === 58 || t === 95 || Yh(t) ? (e.consume(t), E) : ng(t) ? (o = T, N(t)) : ig(t) ? (e.consume(t), T) : M(t);
	}
	function E(t) {
		return t === 45 || t === 46 || t === 58 || t === 95 || Xh(t) ? (e.consume(t), E) : D(t);
	}
	function D(t) {
		return t === 61 ? (e.consume(t), O) : ng(t) ? (o = D, N(t)) : ig(t) ? (e.consume(t), D) : T(t);
	}
	function O(t) {
		return t === null || t === 60 || t === 61 || t === 62 || t === 96 ? n(t) : t === 34 || t === 39 ? (e.consume(t), i = t, k) : ng(t) ? (o = O, N(t)) : ig(t) ? (e.consume(t), O) : (e.consume(t), A);
	}
	function k(t) {
		return t === i ? (e.consume(t), i = void 0, j) : t === null ? n(t) : ng(t) ? (o = k, N(t)) : (e.consume(t), k);
	}
	function A(t) {
		return t === null || t === 34 || t === 39 || t === 60 || t === 61 || t === 96 ? n(t) : t === 47 || t === 62 || rg(t) ? T(t) : (e.consume(t), A);
	}
	function j(e) {
		return e === 47 || e === 62 || rg(e) ? T(e) : n(e);
	}
	function M(r) {
		return r === 62 ? (e.consume(r), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(r);
	}
	function N(t) {
		return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(t), e.exit("lineEnding"), P;
	}
	function P(t) {
		return ig(t) ? lg(e, ee, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(t) : ee(t);
	}
	function ee(t) {
		return e.enter("htmlTextData"), o(t);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/label-end.js
var T_ = {
	name: "labelEnd",
	resolveAll: k_,
	resolveTo: A_,
	tokenize: j_
}, E_ = { tokenize: M_ }, D_ = { tokenize: N_ }, O_ = { tokenize: P_ };
function k_(e) {
	let t = -1, n = [];
	for (; ++t < e.length;) {
		let r = e[t][1];
		if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
			let e = r.type === "labelImage" ? 4 : 2;
			r.type = "data", t += e;
		}
	}
	return e.length !== n.length && Vh(e, 0, e.length, n), e;
}
function A_(e, t) {
	let n = e.length, r = 0, i, a, o, s;
	for (; n--;) if (i = e[n][1], a) {
		if (i.type === "link" || i.type === "labelLink" && i._inactive) break;
		e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
	} else if (o) {
		if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
			r = 2;
			break;
		}
	} else i.type === "labelEnd" && (o = n);
	let c = {
		type: e[a][1].type === "labelLink" ? "link" : "image",
		start: { ...e[a][1].start },
		end: { ...e[e.length - 1][1].end }
	}, l = {
		type: "label",
		start: { ...e[a][1].start },
		end: { ...e[o][1].end }
	}, u = {
		type: "labelText",
		start: { ...e[a + r + 2][1].end },
		end: { ...e[o - 2][1].start }
	};
	return s = [[
		"enter",
		c,
		t
	], [
		"enter",
		l,
		t
	]], s = Hh(s, e.slice(a + 1, a + r + 3)), s = Hh(s, [[
		"enter",
		u,
		t
	]]), s = Hh(s, _g(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), t)), s = Hh(s, [
		[
			"exit",
			u,
			t
		],
		e[o - 2],
		e[o - 1],
		[
			"exit",
			l,
			t
		]
	]), s = Hh(s, e.slice(o + 1)), s = Hh(s, [[
		"exit",
		c,
		t
	]]), Vh(e, a, e.length, s), e;
}
function j_(e, t, n) {
	let r = this, i = r.events.length, a, o;
	for (; i--;) if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
		a = r.events[i][1];
		break;
	}
	return s;
	function s(t) {
		return a ? a._inactive ? d(t) : (o = r.parser.defined.includes(Jh(r.sliceSerialize({
			start: a.end,
			end: r.now()
		}))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(t);
	}
	function c(t) {
		return t === 40 ? e.attempt(E_, u, o ? u : d)(t) : t === 91 ? e.attempt(D_, u, o ? l : d)(t) : o ? u(t) : d(t);
	}
	function l(t) {
		return e.attempt(O_, u, d)(t);
	}
	function u(e) {
		return t(e);
	}
	function d(e) {
		return a._balanced = !0, n(e);
	}
}
function M_(e, t, n) {
	return r;
	function r(t) {
		return e.enter("resource"), e.enter("resourceMarker"), e.consume(t), e.exit("resourceMarker"), i;
	}
	function i(t) {
		return rg(t) ? i_(e, a)(t) : a(t);
	}
	function a(t) {
		return t === 41 ? u(t) : t_(e, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(t);
	}
	function o(t) {
		return rg(t) ? i_(e, c)(t) : u(t);
	}
	function s(e) {
		return n(e);
	}
	function c(t) {
		return t === 34 || t === 39 || t === 40 ? r_(e, l, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(t) : u(t);
	}
	function l(t) {
		return rg(t) ? i_(e, u)(t) : u(t);
	}
	function u(r) {
		return r === 41 ? (e.enter("resourceMarker"), e.consume(r), e.exit("resourceMarker"), e.exit("resource"), t) : n(r);
	}
}
function N_(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return n_.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(t);
	}
	function a(e) {
		return r.parser.defined.includes(Jh(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(e) : n(e);
	}
	function o(e) {
		return n(e);
	}
}
function P_(e, t, n) {
	return r;
	function r(t) {
		return e.enter("reference"), e.enter("referenceMarker"), e.consume(t), e.exit("referenceMarker"), i;
	}
	function i(r) {
		return r === 93 ? (e.enter("referenceMarker"), e.consume(r), e.exit("referenceMarker"), e.exit("reference"), t) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/label-start-image.js
var F_ = {
	name: "labelStartImage",
	resolveAll: T_.resolveAll,
	tokenize: I_
};
function I_(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(t), e.exit("labelImageMarker"), a;
	}
	function a(t) {
		return t === 91 ? (e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelImage"), o) : n(t);
	}
	function o(e) {
		/* c8 ignore next 3 */
		return e === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(e) : t(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/label-start-link.js
var L_ = {
	name: "labelStartLink",
	resolveAll: T_.resolveAll,
	tokenize: R_
};
function R_(e, t, n) {
	let r = this;
	return i;
	function i(t) {
		return e.enter("labelLink"), e.enter("labelMarker"), e.consume(t), e.exit("labelMarker"), e.exit("labelLink"), a;
	}
	function a(e) {
		/* c8 ignore next 3 */
		return e === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(e) : t(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/line-ending.js
var z_ = {
	name: "lineEnding",
	tokenize: B_
};
function B_(e, t) {
	return n;
	function n(n) {
		return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), lg(e, t, "linePrefix");
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/thematic-break.js
var V_ = {
	name: "thematicBreak",
	tokenize: H_
};
function H_(e, t, n) {
	let r = 0, i;
	return a;
	function a(t) {
		return e.enter("thematicBreak"), o(t);
	}
	function o(e) {
		return i = e, s(e);
	}
	function s(a) {
		return a === i ? (e.enter("thematicBreakSequence"), c(a)) : r >= 3 && (a === null || ng(a)) ? (e.exit("thematicBreak"), t(a)) : n(a);
	}
	function c(t) {
		return t === i ? (e.consume(t), r++, c) : (e.exit("thematicBreakSequence"), ig(t) ? lg(e, s, "whitespace")(t) : s(t));
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/list.js
var U_ = {
	continuation: { tokenize: q_ },
	exit: Y_,
	name: "list",
	tokenize: K_
}, W_ = {
	partial: !0,
	tokenize: X_
}, G_ = {
	partial: !0,
	tokenize: J_
};
function K_(e, t, n) {
	let r = this, i = r.events[r.events.length - 1], a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
	return s;
	function s(t) {
		let i = r.containerState.type || (t === 42 || t === 43 || t === 45 ? "listUnordered" : "listOrdered");
		if (i === "listUnordered" ? !r.containerState.marker || t === r.containerState.marker : $h(t)) {
			if (r.containerState.type || (r.containerState.type = i, e.enter(i, { _container: !0 })), i === "listUnordered") return e.enter("listItemPrefix"), t === 42 || t === 45 ? e.check(V_, n, l)(t) : l(t);
			if (!r.interrupt || t === 49) return e.enter("listItemPrefix"), e.enter("listItemValue"), c(t);
		}
		return n(t);
	}
	function c(t) {
		return $h(t) && ++o < 10 ? (e.consume(t), c) : (!r.interrupt || o < 2) && (r.containerState.marker ? t === r.containerState.marker : t === 41 || t === 46) ? (e.exit("listItemValue"), l(t)) : n(t);
	}
	function l(t) {
		return e.enter("listItemMarker"), e.consume(t), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || t, e.check(wg, r.interrupt ? n : u, e.attempt(W_, f, d));
	}
	function u(e) {
		return r.containerState.initialBlankLine = !0, a++, f(e);
	}
	function d(t) {
		return ig(t) ? (e.enter("listItemPrefixWhitespace"), e.consume(t), e.exit("listItemPrefixWhitespace"), f) : n(t);
	}
	function f(n) {
		return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(n);
	}
}
function q_(e, t, n) {
	let r = this;
	return r.containerState._closeFlow = void 0, e.check(wg, i, a);
	function i(n) {
		return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, lg(e, t, "listItemIndent", r.containerState.size + 1)(n);
	}
	function a(n) {
		return r.containerState.furtherBlankLines || !ig(n) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(n)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(G_, t, o)(n));
	}
	function o(i) {
		return r.containerState._closeFlow = !0, r.interrupt = void 0, lg(e, e.attempt(U_, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(i);
	}
}
function J_(e, t, n) {
	let r = this;
	return lg(e, i, "listItemIndent", r.containerState.size + 1);
	function i(e) {
		let i = r.events[r.events.length - 1];
		return i && i[1].type === "listItemIndent" && i[2].sliceSerialize(i[1], !0).length === r.containerState.size ? t(e) : n(e);
	}
}
function Y_(e) {
	e.exit(this.containerState.type);
}
function X_(e, t, n) {
	let r = this;
	return lg(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
	function i(e) {
		let i = r.events[r.events.length - 1];
		return !ig(e) && i && i[1].type === "listItemPrefixWhitespace" ? t(e) : n(e);
	}
}
//#endregion
//#region ../../../node_modules/micromark-core-commonmark/lib/setext-underline.js
var Z_ = {
	name: "setextUnderline",
	resolveTo: Q_,
	tokenize: $_
};
function Q_(e, t) {
	let n = e.length, r, i, a;
	for (; n--;) if (e[n][0] === "enter") {
		if (e[n][1].type === "content") {
			r = n;
			break;
		}
		e[n][1].type === "paragraph" && (i = n);
	} else e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
	let o = {
		type: "setextHeading",
		start: { ...e[i][1].start },
		end: { ...e[e.length - 1][1].end }
	};
	return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, [
		"enter",
		o,
		t
	]), e.splice(a + 1, 0, [
		"exit",
		e[r][1],
		t
	]), e[r][1].end = { ...e[a][1].end }) : e[r][1] = o, e.push([
		"exit",
		o,
		t
	]), e;
}
function $_(e, t, n) {
	let r = this, i;
	return a;
	function a(t) {
		let a = r.events.length, s;
		for (; a--;) if (r.events[a][1].type !== "lineEnding" && r.events[a][1].type !== "linePrefix" && r.events[a][1].type !== "content") {
			s = r.events[a][1].type === "paragraph";
			break;
		}
		return !r.parser.lazy[r.now().line] && (r.interrupt || s) ? (e.enter("setextHeadingLine"), i = t, o(t)) : n(t);
	}
	function o(t) {
		return e.enter("setextHeadingLineSequence"), s(t);
	}
	function s(t) {
		return t === i ? (e.consume(t), s) : (e.exit("setextHeadingLineSequence"), ig(t) ? lg(e, c, "lineSuffix")(t) : c(t));
	}
	function c(r) {
		return r === null || ng(r) ? (e.exit("setextHeadingLine"), t(r)) : n(r);
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/flow.js
var ev = { tokenize: tv };
function tv(e) {
	let t = this, n = e.attempt(wg, r, e.attempt(this.parser.constructs.flowInitial, i, lg(e, e.attempt(this.parser.constructs.flow, i, e.attempt(Xg, i)), "linePrefix")));
	return n;
	function r(r) {
		if (r === null) {
			e.consume(r);
			return;
		}
		return e.enter("lineEndingBlank"), e.consume(r), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
	}
	function i(r) {
		if (r === null) {
			e.consume(r);
			return;
		}
		return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), t.currentConstruct = void 0, n;
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/initialize/text.js
var nv = { resolveAll: ov() }, rv = av("string"), iv = av("text");
function av(e) {
	return {
		resolveAll: ov(e === "text" ? sv : void 0),
		tokenize: t
	};
	function t(t) {
		let n = this, r = this.parser.constructs[e], i = t.attempt(r, a, o);
		return a;
		function a(e) {
			return c(e) ? i(e) : o(e);
		}
		function o(e) {
			if (e === null) {
				t.consume(e);
				return;
			}
			return t.enter("data"), t.consume(e), s;
		}
		function s(e) {
			return c(e) ? (t.exit("data"), i(e)) : (t.consume(e), s);
		}
		function c(e) {
			if (e === null) return !0;
			let t = r[e], i = -1;
			if (t) for (; ++i < t.length;) {
				let e = t[i];
				if (!e.previous || e.previous.call(n, n.previous)) return !0;
			}
			return !1;
		}
	}
}
function ov(e) {
	return t;
	function t(t, n) {
		let r = -1, i;
		for (; ++r <= t.length;) i === void 0 ? t[r] && t[r][1].type === "data" && (i = r, r++) : (!t[r] || t[r][1].type !== "data") && (r !== i + 2 && (t[i][1].end = t[r - 1][1].end, t.splice(i + 2, r - i - 2), r = i + 2), i = void 0);
		return e ? e(t, n) : t;
	}
}
function sv(e, t) {
	let n = 0;
	for (; ++n <= e.length;) if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
		let r = e[n - 1][1], i = t.sliceStream(r), a = i.length, o = -1, s = 0, c;
		for (; a--;) {
			let e = i[a];
			if (typeof e == "string") {
				for (o = e.length; e.charCodeAt(o - 1) === 32;) s++, o--;
				if (o) break;
				o = -1;
			} else if (e === -2) c = !0, s++;
			else if (e !== -1) {
				a++;
				break;
			}
		}
		if (s) {
			let i = {
				type: n === e.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
				start: {
					_bufferIndex: a ? o : r.start._bufferIndex + o,
					_index: r.start._index + a,
					line: r.end.line,
					column: r.end.column - s,
					offset: r.end.offset - s
				},
				end: { ...r.end }
			};
			r.end = { ...i.start }, r.start.offset === r.end.offset ? Object.assign(r, i) : (e.splice(n, 0, [
				"enter",
				i,
				t
			], [
				"exit",
				i,
				t
			]), n += 2);
		}
		n++;
	}
	return e;
}
//#endregion
//#region ../../../node_modules/micromark/lib/constructs.js
var cv = /* @__PURE__ */ Ot({
	attentionMarkers: () => gv,
	contentInitial: () => uv,
	disable: () => _v,
	document: () => lv,
	flow: () => fv,
	flowInitial: () => dv,
	insideSpan: () => hv,
	string: () => pv,
	text: () => mv
}), lv = {
	42: U_,
	43: U_,
	45: U_,
	48: U_,
	49: U_,
	50: U_,
	51: U_,
	52: U_,
	53: U_,
	54: U_,
	55: U_,
	56: U_,
	57: U_,
	62: Eg
}, uv = { 91: a_ }, dv = {
	[-2]: Rg,
	[-1]: Rg,
	32: Rg
}, fv = {
	35: d_,
	42: V_,
	45: [Z_, V_],
	60: g_,
	61: Z_,
	95: V_,
	96: Fg,
	126: Fg
}, pv = {
	38: Mg,
	92: Ag
}, mv = {
	[-5]: z_,
	[-4]: z_,
	[-3]: z_,
	33: F_,
	38: Mg,
	42: vg,
	60: [Sg, C_],
	91: L_,
	92: [l_, Ag],
	93: T_,
	95: vg,
	96: Hg
}, hv = { null: [vg, nv] }, gv = { null: [42, 95] }, _v = { null: [] };
//#endregion
//#region ../../../node_modules/micromark/lib/create-tokenizer.js
function vv(e, t, n) {
	let r = {
		_bufferIndex: -1,
		_index: 0,
		line: n && n.line || 1,
		column: n && n.column || 1,
		offset: n && n.offset || 0
	}, i = {}, a = [], o = [], s = [], c = {
		attempt: C(x),
		check: C(S),
		consume: v,
		enter: y,
		exit: b,
		interrupt: C(S, { interrupt: !0 })
	}, l = {
		code: null,
		containerState: {},
		defineSkip: h,
		events: [],
		now: m,
		parser: e,
		previous: null,
		sliceSerialize: f,
		sliceStream: p,
		write: d
	}, u = t.tokenize.call(l, c);
	return t.resolveAll && a.push(t), l;
	function d(e) {
		return o = Hh(o, e), g(), o[o.length - 1] === null ? (w(t, 0), l.events = _g(a, l.events, l), l.events) : [];
	}
	function f(e, t) {
		return bv(p(e), t);
	}
	function p(e) {
		return yv(o, e);
	}
	function m() {
		let { _bufferIndex: e, _index: t, line: n, column: i, offset: a } = r;
		return {
			_bufferIndex: e,
			_index: t,
			line: n,
			column: i,
			offset: a
		};
	}
	function h(e) {
		i[e.line] = e.column, E();
	}
	function g() {
		let e;
		for (; r._index < o.length;) {
			let t = o[r._index];
			if (typeof t == "string") for (e = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === e && r._bufferIndex < t.length;) _(t.charCodeAt(r._bufferIndex));
			else _(t);
		}
	}
	function _(e) {
		u = u(e);
	}
	function v(e) {
		ng(e) ? (r.line++, r.column = 1, r.offset += e === -3 ? 2 : 1, E()) : e !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = e;
	}
	function y(e, t) {
		let n = t || {};
		return n.type = e, n.start = m(), l.events.push([
			"enter",
			n,
			l
		]), s.push(n), n;
	}
	function b(e) {
		let t = s.pop();
		return t.end = m(), l.events.push([
			"exit",
			t,
			l
		]), t;
	}
	function x(e, t) {
		w(e, t.from);
	}
	function S(e, t) {
		t.restore();
	}
	function C(e, t) {
		return n;
		function n(n, r, i) {
			let a, o, s, u;
			return Array.isArray(n) ? f(n) : "tokenize" in n ? f([n]) : d(n);
			function d(e) {
				return t;
				function t(t) {
					let n = t !== null && e[t], r = t !== null && e.null;
					return f([...Array.isArray(n) ? n : n ? [n] : [], ...Array.isArray(r) ? r : r ? [r] : []])(t);
				}
			}
			function f(e) {
				return a = e, o = 0, e.length === 0 ? i : p(e[o]);
			}
			function p(e) {
				return n;
				function n(n) {
					return u = T(), s = e, e.partial || (l.currentConstruct = e), e.name && l.parser.constructs.disable.null.includes(e.name) ? h(n) : e.tokenize.call(t ? Object.assign(Object.create(l), t) : l, c, m, h)(n);
				}
			}
			function m(t) {
				return e(s, u), r;
			}
			function h(e) {
				return u.restore(), ++o < a.length ? p(a[o]) : i;
			}
		}
	}
	function w(e, t) {
		e.resolveAll && !a.includes(e) && a.push(e), e.resolve && Vh(l.events, t, l.events.length - t, e.resolve(l.events.slice(t), l)), e.resolveTo && (l.events = e.resolveTo(l.events, l));
	}
	function T() {
		let e = m(), t = l.previous, n = l.currentConstruct, i = l.events.length, a = Array.from(s);
		return {
			from: i,
			restore: o
		};
		function o() {
			r = e, l.previous = t, l.currentConstruct = n, l.events.length = i, s = a, E();
		}
	}
	function E() {
		r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
	}
}
function yv(e, t) {
	let n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex, o;
	if (n === i) o = [e[n].slice(r, a)];
	else {
		if (o = e.slice(n, i), r > -1) {
			let e = o[0];
			typeof e == "string" ? o[0] = e.slice(r) : o.shift();
		}
		a > 0 && o.push(e[i].slice(0, a));
	}
	return o;
}
function bv(e, t) {
	let n = -1, r = [], i;
	for (; ++n < e.length;) {
		let a = e[n], o;
		if (typeof a == "string") o = a;
		else switch (a) {
			case -5:
				o = "\r";
				break;
			case -4:
				o = "\n";
				break;
			case -3:
				o = "\r\n";
				break;
			case -2:
				o = t ? " " : "	";
				break;
			case -1:
				if (!t && i) continue;
				o = " ";
				break;
			default: o = String.fromCharCode(a);
		}
		i = a === -2, r.push(o);
	}
	return r.join("");
}
//#endregion
//#region ../../../node_modules/micromark/lib/parse.js
function xv(e) {
	let t = {
		constructs: Wh([cv, ...(e || {}).extensions || []]),
		content: n(ug),
		defined: [],
		document: n(fg),
		flow: n(ev),
		lazy: {},
		string: n(rv),
		text: n(iv)
	};
	return t;
	function n(e) {
		return n;
		function n(n) {
			return vv(t, e, n);
		}
	}
}
//#endregion
//#region ../../../node_modules/micromark/lib/postprocess.js
function Sv(e) {
	for (; !Jg(e););
	return e;
}
//#endregion
//#region ../../../node_modules/micromark/lib/preprocess.js
var Cv = /[\0\t\n\r]/g;
function wv() {
	let e = 1, t = "", n = !0, r;
	return i;
	function i(i, a, o) {
		let s = [], c, l, u, d, f;
		for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(a || void 0).decode(i)), u = 0, t = "", n &&= (i.charCodeAt(0) === 65279 && u++, void 0); u < i.length;) {
			if (Cv.lastIndex = u, c = Cv.exec(i), d = c && c.index !== void 0 ? c.index : i.length, f = i.charCodeAt(d), !c) {
				t = i.slice(u);
				break;
			}
			if (f === 10 && u === d && r) s.push(-3), r = void 0;
			else switch (r &&= (s.push(-5), void 0), u < d && (s.push(i.slice(u, d)), e += d - u), f) {
				case 0:
					s.push(65533), e++;
					break;
				case 9:
					for (l = Math.ceil(e / 4) * 4, s.push(-2); e++ < l;) s.push(-1);
					break;
				case 10:
					s.push(-4), e = 1;
					break;
				default: r = !0, e = 1;
			}
			u = d + 1;
		}
		return o && (r && s.push(-5), t && s.push(t), s.push(null)), s;
	}
}
//#endregion
//#region ../../../node_modules/micromark-util-decode-string/index.js
var Tv = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Ev(e) {
	return e.replace(Tv, Dv);
}
function Dv(e, t, n) {
	if (t) return t;
	if (n.charCodeAt(0) === 35) {
		let e = n.charCodeAt(1), t = e === 120 || e === 88;
		return qh(n.slice(t ? 2 : 1), t ? 16 : 10);
	}
	return Bh(n) || e;
}
//#endregion
//#region ../../../node_modules/mdast-util-from-markdown/lib/index.js
var Ov = {}.hasOwnProperty;
function kv(e, t, n) {
	return typeof t != "string" && (n = t, t = void 0), Av(n)(Sv(xv(n).document().write(wv()(e, t, !0))));
}
function Av(e) {
	let t = {
		transforms: [],
		canContainEols: [
			"emphasis",
			"fragment",
			"heading",
			"paragraph",
			"strong"
		],
		enter: {
			autolink: a(he),
			autolinkProtocol: T,
			autolinkEmail: T,
			atxHeading: a(de),
			blockQuote: a(oe),
			characterEscape: T,
			characterReference: T,
			codeFenced: a(se),
			codeFencedFenceInfo: o,
			codeFencedFenceMeta: o,
			codeIndented: a(se, o),
			codeText: a(ce, o),
			codeTextData: T,
			data: T,
			codeFlowValue: T,
			definition: a(le),
			definitionDestinationString: o,
			definitionLabelString: o,
			definitionTitleString: o,
			emphasis: a(ue),
			hardBreakEscape: a(fe),
			hardBreakTrailing: a(fe),
			htmlFlow: a(pe, o),
			htmlFlowData: T,
			htmlText: a(pe, o),
			htmlTextData: T,
			image: a(me),
			label: o,
			link: a(he),
			listItem: a(_e),
			listItemValue: f,
			listOrdered: a(ge, d),
			listUnordered: a(ge),
			paragraph: a(ve),
			reference: L,
			referenceString: o,
			resourceDestinationString: o,
			resourceTitleString: o,
			setextHeading: a(de),
			strong: a(ye),
			thematicBreak: a(xe)
		},
		exit: {
			atxHeading: c(),
			atxHeadingSequence: x,
			autolink: c(),
			autolinkEmail: z,
			autolinkProtocol: ae,
			blockQuote: c(),
			characterEscapeValue: E,
			characterReferenceMarkerHexadecimal: re,
			characterReferenceMarkerNumeric: re,
			characterReferenceValue: ie,
			characterReference: R,
			codeFenced: c(g),
			codeFencedFence: h,
			codeFencedFenceInfo: p,
			codeFencedFenceMeta: m,
			codeFlowValue: E,
			codeIndented: c(_),
			codeText: c(j),
			codeTextData: E,
			data: E,
			definition: c(),
			definitionDestinationString: b,
			definitionLabelString: v,
			definitionTitleString: y,
			emphasis: c(),
			hardBreakEscape: c(O),
			hardBreakTrailing: c(O),
			htmlFlow: c(k),
			htmlFlowData: E,
			htmlText: c(A),
			htmlTextData: E,
			image: c(N),
			label: ee,
			labelText: P,
			lineEnding: D,
			link: c(M),
			listItem: c(),
			listOrdered: c(),
			listUnordered: c(),
			paragraph: c(),
			referenceString: ne,
			resourceDestinationString: F,
			resourceTitleString: I,
			resource: te,
			setextHeading: c(w),
			setextHeadingLineSequence: C,
			setextHeadingText: S,
			strong: c(),
			thematicBreak: c()
		}
	};
	Mv(t, (e || {}).mdastExtensions || []);
	let n = {};
	return r;
	function r(e) {
		let r = {
			type: "root",
			children: []
		}, a = {
			stack: [r],
			tokenStack: [],
			config: t,
			enter: s,
			exit: l,
			buffer: o,
			resume: u,
			data: n
		}, c = [], d = -1;
		for (; ++d < e.length;) (e[d][1].type === "listOrdered" || e[d][1].type === "listUnordered") && (e[d][0] === "enter" ? c.push(d) : d = i(e, c.pop(), d));
		for (d = -1; ++d < e.length;) {
			let n = t[e[d][0]];
			Ov.call(n, e[d][1].type) && n[e[d][1].type].call(Object.assign({ sliceSerialize: e[d][2].sliceSerialize }, a), e[d][1]);
		}
		if (a.tokenStack.length > 0) {
			let e = a.tokenStack[a.tokenStack.length - 1];
			(e[1] || Pv).call(a, void 0, e[0]);
		}
		for (r.position = {
			start: jv(e.length > 0 ? e[0][1].start : {
				line: 1,
				column: 1,
				offset: 0
			}),
			end: jv(e.length > 0 ? e[e.length - 2][1].end : {
				line: 1,
				column: 1,
				offset: 0
			})
		}, d = -1; ++d < t.transforms.length;) r = t.transforms[d](r) || r;
		return r;
	}
	function i(e, t, n) {
		let r = t - 1, i = -1, a = !1, o, s, c, l;
		for (; ++r <= n;) {
			let t = e[r];
			switch (t[1].type) {
				case "listUnordered":
				case "listOrdered":
				case "blockQuote":
					t[0] === "enter" ? i++ : i--, l = void 0;
					break;
				case "lineEndingBlank":
					t[0] === "enter" && (o && !l && !i && !c && (c = r), l = void 0);
					break;
				case "linePrefix":
				case "listItemValue":
				case "listItemMarker":
				case "listItemPrefix":
				case "listItemPrefixWhitespace": break;
				default: l = void 0;
			}
			if (!i && t[0] === "enter" && t[1].type === "listItemPrefix" || i === -1 && t[0] === "exit" && (t[1].type === "listUnordered" || t[1].type === "listOrdered")) {
				if (o) {
					let i = r;
					for (s = void 0; i--;) {
						let t = e[i];
						if (t[1].type === "lineEnding" || t[1].type === "lineEndingBlank") {
							if (t[0] === "exit") continue;
							s && (e[s][1].type = "lineEndingBlank", a = !0), t[1].type = "lineEnding", s = i;
						} else if (!(t[1].type === "linePrefix" || t[1].type === "blockQuotePrefix" || t[1].type === "blockQuotePrefixWhitespace" || t[1].type === "blockQuoteMarker" || t[1].type === "listItemIndent")) break;
					}
					c && (!s || c < s) && (o._spread = !0), o.end = Object.assign({}, s ? e[s][1].start : t[1].end), e.splice(s || r, 0, [
						"exit",
						o,
						t[2]
					]), r++, n++;
				}
				if (t[1].type === "listItemPrefix") {
					let i = {
						type: "listItem",
						_spread: !1,
						start: Object.assign({}, t[1].start),
						end: void 0
					};
					o = i, e.splice(r, 0, [
						"enter",
						i,
						t[2]
					]), r++, n++, c = void 0, l = !0;
				}
			}
		}
		return e[t][1]._spread = a, n;
	}
	function a(e, t) {
		return n;
		function n(n) {
			s.call(this, e(n), n), t && t.call(this, n);
		}
	}
	function o() {
		this.stack.push({
			type: "fragment",
			children: []
		});
	}
	function s(e, t, n) {
		this.stack[this.stack.length - 1].children.push(e), this.stack.push(e), this.tokenStack.push([t, n || void 0]), e.position = {
			start: jv(t.start),
			end: void 0
		};
	}
	function c(e) {
		return t;
		function t(t) {
			e && e.call(this, t), l.call(this, t);
		}
	}
	function l(e, t) {
		let n = this.stack.pop(), r = this.tokenStack.pop();
		if (r) r[0].type !== e.type && (t ? t.call(this, e, r[0]) : (r[1] || Pv).call(this, e, r[0]));
		else throw Error("Cannot close `" + e.type + "` (" + $m({
			start: e.start,
			end: e.end
		}) + "): it’s not open");
		n.position.end = jv(e.end);
	}
	function u() {
		return Fh(this.stack.pop());
	}
	function d() {
		this.data.expectingFirstListItemValue = !0;
	}
	function f(e) {
		if (this.data.expectingFirstListItemValue) {
			let t = this.stack[this.stack.length - 2];
			t.start = Number.parseInt(this.sliceSerialize(e), 10), this.data.expectingFirstListItemValue = void 0;
		}
	}
	function p() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.lang = e;
	}
	function m() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.meta = e;
	}
	function h() {
		this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
	}
	function g() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
	}
	function _() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e.replace(/(\r?\n|\r)$/g, "");
	}
	function v(e) {
		let t = this.resume(), n = this.stack[this.stack.length - 1];
		n.label = t, n.identifier = Jh(this.sliceSerialize(e)).toLowerCase();
	}
	function y() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.title = e;
	}
	function b() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.url = e;
	}
	function x(e) {
		let t = this.stack[this.stack.length - 1];
		t.depth ||= this.sliceSerialize(e).length;
	}
	function S() {
		this.data.setextHeadingSlurpLineEnding = !0;
	}
	function C(e) {
		let t = this.stack[this.stack.length - 1];
		t.depth = this.sliceSerialize(e).codePointAt(0) === 61 ? 1 : 2;
	}
	function w() {
		this.data.setextHeadingSlurpLineEnding = void 0;
	}
	function T(e) {
		let t = this.stack[this.stack.length - 1].children, n = t[t.length - 1];
		(!n || n.type !== "text") && (n = be(), n.position = {
			start: jv(e.start),
			end: void 0
		}, t.push(n)), this.stack.push(n);
	}
	function E(e) {
		let t = this.stack.pop();
		t.value += this.sliceSerialize(e), t.position.end = jv(e.end);
	}
	function D(e) {
		let n = this.stack[this.stack.length - 1];
		if (this.data.atHardBreak) {
			let t = n.children[n.children.length - 1];
			t.position.end = jv(e.end), this.data.atHardBreak = void 0;
			return;
		}
		!this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(n.type) && (T.call(this, e), E.call(this, e));
	}
	function O() {
		this.data.atHardBreak = !0;
	}
	function k() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e;
	}
	function A() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e;
	}
	function j() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.value = e;
	}
	function M() {
		let e = this.stack[this.stack.length - 1];
		if (this.data.inReference) {
			let t = this.data.referenceType || "shortcut";
			e.type += "Reference", e.referenceType = t, delete e.url, delete e.title;
		} else delete e.identifier, delete e.label;
		this.data.referenceType = void 0;
	}
	function N() {
		let e = this.stack[this.stack.length - 1];
		if (this.data.inReference) {
			let t = this.data.referenceType || "shortcut";
			e.type += "Reference", e.referenceType = t, delete e.url, delete e.title;
		} else delete e.identifier, delete e.label;
		this.data.referenceType = void 0;
	}
	function P(e) {
		let t = this.sliceSerialize(e), n = this.stack[this.stack.length - 2];
		n.label = Ev(t), n.identifier = Jh(t).toLowerCase();
	}
	function ee() {
		let e = this.stack[this.stack.length - 1], t = this.resume(), n = this.stack[this.stack.length - 1];
		this.data.inReference = !0, n.type === "link" ? n.children = e.children : n.alt = t;
	}
	function F() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.url = e;
	}
	function I() {
		let e = this.resume(), t = this.stack[this.stack.length - 1];
		t.title = e;
	}
	function te() {
		this.data.inReference = void 0;
	}
	function L() {
		this.data.referenceType = "collapsed";
	}
	function ne(e) {
		let t = this.resume(), n = this.stack[this.stack.length - 1];
		n.label = t, n.identifier = Jh(this.sliceSerialize(e)).toLowerCase(), this.data.referenceType = "full";
	}
	function re(e) {
		this.data.characterReferenceType = e.type;
	}
	function ie(e) {
		let t = this.sliceSerialize(e), n = this.data.characterReferenceType, r;
		n ? (r = qh(t, n === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : r = Bh(t);
		let i = this.stack[this.stack.length - 1];
		i.value += r;
	}
	function R(e) {
		let t = this.stack.pop();
		t.position.end = jv(e.end);
	}
	function ae(e) {
		E.call(this, e);
		let t = this.stack[this.stack.length - 1];
		t.url = this.sliceSerialize(e);
	}
	function z(e) {
		E.call(this, e);
		let t = this.stack[this.stack.length - 1];
		t.url = "mailto:" + this.sliceSerialize(e);
	}
	function oe() {
		return {
			type: "blockquote",
			children: []
		};
	}
	function se() {
		return {
			type: "code",
			lang: null,
			meta: null,
			value: ""
		};
	}
	function ce() {
		return {
			type: "inlineCode",
			value: ""
		};
	}
	function le() {
		return {
			type: "definition",
			identifier: "",
			label: null,
			title: null,
			url: ""
		};
	}
	function ue() {
		return {
			type: "emphasis",
			children: []
		};
	}
	function de() {
		return {
			type: "heading",
			depth: 0,
			children: []
		};
	}
	function fe() {
		return { type: "break" };
	}
	function pe() {
		return {
			type: "html",
			value: ""
		};
	}
	function me() {
		return {
			type: "image",
			title: null,
			url: "",
			alt: null
		};
	}
	function he() {
		return {
			type: "link",
			title: null,
			url: "",
			children: []
		};
	}
	function ge(e) {
		return {
			type: "list",
			ordered: e.type === "listOrdered",
			start: null,
			spread: e._spread,
			children: []
		};
	}
	function _e(e) {
		return {
			type: "listItem",
			spread: e._spread,
			checked: null,
			children: []
		};
	}
	function ve() {
		return {
			type: "paragraph",
			children: []
		};
	}
	function ye() {
		return {
			type: "strong",
			children: []
		};
	}
	function be() {
		return {
			type: "text",
			value: ""
		};
	}
	function xe() {
		return { type: "thematicBreak" };
	}
}
function jv(e) {
	return {
		line: e.line,
		column: e.column,
		offset: e.offset
	};
}
function Mv(e, t) {
	let n = -1;
	for (; ++n < t.length;) {
		let r = t[n];
		Array.isArray(r) ? Mv(e, r) : Nv(e, r);
	}
}
function Nv(e, t) {
	let n;
	for (n in t) if (Ov.call(t, n)) switch (n) {
		case "canContainEols": {
			let r = t[n];
			r && e[n].push(...r);
			break;
		}
		case "transforms": {
			let r = t[n];
			r && e[n].push(...r);
			break;
		}
		case "enter":
		case "exit": {
			let r = t[n];
			r && Object.assign(e[n], r);
			break;
		}
	}
}
function Pv(e, t) {
	throw Error(e ? "Cannot close `" + e.type + "` (" + $m({
		start: e.start,
		end: e.end
	}) + "): a different token (`" + t.type + "`, " + $m({
		start: t.start,
		end: t.end
	}) + ") is open" : "Cannot close document, a token (`" + t.type + "`, " + $m({
		start: t.start,
		end: t.end
	}) + ") is still open");
}
//#endregion
//#region ../../../node_modules/remark-parse/lib/index.js
function Fv(e) {
	let t = this;
	t.parser = n;
	function n(n) {
		return kv(n, {
			...t.data("settings"),
			...e,
			extensions: t.data("micromarkExtensions") || [],
			mdastExtensions: t.data("fromMarkdownExtensions") || []
		});
	}
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
function Iv(e, t) {
	let n = {
		type: "element",
		tagName: "blockquote",
		properties: {},
		children: e.wrap(e.all(t), !0)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/break.js
function Lv(e, t) {
	let n = {
		type: "element",
		tagName: "br",
		properties: {},
		children: []
	};
	return e.patch(t, n), [e.applyData(t, n), {
		type: "text",
		value: "\n"
	}];
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/code.js
function Rv(e, t) {
	let n = t.value ? t.value + "\n" : "", r = {}, i = t.lang ? t.lang.split(/\s+/) : [];
	i.length > 0 && (r.className = ["language-" + i[0]]);
	let a = {
		type: "element",
		tagName: "code",
		properties: r,
		children: [{
			type: "text",
			value: n
		}]
	};
	return t.meta && (a.data = { meta: t.meta }), e.patch(t, a), a = e.applyData(t, a), a = {
		type: "element",
		tagName: "pre",
		properties: {},
		children: [a]
	}, e.patch(t, a), a;
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/delete.js
function zv(e, t) {
	let n = {
		type: "element",
		tagName: "del",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
function Bv(e, t) {
	let n = {
		type: "element",
		tagName: "em",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
function Vv(e, t) {
	let n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = cg(r.toLowerCase()), a = e.footnoteOrder.indexOf(r), o, s = e.footnoteCounts.get(r);
	s === void 0 ? (s = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, s += 1, e.footnoteCounts.set(r, s);
	let c = {
		type: "element",
		tagName: "a",
		properties: {
			href: "#" + n + "fn-" + i,
			id: n + "fnref-" + i + (s > 1 ? "-" + s : ""),
			dataFootnoteRef: !0,
			ariaDescribedBy: ["footnote-label"]
		},
		children: [{
			type: "text",
			value: String(o)
		}]
	};
	e.patch(t, c);
	let l = {
		type: "element",
		tagName: "sup",
		properties: {},
		children: [c]
	};
	return e.patch(t, l), e.applyData(t, l);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/heading.js
function Hv(e, t) {
	let n = {
		type: "element",
		tagName: "h" + t.depth,
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/html.js
function Uv(e, t) {
	if (e.options.allowDangerousHtml) {
		let n = {
			type: "raw",
			value: t.value
		};
		return e.patch(t, n), e.applyData(t, n);
	}
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/revert.js
function Wv(e, t) {
	let n = t.referenceType, r = "]";
	if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference") return [{
		type: "text",
		value: "![" + t.alt + r
	}];
	let i = e.all(t), a = i[0];
	a && a.type === "text" ? a.value = "[" + a.value : i.unshift({
		type: "text",
		value: "["
	});
	let o = i[i.length - 1];
	return o && o.type === "text" ? o.value += r : i.push({
		type: "text",
		value: r
	}), i;
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
function Gv(e, t) {
	let n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
	if (!r) return Wv(e, t);
	let i = {
		src: cg(r.url || ""),
		alt: t.alt
	};
	r.title !== null && r.title !== void 0 && (i.title = r.title);
	let a = {
		type: "element",
		tagName: "img",
		properties: i,
		children: []
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/image.js
function Kv(e, t) {
	let n = { src: cg(t.url) };
	t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
	let r = {
		type: "element",
		tagName: "img",
		properties: n,
		children: []
	};
	return e.patch(t, r), e.applyData(t, r);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
function qv(e, t) {
	let n = {
		type: "text",
		value: t.value.replace(/\r?\n|\r/g, " ")
	};
	e.patch(t, n);
	let r = {
		type: "element",
		tagName: "code",
		properties: {},
		children: [n]
	};
	return e.patch(t, r), e.applyData(t, r);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
function Jv(e, t) {
	let n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
	if (!r) return Wv(e, t);
	let i = { href: cg(r.url || "") };
	r.title !== null && r.title !== void 0 && (i.title = r.title);
	let a = {
		type: "element",
		tagName: "a",
		properties: i,
		children: e.all(t)
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/link.js
function Yv(e, t) {
	let n = { href: cg(t.url) };
	t.title !== null && t.title !== void 0 && (n.title = t.title);
	let r = {
		type: "element",
		tagName: "a",
		properties: n,
		children: e.all(t)
	};
	return e.patch(t, r), e.applyData(t, r);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/list-item.js
function Xv(e, t, n) {
	let r = e.all(t), i = n ? Zv(n) : Qv(t), a = {}, o = [];
	if (typeof t.checked == "boolean") {
		let e = r[0], n;
		e && e.type === "element" && e.tagName === "p" ? n = e : (n = {
			type: "element",
			tagName: "p",
			properties: {},
			children: []
		}, r.unshift(n)), n.children.length > 0 && n.children.unshift({
			type: "text",
			value: " "
		}), n.children.unshift({
			type: "element",
			tagName: "input",
			properties: {
				type: "checkbox",
				checked: t.checked,
				disabled: !0
			},
			children: []
		}), a.className = ["task-list-item"];
	}
	let s = -1;
	for (; ++s < r.length;) {
		let e = r[s];
		(i || s !== 0 || e.type !== "element" || e.tagName !== "p") && o.push({
			type: "text",
			value: "\n"
		}), e.type === "element" && e.tagName === "p" && !i ? o.push(...e.children) : o.push(e);
	}
	let c = r[r.length - 1];
	c && (i || c.type !== "element" || c.tagName !== "p") && o.push({
		type: "text",
		value: "\n"
	});
	let l = {
		type: "element",
		tagName: "li",
		properties: a,
		children: o
	};
	return e.patch(t, l), e.applyData(t, l);
}
function Zv(e) {
	let t = !1;
	if (e.type === "list") {
		t = e.spread || !1;
		let n = e.children, r = -1;
		for (; !t && ++r < n.length;) t = Qv(n[r]);
	}
	return t;
}
function Qv(e) {
	return e.spread ?? e.children.length > 1;
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/list.js
function $v(e, t) {
	let n = {}, r = e.all(t), i = -1;
	for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length;) {
		let e = r[i];
		if (e.type === "element" && e.tagName === "li" && e.properties && Array.isArray(e.properties.className) && e.properties.className.includes("task-list-item")) {
			n.className = ["contains-task-list"];
			break;
		}
	}
	let a = {
		type: "element",
		tagName: t.ordered ? "ol" : "ul",
		properties: n,
		children: e.wrap(r, !0)
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
function ey(e, t) {
	let n = {
		type: "element",
		tagName: "p",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/root.js
function ty(e, t) {
	let n = {
		type: "root",
		children: e.wrap(e.all(t))
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/strong.js
function ny(e, t) {
	let n = {
		type: "element",
		tagName: "strong",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/table.js
function ry(e, t) {
	let n = e.all(t), r = n.shift(), i = [];
	if (r) {
		let n = {
			type: "element",
			tagName: "thead",
			properties: {},
			children: e.wrap([r], !0)
		};
		e.patch(t.children[0], n), i.push(n);
	}
	if (n.length > 0) {
		let r = {
			type: "element",
			tagName: "tbody",
			properties: {},
			children: e.wrap(n, !0)
		}, a = Xm(t.children[1]), o = Ym(t.children[t.children.length - 1]);
		a && o && (r.position = {
			start: a,
			end: o
		}), i.push(r);
	}
	let a = {
		type: "element",
		tagName: "table",
		properties: {},
		children: e.wrap(i, !0)
	};
	return e.patch(t, a), e.applyData(t, a);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/table-row.js
function iy(e, t, n) {
	let r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, o = a ? a.length : t.children.length, s = -1, c = [];
	for (; ++s < o;) {
		let n = t.children[s], r = {}, o = a ? a[s] : void 0;
		o && (r.align = o);
		let l = {
			type: "element",
			tagName: i,
			properties: r,
			children: []
		};
		n && (l.children = e.all(n), e.patch(n, l), l = e.applyData(n, l)), c.push(l);
	}
	let l = {
		type: "element",
		tagName: "tr",
		properties: {},
		children: e.wrap(c, !0)
	};
	return e.patch(t, l), e.applyData(t, l);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/table-cell.js
function ay(e, t) {
	let n = {
		type: "element",
		tagName: "td",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/trim-lines/index.js
var oy = 9, sy = 32;
function cy(e) {
	let t = String(e), n = /\r?\n|\r/g, r = n.exec(t), i = 0, a = [];
	for (; r;) a.push(ly(t.slice(i, r.index), i > 0, !0), r[0]), i = r.index + r[0].length, r = n.exec(t);
	return a.push(ly(t.slice(i), i > 0, !1)), a.join("");
}
function ly(e, t, n) {
	let r = 0, i = e.length;
	if (t) {
		let t = e.codePointAt(r);
		for (; t === oy || t === sy;) r++, t = e.codePointAt(r);
	}
	if (n) {
		let t = e.codePointAt(i - 1);
		for (; t === oy || t === sy;) i--, t = e.codePointAt(i - 1);
	}
	return i > r ? e.slice(r, i) : "";
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/text.js
function uy(e, t) {
	let n = {
		type: "text",
		value: cy(String(t.value))
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
function dy(e, t) {
	let n = {
		type: "element",
		tagName: "hr",
		properties: {},
		children: []
	};
	return e.patch(t, n), e.applyData(t, n);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/handlers/index.js
var fy = {
	blockquote: Iv,
	break: Lv,
	code: Rv,
	delete: zv,
	emphasis: Bv,
	footnoteReference: Vv,
	heading: Hv,
	html: Uv,
	imageReference: Gv,
	image: Kv,
	inlineCode: qv,
	linkReference: Jv,
	link: Yv,
	listItem: Xv,
	list: $v,
	paragraph: ey,
	root: ty,
	strong: ny,
	table: ry,
	tableCell: ay,
	tableRow: iy,
	text: uy,
	thematicBreak: dy,
	toml: py,
	yaml: py,
	definition: py,
	footnoteDefinition: py
};
function py() {}
//#endregion
//#region ../../../node_modules/@ungap/structured-clone/esm/deserialize.js
var my = typeof self == "object" ? self : globalThis, hy = (e, t) => {
	let n = (t, n) => (e.set(n, t), t), r = (i) => {
		if (e.has(i)) return e.get(i);
		let [a, o] = t[i];
		switch (a) {
			case 0:
			case -1: return n(o, i);
			case 1: {
				let e = n([], i);
				for (let t of o) e.push(r(t));
				return e;
			}
			case 2: {
				let e = n({}, i);
				for (let [t, n] of o) e[r(t)] = r(n);
				return e;
			}
			case 3: return n(new Date(o), i);
			case 4: {
				let { source: e, flags: t } = o;
				return n(new RegExp(e, t), i);
			}
			case 5: {
				let e = n(/* @__PURE__ */ new Map(), i);
				for (let [t, n] of o) e.set(r(t), r(n));
				return e;
			}
			case 6: {
				let e = n(/* @__PURE__ */ new Set(), i);
				for (let t of o) e.add(r(t));
				return e;
			}
			case 7: {
				let { name: e, message: t } = o;
				return n(new my[e](t), i);
			}
			case 8: return n(BigInt(o), i);
			case "BigInt": return n(Object(BigInt(o)), i);
		}
		return n(new my[a](o), i);
	};
	return r;
}, gy = (e) => hy(/* @__PURE__ */ new Map(), e)(0), _y = "", { toString: vy } = {}, { keys: yy } = Object, by = (e) => {
	let t = typeof e;
	if (t !== "object" || !e) return [0, t];
	let n = vy.call(e).slice(8, -1);
	switch (n) {
		case "Array": return [1, _y];
		case "Object": return [2, _y];
		case "Date": return [3, _y];
		case "RegExp": return [4, _y];
		case "Map": return [5, _y];
		case "Set": return [6, _y];
	}
	return n.includes("Array") ? [1, n] : n.includes("Error") ? [7, n] : [2, n];
}, xy = ([e, t]) => e === 0 && (t === "function" || t === "symbol"), Sy = (e, t, n, r) => {
	let i = (e, t) => {
		let i = r.push(e) - 1;
		return n.set(t, i), i;
	}, a = (r) => {
		if (n.has(r)) return n.get(r);
		let [o, s] = by(r);
		switch (o) {
			case 0: {
				let t = r;
				switch (s) {
					case "bigint":
						o = 8, t = r.toString();
						break;
					case "function":
					case "symbol":
						if (e) throw TypeError("unable to serialize " + s);
						t = null;
						break;
					case "undefined": return i([-1], r);
				}
				return i([o, t], r);
			}
			case 1: {
				if (s) return i([s, [...r]], r);
				let e = [], t = i([o, e], r);
				for (let t of r) e.push(a(t));
				return t;
			}
			case 2: {
				if (s) switch (s) {
					case "BigInt": return i([s, r.toString()], r);
					case "Boolean":
					case "Number":
					case "String": return i([s, r.valueOf()], r);
				}
				if (t && "toJSON" in r) return a(r.toJSON());
				let n = [], c = i([o, n], r);
				for (let t of yy(r)) (e || !xy(by(r[t]))) && n.push([a(t), a(r[t])]);
				return c;
			}
			case 3: return i([o, r.toISOString()], r);
			case 4: {
				let { source: e, flags: t } = r;
				return i([o, {
					source: e,
					flags: t
				}], r);
			}
			case 5: {
				let t = [], n = i([o, t], r);
				for (let [n, i] of r) (e || !(xy(by(n)) || xy(by(i)))) && t.push([a(n), a(i)]);
				return n;
			}
			case 6: {
				let t = [], n = i([o, t], r);
				for (let n of r) (e || !xy(by(n))) && t.push(a(n));
				return n;
			}
		}
		let { message: c } = r;
		return i([o, {
			name: s,
			message: c
		}], r);
	};
	return a;
}, Cy = (e, { json: t, lossy: n } = {}) => {
	let r = [];
	return Sy(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, wy = typeof structuredClone == "function" ? (e, t) => t && ("json" in t || "lossy" in t) ? gy(Cy(e, t)) : structuredClone(e) : (e, t) => gy(Cy(e, t));
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/footer.js
function Ty(e, t) {
	let n = [{
		type: "text",
		value: "↩"
	}];
	return t > 1 && n.push({
		type: "element",
		tagName: "sup",
		properties: {},
		children: [{
			type: "text",
			value: String(t)
		}]
	}), n;
}
function Ey(e, t) {
	return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function Dy(e) {
	let t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || Ty, r = e.options.footnoteBackLabel || Ey, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || { className: ["sr-only"] }, s = [], c = -1;
	for (; ++c < e.footnoteOrder.length;) {
		let i = e.footnoteById.get(e.footnoteOrder[c]);
		if (!i) continue;
		let a = e.all(i), o = String(i.identifier).toUpperCase(), l = cg(o.toLowerCase()), u = 0, d = [], f = e.footnoteCounts.get(o);
		for (; f !== void 0 && ++u <= f;) {
			d.length > 0 && d.push({
				type: "text",
				value: " "
			});
			let e = typeof n == "string" ? n : n(c, u);
			typeof e == "string" && (e = {
				type: "text",
				value: e
			}), d.push({
				type: "element",
				tagName: "a",
				properties: {
					href: "#" + t + "fnref-" + l + (u > 1 ? "-" + u : ""),
					dataFootnoteBackref: "",
					ariaLabel: typeof r == "string" ? r : r(c, u),
					className: ["data-footnote-backref"]
				},
				children: Array.isArray(e) ? e : [e]
			});
		}
		let p = a[a.length - 1];
		if (p && p.type === "element" && p.tagName === "p") {
			let e = p.children[p.children.length - 1];
			e && e.type === "text" ? e.value += " " : p.children.push({
				type: "text",
				value: " "
			}), p.children.push(...d);
		} else a.push(...d);
		let m = {
			type: "element",
			tagName: "li",
			properties: { id: t + "fn-" + l },
			children: e.wrap(a, !0)
		};
		e.patch(i, m), s.push(m);
	}
	if (s.length !== 0) return {
		type: "element",
		tagName: "section",
		properties: {
			dataFootnotes: !0,
			className: ["footnotes"]
		},
		children: [
			{
				type: "element",
				tagName: a,
				properties: {
					...wy(o),
					id: "footnote-label"
				},
				children: [{
					type: "text",
					value: i
				}]
			},
			{
				type: "text",
				value: "\n"
			},
			{
				type: "element",
				tagName: "ol",
				properties: {},
				children: e.wrap(s, !0)
			},
			{
				type: "text",
				value: "\n"
			}
		]
	};
}
//#endregion
//#region ../../../node_modules/unist-util-is/lib/index.js
var Oy = (function(e) {
	if (e == null) return Ny;
	if (typeof e == "function") return My(e);
	if (typeof e == "object") return Array.isArray(e) ? ky(e) : Ay(e);
	if (typeof e == "string") return jy(e);
	throw Error("Expected function, string, or object as test");
});
function ky(e) {
	let t = [], n = -1;
	for (; ++n < e.length;) t[n] = Oy(e[n]);
	return My(r);
	function r(...e) {
		let n = -1;
		for (; ++n < t.length;) if (t[n].apply(this, e)) return !0;
		return !1;
	}
}
function Ay(e) {
	let t = e;
	return My(n);
	function n(n) {
		let r = n, i;
		for (i in e) if (r[i] !== t[i]) return !1;
		return !0;
	}
}
function jy(e) {
	return My(t);
	function t(t) {
		return t && t.type === e;
	}
}
function My(e) {
	return t;
	function t(t, n, r) {
		return !!(Py(t) && e.call(this, t, typeof n == "number" ? n : void 0, r || void 0));
	}
}
function Ny() {
	return !0;
}
function Py(e) {
	return typeof e == "object" && !!e && "type" in e;
}
//#endregion
//#region ../../../node_modules/unist-util-visit-parents/lib/color.js
function Fy(e) {
	return e;
}
//#endregion
//#region ../../../node_modules/unist-util-visit-parents/lib/index.js
var Iy = [];
function Ly(e, t, n, r) {
	let i;
	typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
	let a = Oy(i), o = r ? -1 : 1;
	s(e, void 0, [])();
	function s(e, i, c) {
		let l = e && typeof e == "object" ? e : {};
		if (typeof l.type == "string") {
			let t = typeof l.tagName == "string" ? l.tagName : typeof l.name == "string" ? l.name : void 0;
			Object.defineProperty(u, "name", { value: "node (" + Fy(e.type + (t ? "<" + t + ">" : "")) + ")" });
		}
		return u;
		function u() {
			let l = Iy, u, d, f;
			if ((!t || a(e, i, c[c.length - 1] || void 0)) && (l = Ry(n(e, c)), l[0] === !1)) return l;
			if ("children" in e && e.children) {
				let t = e;
				if (t.children && l[0] !== "skip") for (d = (r ? t.children.length : -1) + o, f = c.concat(t); d > -1 && d < t.children.length;) {
					let e = t.children[d];
					if (u = s(e, d, f)(), u[0] === !1) return u;
					d = typeof u[1] == "number" ? u[1] : d + o;
				}
			}
			return l;
		}
	}
}
function Ry(e) {
	return Array.isArray(e) ? e : typeof e == "number" ? [!0, e] : e == null ? Iy : [e];
}
//#endregion
//#region ../../../node_modules/unist-util-visit/lib/index.js
function zy(e, t, n, r) {
	let i, a, o;
	typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), Ly(e, a, s, i);
	function s(e, t) {
		let n = t[t.length - 1], r = n ? n.children.indexOf(e) : void 0;
		return o(e, r, n);
	}
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/state.js
var By = {}.hasOwnProperty, Vy = {};
function Hy(e, t) {
	let n = t || Vy, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = {
		all: s,
		applyData: Wy,
		definitionById: r,
		footnoteById: i,
		footnoteCounts: /* @__PURE__ */ new Map(),
		footnoteOrder: [],
		handlers: {
			...fy,
			...n.handlers
		},
		one: o,
		options: n,
		patch: Uy,
		wrap: Ky
	};
	return zy(e, function(e) {
		if (e.type === "definition" || e.type === "footnoteDefinition") {
			let t = e.type === "definition" ? r : i, n = String(e.identifier).toUpperCase();
			t.has(n) || t.set(n, e);
		}
	}), a;
	function o(e, t) {
		let n = e.type, r = a.handlers[n];
		if (By.call(a.handlers, n) && r) return r(a, e, t);
		if (a.options.passThrough && a.options.passThrough.includes(n)) {
			if ("children" in e) {
				let { children: t, ...n } = e, r = wy(n);
				return r.children = a.all(e), r;
			}
			return wy(e);
		}
		return (a.options.unknownHandler || Gy)(a, e, t);
	}
	function s(e) {
		let t = [];
		if ("children" in e) {
			let n = e.children, r = -1;
			for (; ++r < n.length;) {
				let i = a.one(n[r], e);
				if (i) {
					if (r && n[r - 1].type === "break" && (!Array.isArray(i) && i.type === "text" && (i.value = qy(i.value)), !Array.isArray(i) && i.type === "element")) {
						let e = i.children[0];
						e && e.type === "text" && (e.value = qy(e.value));
					}
					Array.isArray(i) ? t.push(...i) : t.push(i);
				}
			}
		}
		return t;
	}
}
function Uy(e, t) {
	e.position && (t.position = Qm(e));
}
function Wy(e, t) {
	let n = t;
	if (e && e.data) {
		let t = e.data.hName, r = e.data.hChildren, i = e.data.hProperties;
		typeof t == "string" && (n.type === "element" ? n.tagName = t : n = {
			type: "element",
			tagName: t,
			properties: {},
			children: "children" in n ? n.children : [n]
		}), n.type === "element" && i && Object.assign(n.properties, wy(i)), "children" in n && n.children && r != null && (n.children = r);
	}
	return n;
}
function Gy(e, t) {
	let n = t.data || {}, r = "value" in t && !(By.call(n, "hProperties") || By.call(n, "hChildren")) ? {
		type: "text",
		value: t.value
	} : {
		type: "element",
		tagName: "div",
		properties: {},
		children: e.all(t)
	};
	return e.patch(t, r), e.applyData(t, r);
}
function Ky(e, t) {
	let n = [], r = -1;
	for (t && n.push({
		type: "text",
		value: "\n"
	}); ++r < e.length;) r && n.push({
		type: "text",
		value: "\n"
	}), n.push(e[r]);
	return t && e.length > 0 && n.push({
		type: "text",
		value: "\n"
	}), n;
}
function qy(e) {
	let t = 0, n = e.charCodeAt(t);
	for (; n === 9 || n === 32;) t++, n = e.charCodeAt(t);
	return e.slice(t);
}
//#endregion
//#region ../../../node_modules/mdast-util-to-hast/lib/index.js
function Jy(e, t) {
	let n = Hy(e, t), r = n.one(e, void 0), i = Dy(n), a = Array.isArray(r) ? {
		type: "root",
		children: r
	} : r || {
		type: "root",
		children: []
	};
	return i && ("children" in a, a.children.push({
		type: "text",
		value: "\n"
	}, i)), a;
}
//#endregion
//#region ../../../node_modules/remark-rehype/lib/index.js
function Yy(e, t) {
	return e && "run" in e ? async function(n, r) {
		let i = Jy(n, {
			file: r,
			...t
		});
		await e.run(i, r);
	} : function(n, r) {
		return Jy(n, {
			file: r,
			...e || t
		});
	};
}
//#endregion
//#region ../../../node_modules/bail/index.js
function Xy(e) {
	if (e) throw e;
}
//#endregion
//#region ../../../node_modules/extend/index.js
var Zy = /* @__PURE__ */ Dt(((e, t) => {
	var n = Object.prototype.hasOwnProperty, r = Object.prototype.toString, i = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = function(e) {
		return typeof Array.isArray == "function" ? Array.isArray(e) : r.call(e) === "[object Array]";
	}, s = function(e) {
		if (!e || r.call(e) !== "[object Object]") return !1;
		var t = n.call(e, "constructor"), i = e.constructor && e.constructor.prototype && n.call(e.constructor.prototype, "isPrototypeOf");
		if (e.constructor && !t && !i) return !1;
		for (var a in e);
		return a === void 0 || n.call(e, a);
	}, c = function(e, t) {
		i && t.name === "__proto__" ? i(e, t.name, {
			enumerable: !0,
			configurable: !0,
			value: t.newValue,
			writable: !0
		}) : e[t.name] = t.newValue;
	}, l = function(e, t) {
		if (t === "__proto__") {
			if (!n.call(e, t)) return;
			if (a) return a(e, t).value;
		}
		return e[t];
	};
	t.exports = function e() {
		var t, n, r, i, a, u, d = arguments[0], f = 1, p = arguments.length, m = !1;
		for (typeof d == "boolean" && (m = d, d = arguments[1] || {}, f = 2), (d == null || typeof d != "object" && typeof d != "function") && (d = {}); f < p; ++f) if (t = arguments[f], t != null) for (n in t) r = l(d, n), i = l(t, n), d !== i && (m && i && (s(i) || (a = o(i))) ? (a ? (a = !1, u = r && o(r) ? r : []) : u = r && s(r) ? r : {}, c(d, {
			name: n,
			newValue: e(m, u, i)
		})) : i !== void 0 && c(d, {
			name: n,
			newValue: i
		}));
		return d;
	};
}));
//#endregion
//#region ../../../node_modules/is-plain-obj/index.js
function Qy(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
//#endregion
//#region ../../../node_modules/trough/index.js
function $y() {
	let e = [], t = {
		run: n,
		use: r
	};
	return t;
	function n(...t) {
		let n = -1, r = t.pop();
		if (typeof r != "function") throw TypeError("Expected function as last argument, not " + r);
		i(null, ...t);
		function i(a, ...o) {
			let s = e[++n], c = -1;
			if (a) {
				r(a);
				return;
			}
			for (; ++c < t.length;) (o[c] === null || o[c] === void 0) && (o[c] = t[c]);
			t = o, s ? eb(s, i)(...o) : r(null, ...o);
		}
	}
	function r(n) {
		if (typeof n != "function") throw TypeError("Expected `middelware` to be a function, not " + n);
		return e.push(n), t;
	}
}
function eb(e, t) {
	let n;
	return r;
	function r(...t) {
		let r = e.length > t.length, o;
		r && t.push(i);
		try {
			o = e.apply(this, t);
		} catch (e) {
			let t = e;
			if (r && n) throw t;
			return i(t);
		}
		r || (o instanceof Promise ? o.then(a, i) : o instanceof Error ? i(o) : a(o));
	}
	function i(e, ...r) {
		n || (n = !0, t(e, ...r));
	}
	function a(e) {
		i(null, e);
	}
}
//#endregion
//#region ../../../node_modules/vfile/lib/minpath.browser.js
var tb = {
	basename: nb,
	dirname: rb,
	extname: ib,
	join: ab,
	sep: "/"
};
function nb(e, t) {
	if (t !== void 0 && typeof t != "string") throw TypeError("\"ext\" argument must be a string");
	cb(e);
	let n = 0, r = -1, i = e.length, a;
	if (t === void 0 || t.length === 0 || t.length > e.length) {
		for (; i--;) if (e.codePointAt(i) === 47) {
			if (a) {
				n = i + 1;
				break;
			}
		} else r < 0 && (a = !0, r = i + 1);
		return r < 0 ? "" : e.slice(n, r);
	}
	if (t === e) return "";
	let o = -1, s = t.length - 1;
	for (; i--;) if (e.codePointAt(i) === 47) {
		if (a) {
			n = i + 1;
			break;
		}
	} else o < 0 && (a = !0, o = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = o));
	return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function rb(e) {
	if (cb(e), e.length === 0) return ".";
	let t = -1, n = e.length, r;
	for (; --n;) if (e.codePointAt(n) === 47) {
		if (r) {
			t = n;
			break;
		}
	} else r ||= !0;
	return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function ib(e) {
	cb(e);
	let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
	for (; t--;) {
		let s = e.codePointAt(t);
		if (s === 47) {
			if (o) {
				r = t + 1;
				break;
			}
			continue;
		}
		n < 0 && (o = !0, n = t + 1), s === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
	}
	return i < 0 || n < 0 || a === 0 || a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function ab(...e) {
	let t = -1, n;
	for (; ++t < e.length;) cb(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
	return n === void 0 ? "." : ob(n);
}
function ob(e) {
	cb(e);
	let t = e.codePointAt(0) === 47, n = sb(e, !t);
	return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function sb(e, t) {
	let n = "", r = 0, i = -1, a = 0, o = -1, s, c;
	for (; ++o <= e.length;) {
		if (o < e.length) s = e.codePointAt(o);
		else if (s === 47) break;
		else s = 47;
		if (s === 47) {
			if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
				if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
					if (n.length > 2) {
						if (c = n.lastIndexOf("/"), c !== n.length - 1) {
							c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
							continue;
						}
					} else if (n.length > 0) {
						n = "", r = 0, i = o, a = 0;
						continue;
					}
				}
				t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
			} else n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
			i = o, a = 0;
		} else s === 46 && a > -1 ? a++ : a = -1;
	}
	return n;
}
function cb(e) {
	if (typeof e != "string") throw TypeError("Path must be a string. Received " + JSON.stringify(e));
}
//#endregion
//#region ../../../node_modules/vfile/lib/minproc.browser.js
var lb = { cwd: ub };
function ub() {
	return "/";
}
//#endregion
//#region ../../../node_modules/vfile/lib/minurl.shared.js
function db(e) {
	return !!(typeof e == "object" && e && "href" in e && e.href && "protocol" in e && e.protocol && e.auth === void 0);
}
//#endregion
//#region ../../../node_modules/vfile/lib/minurl.browser.js
function fb(e) {
	if (typeof e == "string") e = new URL(e);
	else if (!db(e)) {
		let t = /* @__PURE__ */ TypeError("The \"path\" argument must be of type string or an instance of URL. Received `" + e + "`");
		throw t.code = "ERR_INVALID_ARG_TYPE", t;
	}
	if (e.protocol !== "file:") {
		let e = /* @__PURE__ */ TypeError("The URL must be of scheme file");
		throw e.code = "ERR_INVALID_URL_SCHEME", e;
	}
	return pb(e);
}
function pb(e) {
	if (e.hostname !== "") {
		let e = /* @__PURE__ */ TypeError("File URL host must be \"localhost\" or empty on darwin");
		throw e.code = "ERR_INVALID_FILE_URL_HOST", e;
	}
	let t = e.pathname, n = -1;
	for (; ++n < t.length;) if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
		let e = t.codePointAt(n + 2);
		if (e === 70 || e === 102) {
			let e = /* @__PURE__ */ TypeError("File URL path must not include encoded / characters");
			throw e.code = "ERR_INVALID_FILE_URL_PATH", e;
		}
	}
	return decodeURIComponent(t);
}
//#endregion
//#region ../../../node_modules/vfile/lib/index.js
var mb = [
	"history",
	"path",
	"basename",
	"stem",
	"extname",
	"dirname"
], hb = class {
	constructor(e) {
		let t;
		t = e ? db(e) ? { path: e } : typeof e == "string" || yb(e) ? { value: e } : e : {}, this.cwd = "cwd" in t ? "" : lb.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
		let n = -1;
		for (; ++n < mb.length;) {
			let e = mb[n];
			e in t && t[e] !== void 0 && t[e] !== null && (this[e] = e === "history" ? [...t[e]] : t[e]);
		}
		let r;
		for (r in t) mb.includes(r) || (this[r] = t[r]);
	}
	get basename() {
		return typeof this.path == "string" ? tb.basename(this.path) : void 0;
	}
	set basename(e) {
		_b(e, "basename"), gb(e, "basename"), this.path = tb.join(this.dirname || "", e);
	}
	get dirname() {
		return typeof this.path == "string" ? tb.dirname(this.path) : void 0;
	}
	set dirname(e) {
		vb(this.basename, "dirname"), this.path = tb.join(e || "", this.basename);
	}
	get extname() {
		return typeof this.path == "string" ? tb.extname(this.path) : void 0;
	}
	set extname(e) {
		if (gb(e, "extname"), vb(this.dirname, "extname"), e) {
			if (e.codePointAt(0) !== 46) throw Error("`extname` must start with `.`");
			if (e.includes(".", 1)) throw Error("`extname` cannot contain multiple dots");
		}
		this.path = tb.join(this.dirname, this.stem + (e || ""));
	}
	get path() {
		return this.history[this.history.length - 1];
	}
	set path(e) {
		db(e) && (e = fb(e)), _b(e, "path"), this.path !== e && this.history.push(e);
	}
	get stem() {
		return typeof this.path == "string" ? tb.basename(this.path, this.extname) : void 0;
	}
	set stem(e) {
		_b(e, "stem"), gb(e, "stem"), this.path = tb.join(this.dirname || "", e + (this.extname || ""));
	}
	fail(e, t, n) {
		let r = this.message(e, t, n);
		throw r.fatal = !0, r;
	}
	info(e, t, n) {
		let r = this.message(e, t, n);
		return r.fatal = void 0, r;
	}
	message(e, t, n) {
		let r = new rh(e, t, n);
		return this.path && (r.name = this.path + ":" + r.name, r.file = this.path), r.fatal = !1, this.messages.push(r), r;
	}
	toString(e) {
		return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(e || void 0).decode(this.value);
	}
};
function gb(e, t) {
	if (e && e.includes(tb.sep)) throw Error("`" + t + "` cannot be a path: did not expect `" + tb.sep + "`");
}
function _b(e, t) {
	if (!e) throw Error("`" + t + "` cannot be empty");
}
function vb(e, t) {
	if (!e) throw Error("Setting `" + t + "` requires `path` to be set too");
}
function yb(e) {
	return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
//#endregion
//#region ../../../node_modules/unified/lib/callable-instance.js
var bb = (function(e) {
	let t = this.constructor.prototype, n = t[e], r = function() {
		return n.apply(r, arguments);
	};
	return Object.setPrototypeOf(r, t), r;
}), xb = /* @__PURE__ */ At(Zy()), Sb = {}.hasOwnProperty, Cb = new class e extends bb {
	constructor() {
		super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = $y();
	}
	copy() {
		let t = new e(), n = -1;
		for (; ++n < this.attachers.length;) {
			let e = this.attachers[n];
			t.use(...e);
		}
		return t.data((0, xb.default)(!0, {}, this.namespace)), t;
	}
	data(e, t) {
		return typeof e == "string" ? arguments.length === 2 ? (Eb("data", this.frozen), this.namespace[e] = t, this) : Sb.call(this.namespace, e) && this.namespace[e] || void 0 : e ? (Eb("data", this.frozen), this.namespace = e, this) : this.namespace;
	}
	freeze() {
		if (this.frozen) return this;
		let e = this;
		for (; ++this.freezeIndex < this.attachers.length;) {
			let [t, ...n] = this.attachers[this.freezeIndex];
			if (n[0] === !1) continue;
			n[0] === !0 && (n[0] = void 0);
			let r = t.call(e, ...n);
			typeof r == "function" && this.transformers.use(r);
		}
		return this.frozen = !0, this.freezeIndex = Infinity, this;
	}
	parse(e) {
		this.freeze();
		let t = kb(e), n = this.parser || this.Parser;
		return wb("parse", n), n(String(t), t);
	}
	process(e, t) {
		let n = this;
		return this.freeze(), wb("process", this.parser || this.Parser), Tb("process", this.compiler || this.Compiler), t ? r(void 0, t) : new Promise(r);
		function r(r, i) {
			let a = kb(e), o = n.parse(a);
			n.run(o, a, function(e, t, r) {
				if (e || !t || !r) return s(e);
				let i = t, a = n.stringify(i, r);
				jb(a) ? r.value = a : r.result = a, s(e, r);
			});
			function s(e, n) {
				e || !n ? i(e) : r ? r(n) : t(void 0, n);
			}
		}
	}
	processSync(e) {
		let t = !1, n;
		return this.freeze(), wb("processSync", this.parser || this.Parser), Tb("processSync", this.compiler || this.Compiler), this.process(e, r), Ob("processSync", "process", t), n;
		function r(e, r) {
			t = !0, Xy(e), n = r;
		}
	}
	run(e, t, n) {
		Db(e), this.freeze();
		let r = this.transformers;
		return !n && typeof t == "function" && (n = t, t = void 0), n ? i(void 0, n) : new Promise(i);
		function i(i, a) {
			let o = kb(t);
			r.run(e, o, s);
			function s(t, r, o) {
				let s = r || e;
				t ? a(t) : i ? i(s) : n(void 0, s, o);
			}
		}
	}
	runSync(e, t) {
		let n = !1, r;
		return this.run(e, t, i), Ob("runSync", "run", n), r;
		function i(e, t) {
			Xy(e), r = t, n = !0;
		}
	}
	stringify(e, t) {
		this.freeze();
		let n = kb(t), r = this.compiler || this.Compiler;
		return Tb("stringify", r), Db(e), r(e, n);
	}
	use(e, ...t) {
		let n = this.attachers, r = this.namespace;
		if (Eb("use", this.frozen), e != null) if (typeof e == "function") s(e, t);
		else if (typeof e == "object") Array.isArray(e) ? o(e) : a(e);
		else throw TypeError("Expected usable value, not `" + e + "`");
		return this;
		function i(e) {
			if (typeof e == "function") s(e, []);
			else if (typeof e == "object") if (Array.isArray(e)) {
				let [t, ...n] = e;
				s(t, n);
			} else a(e);
			else throw TypeError("Expected usable value, not `" + e + "`");
		}
		function a(e) {
			if (!("plugins" in e) && !("settings" in e)) throw Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");
			o(e.plugins), e.settings && (r.settings = (0, xb.default)(!0, r.settings, e.settings));
		}
		function o(e) {
			let t = -1;
			if (e != null) if (Array.isArray(e)) for (; ++t < e.length;) {
				let n = e[t];
				i(n);
			}
			else throw TypeError("Expected a list of plugins, not `" + e + "`");
		}
		function s(e, t) {
			let r = -1, i = -1;
			for (; ++r < n.length;) if (n[r][0] === e) {
				i = r;
				break;
			}
			if (i === -1) n.push([e, ...t]);
			else if (t.length > 0) {
				let [r, ...a] = t, o = n[i][1];
				Qy(o) && Qy(r) && (r = (0, xb.default)(!0, o, r)), n[i] = [
					e,
					r,
					...a
				];
			}
		}
	}
}().freeze();
function wb(e, t) {
	if (typeof t != "function") throw TypeError("Cannot `" + e + "` without `parser`");
}
function Tb(e, t) {
	if (typeof t != "function") throw TypeError("Cannot `" + e + "` without `compiler`");
}
function Eb(e, t) {
	if (t) throw Error("Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
function Db(e) {
	if (!Qy(e) || typeof e.type != "string") throw TypeError("Expected node, got `" + e + "`");
}
function Ob(e, t, n) {
	if (!n) throw Error("`" + e + "` finished async. Use `" + t + "` instead");
}
function kb(e) {
	return Ab(e) ? e : new hb(e);
}
function Ab(e) {
	return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function jb(e) {
	return typeof e == "string" || Mb(e);
}
function Mb(e) {
	return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
//#endregion
//#region ../../../node_modules/react-markdown/lib/index.js
var Nb = [], Pb = { allowDangerousHtml: !0 }, Fb = /^(https?|ircs?|mailto|xmpp)$/i, Ib = [
	{
		from: "astPlugins",
		id: "remove-buggy-html-in-markdown-parser"
	},
	{
		from: "allowDangerousHtml",
		id: "remove-buggy-html-in-markdown-parser"
	},
	{
		from: "allowNode",
		id: "replace-allownode-allowedtypes-and-disallowedtypes",
		to: "allowElement"
	},
	{
		from: "allowedTypes",
		id: "replace-allownode-allowedtypes-and-disallowedtypes",
		to: "allowedElements"
	},
	{
		from: "disallowedTypes",
		id: "replace-allownode-allowedtypes-and-disallowedtypes",
		to: "disallowedElements"
	},
	{
		from: "escapeHtml",
		id: "remove-buggy-html-in-markdown-parser"
	},
	{
		from: "includeElementIndex",
		id: "#remove-includeelementindex"
	},
	{
		from: "includeNodeIndex",
		id: "change-includenodeindex-to-includeelementindex"
	},
	{
		from: "linkTarget",
		id: "remove-linktarget"
	},
	{
		from: "plugins",
		id: "change-plugins-to-remarkplugins",
		to: "remarkPlugins"
	},
	{
		from: "rawSourcePos",
		id: "#remove-rawsourcepos"
	},
	{
		from: "renderers",
		id: "change-renderers-to-components",
		to: "components"
	},
	{
		from: "source",
		id: "change-source-to-children",
		to: "children"
	},
	{
		from: "sourcePos",
		id: "#remove-sourcepos"
	},
	{
		from: "transformImageUri",
		id: "#add-urltransform",
		to: "urlTransform"
	},
	{
		from: "transformLinkUri",
		id: "#add-urltransform",
		to: "urlTransform"
	}
];
function Lb(e) {
	let t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, a = e.components, o = e.disallowedElements, s = e.rehypePlugins || Nb, c = e.remarkPlugins || Nb, l = e.remarkRehypeOptions ? {
		...e.remarkRehypeOptions,
		...Pb
	} : Pb, u = e.skipHtml, d = e.unwrapDisallowed, f = e.urlTransform || Rb, p = Cb().use(Fv).use(c).use(Yy, l).use(s), m = new hb();
	typeof r == "string" ? m.value = r : "" + r;
	for (let t of Ib) Object.hasOwn(e, t.from) && "" + t.from + (t.to ? "use `" + t.to + "` instead" : "remove it") + t.id;
	let h = p.parse(m), g = p.runSync(h, m);
	return i && (g = {
		type: "element",
		tagName: "div",
		properties: { className: i },
		children: g.type === "root" ? g.children : [g]
	}), zy(g, _), uh(g, {
		Fragment: W,
		components: a,
		ignoreInvalidStyle: !0,
		jsx: G,
		jsxs: K,
		passKeys: !0,
		passNode: !0
	});
	function _(e, r, i) {
		if (e.type === "raw" && i && typeof r == "number") return u ? i.children.splice(r, 1) : i.children[r] = {
			type: "text",
			value: e.value
		}, r;
		if (e.type === "element") {
			let t;
			for (t in Nh) if (Object.hasOwn(Nh, t) && Object.hasOwn(e.properties, t)) {
				let n = e.properties[t], r = Nh[t];
				(r === null || r.includes(e.tagName)) && (e.properties[t] = f(String(n || ""), t, e));
			}
		}
		if (e.type === "element") {
			let a = t ? !t.includes(e.tagName) : o ? o.includes(e.tagName) : !1;
			if (!a && n && typeof r == "number" && (a = !n(e, r, i)), a && i && typeof r == "number") return d && e.children ? i.children.splice(r, 1, ...e.children) : i.children.splice(r, 1), r;
		}
	}
}
function Rb(e) {
	let t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
	return t < 0 || i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || Fb.test(e.slice(0, t)) ? e : "";
}
//#endregion
//#region ../widget-linear/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;position:relative;overflow:hidden}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:\"\";background:linear-gradient(#fff0 0%,#ffffff01 1.8%,#ffffff02 4.8%,#ffffff05 9%,#ffffff0b 13.9%,#ffffff13 19.8%,#ffffff20 27%,#ffffff31 35%,#ffffff47 43.5%,#ffffff61 53%,#ffffff8a 66%,#ffffffbc 81%,#fff 100%);position:absolute;bottom:0;left:0}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;text-overflow:ellipsis;color:var(--dixa-color-neutral-600);overflow:hidden}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500);position:absolute}._loader_13xpk_1{width:100%;padding:var(--dixa-size-spacer-200);justify-content:center;display:flex}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);box-sizing:border-box;gap:var(--dixa-size-spacer-100);background-color:#0000;width:100%}._collapseHeader_su0f9_8>div:first-of-type{padding-right:var(--dixa-size-spacer-300);width:100%;padding:0!important}._collapseHeader_su0f9_8>div>div:first-of-type{width:100%;padding:0!important}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{margin:0;white-space:unset!important}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);flex-direction:row;display:flex}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{align-items:center;display:flex}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{gap:var(--dixa-size-spacer-100);display:flex}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var zb = {
	"\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createIssue"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueTitle"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueDescription"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "teamId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "projectId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "statusId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "priority"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "issueCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "ObjectValue",
									fields: [
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "title"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "issueTitle"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "description"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "issueDescription"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "teamId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "teamId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "projectId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "projectId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "stateId"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "statusId"
												}
											}
										},
										{
											kind: "ObjectField",
											name: {
												kind: "Name",
												value: "priority"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "priority"
												}
											}
										}
									]
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "success"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "issue"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "identifier"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "url"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "staticData"
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "teams"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "edges"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "node"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "organization"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "urlKey"
																	}
																}]
															}
														}
													]
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "issuePriorityValues"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "priority"
										}
									}, {
										kind: "Field",
										name: {
											kind: "Name",
											value: "label"
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "organization"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "urlKey"
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "teamData"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "teamId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "team"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "teamId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "projects"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "edges"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "node"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}]
												}
											}]
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "states"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "edges"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "node"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "color"
																	}
																}
															]
														}
													}]
												}
											}]
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "templates"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "edges"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "node"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "templateData"
																	}
																}
															]
														}
													}]
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchIssues"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "issueQuery"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "after"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "first"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "searchIssues"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "first"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "after"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "after"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "term"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "issueQuery"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "description"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "identifier"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priority"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priorityLabel"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "color"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignee"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "displayName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "avatarUrl"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "email"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "color"
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "team"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "organization"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "urlKey"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "project"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}
												]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "pageInfo"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "hasNextPage"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "endCursor"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchLinkedIssues"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "linkedIssues"
					}
				},
				type: {
					kind: "ListType",
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ID"
							}
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Linear"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "issues"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "filter"
								},
								value: {
									kind: "ObjectValue",
									fields: [{
										kind: "ObjectField",
										name: {
											kind: "Name",
											value: "id"
										},
										value: {
											kind: "ObjectValue",
											fields: [{
												kind: "ObjectField",
												name: {
													kind: "Name",
													value: "in"
												},
												value: {
													kind: "Variable",
													name: {
														kind: "Name",
														value: "linkedIssues"
													}
												}
											}]
										}
									}]
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "description"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "identifier"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priority"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "priorityLabel"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "state"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "type"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "color"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "assignee"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "displayName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "avatarUrl"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "email"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "labels"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "color"
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "team"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "organization"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "urlKey"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "project"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Bb(e) {
	return zb[e] ?? {};
}
var Vb = Bb("\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n"), Hb = Bb("\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n"), Ub = ({ title: e, children: t }) => /* @__PURE__ */ K(v, {
	flexDirection: "column",
	gap: "100",
	children: [/* @__PURE__ */ G(L.Paragraph, {
		variant: "5",
		color: "neutral.500",
		children: e
	}), t]
}), Wb = {
	issueAvatar: "_issueAvatar_kc0sw_1",
	issueField: "_issueField_kc0sw_9",
	issueDescription: "_issueDescription_kc0sw_12"
}, Gb = ({ issue: e }) => /* @__PURE__ */ K(W, { children: [
	/* @__PURE__ */ G(Ub, {
		title: "Assignee",
		children: /* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "row",
			alignContent: "center",
			className: Wb.issueAvatar,
			children: [/* @__PURE__ */ G(t, {
				size: "24",
				user: e.assignee ? {
					name: e.assignee.name || null,
					avatar_url: e.assignee.avatarUrl || null,
					email: e.assignee.email
				} : void 0
			}), /* @__PURE__ */ G(L.Heading, {
				variant: "heading-4",
				children: e.assignee ? e.assignee.name : "Unassigned"
			})]
		})
	}),
	e.team?.name && /* @__PURE__ */ G(Ub, {
		title: "Team",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "3",
			color: "neutral.800",
			className: Wb.issueField,
			children: e.team.name
		})
	}),
	e.project?.name && /* @__PURE__ */ G(Ub, {
		title: "Project",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "3",
			color: "neutral.800",
			className: Wb.issueField,
			children: e.project.name
		})
	}),
	/* @__PURE__ */ G(Ub, {
		title: "Description",
		children: /* @__PURE__ */ G(Lb, {
			className: Wb.issueDescription,
			children: e.description
		})
	})
] }), Kb = {
	0: /* @__PURE__ */ K("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "No Priority",
		"data-testid": "noPriorityIcon",
		children: [
			/* @__PURE__ */ G("rect", {
				width: "2",
				height: "2",
				rx: "1",
				transform: "matrix(-1 0 0 1 5 7)"
			}),
			/* @__PURE__ */ G("rect", {
				width: "2",
				height: "2",
				rx: "1",
				transform: "matrix(-1 0 0 1 8 7)"
			}),
			/* @__PURE__ */ G("rect", {
				width: "2",
				height: "2",
				rx: "1",
				transform: "matrix(-1 0 0 1 11 7)"
			})
		]
	}),
	1: /* @__PURE__ */ G("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "16",
		height: "16",
		viewBox: "-1 -1 15 15",
		"aria-label": "Urgent Priority",
		fill: "var(--dixa-color-orange-400)",
		children: /* @__PURE__ */ G("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
		})
	}),
	2: /* @__PURE__ */ K("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "High Priority",
		children: [
			/* @__PURE__ */ G("rect", {
				x: "1",
				y: "8",
				width: "3",
				height: "6",
				rx: "1"
			}),
			/* @__PURE__ */ G("rect", {
				x: "6",
				y: "5",
				width: "3",
				height: "9",
				rx: "1"
			}),
			/* @__PURE__ */ G("rect", {
				x: "11",
				y: "2",
				width: "3",
				height: "12",
				rx: "1"
			})
		]
	}),
	3: /* @__PURE__ */ K("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "Medium Priority",
		children: [
			/* @__PURE__ */ G("rect", {
				x: "1",
				y: "8",
				width: "3",
				height: "6",
				rx: "1"
			}),
			/* @__PURE__ */ G("rect", {
				x: "6",
				y: "5",
				width: "3",
				height: "9",
				rx: "1"
			}),
			/* @__PURE__ */ G("rect", {
				x: "11",
				y: "2",
				width: "3",
				height: "12",
				rx: "1",
				fillOpacity: "0.4"
			})
		]
	}),
	4: /* @__PURE__ */ K("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "var(--dixa-color-neutral-500)",
		width: "16",
		height: "16",
		viewBox: "0 0 16 16",
		"aria-label": "Low Priority",
		children: [
			/* @__PURE__ */ G("rect", {
				x: "1",
				y: "8",
				width: "3",
				height: "6",
				rx: "1"
			}),
			/* @__PURE__ */ G("rect", {
				x: "6",
				y: "5",
				width: "3",
				height: "9",
				rx: "1",
				fillOpacity: "0.4"
			}),
			/* @__PURE__ */ G("rect", {
				x: "11",
				y: "2",
				width: "3",
				height: "12",
				rx: "1",
				fillOpacity: "0.4"
			})
		]
	})
}, qb = (e) => e in Kb, Jb = ({ priority: e }) => qb(e) ? Kb[e] : /* @__PURE__ */ G(I, {
	"data-testid": "defaultPriorityTag",
	children: e
}), Yb = (e, t) => /* @__PURE__ */ G("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	"data-testid": "defaultStatusIcon",
	children: /* @__PURE__ */ G("path", {
		d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
		stroke: "none"
	})
}), Xb = (e, t) => /* @__PURE__ */ K("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	fill: "none",
	"aria-label": t,
	"data-testid": "unstartedStatusIcon",
	children: [/* @__PURE__ */ G("rect", {
		x: "1",
		y: "1",
		width: "12",
		height: "12",
		rx: "6",
		stroke: e,
		strokeWidth: "2",
		fill: "none"
	}), /* @__PURE__ */ G("path", {
		fill: e,
		stroke: "none",
		d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
		transform: "translate(3.5,3.5)"
	})]
}), Zb = (e, t) => /* @__PURE__ */ K("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	fill: "none",
	"aria-label": t,
	children: [/* @__PURE__ */ G("rect", {
		x: "1",
		y: "1",
		width: "12",
		height: "12",
		rx: "6",
		stroke: e,
		strokeWidth: "2",
		fill: "none"
	}), /* @__PURE__ */ G("path", {
		fill: e,
		stroke: "none",
		d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
		transform: "translate(3.5,3.5)"
	})]
}), Qb = (e, t) => /* @__PURE__ */ G("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	children: /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
	})
}), $b = (e, t) => /* @__PURE__ */ G("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	children: /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
		stroke: "none"
	})
}), ex = (e, t) => /* @__PURE__ */ G("svg", {
	width: "14",
	height: "14",
	viewBox: "0 0 14 14",
	"aria-label": t,
	fill: e,
	children: /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
	})
}), tx = {
	backlog: (e, t) => Yb(e, t),
	unstarted: (e, t) => Xb(e, t),
	started: (e, t) => Zb(e, t),
	done: (e, t) => Qb(e, t),
	canceled: (e, t) => $b(e, t),
	completed: (e, t) => ex(e, t)
}, nx = (e) => e in tx, rx = ({ type: e = "backlog", color: t = "var(--dixa-color-neutral-400)", name: n = "linear-backlog-icon" }) => nx(e) ? tx[e](t, n) : tx.backlog("var(--dixa-color-neutral-400)", "linear-backlog-icon"), ix = {
	wrapper: "_wrapper_e0qj3_1",
	description: "_description_e0qj3_8",
	resultTitle: "_resultTitle_e0qj3_21",
	resultTooltipTitle: "_resultTooltipTitle_e0qj3_28",
	resultLinkIcon: "_resultLinkIcon_e0qj3_31"
}, ax = ({ issue: e }) => {
	let [t, n] = U(!1), { list: { isDisabled: r }, item: { onSelect: i } } = Xe(ae()), a = Ye((t) => {
		r || i({
			value: e,
			meta: {
				target: t?.target,
				event: t || void 0
			}
		});
	}, [
		r,
		i,
		e
	]);
	return /* @__PURE__ */ G(R, {
		wrap: "none",
		side: "left",
		content: /* @__PURE__ */ K(v, {
			flexDirection: "column",
			gap: "300",
			className: ix.wrapper,
			children: [/* @__PURE__ */ K(v, {
				flexDirection: "row",
				justifyContent: "space-between",
				gap: "300",
				children: [/* @__PURE__ */ K(v, {
					flexDirection: "row",
					gap: "200",
					alignItems: "center",
					children: [
						/* @__PURE__ */ G(rx, {
							type: e.state.type,
							name: e.state.name,
							color: e.state.color
						}),
						/* @__PURE__ */ G(L.Heading, {
							variant: "heading-3",
							children: e.identifier
						}),
						/* @__PURE__ */ G(Jb, { priority: e.priority })
					]
				}), /* @__PURE__ */ G(I, { children: e.state.name })]
			}), /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					className: ix.resultTooltipTitle,
					children: e.title
				}), /* @__PURE__ */ G(Gb, { issue: e })]
			})]
		}),
		light: !0,
		children: /* @__PURE__ */ G(N.Item, {
			value: e,
			noFixedSelectionStateSpace: !0,
			className: ix.result,
			onMouseEnter: () => n(!0),
			onMouseLeave: () => n(!1),
			"data-testid": "selectionListItemWrapper",
			onClick: a,
			children: /* @__PURE__ */ K(v, {
				flexDirection: "column",
				style: { width: t ? "calc(100% - 32px)" : "100%" },
				children: [
					/* @__PURE__ */ K(v, {
						flexDirection: "row",
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ G(rx, {
								type: e.state.type,
								color: e.state.color,
								name: e.state.name
							}),
							/* @__PURE__ */ G(L.Heading, {
								variant: "heading-3",
								children: e.identifier
							}),
							/* @__PURE__ */ G(Jb, { priority: e.priority })
						]
					}),
					/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						className: ix.resultTitle,
						children: e.title
					}),
					t && /* @__PURE__ */ G(x, {
						className: ix.resultLinkIcon,
						name: "plus",
						size: 32
					})
				]
			})
		}, e.id)
	});
}, ox = {
	loader: "_loader_13xpk_1",
	dropdown: "_dropdown_13xpk_8",
	loadMore: "_loadMore_13xpk_13"
}, sx = ({ handleSelect: e, linkedIssues: t }) => {
	let [n, r] = U(), [i, a] = U([]), [o, s] = U(""), [c, l] = U(!1), { useLazyQuery: u } = B(), [d, { data: f, loading: p, networkStatus: m }] = u(Vb, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	}), [h, g] = au(() => {
		!p && o !== "" && m === st.ready ? d({ variables: {
			issueQuery: o,
			first: 8
		} }) : a([]);
	}, 500, [o]);
	H(() => {
		p || a([]);
	}, [o]), H(() => {
		if (f && Object.keys(f).length > 0) {
			let e = f.Linear.searchIssues.edges.map(({ node: e }) => e), n = i.filter((e) => !t.find((t) => t.id === e.id)), o = n.filter((t) => !e.find((e) => e.id === t.id)), s = e.filter((e) => !t.find((t) => t.id === e.id));
			t.length > 0 ? a(c ? [...o, ...s] : s) : f?.Linear?.searchIssues?.edges && a(c ? [...n, ...e] : e), f.Linear.searchIssues.pageInfo.hasNextPage && l(!1), r(f.Linear.searchIssues?.pageInfo);
		}
	}, [f, t]);
	let _ = () => {
		!p && o !== "" && m === st.ready ? (l(!0), d({ variables: {
			issueQuery: o,
			first: 8,
			after: n?.endCursor
		} })) : a([]);
	};
	return /* @__PURE__ */ G(v, {
		flexDirection: "column",
		gap: "200",
		"data-testid": "searchBarWrapper",
		children: /* @__PURE__ */ K(w, {
			"data-testid": "searchBarComponent",
			clearable: !0,
			getItemTitleByValue: (e) => e?.title,
			onChange: (t) => e(t.selectedValues[0]),
			dropdownProps: { className: ox.dropdown },
			filter: {
				value: o,
				onChange: (e) => {
					let t = e.target.value;
					s(t);
				}
			},
			placeholder: "Search Linear issues",
			children: [
				i?.map((e) => /* @__PURE__ */ G(ax, { issue: e }, e.id)),
				n?.hasNextPage && !p && o !== "" && i.length && /* @__PURE__ */ G(v, {
					gap: "100",
					justifyContent: "center",
					padding: "200",
					alignItems: "center",
					onClick: () => _(),
					className: ox.loadMore,
					children: /* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						children: "Load more ..."
					})
				}),
				p && o !== "" && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					className: ox.loader,
					children: /* @__PURE__ */ G(P, { size: 24 })
				}),
				o === "" && i.length === 0 && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					style: { margin: "var(--dixa-size-spacer-250)" },
					children: /* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						color: "neutral.400",
						children: "Enter issue title or description"
					})
				}),
				i.length === 0 && o !== "" && !p && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					style: { margin: "var(--dixa-size-spacer-250)" },
					children: /* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						color: "neutral.400",
						children: "No Linear issues found"
					})
				})
			]
		})
	});
}, cx = {
	collapse: "_collapse_su0f9_1",
	collapseHeader: "_collapseHeader_su0f9_8",
	collapseContent: "_collapseContent_su0f9_31",
	url: "_url_su0f9_35",
	empty: "_empty_su0f9_47",
	externalLink: "_externalLink_su0f9_51",
	emptyState: "_emptyState_su0f9_55"
}, lx = ({ linkedIssues: e, isLoading: t, handleUnlinkIssue: n, showUnlinkAllModal: r, showUnlinkAllButton: i, organizationUrl: o }) => {
	let [c, l] = U(e.reduce((e, t) => ({
		...e,
		[t.id]: !1
	}), {})), { track: u } = Ve();
	return t ? /* @__PURE__ */ G(v, {
		flexDirection: "column",
		margin: "0 0 400 0",
		justifyContent: "center",
		alignItems: "center",
		children: /* @__PURE__ */ G(P, { size: 24 })
	}) : e.length === 0 ? /* @__PURE__ */ K(v, {
		flexDirection: "column",
		justifyContent: "center",
		margin: "0 0 300 0",
		gap: "300",
		children: [/* @__PURE__ */ G(L.Paragraph, {
			align: "center",
			variant: "3",
			color: "neutral.400",
			className: cx.emptyState,
			children: "No linked issues found"
		}), /* @__PURE__ */ G(j, {
			slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
			variant: "tertiary",
			className: cx.externalLink,
			navigate: () => window.open(`https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`, "_blank")?.focus(),
			children: "Open Linear"
		})]
	}) : /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "250",
		margin: "0 0 400 0",
		"data-testid": "linkedIssueWrapper",
		children: [
			e.map((e) => {
				let t = c[e.id];
				return /* @__PURE__ */ K(s, {
					"data-testid": "collapseCard",
					onToggle: () => l({
						...c,
						[e.id]: !c[e.id]
					}),
					isOpen: t,
					className: cx.collapse,
					children: [/* @__PURE__ */ G(s.Header, {
						className: cx.collapseHeader,
						children: /* @__PURE__ */ K(v, {
							flexDirection: "column",
							gap: "100",
							children: [/* @__PURE__ */ K(v, {
								flexDirection: "row",
								justifyContent: "space-between",
								children: [/* @__PURE__ */ K(v, {
									gap: "100",
									alignItems: "center",
									children: [
										/* @__PURE__ */ G(R, {
											content: /* @__PURE__ */ G(v, { children: e.state.name }),
											children: /* @__PURE__ */ G(v, {
												alignSelf: "center",
												children: /* @__PURE__ */ G(rx, {
													type: e.state.type,
													color: e.state.color,
													name: e.state.name
												})
											})
										}),
										/* @__PURE__ */ K(L.ExternalLink, {
											className: cx.url,
											href: e.url,
											target: "_blank",
											rel: "noreferrer",
											children: [e.identifier, /* @__PURE__ */ G(x, { name: "external-link" })]
										}),
										/* @__PURE__ */ G(R, {
											content: /* @__PURE__ */ G(v, { children: e.priorityLabel }),
											children: /* @__PURE__ */ G(v, {
												alignSelf: "center",
												children: /* @__PURE__ */ G(Jb, { priority: e.priority })
											})
										})
									]
								}), /* @__PURE__ */ G(I, { children: e.state.name })]
							}), e.title]
						})
					}), /* @__PURE__ */ G(s.Content, {
						className: cx.collapseContent,
						children: /* @__PURE__ */ K(v, {
							flexDirection: "column",
							gap: "300",
							children: [
								e?.labels && e?.labels?.edges?.length > 0 && /* @__PURE__ */ G(v, {
									flexDirection: "row",
									gap: "200",
									alignItems: "center",
									flexWrap: "wrap",
									children: e.labels?.edges.map((e) => /* @__PURE__ */ G(I, {
										color: e.node.color,
										children: e.node.name
									}, e.node.id))
								}),
								/* @__PURE__ */ G(Gb, { issue: e }),
								/* @__PURE__ */ G(a, {
									slotStart: /* @__PURE__ */ G(x, { name: "link-slash" }),
									variant: "secondary",
									onClick: () => n(e.id),
									style: { marginTop: "var(--dixa-size-spacer-200)" },
									children: "Unlink issue from Linear"
								}),
								/* @__PURE__ */ K(j, {
									slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
									variant: "tertiary",
									className: cx.externalLink,
									onClick: () => {
										u("linear:open:issue:clicked", {
											linearInstanceUrl: o,
											linearIssueKey: e.id
										});
									},
									navigate: () => window.open(e.url, "_blank")?.focus(),
									children: [
										"View ",
										e.identifier,
										" in Linear"
									]
								})
							]
						})
					})]
				}, e.id);
			}),
			e.length > 1 && i && /* @__PURE__ */ G(a, {
				slotStart: /* @__PURE__ */ G(x, { name: "link-slash" }),
				variant: "secondary",
				onClick: () => r(!0),
				children: "Unlink all issues"
			}),
			/* @__PURE__ */ G(j, {
				slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
				variant: "tertiary",
				className: cx.externalLink,
				onClick: () => {
					u("linear:open:linear:clicked", {
						linearInstanceUrl: o,
						linearIssueKey: e[0].id
					});
				},
				disabled: !o,
				navigate: () => window.open(o, "_blank")?.focus(),
				children: "Open Linear"
			})
		]
	});
}, ux = {
	default: (e, t) => (t() ?? []).join(""),
	nodes: {
		doc: (e, t) => (t() ?? []).join(""),
		heading: (e, t) => `\n${"#".repeat(parseInt(e.attrs?.level) || 1)} ${t()}\n\n`,
		bullet_list: (e, t) => "\n" + t().map((e) => `- ${e}`).join(""),
		ordered_list: (e, t) => "\n" + t().map((e) => `1. ${e}`).join(""),
		paragraph: (e, t) => t().join("") + "\n",
		text: (e) => e.text ?? "",
		hard_break: () => "\n",
		blockquote: (e, t) => `> ${t().join("")}\n`,
		code_block: (e, t) => "\n```" + (e.attrs?.language || "") + "\n" + t() + "\n```\n"
	},
	marks: { text: {
		strong: (e, t) => `**${t()}**`,
		strike: (e, t) => `~~${t()}~~`,
		subsup: (e, t) => {
			switch (e.attrs?.type) {
				case "sub": return `<sub>${t()}</sub>`;
				case "sup": return `<sup>${t()}</sup>`;
				default: return t();
			}
		},
		underline: (e, t) => `<u>${t()}</u>`,
		em: (e, t) => `*${t()}*`,
		link: (e, t) => `[${t()}](${e.attrs?.href})`,
		code: (e, t) => `\`${t()}\``
	} }
}, dx = (e, t) => ((n) => (e.marks || []).map((n) => ({
	formatterFunction: t.marks[e.type]?.[n.type],
	mark: n
})).reduce((e, t) => () => t.formatterFunction?.(t.mark, e) || n, () => n)())((t.nodes[e.type] || t.default)(e, ((e, t) => () => e.content ? e.content.map((e) => dx(e, t)) : [])(e, t))), fx = {
	modalBody: "_modalBody_iv3ua_1",
	error: "_error_iv3ua_5",
	emptyState: "_emptyState_iv3ua_9",
	dropdown: "_dropdown_iv3ua_16"
}, px = Bb("\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n"), mx = Bb("\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n"), hx = Bb("\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n"), gx = ({ setCreatedIssue: e, isCreateIssueModalOpen: t, setIsCreateIssueModalOpen: n, setIsCreationSuccessfulModalOpen: r, addToLinkedIssueIds: i, organizationUrl: a, setOrganizationUrl: o }) => {
	let { useLazyQuery: s, showNotification: c } = B(), { control: l, handleSubmit: u, reset: d } = gl(), [f, p] = U([]), [m, x] = U(), [S, C] = U([]), [T, E] = U(), [j, M] = U([]), [ee, F] = U(), [I, te] = U([]), [ne, re] = U(), [ie, R] = U([]), [ae, oe] = U(), [se, ce] = U(!1), { useMutation: le } = B(), { track: ue } = Ve(), [de, { loading: fe }] = le(px, {
		onError: () => {
			ce(!1), c({
				title: "Creation was not successful",
				text: "Please try again later or contact your admin.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: (e) => {
			let t = {
				identifier: e.Linear?.issueCreate?.issue?.identifier,
				url: e.Linear?.issueCreate?.issue?.url
			};
			e.Linear && e.Linear?.issueCreate?.issue?.id && (i(e.Linear?.issueCreate?.issue?.id), be(t), ce(!1), c({
				title: "Issue was created and linked to the conversation",
				text: `Issue ${e.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
				icon: "exclamation-triangle-filled",
				severity: "success"
			}), ue("linear:create:new:issue:confirmed", { linearInstanceUrl: a }));
		}
	}), [pe, { data: me, loading: he, error: ge }] = s(mx, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onError: () => c({
			title: "Error while fetching team ID",
			text: "Please try again later or contact your admin.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}),
		onCompleted: (e) => {
			let t = e.Linear.teams.edges.map(({ node: e }) => e);
			p(t), te(e.Linear.issuePriorityValues), o(`${yx}${e.Linear.organization.urlKey}`);
		}
	}), [_e, { data: ve, loading: ye }] = s(hx, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onError: () => c({
			title: "Error while fetching team projects",
			text: "Please try again later or contact your admin.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}),
		onCompleted: (e) => {
			let t = e?.Linear?.team?.projects?.edges?.map(({ node: e }) => e);
			C(t);
			let n = e?.Linear?.team?.states?.edges?.map(({ node: e }) => e);
			M(n);
			let r = e?.Linear?.team?.templates?.edges?.map(({ node: e }) => e);
			R(r.filter((e) => e.type === "issue"));
		}
	}), be = (t) => {
		n(!1), E(void 0), x(void 0), F(void 0), re(void 0), oe(void 0), t && (e(t), r(!0)), d({
			title: "",
			description: "",
			projectId: "",
			teamId: "",
			statusId: "",
			priority: void 0
		});
	}, xe = (e) => {
		me && !he && (de({ variables: {
			issueTitle: e.title,
			issueDescription: e?.description,
			teamId: e.team.id,
			projectId: e?.project?.id,
			statusId: e?.status?.id,
			priority: e?.priority?.priority
		} }), ce(!0));
	};
	H(() => {
		t && pe();
	}, [t]);
	let Se = () => {
		ue("linear:create:new:issue:cancelled", { linearInstanceUrl: a });
	};
	return /* @__PURE__ */ K(D, {
		isOpen: t,
		onClose: () => {
			Se(), be();
		},
		children: [
			/* @__PURE__ */ G(A, {
				title: "Create new Linear issue",
				onClose: () => {
					Se(), be();
				}
			}),
			/* @__PURE__ */ G(O, {
				className: fx.modalBody,
				"data-testid": "createIssueModalBody",
				children: ge ? /* @__PURE__ */ G(z, { error: ge }) : /* @__PURE__ */ G("form", {
					onSubmit: u(xe),
					id: "issueCreationForm",
					children: /* @__PURE__ */ K(b, { children: [
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(xc, {
								control: l,
								name: "team",
								rules: { required: "Team is required" },
								render: ({ field: { value: e, onChange: t }, fieldState: { error: n } }) => /* @__PURE__ */ G(_, {
									required: !0,
									label: "Team",
									meta: { error: n?.message ?? null },
									children: /* @__PURE__ */ G(w, {
										dropdownProps: { className: fx.dropdown },
										placeholder: "Select Linear team",
										className: ht({ [fx.error]: n }),
										getItemTitleByValue: (e) => e?.name,
										onChange: (e) => {
											E(void 0), F(void 0), re(void 0), oe(void 0), x(e.selectedValues[0]), _e({ variables: { teamId: e.selectedValues[0].id } }), t(e.selectedValues[0]);
										},
										value: m ? [e] : void 0,
										children: f?.map((e) => /* @__PURE__ */ G(N.Item, {
											value: e,
											noFixedSelectionStateSpace: !0,
											children: /* @__PURE__ */ G(L.Paragraph, { children: e.name })
										}, e.id))
									})
								})
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(xc, {
								control: l,
								name: "project",
								render: ({ field: { value: e, onChange: t } }) => {
									let n = ye ? [{
										name: "Loading projects...",
										id: ""
									}] : void 0;
									return /* @__PURE__ */ G(_, {
										label: "Project",
										children: /* @__PURE__ */ G(w, {
											dropdownProps: { className: fx.dropdown },
											clearable: !0,
											getItemTitleByValue: (e) => e?.name,
											disabled: m === void 0,
											placeholder: m ? "Select Linear project" : "Select a Team first",
											onChange: (e) => {
												E(e.selectedValues[0]), t(e.selectedValues[0]);
											},
											value: T ? [e] : n,
											children: /* @__PURE__ */ K(W, { children: [ye && /* @__PURE__ */ G(v, {
												justifyContent: "center",
												style: { padding: "var(--dixa-size-spacer-200)" },
												children: /* @__PURE__ */ G(P, { size: 24 })
											}), ve && !ye && S.map((e) => /* @__PURE__ */ G(N.Item, {
												value: e,
												noFixedSelectionStateSpace: !0,
												children: /* @__PURE__ */ G(L.Paragraph, { children: e.name })
											}, e.id))] })
										})
									});
								}
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 6,
							children: /* @__PURE__ */ G(_, {
								label: "Template",
								children: /* @__PURE__ */ G(w, {
									clearable: !0,
									dropdownProps: { className: fx.dropdown },
									disabled: !m || ye,
									placeholder: m ? "Select template" : "Select a Team first",
									getItemTitleByValue: (e) => e?.name,
									onChange: (e) => {
										if (e.selectedValues.length > 0) {
											oe(e.selectedValues[0]);
											let t = JSON.parse(e.selectedValues[0].templateData), n = I.filter((e) => e.priority === t.priority);
											re(n ? n[0] : void 0);
											let r = j.filter((e) => e.id === t.stateId);
											F(r ? r[0] : void 0);
											let i = S.filter((e) => e.id === t.projectId);
											E(i ? i[0] : void 0);
											let a = t.description;
											d({
												title: t?.title,
												priority: n[0],
												status: r[0],
												project: i[0],
												description: a ? dx(a, ux) : "",
												team: m
											});
										} else d({
											title: "",
											description: "",
											team: m
										}), E(void 0), re(void 0), F(void 0), oe(void 0);
									},
									value: ae ? [ae] : void 0,
									children: ie?.map((e) => /* @__PURE__ */ G(N.Item, {
										value: e,
										noFixedSelectionStateSpace: !0,
										children: /* @__PURE__ */ G(L.Paragraph, { children: e.name })
									}, e.id))
								})
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 6,
							children: /* @__PURE__ */ G(xc, {
								control: l,
								name: "title",
								rules: {
									required: "Title field is required",
									minLength: 2
								},
								render: ({ field: { onChange: e, value: t }, fieldState: { error: n } }) => /* @__PURE__ */ G(h, {
									required: !0,
									label: "Title",
									placeholder: "Insert issue title here",
									input: {
										name: "issueTitle",
										value: t || "",
										onChange: e
									},
									meta: { error: n?.message ?? null }
								})
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(xc, {
								control: l,
								name: "status",
								render: ({ field: { value: e, onChange: t } }) => {
									let n = ye ? [{
										name: "Loading statuses...",
										id: "",
										type: "",
										color: ""
									}] : void 0;
									return /* @__PURE__ */ G(_, {
										label: "Status",
										children: /* @__PURE__ */ G(w, {
											dropdownProps: { className: fx.dropdown },
											clearable: !0,
											getItemTitleByValue: (e) => e?.name,
											disabled: m === void 0,
											placeholder: m ? "Select Issue status" : "Select a Team first",
											onChange: (e) => {
												F(e.selectedValues[0]), t(e.selectedValues[0]);
											},
											value: ee ? [e] : n,
											children: /* @__PURE__ */ K(W, { children: [ye && /* @__PURE__ */ G(v, {
												justifyContent: "center",
												style: { padding: "var(--dixa-size-spacer-200)" },
												children: /* @__PURE__ */ G(P, { size: 24 })
											}), ve && !ye && j.map((e) => /* @__PURE__ */ G(N.Item, {
												value: e,
												noFixedSelectionStateSpace: !0,
												children: /* @__PURE__ */ K(v, {
													flexDirection: "row",
													gap: "300",
													alignItems: "center",
													children: [/* @__PURE__ */ G(rx, {
														type: e.type,
														color: e.color,
														name: e.name
													}), /* @__PURE__ */ G(L.Paragraph, { children: e.name })]
												})
											}, e.id))] })
										})
									});
								}
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(xc, {
								control: l,
								name: "priority",
								render: ({ field: { value: e, onChange: t } }) => /* @__PURE__ */ G(_, {
									label: "Priority",
									children: /* @__PURE__ */ G(w, {
										clearable: !0,
										getItemTitleByValue: (e) => e?.label,
										disabled: m === void 0,
										placeholder: m ? "Select Issue priority" : "Select a Team first",
										onChange: (e) => {
											re(e.selectedValues[0]), t(e.selectedValues[0]);
										},
										value: ne ? [e] : he ? [{
											label: "Loading Priorities...",
											priority: 0
										}] : void 0,
										children: /* @__PURE__ */ K(W, { children: [ye && /* @__PURE__ */ G(v, {
											justifyContent: "center",
											style: { padding: "var(--dixa-size-spacer-200)" },
											children: /* @__PURE__ */ G(P, { size: 24 })
										}), me && !he && I.map((e) => /* @__PURE__ */ G(N.Item, {
											value: e,
											noFixedSelectionStateSpace: !0,
											children: /* @__PURE__ */ K(v, {
												flexDirection: "row",
												gap: "300",
												alignItems: "center",
												children: [/* @__PURE__ */ G(Jb, { priority: e.priority }), /* @__PURE__ */ G(L.Paragraph, { children: e.label })]
											})
										}, e.priority))] })
									})
								})
							})
						}),
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(xc, {
							control: l,
							name: "description",
							render: ({ field: { onChange: e, value: t }, fieldState: { error: n } }) => /* @__PURE__ */ G(g, {
								label: "Description",
								placeholder: "Insert Issue description here",
								input: {
									name: "description",
									value: t || "",
									onChange: e
								},
								meta: { error: n?.message ?? null }
							})
						}) })
					] })
				})
			}),
			/* @__PURE__ */ G(k, {
				confirmOnClick: u(xe),
				confirmProps: {
					disabled: fe || !me,
					isLoading: se || he || ye,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmName: "Save",
				cancelOnClick: () => {
					Se(), be();
				}
			})
		]
	});
}, _x = {
	modalWrapper: "_modalWrapper_4kh9u_1",
	copyButton: "_copyButton_4kh9u_6",
	copyWrapper: "_copyWrapper_4kh9u_15",
	copyField: "_copyField_4kh9u_24",
	externalLink: "_externalLink_4kh9u_47",
	externalLinkIcon: "_externalLinkIcon_4kh9u_52",
	textWrapper: "_textWrapper_4kh9u_56"
}, vx = ({ isCreationSuccessfulModalOpen: e, createdIssueData: t, setIsCreationSuccessfulModalOpen: n }) => /* @__PURE__ */ K(D, {
	isOpen: !!t && e,
	className: _x.modalWrapper,
	onClose: () => n(!1),
	children: [
		/* @__PURE__ */ G(A, {
			title: "Issue creation successful",
			onClose: () => n(!1)
		}),
		/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K(v, {
			gap: "300",
			flexDirection: "column",
			"data-testid": "creationSuccessfulModal",
			children: [/* @__PURE__ */ K(L.Paragraph, {
				className: _x.textWrapper,
				children: [
					`You can visit issue ${t?.identifier} by following `,
					" ",
					/* @__PURE__ */ K(L.ExternalLink, {
						href: t?.url,
						target: "_blank",
						className: _x.externalLink,
						children: [
							"this link",
							" ",
							/* @__PURE__ */ G(x, {
								name: "external-link",
								className: _x.externalLinkIcon
							})
						]
					}),
					"or copy it from the field below."
				]
			}), /* @__PURE__ */ G(_, {
				label: "Linear issue link",
				children: /* @__PURE__ */ K(v, {
					flexDirection: "row",
					alignItems: "center",
					"data-testid": "copyInputField",
					className: _x.copyWrapper,
					children: [/* @__PURE__ */ G(T, {
						readOnly: !0,
						value: t?.url,
						className: _x.copyField
					}), /* @__PURE__ */ G(c, {
						className: _x.copyButton,
						textToCopy: t?.url || "",
						clickedProps: { icon: "check-circle-filled" }
					})]
				})
			})]
		}) }),
		/* @__PURE__ */ G(k, {
			cancelOnClick: () => n(!1),
			cancelProps: { variant: "primary" },
			cancelName: "Close"
		})
	]
}), yx = "https://linear.app/", bx = ({ conversationContext: e, settings: t }) => {
	let [n, r] = U([]), [i, o] = U([]), [s, c] = U(!1), [l, u] = U(!1), [d, f] = U(!1), [p, m] = U(), { useLazyQuery: h } = B(), [g, _] = U(""), y = t?.enableCreateIssue, b = !!t?.enableUnlinkAll, { track: x } = Ve(), { loading: S, data: C, error: w, store: T } = ze(e?.conversationId ?? null), [E, { data: j, loading: M, networkStatus: N, error: P }] = h(Hb, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0
	});
	H(() => {
		!S && !w && C && C?.linear?.issues?.length > 0 ? (o(C.linear.issues), E({ variables: { linkedIssues: C.linear.issues } })) : !S && !w && (r([]), o([]));
	}, [
		C,
		S,
		w
	]), H(() => {
		j && j?.Linear && !M && N === st.ready && Object.keys(j).length > 0 && r(j.Linear.issues?.edges?.map(({ node: e }) => e));
	}, [
		j,
		M,
		N
	]);
	let ee = (e) => {
		e && e?.team?.organization?.urlKey && x("linear:link:issue:clicked", {
			linearInstanceUrl: g,
			linearIssueKey: e.id
		});
		let t = (t) => t.id === e?.id;
		n.some((e) => e && t(e)) || (C && i.length === 0 && o([]), T({ linear: { issues: [...i, e.id] } }));
	}, F = (e) => {
		let t = C?.linear.issues.filter((t) => t !== e) || [];
		x("linear:unlink:issue:clicked", {
			linearInstanceUrl: g,
			linearIssueKey: e
		}), r(n.filter(({ id: t }) => t !== e)), o(t), T({ linear: { issues: t } });
	}, I = () => {
		c(!1), r([]), o([]), T({ linear: { issues: [] } });
	}, te = S || M || !C && !w || (C?.linear?.issues?.length ?? 0) > 0 && n.length === 0;
	return !S && !M && (P || w) ? /* @__PURE__ */ G(z, { error: P || w }) : /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "300",
		children: [
			/* @__PURE__ */ K(D, {
				isOpen: s,
				onClose: () => c(!1),
				children: [
					/* @__PURE__ */ G(A, {
						title: "Unlink all Linear issues?",
						onClose: () => c(!1)
					}),
					/* @__PURE__ */ G(O, {
						"data-testid": "unlinkAllIssuesModalBody",
						children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?"
					}),
					/* @__PURE__ */ G(k, {
						confirmOnClick: () => I(),
						confirmName: "Unlink all",
						cancelOnClick: () => c(!1)
					})
				]
			}),
			/* @__PURE__ */ G(gx, {
				isCreateIssueModalOpen: l,
				setIsCreateIssueModalOpen: (e) => u(e),
				setIsCreationSuccessfulModalOpen: (e) => f(e),
				addToLinkedIssueIds: (e) => {
					T({ linear: { issues: [...i, e] } });
				},
				setCreatedIssue: (e) => m(e),
				organizationUrl: g,
				setOrganizationUrl: (e) => _(e)
			}),
			/* @__PURE__ */ G(vx, {
				isCreationSuccessfulModalOpen: d,
				setIsCreationSuccessfulModalOpen: (e) => f(e),
				createdIssueData: p
			}),
			/* @__PURE__ */ K(v, {
				flexDirection: "column",
				background: "neutral.100",
				padding: "300",
				borderRadius: "100",
				gap: "250",
				children: [y && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(a, {
					variant: "primary",
					onClick: () => {
						x("linear:create:new:issue:clicked", { linearInstanceUrl: g }), u(!0);
					},
					style: { minHeight: "38px" },
					children: "Create new issue"
				}), /* @__PURE__ */ G(L.Paragraph, {
					color: "neutral.600",
					align: "center",
					children: "or"
				})] }), /* @__PURE__ */ G(sx, {
					handleSelect: ee,
					linkedIssues: n
				})]
			}),
			/* @__PURE__ */ G(lx, {
				linkedIssues: n,
				isLoading: te,
				handleUnlinkIssue: F,
				showUnlinkAllModal: (e) => c(e),
				showUnlinkAllButton: b,
				organizationUrl: g
			})
		]
	});
}, xx = [{
	key: "enableCreateIssue",
	label: "Enable the \"Create issue\" button",
	type: "boolean",
	secret: !1,
	defaultValue: !0
}, {
	key: "enableUnlinkAll",
	label: "Enable the \"Unlink all\" button",
	type: "boolean",
	secret: !1,
	defaultValue: !0
}], Sx = Pe(xx), Cx = "LINEAR", wx = {
	enabled: !1,
	name: "",
	enableCreateIssue: !0,
	enableUnlinkAll: !0
}, Tx = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i }) => {
	let a = !e, o = gl({
		mode: "onChange",
		defaultValues: wx
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = He({
		integrationId: e,
		integrationType: Cx,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: m, error: h, isWidgetUnknown: g, refetch: S } = Ue({
		integrationId: e,
		fieldDefinitions: xx,
		form: o,
		onMisconfigured: p
	}), C = (e) => ye(e, {
		fieldDefinitions: xx,
		isCreationMode: a,
		create: s,
		update: c
	}), w = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: C,
		error: h ?? d,
		onRetry: h ? S : void 0,
		isLoading: u || m,
		isWidgetUnknown: g,
		children: [
			f && /* @__PURE__ */ G(se, { cause: f }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Sx.enableCreateIssue,
						children: /* @__PURE__ */ G(X, {
							name: "enableCreateIssue",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: Sx.enableUnlinkAll,
						children: /* @__PURE__ */ G(X, {
							name: "enableUnlinkAll",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!a && e && /* @__PURE__ */ G(ce, {
					configuration: t,
					integrationId: e,
					integrationType: Cx,
					label: "Authorize with OAuth"
				})
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: Cx,
				integrationId: e,
				widgetName: w,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => l(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ K(v, {
					gap: "400",
					children: [/* @__PURE__ */ G(x, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ K(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									Cx,
									" integration, all links between Dixa and ",
									Cx,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"All data in ",
								Cx,
								" stays untouched."
							] }),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								Cx,
								" ",
								"integration \"",
								w,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-loop/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._fullWidth_16j0q_1{width:100%}._copyIcon_16j0q_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._lineItem_zi9td_1{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-250)}._lineItem_zi9td_1:hover{background-color:var(--dixa-color-neutral-100)}._lineItemQuantity_zi9td_7{white-space:nowrap}._lineItemContent_zi9td_10{flex:1;min-width:0}._return_1t3xq_1{--loop-brand-color:#0472ff;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._return_1t3xq_1:hover,._returnIsOpen_1t3xq_11{border-color:var(--dixa-color-neutral-400)}._returnHeader_1t3xq_14{cursor:pointer}._statusPageButton_1t3xq_19{color:var(--loop-brand-color)}._trackingRow_1t3xq_24{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-250)}._trackingRow_1t3xq_24:hover{background-color:var(--dixa-color-neutral-100)}._trackingRowDetails_1t3xq_33{flex:1;min-width:0}._trackingRowCode_1t3xq_40{overflow-wrap:anywhere;min-width:0}._trackingRowCarrier_1t3xq_44{white-space:nowrap;flex-shrink:0}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var Ex = /* @__PURE__ */ function(e) {
	return e.Standard = "standard", e.Warranty = "warranty", e;
}({}), Dx = { "\n  query getReturnsByCustomerEmail($email: String!) {\n    LoopReturns {\n      returnsByCustomerEmail(email: $email) {\n        searchedFromDate\n        searchedToDate\n        truncated\n        hasMoreReturns\n        returns {\n          id\n          order_name\n          state\n          outcome\n          type\n          created_at\n          total\n          currency\n          carrier\n          tracking_number\n          label_status\n          status_page_url\n          line_items {\n            line_item_id\n            title\n            sku\n            return_reason\n            outcome\n          }\n        }\n      }\n    }\n  }\n": {
	kind: "Document",
	definitions: [{
		kind: "OperationDefinition",
		operation: "query",
		name: {
			kind: "Name",
			value: "getReturnsByCustomerEmail"
		},
		variableDefinitions: [{
			kind: "VariableDefinition",
			variable: {
				kind: "Variable",
				name: {
					kind: "Name",
					value: "email"
				}
			},
			type: {
				kind: "NonNullType",
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}
		}],
		selectionSet: {
			kind: "SelectionSet",
			selections: [{
				kind: "Field",
				name: {
					kind: "Name",
					value: "LoopReturns"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "returnsByCustomerEmail"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "email"
							},
							value: {
								kind: "Variable",
								name: {
									kind: "Name",
									value: "email"
								}
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "searchedFromDate"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "searchedToDate"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "truncated"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "hasMoreReturns"
									}
								},
								{
									kind: "Field",
									name: {
										kind: "Name",
										value: "returns"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "order_name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "state"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "outcome"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "type"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "created_at"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "total"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "currency"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "carrier"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "tracking_number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "label_status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status_page_url"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "line_items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "line_item_id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "title"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "sku"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "return_reason"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "outcome"
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
} };
function Ox(e) {
	return Dx[e] ?? {};
}
var kx = Ox("\n  query getReturnsByCustomerEmail($email: String!) {\n    LoopReturns {\n      returnsByCustomerEmail(email: $email) {\n        searchedFromDate\n        searchedToDate\n        truncated\n        hasMoreReturns\n        returns {\n          id\n          order_name\n          state\n          outcome\n          type\n          created_at\n          total\n          currency\n          carrier\n          tracking_number\n          label_status\n          status_page_url\n          line_items {\n            line_item_id\n            title\n            sku\n            return_reason\n            outcome\n          }\n        }\n      }\n    }\n  }\n"), Ax = Ws, jx = {
	fullWidth: "_fullWidth_16j0q_1",
	copyIcon: "_copyIcon_16j0q_5"
}, Mx = "DD MMM YYYY", Nx = (e) => (e ?? "").trim() !== "", Px = (e) => {
	if (!Nx(e)) return null;
	try {
		let t = new URL(e);
		return t.protocol === "https:" ? t.toString() : null;
	} catch {
		return null;
	}
}, Fx = "var(--loop-brand-color)", Ix = (e) => {
	let t = e.trim().replaceAll("_PLUS_", " + ").replaceAll("_", " ").replaceAll("-", " ");
	return `${t.charAt(0).toUpperCase()}${t.slice(1).toLowerCase()}`;
}, Lx = { review: "In review" }, Rx = (e) => {
	let t = (e ?? "").trim().toLowerCase();
	return t ? Lx[t] ?? Ix(t) : null;
}, zx = {
	open: "info",
	review: "warning",
	closed: "success",
	cancelled: "error",
	expired: "secondary"
}, Bx = (e) => zx[(e ?? "").trim().toLowerCase()] ?? "secondary", Vx = {
	credit: "Store credit",
	exchange_PLUS_credit: "Exchange + store credit"
}, Hx = (e) => {
	let t = (e ?? "").trim();
	return t ? Vx[t] ?? Ix(t) : null;
}, Ux = (e) => {
	let t = (e ?? "").trim().toLowerCase();
	return !t || t === "default" ? null : Ix(t);
}, Wx = ({ total: e, currency: t }) => Nx(e) ? [e.trim(), (t ?? "").trim()].filter(Boolean).join(" ") : null, Gx = (e) => (e ?? []).filter(Boolean).length, Kx = "Unnamed item", qx = (e) => {
	let t = /* @__PURE__ */ new Map();
	for (let n of e ?? []) {
		if (!n) continue;
		let e = Nx(n.title) ? n.title.trim() : Kx, r = Nx(n.sku) ? n.sku.trim() : null, i = Nx(n.return_reason) ? n.return_reason.trim() : null, a = Ux(n.outcome), o = JSON.stringify([
			e,
			r,
			i,
			a
		]), s = t.get(o);
		s ? t.set(o, {
			...s,
			quantity: s.quantity + 1
		}) : t.set(o, {
			key: o,
			title: e,
			sku: r,
			returnReason: i,
			outcome: a,
			quantity: 1
		});
	}
	return [...t.values()];
}, Jx = {
	lineItem: "_lineItem_zi9td_1",
	lineItemQuantity: "_lineItemQuantity_zi9td_7",
	lineItemContent: "_lineItemContent_zi9td_10"
}, Yx = ({ returnId: e, lineItems: t }) => {
	let r = qx(t);
	if (r.length === 0) return null;
	let i = Gx(t);
	return /* @__PURE__ */ K(v, {
		gap: "100",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: "cart-shopping",
				color: Fx
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "3",
				children: /* @__PURE__ */ K(v, {
					gap: "200",
					flexDirection: "row",
					alignItems: "center",
					children: ["Line items", /* @__PURE__ */ G(n, {
						variant: "success",
						size: "small",
						children: i
					})]
				})
			})]
		}), /* @__PURE__ */ G(v, {
			flexDirection: "column",
			children: r.map(({ key: t, title: n, sku: r, returnReason: i, outcome: a, quantity: o }) => /* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				alignItems: "center",
				className: Jx.lineItem,
				"data-testid": "widget-return-line-item",
				children: [/* @__PURE__ */ K(v, {
					gap: "200",
					className: Jx.lineItemQuantity,
					children: [/* @__PURE__ */ G(L.Paragraph, { children: o }), /* @__PURE__ */ G(L.Paragraph, { children: "×" })]
				}), /* @__PURE__ */ K(v, {
					flexDirection: "column",
					className: Jx.lineItemContent,
					children: [
						/* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: n
						}),
						r && /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "tertiary",
							children: r
						}),
						i && /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: i
						}),
						a && /* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "secondary",
							children: a
						})
					]
				})]
			}, `list-${e}-${t}`))
		})]
	});
}, Xx = {
	return: "_return_1t3xq_1",
	returnIsOpen: "_returnIsOpen_1t3xq_11",
	returnHeader: "_returnHeader_1t3xq_14",
	statusPageButton: "_statusPageButton_1t3xq_19",
	trackingRow: "_trackingRow_1t3xq_24",
	trackingRowDetails: "_trackingRowDetails_1t3xq_33",
	trackingRowCode: "_trackingRowCode_1t3xq_40",
	trackingRowCarrier: "_trackingRowCarrier_1t3xq_44"
}, Zx = ({ loopReturn: e, isOpenByDefault: t }) => {
	let [r, i] = U(t), { isCopied: o, copy: s } = Re(), { id: c, order_name: l, state: u, outcome: d, type: f, created_at: p, total: m, currency: h, carrier: g, tracking_number: _, status_page_url: y, line_items: b } = e, C = Rx(u), w = Hx(d), T = Wx({
		total: m,
		currency: h
	}), E = Px(y), D = Nx(g) || Nx(_), O = f === Ex.Warranty;
	return /* @__PURE__ */ K(v, {
		className: ht(Xx.return, { [Xx.returnIsOpen]: r }),
		gap: "200",
		flexDirection: "column",
		"data-testid": "widget-return",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: Xx.returnHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [p && /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: Ax(p).format("DD MMM YYYY")
				}), /* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "1",
						children: [O ? "Warranty return" : "Return", Nx(l) && ` for order ${l}`]
					}), C && /* @__PURE__ */ G(n, {
						variant: Bx(u),
						size: "small",
						children: C
					})]
				})]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: r ? "angle-down" : "angle-right"
			})]
		}), r && /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				w && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "undo",
						color: "var(--loop-brand-color)"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Outcome"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: w
						})]
					})]
				}),
				T && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "chart-bar",
						color: "var(--loop-brand-color)"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Return value"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: T
						})]
					})]
				}),
				/* @__PURE__ */ G(Yx, {
					returnId: c ?? l ?? "unknown",
					lineItems: b
				}),
				D && /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ K(v, {
						gap: "250",
						flexDirection: "row",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "truck",
							color: "var(--loop-brand-color)"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Tracking"
						})]
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						alignItems: "center",
						className: Xx.trackingRow,
						children: [/* @__PURE__ */ K(v, {
							gap: "250",
							alignItems: "center",
							className: Xx.trackingRowDetails,
							children: [Nx(g) && /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								className: Xx.trackingRowCarrier,
								children: g
							}), Nx(_) && /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								color: "tertiary",
								className: Xx.trackingRowCode,
								children: _
							})]
						}), Nx(_) && /* @__PURE__ */ G(R, {
							content: "Copy tracking code",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: o ? "done" : "copy",
								onClick: () => s(_),
								className: jx.copyIcon,
								"data-testid": "widget-return-copy-tracking-code"
							})
						})]
					})]
				}),
				E && /* @__PURE__ */ G(v, {
					width: "100%",
					children: /* @__PURE__ */ G(a, {
						variant: "secondary",
						icon: "external-link",
						className: ht(jx.fullWidth, Xx.statusPageButton),
						onClick: () => {
							window.open(E, "_blank", "noopener")?.focus();
						},
						children: "Open the return status page"
					})
				})
			]
		})]
	});
}, Qx = (e) => [...e ?? []].sort((e, t) => {
	let n = e.created_at ? Ax(e.created_at).valueOf() : 0;
	return (t.created_at ? Ax(t.created_at).valueOf() : 0) - n;
}), $x = ({ searchedFromDate: e, truncated: t, hasMoreReturns: n, shownReturns: r }) => {
	let i = Ax(e).format(Mx);
	return t ? `The lookup stopped early, so returns since ${i} may be missing.` : n ? `Showing the latest ${r} ${r === 1 ? "return" : "returns"}. Older returns exist in Loop.` : `All returns since ${i}.`;
}, eS = ({ email: e }) => {
	let { useQuery: t } = B(), { loading: r, error: i, data: a } = t(kx, {
		skip: !e,
		variables: { email: e }
	});
	if (i) {
		let e = i.graphQLErrors;
		return xe({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The Loop API key used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Loop. Please contact your administrator."
		}) : /* @__PURE__ */ G(z, { error: i });
	}
	if (r) return /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ G(P, {})
	});
	let o = a?.LoopReturns?.returnsByCustomerEmail, s = Qx(o?.returns);
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Returns"
				}), s.length > 0 && /* @__PURE__ */ G(n, {
					variant: "success",
					size: "small",
					children: s.length
				})]
			}),
			o && s.length === 0 && /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "200 0 300 0",
				"data-testid": "widget-no-returns",
				children: /* @__PURE__ */ G(L.Paragraph, {
					color: "tertiary",
					children: "No returns found"
				})
			}),
			s.length > 0 && /* @__PURE__ */ G(v, {
				gap: "200",
				flexDirection: "column",
				children: s.map((e, t) => /* @__PURE__ */ G(Zx, {
					loopReturn: e,
					isOpenByDefault: t === 0
				}, e.id ?? t))
			}),
			o && /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "tertiary",
				"data-testid": "widget-searched-period",
				children: $x({
					...o,
					shownReturns: s.length
				})
			})
		]
	});
}, tS = ({ conversationContext: e }) => {
	let t = e?.customer?.email;
	return t ? /* @__PURE__ */ G(v, {
		flexDirection: "column",
		gap: "300",
		margin: "200 0 300",
		children: /* @__PURE__ */ G(eS, { email: t })
	}) : /* @__PURE__ */ G(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		variant: "4",
		children: "This conversation has no customer email, so the Loop returns cannot be looked up."
	});
}, nS = [
	{
		value: "1",
		label: "1 return"
	},
	{
		value: "5",
		label: "5 returns"
	},
	{
		value: "10",
		label: "10 returns"
	},
	{
		value: "15",
		label: "15 returns"
	}
], rS = [{
	key: "loopReturnsApiKey",
	label: "Loop Returns API key",
	defaultValue: "",
	secret: !0,
	type: "string"
}, {
	key: "loopReturnsMaxReturns",
	label: "Maximum returns to show",
	defaultValue: "5",
	secret: !1,
	type: "string"
}], iS = Pe(rS), aS = "LOOP", oS = "Loop", sS = "Generate the key in Loop Admin under Returns Management → Tools & integrations → Developer Tools → Generate API key, with the \"returns\" and \"orders\" scopes.", cS = "How many of a customer's latest returns the widget shows.", lS = {
	enabled: !1,
	name: "",
	loopReturnsApiKey: "",
	loopReturnsMaxReturns: "5"
}, uS = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r }) => {
	let i = !e, a = gl({
		mode: "onChange",
		defaultValues: lS
	}), { create: o, update: s, remove: c, isLoading: l, error: u, misconfigurationCause: d, setMisconfigurationCause: f } = He({
		integrationId: e,
		integrationType: aS,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: p, error: m, isWidgetUnknown: h, refetch: g } = Ue({
		integrationId: e,
		fieldDefinitions: rS,
		form: a,
		onMisconfigured: f
	}), S = (e) => ye(e, {
		fieldDefinitions: rS,
		isCreationMode: i,
		create: o,
		update: s
	}), C = a.watch("name");
	return /* @__PURE__ */ K(de, {
		form: a,
		integrationId: e,
		onValidSubmit: S,
		error: m ?? u,
		onRetry: m ? g : void 0,
		isLoading: l || p,
		isWidgetUnknown: h,
		children: [
			d && /* @__PURE__ */ G(se, { cause: d }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: a.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: a.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "loopReturnsApiKey",
						label: iS.loopReturnsApiKey,
						helpIcon: { text: sS },
						control: a.control,
						isCreationMode: i,
						rules: { required: "Loop Returns API key is required" },
						componentProps: {
							placeholder: "Insert your Loop Returns API key",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(wl, {
						name: "loopReturnsMaxReturns",
						control: a.control,
						label: iS.loopReturnsMaxReturns,
						helpIcon: { text: cS },
						rules: { required: "Please choose how many returns to show" },
						componentProps: {
							placeholder: "Select an option",
							equalityFn: (e, t) => e === t,
							getItemTitleByValue: (e) => {
								let t = nS.find((t) => t.value === e)?.label;
								return t ? /* @__PURE__ */ G(L.Paragraph, { children: t }) : null;
							}
						},
						children: nS.map((e) => /* @__PURE__ */ G(N.Item, {
							value: e.value,
							children: e.label
						}, e.value))
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 })
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: aS,
				integrationId: e,
				widgetName: C,
				isCreationMode: i,
				isSubmitting: a.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => c(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ K(v, {
					gap: "400",
					children: [/* @__PURE__ */ G(x, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ K(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									oS,
									" integration, all links between Dixa and ",
									oS,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"All data in ",
								oS,
								" stays untouched."
							] }),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								oS,
								" ",
								"integration \"",
								C,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-loyaltylion/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var dS = {
	"\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "FragmentDefinition",
			name: {
				kind: "Name",
				value: "BadRequest"
			},
			typeCondition: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "LoyaltyLion_BadRequest"
				}
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "message"
					}
				}]
			}
		}]
	},
	"\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "addPoints"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "merchantId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}, {
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "input"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "LoyaltyLion_updateCustomersPoints_request_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "LoyaltyLion"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "updateCustomersPoints"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "merchant_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "merchantId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "input"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "LoyaltyLion_updateCustomersPoints_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "UpdateCustomersPointsResponse"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "BadRequest"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_BadRequest"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Unauthorized"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Unauthorized"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Forbidden"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Forbidden"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "NotFound"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_NotFound"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "UnprocessableEntity"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_UnprocessableEntity"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerError"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_ServerError"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "UpdateCustomersPointsResponse"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_updateCustomersPoints_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "BadRequest"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Unauthorized"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Forbidden"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "NotFound"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "UnprocessableEntity"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "ServerError"
							}
						}
					]
				}
			}
		]
	},
	"\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "mutation",
				name: {
					kind: "Name",
					value: "removePoints"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "merchantId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}, {
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "input"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "LoyaltyLion_removeCustomersPoints_request_Input"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "LoyaltyLion"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "removeCustomersPoints"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "merchant_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "merchantId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "input"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "input"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "LoyaltyLion_removeCustomersPoints_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "FragmentSpread",
												name: {
													kind: "Name",
													value: "RemoveCustomersPointsResponse"
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "BadRequest"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_BadRequest"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Unauthorized"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Unauthorized"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Forbidden"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Forbidden"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "NotFound"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_NotFound"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "UnprocessableEntity"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_UnprocessableEntity"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerError"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_ServerError"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "RemoveCustomersPointsResponse"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_removeCustomersPoints_response"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "BadRequest"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Unauthorized"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "Forbidden"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "NotFound"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "UnprocessableEntity"
							}
						},
						{
							kind: "FragmentSpread",
							name: {
								kind: "Name",
								value: "ServerError"
							}
						}
					]
				}
			}
		]
	},
	"\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomers"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "LoyaltyLion"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCustomers"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "LoyaltyLion_getCustomers_response"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "LoyaltyLion_Customers"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "customers"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "merchant_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "points_approved"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "points_pending"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "points_spent"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "rewards_claimed"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "birthday"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "guest"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "blocked"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "enrolled"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "enrolled_at"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "referral_id"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "referred_by"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "id"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "merchant_id"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "loyalty_tier_membership"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "started_at"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "expires_at"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "manual"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "loyalty_tier"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "id"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "name"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "position"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "default"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "hidden"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "lower_bound"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "upper_bound"
																						}
																					}
																				]
																			}
																		}
																	]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "insights_segment"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "referral_url"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "metadata"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "shopify_source_url"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "properties"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "first_name"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "last_name"
																			}
																		}
																	]
																}
															}
														]
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [
			{
				kind: "OperationDefinition",
				operation: "query",
				name: {
					kind: "Name",
					value: "getRewards"
				},
				variableDefinitions: [{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "merchantId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}],
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "LoyaltyLion"
						},
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "getAvailableRewards"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "merchant_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "merchantId"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "LoyaltyLion_getAvailableRewards_response"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "InlineFragment",
													typeCondition: {
														kind: "NamedType",
														name: {
															kind: "Name",
															value: "LoyaltyLion_Rewards"
														}
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "rewards"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "id"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "title"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "description"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "site_id"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "target_site"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "name"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "url"
																					}
																				}
																			]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "content"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "kind"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "point_cost"
																		}
																	}
																]
															}
														}]
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "BadRequest"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "Unauthorized"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "Forbidden"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "NotFound"
													}
												},
												{
													kind: "FragmentSpread",
													name: {
														kind: "Name",
														value: "ServerError"
													}
												}
											]
										}
									}]
								}
							}]
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "BadRequest"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_BadRequest"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Unauthorized"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Unauthorized"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "Forbidden"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_Forbidden"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "NotFound"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_NotFound"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			},
			{
				kind: "FragmentDefinition",
				name: {
					kind: "Name",
					value: "ServerError"
				},
				typeCondition: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "LoyaltyLion_ServerError"
					}
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "message"
						}
					}]
				}
			}
		]
	}
};
function fS(e) {
	return dS[e] ?? {};
}
var pS = fS("\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), mS = fS("\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n"), hS = fS("\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n"), gS = fS("\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n"), _S = Ws;
function vS({ now: e, deprecationDate: t }) {
	let n = _S(t).format("DD MMM YYYY"), r = t.getTime() - e.getTime(), i = Math.max(Math.floor(r / (1e3 * 60 * 60 * 24)), 0);
	return {
		displayDate: n,
		deprecatesInText: `${i} ${i === 1 ? "day" : "days"}`
	};
}
function yS(e, t) {
	switch (e) {
		case "settings": return {
			headline: "You're using a legacy authentication method",
			description: `LoyaltyLion has deprecated token and secret authentication. Migrate to using API key authorization before ${t.displayDate} (${t.deprecatesInText}).`
		};
		case "widget": return { description: `This LoyaltyLion connection uses a legacy authentication method. Ask your administrator to migrate to API key authorization before ${t.displayDate} (${t.deprecatesInText}).` };
	}
}
var bS = /* @__PURE__ */ new Date("2027-01-10T12:00:00Z"), xS = ({ audience: e, onSwitchToApiKey: t, onCancelSwitch: n }) => {
	let { headline: i, description: o } = yS(e, Qe(() => vS({
		now: /* @__PURE__ */ new Date(),
		deprecationDate: bS
	}), []));
	return /* @__PURE__ */ G(v, {
		margin: e === "settings" ? "0 0 400" : "0 0 300 0",
		"data-testid": "loyaltylion-auth-migration-banner",
		children: /* @__PURE__ */ G(r, {
			variant: "warning",
			headline: i,
			description: /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(L.Paragraph, { children: o }), e === "settings" && /* @__PURE__ */ G(L.Paragraph, { children: /* @__PURE__ */ G(L.ExternalLink, {
				href: "https://developers.loyaltylion.com/api-reference/authentication/api-keys",
				target: "_blank",
				rel: "noreferrer",
				children: "See LoyaltyLion's documentation on creating API keys."
			}) })] }),
			actionSlot: n ? /* @__PURE__ */ G(a, {
				variant: "secondary",
				onClick: n,
				children: "Cancel"
			}) : t && /* @__PURE__ */ G(a, {
				variant: "primary",
				onClick: t,
				children: "Switch to API key"
			})
		})
	});
};
function SS(e) {
	return e?.loyaltyLionAuth === "API_KEY" ? "API_KEY" : "TOKEN_AND_SECRET";
}
function CS(e = !1, t) {
	let [n, r] = U(e);
	return H(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var wS = {
	wrapper: "_wrapper_27vny_1",
	textVariant: "_textVariant_27vny_7",
	copyIcon: "_copyIcon_27vny_12"
}, TS = ({ customer: e }) => {
	let { isCopied: t, copy: n } = CS(), { isCopied: r, copy: i } = CS(), { isCopied: a, copy: o } = CS();
	if (!e) return null;
	let { email: s, properties: c, metadata: l, birthday: u, created_at: d, enrolled: f, enrolled_at: p, referral_url: m } = e, h = u ? _S(u).isSame(Date.now(), "day") : !1, { name: g, first_name: _, last_name: y } = c ?? {}, b = g ?? (`${_} ${y}`.trim() || "A customer has no name"), S = l?.shopify_source_url ? l.shopify_source_url.startsWith("https://") ? l.shopify_source_url : `https://${l.shopify_source_url}` : "";
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			className: wS.wrapper,
			gap: "250",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					className: wS.block,
					alignItems: "center",
					children: [/* @__PURE__ */ G(L.Heading, {
						variant: "heading-2",
						children: b
					}), h && /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "primary",
						children: "... has birthday today 🥳"
					})]
				}),
				d && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: "Member since"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: _S(d).format("DD MMM YYYY @ HH:mm")
					})]
				}),
				f && /* @__PURE__ */ G(v, {
					gap: "200",
					children: /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: ["Enrolled since ", _S(p).format("DD MMM YYYY @ HH:mm")]
					})
				}),
				/* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ G(L.ExternalLink, {
							href: `mailto:${s}`,
							children: s
						})]
					}), /* @__PURE__ */ G(R, {
						content: t ? "Copied" : "Copy",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: t ? "done" : "copy",
							onClick: () => n(s),
							className: wS.copyIcon
						})
					})]
				}),
				S && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "link"
						}), /* @__PURE__ */ G(R, {
							content: "Shopify shop",
							children: /* @__PURE__ */ G(L.ExternalLink, {
								href: S,
								target: "_blank",
								rel: "noreferrer",
								children: S.replace("https://", "")
							})
						})]
					}), /* @__PURE__ */ G(R, {
						content: r ? "Copied" : "Copy",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: r ? "done" : "copy",
							onClick: () => i(S),
							className: wS.copyIcon
						})
					})]
				}),
				m && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "external-link"
						}), /* @__PURE__ */ G(R, {
							content: "Referral link",
							children: /* @__PURE__ */ G(L.ExternalLink, {
								href: m,
								target: "_blank",
								rel: "noreferrer",
								children: m.replace("https://", "")
							})
						})]
					}), /* @__PURE__ */ G(R, {
						content: a ? "Copied" : "Copy",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(m),
							className: wS.copyIcon
						})
					})]
				})
			]
		})
	});
}, ES = {
	labelText: "_labelText_1q5b5_1",
	list: "_list_1q5b5_5",
	listItem: "_listItem_1q5b5_8",
	listItemEdit: "_listItemEdit_1q5b5_15",
	notificationText: "_notificationText_1q5b5_19"
}, DS = { modalBody: "_modalBody_1clhs_1" }, OS = ({ isOpen: e, points: t, merchantId: n, onClose: r, refetchCustomerData: i }) => {
	let { useMutation: a, showNotification: o } = B(), { track: s } = Ve(), [c, l] = U(t), [u, d] = U(""), [f, p] = U(), [m, { loading: g }] = a(hS, { onCompleted: () => {
		o({
			title: "Success",
			text: "Added points successfully",
			icon: "check-circle-filled",
			severity: "success"
		}), s("loyaltylion:add:points:succeeded"), te();
	} }), [_, { loading: S }] = a(gS), C = g || S, w = !!f, T = t === c ? "Change the value to update the points" : "", j = isNaN(c), M = j ? "Points can not be empty" : "", N = c > t && c - t > 1e6, ee = N ? "Points can not exceed 1,000,000" : "", F = () => {
		if (!n) {
			p(["Merchant information is missing."]), c > t ? s("loyaltylion:add:points:failed") : c < t && s("loyaltylion:remove:points:failed");
			return;
		}
		c > t && m({ variables: {
			input: {
				points: c - t,
				reason: u
			},
			merchantId: n
		} }).catch((e) => {
			let t = e?.networkError;
			(t ? t?.statusCode : NaN) === 201 ? (s("loyaltylion:add:points:succeeded"), o({
				title: "Success",
				text: "Added points successfully",
				icon: "check-circle-filled",
				severity: "success"
			}), te()) : (s("loyaltylion:add:points:failed"), p(["Failed to add points, try again later."]));
		}), c < t && _({ variables: {
			input: {
				points: t - c,
				reason: u
			},
			merchantId: n
		} }).then((e) => {
			e.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (s("loyaltylion:remove:points:succeeded"), o({
				title: "Success",
				text: "Removed points successfully",
				icon: "check-circle-filled",
				severity: "success"
			}), te()) : "errors" in e && (s("loyaltylion:remove:points:failed"), p(e.errors?.map((e) => e.message) ?? ["Failed to remove points, try again later."]));
		}).catch(() => {
			s("loyaltylion:remove:points:failed"), p(["Failed to remove points, try again later."]);
		});
	}, I = () => {
		j && l(t), d(""), r();
	}, te = () => {
		i(), I();
	};
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		onClose: I,
		"data-testid": "change-points-modal",
		children: [
			/* @__PURE__ */ G(A, {
				title: "Change points",
				onClose: I
			}),
			/* @__PURE__ */ K(O, {
				className: DS.modalBody,
				children: [/* @__PURE__ */ K(b, { children: [/* @__PURE__ */ G(y, {
					span: 6,
					children: /* @__PURE__ */ G(h, {
						required: !0,
						label: "New points",
						type: "number",
						placeholder: "Insert new points",
						min: 0,
						max: 1e5,
						meta: {
							error: ee || M,
							warning: T
						},
						input: {
							name: "points",
							value: c.toString(),
							onChange: (e) => l(e?.target.valueAsNumber ?? 0)
						},
						"data-testid": "points-input"
					})
				}), /* @__PURE__ */ G(y, {
					span: 6,
					children: /* @__PURE__ */ G(h, {
						label: "Reason",
						placeholder: "Insert an optional reason",
						input: {
							name: "reason",
							value: u,
							onChange: (e) => d(e?.target.value ?? "")
						}
					})
				})] }), !C && w && /* @__PURE__ */ G(v, {
					margin: "200 0",
					flexDirection: "column",
					children: /* @__PURE__ */ G(E, { children: f?.map((e, t) => /* @__PURE__ */ G(E.Item, {
						variant: "dense",
						title: e,
						contentLeft: /* @__PURE__ */ G(x, {
							color: "red.500",
							size: 16,
							name: "exclamation-triangle-filled"
						})
					}, t)) })
				})]
			}),
			/* @__PURE__ */ G(k, {
				confirmName: "Save",
				confirmOnClick: () => F(),
				confirmProps: {
					isLoading: C,
					disabled: j || N || t === c,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				cancelOnClick: I
			})
		]
	});
}, kS = ({ label: e, points: t, setIsModalOpen: r }) => {
	let i = t > 0 ? "green.500" : "neutral.400", a = t > 0 ? "warning" : "secondary";
	return /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: ES.listItem,
		children: /* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			children: [/* @__PURE__ */ K(v, {
				gap: "200",
				alignItems: "center",
				children: [/* @__PURE__ */ G(x, {
					color: i,
					size: 10,
					name: "star-full"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: e
				})]
			}), /* @__PURE__ */ K(v, {
				gap: "200",
				alignItems: "center",
				children: [r && /* @__PURE__ */ G(R, {
					content: "Edit points",
					children: /* @__PURE__ */ G(x, {
						name: "pen",
						size: 10,
						"aria-label": "Edit points",
						className: ES.listItemEdit,
						onClick: () => r(!0)
					})
				}), /* @__PURE__ */ G(n, {
					size: "small",
					variant: a,
					children: t
				})]
			})]
		})
	});
}, AS = ({ customer: e, refetchCustomerData: t }) => {
	let [n, r] = U(!1);
	if (!e) return null;
	let { merchant_id: i, points_approved: a, points_pending: o, points_spent: s, rewards_claimed: c } = e, l = [
		{
			id: "pointsApproved",
			label: "Points approved",
			points: a ?? 0,
			setIsModalOpen: r
		},
		{
			id: "pointsPending",
			label: "Points pending",
			points: o ?? 0
		},
		{
			id: "pointsSpent",
			label: "Points spent",
			points: s ?? 0
		},
		{
			id: "rewardClaimed",
			label: "Rewards claimed",
			points: c ?? 0
		}
	];
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Points balance"
			}),
			/* @__PURE__ */ G(E, {
				className: ES.list,
				children: l.map(({ id: e, points: t, label: n, setIsModalOpen: r }) => /* @__PURE__ */ G(kS, {
					points: t,
					label: n,
					setIsModalOpen: r
				}, e))
			}),
			/* @__PURE__ */ G(OS, {
				isOpen: n,
				points: a,
				merchantId: i,
				onClose: () => r(!1),
				refetchCustomerData: t
			})
		]
	});
}, jS = { reward: "_reward_1wxia_1" }, MS = ({ reward: e }) => {
	let { title: t, point_cost: r, target_site: i, description: a } = e, o = i?.name, s = i?.url;
	return /* @__PURE__ */ G(v, {
		gap: "100",
		flexDirection: "column",
		className: jS.reward,
		children: /* @__PURE__ */ G(R, {
			content: a ?? "No description",
			children: /* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "100",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							name: "star",
							size: 12,
							color: "neutral.500"
						}), t]
					}), /* @__PURE__ */ K(n, {
						size: "small",
						variant: "info",
						children: [r ?? 0, " points"]
					})]
				}), o && s && /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "row",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ G(L.ExternalLink, {
						href: s,
						target: "_blank",
						rel: "noreferrer",
						children: o
					})]
				})]
			})
		})
	});
}, NS = ({ customer: e }) => {
	let { useQuery: t } = B(), [n, r] = U(), { merchant_id: i } = e, { loading: a, error: o, data: s } = t(mS, {
		skip: !i,
		variables: { merchantId: i }
	});
	if (H(() => {
		if (s?.LoyaltyLion) {
			let e = s.LoyaltyLion?.getAvailableRewards?.rewards;
			e && r(e);
		}
	}, [s]), o) {
		let e = o.graphQLErrors;
		return Se({ errors: e }) ? /* @__PURE__ */ G(v, {
			justifyContent: "center",
			margin: "200 0 300 0",
			className: ES.notificationText,
			children: "No rewards found"
		}) : Ce({ errors: e }) ? /* @__PURE__ */ G(v, {
			justifyContent: "center",
			margin: "200 0 300 0",
			className: ES.notificationText,
			children: "You don't have permissions to view rewards"
		}) : /* @__PURE__ */ G(z, { error: o });
	}
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Available rewards"
		}), a ? /* @__PURE__ */ G(v, {
			justifyContent: "center",
			margin: "200 0 300 0",
			children: /* @__PURE__ */ G(P, {})
		}) : /* @__PURE__ */ G(v, {
			gap: "200",
			flexDirection: "column",
			children: n?.map((e) => /* @__PURE__ */ G(MS, { reward: e }, e.id))
		})]
	});
}, PS = ({ customer: e }) => {
	let { blocked: t, guest: n, insights_segment: r } = e ?? {};
	return t || n || r ? /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "row",
		flexWrap: "wrap",
		children: [
			t && /* @__PURE__ */ G(v, {
				alignItems: "start",
				children: /* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						color: "red.500",
						name: "exclamation-triangle-filled"
					}), "Blocked"]
				}) })
			}),
			n && /* @__PURE__ */ G(v, {
				alignItems: "start",
				children: /* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						color: "green.500",
						name: "user"
					}), "Guest"]
				}) })
			}),
			r && /* @__PURE__ */ G(v, {
				alignItems: "start",
				children: /* @__PURE__ */ G(R, {
					content: "Insights segment",
					children: /* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							color: "green.500",
							name: "team"
						}), r]
					}) })
				})
			})
		]
	}) : null;
}, FS = ({ additionalProperties: e, ...t }) => /* @__PURE__ */ K(W, { children: [SS(e) === "TOKEN_AND_SECRET" && /* @__PURE__ */ G(xS, { audience: "widget" }), /* @__PURE__ */ G(IS, { ...t })] }), IS = ({ conversationContext: e, settings: t }) => {
	let { useQuery: n } = B(), { track: r } = Ve(), [i, a] = U(null), { customer: o } = e, { showCustomerSummary: s, showTags: c, showPointsBalance: l, showAvailableRewards: u } = t, d = !s && !c && !l && !u, { loading: f, error: p, data: m, refetch: h } = n(pS, {
		skip: !o?.email,
		variables: { email: o?.email ?? "" }
	});
	return H(() => {
		if (m && !f) {
			let e = (m?.LoyaltyLion?.getCustomers).customers;
			e && e.length > 0 && (a(e[0]), r("loyaltylion:customer:received"));
		}
	}, [m, f]), o?.email ? p ? Se({ errors: p.graphQLErrors }) ? /* @__PURE__ */ K(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		className: ES.notificationText,
		children: ["No user found for email: ", o?.email]
	}) : /* @__PURE__ */ G(z, { error: p }) : f ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(P, {})
	}) : d ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "no-feature-enabled-message",
		children: "All features toggles in the integration settings are disabled"
	}) : /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		margin: "0 0 300 0",
		"data-testid": "widget-wrapper",
		children: i ? /* @__PURE__ */ K(W, { children: [
			s && /* @__PURE__ */ G(TS, { customer: i }),
			c && /* @__PURE__ */ G(PS, { customer: i }),
			l && /* @__PURE__ */ G(AS, {
				customer: i,
				refetchCustomerData: h
			}),
			u && /* @__PURE__ */ G(NS, { customer: i })
		] }) : /* @__PURE__ */ G(v, {
			justifyContent: "center",
			padding: "200",
			children: "Nothing found"
		})
	}) : /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "no-email-message",
		children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
	});
}, LS = [
	{
		key: "basicAuthorization",
		label: "LoyaltyLion authorization",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "loyaltyLionApiKey",
		label: "LoyaltyLion API key",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "showCustomerSummary",
		label: "Show customer summary",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showTags",
		label: "Show tags",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showPointsBalance",
		label: "Show points balance",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showAvailableRewards",
		label: "Show available rewards",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], RS = Pe(LS), zS = "LOYALTYLION", BS = {
	enabled: !1,
	name: "",
	showCustomerSummary: !0,
	showTags: !0,
	showPointsBalance: !0,
	showAvailableRewards: !0
}, VS = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r }) => {
	let i = !e, a = gl({
		mode: "onChange",
		defaultValues: BS
	}), { create: o, update: s, remove: c, isLoading: l, error: u, misconfigurationCause: d, setMisconfigurationCause: f } = He({
		integrationId: e,
		integrationType: zS,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: p, error: m, isWidgetUnknown: h, refetch: g, widgetConfiguration: v } = Ue({
		integrationId: e,
		fieldDefinitions: LS,
		form: a,
		onMisconfigured: f
	}), x = i ? "API_KEY" : SS(v?.additionalProperties), [S, C] = U("NEEDS_MIGRATION"), w = x === "API_KEY" ? "NO_MIGRATION_NEEDED" : S, T = i || v !== void 0, E = et(!1);
	H(() => {
		C("NEEDS_MIGRATION"), E.current = !1;
	}, [e]), H(() => {
		E.current && !l && w === "MIGRATION_IN_PROGRESS" && !u && C("NO_MIGRATION_NEEDED"), E.current = l;
	}, [
		l,
		u,
		w
	]);
	let D = T && w !== "NEEDS_MIGRATION", O = i || w === "MIGRATION_IN_PROGRESS", k = (e) => ye(e, {
		fieldDefinitions: LS,
		isCreationMode: i,
		create: o,
		update: s
	}), A = a.watch("name");
	return /* @__PURE__ */ K(de, {
		form: a,
		integrationId: e,
		onValidSubmit: k,
		error: m ?? u,
		onRetry: m ? g : void 0,
		isLoading: l || p,
		isWidgetUnknown: h,
		children: [
			d && /* @__PURE__ */ G(se, { cause: d }),
			T && w !== "NO_MIGRATION_NEEDED" && !l && /* @__PURE__ */ G(xS, {
				audience: "settings",
				onSwitchToApiKey: w === "NEEDS_MIGRATION" ? () => C("MIGRATION_IN_PROGRESS") : void 0,
				onCancelSwitch: w === "MIGRATION_IN_PROGRESS" ? () => C("NEEDS_MIGRATION") : void 0
			}),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: a.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: a.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: D ? /* @__PURE__ */ G(ue, {
						name: "loyaltyLionApiKey",
						label: RS.loyaltyLionApiKey,
						control: a.control,
						isCreationMode: O,
						rules: { required: "API access key is required" },
						componentProps: {
							placeholder: "Insert your API access key",
							autoComplete: "off"
						}
					}, O ? "new" : "existing") : /* @__PURE__ */ G(le, {
						name: "basicAuthorization",
						label: RS.basicAuthorization,
						control: a.control,
						isCreationMode: i,
						rules: { required: "Please insert a value for both fields" },
						usernameLabel: "Token",
						passwordLabel: "Secret",
						usernamePlaceholder: "Insert your token",
						passwordPlaceholder: "Insert your secret"
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: RS.showCustomerSummary,
						children: /* @__PURE__ */ G(X, {
							name: "showCustomerSummary",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: RS.showTags,
						children: /* @__PURE__ */ G(X, {
							name: "showTags",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: RS.showPointsBalance,
						children: /* @__PURE__ */ G(X, {
							name: "showPointsBalance",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: RS.showAvailableRewards,
						children: /* @__PURE__ */ G(X, {
							name: "showAvailableRewards",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 })
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: zS,
				integrationId: e,
				widgetName: A,
				isCreationMode: i,
				isSubmitting: a.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => c()
			})
		]
	});
};
//#endregion
//#region ../widget-miuros/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var HS = { "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": {
	kind: "Document",
	definitions: [{
		kind: "OperationDefinition",
		operation: "query",
		name: {
			kind: "Name",
			value: "conversationsQuery"
		},
		variableDefinitions: [{
			kind: "VariableDefinition",
			variable: {
				kind: "Variable",
				name: {
					kind: "Name",
					value: "query"
				}
			},
			type: {
				kind: "NamedType",
				name: {
					kind: "Name",
					value: "String"
				}
			}
		}],
		selectionSet: {
			kind: "SelectionSet",
			selections: [{
				kind: "Field",
				name: {
					kind: "Name",
					value: "Miuros"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "findTickets"
						},
						arguments: [{
							kind: "Argument",
							name: {
								kind: "Name",
								value: "query"
							},
							value: {
								kind: "Variable",
								name: {
									kind: "Name",
									value: "query"
								}
							}
						}, {
							kind: "Argument",
							name: {
								kind: "Name",
								value: "page_size"
							},
							value: {
								kind: "IntValue",
								value: "10"
							}
						}],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "Field",
								name: {
									kind: "Name",
									value: "data"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "labels"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "subject"
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "messages"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "direction"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "body"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "agent"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "email"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													}
												]
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "custom_fields"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "additionalProperties"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "key"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "value"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "value"
																	}
																}]
															}
														}]
													}
												}]
											}
										},
										{
											kind: "Field",
											name: {
												kind: "Name",
												value: "created_at"
											}
										}
									]
								}
							}]
						}
					}]
				}
			}]
		}
	}]
} };
function US(e) {
	return HS[e] ?? {};
}
var WS = Ws;
function GS(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function KS(e) {
	if (Array.isArray(e)) return e;
}
function qS(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function JS() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function YS(e, t) {
	return KS(e) || qS(e, t) || XS(e, t) || JS();
}
function XS(e, t) {
	if (e) {
		if (typeof e == "string") return GS(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? GS(e, t) : void 0;
	}
}
var ZS = Object.entries, QS = Object.setPrototypeOf, $S = Object.isFrozen, eC = Object.getPrototypeOf, tC = Object.getOwnPropertyDescriptor, nC = Object.freeze, rC = Object.seal, iC = Object.create, aC = typeof Reflect < "u" && Reflect, oC = aC.apply, sC = aC.construct;
nC ||= function(e) {
	return e;
}, rC ||= function(e) {
	return e;
}, oC ||= function(e, t) {
	var n = [...arguments].slice(2);
	return e.apply(t, n);
}, sC ||= function(e) {
	return new e(...[...arguments].slice(1));
};
var cC = OC(Array.prototype.forEach), lC = OC(Array.prototype.lastIndexOf), uC = OC(Array.prototype.pop), dC = OC(Array.prototype.push), fC = OC(Array.prototype.splice), pC = Array.isArray, mC = OC(String.prototype.toLowerCase), hC = OC(String.prototype.toString), gC = OC(String.prototype.match), _C = OC(String.prototype.replace), vC = OC(String.prototype.indexOf), yC = OC(String.prototype.trim), bC = OC(Number.prototype.toString), xC = OC(Boolean.prototype.toString), SC = typeof BigInt > "u" ? null : OC(BigInt.prototype.toString), CC = typeof Symbol > "u" ? null : OC(Symbol.prototype.toString), wC = OC(Object.prototype.hasOwnProperty), TC = OC(Object.prototype.toString), EC = OC(RegExp.prototype.test), DC = kC(TypeError);
function OC(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return oC(e, t, n);
	};
}
function kC(e) {
	return function() {
		return sC(e, [...arguments]);
	};
}
function AC(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : mC;
	if (QS && QS(e, null), !pC(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && ($S(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function jC(e) {
	for (let t = 0; t < e.length; t++) wC(e, t) || (e[t] = null);
	return e;
}
function MC(e) {
	let t = iC(null);
	for (let r of ZS(e)) {
		var n = YS(r, 2);
		let i = n[0], a = n[1];
		wC(e, i) && (pC(a) ? t[i] = jC(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = MC(a) : t[i] = a);
	}
	return t;
}
function NC(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return bC(e);
		case "boolean": return xC(e);
		case "bigint": return SC ? SC(e) : "0";
		case "symbol": return CC ? CC(e) : "Symbol()";
		case "undefined": return TC(e);
		case "function":
		case "object": {
			if (e === null) return TC(e);
			let t = e, n = PC(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : TC(e);
			}
			return TC(e);
		}
		default: return TC(e);
	}
}
function PC(e, t) {
	for (; e !== null;) {
		let n = tC(e, t);
		if (n) {
			if (n.get) return OC(n.get);
			if (typeof n.value == "function") return OC(n.value);
		}
		e = eC(e);
	}
	function n() {
		return null;
	}
	return n;
}
function FC(e) {
	try {
		return EC(e, ""), !0;
	} catch {
		return !1;
	}
}
var IC = nC(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), LC = nC(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), RC = nC([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]), zC = nC([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]), BC = nC(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), VC = nC([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]), HC = nC(["#text"]), UC = nC(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), WC = nC(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dominant-baseline.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.pointer-events.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-orientation.text-rendering.textlength.type.u1.u2.unicode.values.vector-effect.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), GC = nC(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), KC = nC([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]), qC = rC(/{{[\w\W]*|^[\w\W]*}}/g), JC = rC(/<%[\w\W]*|^[\w\W]*%>/g), YC = rC(/\${[\w\W]*/g), XC = rC(/^data-[\-\w.\u00B7-\uFFFF]+$/), ZC = rC(/^aria-[\-\w]+$/), QC = rC(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), $C = rC(/^(?:\w+script|data):/i), ew = rC(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), tw = rC(/^html$/i), nw = rC(/^[a-z][.\w]*(-[.\w]+)+$/i), rw = rC(/<[/\w!]/g), iw = rC(/<[/\w]/g), aw = rC(/<\/no(script|embed|frames)/i), ow = rC(/\/>/i), sw = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	processingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
}, cw = [
	"style",
	"script",
	"xmp",
	"iframe",
	"noembed",
	"noframes",
	"plaintext",
	"noscript"
], lw = nC(AC({}, cw)), uw = function() {
	let e = {};
	return cC(cw, (t) => {
		e[t] = rC(RegExp("</" + t + "(?=[\\t\\n\\f\\r />])", "i"));
	}), nC(e);
}(), dw = function() {
	return typeof window > "u" ? null : window;
}, fw = function(e, t) {
	if (typeof e != "object" || typeof e.createPolicy != "function") return null;
	let n = null, r = "data-tt-policy-suffix";
	t && t.hasAttribute(r) && (n = t.getAttribute(r));
	let i = "dompurify" + (n ? "#" + n : "");
	try {
		return e.createPolicy(i, {
			createHTML(e) {
				return e;
			},
			createScriptURL(e) {
				return e;
			}
		});
	} catch {
		return console.warn("TrustedTypes policy " + i + " could not be created."), null;
	}
}, pw = function() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
}, mw = function(e, t, n, r) {
	return wC(e, t) && pC(e[t]) ? AC(r.base ? MC(r.base) : {}, e[t], r.transform) : n;
}, hw = function(e, t, n) {
	let r = wC(e, t) ? e[t] : void 0;
	return r && typeof r == "object" ? MC(r) : n();
};
function gw() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : dw(), t = (e) => gw(e);
	if (t.version = "3.4.15", t.removed = [], !e || !e.document || e.document.nodeType !== sw.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, f = PC(d, "cloneNode"), p = PC(d, "remove"), m = PC(d, "removeAttributeNode"), h = PC(d, "nextSibling"), g = PC(d, "childNodes"), _ = PC(d, "parentNode"), v = PC(d, "shadowRoot"), y = PC(d, "attributes"), b = o && o.prototype ? PC(o.prototype, "nodeType") : null, x = o && o.prototype ? PC(o.prototype, "nodeName") : null, S = o && o.prototype ? PC(o.prototype, "ownerDocument") : null, C = function(e) {
		return b ? b(e) : e.nodeType;
	}, w = function(e) {
		return x ? x(e) : e.nodeName;
	};
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let T, E = "", D, O = !1, k = 0, A = function() {
		if (k > 0) throw DC("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
	}, j = function(e) {
		A(), k++;
		try {
			return T.createHTML(e);
		} finally {
			k--;
		}
	}, M = function(e) {
		A(), k++;
		try {
			return T.createScriptURL(e);
		} finally {
			k--;
		}
	}, N = function() {
		return O ||= (D = fw(u, i), !0), D;
	}, P = n, ee = P.implementation, F = P.createNodeIterator, I = P.createDocumentFragment, te = P.getElementsByTagName, L = r.importNode, ne = pw();
	t.isSupported = typeof ZS == "function" && typeof _ == "function" && ee && ee.createHTMLDocument !== void 0;
	let re = qC, ie = JC, R = YC, ae = XC, z = ZC, oe = $C, se = ew, ce = nw, le = QC, ue = null, de = AC({}, [
		...IC,
		...LC,
		...RC,
		...BC,
		...HC
	]), fe = null, pe = AC({}, [
		...UC,
		...WC,
		...GC,
		...KC
	]), me = Object.seal(iC(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), he = null, ge = null, _e = Object.seal(iC(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), ve = !0, ye = !0, be = !1, xe = !0, Se = !1, Ce = !0, we = !1, Te = !1, Ee = null, De = null, Oe = !1, ke = !1, Ae = !1, je = !1, Me = !0, Ne = !1, Pe = "user-content-", Fe = !0, Ie = !1, Le = {}, Re = null, ze = AC({}, /* @__PURE__ */ "annotation-xml.audio.colgroup.desc.foreignobject.head.iframe.math.mi.mn.mo.ms.mtext.noembed.noframes.noscript.plaintext.script.selectedcontent.style.svg.template.thead.title.video.xmp".split(".")), Be = null, Ve = AC({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), B = null, He = AC({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), Ue = "http://www.w3.org/1998/Math/MathML", We = "http://www.w3.org/2000/svg", V = "http://www.w3.org/1999/xhtml", Ge = V, Ke = !1, qe = null, Je = AC({}, [
		Ue,
		We,
		V
	], hC), Ye = nC([
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), Xe = AC({}, Ye), H = nC(["annotation-xml"]), Ze = AC({}, H), Qe = AC({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), $e = null, et = ["application/xhtml+xml", "text/html"], U = null, tt = null, nt = n.createElement("form"), rt = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, it = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (tt && tt === e) return;
		(!e || typeof e != "object") && (e = {}), e = MC(e), $e = et.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, U = $e === "application/xhtml+xml" ? hC : mC, ue = mw(e, "ALLOWED_TAGS", de, { transform: U }), fe = mw(e, "ALLOWED_ATTR", pe, { transform: U }), qe = mw(e, "ALLOWED_NAMESPACES", Je, { transform: hC }), B = mw(e, "ADD_URI_SAFE_ATTR", He, {
			transform: U,
			base: He
		}), Be = mw(e, "ADD_DATA_URI_TAGS", Ve, {
			transform: U,
			base: Ve
		}), Re = mw(e, "FORBID_CONTENTS", ze, { transform: U }), he = mw(e, "FORBID_TAGS", MC({}), { transform: U }), ge = mw(e, "FORBID_ATTR", MC({}), { transform: U }), Le = wC(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? MC(e.USE_PROFILES) : e.USE_PROFILES : !1, ve = e.ALLOW_ARIA_ATTR !== !1, ye = e.ALLOW_DATA_ATTR !== !1, be = e.ALLOW_UNKNOWN_PROTOCOLS || !1, xe = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Se = e.SAFE_FOR_TEMPLATES || !1, Ce = e.SAFE_FOR_XML !== !1, we = e.WHOLE_DOCUMENT || !1, ke = e.RETURN_DOM || !1, Ae = e.RETURN_DOM_FRAGMENT || !1, je = e.RETURN_TRUSTED_TYPE || !1, Oe = e.FORCE_BODY || !1, Me = e.SANITIZE_DOM !== !1, Ne = e.SANITIZE_NAMED_PROPS || !1, Fe = e.KEEP_CONTENT !== !1, Ie = e.IN_PLACE || !1, le = FC(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : QC, Ge = typeof e.NAMESPACE == "string" ? e.NAMESPACE : V, Xe = hw(e, "MATHML_TEXT_INTEGRATION_POINTS", () => AC({}, Ye)), Ze = hw(e, "HTML_INTEGRATION_POINTS", () => AC({}, H));
		let t = hw(e, "CUSTOM_ELEMENT_HANDLING", () => iC(null));
		if (me = iC(null), wC(t, "tagNameCheck") && rt(t.tagNameCheck) && (me.tagNameCheck = t.tagNameCheck), wC(t, "attributeNameCheck") && rt(t.attributeNameCheck) && (me.attributeNameCheck = t.attributeNameCheck), wC(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (me.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), rC(me), Se && (ye = !1), Ae && (ke = !0), Le && (ue = AC({}, HC), fe = iC(null), Le.html === !0 && (AC(ue, IC), AC(fe, UC)), Le.svg === !0 && (AC(ue, LC), AC(fe, WC), AC(fe, KC)), Le.svgFilters === !0 && (AC(ue, RC), AC(fe, WC), AC(fe, KC)), Le.mathMl === !0 && (AC(ue, BC), AC(fe, GC), AC(fe, KC))), _e.tagCheck = null, _e.attributeCheck = null, wC(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? _e.tagCheck = e.ADD_TAGS : pC(e.ADD_TAGS) && (ue === de && (ue = MC(ue)), AC(ue, e.ADD_TAGS, U))), wC(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? _e.attributeCheck = e.ADD_ATTR : pC(e.ADD_ATTR) && (fe === pe && (fe = MC(fe)), AC(fe, e.ADD_ATTR, U))), wC(e, "ADD_FORBID_CONTENTS") && pC(e.ADD_FORBID_CONTENTS) && (Re === ze && (Re = MC(Re)), AC(Re, e.ADD_FORBID_CONTENTS, U)), Fe && (ue["#text"] = !0), we && AC(ue, [
			"html",
			"head",
			"body"
		]), ue.table && (AC(ue, ["tbody"]), delete he.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw DC("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw DC("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			let t = T;
			T = e.TRUSTED_TYPES_POLICY;
			try {
				E = j("");
			} catch (e) {
				throw T = t, e;
			}
		} else e.TRUSTED_TYPES_POLICY === null ? (T = void 0, E = "") : (T === void 0 && (T = N()), T && typeof E == "string" && (E = j("")));
		nC && nC(e), tt = e;
	}, at = AC({}, [
		...LC,
		...RC,
		...zC
	]), ot = AC({}, [...BC, ...VC]), st = function(e, t, n) {
		return t.namespaceURI === V ? e === "svg" : t.namespaceURI === Ue ? e === "svg" && (n === "annotation-xml" || Xe[n]) : !!at[e];
	}, ct = function(e, t, n) {
		return t.namespaceURI === V ? e === "math" : t.namespaceURI === We ? e === "math" && Ze[n] : !!ot[e];
	}, lt = function(e, t, n) {
		return t.namespaceURI === We && !Ze[n] || t.namespaceURI === Ue && !Xe[n] ? !1 : !ot[e] && (Qe[e] || !at[e]);
	}, ut = function(e) {
		let t = _(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Ge,
			tagName: "template"
		});
		let n = mC(e.tagName), r = mC(t.tagName);
		return qe[e.namespaceURI] ? e.namespaceURI === We ? st(n, t, r) : e.namespaceURI === Ue ? ct(n, t, r) : e.namespaceURI === V ? lt(n, t, r) : !!($e === "application/xhtml+xml" && qe[e.namespaceURI]) : !1;
	}, dt = function(e) {
		dC(t.removed, { element: e });
		try {
			_(e).removeChild(e);
		} catch {
			if (p(e), !_(e)) throw DC("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
		}
	}, ft = function(e, t, n) {
		try {
			m(e, t);
		} catch {
			try {
				e.removeAttribute(n);
			} catch {}
		}
	}, pt = function(e) {
		G(e);
		let t = g(e);
		if (t) {
			let e = [];
			cC(t, (t) => {
				dC(e, t);
			}), cC(e, (e) => {
				try {
					p(e);
				} catch {}
			});
		}
		let n = y(e);
		if (n) for (let t = n.length - 1; t >= 0; --t) {
			let r = n[t], i = r && r.name;
			typeof i == "string" && ft(e, r, i);
		}
	}, mt = function(e, n, r) {
		if (!r) try {
			r = n.getAttributeNode(e);
		} catch {
			r = null;
		}
		dC(t.removed, {
			attribute: r || null,
			from: n
		});
		try {
			r ? m(n, r) : n.removeAttribute(e);
		} catch {
			try {
				n.removeAttribute(e);
			} catch {}
		}
		if (e === "is") if (ke || Ae) try {
			dt(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, W = function(e) {
		let t = y(e);
		if (t) for (let n = t.length - 1; n >= 0; --n) {
			let r = t[n], i = r && r.name;
			typeof i != "string" || fe[U(i)] || ft(e, r, i);
		}
	}, G = function(e) {
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop();
			C(e) === sw.element && W(e);
			let n = g(e);
			if (n) for (let e = n.length - 1; e >= 0; --e) t.push(n[e]);
		}
	}, K = function(e, t) {
		return Ce ? e === "patchsrc" || e === "for" && t !== "label" && t !== "output" : !1;
	}, ht = function(e) {
		if (!Ce) return;
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop(), n = C(e);
			if (n === sw.processingInstruction || n === sw.comment && EC(iw, e.data)) {
				try {
					p(e);
				} catch {}
				continue;
			}
			if (n === sw.element) {
				let t = e, n = U(w(e));
				try {
					t.hasAttribute && t.hasAttribute("patchsrc") && t.removeAttribute("patchsrc"), t.hasAttribute && t.hasAttribute("for") && K("for", n) && t.removeAttribute("for");
				} catch {}
			}
			let r = g(e);
			if (r) for (let e = r.length - 1; e >= 0; --e) t.push(r[e]);
		}
	}, gt = function(e) {
		let t = null, r = null;
		if (Oe) e = "<remove></remove>" + e;
		else {
			let t = gC(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		$e === "application/xhtml+xml" && Ge === V && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = T ? j(e) : e;
		if (Ge === V) try {
			t = new l().parseFromString(i, $e);
		} catch {}
		if (!t || !t.documentElement) {
			t = ee.createDocument(Ge, "template", null);
			try {
				t.documentElement.innerHTML = Ke ? E : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Ge === V ? te.call(t, we ? "html" : "body")[0] : we ? t.documentElement : a;
	}, _t = function(e) {
		let t = S ? S(e) : e.ownerDocument;
		return F.call(t || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, vt = function(e) {
		return e = _C(e, re, " "), e = _C(e, ie, " "), e = _C(e, R, " "), e;
	}, yt = function(e) {
		e.normalize();
		let t = S ? S(e) : e.ownerDocument, n = F.call(t || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), r = n.nextNode();
		for (; r;) r.data = vt(r.data), r = n.nextNode();
		let i = e.querySelectorAll?.call(e, "template");
		i && cC(i, (e) => {
			xt(e.content) && yt(e.content);
		});
	}, bt = function(e) {
		let t = x ? x(e) : null;
		return typeof t != "string" || U(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== y(e) || typeof e.removeAttribute != "function" || typeof e.removeAttributeNode != "function" || typeof e.getAttributeNode != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== b(e) || e.childNodes !== g(e);
	}, xt = function(e) {
		if (!b || typeof e != "object" || !e) return !1;
		try {
			return b(e) === sw.documentFragment;
		} catch {
			return !1;
		}
	}, St = function(e) {
		if (!b || typeof e != "object" || !e) return !1;
		try {
			return typeof b(e) == "number";
		} catch {
			return !1;
		}
	};
	function Ct(e, n, r) {
		e.length !== 0 && cC(e, (e) => {
			e.call(t, n, r, tt);
		});
	}
	let wt = function(e, t) {
		return !!(Ce && e.hasChildNodes() && !St(e.firstElementChild) && EC(rw, e.textContent) && EC(rw, e.innerHTML) || Ce && e.namespaceURI === V && lw[t] && (St(e.firstElementChild) || typeof e.textContent == "string" && EC(uw[t], e.textContent)) || e.nodeType === sw.processingInstruction || Ce && e.nodeType === sw.comment && EC(iw, e.data));
	}, Tt = function(e, t) {
		return e instanceof RegExp ? EC(e, t) : e instanceof Function && !!e(t, ...[...arguments].slice(2));
	}, Et = function(e, t, n) {
		if (!he[t] && Mt(t) && Tt(me.tagNameCheck, t)) return !1;
		if (Fe && !Re[t]) {
			let t = _(e), r = g(e);
			if (r && t) {
				let i = r.length;
				for (let a = i - 1; a >= 0; --a) {
					let i = e === n ? f(r[a], !0) : r[a];
					t.insertBefore(i, h(e));
				}
			}
		}
		return dt(e), !0;
	}, Dt = function(e, t, n, r) {
		return e.length === 0 ? t : t === n || t === r ? MC(t) : t;
	}, Ot = function(e, t) {
		return e === t || _(e) !== null ? !1 : (Ie && G(e), !0);
	}, kt = function(e, n) {
		if (Ct(ne.beforeSanitizeElements, e, null), Ot(e, n)) return !0;
		if (bt(e)) return dt(e), !0;
		let r = U(w(e));
		if (ue = Dt(ne.uponSanitizeElement, ue, de, Ee), Ct(ne.uponSanitizeElement, e, {
			tagName: r,
			allowedTags: ue
		}), Ot(e, n)) return !0;
		if (wt(e, r)) return dt(e), !0;
		if (he[r] || !(_e.tagCheck instanceof Function && _e.tagCheck(r)) && !ue[r]) {
			let t = Et(e, r, n);
			return t === !1 && Ct(ne.afterSanitizeElements, e, null), t;
		}
		if (C(e) === sw.element && !ut(e) || (r === "noscript" || r === "noembed" || r === "noframes") && EC(aw, e.innerHTML)) return dt(e), !0;
		if (Se && e.nodeType === sw.text) {
			let n = vt(e.textContent);
			e.textContent !== n && (dC(t.removed, { element: e.cloneNode() }), e.textContent = n);
		}
		return Ct(ne.afterSanitizeElements, e, null), !1;
	}, At = function(e, t, r) {
		if (ge[t] || K(t, e) || Me && (t === "id" || t === "name") && (r in n || r in nt)) return !1;
		let i = fe[t] || _e.attributeCheck instanceof Function && _e.attributeCheck(t, e);
		return ye && EC(ae, t) || ve && EC(z, t) ? !0 : i ? B[t] || EC(le, _C(r, se, "")) || (t === "src" || t === "xlink:href" || t === "href") && e !== "script" && vC(r, "data:") === 0 && Be[e] || be && !EC(oe, _C(r, se, "")) ? !0 : !r : Mt(e) && Tt(me.tagNameCheck, e) && Tt(me.attributeNameCheck, t, e) || t === "is" && me.allowCustomizedBuiltInElements && Tt(me.tagNameCheck, r);
	}, jt = AC({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), Mt = function(e) {
		return !jt[mC(e)] && EC(ce, e);
	}, Nt = function(e, t, n, r) {
		if (T && typeof u == "object" && typeof u.getAttributeType == "function" && !n) switch (u.getAttributeType(e, t)) {
			case "TrustedHTML": return j(r);
			case "TrustedScriptURL": return M(r);
		}
		return r;
	}, Pt = function(e, t, n, r) {
		try {
			return n ? e.setAttributeNS(n, t, r) : e.setAttribute(t, r), bt(e) ? (dt(e), !1) : !0;
		} catch {
			return mt(t, e), !1;
		}
	}, Ft = function(e) {
		Ct(ne.beforeSanitizeAttributes, e, null);
		let n = e.attributes;
		if (!n || bt(e)) return;
		fe = Dt(ne.uponSanitizeAttribute, fe, pe, De);
		let r = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: fe,
			forceKeepAttr: void 0
		}, i = n.length, a = U(e.nodeName);
		for (; i--;) {
			let o = n[i], s = o.name, c = o.namespaceURI, l = o.value, u = U(s), d = l, f = s === "value" ? d : yC(d), p = !1;
			if (r.attrName = u, r.attrValue = f, r.keepAttr = !0, r.forceKeepAttr = void 0, Ct(ne.uponSanitizeAttribute, e, r), f = r.attrValue, Ne && (u === "id" || u === "name") && vC(f, Pe) !== 0 && (mt(s, e, o), f = Pe + f, p = !0), Ce && EC(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, f)) {
				mt(s, e, o);
				continue;
			}
			if (u === "attributename" && gC(f, "href")) {
				mt(s, e, o);
				continue;
			}
			if (!r.forceKeepAttr) {
				if (!r.keepAttr) {
					mt(s, e, o);
					continue;
				}
				if (!xe && EC(ow, f)) {
					mt(s, e, o);
					continue;
				}
				if (Se && (f = vt(f)), !At(a, u, f)) {
					mt(s, e, o);
					continue;
				}
				f = Nt(a, u, c, f), f !== d && Pt(e, s, c, f) && p && uC(t.removed);
			}
		}
		Ct(ne.afterSanitizeAttributes, e, null);
	}, It = function(e) {
		let t = null, n = _t(e);
		for (Ct(ne.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (Ct(ne.uponSanitizeShadowNode, t, null), kt(t, e), Ft(t), xt(t.content) && It(t.content), C(t) === sw.element) {
			let e = v(t);
			xt(e) && (Lt(e), It(e));
		}
		Ct(ne.afterSanitizeShadowDOM, e, null);
	}, Lt = function(e) {
		let t = [{
			node: e,
			shadow: null
		}];
		for (; t.length > 0;) {
			let e = t.pop();
			if (e.shadow) {
				It(e.shadow);
				continue;
			}
			let n = e.node, r = C(n) === sw.element, i = g(n);
			if (i) for (let e = i.length - 1; e >= 0; --e) t.push({
				node: i[e],
				shadow: null
			});
			if (r) {
				let e = x ? x(n) : null;
				if (typeof e == "string" && U(e) === "template") {
					let e = n.content;
					xt(e) && t.push({
						node: e,
						shadow: null
					});
				}
			}
			if (r) {
				let e = v(n);
				xt(e) && t.push({
					node: null,
					shadow: e
				}, {
					node: e,
					shadow: null
				});
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (Ke = !e, Ke && (e = "<!-->"), typeof e != "string" && !St(e) && (e = NC(e), typeof e != "string")) throw DC("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		Te ? (ue = Ee, fe = De) : it(n), (ne.uponSanitizeElement.length > 0 || ne.uponSanitizeAttribute.length > 0) && (ue = MC(ue)), ne.uponSanitizeAttribute.length > 0 && (fe = MC(fe)), t.removed = [];
		let c = Ie && typeof e != "string" && St(e);
		if (c) {
			ht(e);
			let t = w(e);
			if (typeof t == "string") {
				let n = U(t);
				if (!ue[n] || he[n]) throw pt(e), DC("root node is forbidden and cannot be sanitized in-place");
			}
			if (bt(e)) throw pt(e), DC("root node is clobbered and cannot be sanitized in-place");
			try {
				Lt(e);
			} catch (t) {
				throw pt(e), t;
			}
		} else if (St(e)) i = gt("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === sw.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), Lt(i);
		else {
			if (!ke && !Se && !we && e.indexOf("<") === -1) return T && je ? j(e) : e;
			if (i = gt(e), !i) return ke ? null : je ? E : "";
		}
		i && Oe && dt(i.firstChild);
		let l = c ? e : i;
		try {
			let e = _t(l);
			for (; o = e.nextNode();) kt(o, l), Ft(o), xt(o.content) && It(o.content);
		} catch (n) {
			throw c && (pt(e), cC(t.removed, (e) => {
				e.element && G(e.element);
			})), n;
		}
		if (c) return cC(t.removed, (e) => {
			e.element && G(e.element);
		}), Se && yt(e), e;
		if (ke) {
			if (Se && yt(i), Ae) for (s = I.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (fe.shadowroot || fe.shadowrootmode) && (s = L.call(r, s, !0)), s;
		}
		let u = we ? i.outerHTML : i.innerHTML;
		return we && ue["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && EC(tw, i.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + u), Se && (u = vt(u)), T && je ? j(u) : u;
	}, t.setConfig = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		it(e), Te = !0, Ee = ue, De = fe;
	}, t.clearConfig = function() {
		tt = null, Te = !1, Ee = null, De = null, T = D, E = "";
	}, t.isValidAttribute = function(e, t, n) {
		tt || it({});
		let r = U(e), i = U(t);
		return At(r, i, n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && wC(ne, e) && dC(ne[e], t);
	}, t.removeHook = function(e, t) {
		if (wC(ne, e)) {
			if (t !== void 0) {
				let n = lC(ne[e], t);
				return n === -1 ? void 0 : fC(ne[e], n, 1)[0];
			}
			return uC(ne[e]);
		}
	}, t.removeHooks = function(e) {
		wC(ne, e) && (ne[e] = []);
	}, t.removeAllHooks = function() {
		ne = pw();
	}, t;
}
var _w = gw(), vw = {
	messageContainer: "_messageContainer_1rxr4_1",
	chip: "_chip_1rxr4_7",
	chipLabel: "_chipLabel_1rxr4_10",
	chipValue: "_chipValue_1rxr4_13"
}, yw = {
	INBOUND: {
		background: "var(--dixa-color-neutral-000)",
		borderColor: "var(--dixa-color-neutral-100)"
	},
	OUTBOUND: {
		background: "var(--dixa-color-neutral-100)",
		borderColor: "var(--dixa-color-neutral-200)"
	},
	INTERNAL: {
		background: "var(--dixa-color-orange-100)",
		borderColor: "var(--dixa-color-orange-200)"
	}
}, bw = ({ messages: n, customFields: r, attachments: a, conversationContext: o }) => {
	H(() => {
		document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
	}, [n]);
	let s = () => {
		let e = "Contact";
		if (!o?.customer) return e;
		let { name: t, given_name: n, family_name: r, email: i, phone_number: a } = o.customer;
		return t ?? n ?? r ?? i ?? a ?? e;
	};
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "200",
		children: [
			/* @__PURE__ */ G(v, {
				flexDirection: "row",
				flexWrap: "wrap",
				margin: "0 0 300",
				children: !!r?.length && /* @__PURE__ */ K(v, {
					gap: "100",
					children: [/* @__PURE__ */ G(R, {
						content: "Conversation Attributes",
						children: /* @__PURE__ */ G(t, {
							icon: "input",
							color: {
								contentColor: "var(--dixa-color-neutral-700)",
								backgroundColor: "var(--dixa-color-neutral-200)"
							}
						})
					}), r.map((e, t) => /* @__PURE__ */ G(v, {
						alignItems: "center",
						children: /* @__PURE__ */ G(I, {
							className: vw.chip,
							children: /* @__PURE__ */ K(v, {
								gap: "100",
								children: [/* @__PURE__ */ K(i, {
									className: vw.chipLabel,
									children: [e.name, ":"]
								}), /* @__PURE__ */ G(i, {
									className: vw.chipValue,
									children: e.value
								})]
							})
						})
					}, `${t}-${e.name}`))]
				})
			}),
			n?.map((e) => /* @__PURE__ */ G(v, {
				className: vw.messageContainer,
				gap: "200",
				style: {
					backgroundColor: e?.direction ? yw[e.direction].background : "var(--dixa-color-neutral-000)",
					borderColor: e?.direction ? yw[e.direction].borderColor : "var(--dixa-color-neutral-100)"
				},
				children: /* @__PURE__ */ K(v, {
					flexDirection: "column",
					gap: "200",
					width: "100%",
					children: [/* @__PURE__ */ K(v, {
						flexDirection: "row",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ G(L.Heading, {
							variant: "heading-3",
							children: e?.direction == "INBOUND" ? s() : e?.agent?.name
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: /* @__PURE__ */ G(ie, {
								relative: !0,
								time: e?.created_at
							})
						})]
					}), /* @__PURE__ */ G("div", { dangerouslySetInnerHTML: { __html: _w.sanitize(e?.body?.replaceAll(/\r\n?|\n/g, "<br />") || "") } })]
				})
			}, e?.created_at)),
			a && /* @__PURE__ */ G(v, {
				gap: "200",
				flexDirection: "row",
				flexWrap: "wrap",
				margin: "300 0 0",
				children: a.map((t, n) => /* @__PURE__ */ G(e, {
					fileName: t.url,
					label: t.label,
					onDownload: () => {
						window.open(t.url, "_blank")?.focus();
					}
				}, `${n}-${t.url}`))
			}),
			/* @__PURE__ */ G("div", {
				id: "endOfConversationAnchor",
				children: "\xA0"
			})
		]
	});
}, xw = {
	conversation: "_conversation_1draa_1",
	conversationSubLine: "_conversationSubLine_1draa_9",
	modal: "_modal_1draa_14"
}, Sw = (e) => (e && JSON.parse(e) || []).map((e) => ({
	url: e.URL__c,
	label: e.Name,
	type: e.File_Type__c
})), Cw = (e) => Object.entries(e || {}).filter(([e]) => e.endsWith("__c")).map(([e, t]) => ({
	name: e.replace("__c", "").replaceAll("_", " "),
	value: t?.value ? t.value.toString() : ""
})), ww = ({ conversation: e, conversationContext: t }) => {
	let [r, i] = U(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
	return /* @__PURE__ */ K(v, {
		className: xw.conversation,
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ K(v, {
				flexDirection: "column",
				gap: "100",
				children: [
					/* @__PURE__ */ K(v, {
						flexDirection: "row",
						gap: "100",
						children: [/* @__PURE__ */ G(L.Heading, {
							variant: "heading-4",
							children: e?.id
						}), a && /* @__PURE__ */ G(n, {
							size: "small",
							variant: "info",
							children: WS(e?.created_at).format("DD MMM YYYY @ HH:mm")
						})]
					}),
					/* @__PURE__ */ G(L.Heading, {
						variant: "heading-4",
						className: xw.conversationSubLine,
						children: e?.subject
					}),
					!!e?.labels?.length && /* @__PURE__ */ G(v, {
						gap: "200",
						flexDirection: "row",
						flexWrap: "wrap",
						children: [...new Set(e.labels)].map((t) => /* @__PURE__ */ G(I, { children: t }, `${e.id}-${t}`))
					})
				]
			}), /* @__PURE__ */ G(R, {
				content: "Show conversation preview",
				children: /* @__PURE__ */ G(S, {
					variant: "secondary",
					icon: "eye",
					onClick: () => i(!0),
					"data-testid": "open-messages-preview"
				})
			})]
		}), /* @__PURE__ */ K(D, {
			isOpen: r,
			allowEscClose: !0,
			onClose: () => i(!1),
			className: xw.modal,
			children: [/* @__PURE__ */ G(A, {
				title: "Conversation preview",
				onClose: () => i(!1)
			}), /* @__PURE__ */ G(O, { children: /* @__PURE__ */ G(bw, {
				messages: e?.messages || [],
				...s && { attachments: Sw(o?.attachments?.value) },
				conversationContext: t,
				customFields: Cw(e?.custom_fields)
			}) })]
		})]
	});
}, Tw = ({ conversations: e, conversationContext: t, conversationsToShow: n }) => {
	let [r, i] = U(!1), o = n > 0 ? n : 1, s = e?.length > o;
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "200",
		margin: "200 0 300 0",
		children: [Qe(() => e?.sort((e, t) => t?.created_at.localeCompare(e?.created_at)).slice(0, r ? e.length : o), [
			e,
			r,
			o
		]).map((e, n) => /* @__PURE__ */ G(ww, {
			conversation: e,
			conversationContext: t
		}, `${n}-${e?.id}`)), s && /* @__PURE__ */ K(a, {
			variant: "secondary",
			onClick: () => i(!r),
			children: ["Show ", r ? "less" : "all"]
		})]
	});
}, Ew = US("\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n"), Dw = ({ conversationContext: e, settings: t }) => {
	let [n, r] = U([]), i = Number.parseInt(t?.amountOfConversationsToShow) || 1, a = [e.customer?.email, e.customer?.phone_number].filter((e) => !!e).map((e) => `'${e}'`).join(","), { useQuery: o } = B(), { data: s, loading: c, error: l } = o(Ew, {
		skip: a.length === 0,
		variables: { query: `requester_id=in=(${a})` }
	});
	return H(() => {
		if (s?.Miuros) {
			let e = s?.Miuros?.findTickets?.data;
			e && r(e);
		}
	}, [s]), l ? /* @__PURE__ */ G(z, { error: l }) : c ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(P, {})
	}) : n?.length === 0 ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: "No conversations found for this customer"
	}) : /* @__PURE__ */ G(Tw, {
		"data-testid": "conversation-list",
		conversationsToShow: i,
		conversations: n,
		conversationContext: e
	});
}, Ow = [
	{
		key: "miurosClientId",
		label: "Authorization: Client ID",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "miurosClientSecret",
		label: "Authorization: Client secret",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "amountOfConversationsToShow",
		label: "Number of conversation to show before the fold",
		type: "string",
		secret: !1,
		defaultValue: "1"
	}
], kw = Pe(Ow), Aw = "MIUROS", jw = {
	enabled: !1,
	name: "",
	miurosClientId: "",
	miurosClientSecret: "",
	amountOfConversationsToShow: "1"
}, Mw = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i }) => {
	let a = !e, o = gl({
		mode: "onChange",
		defaultValues: jw
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = He({
		integrationId: e,
		integrationType: Aw,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: m, error: h, isWidgetUnknown: g, refetch: v } = Ue({
		integrationId: e,
		fieldDefinitions: Ow,
		form: o,
		onMisconfigured: p
	}), x = (e) => ye(e, {
		fieldDefinitions: Ow,
		isCreationMode: a,
		create: s,
		update: c
	}), S = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: x,
		error: h ?? d,
		onRetry: h ? v : void 0,
		isLoading: u || m,
		isWidgetUnknown: g,
		children: [
			f && /* @__PURE__ */ G(se, { cause: f }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "miurosClientId",
						label: kw.miurosClientId,
						control: o.control,
						rules: { required: "Client ID is required" },
						componentProps: {
							placeholder: "Insert client ID",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "miurosClientSecret",
						label: kw.miurosClientSecret,
						control: o.control,
						isCreationMode: a,
						rules: { required: "Client secret is required" },
						componentProps: {
							placeholder: "Insert client secret",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "amountOfConversationsToShow",
						label: kw.amountOfConversationsToShow,
						control: o.control,
						rules: {
							required: "Please enter a number",
							validate: (e) => !Number.isNaN(Number.parseInt(e, 10)) || "Please enter a number"
						},
						componentProps: {
							placeholder: "Enter number",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!a && e && /* @__PURE__ */ G(ce, {
					configuration: t,
					integrationId: e,
					integrationType: Aw,
					label: "Authorize"
				})
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: Aw,
				integrationId: e,
				widgetName: S,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => l()
			})
		]
	});
};
//#endregion
//#region ../widget-recharge/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._list_18ybb_1{padding:0}._listItem_18ybb_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_18ybb_4:last-child{border-bottom:none}._copyIcon_18ybb_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._fullWidth_18ybb_17{width:100%}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}._modal_1op1u_1{min-width:600px}._subscription_1xxl7_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._subscription_1xxl7_1:hover,._subscriptionIsOpen_1xxl7_9{border-color:var(--dixa-color-neutral-400)}._subscriptionHeader_1xxl7_12{cursor:pointer}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var Nw = {
	"\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getAddresses"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getAddresses"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customer_id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Addresses"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "addresses"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "payment_method_id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address1"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address2"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "city"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "company"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "country_code"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "customer_id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "discounts"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "value"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "value_type"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "first_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "last_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_attributes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "value"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_note"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "phone"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentment_currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shipping_lines_conserved"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "price"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shipping_lines_override"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "price"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "updated_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "zip"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getChargeById($id: Int!) {\n    Recharge {\n      getChargeById(id: $id) {\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getChargeById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getChargeById"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Charge"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "charge"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "processed_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "line_items"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "variant_title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "unit_price"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "total_price"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCharges(\n    $customerId: String\n    $purchaseItemId: String\n    $status: String\n    $scheduledAtMin: String\n    $sortBy: String\n    $limit: String\n  ) {\n    Recharge {\n      getCharges(\n        customer_id: $customerId\n        purchase_item_id: $purchaseItemId\n        status: $status\n        scheduled_at_min: $scheduledAtMin\n        sort_by: $sortBy\n        limit: $limit\n      ) {\n        ... on Recharge_Charges {\n          charges {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCharges"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "customerId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "purchaseItemId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "status"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "scheduledAtMin"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "sortBy"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "limit"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCharges"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "customer_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "customerId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "purchase_item_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "purchaseItemId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "status"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "status"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "scheduled_at_min"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "scheduledAtMin"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "sort_by"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "sortBy"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "limit"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "limit"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Charges"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "charges"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "processed_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "line_items"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "variant_title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "unit_price"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "total_price"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomerDetails"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getStore"
							},
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Store"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "store"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "external_platform"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "customer_portal_base_url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "merchant_portal_base_url"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "identifier"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "checkout_platform"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "external_platform"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}, {
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCustomers"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Customers"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "customers"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "email"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "phone"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "first_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "last_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "updated_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "external_customer_id"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "ecommerce"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "subscriptions_active_count"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "subscriptions_total_count"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "has_valid_payment_method"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "hash"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getOrders"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "customerId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "limit"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "addressId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getOrders"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "customer_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "customerId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "limit"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "limit"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "address_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "addressId"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Orders"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "orders"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_prepaid"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "note"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "subtotal_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_discounts"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_duties"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_line_items_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_refunds"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_tax"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_weight_grams"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "type"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "charge"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "external_transaction_id"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "payment_processor"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "billing_address"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country_code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "first_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "last_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shipping_address"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country_code"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "first_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "last_name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getSubscriptionById($id: Int!) {\n    Recharge {\n      getSubscriptionById(id: $id) {\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getSubscriptionById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getSubscriptionById"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Subscription_"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "subscription"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "product_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "variant_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "quantity"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentment_currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_prepaid"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "next_charge_scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_unit"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "charge_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancellation_reason"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancelled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getSubscriptions($customerId: String, $status: String, $limit: String) {\n    Recharge {\n      getSubscriptions(\n        customer_id: $customerId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Subscriptions {\n          subscriptions {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            is_skippable\n            is_swappable\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancellation_reason_comments\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getSubscriptions"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "customerId"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "status"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "limit"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getSubscriptions"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "customer_id"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "customerId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "status"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "status"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "limit"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "limit"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Recharge_Subscriptions"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "subscriptions"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "product_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "variant_title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "quantity"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentment_currency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_prepaid"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_skippable"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "is_swappable"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "next_charge_scheduled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "order_interval_unit"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "charge_interval_frequency"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancellation_reason"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancellation_reason_comments"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancelled_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "created_at"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation activateSubscription($id: Int!) {\n    Recharge {\n      activateSubscription(id: $id) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "activateSubscription"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "activateSubscription"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancelled_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancellation_reason"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation cancelSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionCancelInput_Input\n  ) {\n    Recharge {\n      cancelSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "cancelSubscription"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_SubscriptionCancelInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "cancelSubscription"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancelled_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "cancellation_reason"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation changeSubscriptionNextChargeDate(\n    $id: Int!\n    $input: Recharge_SubscriptionChangeNextChargeDateInput_Input\n  ) {\n    Recharge {\n      changeSubscriptionNextChargeDate(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "changeSubscriptionNextChargeDate"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_SubscriptionChangeNextChargeDateInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "changeSubscriptionNextChargeDate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "next_charge_scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation skipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      skipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "skipCharge"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_ChargeSkipInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "skipCharge"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Charge"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "charge"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation unskipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      unskipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "unskipCharge"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_ChargeSkipInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "unskipCharge"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Charge"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "charge"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionUpdateInput_Input\n  ) {\n    Recharge {\n      updateSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            price\n            quantity\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateSubscription"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "id"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Recharge_SubscriptionUpdateInput_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Recharge"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "updateSubscription"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "id"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "__typename"
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_Subscription_"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subscription"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "product_title"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "variant_title"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "price"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "quantity"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "next_charge_scheduled_at"
															}
														}
													]
												}
											}]
										}
									},
									{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Recharge_BasicResponse"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	}
};
function Pw(e) {
	return Nw[e] ?? {};
}
var Fw = Pw("\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n"), Iw = Pw("\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n"), Lw = Pw("\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n"), Rw = Pw("\n  query getSubscriptions($customerId: String, $status: String, $limit: String) {\n    Recharge {\n      getSubscriptions(\n        customer_id: $customerId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Subscriptions {\n          subscriptions {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            is_skippable\n            is_swappable\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancellation_reason_comments\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n"), zw = Pw("\n  query getCharges(\n    $customerId: String\n    $purchaseItemId: String\n    $status: String\n    $scheduledAtMin: String\n    $sortBy: String\n    $limit: String\n  ) {\n    Recharge {\n      getCharges(\n        customer_id: $customerId\n        purchase_item_id: $purchaseItemId\n        status: $status\n        scheduled_at_min: $scheduledAtMin\n        sort_by: $sortBy\n        limit: $limit\n      ) {\n        ... on Recharge_Charges {\n          charges {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n"), Bw = Pw("\n  mutation cancelSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionCancelInput_Input\n  ) {\n    Recharge {\n      cancelSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), Vw = Pw("\n  mutation activateSubscription($id: Int!) {\n    Recharge {\n      activateSubscription(id: $id) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), Hw = Pw("\n  mutation updateSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionUpdateInput_Input\n  ) {\n    Recharge {\n      updateSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            price\n            quantity\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), Uw = Pw("\n  mutation skipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      skipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), Ww = Pw("\n  mutation unskipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      unskipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n"), Gw = Ws;
function Kw(e = !1, t) {
	let [n, r] = U(e);
	return H(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var qw = ({ mutation: e, isSuccessful: t, successText: n, failureText: r, trackingAction: i, setIsMutationLoading: a, setIsOpen: o, refetchSubscriptions: s }) => {
	let { track: c } = Ve(), { useMutation: l, showNotification: u } = B(), d = () => {
		a(!1), u({
			title: "Something went wrong",
			text: r,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), o(!1);
	}, [f, p] = l(e, {
		onError: d,
		onCompleted: async (e) => {
			if (!t(e)) {
				d();
				return;
			}
			await s().catch(() => void 0), a(!1), u({
				title: "Success",
				text: n,
				icon: "check-circle-filled",
				severity: "success"
			}), c(i), o(!1);
		}
	});
	return [(e) => f(e).catch(() => void 0), p];
}, Jw = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Yw = "DD MMM YYYY @ HH:mm", Xw = {
	list: "_list_18ybb_1",
	listItem: "_listItem_18ybb_4",
	copyIcon: "_copyIcon_18ybb_12",
	fullWidth: "_fullWidth_18ybb_17"
}, Zw = ({ address: e, icon: t, title: n, isLoading: r = !1, hasMultipleAddresses: a = !1 }) => {
	let { isCopied: o, copy: s } = Kw(), { first_name: c, last_name: l, address1: u, address2: d, city: f, zip: p, country_code: m } = e ?? {}, h = [
		`${c} ${l}`.trim() || void 0,
		u,
		d,
		`${f} ${p}`.trim() || void 0,
		m
	].filter(Boolean);
	return /* @__PURE__ */ K(v, {
		gap: "200",
		justifyContent: "space-between",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: t
			}), r ? /* @__PURE__ */ G(P, { size: 14 }) : /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [n && /* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: n
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: h.map((e, t) => /* @__PURE__ */ G(i, { children: e }, t))
				})]
			})]
		}), !r && /* @__PURE__ */ K(v, {
			gap: "100",
			children: [a && /* @__PURE__ */ G(R, {
				content: "The customer has multiple addresses, showing only the first here.",
				children: /* @__PURE__ */ G(x, {
					size: 14,
					name: "exclamation",
					className: Xw.copyIcon
				})
			}), /* @__PURE__ */ G(R, {
				content: `Copy ${n ? n.toLowerCase() : "address"}`,
				children: /* @__PURE__ */ G(x, {
					size: 14,
					name: o ? "done" : "copy",
					onClick: () => s(h.join(", ")),
					className: Xw.copyIcon
				})
			})]
		})]
	});
}, Qw = { wrapper: "_wrapper_1nher_1" }, $w = ({ customer: e, store: t }) => {
	let { track: n } = Ve(), { isCopied: r, copy: i } = Kw(), { isCopied: a, copy: o } = Kw(), { useQuery: s } = B(), c = e?.id, { loading: l, error: u, data: d } = s(Iw, {
		skip: !c,
		variables: { customerId: c?.toString() }
	}), f = d?.Recharge?.getAddresses, p = !l && f?.addresses?.[0] ? f.addresses[0] : void 0, m = (f?.addresses?.length ?? 0) > 1;
	if (H(() => {
		p && n("recharge:profile:received");
	}, [p, n]), u) return /* @__PURE__ */ G(z, { error: u });
	if (!e) return null;
	let { id: h, phone: g, email: _, first_name: y, last_name: b, created_at: S, has_valid_payment_method: C } = e, w = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/customers/${h}` : null, T = `${y || ""} ${b || ""}`.trim() || "A customer has no name";
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			className: Qw.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ G(L.Heading, {
					variant: "heading-2",
					children: T
				}),
				S && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					margin: "0 0 200",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Member since"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: Gw(S).format("DD MMM YYYY @ HH:mm")
					})]
				}),
				_ && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ G(L.ExternalLink, {
							href: `mailto:${_}`,
							children: _
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy email",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: r ? "done" : "copy",
							onClick: () => i(_),
							className: Xw.copyIcon
						})
					})]
				}),
				g && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: g
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(g),
							className: Xw.copyIcon
						})
					})]
				}),
				/* @__PURE__ */ G(Zw, {
					address: p,
					icon: "home",
					isLoading: l,
					hasMultipleAddresses: m
				}),
				/* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "credit-card"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: "Has valid payment method"
						})]
					}), /* @__PURE__ */ G(x, {
						size: 14,
						name: C ? "check-circle" : "close-circle-filled",
						color: C ? "green.500" : "red.500"
					})]
				}),
				w && /* @__PURE__ */ K(v, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ G(L.ExternalLink, {
						href: w,
						target: "_blank",
						rel: "noreferrer",
						onClick: () => n("recharge:external:customer:overview:opened"),
						children: "View customer in Recharge"
					})]
				})
			]
		})
	});
}, eT = {
	order: "_order_1dlaa_1",
	orderIsOpen: "_orderIsOpen_1dlaa_9",
	orderHeader: "_orderHeader_1dlaa_12",
	note: "_note_1dlaa_16"
}, tT = ({ order: e, isOpenByDefault: t, store: n }) => {
	let { track: r } = Ve(), [i, a] = U(t), { id: o, status: s, charge: c, currency: l, note: u, created_at: d, billing_address: f, shipping_address: p, total_price: m, is_prepaid: h } = e, g = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/${o}` : null, _ = c?.external_transaction_id?.payment_processor || void 0;
	return /* @__PURE__ */ K(v, {
		className: ht(eT.order, { [eT.orderIsOpen]: i }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: eT.orderHeader,
			onClick: () => a(!i),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [d && /* @__PURE__ */ G(v, {
					alignItems: "center",
					children: /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: Gw(d).format("DD MMM YYYY @ HH:mm")
					})
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "1",
					children: ["Order #", o]
				})]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: i ? "angle-down" : "angle-right"
			})]
		}), i && /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				u && /* @__PURE__ */ G(R, {
					content: "Note",
					children: /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						className: eT.note,
						children: u
					})
				}),
				s && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "activity"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Status"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: Jw(s)
						})]
					})]
				}),
				/* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "credit-card"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Prepaid"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: h ? "Yes" : "No"
						})]
					})]
				}),
				_ && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "cog"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Payment processor"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: _
						})]
					})]
				}),
				/* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "chart-bar"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Order value"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: [
								m,
								" ",
								l
							]
						})]
					})]
				}),
				/* @__PURE__ */ G(Zw, {
					address: f,
					icon: "home",
					title: "Billing address"
				}),
				/* @__PURE__ */ G(Zw, {
					address: p,
					icon: "map-pin",
					title: "Shipping address"
				}),
				g && /* @__PURE__ */ G(j, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(g, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
					onClick: () => r("recharge:external:order:opened"),
					children: "View order in Recharge"
				})
			]
		})]
	});
}, nT = ({ customerId: e, store: t }) => {
	let { track: r } = Ve(), { useQuery: i } = B(), { loading: a, error: o, data: s } = i(Lw, {
		skip: !e,
		variables: {
			customerId: e?.toString(),
			limit: "5"
		}
	}), c = s?.Recharge?.getOrders, l = !a && c?.orders && c.orders.length > 0 ? c.orders : [];
	if (!e) return null;
	if (o) return /* @__PURE__ */ G(z, { error: o });
	let u = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Customer orders"
			}), !a && /* @__PURE__ */ G(n, {
				variant: "success",
				size: "small",
				children: l.length
			})]
		}), /* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "column",
			children: [
				a && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					margin: "300",
					children: /* @__PURE__ */ G(P, {})
				}),
				!a && l.length === 0 && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					margin: "200 0 300 0",
					"data-testid": "widget-no-orders",
					children: /* @__PURE__ */ G(L.Paragraph, {
						color: "tertiary",
						children: "No orders found"
					})
				}),
				!a && l.length > 0 && /* @__PURE__ */ G(v, {
					gap: "200",
					flexDirection: "column",
					children: l.map((e, n) => /* @__PURE__ */ G(tT, {
						order: e,
						isOpenByDefault: n === 0,
						store: t
					}, `${n}-${e.id}`))
				}),
				u && /* @__PURE__ */ G(j, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(u, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
					onClick: () => r("recharge:external:orders:list:opened"),
					children: "View all orders in Recharge"
				})
			]
		})]
	});
}, rT = [
	"Too expensive",
	"Quality issues",
	"Switching product",
	"No longer needed",
	"Delivery issues",
	"Other"
], iT = {
	reason: null,
	comments: "",
	sendEmail: !0
}, aT = ({ subscriptionId: e, productTitle: t, isOpen: n, setIsOpen: r, isMutationLoading: i, setIsMutationLoading: a, refetchSubscriptions: o }) => {
	let s = gl({ defaultValues: iT }), [c, { reset: l }] = qw({
		mutation: Bw,
		isSuccessful: (e) => e.Recharge?.cancelSubscription?.__typename === "Recharge_Subscription_",
		successText: "The subscription got cancelled.",
		failureText: "Could not cancel the subscription.",
		trackingAction: "recharge:subscription:cancelled",
		setIsMutationLoading: a,
		setIsOpen: r,
		refetchSubscriptions: o
	}), u = Ye((t) => {
		t.reason != null && (a(!0), c({ variables: {
			id: e,
			input: {
				cancellation_reason: t.reason,
				cancellation_reason_comments: t.comments || void 0,
				send_email: t.sendEmail
			}
		} }));
	}, [e]), d = () => {
		r(!1), l(), s.reset(iT);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: n,
		onClose: d,
		children: [
			/* @__PURE__ */ G(A, {
				title: `Cancel subscription ${t}`,
				onClose: d
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(wl, {
					control: s.control,
					label: "Reason",
					name: "reason",
					rules: { required: {
						value: !0,
						message: "Please select a reason"
					} },
					componentProps: {
						placeholder: "Select a reason",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => e ?? ""
					},
					children: rT.map((e) => /* @__PURE__ */ G(N.Item, {
						value: e,
						children: /* @__PURE__ */ G(L.Paragraph, { children: e })
					}, e))
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
					name: "comments",
					label: "Comments (optional)",
					control: s.control
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Notify the customer by email",
					children: /* @__PURE__ */ G(X, {
						control: s.control,
						name: "sendEmail"
					})
				}) })
			] }) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !(s.formState.isValid && s.formState.isDirty),
					isLoading: i,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: s.handleSubmit(u),
				cancelOnClick: d,
				confirmName: "Cancel subscription",
				cancelName: "Back"
			})
		]
	});
}, oT = ({ subscriptionId: e, productTitle: t, refetchSubscriptions: n }) => {
	let [r, i] = U(!1), [o, s] = U(!1);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(R, {
		content: "Cancel this subscription so it no longer creates future orders.",
		wrap: "div",
		wrapProps: { className: Xw.fullWidth },
		children: /* @__PURE__ */ G(a, {
			variant: "secondary",
			onClick: () => i(!0),
			isLoading: o,
			loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
			slotStart: /* @__PURE__ */ G(x, {
				size: 14,
				name: "close-circle-filled",
				color: "red.500"
			}),
			className: Xw.fullWidth,
			children: "Cancel"
		})
	}), /* @__PURE__ */ G(aT, {
		subscriptionId: e,
		productTitle: t,
		isOpen: r,
		setIsOpen: i,
		isMutationLoading: o,
		setIsMutationLoading: s,
		refetchSubscriptions: n
	})] });
}, sT = ({ subscriptionId: e, productTitle: t, isOpen: n, setIsOpen: r, isMutationLoading: i, setIsMutationLoading: a, refetchSubscriptions: o }) => {
	let [s] = qw({
		mutation: Vw,
		isSuccessful: (e) => e.Recharge?.activateSubscription?.__typename === "Recharge_Subscription_",
		successText: "The subscription got reactivated.",
		failureText: "Could not reactivate the subscription.",
		trackingAction: "recharge:subscription:reactivated",
		setIsMutationLoading: a,
		setIsOpen: r,
		refetchSubscriptions: o
	}), c = Ye(() => {
		a(!0), s({ variables: { id: e } });
	}, [e]), l = () => r(!1);
	return /* @__PURE__ */ K(D, {
		isOpen: n,
		onClose: l,
		children: [
			/* @__PURE__ */ G(A, {
				title: `Reactivate subscription ${t}`,
				onClose: l
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ G(L.Paragraph, { children: "Reactivating resumes this subscription. The customer will be charged again on the regular schedule." }) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					isLoading: i,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: c,
				cancelOnClick: l,
				confirmName: "Reactivate subscription",
				cancelName: "Back"
			})
		]
	});
}, cT = ({ subscriptionId: e, productTitle: t, refetchSubscriptions: n }) => {
	let [r, i] = U(!1), [o, s] = U(!1);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(R, {
		content: "Reactivate this cancelled subscription so its orders start again.",
		wrap: "div",
		wrapProps: { className: Xw.fullWidth },
		children: /* @__PURE__ */ G(a, {
			variant: "secondary",
			onClick: () => i(!0),
			isLoading: o,
			loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
			slotStart: /* @__PURE__ */ G(x, {
				size: 14,
				name: "check-circle-filled",
				color: "green.500"
			}),
			className: Xw.fullWidth,
			children: "Reactivate"
		})
	}), /* @__PURE__ */ G(sT, {
		subscriptionId: e,
		productTitle: t,
		isOpen: r,
		setIsOpen: i,
		isMutationLoading: o,
		setIsMutationLoading: s,
		refetchSubscriptions: n
	})] });
}, lT = {
	skip: {
		mutation: Uw,
		title: "Skip next order",
		confirmName: "Skip next order",
		successText: "The next order was skipped.",
		failureText: "Could not skip the next order.",
		trackingAction: "recharge:subscription:order:skipped",
		describeScheduled: (e) => `This skips the upcoming order scheduled for ${e}. The following order proceeds as normal.`,
		describeUnscheduled: "This skips the next upcoming order. The following order proceeds as normal."
	},
	unskip: {
		mutation: Ww,
		title: "Unskip next order",
		confirmName: "Unskip next order",
		successText: "The skipped order was restored.",
		failureText: "Could not restore the skipped order.",
		trackingAction: "recharge:subscription:order:unskipped",
		describeScheduled: (e) => `This restores the skipped order scheduled for ${e} so that it is processed again.`,
		describeUnscheduled: "This restores the skipped order so that it is processed again."
	}
}, uT = (e, t) => e === "skip" ? t.Recharge?.skipCharge : t.Recharge?.unskipCharge, dT = ({ action: e, subscriptionId: t, chargeId: n, productTitle: r, chargeDate: i, isOpen: a, setIsOpen: o, isMutationLoading: s, setIsMutationLoading: c, refetchSubscriptions: l }) => {
	let { mutation: u, title: d, confirmName: f, successText: p, failureText: m, trackingAction: h, describeScheduled: g, describeUnscheduled: _ } = lT[e], [v] = qw({
		mutation: u,
		isSuccessful: (t) => uT(e, t)?.__typename === "Recharge_Charge",
		successText: p,
		failureText: m,
		trackingAction: h,
		setIsMutationLoading: c,
		setIsOpen: o,
		refetchSubscriptions: l
	}), y = Ye(() => {
		c(!0), v({ variables: {
			id: n,
			input: { purchase_item_ids: [t] }
		} });
	}, [
		e,
		n,
		t
	]), b = () => o(!1);
	return /* @__PURE__ */ K(D, {
		isOpen: a,
		onClose: b,
		children: [
			/* @__PURE__ */ G(A, {
				title: `${d} ${r}`,
				onClose: b
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ G(L.Paragraph, { children: i ? g(Gw(i).format(Yw)) : _ }) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					isLoading: s,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: y,
				cancelOnClick: b,
				confirmName: f,
				cancelName: "Back"
			})
		]
	});
}, fT = "SKIPPED", pT = "YYYY-MM-DD", mT = "scheduled_at-asc", hT = {
	skip: {
		label: "Skip next",
		icon: "arrow-right",
		tooltip: "Skip this subscription's next order. The following order proceeds as normal."
	},
	unskip: {
		label: "Unskip next",
		icon: "undo",
		tooltip: "Restore this subscription's skipped order so that it is processed again."
	}
}, gT = "This subscription has no upcoming order that can be skipped.", _T = (e) => (e?.Recharge?.getCharges?.charges ?? []).find((e) => {
	let t = e.status?.toUpperCase();
	return !!e.id && (t === "QUEUED" || t === "SKIPPED");
}), vT = ({ subscriptionId: e, productTitle: t, disabled: n, isSkippable: r, refetchSubscriptions: i }) => {
	let { useQuery: o } = B(), [s, c] = U(!1), [l, u] = U(!1), { loading: d, data: f, refetch: p } = o(zw, {
		skip: n,
		variables: {
			purchaseItemId: e.toString(),
			scheduledAtMin: Gw().format(pT),
			sortBy: mT,
			limit: "5"
		}
	}), m = _T(f), h = m?.status?.toUpperCase() === fT, g = h ? "unskip" : "skip", _ = h || !!m?.id && r, { label: v, icon: y, tooltip: b } = hT[g];
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(R, {
		content: _ ? b : gT,
		wrap: "div",
		wrapProps: { className: Xw.fullWidth },
		children: /* @__PURE__ */ G(a, {
			variant: "secondary",
			onClick: () => c(!0),
			disabled: n || !_,
			isLoading: d || l,
			loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
			slotStart: /* @__PURE__ */ G(x, {
				size: 14,
				name: y
			}),
			className: Xw.fullWidth,
			children: v
		})
	}), m?.id && /* @__PURE__ */ G(dT, {
		action: g,
		subscriptionId: e,
		chargeId: m.id,
		productTitle: t,
		chargeDate: m.scheduled_at,
		isOpen: s,
		setIsOpen: c,
		isMutationLoading: l,
		setIsMutationLoading: u,
		refetchSubscriptions: async () => {
			let e = await i();
			return await p().catch(() => void 0), e;
		}
	})] });
}, yT = { modal: "_modal_1op1u_1" }, bT = ({ subscriptionId: e, productTitle: t, isPrepaid: n, isOpen: r, setIsOpen: i, isMutationLoading: a, setIsMutationLoading: o, refetchSubscriptions: s }) => {
	let c = {
		externalVariantId: "",
		productTitle: "",
		price: ""
	}, l = gl({ defaultValues: c }), [u] = qw({
		mutation: Hw,
		isSuccessful: (e) => e.Recharge?.updateSubscription?.__typename === "Recharge_Subscription_",
		successText: "The product was swapped.",
		failureText: "Could not swap the product.",
		trackingAction: "recharge:subscription:product:swapped",
		setIsMutationLoading: o,
		setIsOpen: i,
		refetchSubscriptions: s
	}), d = Ye((t) => {
		o(!0), u({ variables: {
			id: e,
			input: {
				external_variant_id: { ecommerce: t.externalVariantId },
				product_title: t.productTitle || void 0,
				price: t.price ? Number(t.price) : void 0,
				override: n
			}
		} });
	}, [e]), f = () => {
		i(!1), l.reset(c);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: r,
		onClose: f,
		className: yT.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: `Swap product ${t}`,
				onClose: f
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
					name: "externalVariantId",
					label: "New variant ID",
					control: l.control,
					rules: { required: "A variant ID is required" },
					componentProps: { placeholder: "External variant ID" }
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
					name: "productTitle",
					label: "Product title (optional)",
					control: l.control
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
					name: "price",
					label: "Price (optional)",
					control: l.control,
					rules: { validate: (e) => !e || !Number.isNaN(Number(e)) && Number(e) >= 0 || "Price must be zero or more" }
				}) })
			] }) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !(l.formState.isValid && l.formState.isDirty),
					isLoading: a,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: l.handleSubmit(d),
				cancelOnClick: f,
				confirmName: "Swap product",
				cancelName: "Back"
			})
		]
	});
}, xT = ({ subscriptionId: e, productTitle: t, isPrepaid: n, disabled: r, refetchSubscriptions: i }) => {
	let [o, s] = U(!1), [c, l] = U(!1);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(R, {
		content: "Replace the product or variant on this subscription. Future orders will ship the new item instead.",
		wrap: "div",
		wrapProps: { className: Xw.fullWidth },
		children: /* @__PURE__ */ G(a, {
			variant: "secondary",
			onClick: () => s(!0),
			disabled: r,
			isLoading: c,
			loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
			slotStart: /* @__PURE__ */ G(x, {
				size: 14,
				name: "exchange"
			}),
			className: Xw.fullWidth,
			children: "Swap"
		})
	}), /* @__PURE__ */ G(bT, {
		subscriptionId: e,
		productTitle: t,
		isPrepaid: n,
		isOpen: o,
		setIsOpen: s,
		isMutationLoading: c,
		setIsMutationLoading: l,
		refetchSubscriptions: i
	})] });
}, ST = {
	subscription: "_subscription_1xxl7_1",
	subscriptionIsOpen: "_subscriptionIsOpen_1xxl7_9",
	subscriptionHeader: "_subscriptionHeader_1xxl7_12"
}, CT = "CANCELLED", wT = ({ subscription: e, isOpenByDefault: t, canCancel: r, canReactivate: i, canSkip: o, canSwap: s, store: c, refetchSubscriptions: l }) => {
	let { track: u } = Ve(), [d, f] = U(t), { id: p, status: m, product_title: h, variant_title: g, price: _, presentment_currency: y, is_prepaid: b, is_skippable: C, is_swappable: w, next_charge_scheduled_at: T, order_interval_frequency: E, order_interval_unit: D, cancellation_reason: O, cancellation_reason_comments: k, cancelled_at: A } = e, j = m?.toUpperCase() === CT || !!A, M = c && p ? `https://${c.identifier}.admin.rechargeapps.com/merchant/subscriptions/${p}/details` : null, N = E && D ? `Every ${E} ${D}` : null, P = j ? i : r, ee = o || s, F = P || M !== null;
	return /* @__PURE__ */ K(v, {
		className: ht(ST.subscription, { [ST.subscriptionIsOpen]: d }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: ST.subscriptionHeader,
			onClick: () => f(!d),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "1",
						children: ["Subscription #", p]
					}), j && /* @__PURE__ */ G(n, {
						variant: "error",
						size: "small",
						children: "Cancelled"
					})]
				}), h && /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					color: "secondary",
					children: h
				})]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: d ? "angle-down" : "angle-right"
			})]
		}), d && /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				m && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "activity"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Status"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: Jw(m)
						})]
					})]
				}),
				g && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "tag"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Variant"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: g
						})]
					})]
				}),
				/* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "chart-bar"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Price"
						}), /* @__PURE__ */ K(L.Paragraph, {
							variant: "4",
							children: [
								_,
								" ",
								y
							]
						})]
					})]
				}),
				N && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "sync"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Frequency"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: N
						})]
					})]
				}),
				!j && T && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "calendar"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Next charge"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: Gw(T).format("DD MMM YYYY @ HH:mm")
						})]
					})]
				}),
				/* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "credit-card"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Prepaid"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: b ? "Yes" : "No"
						})]
					})]
				}),
				j && O && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "info"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: O
						}), k && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							color: "secondary",
							children: /* @__PURE__ */ G("i", { children: k })
						})]
					})]
				}),
				p && ee && /* @__PURE__ */ K(v, {
					flexDirection: "row",
					gap: "200",
					children: [o && /* @__PURE__ */ G(v, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: /* @__PURE__ */ G(vT, {
							subscriptionId: p,
							productTitle: h ?? `#${p}`,
							disabled: j,
							isSkippable: !!C,
							refetchSubscriptions: l
						})
					}), s && /* @__PURE__ */ G(v, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: /* @__PURE__ */ G(xT, {
							subscriptionId: p,
							productTitle: h ?? `#${p}`,
							isPrepaid: !!b,
							disabled: j || !w,
							refetchSubscriptions: l
						})
					})]
				}),
				p && F && /* @__PURE__ */ K(v, {
					flexDirection: "row",
					gap: "200",
					children: [P && /* @__PURE__ */ G(v, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: G(j ? cT : oT, {
							subscriptionId: p,
							productTitle: h ?? `#${p}`,
							refetchSubscriptions: l
						})
					}), M && /* @__PURE__ */ G(v, {
						flexDirection: "column",
						style: {
							flex: 1,
							minWidth: 0
						},
						children: /* @__PURE__ */ G(R, {
							content: "Open this subscription in the Recharge merchant portal.",
							wrap: "div",
							wrapProps: { className: Xw.fullWidth },
							children: /* @__PURE__ */ G(a, {
								variant: "secondary",
								onClick: () => {
									window.open(M, "_blank")?.focus(), u("recharge:external:subscription:opened");
								},
								slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
								className: Xw.fullWidth,
								children: "Open"
							})
						})
					})]
				})
			]
		})]
	});
}, TT = ({ customerId: e, canCancel: t, canReactivate: r, canSkip: i, canSwap: a, store: o }) => {
	let { track: s } = Ve(), { useQuery: c } = B(), { loading: l, error: u, data: d, refetch: f } = c(Rw, {
		skip: !e,
		variables: {
			customerId: e?.toString(),
			limit: "10"
		}
	}), p = d?.Recharge?.getSubscriptions, m = !l && p?.subscriptions && p.subscriptions.length > 0 ? p.subscriptions : [];
	if (!e) return null;
	if (u) return /* @__PURE__ */ G(z, { error: u });
	let h = o ? `https://${o.identifier}.admin.rechargeapps.com/merchant/subscriptions` : null;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Subscriptions"
			}), !l && /* @__PURE__ */ G(n, {
				variant: "success",
				size: "small",
				children: m.length
			})]
		}), /* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "column",
			children: [
				l && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					margin: "300",
					children: /* @__PURE__ */ G(P, {})
				}),
				!l && m.length === 0 && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					margin: "200 0 300 0",
					"data-testid": "widget-no-subscriptions",
					children: /* @__PURE__ */ G(L.Paragraph, {
						color: "tertiary",
						children: "No subscriptions found"
					})
				}),
				!l && m.length > 0 && /* @__PURE__ */ G(v, {
					gap: "200",
					flexDirection: "column",
					children: m.map((e, n) => /* @__PURE__ */ G(wT, {
						subscription: e,
						isOpenByDefault: n === 0,
						canCancel: t,
						canReactivate: r,
						canSkip: i,
						canSwap: a,
						store: o,
						refetchSubscriptions: f
					}, `${n}-${e.id}`))
				}),
				h && /* @__PURE__ */ G(j, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(h, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
					onClick: () => s("recharge:external:subscriptions:list:opened"),
					children: "View all subscriptions in Recharge"
				})
			]
		})]
	});
}, ET = ({ customer: e }) => {
	if (!e) return null;
	let { subscriptions_active_count: t, subscriptions_total_count: n } = e, r = n ?? 0, i = t ?? 0;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Subscriptions overview"
		}), /* @__PURE__ */ K(E, {
			className: Xw.list,
			children: [/* @__PURE__ */ G(E.Text, {
				variant: "dense",
				className: Xw.listItem,
				children: /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Total subscriptions"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: r
					})]
				})
			}), /* @__PURE__ */ G(E.Text, {
				variant: "dense",
				className: Xw.listItem,
				children: /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Active subscriptions"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: i
					})]
				})
			})]
		})]
	});
}, DT = ({ conversationContext: e, settings: t }) => {
	let { useQuery: n } = B(), r = e?.customer?.email, i = t.displayCustomerDetails ?? !1, a = t.displaysubscriptionOverview ?? !1, o = t.displaySubscriptions ?? !1, s = t.enableCancelSubscription ?? !1, c = t.enableReactivateSubscription ?? !1, l = t.enableSkipOrder ?? !1, u = t.enableSwapProduct ?? !1, d = t.displayOrders ?? !1, f = !i && !a && !o && !d, { loading: p, error: m, data: h } = n(Fw, {
		skip: !r,
		variables: { email: r }
	}), g = !p && h ? (h?.Recharge?.getCustomers)?.customers?.[0] : void 0, _ = !p && h ? h?.Recharge?.getStore?.store ?? void 0 : void 0;
	if (m) {
		let e = m.graphQLErrors;
		return xe({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Recharge. Please contact your administrator."
		}) : /* @__PURE__ */ G(z, { error: m });
	}
	return p ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ G(P, {})
	}) : g ? f ? /* @__PURE__ */ G(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-no-features",
		children: "All features toggles in the settings are disabled."
	}) : /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			i && /* @__PURE__ */ G($w, {
				customer: g,
				store: _
			}),
			a && /* @__PURE__ */ G(ET, { customer: g }),
			o && /* @__PURE__ */ G(TT, {
				customerId: g.id,
				canCancel: s,
				canReactivate: c,
				canSkip: l,
				canSwap: u,
				store: _
			}),
			d && /* @__PURE__ */ G(nT, {
				customerId: g.id,
				store: _
			})
		]
	}) : /* @__PURE__ */ G(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		align: "center",
		"data-testid": "widget-customer-not-found",
		children: "No data found for this customer in Recharge."
	});
}, OT = [
	{
		key: "rechargeAccessToken",
		label: "API token",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "rechargeStoreHostName",
		label: "Store host name",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "displayCustomerDetails",
		label: "Displays details of a customer",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displaysubscriptionOverview",
		label: "Displays the subscription overview",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displaySubscriptions",
		label: "Displays the list of subscriptions",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "enableCancelSubscription",
		label: "Allows agents to cancel a subscription",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableReactivateSubscription",
		label: "Allows agents to reactivate a cancelled subscription",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableSkipOrder",
		label: "Allows agents to skip the next order of a subscription, and to restore it once skipped",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "enableSwapProduct",
		label: "Allows agents to swap the product of a subscription",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "displayOrders",
		label: "Displays the last 5 orders",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], kT = [
	"enableCancelSubscription",
	"enableReactivateSubscription",
	"enableSkipOrder",
	"enableSwapProduct"
], AT = (e) => {
	let t = e.trim().replace(/^https?:\/\//i, "");
	if (t) return t.includes(".") ? t : `${t}.myshopify.com`;
}, jT = Pe(OT), MT = "RECHARGE", NT = {
	enabled: !1,
	name: "",
	...Le([], OT)
}, PT = {
	...NT,
	...kT.reduce((e, t) => ({
		...e,
		[t]: !0
	}), {})
}, FT = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i }) => {
	let a = !e, o = gl({
		mode: "onChange",
		defaultValues: a ? PT : NT
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = He({
		integrationId: e,
		integrationType: MT,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: m, error: h, isWidgetUnknown: g, refetch: v, widgetConfiguration: x } = Ue({
		integrationId: e,
		fieldDefinitions: OT,
		form: o,
		onMisconfigured: p
	}), { isInboundOAuth: S, shopifyDomain: C } = Be();
	H(() => {
		let e = C ? AT(C) : void 0;
		a && S && e && o.setValue("rechargeStoreHostName", e, {
			shouldDirty: !0,
			shouldValidate: !0
		});
	}, [
		a,
		S,
		C,
		o
	]);
	let w = a || !!x?.additionalProperties?.isUsingOAuth, T = w ? OT : OT.filter((e) => e.key !== "rechargeStoreHostName"), E = (e) => ye(e, {
		fieldDefinitions: T,
		isCreationMode: a,
		create: s,
		update: c
	}), D = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: E,
		error: h ?? d,
		onRetry: h ? v : void 0,
		isLoading: u || m,
		isWidgetUnknown: g,
		children: [
			f && /* @__PURE__ */ G(se, { cause: f }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!w && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "rechargeAccessToken",
						label: jT.rechargeAccessToken,
						control: o.control,
						isCreationMode: a,
						rules: { required: "API token is required" },
						componentProps: {
							placeholder: "Insert the Admin API token for Recharge",
							autoComplete: "off"
						}
					})
				}), /* @__PURE__ */ G(y, { span: 3 })] }),
				w && /* @__PURE__ */ K(W, { children: [
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(El, {
							name: "rechargeStoreHostName",
							label: jT.rechargeStoreHostName,
							control: o.control,
							rules: {
								required: "Store host name is required",
								validate: (e) => We(String(e ?? "")) || !0
							},
							componentProps: {
								placeholder: "e.g. my-store.myshopify.com",
								autoComplete: "off",
								prefix: "https://"
							}
						})
					}),
					/* @__PURE__ */ G(y, { span: 3 }),
					!a && e && /* @__PURE__ */ G(ce, {
						configuration: t,
						integrationId: e,
						integrationType: MT,
						label: "Authorize with OAuth"
					})
				] }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.displayCustomerDetails,
						children: /* @__PURE__ */ G(X, {
							name: "displayCustomerDetails",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.displaysubscriptionOverview,
						children: /* @__PURE__ */ G(X, {
							name: "displaysubscriptionOverview",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.displaySubscriptions,
						children: /* @__PURE__ */ G(X, {
							name: "displaySubscriptions",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.enableCancelSubscription,
						children: /* @__PURE__ */ G(X, {
							name: "enableCancelSubscription",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.enableReactivateSubscription,
						children: /* @__PURE__ */ G(X, {
							name: "enableReactivateSubscription",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.enableSkipOrder,
						children: /* @__PURE__ */ G(X, {
							name: "enableSkipOrder",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.enableSwapProduct,
						children: /* @__PURE__ */ G(X, {
							name: "enableSwapProduct",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: jT.displayOrders,
						children: /* @__PURE__ */ G(X, {
							name: "displayOrders",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 })
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: MT,
				integrationId: e,
				widgetName: D,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => l()
			})
		]
	});
};
//#endregion
//#region ../widget-rivoloyalty/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:230px;padding:0;overflow-y:auto}._listItem_l5y5y_95{padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200);background-color:#0000}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{max-height:230px;padding:0;overflow-y:auto}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200);background-color:#0000}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var IT = /* @__PURE__ */ function(e) {
	return e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e;
}({}), LT = /* @__PURE__ */ function(e) {
	return e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e;
}({}), RT = {
	"\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "adjustCustomerPoints"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "RivoLoyalty_adjust_customer_points_request_Input"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "adjust_customer_points"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: \"lifetime_earnings_tally,next_vip_tier\"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomer"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "return_customer"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customer_identifier"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "fields"
								},
								value: {
									kind: "StringValue",
									value: "lifetime_earnings_tally,next_vip_tier",
									block: !1
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "data"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "attributes"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "email"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "first_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "last_name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "accepts_marketing"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "orders_count"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "verified_email"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "total_spent"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "loyalty_status"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "points_tally"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "credits_tally"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "vip_tier"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "threshold"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "points_expire_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "next_vip_tier"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "name"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "threshold"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "to_spend_or_earn"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "lifetime_earnings_tally"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getFavoriteProducts"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "list_customer_favorite_products"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customer_id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "data_source"
								},
								value: {
									kind: "EnumValue",
									value: "shopify"
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "data"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "product_id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "handle"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getPointsRedemptions"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "RivoLoyalty"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "list_points_redemptions"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "data"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "attributes"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "points_amount"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "code"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "expires_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "used_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "refunded_at"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "revoked_at"
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function zT(e) {
	return RT[e] ?? {};
}
var BT = zT("\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: \"lifetime_earnings_tally,next_vip_tier\"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n"), VT = zT("\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n"), HT = zT("\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n"), UT = zT("\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n"), WT = {
	wrapper: "_wrapper_l5y5y_54",
	inputWrapper: "_inputWrapper_l5y5y_59",
	inputField: "_inputField_l5y5y_67",
	inputSeparator: "_inputSeparator_l5y5y_71",
	buttonLink: "_buttonLink_l5y5y_76",
	noIssuesFound: "_noIssuesFound_l5y5y_80",
	list: "_list_l5y5y_85",
	listItem: "_listItem_l5y5y_95",
	listItemHighlighted: "_listItemHighlighted_l5y5y_103",
	listItemEdit: "_listItemEdit_l5y5y_106",
	fullWidth: "_fullWidth_l5y5y_110",
	boxWrapper: "_boxWrapper_l5y5y_114",
	clickableIcon: "_clickableIcon_l5y5y_120"
}, GT = "rivoLoyaltyShopifyApiHostName", KT = "https://admin.shopify.com";
function qT(e) {
	return e.split(".")[0];
}
var JT = {
	wrapper: "_wrapper_1xucg_1",
	externalLink: "_externalLink_1xucg_7"
}, YT = ({ customerDetails: e, rivoLoyaltyShopifyApiHostName: t }) => {
	let { track: n } = Ve(), { isCopied: r, copy: i } = Re(), { attributes: a } = e, { first_name: o, last_name: s, email: c, verified_email: l } = a, u = `${o || ""} ${s || ""}`.trim() || "No name found for customer";
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			className: JT.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ G(v, {
					justifyContent: "space-between",
					className: JT.block,
					alignItems: "center",
					children: /* @__PURE__ */ G(L.Heading, {
						variant: "heading-2",
						children: u
					})
				}),
				c && /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ G(x, {
								size: 14,
								name: "mail"
							}),
							/* @__PURE__ */ G(L.ExternalLink, {
								href: `mailto:${c}`,
								children: c
							}),
							/* @__PURE__ */ G(R, {
								content: l ? "Verified email" : "Email is not verified",
								children: /* @__PURE__ */ G(v, {
									alignItems: "center",
									children: /* @__PURE__ */ G(x, {
										size: 14,
										color: l ? "green.500" : "red.500",
										name: l ? "check-circle" : "exclamation"
									})
								})
							})
						]
					}), /* @__PURE__ */ G(R, {
						content: "Copy Email",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: r ? "done" : "copy",
							onClick: () => i(c),
							className: WT.clickableIcon
						})
					})]
				}),
				/* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "sign-in"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "2",
							children: "Marketing consent"
						})]
					}), /* @__PURE__ */ G(x, {
						name: a.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
						color: a.accepts_marketing ? "green.500" : "neutral.500"
					})]
				}),
				/* @__PURE__ */ K(v, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ G(L.ExternalLink, {
						href: XT(t, a.id),
						target: "_blank",
						rel: "noreferrer",
						onClick: () => {
							n("rivoloyalty:customer:clicked", {});
						},
						children: "View customer in Rivo Loyalty"
					})]
				})
			]
		})
	});
};
function XT(e, t) {
	return `${KT}/store/${qT(e)}/apps/rivo-loyalty/customers/${t}`;
}
var ZT = {
	list: "_list_rxh85_1",
	listItem: "_listItem_rxh85_6",
	listItemHighlighted: "_listItemHighlighted_rxh85_16"
}, QT = ({ customerId: e, rivoLoyaltyShopifyApiHostName: t }) => {
	let { useQuery: n } = B(), { loading: r, error: i, data: a } = n(VT, {
		skip: !e,
		variables: { customerId: e?.toString() }
	}), o = !r && a ? a.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [];
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Favorite products"
		}), i ? /* @__PURE__ */ G(z, { error: i }) : r ? /* @__PURE__ */ G(v, {
			justifyContent: "center",
			margin: "300",
			children: /* @__PURE__ */ G(P, {})
		}) : o.length === 0 ? /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No favorite products found."
		}) : /* @__PURE__ */ G(E, {
			className: ZT.list,
			children: o.map((e) => /* @__PURE__ */ K(v, {
				alignItems: "center",
				gap: "200",
				className: ZT.listItem,
				children: [/* @__PURE__ */ G(x, {
					size: 14,
					name: "external-link"
				}), /* @__PURE__ */ G(L.ExternalLink, {
					href: $T(t, e.product_id),
					target: "_blank",
					rel: "noreferrer",
					children: e.title
				})]
			}, e.product_id))
		})]
	}) });
};
function $T(e, t) {
	return `${KT}/store/${qT(e)}/products/${t}`;
}
var eE = { modalBody: "_modalBody_1clhs_1" };
function tE(e, t) {
	if (isNaN(e)) return "Points can not be empty";
	if (e < t.min) return `Points cannot be below ${t.min}`;
	if (e > t.max) return `Points can not exceed ${t.max}`;
}
function nE(e, t) {
	if (e === t) return "Change the value to update the points";
}
var rE = IT, iE = {
	addPoints: {
		successEventName: "rivoloyalty:points:add:succeeded",
		successEventText: "Added points successfully",
		failEventName: "rivoloyalty:points:add:failed",
		failEventText: "Failed to add points, try again later."
	},
	removePoints: {
		successEventName: "rivoloyalty:points:remove:succeeded",
		successEventText: "Removed points successfully",
		failEventName: "rivoloyalty:points:remove:failed",
		failEventText: "Failed to remove points, try again later."
	}
}, aE = ({ customerIdentifier: e, isOpen: t, points: n, onClose: r, refetchCustomerData: i }) => {
	let { useMutation: a, showNotification: o } = B(), { track: s } = Ve(), [c, l] = U(n), [u, d] = U(""), [f, p] = U(!0), [g, S] = U(), C = {
		min: 0,
		max: 1e5
	}, [w, { loading: T }] = a(UT, { onCompleted: () => {
		let e = c > n ? iE.addPoints : iE.removePoints;
		o({
			title: "Success",
			text: e.successEventText,
			icon: "check-circle-filled",
			severity: "success"
		}), s(e.successEventName), te();
	} }), j = () => {
		l(n), d(""), p(!0), S(void 0);
	};
	H(() => {
		t && j();
	}, [t]);
	let M = !!g, N = tE(c, C), ee = nE(n, c), F = () => {
		if (c !== n) {
			let t = c > n ? iE.addPoints : iE.removePoints, r = !f;
			w({ variables: { input: {
				points_amount: c - n,
				...u && { internal_note: u },
				customer_identifier: e?.toString(),
				source: rE.Manual,
				skip_email: r
			} } }).catch(() => {
				s(t.failEventName), S([t.failEventText]);
			});
		}
	}, I = () => {
		j(), r();
	}, te = () => {
		i(), I();
	};
	return /* @__PURE__ */ K(D, {
		isOpen: t,
		onClose: I,
		"data-testid": "rivo-loyalty-change-points-modal",
		children: [
			/* @__PURE__ */ G(A, {
				title: "Change points",
				onClose: I
			}),
			/* @__PURE__ */ K(O, {
				className: eE.modalBody,
				children: [/* @__PURE__ */ K(b, { children: [
					/* @__PURE__ */ G(y, {
						span: 6,
						"data-testid": "rivo-loyalty-points-input",
						children: /* @__PURE__ */ G(h, {
							label: "New points balance",
							type: "number",
							placeholder: "Insert points balance",
							min: C.min,
							max: C.max,
							meta: {
								error: N,
								warning: ee
							},
							input: {
								name: "points",
								value: c.toString(),
								onChange: (e) => l(e?.target.valueAsNumber ?? 0)
							}
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 6,
						children: /* @__PURE__ */ G(h, {
							label: "Internal note",
							placeholder: "Insert an internal note (optional)",
							input: {
								name: "internalNote",
								value: u,
								onChange: (e) => d(e?.target.value ?? "")
							}
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 6,
						children: /* @__PURE__ */ G(_, {
							label: "Notify the customer by email",
							children: /* @__PURE__ */ G(m, { input: {
								name: "sendEmail",
								value: "sendEmail",
								checked: f,
								onChange: () => p(!f)
							} })
						})
					})
				] }), !T && M && /* @__PURE__ */ G(v, {
					margin: "200 0",
					flexDirection: "column",
					children: /* @__PURE__ */ G(E, { children: g?.map((e, t) => /* @__PURE__ */ G(E.Item, {
						variant: "dense",
						title: e,
						contentLeft: /* @__PURE__ */ G(x, {
							color: "red.500",
							size: 16,
							name: "exclamation-triangle-filled"
						})
					}, t)) })
				})]
			}),
			/* @__PURE__ */ G(k, {
				confirmName: "Save",
				confirmOnClick: () => F(),
				confirmProps: {
					isLoading: T,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
					disabled: !!(N || ee)
				},
				cancelOnClick: I
			})
		]
	});
}, oE = ({ description: e, content: t, tooltip: n, isHighlighted: r = !1 }) => {
	if (t == null) return null;
	let i = Je(t);
	return /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: ht(WT.listItem, { [WT.listItemHighlighted]: r }),
		children: /* @__PURE__ */ G(R, {
			content: n,
			children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: e
				}), i ? t : ge(t)]
			})
		})
	});
}, sE = {
	[LT.Guest]: {
		name: "Guest",
		tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
		badgeColor: "info"
	},
	[LT.Member]: {
		name: "Member",
		tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
		badgeColor: "success"
	},
	[LT.Excluded]: {
		name: "Excluded",
		tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
		badgeColor: "warning"
	}
}, cE = ({ customer: e, allowAdjustLoyaltyPoints: t, refetchCustomerData: r }) => {
	let { attributes: i } = e, a = i.loyalty_status ? sE[i.loyalty_status] : sE[LT.Guest], o = a?.name === LT.Excluded, s = i.lifetime_earnings_tally ?? 0, c = i.total_spent ?? 0, l = Math.trunc(i.points_tally ?? 0), u = i.next_vip_tier, d = i.next_vip_tier?.to_spend_or_earn ?? 0, f = u?.name ?? "None", [p, m] = U(!1), h = () => /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: ht(WT.listItem),
		children: /* @__PURE__ */ G(R, {
			content: a.tooltip,
			children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: "Loyalty status"
				}), /* @__PURE__ */ G(n, {
					variant: a.badgeColor,
					size: "small",
					children: a.name
				})]
			})
		})
	});
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Loyalty"
		}), /* @__PURE__ */ G(E, {
			className: WT.list,
			children: o ? h() : /* @__PURE__ */ K(W, { children: [
				/* @__PURE__ */ G(E.Text, {
					variant: "dense",
					className: ht(WT.listItem, WT.listItemHighlighted, { [WT.listItemEdit]: t }),
					onClick: () => t ? m(!0) : void 0,
					children: /* @__PURE__ */ G(R, {
						content: "The current balance of loyalty points for the customer.",
						children: /* @__PURE__ */ K(v, {
							justifyContent: "space-between",
							alignItems: "center",
							children: [/* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: "Points balance"
							}), /* @__PURE__ */ K(v, {
								alignItems: "center",
								justifyContent: "space-between",
								gap: "100",
								children: [t && /* @__PURE__ */ G(x, {
									name: "pen",
									size: 10,
									"aria-label": "Edit points"
								}), /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: ge(l)
								})]
							})]
						})
					})
				}),
				d != null && f && /* @__PURE__ */ G(oE, {
					description: `Points until ${f} tier`,
					tooltip: `Loyalty points until the customer advances to ${f} tier`,
					content: d.toFixed(2)
				}),
				/* @__PURE__ */ G(oE, {
					description: "Points expiry date",
					tooltip: "The timestamp when the customer's loyalty points are set to expire.",
					content: i.points_expire_at ?? "No expiry"
				}),
				/* @__PURE__ */ G(oE, {
					description: "Total points earned",
					tooltip: "The total number of loyalty points earned by the customer.",
					content: s?.toFixed(2)
				}),
				/* @__PURE__ */ G(oE, {
					description: "Total points spent",
					tooltip: "The total number of loyalty points spent by the customer.",
					content: c.toFixed(2)
				}),
				h(),
				/* @__PURE__ */ G(oE, {
					description: "VIP tier",
					tooltip: "The name of the customer's current VIP tier status.",
					content: i.vip_tier?.name ?? "None"
				}),
				/* @__PURE__ */ G(oE, {
					description: "Next VIP tier",
					tooltip: "The name of the customer's next VIP tier status.",
					content: f
				})
			] })
		})]
	}), /* @__PURE__ */ G(aE, {
		customerIdentifier: i.id,
		isOpen: p,
		points: l,
		onClose: () => m(!1),
		refetchCustomerData: r
	})] });
}, lE = ({ ordersCount: e }) => /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
	gap: "200",
	flexDirection: "column",
	children: [/* @__PURE__ */ G(L.Heading, {
		variant: "heading-3",
		children: "Orders overview"
	}), /* @__PURE__ */ G(E, {
		className: WT.list,
		children: /* @__PURE__ */ G(E.Text, {
			variant: "dense",
			className: WT.listItem,
			children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: "Total orders"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: e ?? 0
				})]
			})
		})
	})]
}) }), uE = {
	reward: "_reward_1gmba_1",
	clickable: "_clickable_1gmba_10",
	voucherCode: "_voucherCode_1gmba_14"
}, dE = ({ pointsRedemption: e }) => {
	let { isCopied: t, copy: r } = Re(), { name: i, code: a, points_amount: o } = e.attributes;
	return /* @__PURE__ */ G(v, {
		gap: "100",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			gap: "100",
			flexDirection: "column",
			className: uE.reward,
			children: [/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(v, {
					gap: "100",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						name: "star",
						size: 12,
						color: "neutral.500"
					}), i]
				}), /* @__PURE__ */ K(n, {
					size: "small",
					variant: "info",
					children: [o ?? 0, " points"]
				})]
			}), /* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "row",
				alignItems: "center",
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "row",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "tag"
					}), /* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						className: uE.voucherCode,
						children: a
					}) })]
				}), /* @__PURE__ */ G(R, {
					content: "Copy reward code",
					children: /* @__PURE__ */ G(x, {
						size: 14,
						name: t ? "done" : "copy",
						className: WT.clickableIcon,
						onClick: () => r(a)
					})
				})]
			})]
		})
	});
}, fE = ({ customer: e }) => {
	let { useQuery: t } = B(), { loading: n, error: r, data: i } = t(HT, {
		skip: !e,
		variables: { customerId: e.attributes.id.toString() }
	}), a = (!n && e && i ? i?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(({ attributes: e }) => pE({
		usedAt: e.used_at,
		revokedAt: e.revoked_at,
		refundedAt: e.refunded_at
	}) === "Issued");
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Available rewards"
		}), r ? /* @__PURE__ */ G(z, { error: r }) : n ? /* @__PURE__ */ G(v, {
			justifyContent: "center",
			margin: "300",
			children: /* @__PURE__ */ G(P, {})
		}) : a.length > 0 ? /* @__PURE__ */ G(v, {
			gap: "200",
			flexDirection: "column",
			children: a.map((e) => /* @__PURE__ */ G(dE, { pointsRedemption: e }, e.id))
		}) : /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No loyalty rewards found."
		})]
	}) });
};
function pE(e) {
	return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
var mE = (e) => {
	let { conversationContext: t, settings: n } = e, { rivoLoyaltyShowOrders: r, rivoLoyaltyShowLoyalty: i, rivoLoyaltyAdjustLoyaltyPoints: a, rivoLoyaltyShowFavoriteProducts: o, rivoLoyaltyShowPointsRedemptions: s } = n, c = n[GT].toString(), { useQuery: l } = B(), { track: u } = Ve(), [d, f] = U(!1), p = t?.customer?.email, { loading: m, error: h, data: g, refetch: _ } = l(BT, {
		skip: !p,
		variables: { email: p }
	}), y = !m && g ? g.RivoLoyalty?.return_customer?.data : void 0;
	H(() => {
		!m && y && !d && (u("rivoloyalty:customer:received"), f(!0));
	}, [m, y]);
	let b = () => /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No customer profile found."
		})
	});
	if (h) {
		let e = h.graphQLErrors;
		return Se({ errors: e }) ? b() : xe({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
		}) : /* @__PURE__ */ G(z, { error: h });
	}
	return m ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ G(P, {})
	}) : !p || !y ? b() : /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			/* @__PURE__ */ G(YT, {
				customerDetails: y,
				rivoLoyaltyShopifyApiHostName: c
			}),
			r && /* @__PURE__ */ G(lE, { ordersCount: y.attributes?.orders_count ?? 0 }),
			i && /* @__PURE__ */ G(cE, {
				customer: y,
				refetchCustomerData: _,
				allowAdjustLoyaltyPoints: !!a
			}),
			o && /* @__PURE__ */ G(QT, {
				customerId: y.attributes.id,
				rivoLoyaltyShopifyApiHostName: c
			}),
			s && /* @__PURE__ */ G(fE, { customer: y })
		]
	});
}, hE = Gs, gE = (e) => e.type === "checkbox", _E = (e) => e instanceof Date, vE = (e) => e == null, yE = (e) => typeof e == "object", bE = (e) => !vE(e) && !Array.isArray(e) && yE(e) && !_E(e), xE = (e) => bE(e) && e.target ? gE(e.target) ? e.target.checked : e.target.value : e, SE = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, CE = (e, t) => e.has(SE(t)), wE = (e) => {
	let t = e.constructor && e.constructor.prototype;
	return bE(t) && t.hasOwnProperty("isPrototypeOf");
}, TE = typeof window < "u" && window.HTMLElement !== void 0 && typeof document < "u";
function EE(e) {
	let t, n = Array.isArray(e), r = typeof FileList < "u" && e instanceof FileList;
	if (e instanceof Date) t = new Date(e);
	else if (e instanceof Set) t = new Set(e);
	else if (!(TE && (e instanceof Blob || r)) && (n || bE(e))) if (t = n ? [] : {}, !n && !wE(e)) t = e;
	else for (let n in e) e.hasOwnProperty(n) && (t[n] = EE(e[n]));
	else return e;
	return t;
}
var DE = (e) => Array.isArray(e) ? e.filter(Boolean) : [], OE = (e) => e === void 0, Q = (e, t, n) => {
	if (!t || !bE(e)) return n;
	let r = DE(t.split(/[,[\].]+?/)).reduce((e, t) => vE(e) ? e : e[t], e);
	return OE(r) || r === e ? OE(e[t]) ? n : e[t] : r;
}, kE = (e) => typeof e == "boolean", AE = (e) => /^\w*$/.test(e), jE = (e) => DE(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ME = (e, t, n) => {
	let r = -1, i = AE(t) ? [t] : jE(t), a = i.length, o = a - 1;
	for (; ++r < a;) {
		let t = i[r], a = n;
		if (r !== o) {
			let n = e[t];
			a = bE(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
		}
		if (t === "__proto__" || t === "constructor" || t === "prototype") return;
		e[t] = a, e = e[t];
	}
}, NE = {
	BLUR: "blur",
	FOCUS_OUT: "focusout",
	CHANGE: "change"
}, PE = {
	onBlur: "onBlur",
	onChange: "onChange",
	onSubmit: "onSubmit",
	onTouched: "onTouched",
	all: "all"
}, FE = {
	max: "max",
	min: "min",
	maxLength: "maxLength",
	minLength: "minLength",
	pattern: "pattern",
	required: "required",
	validate: "validate"
}, IE = V.createContext(null), LE = () => V.useContext(IE), RE = (e, t, n, r = !0) => {
	let i = { defaultValues: t._defaultValues };
	for (let a in e) Object.defineProperty(i, a, { get: () => {
		let i = a;
		return t._proxyFormState[i] !== PE.all && (t._proxyFormState[i] = !r || PE.all), n && (n[i] = !0), e[i];
	} });
	return i;
};
function zE(e) {
	let t = LE(), { control: n = t.control, disabled: r, name: i, exact: a } = e || {}, [o, s] = V.useState(n._formState), c = V.useRef({
		isDirty: !1,
		isLoading: !1,
		dirtyFields: !1,
		touchedFields: !1,
		validatingFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}), l = V.useRef(i);
	return l.current = i, V.useEffect(() => n._subscribe({
		name: l.current,
		formState: c.current,
		exact: a,
		callback: (e) => {
			!r && s({
				...n._formState,
				...e
			});
		}
	}), [
		n,
		r,
		a
	]), V.useEffect(() => {
		c.current.isValid && n._setValid(!0);
	}, [n]), V.useMemo(() => RE(o, n, c.current, !1), [o, n]);
}
var BE = (e) => typeof e == "string", VE = (e, t, n, r, i) => BE(e) ? (r && t.watch.add(e), Q(n, e, i)) : Array.isArray(e) ? e.map((e) => (r && t.watch.add(e), Q(n, e))) : (r && (t.watchAll = !0), n);
function HE(e) {
	let t = LE(), { control: n = t.control, name: r, defaultValue: i, disabled: a, exact: o } = e || {}, s = V.useRef(r), c = V.useRef(i);
	s.current = r, V.useEffect(() => n._subscribe({
		name: s.current,
		formState: { values: !0 },
		exact: o,
		callback: (e) => !a && u(VE(s.current, n._names, e.values || n._formValues, !1, c.current))
	}), [
		n,
		a,
		o
	]);
	let [l, u] = V.useState(n._getWatch(r, i));
	return V.useEffect(() => n._removeUnmounted()), l;
}
function UE(e) {
	let t = LE(), { name: n, disabled: r, control: i = t.control, shouldUnregister: a } = e, o = CE(i._names.array, n), s = HE({
		control: i,
		name: n,
		defaultValue: Q(i._formValues, n, Q(i._defaultValues, n, e.defaultValue)),
		exact: !0
	}), c = zE({
		control: i,
		name: n,
		exact: !0
	}), l = V.useRef(e), u = V.useRef(i.register(n, {
		...e.rules,
		value: s,
		...kE(e.disabled) ? { disabled: e.disabled } : {}
	})), d = V.useMemo(() => Object.defineProperties({}, {
		invalid: {
			enumerable: !0,
			get: () => !!Q(c.errors, n)
		},
		isDirty: {
			enumerable: !0,
			get: () => !!Q(c.dirtyFields, n)
		},
		isTouched: {
			enumerable: !0,
			get: () => !!Q(c.touchedFields, n)
		},
		isValidating: {
			enumerable: !0,
			get: () => !!Q(c.validatingFields, n)
		},
		error: {
			enumerable: !0,
			get: () => Q(c.errors, n)
		}
	}), [c, n]), f = V.useCallback((e) => u.current.onChange({
		target: {
			value: xE(e),
			name: n
		},
		type: NE.CHANGE
	}), [n]), p = V.useCallback(() => u.current.onBlur({
		target: {
			value: Q(i._formValues, n),
			name: n
		},
		type: NE.BLUR
	}), [n, i._formValues]), m = V.useCallback((e) => {
		let t = Q(i._fields, n);
		t && e && (t._f.ref = {
			focus: () => e.focus(),
			select: () => e.select(),
			setCustomValidity: (t) => e.setCustomValidity(t),
			reportValidity: () => e.reportValidity()
		});
	}, [i._fields, n]), h = V.useMemo(() => ({
		name: n,
		value: s,
		...kE(r) || c.disabled ? { disabled: c.disabled || r } : {},
		onChange: f,
		onBlur: p,
		ref: m
	}), [
		n,
		r,
		c.disabled,
		f,
		p,
		m,
		s
	]);
	return V.useEffect(() => {
		let e = i._options.shouldUnregister || a;
		i.register(n, {
			...l.current.rules,
			...kE(l.current.disabled) ? { disabled: l.current.disabled } : {}
		});
		let t = (e, t) => {
			let n = Q(i._fields, e);
			n && n._f && (n._f.mount = t);
		};
		if (t(n, !0), e) {
			let e = EE(Q(i._options.defaultValues, n));
			ME(i._defaultValues, n, e), OE(Q(i._formValues, n)) && ME(i._formValues, n, e);
		}
		return !o && i.register(n), () => {
			(o ? e && !i._state.action : e) ? i.unregister(n) : t(n, !1);
		};
	}, [
		n,
		i,
		o,
		a
	]), V.useEffect(() => {
		i._setDisabledField({
			disabled: r,
			name: n
		});
	}, [
		r,
		n,
		i
	]), V.useMemo(() => ({
		field: h,
		formState: c,
		fieldState: d
	}), [
		h,
		c,
		d
	]);
}
var WE = (e, t, n, r, i) => t ? {
	...n[e],
	types: {
		...n[e] && n[e].types ? n[e].types : {},
		[r]: i || !0
	}
} : {}, GE = (e) => Array.isArray(e) ? e : [e], KE = () => {
	let e = [];
	return {
		get observers() {
			return e;
		},
		next: (t) => {
			for (let n of e) n.next && n.next(t);
		},
		subscribe: (t) => (e.push(t), { unsubscribe: () => {
			e = e.filter((e) => e !== t);
		} }),
		unsubscribe: () => {
			e = [];
		}
	};
}, qE = (e) => vE(e) || !yE(e);
function JE(e, t) {
	if (qE(e) || qE(t)) return e === t;
	if (_E(e) && _E(t)) return e.getTime() === t.getTime();
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let i of n) {
		let n = e[i];
		if (!r.includes(i)) return !1;
		if (i !== "ref") {
			let e = t[i];
			if (_E(n) && _E(e) || bE(n) && bE(e) || Array.isArray(n) && Array.isArray(e) ? !JE(n, e) : n !== e) return !1;
		}
	}
	return !0;
}
var YE = (e) => bE(e) && !Object.keys(e).length, XE = (e) => e.type === "file", ZE = (e) => typeof e == "function", QE = (e) => {
	if (!TE) return !1;
	let t = e ? e.ownerDocument : 0;
	return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, $E = (e) => e.type === "select-multiple", eD = (e) => e.type === "radio", tD = (e) => eD(e) || gE(e), nD = (e) => QE(e) && e.isConnected;
function rD(e, t) {
	let n = t.slice(0, -1).length, r = 0;
	for (; r < n;) e = OE(e) ? r++ : e[t[r++]];
	return e;
}
function iD(e) {
	for (let t in e) if (e.hasOwnProperty(t) && !OE(e[t])) return !1;
	return !0;
}
function aD(e, t) {
	let n = Array.isArray(t) ? t : AE(t) ? [t] : jE(t), r = n.length === 1 ? e : rD(e, n), i = n.length - 1, a = n[i];
	return r && delete r[a], i !== 0 && (bE(r) && YE(r) || Array.isArray(r) && iD(r)) && aD(e, n.slice(0, -1)), e;
}
var oD = (e) => {
	for (let t in e) if (ZE(e[t])) return !0;
	return !1;
};
function sD(e, t = {}) {
	let n = Array.isArray(e);
	if (bE(e) || n) for (let n in e) Array.isArray(e[n]) || bE(e[n]) && !oD(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, sD(e[n], t[n])) : vE(e[n]) || (t[n] = !0);
	return t;
}
function cD(e, t, n) {
	let r = Array.isArray(e);
	if (bE(e) || r) for (let r in e) Array.isArray(e[r]) || bE(e[r]) && !oD(e[r]) ? OE(t) || qE(n[r]) ? n[r] = Array.isArray(e[r]) ? sD(e[r], []) : { ...sD(e[r]) } : cD(e[r], vE(t) ? {} : t[r], n[r]) : n[r] = !JE(e[r], t[r]);
	return n;
}
var lD = (e, t) => cD(e, t, sD(t)), uD = {
	value: !1,
	isValid: !1
}, dD = {
	value: !0,
	isValid: !0
}, fD = (e) => {
	if (Array.isArray(e)) {
		if (e.length > 1) {
			let t = e.filter((e) => e && e.checked && !e.disabled).map((e) => e.value);
			return {
				value: t,
				isValid: !!t.length
			};
		}
		return e[0].checked && !e[0].disabled ? e[0].attributes && !OE(e[0].attributes.value) ? OE(e[0].value) || e[0].value === "" ? dD : {
			value: e[0].value,
			isValid: !0
		} : dD : uD;
	}
	return uD;
}, pD = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => OE(e) ? e : t ? e === "" ? NaN : e && +e : n && BE(e) ? new Date(e) : r ? r(e) : e, mD = {
	isValid: !1,
	value: null
}, hD = (e) => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
	isValid: !0,
	value: t.value
} : e, mD) : mD;
function gD(e) {
	let t = e.ref;
	return XE(t) ? t.files : eD(t) ? hD(e.refs).value : $E(t) ? [...t.selectedOptions].map(({ value: e }) => e) : gE(t) ? fD(e.refs).value : pD(OE(t.value) ? e.ref.value : t.value, e);
}
var _D = (e, t, n, r) => {
	let i = {};
	for (let n of e) {
		let e = Q(t, n);
		e && ME(i, n, e._f);
	}
	return {
		criteriaMode: n,
		names: [...e],
		fields: i,
		shouldUseNativeValidation: r
	};
}, vD = (e) => e instanceof RegExp, yD = (e) => OE(e) ? e : vD(e) ? e.source : bE(e) ? vD(e.value) ? e.value.source : e.value : e, bD = (e) => ({
	isOnSubmit: !e || e === PE.onSubmit,
	isOnBlur: e === PE.onBlur,
	isOnChange: e === PE.onChange,
	isOnAll: e === PE.all,
	isOnTouch: e === PE.onTouched
}), xD = "AsyncFunction", SD = (e) => !!e && !!e.validate && !!(ZE(e.validate) && e.validate.constructor.name === xD || bE(e.validate) && Object.values(e.validate).find((e) => e.constructor.name === xD)), CD = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), wD = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((t) => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))), TD = (e, t, n, r) => {
	for (let i of n || Object.keys(e)) {
		let n = Q(e, i);
		if (n) {
			let { _f: e, ...a } = n;
			if (e) {
				if (e.refs && e.refs[0] && t(e.refs[0], i) && !r || e.ref && t(e.ref, e.name) && !r) return !0;
				if (TD(a, t)) break;
			} else if (bE(a) && TD(a, t)) break;
		}
	}
};
function ED(e, t, n) {
	let r = Q(e, n);
	if (r || AE(n)) return {
		error: r,
		name: n
	};
	let i = n.split(".");
	for (; i.length;) {
		let r = i.join("."), a = Q(t, r), o = Q(e, r);
		if (a && !Array.isArray(a) && n !== r) return { name: n };
		if (o && o.type) return {
			name: r,
			error: o
		};
		i.pop();
	}
	return { name: n };
}
var DD = (e, t, n, r) => {
	n(e);
	let { name: i, ...a } = e;
	return YE(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((e) => t[e] === (!r || PE.all));
}, OD = (e, t, n) => !e || !t || e === t || GE(e).some((e) => e && (n ? e === t : e.startsWith(t) || t.startsWith(e))), kD = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, AD = (e, t) => !DE(Q(e, t)).length && aD(e, t), jD = (e, t, n) => {
	let r = GE(Q(e, n));
	return ME(r, "root", t[n]), ME(e, n, r), e;
}, MD = (e) => BE(e);
function ND(e, t, n = "validate") {
	if (MD(e) || Array.isArray(e) && e.every(MD) || kE(e) && !e) return {
		type: n,
		message: MD(e) ? e : "",
		ref: t
	};
}
var PD = (e) => bE(e) && !vD(e) ? e : {
	value: e,
	message: ""
}, FD = async (e, t, n, r, i, a) => {
	let { ref: o, refs: s, required: c, maxLength: l, minLength: u, min: d, max: f, pattern: p, validate: m, name: h, valueAsNumber: g, mount: _ } = e._f, v = Q(n, h);
	if (!_ || t.has(h)) return {};
	let y = s ? s[0] : o, b = (e) => {
		i && y.reportValidity && (y.setCustomValidity(kE(e) ? "" : e || ""), y.reportValidity());
	}, x = {}, S = eD(o), C = gE(o), w = S || C, T = (g || XE(o)) && OE(o.value) && OE(v) || QE(o) && o.value === "" || v === "" || Array.isArray(v) && !v.length, E = WE.bind(null, h, r, x), D = (e, t, n, r = FE.maxLength, i = FE.minLength) => {
		let a = e ? t : n;
		x[h] = {
			type: e ? r : i,
			message: a,
			ref: o,
			...E(e ? r : i, a)
		};
	};
	if (a ? !Array.isArray(v) || !v.length : c && (!w && (T || vE(v)) || kE(v) && !v || C && !fD(s).isValid || S && !hD(s).isValid)) {
		let { value: e, message: t } = MD(c) ? {
			value: !!c,
			message: c
		} : PD(c);
		if (e && (x[h] = {
			type: FE.required,
			message: t,
			ref: y,
			...E(FE.required, t)
		}, !r)) return b(t), x;
	}
	if (!T && (!vE(d) || !vE(f))) {
		let e, t, n = PD(f), i = PD(d);
		if (!vE(v) && !isNaN(v)) {
			let r = o.valueAsNumber || v && +v;
			vE(n.value) || (e = r > n.value), vE(i.value) || (t = r < i.value);
		} else {
			let r = o.valueAsDate || new Date(v), a = (e) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + e), s = o.type == "time", c = o.type == "week";
			BE(n.value) && v && (e = s ? a(v) > a(n.value) : c ? v > n.value : r > new Date(n.value)), BE(i.value) && v && (t = s ? a(v) < a(i.value) : c ? v < i.value : r < new Date(i.value));
		}
		if ((e || t) && (D(!!e, n.message, i.message, FE.max, FE.min), !r)) return b(x[h].message), x;
	}
	if ((l || u) && !T && (BE(v) || a && Array.isArray(v))) {
		let e = PD(l), t = PD(u), n = !vE(e.value) && v.length > +e.value, i = !vE(t.value) && v.length < +t.value;
		if ((n || i) && (D(n, e.message, t.message), !r)) return b(x[h].message), x;
	}
	if (p && !T && BE(v)) {
		let { value: e, message: t } = PD(p);
		if (vD(e) && !v.match(e) && (x[h] = {
			type: FE.pattern,
			message: t,
			ref: o,
			...E(FE.pattern, t)
		}, !r)) return b(t), x;
	}
	if (m) {
		if (ZE(m)) {
			let e = ND(await m(v, n), y);
			if (e && (x[h] = {
				...e,
				...E(FE.validate, e.message)
			}, !r)) return b(e.message), x;
		} else if (bE(m)) {
			let e = {};
			for (let t in m) {
				if (!YE(e) && !r) break;
				let i = ND(await m[t](v, n), y, t);
				i && (e = {
					...i,
					...E(t, i.message)
				}, b(i.message), r && (x[h] = e));
			}
			if (!YE(e) && (x[h] = {
				ref: y,
				...e
			}, !r)) return x;
		}
	}
	return b(!0), x;
}, ID = {
	mode: PE.onSubmit,
	reValidateMode: PE.onChange,
	shouldFocusError: !0
};
function LD(e = {}) {
	let t = {
		...ID,
		...e
	}, n = {
		submitCount: 0,
		isDirty: !1,
		isLoading: ZE(t.defaultValues),
		isValidating: !1,
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		touchedFields: {},
		dirtyFields: {},
		validatingFields: {},
		errors: t.errors || {},
		disabled: t.disabled || !1
	}, r = {}, i = (bE(t.defaultValues) || bE(t.values)) && EE(t.values || t.defaultValues) || {}, a = t.shouldUnregister ? {} : EE(i), o = {
		action: !1,
		mount: !1,
		watch: !1
	}, s = {
		mount: /* @__PURE__ */ new Set(),
		disabled: /* @__PURE__ */ new Set(),
		unMount: /* @__PURE__ */ new Set(),
		array: /* @__PURE__ */ new Set(),
		watch: /* @__PURE__ */ new Set()
	}, c, l = 0, u = {
		isDirty: !1,
		dirtyFields: !1,
		validatingFields: !1,
		touchedFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}, d = { ...u }, f = {
		array: KE(),
		state: KE()
	}, p = bD(t.mode), m = bD(t.reValidateMode), h = t.criteriaMode === PE.all, g = (e) => (t) => {
		clearTimeout(l), l = setTimeout(e, t);
	}, _ = async (e) => {
		if (!t.disabled && (u.isValid || d.isValid || e)) {
			let e = t.resolver ? YE((await T()).errors) : await D(r, !0);
			e !== n.isValid && f.state.next({ isValid: e });
		}
	}, v = (e, r) => {
		!t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((e || Array.from(s.mount)).forEach((e) => {
			e && (r ? ME(n.validatingFields, e, r) : aD(n.validatingFields, e));
		}), f.state.next({
			validatingFields: n.validatingFields,
			isValidating: !YE(n.validatingFields)
		}));
	}, y = (e, s = [], c, l, p = !0, m = !0) => {
		if (l && c && !t.disabled) {
			if (o.action = !0, m && Array.isArray(Q(r, e))) {
				let t = c(Q(r, e), l.argA, l.argB);
				p && ME(r, e, t);
			}
			if (m && Array.isArray(Q(n.errors, e))) {
				let t = c(Q(n.errors, e), l.argA, l.argB);
				p && ME(n.errors, e, t), AD(n.errors, e);
			}
			if ((u.touchedFields || d.touchedFields) && m && Array.isArray(Q(n.touchedFields, e))) {
				let t = c(Q(n.touchedFields, e), l.argA, l.argB);
				p && ME(n.touchedFields, e, t);
			}
			(u.dirtyFields || d.dirtyFields) && (n.dirtyFields = lD(i, a)), f.state.next({
				name: e,
				isDirty: k(e, s),
				dirtyFields: n.dirtyFields,
				errors: n.errors,
				isValid: n.isValid
			});
		} else ME(a, e, s);
	}, b = (e, t) => {
		ME(n.errors, e, t), f.state.next({ errors: n.errors });
	}, x = (e) => {
		n.errors = e, f.state.next({
			errors: n.errors,
			isValid: !1
		});
	}, S = (e, t, n, s) => {
		let c = Q(r, e);
		if (c) {
			let r = Q(a, e, OE(n) ? Q(i, e) : n);
			OE(r) || s && s.defaultChecked || t ? ME(a, e, t ? r : gD(c._f)) : M(e, r), o.mount && _();
		}
	}, C = (e, r, a, o, s) => {
		let c = !1, l = !1, p = { name: e };
		if (!t.disabled) {
			if (!a || o) {
				(u.isDirty || d.isDirty) && (l = n.isDirty, n.isDirty = p.isDirty = k(), c = l !== p.isDirty);
				let t = JE(Q(i, e), r);
				l = !!Q(n.dirtyFields, e), t ? aD(n.dirtyFields, e) : ME(n.dirtyFields, e, !0), p.dirtyFields = n.dirtyFields, c ||= (u.dirtyFields || d.dirtyFields) && l !== !t;
			}
			if (a) {
				let t = Q(n.touchedFields, e);
				t || (ME(n.touchedFields, e, a), p.touchedFields = n.touchedFields, c ||= (u.touchedFields || d.touchedFields) && t !== a);
			}
			c && s && f.state.next(p);
		}
		return c ? p : {};
	}, w = (e, r, i, a) => {
		let o = Q(n.errors, e), s = (u.isValid || d.isValid) && kE(r) && n.isValid !== r;
		if (t.delayError && i ? (c = g(() => b(e, i)), c(t.delayError)) : (clearTimeout(l), c = null, i ? ME(n.errors, e, i) : aD(n.errors, e)), (i ? !JE(o, i) : o) || !YE(a) || s) {
			let t = {
				...a,
				...s && kE(r) ? { isValid: r } : {},
				errors: n.errors,
				name: e
			};
			n = {
				...n,
				...t
			}, f.state.next(t);
		}
	}, T = async (e) => {
		v(e, !0);
		let n = await t.resolver(a, t.context, _D(e || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
		return v(e), n;
	}, E = async (e) => {
		let { errors: t } = await T(e);
		if (e) for (let r of e) {
			let e = Q(t, r);
			e ? ME(n.errors, r, e) : aD(n.errors, r);
		}
		else n.errors = t;
		return t;
	}, D = async (e, r, i = { valid: !0 }) => {
		for (let o in e) {
			let c = e[o];
			if (c) {
				let { _f: e, ...l } = c;
				if (e) {
					let l = s.array.has(e.name), d = c._f && SD(c._f);
					d && u.validatingFields && v([o], !0);
					let f = await FD(c, s.disabled, a, h, t.shouldUseNativeValidation && !r, l);
					if (d && u.validatingFields && v([o]), f[e.name] && (i.valid = !1, r)) break;
					!r && (Q(f, e.name) ? l ? jD(n.errors, f, e.name) : ME(n.errors, e.name, f[e.name]) : aD(n.errors, e.name));
				}
				!YE(l) && await D(l, r, i);
			}
		}
		return i.valid;
	}, O = () => {
		for (let e of s.unMount) {
			let t = Q(r, e);
			t && (t._f.refs ? t._f.refs.every((e) => !nD(e)) : !nD(t._f.ref)) && z(e);
		}
		s.unMount = /* @__PURE__ */ new Set();
	}, k = (e, n) => !t.disabled && (e && n && ME(a, e, n), !JE(te(), i)), A = (e, t, n) => VE(e, s, { ...o.mount ? a : OE(t) ? i : BE(e) ? { [e]: t } : t }, n, t), j = (e) => DE(Q(o.mount ? a : i, e, t.shouldUnregister ? Q(i, e, []) : [])), M = (e, t, n = {}) => {
		let i = Q(r, e), o = t;
		if (i) {
			let n = i._f;
			n && (!n.disabled && ME(a, e, pD(t, n)), o = QE(n.ref) && vE(t) ? "" : t, $E(n.ref) ? [...n.ref.options].forEach((e) => e.selected = o.includes(e.value)) : n.refs ? gE(n.ref) ? n.refs.length > 1 ? n.refs.forEach((e) => (!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(o) ? !!o.find((t) => t === e.value) : o === e.value)) : n.refs[0] && (n.refs[0].checked = !!o) : n.refs.forEach((e) => e.checked = e.value === o) : XE(n.ref) ? n.ref.value = "" : (n.ref.value = o, n.ref.type || f.state.next({
				name: e,
				values: EE(a)
			})));
		}
		(n.shouldDirty || n.shouldTouch) && C(e, o, n.shouldTouch, n.shouldDirty, !0), n.shouldValidate && I(e);
	}, N = (e, t, n) => {
		for (let i in t) {
			let a = t[i], o = `${e}.${i}`, c = Q(r, o);
			(s.array.has(e) || bE(a) || c && !c._f) && !_E(a) ? N(o, a, n) : M(o, a, n);
		}
	}, P = (e, t, c = {}) => {
		let l = Q(r, e), p = s.array.has(e), m = EE(t);
		ME(a, e, m), p ? (f.array.next({
			name: e,
			values: EE(a)
		}), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && c.shouldDirty && f.state.next({
			name: e,
			dirtyFields: lD(i, a),
			isDirty: k(e, m)
		})) : l && !l._f && !vE(m) ? N(e, m, c) : M(e, m, c), wD(e, s) && f.state.next({ ...n }), f.state.next({
			name: o.mount ? e : void 0,
			values: EE(a)
		});
	}, ee = async (e) => {
		o.mount = !0;
		let i = e.target, l = i.name, g = !0, y = Q(r, l), b = (e) => {
			g = Number.isNaN(e) || _E(e) && isNaN(e.getTime()) || JE(e, Q(a, l, e));
		};
		if (y) {
			let o, x, S = i.type ? gD(y._f) : xE(e), E = e.type === NE.BLUR || e.type === NE.FOCUS_OUT, O = !CD(y._f) && !t.resolver && !Q(n.errors, l) && !y._f.deps || kD(E, Q(n.touchedFields, l), n.isSubmitted, m, p), k = wD(l, s, E);
			ME(a, l, S), E ? (y._f.onBlur && y._f.onBlur(e), c && c(0)) : y._f.onChange && y._f.onChange(e);
			let A = C(l, S, E), j = !YE(A) || k;
			if (!E && f.state.next({
				name: l,
				type: e.type,
				values: EE(a)
			}), O) return (u.isValid || d.isValid) && (t.mode === "onBlur" ? E && _() : E || _()), j && f.state.next({
				name: l,
				...k ? {} : A
			});
			if (!E && k && f.state.next({ ...n }), t.resolver) {
				let { errors: e } = await T([l]);
				if (b(S), g) {
					let t = ED(n.errors, r, l), i = ED(e, r, t.name || l);
					o = i.error, l = i.name, x = YE(e);
				}
			} else v([l], !0), o = (await FD(y, s.disabled, a, h, t.shouldUseNativeValidation))[l], v([l]), b(S), g && (o ? x = !1 : (u.isValid || d.isValid) && (x = await D(r, !0)));
			g && (y._f.deps && I(y._f.deps), w(l, x, o, A));
		}
	}, F = (e, t) => {
		if (Q(n.errors, t) && e.focus) return e.focus(), 1;
	}, I = async (e, i = {}) => {
		let a, o, c = GE(e);
		if (t.resolver) {
			let t = await E(OE(e) ? e : c);
			a = YE(t), o = e ? !c.some((e) => Q(t, e)) : a;
		} else e ? (o = (await Promise.all(c.map(async (e) => {
			let t = Q(r, e);
			return await D(t && t._f ? { [e]: t } : t);
		}))).every(Boolean), !(!o && !n.isValid) && _()) : o = a = await D(r);
		return f.state.next({
			...!BE(e) || (u.isValid || d.isValid) && a !== n.isValid ? {} : { name: e },
			...t.resolver || !e ? { isValid: a } : {},
			errors: n.errors
		}), i.shouldFocus && !o && TD(r, F, e ? c : s.mount), o;
	}, te = (e) => {
		let t = { ...o.mount ? a : i };
		return OE(e) ? t : BE(e) ? Q(t, e) : e.map((e) => Q(t, e));
	}, L = (e, t) => ({
		invalid: !!Q((t || n).errors, e),
		isDirty: !!Q((t || n).dirtyFields, e),
		error: Q((t || n).errors, e),
		isValidating: !!Q(n.validatingFields, e),
		isTouched: !!Q((t || n).touchedFields, e)
	}), ne = (e) => {
		e && GE(e).forEach((e) => aD(n.errors, e)), f.state.next({ errors: e ? n.errors : {} });
	}, re = (e, t, i) => {
		let a = (Q(r, e, { _f: {} })._f || {}).ref, { ref: o, message: s, type: c, ...l } = Q(n.errors, e) || {};
		ME(n.errors, e, {
			...l,
			...t,
			ref: a
		}), f.state.next({
			name: e,
			errors: n.errors,
			isValid: !1
		}), i && i.shouldFocus && a && a.focus && a.focus();
	}, ie = (e, t) => ZE(e) ? f.state.subscribe({ next: (n) => e(A(void 0, t), n) }) : A(e, t, !0), R = (e) => f.state.subscribe({ next: (t) => {
		OD(e.name, t.name, e.exact) && DD(t, e.formState || u, he, e.reRenderRoot) && e.callback({
			values: { ...a },
			...n,
			...t
		});
	} }).unsubscribe, ae = (e) => (o.mount = !0, d = {
		...d,
		...e.formState
	}, R({
		...e,
		formState: d
	})), z = (e, o = {}) => {
		for (let c of e ? GE(e) : s.mount) s.mount.delete(c), s.array.delete(c), o.keepValue || (aD(r, c), aD(a, c)), !o.keepError && aD(n.errors, c), !o.keepDirty && aD(n.dirtyFields, c), !o.keepTouched && aD(n.touchedFields, c), !o.keepIsValidating && aD(n.validatingFields, c), !t.shouldUnregister && !o.keepDefaultValue && aD(i, c);
		f.state.next({ values: EE(a) }), f.state.next({
			...n,
			...o.keepDirty ? { isDirty: k() } : {}
		}), !o.keepIsValid && _();
	}, oe = ({ disabled: e, name: t }) => {
		(kE(e) && o.mount || e || s.disabled.has(t)) && (e ? s.disabled.add(t) : s.disabled.delete(t));
	}, se = (e, n = {}) => {
		let a = Q(r, e), c = kE(n.disabled) || kE(t.disabled);
		return ME(r, e, {
			...a || {},
			_f: {
				...a && a._f ? a._f : { ref: { name: e } },
				name: e,
				mount: !0,
				...n
			}
		}), s.mount.add(e), a ? oe({
			disabled: kE(n.disabled) ? n.disabled : t.disabled,
			name: e
		}) : S(e, !0, n.value), {
			...c ? { disabled: n.disabled || t.disabled } : {},
			...t.progressive ? {
				required: !!n.required,
				min: yD(n.min),
				max: yD(n.max),
				minLength: yD(n.minLength),
				maxLength: yD(n.maxLength),
				pattern: yD(n.pattern)
			} : {},
			name: e,
			onChange: ee,
			onBlur: ee,
			ref: (c) => {
				if (c) {
					se(e, n), a = Q(r, e);
					let t = OE(c.value) && c.querySelectorAll && c.querySelectorAll("input,select,textarea")[0] || c, o = tD(t), s = a._f.refs || [];
					if (o ? s.find((e) => e === t) : t === a._f.ref) return;
					ME(r, e, { _f: {
						...a._f,
						...o ? {
							refs: [
								...s.filter(nD),
								t,
								...Array.isArray(Q(i, e)) ? [{}] : []
							],
							ref: {
								type: t.type,
								name: e
							}
						} : { ref: t }
					} }), S(e, !1, void 0, t);
				} else a = Q(r, e, {}), a._f && (a._f.mount = !1), (t.shouldUnregister || n.shouldUnregister) && !(CE(s.array, e) && o.action) && s.unMount.add(e);
			}
		};
	}, ce = () => t.shouldFocusError && TD(r, F, s.mount), le = (e) => {
		kE(e) && (f.state.next({ disabled: e }), TD(r, (t, n) => {
			let i = Q(r, n);
			i && (t.disabled = i._f.disabled || e, Array.isArray(i._f.refs) && i._f.refs.forEach((t) => {
				t.disabled = i._f.disabled || e;
			}));
		}, 0, !1));
	}, ue = (e, i) => async (o) => {
		let c;
		o && (o.preventDefault && o.preventDefault(), o.persist && o.persist());
		let l = EE(a);
		if (f.state.next({ isSubmitting: !0 }), t.resolver) {
			let { errors: e, values: t } = await T();
			n.errors = e, l = t;
		} else await D(r);
		if (s.disabled.size) for (let e of s.disabled) ME(l, e, void 0);
		if (aD(n.errors, "root"), YE(n.errors)) {
			f.state.next({ errors: {} });
			try {
				await e(l, o);
			} catch (e) {
				c = e;
			}
		} else i && await i({ ...n.errors }, o), ce(), setTimeout(ce);
		if (f.state.next({
			isSubmitted: !0,
			isSubmitting: !1,
			isSubmitSuccessful: YE(n.errors) && !c,
			submitCount: n.submitCount + 1,
			errors: n.errors
		}), c) throw c;
	}, de = (e, t = {}) => {
		Q(r, e) && (OE(t.defaultValue) ? P(e, EE(Q(i, e))) : (P(e, t.defaultValue), ME(i, e, EE(t.defaultValue))), t.keepTouched || aD(n.touchedFields, e), t.keepDirty || (aD(n.dirtyFields, e), n.isDirty = t.defaultValue ? k(e, EE(Q(i, e))) : k()), t.keepError || (aD(n.errors, e), u.isValid && _()), f.state.next({ ...n }));
	}, fe = (e, c = {}) => {
		let l = e ? EE(e) : i, d = EE(l), p = YE(e), m = p ? i : d;
		if (c.keepDefaultValues || (i = l), !c.keepValues) {
			if (c.keepDirtyValues) {
				let e = /* @__PURE__ */ new Set([...s.mount, ...Object.keys(lD(i, a))]);
				for (let t of Array.from(e)) Q(n.dirtyFields, t) ? ME(m, t, Q(a, t)) : P(t, Q(m, t));
			} else {
				if (TE && OE(e)) for (let e of s.mount) {
					let t = Q(r, e);
					if (t && t._f) {
						let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
						if (QE(e)) {
							let t = e.closest("form");
							if (t) {
								t.reset();
								break;
							}
						}
					}
				}
				for (let e of s.mount) P(e, Q(m, e));
			}
			a = EE(m), f.array.next({ values: { ...m } }), f.state.next({ values: { ...m } });
		}
		s = {
			mount: c.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
			unMount: /* @__PURE__ */ new Set(),
			array: /* @__PURE__ */ new Set(),
			disabled: /* @__PURE__ */ new Set(),
			watch: /* @__PURE__ */ new Set(),
			watchAll: !1,
			focus: ""
		}, o.mount = !u.isValid || !!c.keepIsValid || !!c.keepDirtyValues, o.watch = !!t.shouldUnregister, f.state.next({
			submitCount: c.keepSubmitCount ? n.submitCount : 0,
			isDirty: p ? !1 : c.keepDirty ? n.isDirty : !!(c.keepDefaultValues && !JE(e, i)),
			isSubmitted: c.keepIsSubmitted ? n.isSubmitted : !1,
			dirtyFields: p ? {} : c.keepDirtyValues ? c.keepDefaultValues && a ? lD(i, a) : n.dirtyFields : c.keepDefaultValues && e ? lD(i, e) : c.keepDirty ? n.dirtyFields : {},
			touchedFields: c.keepTouched ? n.touchedFields : {},
			errors: c.keepErrors ? n.errors : {},
			isSubmitSuccessful: c.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
			isSubmitting: !1
		});
	}, pe = (e, t) => fe(ZE(e) ? e(a) : e, t), me = (e, t = {}) => {
		let n = Q(r, e), i = n && n._f;
		if (i) {
			let e = i.refs ? i.refs[0] : i.ref;
			e.focus && (e.focus(), t.shouldSelect && ZE(e.select) && e.select());
		}
	}, he = (e) => {
		n = {
			...n,
			...e
		};
	}, ge = {
		control: {
			register: se,
			unregister: z,
			getFieldState: L,
			handleSubmit: ue,
			setError: re,
			_subscribe: R,
			_runSchema: T,
			_getWatch: A,
			_getDirty: k,
			_setValid: _,
			_setFieldArray: y,
			_setDisabledField: oe,
			_setErrors: x,
			_getFieldArray: j,
			_reset: fe,
			_resetDefaultValues: () => ZE(t.defaultValues) && t.defaultValues().then((e) => {
				pe(e, t.resetOptions), f.state.next({ isLoading: !1 });
			}),
			_removeUnmounted: O,
			_disableForm: le,
			_subjects: f,
			_proxyFormState: u,
			get _fields() {
				return r;
			},
			get _formValues() {
				return a;
			},
			get _state() {
				return o;
			},
			set _state(e) {
				o = e;
			},
			get _defaultValues() {
				return i;
			},
			get _names() {
				return s;
			},
			set _names(e) {
				s = e;
			},
			get _formState() {
				return n;
			},
			get _options() {
				return t;
			},
			set _options(e) {
				t = {
					...t,
					...e
				};
			}
		},
		subscribe: ae,
		trigger: I,
		register: se,
		handleSubmit: ue,
		watch: ie,
		setValue: P,
		getValues: te,
		reset: pe,
		resetField: de,
		clearErrors: ne,
		unregister: z,
		setError: re,
		setFocus: me,
		getFieldState: L
	};
	return {
		...ge,
		formControl: ge
	};
}
function RD(e = {}) {
	let t = V.useRef(void 0), n = V.useRef(void 0), [r, i] = V.useState({
		isDirty: !1,
		isValidating: !1,
		isLoading: ZE(e.defaultValues),
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		submitCount: 0,
		dirtyFields: {},
		touchedFields: {},
		validatingFields: {},
		errors: e.errors || {},
		disabled: e.disabled || !1,
		defaultValues: ZE(e.defaultValues) ? void 0 : e.defaultValues
	});
	t.current || (t.current = {
		...e.formControl ? e.formControl : LD(e),
		formState: r
	}, e.formControl && e.defaultValues && !ZE(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
	let a = t.current.control;
	return a._options = e, V.useLayoutEffect(() => a._subscribe({
		formState: a._proxyFormState,
		callback: () => i({ ...a._formState }),
		reRenderRoot: !0
	}), [a]), V.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), V.useEffect(() => {
		if (a._proxyFormState.isDirty) {
			let e = a._getDirty();
			e !== r.isDirty && a._subjects.state.next({ isDirty: e });
		}
	}, [a, r.isDirty]), V.useEffect(() => {
		e.values && !JE(e.values, n.current) ? (a._reset(e.values, a._options.resetOptions), n.current = e.values, i((e) => ({ ...e }))) : a._resetDefaultValues();
	}, [e.values, a]), V.useEffect(() => {
		e.errors && !YE(e.errors) && a._setErrors(e.errors);
	}, [e.errors, a]), V.useEffect(() => {
		a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
	}), V.useEffect(() => {
		e.shouldUnregister && a._subjects.state.next({ values: a._getWatch() });
	}, [e.shouldUnregister, a]), t.current.formState = RE(r, a), t.current;
}
var zD = _l;
function BD(e) {
	return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var VD = hE, HD = [
	"control",
	"defaultValue",
	"name",
	"rules",
	"shouldUnregister"
];
function UD(e) {
	let t = VD(e, HD);
	return {
		controller: UE(t),
		controllerProps: t
	};
}
var WD = [
	"className",
	"description",
	"disabled",
	"helpIcon",
	"label",
	"noAlert",
	"noLabel",
	"style"
];
function GD(e) {
	let { controller: t, controllerProps: n } = UD(e);
	return {
		controller: t,
		controllerProps: n,
		fieldWrapperProps: {
			...VD(e, WD),
			required: BD(n.rules?.required),
			meta: {
				touched: t.fieldState.isTouched,
				error: t.fieldState.error?.message,
				success: e.meta?.success,
				warning: e.meta?.warning
			},
			labelFor: n.name,
			noLabel: e.noLabel,
			noAlert: e.noAlert
		}
	};
}
var KD = zD, qD = ({ transformValue: e = KD, label: t, helpIcon: n, className: r, ...i }) => {
	let { controller: { field: a }, controllerProps: { name: o } } = UD(i);
	return /* @__PURE__ */ K(v, {
		gap: "200",
		alignItems: "center",
		className: r,
		children: [/* @__PURE__ */ G(ee, {
			...a,
			id: o,
			checked: e(a.value),
			disabled: i.componentProps?.disabled,
			onChange: (t) => {
				i.componentProps?.onChange?.(t), a.onChange(e(t.target.checked));
			}
		}), t && /* @__PURE__ */ G(p, {
			htmlFor: o,
			helpIcon: n,
			children: t
		})]
	});
}, JD = (e) => {
	let { controller: t, controllerProps: n, fieldWrapperProps: r } = GD(e);
	return /* @__PURE__ */ G(_, {
		...r,
		children: /* @__PURE__ */ G(T, {
			...e.componentProps,
			...t.field,
			value: e.componentProps?.type === "number" && isNaN(t.field.value) ? "" : t.field.value ?? "",
			onBlur: (n) => {
				e.componentProps?.onBlur?.(n), t.field.onBlur();
			},
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(e.componentProps?.type === "number" ? n.target.valueAsNumber : n);
			},
			id: n.name,
			"aria-disabled": r.disabled,
			disabled: r.disabled,
			"aria-required": r.required,
			required: r.required,
			status: _.getStatus(r.meta)
		})
	});
}, YD = [
	{
		key: "rivoLoyaltyApiKey",
		label: "API key",
		defaultValue: "",
		secret: !0,
		type: "string"
	},
	{
		key: GT,
		label: "Shopify API host name",
		defaultValue: "",
		secret: !1,
		type: "string"
	},
	{
		key: "rivoLoyaltyShowOrders",
		label: "Show orders overview",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyShowLoyalty",
		label: "Show loyalty",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyAdjustLoyaltyPoints",
		label: "Allow adjusting loyalty points",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyShowFavoriteProducts",
		label: "Show favorite products",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	},
	{
		key: "rivoLoyaltyShowPointsRedemptions",
		label: "Show available rewards",
		defaultValue: !0,
		secret: !1,
		type: "boolean"
	}
], XD = Pe(YD), ZD = "RIVOLOYALTY", QD = "Rivo Loyalty", $D = {
	enabled: !1,
	name: "",
	rivoLoyaltyApiKey: "",
	[GT]: "",
	rivoLoyaltyShowOrders: !0,
	rivoLoyaltyShowLoyalty: !0,
	rivoLoyaltyAdjustLoyaltyPoints: !0,
	rivoLoyaltyShowFavoriteProducts: !0,
	rivoLoyaltyShowPointsRedemptions: !0
}, eO = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r }) => {
	let i = !e, a = RD({
		mode: "onChange",
		defaultValues: $D
	}), { create: o, update: s, remove: c, isLoading: l, error: u, misconfigurationCause: d, setMisconfigurationCause: f } = He({
		integrationId: e,
		integrationType: ZD,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: p, error: m, isWidgetUnknown: h, refetch: g } = Ue({
		integrationId: e,
		fieldDefinitions: YD,
		form: a,
		onMisconfigured: f
	}), S = (e) => ye(e, {
		fieldDefinitions: YD,
		isCreationMode: i,
		create: o,
		update: s
	}), C = a.watch("name");
	return /* @__PURE__ */ K(de, {
		form: a,
		integrationId: e,
		onValidSubmit: S,
		error: m ?? u,
		onRetry: m ? g : void 0,
		isLoading: l || p,
		isWidgetUnknown: h,
		children: [
			d && /* @__PURE__ */ G(se, { cause: d }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(qD, {
						name: "enabled",
						control: a.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(JD, {
						name: "name",
						label: "Widget name",
						control: a.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(JD, {
						name: "rivoLoyaltyShopifyApiHostName",
						label: XD[GT],
						control: a.control,
						rules: {
							required: "Shopify API host name is required",
							validate: (e) => We(e) ?? void 0
						},
						componentProps: {
							placeholder: "Host name of your Shopify shop, e.g. \"my-webshop.myshopify.com\"",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "rivoLoyaltyApiKey",
						label: XD.rivoLoyaltyApiKey,
						control: a.control,
						isCreationMode: i,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "Insert your Rivo API key",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: XD.rivoLoyaltyShowOrders,
						children: /* @__PURE__ */ G(qD, {
							name: "rivoLoyaltyShowOrders",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: XD.rivoLoyaltyShowLoyalty,
						children: /* @__PURE__ */ G(qD, {
							name: "rivoLoyaltyShowLoyalty",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: XD.rivoLoyaltyAdjustLoyaltyPoints,
						children: /* @__PURE__ */ G(qD, {
							name: "rivoLoyaltyAdjustLoyaltyPoints",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: XD.rivoLoyaltyShowFavoriteProducts,
						children: /* @__PURE__ */ G(qD, {
							name: "rivoLoyaltyShowFavoriteProducts",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: XD.rivoLoyaltyShowPointsRedemptions,
						children: /* @__PURE__ */ G(qD, {
							name: "rivoLoyaltyShowPointsRedemptions",
							control: a.control
						})
					})
				})
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: ZD,
				integrationId: e,
				widgetName: C,
				isCreationMode: i,
				isSubmitting: a.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => c(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ K(v, {
					gap: "400",
					children: [/* @__PURE__ */ G(x, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ K(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									QD,
									" integration, all links between Dixa and ",
									QD,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"All data in ",
								QD,
								" stays untouched."
							] }),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								QD,
								" ",
								"integration \"",
								C,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-shopify/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_eygw8_1{width:400px}._channelRow_15phg_1{width:100%}._editIcon_1dntr_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._dropdown_7zjgt_1{max-height:300px;overflow-y:auto}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{white-space:nowrap;overflow:hidden}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var tO = "__PairingContext__", nO = globalThis[tO] ?? (() => {
	let e = Ke({});
	return globalThis[tO] = e, e;
})(), rO = () => Xe(nO), iO = {
	banner: "_banner_d9pot_1",
	list: "_list_d9pot_8"
}, aO = "https://apps.shopify.com/dixa-dashboard", oO = {
	install: {
		description: "Connect your Shopify store to Dixa with just a few clicks.",
		listHeading: "How it works:",
		listType: "ol",
		listItems: [
			"Click \"Install Dixa app in Shopify\" below to start the connection",
			"You'll be redirected to the Shopify App Store to install the Dixa app",
			"After installing, open the Dixa app in your Shopify admin and click \"Connect to Dixa\"",
			"The connection is approved automatically for the next 10 minutes, no extra sign-in or approval click needed",
			"Return to the Settings > Integrations overview to see your newly connected Shopify integration"
		],
		buttonText: "Install Dixa app in Shopify",
		buttonVariant: "primary"
	},
	migration: {
		description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
		listHeading: "Benefits of upgrading:",
		listType: "ul",
		listItems: [
			"No need to manage Client ID and Client Secret",
			"Automatic token refresh handled by the app",
			"Easier setup for new stores"
		],
		buttonText: "Upgrade via Shopify App Store",
		buttonVariant: "primary"
	}
}, sO = ({ label: e, bannerVariant: t = "install" }) => {
	let { initiateFromDixa: n } = rO(), [r, i] = U(!1), [o, s] = U(null), c = oO[t], l = async () => {
		if (t === "install" && n) {
			i(!0), s(null);
			try {
				let e = await n();
				window.open(e ?? "https://apps.shopify.com/dixa-dashboard", "_blank", "noopener,noreferrer");
			} catch {
				s("Failed to start the connection. Please try again.");
			} finally {
				i(!1);
			}
			return;
		}
		window.open(aO, "_blank", "noopener,noreferrer");
	}, u = c.listType === "ol" ? "ol" : "ul";
	return /* @__PURE__ */ G(y, { children: /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		className: iO.banner,
		children: [
			/* @__PURE__ */ G(L.Heading, {
				variant: "heading-2",
				children: e
			}),
			/* @__PURE__ */ K(v, {
				alignItems: "center",
				gap: "200",
				children: [/* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(x, {
					size: 30,
					name: "shopify",
					color: "green.500"
				}) }), /* @__PURE__ */ G(L.Paragraph, { children: c.description })]
			}),
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: c.listHeading
				}), /* @__PURE__ */ G(L.Paragraph, {
					as: "div",
					children: /* @__PURE__ */ G(u, {
						className: iO.list,
						children: c.listItems.map((e, t) => /* @__PURE__ */ G("li", { children: e }, t))
					})
				})]
			}),
			o && /* @__PURE__ */ G(L.Paragraph, {
				color: "danger",
				children: o
			}),
			/* @__PURE__ */ G(v, {
				margin: "200 0 0 0",
				children: /* @__PURE__ */ G(a, {
					onClick: l,
					icon: "external-link",
					variant: c.buttonVariant,
					disabled: r,
					children: r ? /* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ G(P, { size: 16 }), "Connecting…"]
					}) : c.buttonText
				})
			})
		]
	}) });
}, cO = [
	{
		key: "apiHostName",
		label: "API host name",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "displayRefundOrder",
		label: "Display the refund order button",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "displayPartialRefundOrder",
		label: "Displays the partial refund order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCancelOrder",
		label: "Displays the cancel order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "enableEditShippingAddress",
		label: "Enable the \"edit shipping address\" button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayOrdersOverview",
		label: "Displays short orders overview",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayEmailMarketingConsent",
		label: "Displays the email and phone marketing consent status of the customer",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "enableEditMarketingConsent",
		label: "Enable editing the marketing consent of the customer",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "displaySegmentMembership",
		label: "Displays the segment memberships of the customer",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDiscountCodes",
		label: "Displays available discount codes",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDiscountCodeCreation",
		label: "Displays the discount code creation button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCreateOrder",
		label: "Displays the create order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayCreateDraftOrder",
		label: "Displays the create draft order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayDuplicateOrder",
		label: "Displays the duplicate order button",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "shopifySalesAttribution",
		label: "Enable sales attribution",
		type: "boolean",
		secret: !1,
		defaultValue: !1
	},
	{
		key: "apiAccessToken",
		label: "API Access Token",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "shopifyClientId",
		label: "Client ID",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "shopifyClientSecret",
		label: "Client Secret",
		type: "string",
		secret: !0,
		defaultValue: ""
	}
], lO = "SHOPIFY", uO = Pe(cO), dO = [
	"displayRefundOrder",
	"displayPartialRefundOrder",
	"displayCancelOrder",
	"enableEditShippingAddress",
	"displayOrdersOverview",
	"displayEmailMarketingConsent",
	"enableEditMarketingConsent",
	"displaySegmentMembership",
	"displayDiscountCodes",
	"displayDiscountCodeCreation",
	"displayCreateOrder",
	"displayCreateDraftOrder",
	"displayDuplicateOrder",
	"shopifySalesAttribution"
], fO = {
	enabled: !1,
	name: "",
	...Le([], cO)
}, pO = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r, featureFlags: i }) => {
	let a = !e, { shopifySalesAttribution: o } = i, s = gl({
		mode: "onChange",
		defaultValues: fO
	}), { create: c, update: l, remove: u, isLoading: d, error: f, misconfigurationCause: p, setMisconfigurationCause: m } = He({
		integrationId: e,
		integrationType: lO,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: h, error: g, isWidgetUnknown: v, refetch: x, widgetConfiguration: S } = Ue({
		integrationId: e,
		fieldDefinitions: cO,
		form: s,
		onMisconfigured: m
	}), C = S?.additionalProperties, w = C?.tokenSource === "marketplace_app", T = !!C?.isUsingOAuth, E = !w, D = Qe(() => o && w ? dO : dO.filter((e) => e !== "shopifySalesAttribution"), [o, w]), O = (e) => ye(e, {
		fieldDefinitions: cO,
		isCreationMode: a,
		create: c,
		update: l
	}), k = s.watch("name");
	return /* @__PURE__ */ G(de, {
		form: s,
		integrationId: e,
		onValidSubmit: O,
		error: g ?? f,
		onRetry: g ? x : void 0,
		isLoading: d || h,
		isWidgetUnknown: v,
		children: a ? /* @__PURE__ */ G(b, { children: /* @__PURE__ */ G(sO, {
			label: "Connect your Shopify store",
			bannerVariant: "install"
		}) }) : /* @__PURE__ */ K(W, { children: [
			p && /* @__PURE__ */ G(se, { cause: p }),
			/* @__PURE__ */ K(b, { children: [
				E && /* @__PURE__ */ G(sO, {
					label: "Upgrade to simplified connection",
					bannerVariant: "migration"
				}),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: s.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: s.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				E && T && /* @__PURE__ */ K(W, { children: [
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(ue, {
							name: "shopifyClientId",
							label: uO.shopifyClientId,
							control: s.control,
							isCreationMode: a,
							rules: { required: "Client ID is required" },
							componentProps: {
								placeholder: "Client ID from Shopify",
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ G(y, { span: 3 }),
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(ue, {
							name: "shopifyClientSecret",
							label: uO.shopifyClientSecret,
							control: s.control,
							isCreationMode: a,
							rules: { required: "Client Secret is required" },
							componentProps: {
								placeholder: "Client Secret from Shopify",
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ G(y, { span: 3 })
				] }),
				E && !T && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "apiAccessToken",
						label: uO.apiAccessToken,
						control: s.control,
						isCreationMode: a,
						rules: { required: "API access token is required" },
						componentProps: {
							placeholder: "API access token from Shopify",
							autoComplete: "off"
						}
					})
				}), /* @__PURE__ */ G(y, { span: 3 })] }),
				w ? /* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "apiHostName",
						label: "Connected Shopify store",
						control: s.control,
						componentProps: {
							readOnly: !0,
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}) : /* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "apiHostName",
						label: "API host name",
						control: s.control,
						rules: {
							required: "API host name is required",
							validate: (e) => We(e) || !0
						},
						componentProps: {
							placeholder: "Host name of your shop, e.g. \"my-webshop.myshopify.com\"",
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				D.map((e) => /* @__PURE__ */ K(Ge, { children: [/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: uO[e],
						children: /* @__PURE__ */ G(X, {
							name: e,
							control: s.control
						})
					})
				}), /* @__PURE__ */ G(y, { span: 3 })] }, e))
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: lO,
				integrationId: e,
				widgetName: k,
				isCreationMode: a,
				isSubmitting: s.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => u()
			})
		] })
	});
}, mO = (e) => /* @__PURE__ */ G(sO, {
	...e,
	bannerVariant: "install"
}), hO = (e) => /* @__PURE__ */ G(sO, {
	...e,
	bannerVariant: "migration"
}), gO = [{
	key: "shopifyClientId",
	label: "Client ID",
	placeholder: "Client ID from Shopify",
	required: !0,
	secret: !0,
	type: "input"
}, {
	key: "shopifyClientSecret",
	label: "Client Secret",
	placeholder: "Client Secret from Shopify",
	required: !0,
	secret: !0,
	type: "input"
}], _O = [{
	key: "apiAccessToken",
	label: "API Access Token",
	placeholder: "API access token from Shopify",
	required: !0,
	secret: !0,
	type: "input"
}], vO = [{
	key: "marketplaceInstallBanner",
	label: "Connect your Shopify store",
	secret: !1,
	type: "custom",
	component: mO
}], yO = [{
	key: "apiHostName",
	label: "Connected Shopify store",
	placeholder: "",
	required: !1,
	secret: !1,
	type: "input",
	prefix: "https://",
	readOnly: !0
}], bO = [{
	key: "migrationBanner",
	label: "Upgrade to simplified connection",
	secret: !1,
	type: "custom",
	component: hO,
	additionalProperties: { renderAboveForm: !0 }
}], xO = [
	{
		key: "displayRefundOrder",
		label: "Display the refund order button",
		secret: !1,
		type: "switch",
		defaultValue: !1
	},
	{
		key: "displayPartialRefundOrder",
		label: "Displays the partial refund order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayCancelOrder",
		label: "Displays the cancel order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "enableEditShippingAddress",
		label: "Enable the \"edit shipping address\" button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayOrdersOverview",
		label: "Displays short orders overview",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayEmailMarketingConsent",
		label: "Displays the email and phone marketing consent status of the customer",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "enableEditMarketingConsent",
		label: "Enable editing the marketing consent of the customer",
		secret: !1,
		type: "switch",
		defaultValue: !1
	},
	{
		key: "displaySegmentMembership",
		label: "Displays the segment memberships of the customer",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayDiscountCodes",
		label: "Displays available discount codes",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayDiscountCodeCreation",
		label: "Displays the discount code creation button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayCreateOrder",
		label: "Displays the create order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayCreateDraftOrder",
		label: "Displays the create draft order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	},
	{
		key: "displayDuplicateOrder",
		label: "Displays the duplicate order button",
		secret: !1,
		type: "switch",
		defaultValue: !0
	}
], SO = [{
	key: "apiHostName",
	label: "API host name",
	placeholder: "Host name of your shop, e.g. \"my-webshop.myshopify.com\"",
	required: !0,
	secret: !1,
	type: "input",
	prefix: "https://",
	customValidation: (e) => We(e)
}, ...xO], CO = /* @__PURE__ */ function(e) {
	return e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e;
}({}), wO = /* @__PURE__ */ function(e) {
	return e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e;
}({}), TO = /* @__PURE__ */ function(e) {
	return e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e;
}({}), EO = /* @__PURE__ */ function(e) {
	return e.All = "ALL", e;
}({}), DO = /* @__PURE__ */ function(e) {
	return e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e;
}({}), OO = /* @__PURE__ */ function(e) {
	return e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e;
}({}), kO = /* @__PURE__ */ function(e) {
	return e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e;
}({}), AO = /* @__PURE__ */ function(e) {
	return e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e;
}({}), jO = /* @__PURE__ */ function(e) {
	return e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e;
}({}), MO = /* @__PURE__ */ function(e) {
	return e.Cancel = "CANCEL", e.LegacyRestock = "LEGACY_RESTOCK", e.NoRestock = "NO_RESTOCK", e.Return = "RETURN", e;
}({}), NO = {
	"\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "refundCreate"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_RefundInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "refundCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "orderUpdate"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderUpdate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "shippingAddress"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "firstName"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "lastName"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "company"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address1"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "address2"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "city"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "countryCodeV2"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "provinceCode"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "zip"
														}
													}
												]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "orderCancel"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "notifyCustomer"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Boolean"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "orderId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "reason"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Shopify_OrderCancelReason"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "refundMethod"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Shopify_OrderCancelRefundMethodInput"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "restock"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Boolean"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "staffNote"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderCancel"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "notifyCustomer"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "notifyCustomer"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "orderId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "orderId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "reason"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "reason"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "refundMethod"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "refundMethod"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "restock"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "restock"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "staffNote"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "staffNote"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "job"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "done"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "orderCancelUserErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "code"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "field"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "message"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createCustomer"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_CustomerInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "customerCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "customer"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "defaultEmailAddress"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "emailAddress"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "defaultPhoneNumber"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "phoneNumber"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "marketingState"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "marketingOptInLevel"
															}
														}
													]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "taxExempt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "firstName"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "lastName"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "amountSpent"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "amount"
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "currencyCode"
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createOrder"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "order"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderCreateOrderInput"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "options"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Shopify_OrderCreateOptionsInput"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "order"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "order"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "options"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "options"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "createdAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "displayFulfillmentStatus"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "displayFinancialStatus"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalPriceSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "shopMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createDraftOrder"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_DraftOrderInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "draftOrderCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "draftOrder"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "createdAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "tags"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalPriceSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "shopMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											}
										]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "createDiscountCode"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_DiscountCodeBasicInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "discountCodeBasicCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "basicCodeDiscount"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "codeDiscountNode"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "codeDiscount"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "InlineFragment",
													typeCondition: {
														kind: "NamedType",
														name: {
															kind: "Name",
															value: "Shopify_DiscountCodeBasic"
														}
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "codes"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "first"
																	},
																	value: {
																		kind: "IntValue",
																		value: "1"
																	}
																}],
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "nodes"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "code"
																				}
																			}]
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "title"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "status"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "startsAt"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "endsAt"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "usageLimit"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "appliesOncePerCustomer"
																}
															}
														]
													}
												}]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "orderMarkAsPaid"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderMarkAsPaidInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderMarkAsPaid"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateEmailMarketingConsent(\n    $input: Shopify_CustomerEmailMarketingConsentUpdateInput!\n  ) {\n    Shopify {\n      customerEmailMarketingConsentUpdate(input: $input) {\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n            marketingState\n            marketingOptInLevel\n            marketingUpdatedAt\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateEmailMarketingConsent"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_CustomerEmailMarketingConsentUpdateInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "customerEmailMarketingConsentUpdate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "customer"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "defaultEmailAddress"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "emailAddress"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "marketingState"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "marketingOptInLevel"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "marketingUpdatedAt"
														}
													}
												]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateSmsMarketingConsent(\n    $input: Shopify_CustomerSmsMarketingConsentUpdateInput!\n  ) {\n    Shopify {\n      customerSmsMarketingConsentUpdate(input: $input) {\n        customer {\n          id\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n            marketingUpdatedAt\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateSmsMarketingConsent"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_CustomerSmsMarketingConsentUpdateInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "customerSmsMarketingConsentUpdate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "customer"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "defaultPhoneNumber"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "phoneNumber"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "marketingState"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "marketingOptInLevel"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "marketingUpdatedAt"
														}
													}
												]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "refundLineItems"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_RefundInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "refundCreate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "refund"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "totalRefundedSet"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "presentmentMoney"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [{
															kind: "Field",
															name: {
																kind: "Name",
																value: "amount"
															}
														}, {
															kind: "Field",
															name: {
																kind: "Name",
																value: "currencyCode"
															}
														}]
													}
												}]
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "userErrors"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "field"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updateOrder"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Shopify_OrderInput"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orderUpdate"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "order"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "tags"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "segments"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "first"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "segments"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "first"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "first"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "id"
													}
												}, {
													kind: "Field",
													name: {
														kind: "Name",
														value: "name"
													}
												}]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "customerSegmentMembership"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "customerId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "ID"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "segmentIds"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "ListType",
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "ID"
								}
							}
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "customerSegmentMembership"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "customerId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "customerId"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "segmentIds"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "segmentIds"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "memberships"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "segmentId"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "isMember"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      currentAppInstallation {\n        accessScopes {\n          handle\n        }\n      }\n\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "shopifyCustomerData"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "currentAppInstallation"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "accessScopes"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "handle"
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "shop"
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "countriesInShippingZones"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "countryCodes"
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "customers"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "IntValue",
										value: "1"
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "Field",
										name: {
											kind: "Name",
											value: "edges"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "node"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "displayName"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "firstName"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "lastName"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "defaultEmailAddress"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "emailAddress"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingOptInLevel"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingState"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingUpdatedAt"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "defaultPhoneNumber"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "phoneNumber"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingOptInLevel"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingState"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "marketingUpdatedAt"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "numberOfOrders"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "tags"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "verifiedEmail"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "amountSpent"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "amount"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "currencyCode"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "defaultAddress"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "firstName"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "lastName"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "address1"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "address2"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "city"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "country"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "zip"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "phone"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "provinceCode"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "countryCodeV2"
																		}
																	}
																]
															}
														}
													]
												}
											}]
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  variant {\n                    id\n                    inventoryQuantity\n                    selectedOptions {\n                      name\n                      value\n                    }\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "shopifyCustomerOrders"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "query"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "orders"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "IntValue",
										value: "5"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "sortKey"
									},
									value: {
										kind: "EnumValue",
										value: "CREATED_AT"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "reverse"
									},
									value: {
										kind: "BooleanValue",
										value: !0
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "edges"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "node"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "name"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "createdAt"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "displayFulfillmentStatus"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "displayFinancialStatus"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "cancelledAt"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "tags"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "discountCodes"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "netPaymentSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "totalRefundedSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "billingAddress"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "firstName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "lastName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "countryCodeV2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "provinceCode"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shippingAddress"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "firstName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "lastName"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "company"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address1"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "address2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "city"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "country"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "countryCodeV2"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "province"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "provinceCode"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "zip"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "phone"
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "suggestedRefund"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "suggestFullRefund"
															},
															value: {
																kind: "BooleanValue",
																value: !0
															}
														}, {
															kind: "Argument",
															name: {
																kind: "Name",
																value: "refundShipping"
															},
															value: {
																kind: "BooleanValue",
																value: !0
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "amountSet"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "presentmentMoney"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "amount"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "currencyCode"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "subtotalSet"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "presentmentMoney"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "amount"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "currencyCode"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "totalTaxSet"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "presentmentMoney"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "amount"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "currencyCode"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "shipping"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "amountSet"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "presentmentMoney"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "amount"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "currencyCode"
																							}
																						}]
																					}
																				}]
																			}
																		}, {
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "maximumRefundableSet"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "presentmentMoney"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "amount"
																							}
																						}, {
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "currencyCode"
																							}
																						}]
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "suggestedTransactions"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "accountNumber"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "gateway"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "kind"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "parentTransaction"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "id"
																						}
																					}]
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "amountSet"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "presentmentMoney"
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "amount"
																								}
																							}, {
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "currencyCode"
																								}
																							}]
																						}
																					}]
																				}
																			}
																		]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "refundLineItems"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "lineItem"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				}, {
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "quantity"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "shippingLines"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "5"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "title"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "source"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discountedPriceSet"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "shopMoney"
																							},
																							selectionSet: {
																								kind: "SelectionSet",
																								selections: [{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "amount"
																									}
																								}, {
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "currencyCode"
																									}
																								}]
																							}
																						}]
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "fulfillments"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "2"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "trackingInfo"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "company"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "number"
																			}
																		},
																		{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "url"
																			}
																		}
																	]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "lineItems"
														},
														arguments: [{
															kind: "Argument",
															name: {
																kind: "Name",
																value: "first"
															},
															value: {
																kind: "IntValue",
																value: "15"
															}
														}],
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "edges"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "node"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "id"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "title"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "quantity"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "variantTitle"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "sku"
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "image"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "url"
																							}
																						}]
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "product"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "id"
																							}
																						}]
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "variant"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [
																							{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "id"
																								}
																							},
																							{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "inventoryQuantity"
																								}
																							},
																							{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "selectedOptions"
																								},
																								selectionSet: {
																									kind: "SelectionSet",
																									selections: [{
																										kind: "Field",
																										name: {
																											kind: "Name",
																											value: "name"
																										}
																									}, {
																										kind: "Field",
																										name: {
																											kind: "Name",
																											value: "value"
																										}
																									}]
																								}
																							}
																						]
																					}
																				},
																				{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "discountedUnitPriceSet"
																					},
																					selectionSet: {
																						kind: "SelectionSet",
																						selections: [{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "shopMoney"
																							},
																							selectionSet: {
																								kind: "SelectionSet",
																								selections: [{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "amount"
																									}
																								}, {
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "currencyCode"
																									}
																								}]
																							}
																						}]
																					}
																				}
																			]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "refunds"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "totalRefunded"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "refundLineItems"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "first"
																	},
																	value: {
																		kind: "IntValue",
																		value: "250"
																	}
																}],
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "edges"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "node"
																				},
																				selectionSet: {
																					kind: "SelectionSet",
																					selections: [
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "id"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "quantity"
																							}
																						},
																						{
																							kind: "Field",
																							name: {
																								kind: "Name",
																								value: "lineItem"
																							},
																							selectionSet: {
																								kind: "SelectionSet",
																								selections: [{
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "id"
																									}
																								}, {
																									kind: "Field",
																									name: {
																										kind: "Name",
																										value: "title"
																									}
																								}]
																							}
																						}
																					]
																				}
																			}]
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currentTotalPriceSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "shopMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "currentTotalDiscountsSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "shopMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchDiscountCodes"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "query"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "first"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "after"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "discountNodes"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "query"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "query"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "first"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "first"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "after"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "after"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "pageInfo"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "hasNextPage"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "endCursor"
											}
										}]
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "discount"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "__typename"
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeApp"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeBasic"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "customerGets"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "value"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "__typename"
																						}
																					},
																					{
																						kind: "InlineFragment",
																						typeCondition: {
																							kind: "NamedType",
																							name: {
																								kind: "Name",
																								value: "Shopify_DiscountPercentage"
																							}
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "percentage"
																								}
																							}]
																						}
																					},
																					{
																						kind: "InlineFragment",
																						typeCondition: {
																							kind: "NamedType",
																							name: {
																								kind: "Name",
																								value: "Shopify_DiscountAmount"
																							}
																						},
																						selectionSet: {
																							kind: "SelectionSet",
																							selections: [{
																								kind: "Field",
																								name: {
																									kind: "Name",
																									value: "amount"
																								},
																								selectionSet: {
																									kind: "SelectionSet",
																									selections: [{
																										kind: "Field",
																										name: {
																											kind: "Name",
																											value: "amount"
																										}
																									}, {
																										kind: "Field",
																										name: {
																											kind: "Name",
																											value: "currencyCode"
																										}
																									}]
																								}
																							}]
																						}
																					}
																				]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeBxgy"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													},
													{
														kind: "InlineFragment",
														typeCondition: {
															kind: "NamedType",
															name: {
																kind: "Name",
																value: "Shopify_DiscountCodeFreeShipping"
															}
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "codes"
																	},
																	arguments: [{
																		kind: "Argument",
																		name: {
																			kind: "Name",
																			value: "first"
																		},
																		value: {
																			kind: "IntValue",
																			value: "100"
																		}
																	}],
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "nodes"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [{
																					kind: "Field",
																					name: {
																						kind: "Name",
																						value: "code"
																					}
																				}]
																			}
																		}]
																	}
																}
															]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query productVariants($productId: ID!, $variantCount: Int, $after: String) {\n    Shopify {\n      product(id: $productId) {\n        id\n        variants(first: $variantCount, after: $after) {\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n          nodes {\n            id\n            title\n            sku\n            price\n            inventoryQuantity\n            inventoryPolicy\n            image {\n              url\n            }\n            selectedOptions {\n              name\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "productVariants"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "productId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "variantCount"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "after"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "product"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "productId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "variants"
									},
									arguments: [{
										kind: "Argument",
										name: {
											kind: "Name",
											value: "first"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "variantCount"
											}
										}
									}, {
										kind: "Argument",
										name: {
											kind: "Name",
											value: "after"
										},
										value: {
											kind: "Variable",
											name: {
												kind: "Name",
												value: "after"
											}
										}
									}],
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "pageInfo"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "hasNextPage"
													}
												}, {
													kind: "Field",
													name: {
														kind: "Name",
														value: "endCursor"
													}
												}]
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "nodes"
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "id"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "title"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "sku"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "price"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "inventoryQuantity"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "inventoryPolicy"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "image"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "url"
																}
															}]
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "selectedOptions"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "name"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "value"
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          totalInventory\n          hasOnlyDefaultVariant\n          variantsCount {\n            count\n          }\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n          variants(first: 1) {\n            nodes {\n              id\n              title\n              sku\n              price\n              inventoryQuantity\n              inventoryPolicy\n              image {\n                url\n              }\n              selectedOptions {\n                name\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "searchProducts"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "query"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "String"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "productCount"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "mediaCount"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "products"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "first"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "productCount"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "query"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "query"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "nodes"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "description"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "onlineStoreUrl"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "tags"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalInventory"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "hasOnlyDefaultVariant"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "variantsCount"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "count"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "priceRangeV2"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "maxVariantPrice"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "minVariantPrice"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "media"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "Variable",
														name: {
															kind: "Name",
															value: "mediaCount"
														}
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "alt"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "status"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "mediaContentType"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "preview"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "image"
																			},
																			selectionSet: {
																				kind: "SelectionSet",
																				selections: [
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "id"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "altText"
																						}
																					},
																					{
																						kind: "Field",
																						name: {
																							kind: "Name",
																							value: "url"
																						}
																					}
																				]
																			}
																		}]
																	}
																}
															]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "variants"
												},
												arguments: [{
													kind: "Argument",
													name: {
														kind: "Name",
														value: "first"
													},
													value: {
														kind: "IntValue",
														value: "1"
													}
												}],
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "nodes"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "title"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "sku"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "price"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "inventoryQuantity"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "inventoryPolicy"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "image"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "url"
																			}
																		}]
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "selectedOptions"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "name"
																			}
																		}, {
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "value"
																			}
																		}]
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n    $canReadLocations: Boolean!\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            restockType\n            location @include(if: $canReadLocations) {\n              id\n            }\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "shopifySuggestedRefund"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "orderId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "ID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "refundLineItems"
						}
					},
					type: {
						kind: "ListType",
						type: {
							kind: "NonNullType",
							type: {
								kind: "NamedType",
								name: {
									kind: "Name",
									value: "Shopify_RefundLineItemInput"
								}
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "refundShipping"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Boolean"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "suggestFullRefund"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Boolean"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "canReadLocations"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Boolean"
							}
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "order"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "orderId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "suggestedRefund"
									},
									arguments: [
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "refundLineItems"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "refundLineItems"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "refundShipping"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "refundShipping"
												}
											}
										},
										{
											kind: "Argument",
											name: {
												kind: "Name",
												value: "suggestFullRefund"
											},
											value: {
												kind: "Variable",
												name: {
													kind: "Name",
													value: "suggestFullRefund"
												}
											}
										}
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "amountSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "subtotalSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalTaxSet"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "presentmentMoney"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "amount"
																}
															}, {
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "currencyCode"
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "shipping"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "amountSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													}, {
														kind: "Field",
														name: {
															kind: "Name",
															value: "maximumRefundableSet"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "presentmentMoney"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "amount"
																		}
																	}, {
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "currencyCode"
																		}
																	}]
																}
															}]
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "suggestedTransactions"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "accountNumber"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "gateway"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "kind"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "parentTransaction"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "amountSet"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "presentmentMoney"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [{
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "amount"
																			}
																		}, {
																			kind: "Field",
																			name: {
																				kind: "Name",
																				value: "currencyCode"
																			}
																		}]
																	}
																}]
															}
														}
													]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "refundLineItems"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "restockType"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "location"
															},
															directives: [{
																kind: "Directive",
																name: {
																	kind: "Name",
																	value: "include"
																},
																arguments: [{
																	kind: "Argument",
																	name: {
																		kind: "Name",
																		value: "if"
																	},
																	value: {
																		kind: "Variable",
																		name: {
																			kind: "Name",
																			value: "canReadLocations"
																		}
																	}
																}]
															}],
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "lineItem"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																}]
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "test"
			},
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Shopify"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "shop"
							},
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "name"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "email"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "description"
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	}
};
function PO(e) {
	return NO[e] ?? {};
}
var FO = PO("\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      currentAppInstallation {\n        accessScopes {\n          handle\n        }\n      }\n\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n"), IO = PO("\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  variant {\n                    id\n                    inventoryQuantity\n                    selectedOptions {\n                      name\n                      value\n                    }\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), LO = PO("\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n    $canReadLocations: Boolean!\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            restockType\n            location @include(if: $canReadLocations) {\n              id\n            }\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n"), RO = PO("\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"), zO = PO("\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n"), BO = PO("\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          totalInventory\n          hasOnlyDefaultVariant\n          variantsCount {\n            count\n          }\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n          variants(first: 1) {\n            nodes {\n              id\n              title\n              sku\n              price\n              inventoryQuantity\n              inventoryPolicy\n              image {\n                url\n              }\n              selectedOptions {\n                name\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), VO = PO("\n  query productVariants($productId: ID!, $variantCount: Int, $after: String) {\n    Shopify {\n      product(id: $productId) {\n        id\n        variants(first: $variantCount, after: $after) {\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n          nodes {\n            id\n            title\n            sku\n            price\n            inventoryQuantity\n            inventoryPolicy\n            image {\n              url\n            }\n            selectedOptions {\n              name\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n"), HO = PO("\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), UO = PO("\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), WO = PO("\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), GO = PO("\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n"), KO = PO("\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n"), qO = PO("\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n"), JO = PO("\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), YO = ut`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, XO = ut`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, ZO = PO("\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), QO = PO("\n  mutation updateEmailMarketingConsent(\n    $input: Shopify_CustomerEmailMarketingConsentUpdateInput!\n  ) {\n    Shopify {\n      customerEmailMarketingConsentUpdate(input: $input) {\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n            marketingState\n            marketingOptInLevel\n            marketingUpdatedAt\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), $O = PO("\n  mutation updateSmsMarketingConsent(\n    $input: Shopify_CustomerSmsMarketingConsentUpdateInput!\n  ) {\n    Shopify {\n      customerSmsMarketingConsentUpdate(input: $input) {\n        customer {\n          id\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n            marketingUpdatedAt\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n"), ek = ({ conversationContext: e, forcePhoneLookup: t }) => {
	let { useQuery: n } = B(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = t ? o : a ?? o, { loading: c, error: l, data: u, refetch: d, networkStatus: f } = n(FO, {
		skip: !s,
		variables: { query: s },
		notifyOnNetworkStatusChange: !0
	});
	return {
		isCustomerLoading: c,
		customerError: l,
		customerData: u,
		refetchCustomer: d,
		customerNetworkStatus: f
	};
}, tk = () => {
	let { useLazyQuery: e } = B(), [t, { loading: n, error: r, data: i, refetch: a }] = e(IO);
	return {
		getCustomerOrders: t,
		isCustomerOrdersLoading: n,
		customerOrdersError: r,
		customerOrders: i,
		refetchCustomerOrders: a
	};
};
function nk(e = !1, t) {
	let [n, r] = U(e);
	return H(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var rk = "Default Title", ik = (e) => (e.media?.nodes?.[0])?.preview?.image?.url || null, ak = (e) => e.title && e.title !== rk ? e.title : null, ok = (e) => e.filter((e) => e.value !== rk).map((e) => `${e.name}: ${e.value}`), sk = (e) => {
	let t = ok(e.variantOptions);
	return t.length > 0 ? t : e.variantTitle ? [e.variantTitle] : [];
}, ck = (e) => (e.inventoryQuantity ?? 0) <= 0, lk = (e) => e.totalInventory <= 0, uk = (e) => (e ?? 0) <= 0 ? "Out of stock" : `${e} in stock`, dk = (e, t) => {
	let n = t.trim().toLowerCase();
	return !n || e.title.toLowerCase().includes(n) || !!e.sku?.toLowerCase().includes(n);
}, fk = (e) => e.hasOnlyDefaultVariant || e.variantsCount?.count === 1 ? e.variants?.nodes?.[0] ?? null : null, pk = (e, t) => ({
	id: t.id,
	productId: e.id,
	variantId: t.id,
	title: e.title,
	variantTitle: ak(t),
	variantOptions: t.selectedOptions ?? [],
	sku: t.sku ?? null,
	imageUrl: t.image?.url ?? ik(e),
	price: {
		amount: Number(t.price),
		currencyCode: e.priceRangeV2.minVariantPrice.currencyCode
	},
	inventoryQuantity: t.inventoryQuantity ?? null,
	quantity: 1
}), mk = (e, t) => {
	let n = e.discountedUnitPriceSet?.shopMoney;
	return n ? {
		id: e.id,
		productId: e.product?.id ?? null,
		variantId: e.variant?.id ?? null,
		title: e.title,
		variantTitle: e.variantTitle ?? null,
		variantOptions: e.variant?.selectedOptions ?? [],
		sku: e.sku ?? null,
		imageUrl: e.image?.url ?? null,
		price: {
			amount: Number(n.amount),
			currencyCode: n.currencyCode
		},
		inventoryQuantity: e.variant?.inventoryQuantity ?? null,
		quantity: t
	} : null;
}, hk = (e, t) => {
	let n = e.findIndex((e) => e.variantId === t.variantId);
	return n === -1 ? [...e, t] : e.map((e, r) => {
		if (r !== n) return e;
		let i = (e.quantity || 0) + t.quantity, a = t.inventoryQuantity ?? e.inventoryQuantity, o = a !== null && a > 0;
		return {
			...e,
			quantity: o ? Math.min(i, a) : i
		};
	});
}, gk = (e, t) => `${e.toFixed(2)} ${t}`, _k = "UNFULFILLED", vk = (e, t) => (t ?? []).map(({ amountSet: t, gateway: n, parentTransaction: r }) => ({
	amount: String(t?.presentmentMoney?.amount ?? "0.00"),
	gateway: n ?? "",
	kind: jO.Refund,
	orderId: e,
	parentId: r?.id
})), yk = ({ orderId: e, transactions: t, refundLineItems: n, refundShipping: r, note: i, notify: a = !0 }) => ({
	orderId: e,
	notify: a,
	note: i,
	refundLineItems: n,
	transactions: t,
	shipping: { fullRefund: r }
}), bk = (e) => e.refundLineItems.map((t) => e.restock ? t : {
	lineItemId: t.lineItemId,
	quantity: t.quantity,
	restockType: MO.NoRestock
}), xk = (e) => {
	let t = new Map(e.restockSource.map((e) => [e.lineItemId, e]));
	return e.selectedLineItems.map((e) => {
		let n = t.get(e.lineItemId);
		return n ? {
			...e,
			restockType: n.restockType,
			locationId: n.locationId
		} : {
			lineItemId: e.lineItemId,
			quantity: e.quantity,
			restockType: MO.NoRestock
		};
	});
}, Sk = (e) => !!e?.includes("read_locations"), Ck = ({ ordersData: e }) => {
	let t = (e) => e?.fulfillments?.length > 0 ? e.fulfillments[0].trackingInfo : [];
	return e.map(({ node: e }) => ({
		id: e.id,
		name: e.name,
		createdAt: new Date(e.createdAt),
		cancelledAt: e.cancelledAt ? new Date(e.cancelledAt) : void 0,
		status: `${e.displayFulfillmentStatus?.toLowerCase()}, ${e.displayFinancialStatus?.toLowerCase()}${e.cancelledAt ? ", cancelled" : ""}`,
		displayFinancialStatus: e.displayFinancialStatus,
		currentTotalPriceSet: e.currentTotalPriceSet,
		currentTotalDiscountsSet: e.currentTotalDiscountsSet,
		value: e.netPaymentSet?.presentmentMoney?.amount,
		currencyCode: e.netPaymentSet?.presentmentMoney?.currencyCode,
		shippingAddress: e.shippingAddress,
		billingAddress: e.billingAddress,
		lineItems: e.lineItems?.edges?.map(({ node: e }) => e),
		suggestedRefund: {
			orderId: e.id,
			amount: e.suggestedRefund?.amountSet?.presentmentMoney?.amount,
			subtotal: e.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
			tax: e.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
			currency: e.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
			notify: !0,
			refundLineItems: e.suggestedRefund?.refundLineItems.map(({ lineItem: e }) => ({
				lineItemId: e.id,
				quantity: e.quantity
			})),
			transactions: vk(e.id, e.suggestedRefund?.suggestedTransactions),
			shipping: {
				fullRefund: !0,
				amount: e.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
				maximumRefundable: e.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
			}
		},
		trackingInfos: t(e),
		shippingLines: e.shippingLines?.edges?.map(({ node: e }) => e),
		tags: e.tags,
		discountCodes: e.discountCodes,
		refunds: e.refunds
	}));
}, wk = [
	{
		value: kO.Pending,
		label: "Pending",
		description: "The payment is pending"
	},
	{
		value: kO.Authorized,
		label: "Authorized",
		description: "The payment has been authorized but not captured"
	},
	{
		value: kO.Paid,
		label: "Paid",
		description: "The payment has been completed"
	}
], Tk = [
	{
		value: AO.Fulfilled,
		label: "Fulfilled",
		description: "Every line item in the order has been fulfilled"
	},
	{
		value: AO.Partial,
		label: "Partial",
		description: "At least one line item in the order has been fulfilled"
	},
	{
		value: AO.Restocked,
		label: "Restocked",
		description: "Every line item in the order has been restocked and the order canceled"
	},
	{
		value: _k,
		label: "Unfulfilled",
		description: "No line items in the order have been fulfilled"
	}
], Ek = (e) => e === "UNFULFILLED" ? void 0 : e, Dk = (e) => sk({
	variantTitle: e.variantTitle ?? null,
	variantOptions: e.variant?.selectedOptions ?? []
}), Ok = (e) => ({
	productId: e.productId ?? void 0,
	variantId: e.variantId ?? void 0,
	...e.variantId === null && {
		title: e.title,
		variantTitle: e.variantTitle ?? void 0,
		sku: e.sku ?? void 0
	},
	quantity: e.quantity,
	requiresShipping: !0,
	priceSet: { shopMoney: {
		amount: e.price.amount,
		currencyCode: e.price.currencyCode
	} }
}), kk = (e) => e.variantId ? {
	variantId: e.variantId,
	quantity: e.quantity
} : {
	title: e.title,
	sku: e.sku ?? void 0,
	quantity: e.quantity,
	requiresShipping: !0,
	originalUnitPriceWithCurrency: {
		amount: e.price.amount,
		currencyCode: e.price.currencyCode
	}
}, Ak = (e) => jk(Mk(e)), jk = (e) => Object.fromEntries(Object.entries(e ?? {}).filter(([, e]) => e != null)), Mk = (e) => {
	let t = e;
	if (typeof t == "object" && "countryCodeV2" in t) {
		let { countryCodeV2: e, ...n } = t;
		return {
			...n,
			...e && { countryCode: e }
		};
	}
	return e;
}, Nk = ({ orderId: e, refundShipping: t, refundLineItems: n, suggestFullRefund: r, skip: i, canReadLocations: a }) => {
	let { useQuery: o } = B(), { data: s, previousData: c, loading: l, error: u } = o(LO, {
		skip: i,
		fetchPolicy: "cache-and-network",
		notifyOnNetworkStatusChange: !0,
		variables: {
			orderId: e,
			refundShipping: t,
			refundLineItems: n,
			suggestFullRefund: r,
			canReadLocations: a
		}
	}), d = i ? void 0 : s?.Shopify?.order?.suggestedRefund ?? c?.Shopify?.order?.suggestedRefund;
	return {
		suggestedRefund: Qe(() => {
			if (d) return {
				amount: String(d.amountSet.presentmentMoney.amount),
				subtotal: String(d.subtotalSet.presentmentMoney.amount),
				tax: String(d.totalTaxSet.presentmentMoney.amount),
				currency: d.amountSet.presentmentMoney.currencyCode,
				shipping: {
					amount: String(d.shipping.amountSet.presentmentMoney.amount),
					maximumRefundable: String(d.shipping.maximumRefundableSet.presentmentMoney.amount)
				},
				transactions: vk(e, d.suggestedTransactions),
				refundLineItems: d.refundLineItems.map(({ lineItem: e, restockType: t, location: n }) => ({
					lineItemId: e.id,
					quantity: e.quantity,
					restockType: t,
					locationId: n?.id
				}))
			};
		}, [d, e]),
		isLoading: l,
		error: u
	};
}, Pk = {
	nodes: [],
	hasMoreResults: !1
}, Fk = (e) => "codes" in e.discount, Ik = (e) => Fk(e) ? e.discount.codes.nodes[0]?.code ?? "" : "", Lk = (e) => [...e].sort((e, t) => Ik(e).localeCompare(Ik(t))), Rk = (e) => {
	let t = e?.Shopify?.discountNodes;
	return {
		nodes: Lk((t?.nodes ?? []).filter(Fk)),
		hasMoreResults: !!t?.pageInfo?.hasNextPage
	};
}, zk = 300, Bk = 2, Vk = 250, Hk = ({ enabled: e = !0 } = {}) => {
	let { useLazyQuery: t, showNotification: n } = B(), [r, i] = U(""), [a, o] = U([]), [s, c] = U(!1), [l, u] = U(!1), d = et(null), f = et(0), [p] = t(HO, { fetchPolicy: "no-cache" }), m = (e) => {
		o(e.nodes), c(e.hasMoreResults);
	}, h = async (e, t) => {
		let r = f.current + 1;
		f.current = r, u(!0);
		try {
			let n = await p({ variables: {
				query: e,
				first: Vk
			} });
			if (r !== f.current) return;
			if (n.error) throw n.error;
			let i = Rk(n.data);
			t && (d.current = i), m(i);
		} catch {
			if (r !== f.current) return;
			m(Pk), n({
				title: "Something went wrong",
				text: "Could not search for discount codes. Please try again.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		} finally {
			r === f.current && u(!1);
		}
	};
	return au(() => {
		if (!e) return;
		let t = r.trim(), n = t.length === 0;
		if (!(!n && t.length < Bk)) {
			if (n && d.current) {
				m(d.current);
				return;
			}
			h(n ? void 0 : t, n);
		}
	}, zk, [r, e]), {
		discountNodes: a,
		isLoading: l,
		hasMoreResults: s,
		filter: r,
		setFilter: i,
		minSearchCharacters: Bk
	};
}, Uk = 50, Wk = ({ productId: e }) => {
	let { useLazyQuery: t, showNotification: n } = B(), [r, i] = U([]), [a, o] = U(!1), [s, c] = U(null), [l, u] = U(!1), [d, f] = U(!1), p = et(null), m = et(0), [h] = t(VO, { fetchPolicy: "no-cache" }), g = Ye(async (t) => {
		if (!e) return;
		let r = m.current + 1;
		m.current = r, o(!0), f(!1);
		try {
			let n = await h({ variables: {
				productId: e,
				variantCount: Uk,
				after: t
			} });
			if (r !== m.current) return;
			if (n.error) throw n.error;
			let a = n.data?.Shopify?.product?.variants, o = a?.nodes ?? [];
			i((e) => t ? [...e, ...o] : o), u(!!a?.pageInfo?.hasNextPage), c(a?.pageInfo?.endCursor ?? null);
		} catch {
			if (r !== m.current) return;
			p.current = t, f(!0), n({
				title: "Something went wrong",
				text: "Could not load the product variants. Please try again.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		} finally {
			r === m.current && o(!1);
		}
	}, [
		e,
		h,
		n
	]);
	return H(() => {
		i([]), c(null), u(!1), f(!1), g(null);
	}, [e]), {
		variants: r,
		isLoading: a,
		hasNextPage: l,
		hasError: d,
		loadNextPage: Ye(() => {
			!a && l && g(s);
		}, [
			a,
			l,
			s,
			g
		]),
		retry: Ye(() => {
			!a && d && g(p.current);
		}, [
			a,
			d,
			g
		])
	};
}, Gk = [CO.Redacted, CO.Invalid], Kk = {
	[CO.Subscribed]: "The customer receives marketing.",
	[CO.Unsubscribed]: "The customer was subscribed and has opted out.",
	[CO.Pending]: "The customer still has to confirm the subscription."
}, qk = (e) => e ? me(e.replaceAll("_", " ")) : "No state available", Jk = (e) => {
	switch (e) {
		case CO.Invalid:
		case CO.NotSubscribed: return "red.500";
		case CO.Pending:
		case CO.Unsubscribed: return "orange.500";
		case CO.Subscribed: return "green.500";
		default: return "neutral.500";
	}
}, Yk = (e) => !!e && !Gk.includes(e ?? ""), Xk = (e) => ({
	value: e,
	label: qk(e),
	description: Kk[e] ?? ""
}), Zk = [
	CO.Subscribed,
	CO.Unsubscribed,
	CO.Pending
].map(Xk), Qk = [
	TO.Subscribed,
	TO.Unsubscribed,
	TO.Pending
].map(Xk), $k = (e) => Yk(e) ? e : void 0, eA = (e) => Yk(e) ? e : void 0, tA = (e) => {
	switch (e) {
		case CO.Subscribed: return wO.SingleOptIn;
		case CO.Pending: return wO.ConfirmedOptIn;
		default: return;
	}
}, nA = ({ customerId: e, refetchCustomer: t }) => {
	let { useMutation: n, showNotification: r } = B(), { track: i } = Ve(), [a] = n(QO), [o] = n($O), s = async (t) => {
		try {
			return !(await a({ variables: { input: {
				customerId: e,
				emailMarketingConsent: {
					marketingState: t,
					marketingOptInLevel: tA(t)
				}
			} } })).data?.Shopify?.customerEmailMarketingConsentUpdate?.userErrors?.length;
		} catch {
			return !1;
		}
	}, c = async (t) => {
		try {
			return !(await o({ variables: { input: {
				customerId: e,
				smsMarketingConsent: {
					marketingState: t,
					marketingOptInLevel: tA(t)
				}
			} } })).data?.Shopify?.customerSmsMarketingConsentUpdate?.userErrors?.length;
		} catch {
			return !1;
		}
	};
	return { updateMarketingConsent: async (e) => {
		let n = [];
		e.email && n.push(["email", s(e.email)]), e.phone && n.push(["phone", c(e.phone)]);
		let a = await Promise.all(n.map(async ([e, t]) => ({
			channel: e,
			succeeded: await t
		}))), o = a.filter((e) => e.succeeded), l = a.filter((e) => !e.succeeded);
		if (o.length > 0 && await t?.(), o.forEach(({ channel: e }) => i("shopify:customer:marketing:consent:updated", { channel: e })), l.forEach(({ channel: e }) => i("shopify:customer:marketing:consent:failed", { channel: e })), l.length > 0) {
			let e = l.map(({ channel: e }) => e === "email" ? "email" : "SMS").join(" and ");
			return r({
				title: "Something went wrong",
				text: `The ${e} marketing consent could not be updated. Please try again.`,
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), !1;
		}
		return r({
			title: "Marketing consent updated",
			text: "The marketing consent was updated in Shopify.",
			icon: "check-circle-filled",
			severity: "success"
		}), !0;
	} };
}, rA = {
	list: "_list_alvh6_1",
	listItem: "_listItem_alvh6_4",
	listItemEdit: "_listItemEdit_alvh6_11",
	fullWidth: "_fullWidth_alvh6_15",
	boxWrapper: "_boxWrapper_alvh6_19"
}, iA = {
	modal: "_modal_1vkwz_1",
	disabled: "_disabled_1vkwz_5"
}, aA = [
	{
		label: "Single Opt-In",
		description: "After providing their information, the customer receives marketing information without any intermediate steps.",
		value: wO.SingleOptIn
	},
	{
		label: "Confirmed Opt-In",
		description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
		value: wO.ConfirmedOptIn
	},
	{
		label: "Unknown",
		description: "The customer receives marketing information but how they were opted in is unknown.",
		value: wO.Unknown
	}
], oA = [
	{
		label: "Not Subscribed",
		description: "The customer hasn’t subscribed to SMS marketing.",
		value: TO.NotSubscribed
	},
	{
		label: "Pending",
		description: "The customer is in the process of subscribing to SMS marketing.",
		value: TO.Pending
	},
	{
		label: "Redacted",
		description: "The customer’s personal data is erased. This value is internally-set and read-only.",
		value: TO.Redacted
	},
	{
		label: "Subscribed",
		description: "The customer is subscribed to SMS marketing.",
		value: TO.Subscribed
	},
	{
		label: "Unsubscribed",
		description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
		value: TO.Unsubscribed
	}
], sA = ({ conversationContext: e, isOpen: t, setIsOpen: n, isMutationLoading: r, setIsMutationLoading: i, refetchCustomer: a }) => {
	let { track: o } = Ve(), { useMutation: s, showNotification: c } = B(), [l, u] = U(), [d, f] = U(), [p, m] = eu(!0), [h, g] = eu(!0), _ = !!l, S = e.customer?.email, C = e.customer?.phone_number, w = e.customer?.given_name, T = e.customer?.family_name, E = {
		email: S ?? "",
		phone: C ?? "",
		firstName: w ?? "",
		lastName: T ?? "",
		smsMarketingState: null,
		smsMarketingOptInLevel: null
	}, j = gl({ defaultValues: E });
	H(() => {
		d?.forEach((e) => {
			let t = e?.field?.[0];
			t && (j.setError(t, {
				type: "server",
				message: e.message
			}), j.setFocus(t));
		});
	}, [d, j]);
	let [M, { error: F, reset: I }] = s(qO, {
		onError: (e) => {
			u(e.message), i(!1), c({
				title: "Something went wrong",
				text: "The customer creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: async (e) => {
			let t = e?.Shopify?.customerCreate?.userErrors || [];
			t.length > 0 ? (f(t), i(!1), c({
				title: "Something went wrong",
				text: "The customer creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			})) : (setTimeout(async () => {
				await a(), i(!1);
			}, 3e3), c({
				title: "Success",
				text: "The customer creation was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), o("shopify:profile:created"), n(!1));
		}
	}), te = Ye((e) => {
		i(!0), u(void 0), M({ variables: { input: {
			firstName: e.firstName,
			lastName: e.lastName,
			...p && { email: e.email },
			...h && { phone: e.phone },
			...e.smsMarketingState && { smsMarketingConsent: {
				marketingState: e.smsMarketingState,
				marketingOptInLevel: e.smsMarketingOptInLevel
			} }
		} } });
	}, [
		M,
		i,
		h,
		p
	]), ne = () => {
		n(!1), I(), u(void 0), j.reset(E);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: t,
		onClose: ne,
		className: iA.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: "Create new customer",
				onClose: ne
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						label: "First name",
						name: "firstName",
						control: j.control,
						rules: { required: "First name is required" }
					})
				}),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						label: "Last name",
						name: "lastName",
						control: j.control,
						rules: { required: "Last name is required" }
					})
				}),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
					label: "Email",
					name: "email",
					control: j.control,
					rules: { required: p ? "Email is required" : void 0 },
					componentProps: {
						className: ht({ [iA.disabled]: !p }),
						prefix: {
							type: "custom",
							value: /* @__PURE__ */ G(ee, {
								disabled: !h,
								name: "hasEmail",
								value: "email",
								checked: p,
								onChange: () => m()
							})
						}
					}
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
					label: "Phone",
					name: "phone",
					control: j.control,
					rules: { required: h ? "Phone is required" : void 0 },
					componentProps: {
						className: ht({ [iA.disabled]: !h }),
						prefix: {
							type: "custom",
							value: /* @__PURE__ */ G(ee, {
								disabled: !p,
								name: "hasPhone",
								value: "phone",
								checked: h,
								onChange: () => g()
							})
						}
					}
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(wl, {
					control: j.control,
					label: "SMS marketing state",
					name: "smsMarketingState",
					rules: { required: {
						value: !0,
						message: "Please select a marketing state"
					} },
					componentProps: {
						placeholder: "Select a marketing state",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => {
							let t = oA.find((t) => t.value === e);
							return /* @__PURE__ */ K(v, {
								flexDirection: "column",
								gap: "100",
								margin: "100 0 200",
								children: [/* @__PURE__ */ G(L.Heading, {
									variant: "heading-3",
									children: t.label
								}), /* @__PURE__ */ G(L.Paragraph, {
									color: "secondary",
									children: t.description
								})]
							});
						}
					},
					children: oA.map((e) => /* @__PURE__ */ G(N.Item, {
						value: e.value,
						children: /* @__PURE__ */ K(v, {
							flexDirection: "column",
							gap: "100",
							children: [/* @__PURE__ */ G(L.Heading, {
								variant: "heading-3",
								children: e.label
							}), /* @__PURE__ */ G(L.Paragraph, {
								color: "secondary",
								children: e.description
							})]
						})
					}, e.value))
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(wl, {
					control: j.control,
					label: "SMS marketing opt-in level",
					name: "smsMarketingOptInLevel",
					rules: { required: {
						value: !0,
						message: "Please select a marketing opt-in level"
					} },
					componentProps: {
						placeholder: "Select a marketing opt-in level",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => {
							let t = aA.find((t) => t.value === e);
							return /* @__PURE__ */ K(v, {
								flexDirection: "column",
								gap: "100",
								margin: "100 0 200",
								children: [/* @__PURE__ */ G(L.Heading, {
									variant: "heading-3",
									children: t.label
								}), /* @__PURE__ */ G(L.Paragraph, {
									color: "secondary",
									children: t.description
								})]
							});
						}
					},
					children: aA.map((e) => /* @__PURE__ */ G(N.Item, {
						value: e.value,
						children: /* @__PURE__ */ K(v, {
							flexDirection: "column",
							gap: "100",
							children: [/* @__PURE__ */ G(L.Heading, {
								variant: "heading-3",
								children: e.label
							}), /* @__PURE__ */ G(L.Paragraph, {
								color: "secondary",
								children: e.description
							})]
						})
					}, e.value))
				}) }),
				_ && /* @__PURE__ */ G(y, { children: /* @__PURE__ */ K(v, {
					flexDirection: "row",
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						name: "close-circle-filled",
						color: "red.500"
					}), /* @__PURE__ */ G(L.Paragraph, { children: l })]
				}) })
			] }) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !(j.formState.isValid && j.formState.isDirty),
					isLoading: r,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: j.handleSubmit(te),
				cancelOnClick: ne,
				confirmName: F ? "Close" : "Save",
				cancelName: F ? void 0 : "Cancel"
			})
		]
	});
}, cA = ({ conversationContext: e, refetchCustomer: t }) => {
	let [n, r] = U(!1), [i, o] = U(!1);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(a, {
		variant: "secondary",
		onClick: () => r(!0),
		isLoading: i,
		loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
		slotStart: /* @__PURE__ */ G(x, {
			size: 14,
			name: "user-plus",
			color: "green.500"
		}),
		className: rA.fullWidth,
		children: "Create new Shopify profile"
	}), /* @__PURE__ */ G(sA, {
		isOpen: n,
		setIsOpen: r,
		isMutationLoading: i,
		setIsMutationLoading: o,
		conversationContext: e,
		refetchCustomer: t
	})] });
}, lA = (e) => {
	let t = e?.match(/shopify\/\w+\/(\d+)/);
	return t ? t[1] : null;
}, uA = "DD MMM YYYY @ HH:mm", dA = {
	wrapper: "_wrapper_10fld_1",
	copyIcon: "_copyIcon_10fld_7"
}, fA = ({ customer: e, shopifyDomain: t, refresh: n, loading: r, networkStatus: i }) => {
	let { isCopied: a, copy: o } = nk(), { isCopied: s, copy: c } = nk(), { track: l } = Ve();
	if (!e) return null;
	let { id: u, displayName: d, defaultEmailAddress: f, defaultPhoneNumber: p, tags: m = [], verifiedEmail: h } = e, g = f?.emailAddress, _ = p?.phoneNumber, y = `https://${t}/admin/customers/${lA(u) ?? ""}`, b = r && i === st.refetch;
	return /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			className: dA.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ G(L.Heading, {
						variant: "heading-3",
						children: d
					}), b ? /* @__PURE__ */ G(P, { size: 14 }) : /* @__PURE__ */ G(R, {
						content: "Reload customer",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: "sync",
							onClick: () => {
								l("shopify:refreshed", { shopifyId: u }), n();
							},
							className: dA.copyIcon
						})
					})]
				}),
				g && /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [
							/* @__PURE__ */ G(x, {
								size: 14,
								name: "mail"
							}),
							/* @__PURE__ */ G(L.ExternalLink, {
								href: `mailto:${g}`,
								children: g
							}),
							/* @__PURE__ */ G(R, {
								content: h ? "Verified email" : "Email is not verified",
								children: /* @__PURE__ */ G(v, {
									alignItems: "center",
									children: /* @__PURE__ */ G(x, {
										size: 14,
										color: h ? "green.500" : "red.500",
										name: h ? "check-circle" : "exclamation"
									})
								})
							})
						]
					}), /* @__PURE__ */ G(R, {
						content: "Copy Email",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(g),
							className: dA.copyIcon
						})
					})]
				}),
				_ && /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ K(v, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ G(L.ExternalLink, {
							href: `tel:${_}`,
							children: _
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ G(x, {
							size: 14,
							name: s ? "done" : "copy",
							onClick: () => c(_),
							className: dA.copyIcon
						})
					})]
				}),
				/* @__PURE__ */ K(v, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "external-link"
					}), /* @__PURE__ */ G(L.ExternalLink, {
						href: y,
						target: "_blank",
						rel: "noreferrer",
						children: "View customer in Shopify"
					})]
				})
			]
		}), m.length > 0 && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Customer Tags"
		}), /* @__PURE__ */ G(v, {
			gap: "200",
			flexDirection: "row",
			flexWrap: "wrap",
			children: m.map((e) => /* @__PURE__ */ G(I, { children: e }, `${u}-${e}`))
		})] })]
	});
}, pA = {
	creationModal: "_creationModal_pbe64_1",
	detailsModal: "_detailsModal_pbe64_5",
	percentageSuffix: "_percentageSuffix_pbe64_9"
}, mA = () => Array.from({ length: 12 }, () => "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789".charAt(Math.floor(Math.random() * 36))).join(""), hA = (e) => {
	let t = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, n = (() => {
		switch (e.minimumRequirementOption) {
			case "quantity": return "greaterThanOrEqualToQuantity";
			case "subtotal": return "greaterThanOrEqualToSubtotal";
			default: return null;
		}
	})(), r = e.maximumUsage;
	return {
		code: e.code,
		title: e.title,
		usageLimit: r === "only-once" ? 1 : null,
		appliesOncePerCustomer: r === "once-per-customer",
		customerGets: {
			value: { [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: t } : t },
			items: { all: !0 }
		},
		context: { all: EO.All },
		...n && { minimumRequirement: { [e.minimumRequirementOption]: { [n]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue } } },
		startsAt: (/* @__PURE__ */ new Date()).toISOString()
	};
}, gA = [{
	label: "Percentage",
	description: "The percentage value of the discount.",
	value: "percentage"
}, {
	label: "Amount",
	description: "The value of the discount.",
	value: "discountAmount"
}], _A = [
	{
		label: "None",
		description: "No minimum requirements.",
		value: "none"
	},
	{
		label: "Quantity",
		description: "Minimum required quantity of items.",
		value: "quantity"
	},
	{
		label: "Subtotal",
		description: "Minimum required order subtotal.",
		value: "subtotal"
	}
], vA = [
	{
		label: "No limit",
		value: "no-limit",
		description: "The discount code can be used unlimited times."
	},
	{
		label: "Only once",
		value: "only-once",
		description: "The discount code can only be used once."
	},
	{
		label: "Once per customer",
		value: "once-per-customer",
		description: "The discount code can be used once per customer."
	}
], yA = Ws, bA = ({ codeDiscount: e }) => {
	let t = e?.codes?.nodes?.[0]?.code, { isCopied: n, copy: r } = Re(), i = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "400",
		children: [/* @__PURE__ */ K(E, { children: [
			/* @__PURE__ */ G(E.Text, { children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "1",
					children: "Title"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: e?.title
				})]
			}) }),
			/* @__PURE__ */ G(E.Text, { children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "1",
					children: "Status"
				}), /* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
						color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "2",
						color: "secondary",
						children: e?.status
					})]
				})]
			}) }),
			/* @__PURE__ */ G(E.Text, { children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "1",
					children: "Usage limit"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: i
				})]
			}) }),
			/* @__PURE__ */ G(E.Text, { children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "1",
					children: "Applies once per customer"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: e?.appliesOncePerCustomer ? "Yes" : "No"
				})]
			}) }),
			/* @__PURE__ */ G(E.Text, { children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "1",
					children: "Starts at"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "2",
					color: "secondary",
					children: yA(e?.startsAt).format(he)
				})]
			}) })
		] }), /* @__PURE__ */ G(_, {
			label: "Discount code",
			children: /* @__PURE__ */ G(T, {
				readOnly: !0,
				value: t,
				suffix: {
					type: "button",
					button: {
						icon: n ? "done" : "copy",
						onClick: () => {
							r(t);
						}
					}
				}
			})
		})]
	});
}, xA = "shopify-discount-code-form", SA = {
	title: "",
	code: "",
	customerGets: void 0,
	customerGetsOption: "percentage",
	minimumRequirementOption: "none",
	minimumRequirementValue: void 0,
	maximumUsage: "only-once"
}, CA = ({ isOpen: e, setIsOpen: t }) => {
	let { track: n } = Ve(), { useMutation: i, showNotification: a } = B(), [o, s] = U([]), [c, l] = U(), u = gl({
		mode: "all",
		defaultValues: SA
	});
	H(() => {
		o?.forEach((e) => {
			let t = e?.field?.[1];
			t && u.setError(t, {
				type: "server",
				message: e.message
			});
		});
	}, [o, u]);
	let d = !!c, f = u.watch("minimumRequirementOption"), p = u.watch("customerGetsOption"), m = Qe(() => {
		switch (f) {
			case "quantity": return "Minimum quantity";
			case "subtotal": return "Minimum subtotal";
			default: return "";
		}
	}, [f]), [h, { loading: g, error: _, reset: x }] = i(JO, {
		onError: () => {
			a({
				title: "Something went wrong",
				text: "The discount code creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: (e) => {
			let t = e?.Shopify?.discountCodeBasicCreate?.userErrors;
			if (t && t.length > 0) s(t);
			else {
				let t = e?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
				t && "codes" in t && l(t), a({
					title: "Success",
					text: "The discount code was created successfully.",
					icon: "check-circle-filled",
					severity: "success"
				}), n("shopify:discount:code:created"), s([]);
			}
		}
	}), S = () => {
		u.setValue("code", mA(), {
			shouldDirty: !0,
			shouldValidate: !0,
			shouldTouch: !0
		});
	}, C = (e) => {
		h({ variables: { input: hA(e) } });
	}, w = () => {
		u.reset(SA), s([]), x(), l(void 0), t(!1);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		onClose: w,
		className: ht({
			[pA.creationModal]: !d,
			[pA.detailsModal]: d
		}),
		children: [
			/* @__PURE__ */ G(A, {
				title: d ? "Discount code details" : "Create new discount code",
				onClose: w
			}),
			/* @__PURE__ */ K(O, { children: [
				d && /* @__PURE__ */ G(bA, { codeDiscount: c }),
				!d && /* @__PURE__ */ K("form", {
					noValidate: !0,
					id: xA,
					onSubmit: u.handleSubmit(C),
					children: [/* @__PURE__ */ G(v, {
						margin: "0 0 400",
						children: /* @__PURE__ */ G(r, {
							variant: "info",
							description: /* @__PURE__ */ G(L.Paragraph, { children: "This code will be eligible for all customers." })
						})
					}), /* @__PURE__ */ K(b, { children: [
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
							label: "Title",
							name: "title",
							control: u.control,
							rules: { required: "Please enter a title" },
							componentProps: { placeholder: "Enter a title" }
						}) }),
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(wl, {
								control: u.control,
								label: "Discount type",
								name: "customerGetsOption",
								rules: { required: "Please select a discount type" },
								componentProps: {
									placeholder: "Select a discount type",
									equalityFn: (e, t) => e === t,
									onChange: () => {
										u.setValue("customerGets", void 0), u.clearErrors("customerGets");
									},
									getItemTitleByValue: (e) => {
										let t = gA.find((t) => t.value === e);
										return /* @__PURE__ */ G(v, {
											margin: "0 0 100",
											children: /* @__PURE__ */ G(L.Heading, {
												variant: "heading-3",
												children: t?.label
											})
										});
									}
								},
								children: gA.map((e) => /* @__PURE__ */ G(N.Item, {
									value: e.value,
									children: /* @__PURE__ */ K(v, {
										flexDirection: "column",
										gap: "100",
										children: [/* @__PURE__ */ G(L.Heading, {
											variant: "heading-3",
											children: e.label
										}), /* @__PURE__ */ G(L.Paragraph, {
											color: "secondary",
											children: e.description
										})]
									})
								}, e.value))
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(El, {
								label: "Discount value",
								name: "customerGets",
								control: u.control,
								rules: {
									required: "Please enter a value",
									validate: (e) => {
										if (e) {
											if (p === "percentage" && (e < 0 || e > 100)) return "Percentage must be between 0 and 100";
											if (p === "discountAmount" && e < 0) return "Discount amount must be greater than 0";
										}
									}
								},
								componentProps: {
									placeholder: "Enter a value",
									type: "number",
									...p === "percentage" && { suffix: {
										type: "custom",
										noWrap: !0,
										value: /* @__PURE__ */ G(v, {
											alignItems: "center",
											className: pA.percentageSuffix,
											children: "%"
										})
									} }
								}
							})
						}),
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
							label: "Code",
							name: "code",
							control: u.control,
							rules: { required: "Please enter a code" },
							componentProps: {
								placeholder: "Enter a code or click to the right to generate",
								suffix: {
									type: "button",
									button: {
										icon: "sync",
										onClick: S
									}
								}
							}
						}) }),
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(wl, {
								control: u.control,
								label: "Minimum purchase requirements",
								name: "minimumRequirementOption",
								rules: { required: "Please select a minimum requirement option" },
								componentProps: {
									placeholder: "Select a minimum purchase requirement",
									equalityFn: (e, t) => e === t,
									onChange: () => {
										u.setValue("minimumRequirementValue", void 0), u.clearErrors("minimumRequirementValue");
									},
									getItemTitleByValue: (e) => {
										let t = _A.find((t) => t.value === e);
										return /* @__PURE__ */ G(v, {
											margin: "0 0 100",
											children: /* @__PURE__ */ G(L.Heading, {
												variant: "heading-3",
												children: t?.label
											})
										});
									}
								},
								children: _A.map((e) => /* @__PURE__ */ G(N.Item, {
									value: e.value,
									children: /* @__PURE__ */ K(v, {
										flexDirection: "column",
										gap: "100",
										children: [/* @__PURE__ */ G(L.Heading, {
											variant: "heading-3",
											children: e.label
										}), /* @__PURE__ */ G(L.Paragraph, {
											color: "secondary",
											children: e.description
										})]
									})
								}, e.value))
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 3,
							children: /* @__PURE__ */ G(El, {
								name: "minimumRequirementValue",
								label: m,
								control: u.control,
								disabled: f === "none",
								rules: {
									required: {
										value: f !== "none",
										message: "Please enter a value"
									},
									validate: (e) => {
										if (e && f !== "none" && e < 0) return `Minimum ${f} must be greater than 0`;
									}
								},
								componentProps: {
									type: "number",
									placeholder: "Enter a value"
								}
							})
						}),
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(wl, {
							name: "maximumUsage",
							label: "Maximum usage",
							control: u.control,
							componentProps: {
								placeholder: "Select a maximum usage",
								equalityFn: (e, t) => e === t,
								getItemTitleByValue: (e) => {
									let t = vA.find((t) => t.value === e);
									return /* @__PURE__ */ G(v, {
										margin: "0 0 100",
										children: /* @__PURE__ */ G(L.Heading, {
											variant: "heading-3",
											children: t?.label
										})
									});
								}
							},
							children: vA.map((e) => /* @__PURE__ */ G(N.Item, {
								value: e.value,
								children: /* @__PURE__ */ K(v, {
									flexDirection: "column",
									gap: "100",
									children: [/* @__PURE__ */ G(L.Heading, {
										variant: "heading-3",
										children: e.label
									}), /* @__PURE__ */ G(L.Paragraph, {
										color: "secondary",
										children: e.description
									})]
								})
							}, e.value))
						}) })
					] })]
				}),
				_ && /* @__PURE__ */ G(z, { error: _ })
			] }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !d && !(u.formState.isValid && u.formState.isDirty),
					isLoading: g,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmName: d ? "Close" : "Save",
				confirmOnClick: d ? w : u.handleSubmit(C),
				cancelOnClick: d ? void 0 : w
			})
		]
	});
}, wA = ({ code: e }) => {
	let { isCopied: t, copy: n } = nk();
	return /* @__PURE__ */ K(v, {
		justifyContent: "space-between",
		alignItems: "center",
		gap: "200",
		width: "100%",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			alignItems: "center",
			children: [/* @__PURE__ */ G(x, {
				size: 12,
				name: "shopify",
				color: "green.500"
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "3",
				children: e
			})]
		}), /* @__PURE__ */ G(S, {
			icon: t ? "done" : "copy",
			onClick: () => n(e),
			variant: "secondary"
		})]
	});
}, TA = ({ discountCode: e }) => {
	let { discount: t } = e;
	if (!("codes" in t)) return null;
	let n = t?.codes?.nodes ?? [];
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "100",
		children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: t.title
		}), /* @__PURE__ */ G(E, { children: n.map((e) => /* @__PURE__ */ G(E.Item, {
			className: rA.listItem,
			children: /* @__PURE__ */ G(wA, { code: e.code })
		}, e.code)) })]
	});
}, EA = {
	modal: "_modal_11d6e_1",
	modalBody: "_modalBody_11d6e_4",
	codeContainer: "_codeContainer_11d6e_9"
}, DA = ({ isOpen: e, setIsOpen: t }) => {
	let { discountNodes: n, isLoading: r, filter: i, setFilter: a, minSearchCharacters: o } = Hk({ enabled: e }), s = n.length === 0, c = () => {
		a(""), t(!1);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		onClose: c,
		className: EA.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: "Discount codes",
				onClose: c
			}),
			/* @__PURE__ */ K(O, {
				className: EA.modalBody,
				children: [
					/* @__PURE__ */ G(T, {
						type: "search",
						icon: "search",
						value: i,
						placeholder: `Search discount codes (min. ${o} characters)`,
						onChange: (e) => {
							a(e.target.value);
						}
					}),
					r && /* @__PURE__ */ G(v, {
						justifyContent: "center",
						margin: "300",
						children: /* @__PURE__ */ G(P, {})
					}),
					!r && s && /* @__PURE__ */ G(u, {
						title: "No discount codes found.",
						description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
					}),
					!r && !s && n.map((e) => /* @__PURE__ */ G("div", {
						className: EA.codeContainer,
						children: /* @__PURE__ */ G(TA, { discountCode: e })
					}, e.id))
				]
			}),
			/* @__PURE__ */ G(k, {
				confirmName: "Close",
				confirmOnClick: c
			})
		]
	});
}, OA = ({ displayDiscountCodeCreation: e }) => {
	let [t, n] = U(!1), [r, i] = U(!1);
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "column",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Discount codes"
			}), /* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "row",
				alignItems: "center",
				width: "100%",
				children: [/* @__PURE__ */ G(v, {
					flex: "1",
					children: /* @__PURE__ */ G(a, {
						variant: "secondary",
						icon: "gift",
						onClick: () => i(!0),
						style: { width: "100%" },
						children: "View discount codes"
					})
				}), e && /* @__PURE__ */ G(v, {
					flex: "1",
					children: /* @__PURE__ */ G(a, {
						variant: "secondary",
						icon: "plus",
						onClick: () => n(!0),
						style: { width: "100%" },
						children: "Create new"
					})
				})]
			})]
		}),
		/* @__PURE__ */ G(DA, {
			isOpen: r,
			setIsOpen: i
		}),
		/* @__PURE__ */ G(CA, {
			isOpen: t,
			setIsOpen: n
		})
	] });
}, kA = ({ ariaLabel: e, value: t, options: n, disabled: r = !1, disabledHint: i, onChange: a }) => /* @__PURE__ */ G(w, {
	"aria-label": e,
	placeholder: r && i ? i : "Select a state",
	tabIndex: 0,
	disabled: r,
	value: t ? [t] : [],
	getItemTitleByValue: (e) => /* @__PURE__ */ G(L.Paragraph, { children: qk(e) }),
	onChange: (e) => {
		let t = e.selectedValues[0];
		t && a(t);
	},
	children: n.map((e) => /* @__PURE__ */ G(N.Item, {
		value: e.value,
		children: /* @__PURE__ */ K(v, {
			flexDirection: "column",
			gap: "100",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-4",
				children: e.label
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "5",
				color: "tertiary",
				children: e.description
			})]
		})
	}, e.value))
}), AA = { modal: "_modal_eygw8_1" }, jA = ({ isOpen: e, customer: t, onClose: n, onSave: r }) => {
	let { defaultEmailAddress: i, defaultPhoneNumber: a } = t, o = $k(i?.marketingState), s = eA(a?.marketingState), [c, l] = U(o), [u, d] = U(s), [f, p] = U(!1);
	H(() => {
		e && (l(o), d(s));
	}, [
		e,
		o,
		s
	]);
	let m = !!i && Yk(i?.marketingState), h = !!a && Yk(a?.marketingState), g = {
		...c && c !== o && { email: c },
		...u && u !== s && { phone: u }
	}, _ = Object.keys(g).length > 0;
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		onClose: n,
		className: AA.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: "Edit marketing consent",
				onClose: n
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K(v, {
				flexDirection: "column",
				gap: "300",
				children: [/* @__PURE__ */ K(v, {
					flexDirection: "column",
					gap: "200",
					children: [/* @__PURE__ */ G(L.Heading, {
						variant: "heading-4",
						children: "Email consent"
					}), /* @__PURE__ */ G(kA, {
						ariaLabel: "Email consent",
						value: c,
						options: Zk,
						disabled: !m || f,
						disabledHint: i ? "Managed by Shopify" : "No email address",
						onChange: l
					})]
				}), /* @__PURE__ */ K(v, {
					flexDirection: "column",
					gap: "200",
					children: [/* @__PURE__ */ G(L.Heading, {
						variant: "heading-4",
						children: "Phone consent"
					}), /* @__PURE__ */ G(kA, {
						ariaLabel: "Phone consent",
						value: u,
						options: Qk,
						disabled: !h || f,
						disabledHint: a ? "Managed by Shopify" : "No phone number",
						onChange: d
					})]
				})]
			}) }),
			/* @__PURE__ */ G(k, {
				confirmName: "Save",
				cancelName: "Cancel",
				confirmOnClick: async () => {
					p(!0);
					let e = await r(g);
					p(!1), e && n();
				},
				cancelOnClick: n,
				confirmProps: {
					disabled: !_ || f,
					isLoading: f,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				cancelProps: { disabled: f }
			})
		]
	});
}, MA = { channelRow: "_channelRow_15phg_1" }, NA = ({ channelName: e, icon: t, consent: n }) => {
	let r = n?.marketingUpdatedAt ? `Last edited: ${yA(n.marketingUpdatedAt).format(uA)}` : "";
	return /* @__PURE__ */ K(v, {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		gap: "200",
		className: MA.channelRow,
		children: [/* @__PURE__ */ K(v, {
			flexDirection: "row",
			alignItems: "center",
			gap: "200",
			children: [
				/* @__PURE__ */ G(x, {
					name: t,
					color: "neutral.500"
				}),
				/* @__PURE__ */ G(L.Heading, {
					variant: "heading-4",
					children: e
				}),
				n?.marketingOptInLevel && /* @__PURE__ */ G(L.Paragraph, {
					variant: "5",
					color: "tertiary",
					children: `(${qk(n.marketingOptInLevel)})`
				})
			]
		}), /* @__PURE__ */ G(R, {
			content: r,
			disabled: !r,
			children: /* @__PURE__ */ G(I, {
				color: Jk(n?.marketingState),
				children: qk(n?.marketingState)
			})
		})]
	});
}, PA = { editIcon: "_editIcon_1dntr_1" }, FA = 14, IA = ({ customer: e, isEditable: t = !1, refetchCustomer: n }) => {
	let [r, i] = U(!1), { updateMarketingConsent: a } = nA({
		customerId: e?.id ?? "",
		refetchCustomer: n
	});
	return e ? /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				flexDirection: "row",
				alignItems: "center",
				gap: "250",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Marketing consent"
				}), t && /* @__PURE__ */ G(R, {
					content: "Edit marketing consent",
					children: /* @__PURE__ */ G(x, {
						size: FA,
						name: "pen",
						className: PA.editIcon,
						"data-testid": "edit-marketing-consent",
						onClick: () => i(!0)
					})
				})]
			}),
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(NA, {
					channelName: "Email",
					icon: "mail",
					consent: e.defaultEmailAddress
				}), /* @__PURE__ */ G(NA, {
					channelName: "Phone",
					icon: "phone",
					consent: e.defaultPhoneNumber
				})]
			}),
			t && /* @__PURE__ */ G(jA, {
				isOpen: r,
				customer: e,
				onClose: () => i(!1),
				onSave: a
			})
		]
	}) : null;
}, LA = (e) => {
	let { discount: t } = e;
	switch (t.__typename) {
		case "Shopify_DiscountCodeBasic": {
			if (t.status !== DO.Active) return null;
			let e = t.codes.nodes[0]?.code;
			if (!e) return null;
			let { value: n } = t.customerGets;
			return n.__typename === "Shopify_DiscountPercentage" ? {
				code: e,
				kind: "percentage",
				percentage: Number((n.percentage * 100).toFixed(2))
			} : n.__typename === "Shopify_DiscountAmount" ? {
				code: e,
				kind: "fixedAmount",
				amount: String(n.amount.amount),
				currencyCode: n.amount.currencyCode
			} : null;
		}
		case "Shopify_DiscountCodeFreeShipping": {
			if (t.status !== DO.Active) return null;
			let e = t.codes.nodes[0]?.code;
			return e ? {
				code: e,
				kind: "freeShipping"
			} : null;
		}
		default: return null;
	}
}, RA = (e) => {
	let t = e.map(LA).filter((e) => !!e), n = /* @__PURE__ */ new Map();
	return t.forEach((e) => {
		n.has(e.code) || n.set(e.code, e);
	}), Array.from(n.values());
}, zA = (e) => {
	if (e) switch (e.kind) {
		case "percentage": return { itemPercentageDiscountCode: {
			code: e.code,
			percentage: e.percentage
		} };
		case "fixedAmount": return { itemFixedDiscountCode: {
			code: e.code,
			amountSet: { shopMoney: {
				amount: e.amount,
				currencyCode: e.currencyCode
			} }
		} };
		case "freeShipping": return { freeShippingDiscountCode: { code: e.code } };
		default: return;
	}
}, BA = (e) => e ? [e.code] : void 0, VA = (e) => {
	switch (e.kind) {
		case "percentage": return `${e.percentage}% off`;
		case "fixedAmount": return `${e.amount} ${e.currencyCode} off`;
		case "freeShipping": return "Free shipping";
		default: return "";
	}
}, HA = ({ enabled: e }) => {
	let t = pc(), { discountNodes: n, isLoading: r, filter: i, setFilter: a, minSearchCharacters: o } = Hk({ enabled: e }), s = Qe(() => RA(n), [n]), c = i.trim().length > 0;
	if (!r && !c && s.length === 0) return null;
	let l = !r && s.length === 0;
	return /* @__PURE__ */ G(wl, {
		label: "Discount code",
		control: t.control,
		name: "discountCode",
		componentProps: {
			clearable: !0,
			placeholder: "Search discount codes",
			tabIndex: 0,
			equalityFn: (e, t) => e?.code === t?.code,
			getItemTitleByValue: (e) => e ? /* @__PURE__ */ K(L.Paragraph, { children: [
				e.code,
				" · ",
				VA(e)
			] }) : null,
			filter: {
				value: i,
				placeholder: `Search discount codes (min. ${o} characters)`,
				onChange: (e) => {
					a(e.target.value);
				}
			},
			onToggleDropdown: (e) => {
				!e && i !== "" && a("");
			}
		},
		children: /* @__PURE__ */ K(W, { children: [
			r && /* @__PURE__ */ G(N.Item, {
				noFixedSelectionStateSpace: !0,
				children: /* @__PURE__ */ G(v, {
					justifyContent: "center",
					padding: "300",
					children: /* @__PURE__ */ G(P, {})
				})
			}),
			!r && s.map((e) => /* @__PURE__ */ G(N.Item, {
				value: e,
				children: /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					alignItems: "center",
					gap: "200",
					children: [c ? /* @__PURE__ */ G(ne, {
						text: e.code,
						highlight: i
					}) : /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: e.code
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "5",
						color: "tertiary",
						children: VA(e)
					})]
				})
			}, e.code)),
			l && /* @__PURE__ */ G(N.Item, {
				noFixedSelectionStateSpace: !0,
				children: /* @__PURE__ */ G(u, {
					title: "No discount codes found",
					description: "Try changing your search criteria."
				})
			})
		] })
	});
}, UA = ({ control: e, name: t, label: n, placeholder: r, required: i = !1, apiUserError: a }) => /* @__PURE__ */ G(xc, {
	name: t,
	control: e,
	rules: { required: i ? {
		value: !0,
		message: "This field is required"
	} : !1 },
	render: ({ field: e, fieldState: t }) => /* @__PURE__ */ G(h, {
		required: i,
		label: n,
		input: e,
		placeholder: r,
		meta: {
			warning: t?.error?.message,
			error: t?.error?.message || a?.[e.name]
		}
	})
}), WA = { modal: "_modal_1wlra_1" };
function GA(e) {
	try {
		return new Intl.DisplayNames(["en"], { type: "region" }).of(e.toUpperCase()) ?? e;
	} catch {
		return e;
	}
}
var KA = /* @__PURE__ */ "AF.AX.AL.DZ.AD.AO.AI.AG.AR.AM.AW.AC.AU.AT.AZ.BS.BH.BD.BB.BY.BE.BZ.BJ.BM.BT.BO.BA.BW.BV.BR.IO.BN.BG.BF.BI.KH.CA.CV.BQ.KY.CF.TD.CL.CN.CX.CC.CO.KM.CG.CD.CK.CR.HR.CU.CW.CY.CZ.CI.DK.DJ.DM.DO.EC.EG.SV.GQ.ER.EE.SZ.ET.FK.FO.FJ.FI.FR.GF.PF.TF.GA.GM.GE.DE.GH.GI.GR.GL.GD.GP.GT.GG.GN.GW.GY.HT.HM.VA.HN.HK.HU.IS.IN.ID.IR.IQ.IE.IM.IL.IT.JM.JP.JE.JO.KZ.KE.KI.KP.XK.KW.KG.LA.LV.LB.LS.LR.LY.LI.LT.LU.MO.MG.MW.MY.MV.ML.MT.MQ.MR.MU.YT.MX.MD.MC.MN.ME.MS.MA.MZ.MM.NA.NR.NP.NL.AN.NC.NZ.NI.NE.NG.NU.NF.MK.NO.OM.PK.PS.PA.PG.PY.PE.PH.PN.PL.PT.QA.CM.RE.RO.RU.RW.BL.SH.KN.LC.MF.PM.WS.SM.ST.SA.SN.RS.SC.SL.SG.SX.SK.SI.SB.SO.ZA.GS.KR.SS.ES.LK.VC.SD.SR.SJ.SE.CH.SY.TW.TJ.TZ.TH.TL.TG.TK.TO.TT.TA.TN.TR.TM.TC.TV.UG.UA.AE.GB.US.UM.UY.UZ.VU.VE.VN.VG.WF.EH.YE.ZM.ZW.ZZ".split("."), qA = "shopify-shiping-address-form", JA = ({ title: e, address: t, isOpen: n, setIsOpen: r, orderId: i, shopifyId: a, shippingCountryCodes: o, onChange: s, refetchOrders: c }) => {
	let { useMutation: l, showNotification: u } = B(), { track: d } = Ve(), [f, p] = U(!1), [m, h] = U({}), g = !s, [_, { error: v, reset: x }] = l(UO, {
		onError: () => {
			p(!1), u({
				title: "Something went wrong",
				text: "The address change was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		},
		onCompleted: (e) => {
			p(!1);
			let t = e?.Shopify?.orderUpdate?.userErrors;
			if (t != null && t.length > 0) {
				let e = t.reduce((e, t) => {
					let n = t.field;
					if (n == null || n.length === 0) return e;
					let r = n[n.length - 1];
					return r != null && (e[r] = t.message), e;
				}, {});
				h(e);
			} else u({
				title: "Success",
				text: "The address change was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), c(), M();
		}
	}), S = Ye(() => ({
		firstName: t?.firstName || "",
		lastName: t?.lastName || "",
		company: t?.company || "",
		address1: t?.address1 || "",
		address2: t?.address2 || "",
		city: t?.city || "",
		countryCodeV2: KA.find((e) => e === t?.countryCodeV2),
		provinceCode: t?.province || "",
		zip: t?.zip || ""
	}), [t]), { control: C, handleSubmit: w, formState: T, reset: E } = gl({
		mode: "all",
		defaultValues: S()
	}), j = w((e) => {
		if (g) {
			if (p(!0), !a || !i) {
				p(!1);
				return;
			}
			d("shopify:order:edit:shipping:address:modal:submitted", {
				shopifyId: a,
				orderId: i
			});
			let { countryCodeV2: t, ...n } = e, r = {
				...n,
				countryCode: t
			};
			_({ variables: { input: {
				id: i,
				shippingAddress: r
			} } });
		} else s(e), M();
	});
	H(() => {
		n && E(S());
	}, [
		n,
		t,
		E,
		S
	]);
	let M = () => {
		E(S()), h({}), x(), r(!1);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: n,
		onClose: M,
		className: WA.modal,
		"data-testid": "edit-shipping-address-modal",
		children: [
			/* @__PURE__ */ G(A, {
				title: e,
				onClose: () => M()
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K("form", {
				noValidate: !0,
				id: qA,
				onSubmit: j,
				children: [v && /* @__PURE__ */ G(z, { error: v }), /* @__PURE__ */ K(b, { children: [
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(UA, {
							required: !0,
							control: C,
							name: "firstName",
							label: "First name",
							placeholder: "Insert your first name",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(UA, {
							required: !0,
							control: C,
							name: "lastName",
							label: "Last name",
							placeholder: "Insert your last name",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 6,
						children: /* @__PURE__ */ G(UA, {
							control: C,
							name: "company",
							label: "Company",
							placeholder: "Insert your company name"
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 6,
						children: /* @__PURE__ */ G(UA, {
							required: !0,
							control: C,
							name: "address1",
							label: "Address",
							placeholder: "Insert your address",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 6,
						children: /* @__PURE__ */ G(UA, {
							control: C,
							name: "address2",
							label: "Additional address details",
							placeholder: "Insert more address details"
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(UA, {
							required: !0,
							control: C,
							name: "zip",
							label: "Zip / postal code",
							placeholder: "Insert your zip / postal code",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(UA, {
							required: !0,
							control: C,
							name: "city",
							label: "City",
							placeholder: "Insert your city",
							apiUserError: m
						})
					}),
					/* @__PURE__ */ G(y, {
						span: 6,
						children: /* @__PURE__ */ G(wl, {
							name: "countryCodeV2",
							control: C,
							label: "Country",
							rules: { required: {
								value: !0,
								message: "Please select a country"
							} },
							componentProps: {
								placeholder: "Select your country",
								getItemTitleByValue: (e) => e ? GA(e) : ""
							},
							children: KA.filter((e) => o.includes(e)).map((e) => /* @__PURE__ */ G(N.Item, {
								value: e,
								children: /* @__PURE__ */ G(L.Paragraph, { children: GA(e) })
							}, e))
						})
					})
				] })]
			}) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !(T.isValid && T.isDirty),
					type: "submit",
					form: qA,
					isLoading: f,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: () => {
					v && M();
				},
				cancelOnClick: () => {
					a && i && !v && d("shopify:order:edit:shipping:address:modal:canceled", {
						shopifyId: a,
						orderId: i
					}), M();
				},
				confirmName: v ? "Close" : "Save",
				cancelName: v ? void 0 : "Cancel"
			})
		]
	});
}, YA = { clickableIcon: "_clickableIcon_33mqm_1" }, XA = ({ formFieldName: e, ...t }) => {
	let { field: n } = bc({
		control: pc().control,
		name: e
	});
	return /* @__PURE__ */ G(ZA, {
		enableEditAddress: !0,
		openByDefault: !0,
		onChange: n.onChange,
		...t
	});
}, ZA = ({ labelText: e, address: t, orderId: n, shopifyId: r, shippingCountryCodes: i, enableEditAddress: a, icon: o = "home", onChange: s, refetchOrders: c, openByDefault: l = !1 }) => {
	let [u, d] = U(!1), [f, p] = U(l), { isCopied: m, copy: h } = nk(), { track: g } = Ve(), _ = a && (!!n || !!s), y = [t?.zip || "", t?.city || ""].filter(Boolean).join(" "), b = [t?.firstName || "", t?.lastName || ""].filter(Boolean).join(" "), S = t?.countryCodeV2 && _e(t.countryCodeV2), C = Ye(() => [
		b,
		t?.company,
		t?.address1,
		t?.address2,
		y,
		t?.province,
		S
	].filter(Boolean).join("\n"), [
		t,
		b,
		y,
		S
	]);
	if (!t) return null;
	let w = () => {
		r && n && g("shopify:order:edit:shipping:address:modal:opened", {
			shopifyId: r,
			orderId: n
		}), d(!0);
	};
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
		justifyContent: "space-between",
		children: [/* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: o,
				color: "green.500"
			}), /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "row",
					onClick: () => p(!f),
					className: YA.clickableIcon,
					alignItems: "center",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						children: e
					}), /* @__PURE__ */ G(x, {
						size: 14,
						name: f ? "angle-down" : "angle-right"
					})]
				}), f && /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [
						b && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: b
						}),
						t?.company && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.company
						}),
						t?.address1 && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.address1
						}),
						t?.address2 && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.address2
						}),
						y && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: y
						}),
						t?.province && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.province
						}),
						S && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: S
						})
					]
				})]
			})]
		}), /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [_ && /* @__PURE__ */ G(R, {
				content: `Edit ${e.toLowerCase()}`,
				children: /* @__PURE__ */ G(x, {
					size: 14,
					name: "pen",
					onClick: () => w(),
					className: YA.clickableIcon
				})
			}), /* @__PURE__ */ G(R, {
				content: `Copy ${e.toLowerCase()}`,
				children: /* @__PURE__ */ G(x, {
					size: 14,
					name: m ? "done" : "copy",
					onClick: () => h(C()),
					className: YA.clickableIcon
				})
			})]
		})]
	}), _ && /* @__PURE__ */ G(JA, {
		title: `Edit ${e}`,
		address: t,
		isOpen: u,
		setIsOpen: d,
		orderId: n,
		shopifyId: r,
		shippingCountryCodes: i,
		onChange: s,
		refetchOrders: c
	})] });
}, QA = ({ withAddresses: e = !0, selectedLineItemIds: t }) => {
	let n = pc(), r = yc({
		control: n.control,
		name: "lineItems"
	}), i = yc({
		control: n.control,
		name: "billingAddress"
	}), a = yc({
		control: n.control,
		name: "shippingAddress"
	}), o = yc({
		control: n.control,
		name: "discountCode"
	}), s = Qe(() => t ? t.length === 0 ? [] : (r || []).filter((e) => t.includes(e.id)) : r, [r, t]), c = Qe(() => !s || s.length === 0 ? 0 : s.reduce((e, t) => e + (t.price?.amount || 0) * (t.quantity || 0), 0), [s]), u = s?.[0]?.price?.currencyCode || "";
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "300",
		children: [
			e && /* @__PURE__ */ K(W, { children: [
				/* @__PURE__ */ K(L.Paragraph, {
					variant: "3",
					children: [
						i?.firstName,
						" ",
						i?.lastName
					]
				}),
				/* @__PURE__ */ G(XA, {
					formFieldName: "billingAddress",
					address: i,
					labelText: "Billing address",
					shippingCountryCodes: [],
					refetchOrders: () => Promise.resolve({})
				}),
				/* @__PURE__ */ G(XA, {
					formFieldName: "shippingAddress",
					address: a,
					labelText: "Shipping address",
					shippingCountryCodes: [],
					icon: "map-pin",
					refetchOrders: () => Promise.resolve({})
				})
			] }),
			/* @__PURE__ */ G(l, {}),
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: "Subtotal"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: `${c.toFixed(2)} ${u}`
				})]
			}),
			o && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ K(L.Paragraph, {
					variant: "4",
					children: [
						"Discount (",
						o.code,
						")"
					]
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: VA(o)
				})]
			}), /* @__PURE__ */ G(L.Paragraph, {
				color: "tertiary",
				variant: "5",
				children: "The discount will be deducted after the order is created."
			})] }),
			/* @__PURE__ */ G(L.Paragraph, {
				color: "tertiary",
				variant: "5",
				children: "Tax and shipping will be calculated by Shopify based on customer address and store settings."
			})
		]
	});
}, $A = {
	productTableHeader: "_productTableHeader_6h6pl_1",
	productImage: "_productImage_6h6pl_5"
}, ej = ({ title: e, imageUrl: t, subtitleLines: n = [], hint: r, highlight: i }) => /* @__PURE__ */ K(v, {
	gap: "200",
	alignItems: "center",
	children: [t && /* @__PURE__ */ G(C, {
		src: t,
		alt: e,
		className: $A.productImage
	}), /* @__PURE__ */ K(v, {
		flexDirection: "column",
		children: [
			i ? /* @__PURE__ */ G(ne, {
				text: e,
				highlight: i
			}) : /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				children: e
			}),
			n.map((e) => /* @__PURE__ */ G(L.Paragraph, {
				variant: "5",
				color: "tertiary",
				children: e
			}, e)),
			r && /* @__PURE__ */ G(L.Paragraph, {
				variant: "5",
				children: r
			})
		]
	})]
}), tj = ({ lineItem: e, index: t, onRemove: n }) => {
	let r = pc(), i = `lineItems.${t}.quantity`, a = r.watch(i);
	return /* @__PURE__ */ K(F.Tr, { children: [
		/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(ej, {
			title: e.title,
			imageUrl: e.imageUrl,
			subtitleLines: sk(e)
		}) }),
		/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			children: e.inventoryQuantity ?? "–"
		}) }),
		/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			children: gk(e.price.amount, e.price.currencyCode)
		}) }),
		/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(El, {
			noLabel: !0,
			noAlert: !0,
			name: i,
			control: r.control,
			componentProps: {
				type: "number",
				min: 1,
				max: e.inventoryQuantity ?? void 0,
				tabIndex: 0
			}
		}, `${i}-${a}`) }),
		/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			children: gk(e.price.amount * a, e.price.currencyCode)
		}) }),
		/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(v, {
			justifyContent: "flex-end",
			children: /* @__PURE__ */ G(S, {
				icon: "trash",
				variant: "secondary",
				onClick: n
			})
		}) })
	] });
}, nj = ({ title: e, stockLabel: t, imageUrl: n, subtitleLines: r, highlight: i, price: a }) => /* @__PURE__ */ K(v, {
	justifyContent: "space-between",
	alignItems: "center",
	children: [/* @__PURE__ */ G(ej, {
		title: e,
		imageUrl: n,
		subtitleLines: r,
		highlight: i
	}), /* @__PURE__ */ K(v, {
		flexDirection: "column",
		alignItems: "flex-end",
		children: [a && /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			children: a
		}), /* @__PURE__ */ G(L.Paragraph, {
			variant: "5",
			children: t
		})]
	})]
}), rj = { dropdown: "_dropdown_7zjgt_1" }, ij = ({ product: e, onVariantSelected: t }) => {
	let [n, r] = U(""), { variants: i, isLoading: o, hasNextPage: s, hasError: c, loadNextPage: l, retry: d } = Wk({ productId: e.id }), f = i.filter((e) => dk(e, n)), p = e.variantsCount?.count, m = e.priceRangeV2.minVariantPrice.currencyCode, h = ik(e), g = !o && i.length > 0 && !f.length, y = (e) => {
		let n = i.find((t) => t.id === e);
		n && t(n), r("");
	};
	return /* @__PURE__ */ G(_, {
		label: `Variant selection for ${e.title}`,
		noAlert: !0,
		children: /* @__PURE__ */ G(w, {
			autoFocus: !0,
			dropdownProps: { className: rj.dropdown },
			placeholder: "Select a variant",
			tabIndex: 0,
			value: [],
			getItemTitleByValue: () => null,
			onChange: (e) => y(e.selectedValues[0]),
			filter: {
				value: n,
				onChange: (e) => {
					r(e.target.value);
				}
			},
			onToggleDropdown: (e) => {
				!e && n !== "" && r("");
			},
			children: /* @__PURE__ */ K(W, { children: [
				f.map((t) => /* @__PURE__ */ G(N.Item, {
					value: t.id,
					isDisabled: ck(t),
					children: /* @__PURE__ */ G(nj, {
						title: e.title,
						imageUrl: t.image?.url ?? h,
						subtitleLines: [...ok(t.selectedOptions), ...t.sku ? [`SKU ${t.sku}`] : []],
						price: gk(Number(t.price), m),
						stockLabel: uk(t.inventoryQuantity)
					})
				}, t.id)),
				o && /* @__PURE__ */ G(N.Item, {
					noFixedSelectionStateSpace: !0,
					children: /* @__PURE__ */ G(v, {
						justifyContent: "center",
						padding: "300",
						children: /* @__PURE__ */ G(P, {})
					})
				}),
				g && /* @__PURE__ */ G(N.Item, {
					noFixedSelectionStateSpace: !0,
					children: /* @__PURE__ */ G(u, {
						title: "No variants found",
						description: "Try changing your search criteria."
					})
				}),
				c && !o && /* @__PURE__ */ G(N.Item, {
					noFixedSelectionStateSpace: !0,
					children: /* @__PURE__ */ K(v, {
						flexDirection: "column",
						alignItems: "center",
						gap: "100",
						padding: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							color: "tertiary",
							children: i.length > 0 ? "Could not load more variants" : "Could not load the variants"
						}), /* @__PURE__ */ G(a, {
							variant: "tertiary",
							onClick: (e) => {
								e.stopPropagation(), d();
							},
							children: "Retry"
						})]
					})
				}),
				s && !c && !o && /* @__PURE__ */ G(N.Item, {
					noFixedSelectionStateSpace: !0,
					children: /* @__PURE__ */ G(v, {
						justifyContent: "center",
						padding: "200",
						children: /* @__PURE__ */ G(a, {
							variant: "tertiary",
							onClick: (e) => {
								e.stopPropagation(), l();
							},
							children: p ? `Load more variants (${i.length} of ${p})` : "Load more variants"
						})
					})
				})
			] })
		})
	});
}, aj = 300, oj = 2, sj = 25, cj = ({ onLineItemSelected: e }) => {
	let { useLazyQuery: t, showNotification: n } = B(), [r, i] = U(""), [a, o] = U([]), [s, c] = U(null), l = pc(), d = l.watch("selectedProductId"), [f, { loading: p, networkStatus: m }] = t(BO, {
		fetchPolicy: "no-cache",
		notifyOnNetworkStatusChange: !0,
		onCompleted: (e) => {
			let t = e?.Shopify?.products?.nodes || [];
			o(t.filter((e) => !!e).sort((e, t) => e.title.localeCompare(t.title)));
		},
		onError: () => {
			o([]), n({
				title: "Something went wrong",
				text: "Could not search for products. Please try again.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
		}
	});
	au(() => {
		r.trim().length >= oj && !p && m === st.ready ? f({ variables: {
			query: r.trim(),
			productCount: sj,
			mediaCount: 1
		} }) : r.trim().length < oj && o([]);
	}, aj, [r]);
	let h = Ye(() => {
		l.setValue("selectedProductId", void 0), c(null);
	}, [l]);
	H(() => {
		if (!d) {
			c(null);
			return;
		}
		let t = a.find((e) => e.id === d);
		if (!t) return;
		let n = fk(t);
		if (n) {
			e(pk(t, n)), h();
			return;
		}
		c((e) => e?.id === t.id ? e : t);
	}, [
		d,
		a,
		e,
		h
	]);
	let g = (t) => {
		s && e(pk(s, t)), h();
	}, _ = (e) => a.find((t) => t.id === e) ?? (s?.id === e ? s : null), y = p && m !== st.ready, b = r.trim().length >= oj, x = !a.length && !y && b;
	return /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ G(wl, {
			noAlert: !0,
			label: "Product selection",
			control: l.control,
			name: "selectedProductId",
			componentProps: {
				clearable: !0,
				placeholder: `Search products (min. ${oj} characters)`,
				tabIndex: 0,
				getItemTitleByValue: (e) => {
					let t = _(e);
					return t ? /* @__PURE__ */ G(L.Paragraph, { children: t.title }) : null;
				},
				filter: {
					value: r,
					onChange: (e) => {
						i(e.target.value);
					}
				},
				onToggleDropdown: (e) => {
					!e && r !== "" && i("");
				}
			},
			children: /* @__PURE__ */ K(W, { children: [
				y && /* @__PURE__ */ G(N.Item, {
					noFixedSelectionStateSpace: !0,
					children: /* @__PURE__ */ G(v, {
						justifyContent: "center",
						padding: "300",
						children: /* @__PURE__ */ G(P, {})
					})
				}),
				!y && a.map((e) => {
					let t = e.variantsCount?.count, n = !e.hasOnlyDefaultVariant && !!t;
					return /* @__PURE__ */ G(N.Item, {
						value: e.id,
						isDisabled: lk(e),
						children: /* @__PURE__ */ G(nj, {
							title: e.title,
							imageUrl: ik(e),
							highlight: r,
							subtitleLines: n ? [`${t} variants`] : [],
							stockLabel: uk(e.totalInventory)
						})
					}, e.id);
				}),
				x && /* @__PURE__ */ G(N.Item, {
					noFixedSelectionStateSpace: !0,
					children: /* @__PURE__ */ G(u, {
						title: "No products found",
						description: "Try changing your search criteria."
					})
				}),
				!b && !y && /* @__PURE__ */ G(N.Item, {
					noFixedSelectionStateSpace: !0,
					children: /* @__PURE__ */ G(u, {
						title: "Search for products",
						description: `Type at least ${oj} characters to search.`
					})
				})
			] })
		}), s && /* @__PURE__ */ G(ij, {
			product: s,
			onVariantSelected: g
		}, s.id)]
	});
}, lj = ({ selectionMode: e = !1, hideDeleteButton: t = !1, hideProductSelect: n = !1, selectedLineItemIds: r = [], disabledLineItemIds: i = [], maxQuantities: a, onToggleSelect: s, onToggleSelectAll: c }) => {
	let l = pc(), d = l.watch("lineItems"), f = !!d?.length, p = e && f ? d.filter((e) => !i.includes(e?.id)) : [], m = p.length > 0 && p.every((e) => r.includes(e?.id)), h = p.some((e) => r.includes(e?.id)) && !m, g = Ye((e) => {
		l.setValue("lineItems", hk(l.getValues("lineItems"), e));
	}, [l]), _ = (e) => {
		l.setValue("lineItems", d.filter((t, n) => n !== e));
	};
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			!n && /* @__PURE__ */ G(cj, { onLineItemSelected: g }),
			!f && /* @__PURE__ */ G(v, {
				margin: "200 0",
				justifyContent: "center",
				className: rA.boxWrapper,
				children: /* @__PURE__ */ G(u, {
					title: "No products selected",
					description: "Select a product above for your new order"
				})
			}),
			f && /* @__PURE__ */ G(v, {
				margin: "300 0",
				children: /* @__PURE__ */ K(F, {
					hoverable: !0,
					framed: !1,
					headerWithBackground: !1,
					className: $A.productTable,
					children: [/* @__PURE__ */ G(F.Thead, {
						className: $A.productTableHeader,
						children: /* @__PURE__ */ K(F.Tr, { children: [
							e && /* @__PURE__ */ G(F.Th, { children: /* @__PURE__ */ G(o, {
								checked: m,
								indeterminate: h,
								onChange: () => c?.(!m)
							}) }),
							/* @__PURE__ */ G(F.Th, { children: "Product" }),
							/* @__PURE__ */ G(F.Th, { children: "In stock" }),
							/* @__PURE__ */ G(F.Th, { children: "Price" }),
							/* @__PURE__ */ G(F.Th, { children: "Quantity" }),
							/* @__PURE__ */ G(F.Th, { children: "Total" }),
							!t && /* @__PURE__ */ G(F.Th, {})
						] })
					}), /* @__PURE__ */ G(F.Tbody, { children: d?.map((n, c) => {
						if (!e) return /* @__PURE__ */ G(tj, {
							lineItem: n,
							index: c,
							onRemove: () => _(c)
						}, `${n?.id}-${c}`);
						let u = `lineItems.${c}.quantity`, d = l.watch(u) || 0, f = r.includes(n.id), p = i.includes(n.id), m = a?.[n.id] ?? n.inventoryQuantity ?? void 0;
						return /* @__PURE__ */ K(F.Tr, {
							style: p ? { opacity: .5 } : void 0,
							children: [
								/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(o, {
									checked: f,
									disabled: p,
									onChange: () => s?.(n.id, !f)
								}) }),
								/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(ej, {
									title: n.title,
									imageUrl: n.imageUrl,
									subtitleLines: sk(n),
									hint: p ? "Already refunded" : void 0
								}) }),
								/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: n.inventoryQuantity ?? "–"
								}) }),
								/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: gk(n.price.amount, n.price.currencyCode)
								}) }),
								/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(El, {
									noLabel: !0,
									noAlert: !0,
									disabled: p || m !== void 0 && m <= 1,
									name: u,
									control: l.control,
									componentProps: {
										type: "number",
										min: 1,
										max: m,
										tabIndex: 0
									}
								}, `${u}-${l.watch(u)}`) }),
								/* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: gk(n.price.amount * d, n.price.currencyCode)
								}) }),
								!t && /* @__PURE__ */ G(F.Td, { children: /* @__PURE__ */ G(v, {
									justifyContent: "flex-end",
									children: /* @__PURE__ */ G(S, {
										icon: "trash",
										variant: "secondary",
										onClick: () => {
											_(c), f && s?.(n.id, !1);
										}
									})
								}) })
							]
						}, `${n.id}-${c}`);
					}) })]
				})
			})
		]
	});
}, uj = ({ previousOrderStatus: e } = {}) => /* @__PURE__ */ G(wl, {
	label: "Payment Status",
	name: "financialStatus",
	control: pc().control,
	rules: { required: {
		value: !0,
		message: "Please select a payment status"
	} },
	componentProps: {
		placeholder: "Select payment status",
		tabIndex: 0,
		getItemTitleByValue: (e) => {
			let t = wk.find((t) => t.value === e);
			return t ? /* @__PURE__ */ K(v, {
				flexDirection: "row",
				gap: "200",
				alignItems: "center",
				margin: "0 0 100 0",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: t.label
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "5",
					color: "secondary",
					children: [
						"(",
						t.description,
						")"
					]
				})]
			}) : null;
		}
	},
	children: wk.map((t) => {
		let n = e && t.value === e;
		return /* @__PURE__ */ G(N.Item, {
			value: t.value,
			children: /* @__PURE__ */ K(v, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ K(v, {
					flexDirection: "row",
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: t.label
					}), n && /* @__PURE__ */ G(L.Paragraph, {
						variant: "5",
						color: "secondary",
						children: "(previous order status)"
					})]
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "5",
					color: "secondary",
					children: t.description
				})]
			})
		}, t.value);
	})
}), dj = () => /* @__PURE__ */ G(wl, {
	label: "Fulfillment Status",
	helpIcon: { text: "Defaults to 'unfulfilled' if nothing is selected" },
	name: "fulfillmentStatus",
	control: pc().control,
	componentProps: {
		clearable: !0,
		placeholder: "Select fulfillment status",
		tabIndex: 0,
		getItemTitleByValue: (e) => {
			let t = Tk.find((t) => t.value === e);
			return t ? /* @__PURE__ */ K(v, {
				gap: "200",
				alignItems: "center",
				margin: "0 0 100 0",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: t.label
				}), /* @__PURE__ */ K(L.Paragraph, {
					variant: "5",
					color: "secondary",
					children: [
						"(",
						t.description,
						")"
					]
				})]
			}) : null;
		}
	},
	children: Tk.map((e) => /* @__PURE__ */ G(N.Item, {
		value: e.value,
		children: /* @__PURE__ */ K(v, {
			flexDirection: "column",
			gap: "100",
			children: [/* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				children: e.label
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "5",
				color: "secondary",
				children: e.description
			})]
		})
	}, e.value))
}), fj = { modal: "_modal_1mprq_1" }, pj = "create-shopify-order-form", mj = ({ isOpen: e, shopifyCustomer: t, displayCreateDraftOrder: n, setIsOpen: r, refetchCustomerOrders: i }) => {
	let { useMutation: a, showNotification: o } = B(), { track: s } = Ve(), [c, l] = U(!1), [u, d] = U(!1), f = {
		firstName: t.defaultAddress?.firstName,
		lastName: t.defaultAddress?.lastName,
		address1: t.defaultAddress?.address1,
		address2: t.defaultAddress?.address2,
		city: t.defaultAddress?.city,
		zip: t.defaultAddress?.zip,
		countryCodeV2: t.defaultAddress?.countryCodeV2,
		phone: t.defaultAddress?.phone
	}, p = {
		selectedProductId: void 0,
		lineItems: [],
		customNote: "",
		tags: [],
		billingAddress: f,
		shippingAddress: f,
		financialStatus: kO.Pending,
		fulfillmentStatus: void 0,
		discountCode: void 0
	}, [m, h] = U([]), g = gl({
		mode: "all",
		defaultValues: p
	}), x = g.watch("lineItems").length > 0, S = () => {
		g.reset(p), h([]), r(!1);
	};
	H(() => {
		m.length > 0 && g.setValue("tags", m, { shouldDirty: !0 });
	}, [m, g]);
	let C = et(!1), w = () => {
		i(), l(!1), o({
			title: "Success",
			text: "The order was created successfully.",
			icon: "check-circle-filled",
			severity: "success"
		}), s("shopify:order:create:succeeded"), S();
	}, T = () => {
		i(), l(!1), o({
			title: "Order created but not marked as paid",
			text: "The order was created but recording the payment failed. You can mark it as paid in Shopify.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), S();
	}, E = () => {
		l(!1), o({
			title: "Something went wrong",
			text: "The order creation was not successful.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), s("shopify:order:create:failed"), S();
	}, [j] = a(ZO, {
		onError: T,
		onCompleted: (e) => {
			let t = e.Shopify?.orderMarkAsPaid?.userErrors;
			if (t && t.length > 0) {
				T();
				return;
			}
			w();
		}
	}), [M, { error: N }] = a(YO, {
		onError: E,
		onCompleted: (e) => {
			let t = e.Shopify?.orderCreate, n = t?.order?.id;
			if (t?.userErrors?.length || !n) {
				E();
				return;
			}
			if (C.current) {
				j({ variables: { input: { id: n } } });
				return;
			}
			w();
		}
	}), [ee, { error: F }] = a(XO, {
		onError: () => {
			d(!1), o({
				title: "Something went wrong",
				text: "The draft order creation was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), s("shopify:order:create:draft:failed"), S();
		},
		onCompleted: () => {
			i(), d(!1), o({
				title: "Success",
				text: "The draft order creation was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), s("shopify:order:create:draft:succeeded"), S();
		}
	}), I = (e) => {
		let n = e.lineItems.map(Ok);
		l(!0);
		let r = Ak(e?.billingAddress), i = Ak(e?.shippingAddress), a = e.financialStatus === kO.Paid;
		C.current = a, M({ variables: { order: {
			lineItems: n,
			customer: { toAssociate: { id: t?.id } },
			note: e.customNote,
			tags: e.tags,
			financialStatus: a ? void 0 : e.financialStatus,
			fulfillmentStatus: Ek(e.fulfillmentStatus),
			discountCode: zA(e.discountCode),
			shippingAddress: i,
			billingAddress: r
		} } });
	}, L = (e) => {
		let n = e.lineItems.map(kk);
		d(!0);
		let r = Ak(e?.billingAddress), i = Ak(e?.shippingAddress);
		ee({ variables: { input: {
			email: t.defaultEmailAddress?.emailAddress,
			note: e.customNote,
			tags: e.tags,
			lineItems: n,
			discountCodes: BA(e.discountCode),
			shippingAddress: i,
			billingAddress: r
		} } });
	};
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		onClose: S,
		className: fj.modal,
		allowEscClose: !1,
		children: [
			/* @__PURE__ */ G(A, {
				title: "Create new order",
				onClose: S
			}),
			/* @__PURE__ */ K(O, { children: [/* @__PURE__ */ G(mc, {
				...g,
				children: /* @__PURE__ */ G("form", {
					id: pj,
					children: /* @__PURE__ */ K(b, { children: [
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(lj, {}) }),
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(xc, {
							name: "tags",
							render: ({ fieldState: { error: t } }) => /* @__PURE__ */ G(_, {
								label: "Tags",
								meta: { error: t?.message },
								children: /* @__PURE__ */ G("div", {
									tabIndex: 0,
									onKeyDown: (e) => {
										e.key === "Enter" && (e.preventDefault(), e.stopPropagation());
									},
									children: /* @__PURE__ */ G(te, {
										placeholder: "Type and hit enter to add tags",
										selectedTags: m,
										onChange: (e) => {
											h(e);
										}
									}, `tags-input-${e}`)
								})
							})
						}) }),
						/* @__PURE__ */ G(y, {
							span: 4,
							children: /* @__PURE__ */ K(v, {
								flexDirection: "column",
								gap: "300",
								children: [
									/* @__PURE__ */ G(uj, {}),
									/* @__PURE__ */ G(dj, {}),
									/* @__PURE__ */ G(HA, { enabled: e }),
									/* @__PURE__ */ G(El, {
										label: "Custom note",
										name: "customNote",
										componentProps: {
											placeholder: "Enter custom note",
											tabIndex: 0
										}
									})
								]
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 2,
							children: /* @__PURE__ */ G(_, {
								label: "Details",
								noAlert: !0,
								children: /* @__PURE__ */ G(v, {
									flexDirection: "column",
									gap: "200",
									justifyContent: "end",
									className: rA.boxWrapper,
									children: /* @__PURE__ */ G(QA, {})
								})
							})
						})
					] })
				})
			}), (N || F) && /* @__PURE__ */ G(z, { error: N || F })] }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					type: "submit",
					form: pj,
					disabled: !x || c,
					isLoading: c,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Create order",
				confirmOnClick: g.handleSubmit(I),
				...n && {
					confirmSecondaryName: "Create draft order",
					confirmSecondaryOnClick: () => {
						g.handleSubmit(L)();
					},
					confirmSecondaryProps: {
						type: "submit",
						form: pj,
						disabled: !x || u,
						isLoading: u,
						loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
						tabIndex: 0
					}
				}
			})
		]
	});
}, hj = { modal: "_modal_al73g_1" }, gj = [
	{
		label: "Customer",
		value: OO.Customer,
		description: "The customer wanted to cancel the order."
	},
	{
		label: "Declined",
		value: OO.Declined,
		description: "Payment was declined."
	},
	{
		label: "Fraud",
		value: OO.Fraud,
		description: "The order was fraudulent."
	},
	{
		label: "Inventory",
		value: OO.Inventory,
		description: "There was insufficient inventory."
	},
	{
		label: "Other",
		value: OO.Other,
		description: "The order was canceled for an unlisted reason."
	},
	{
		label: "Staff",
		value: OO.Staff,
		description: "Staff made an error."
	}
], _j = ({ orderId: e, isOpen: t, orderName: n, setIsOpen: r, isMutationLoading: i, setIsMutationLoading: a, refetchOrders: o }) => {
	let { track: s } = Ve(), { useMutation: c, showNotification: l } = B(), [u, d] = U([]), f = u.length > 0, p = {
		orderId: e,
		reason: null,
		refundMethod: { originalPaymentMethodsRefund: !0 },
		restock: !0,
		notifyCustomer: !1,
		staffNote: ""
	}, m = gl({ defaultValues: p }), [h, { error: g, reset: S }] = c(GO, {
		onError: () => {
			a(!1), l({
				title: "Something went wrong",
				text: "Could not cancel the order.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), r(!1);
		},
		onCompleted: async (e) => {
			let t = e.Shopify?.orderCancel?.orderCancelUserErrors || [];
			if (t.length > 0) a(!1), d(t), l({
				title: "Something went wrong",
				text: "Could not cancel the order.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			});
			else {
				let t = e.Shopify?.orderCancel?.job?.done;
				setTimeout(async () => {
					await o().finally(() => a(!1));
				}, t ? 0 : 4e3), l({
					title: "Success",
					text: `${t ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
					icon: "check-circle-filled",
					severity: "success"
				}), s("shopify:order:cancelled"), r(!1);
			}
		}
	}), C = Ye((e) => {
		e.reason != null && (a(!0), h({ variables: {
			orderId: e.orderId,
			reason: e.reason,
			refundMethod: e.refundMethod,
			restock: e.restock,
			notifyCustomer: e.notifyCustomer,
			staffNote: e.staffNote ?? ""
		} }));
	}, [e]), w = () => {
		r(!1), S(), d([]), m.reset(p);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: t,
		onClose: w,
		className: hj.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: `Cancel order ${n}`,
				onClose: w
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(wl, {
					control: m.control,
					label: "Reason",
					name: "reason",
					rules: { required: {
						value: !0,
						message: "Please select a reason"
					} },
					componentProps: {
						placeholder: "Select a reason",
						equalityFn: (e, t) => e === t,
						getItemTitleByValue: (e) => {
							if (!e) return "";
							let t = gj.find((t) => t.value === e);
							return /* @__PURE__ */ K(v, {
								flexDirection: "row",
								gap: "200",
								children: [/* @__PURE__ */ G(L.Heading, {
									variant: "heading-3",
									children: t.label
								}), /* @__PURE__ */ G(L.Paragraph, {
									color: "secondary",
									children: t.description
								})]
							});
						}
					},
					children: gj.map((e) => /* @__PURE__ */ G(N.Item, {
						value: e.value,
						children: /* @__PURE__ */ K(v, {
							flexDirection: "row",
							gap: "200",
							children: [/* @__PURE__ */ G(L.Heading, {
								variant: "heading-3",
								children: e.label
							}), /* @__PURE__ */ G(L.Paragraph, {
								color: "secondary",
								children: e.description
							})]
						})
					}, e.value))
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Refund order",
					children: /* @__PURE__ */ G(X, {
						control: m.control,
						name: "refundMethod.originalPaymentMethodsRefund"
					})
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Restock items",
					children: /* @__PURE__ */ G(X, {
						control: m.control,
						name: "restock"
					})
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Notify the customer",
					children: /* @__PURE__ */ G(X, {
						control: m.control,
						name: "notifyCustomer"
					})
				}) }),
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(El, {
					name: "staffNote",
					label: "Staff note",
					control: m.control
				}) }),
				f && /* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(v, {
					gap: "200",
					flexDirection: "column",
					children: u.map((e) => /* @__PURE__ */ K(v, {
						flexDirection: "row",
						gap: "200",
						alignItems: "center",
						children: [
							/* @__PURE__ */ G(x, {
								name: "close-circle-filled",
								color: "red.500"
							}),
							/* @__PURE__ */ G(L.Heading, {
								variant: "heading-3",
								children: e.code
							}),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"(",
								e.field?.join(","),
								") ",
								e.message
							] })
						]
					}, e.code))
				}) })
			] }) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !(m.formState.isValid && m.formState.isDirty),
					isLoading: i,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: m.handleSubmit(C),
				cancelOnClick: w,
				confirmName: g ? "Close" : "Cancel order",
				cancelName: g ? void 0 : "Cancel"
			})
		]
	});
}, vj = ({ orderId: e, orderName: t, refetchOrders: n, disabled: r }) => {
	let [i, o] = U(!1), [s, c] = U(!1);
	return /* @__PURE__ */ K(v, {
		width: "100%",
		children: [/* @__PURE__ */ G(a, {
			variant: "secondary",
			onClick: () => o(!0),
			isLoading: s,
			loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
			disabled: r,
			slotStart: /* @__PURE__ */ G(x, {
				size: 14,
				name: "close-circle-filled",
				color: "red.500"
			}),
			className: rA.fullWidth,
			children: "Cancel"
		}), /* @__PURE__ */ G(_j, {
			orderId: e,
			orderName: t,
			isOpen: i,
			setIsOpen: o,
			isMutationLoading: s,
			setIsMutationLoading: c,
			refetchOrders: n
		})]
	});
}, yj = { modal: "_modal_1mprq_1" }, bj = ({ order: e, orderName: t, isOpen: n, shopifyId: r, setIsOpen: i, refetchOrders: a }) => {
	let { useMutation: o, showNotification: s } = B(), { track: c } = Ve(), [l, u] = U(!1), [d, f] = U(e?.tags || []), p = "duplicate-shopify-order-form", m = (e) => ({
		firstName: e?.firstName,
		lastName: e?.lastName,
		company: e?.company,
		address1: e?.address1,
		address2: e?.address2,
		city: e?.city,
		provinceCode: e?.provinceCode,
		zip: e?.zip,
		countryCode: e?.countryCodeV2,
		phone: e?.phone
	}), h = {
		selectedProductId: void 0,
		lineItems: [],
		customNote: "",
		tags: e?.tags || [],
		billingAddress: m(e?.billingAddress ?? e?.shippingAddress),
		shippingAddress: m(e?.shippingAddress),
		financialStatus: void 0,
		fulfillmentStatus: void 0,
		discountCode: void 0
	}, g = gl({
		mode: "all",
		defaultValues: h
	}), x = g.watch("lineItems").length > 0;
	H(() => {
		if (!n || g.getValues("lineItems")?.length) return;
		let t = (e?.lineItems ?? []).map((e) => mk(e, e.quantity || 1)).filter((e) => !!e);
		t.length > 0 && g.setValue("lineItems", t, { shouldDirty: !0 });
	}, [
		n,
		e,
		g
	]), H(() => {
		(d.length > 0 || (g.getValues("tags") || []).length > 0) && g.setValue("tags", d, { shouldDirty: !0 });
	}, [d, g]);
	let S = et(!1), C = () => {
		a(), u(!1), s({
			title: "Success",
			text: "The order was duplicated successfully.",
			icon: "check-circle-filled",
			severity: "success"
		}), c("shopify:order:duplicate:succeeded"), ee();
	}, w = () => {
		a(), u(!1), s({
			title: "Order duplicated but not marked as paid",
			text: "The order was duplicated but recording the payment failed. You can mark it as paid in Shopify.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), ee();
	}, T = () => {
		u(!1), s({
			title: "Something went wrong",
			text: "The order duplication was not successful.",
			icon: "exclamation-triangle-filled",
			severity: "warning"
		}), c("shopify:order:duplicate:failed"), ee();
	}, [E] = o(ZO, {
		onError: w,
		onCompleted: (e) => {
			let t = e.Shopify?.orderMarkAsPaid?.userErrors;
			if (t && t.length > 0) {
				w();
				return;
			}
			C();
		}
	}), [j, { error: M }] = o(YO, {
		onError: T,
		onCompleted: (e) => {
			let t = e.Shopify?.orderCreate, n = t?.order?.id;
			if (t?.userErrors?.length || !n) {
				T();
				return;
			}
			if (S.current) {
				E({ variables: { input: { id: n } } });
				return;
			}
			C();
		}
	}), N = (t) => {
		let n = t.lineItems.map(Ok), i = (e?.shippingLines ?? []).map((e) => ({
			title: e.title,
			code: e.code,
			source: e.source,
			priceSet: { shopMoney: {
				amount: e.discountedPriceSet?.shopMoney?.amount ?? "0.00",
				currencyCode: e.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
			} }
		}));
		u(!0);
		let a = t.financialStatus === kO.Paid;
		S.current = a, j({ variables: { order: {
			customer: { toAssociate: { id: r } },
			lineItems: n,
			shippingLines: i,
			note: t.customNote,
			tags: t.tags,
			financialStatus: a ? void 0 : t.financialStatus,
			fulfillmentStatus: Ek(t.fulfillmentStatus),
			discountCode: zA(t.discountCode),
			shippingAddress: Ak(t?.shippingAddress),
			billingAddress: Ak(t?.billingAddress)
		} } });
	}, ee = () => {
		g.reset(h), f(e?.tags || []), i(!1);
	};
	return /* @__PURE__ */ K(D, {
		isOpen: n,
		onClose: ee,
		className: yj.modal,
		allowEscClose: !1,
		children: [
			/* @__PURE__ */ G(A, {
				title: `Duplicate order ${t}`,
				onClose: ee
			}),
			/* @__PURE__ */ K(O, { children: [/* @__PURE__ */ G(mc, {
				...g,
				children: /* @__PURE__ */ G("form", {
					id: p,
					children: /* @__PURE__ */ K(b, { children: [
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(lj, {}) }),
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(xc, {
							name: "tags",
							render: ({ fieldState: { error: e } }) => /* @__PURE__ */ G(_, {
								label: "Tags",
								meta: { error: e?.message },
								children: /* @__PURE__ */ G("div", {
									tabIndex: 0,
									onKeyDown: (e) => {
										e.key === "Enter" && (e.preventDefault(), e.stopPropagation());
									},
									children: /* @__PURE__ */ G(te, {
										placeholder: "Type and hit enter to add tags",
										selectedTags: d,
										onChange: (e) => {
											f(e);
										}
									}, `tags-input-${n}`)
								})
							})
						}) }),
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(HA, { enabled: n }) }),
						/* @__PURE__ */ G(y, {
							span: 4,
							children: /* @__PURE__ */ K(v, {
								flexDirection: "column",
								gap: "300",
								children: [
									/* @__PURE__ */ G(uj, { previousOrderStatus: e?.displayFinancialStatus }),
									/* @__PURE__ */ G(dj, {}),
									/* @__PURE__ */ G(El, {
										label: "Custom note",
										name: "customNote",
										componentProps: {
											placeholder: "Enter custom note",
											tabIndex: 0
										}
									})
								]
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 2,
							children: /* @__PURE__ */ G(_, {
								label: "Details",
								noAlert: !0,
								children: /* @__PURE__ */ G(v, {
									flexDirection: "column",
									gap: "200",
									justifyContent: "end",
									className: rA.boxWrapper,
									children: /* @__PURE__ */ G(QA, {})
								})
							})
						})
					] })
				})
			}), M && /* @__PURE__ */ G(z, { error: M })] }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					type: "submit",
					form: p,
					disabled: !x || l,
					isLoading: l,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Create order",
				confirmOnClick: g.handleSubmit(N)
			})
		]
	});
}, xj = { copyIcon: "_copyIcon_1dlzg_1" }, Sj = ({ orderId: e, lineItems: t, refundedQuantities: n = {} }) => {
	let { isCopied: r, copy: i } = nk();
	if (!t || t?.length === 0) return null;
	let a = Object.values(n).some((e) => e > 0), o = t.every(({ id: e, quantity: t }) => (n[e] || 0) >= t), s = t.map((e) => {
		let t = Dk(e), n = `${e.quantity}x ${e.title}`;
		return t.length > 0 ? `${n} (${t.join(", ")})` : n;
	}).join("\n");
	return /* @__PURE__ */ K(v, {
		gap: "100",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "row",
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "shopify",
						color: "green.500"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						children: "Line items"
					})]
				}), /* @__PURE__ */ G(R, {
					content: "Copy line items",
					children: /* @__PURE__ */ G(x, {
						size: 14,
						name: r ? "done" : "copy",
						onClick: () => i(s),
						className: xj.copyIcon
					})
				})]
			}),
			a && /* @__PURE__ */ G(v, {
				gap: "100",
				flexDirection: "row",
				margin: "200 0 0",
				justifyContent: "center",
				children: /* @__PURE__ */ G(I, {
					color: "red.500",
					children: o ? "The order has been refunded" : "Order has refunded items"
				})
			}),
			/* @__PURE__ */ G(E, { children: t.map((t) => {
				let { id: r, title: i, quantity: a, image: o } = t, s = Dk(t), c = n[r], l = c > 0, u = c > 1 ? `Refunded (${c} items)` : "Refunded";
				return /* @__PURE__ */ G(E.Item, {
					contentLeft: /* @__PURE__ */ K(v, {
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, { children: a }), /* @__PURE__ */ G(L.Paragraph, { children: "×" })]
					}),
					title: /* @__PURE__ */ K(v, {
						flexDirection: "column",
						children: [
							/* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: i
							}),
							s.map((e) => /* @__PURE__ */ G(L.Paragraph, {
								variant: "5",
								color: "tertiary",
								children: e
							}, e)),
							l && /* @__PURE__ */ G(L.Paragraph, {
								variant: "3",
								color: "red.500",
								children: u
							})
						]
					}),
					contentRight: o?.url && /* @__PURE__ */ G(C, {
						src: `${o?.url}&height=48`,
						alt: i
					})
				}, `list-${e}-${r}`);
			}) })
		]
	});
}, Cj = ut`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, wj = (e) => {
	let t = [];
	return e.refunds.forEach((e) => {
		let n = e.refundLineItems.edges.filter((e) => e.node.id !== null);
		n.length > 0 && t.push({
			...e,
			refundLineItems: {
				...e.refundLineItems,
				edges: n
			}
		});
	}), t;
}, Tj = (e) => {
	let t = {}, n = wj(e);
	return e.lineItems?.forEach((e) => {
		t[e.id] = 0;
	}), n.forEach((e) => {
		e.refundLineItems.edges.forEach((e) => {
			let n = e.node;
			if (n.id !== null) {
				let e = n.lineItem.id;
				t[e] += n.quantity;
			}
		});
	}), t;
}, Ej = (e, t) => `${Number(e || 0).toFixed(2)} ${t}`, Dj = "To restock items, the Dixa app must be re-authorised in Shopify. Please contact your admin", Oj = ({ refund: e, currencyCode: t, refundShipping: n, onToggleShipping: r, isLoading: i = !1, restockItems: a, onToggleRestock: o, restockItemsLabel: s, restockDisabled: c = !1, canRestock: l }) => {
	let u = e?.currency || t, d = Number(e?.shipping.maximumRefundable || 0) > 0, f = d && n;
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "300",
		children: [
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: "Subtotal"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: Ej(e?.subtotal || "0", u)
				})]
			}),
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: "Tax"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: Ej(e?.tax || "0", u)
				})]
			}),
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ K(v, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ G(ee, {
						name: "refundShipping",
						value: "shipping",
						checked: f,
						disabled: !d || i,
						onChange: () => r(!n)
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						subdued: !f,
						children: "Refund shipping"
					})]
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					subdued: !f,
					children: Ej(e?.shipping.amount || "0", u)
				})]
			}),
			/* @__PURE__ */ K(v, {
				alignItems: "center",
				gap: "200",
				children: [
					/* @__PURE__ */ G(ee, {
						name: "restockItems",
						value: "restock",
						checked: l && a,
						disabled: c || !l,
						onChange: () => o(!a)
					}),
					/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						subdued: !l || !a,
						children: s
					}),
					!l && /* @__PURE__ */ G(R, {
						content: Dj,
						wrap: "span",
						children: /* @__PURE__ */ G("span", {
							"aria-label": Dj,
							role: "img",
							children: /* @__PURE__ */ G(x, {
								name: "info",
								size: 16
							})
						})
					})
				]
			}),
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: "Total refund"
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: Ej(e?.amount || "0", u)
				})]
			})
		]
	});
}, kj = { modal: "_modal_1mprq_1" }, Aj = "partial-refund-shopify-order-form", jj = ({ order: e, orderName: t, isOpen: n, setIsOpen: r, refetchOrders: i, canRestockOnRefund: a }) => {
	let { useMutation: o, showNotification: s } = B(), { track: c } = Ve(), [l, u] = U(!1), [d, f] = U([]), [p, m] = U(!1), [h, g] = U(!1), x = Qe(() => e?.refunds ? Tj(e) : {}, [e]), S = Qe(() => (e?.lineItems || []).filter((e) => (x[e.id] || 0) >= (e.quantity || 0)).map((e) => e.id), [e, x]), C = Qe(() => {
		let t = {};
		return (e?.lineItems || []).forEach((e) => {
			let n = x[e.id] || 0;
			t[e.id] = Math.max(0, (e.quantity || 0) - n);
		}), t;
	}, [e, x]), w = {
		selectedProductId: void 0,
		lineItems: [],
		customNote: ""
	}, T = gl({
		mode: "all",
		defaultValues: w
	}), E = d.length > 0;
	H(() => {
		E || (p && m(!1), h && g(!1));
	}, [
		E,
		p,
		h
	]);
	let j = yc({
		control: T.control,
		name: "lineItems"
	}), M = Qe(() => (j || []).filter((e) => d.includes(e.id)).map((e) => {
		let t = C[e.id] ?? 0, n = Math.max(0, Math.min(t, e.quantity || 0));
		return n > 0 ? {
			lineItemId: e.id,
			quantity: n
		} : void 0;
	}).filter((e) => !!e), [
		j,
		d,
		C
	]), { suggestedRefund: N, isLoading: ee, error: F } = Nk({
		orderId: e.id,
		refundShipping: p,
		canReadLocations: a,
		refundLineItems: M,
		skip: !E
	}), { suggestedRefund: I, isLoading: te, error: L } = Nk({
		orderId: e.id,
		refundShipping: !1,
		suggestFullRefund: !0,
		skip: !n || !h,
		canReadLocations: a
	}), [ne, { error: re }] = o(Cj, {
		onError: () => {
			s({
				title: "Something went wrong",
				text: "The partial refund was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), c("shopify:order:partial:refund:failed"), R();
		},
		onCompleted: () => {
			i(), s({
				title: "Success",
				text: "The partial refund was created successfully.",
				icon: "check-circle-filled",
				severity: "success"
			}), c("shopify:order:partial:refund:succeeded"), R();
		}
	});
	H(() => {
		if (!n || T.getValues("lineItems")?.length) return;
		let t = (e?.lineItems ?? []).map((e) => {
			let t = x[e.id] || 0, n = (e.quantity || 1) - t;
			return mk(e, n > 0 ? n : e.quantity || 1);
		}).filter((e) => !!e);
		t.length > 0 && (T.setValue("lineItems", t, { shouldDirty: !0 }), f([]));
	}, [
		n,
		e,
		T,
		x
	]);
	let ie = (t) => {
		u(!0), ne({ variables: { input: yk({
			orderId: e.id,
			transactions: N?.transactions,
			refundLineItems: bk({
				refundLineItems: xk({
					selectedLineItems: M,
					restockSource: I?.refundLineItems ?? []
				}),
				restock: a && h
			}),
			refundShipping: p,
			note: t.customNote || void 0,
			notify: !0
		}) } });
	}, R = () => {
		T.reset(w), u(!1), g(!1), r(!1);
	}, ae = M.length > 1 ? "Restock selected items" : "Restock selected item", oe = re ?? F ?? L;
	return /* @__PURE__ */ K(D, {
		isOpen: n,
		onClose: R,
		className: kj.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: `Refund order ${t}`,
				onClose: R
			}),
			/* @__PURE__ */ K(O, { children: [/* @__PURE__ */ G(mc, {
				...T,
				children: /* @__PURE__ */ G("form", {
					id: Aj,
					children: /* @__PURE__ */ K(b, { children: [
						/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(lj, {
							selectionMode: !0,
							hideDeleteButton: !0,
							hideProductSelect: !0,
							selectedLineItemIds: d,
							disabledLineItemIds: S,
							maxQuantities: C,
							onToggleSelect: (e, t) => {
								f((n) => t ? Array.from(/* @__PURE__ */ new Set([...n, e])) : n.filter((t) => t !== e));
							},
							onToggleSelectAll: (e) => {
								let t = (T.getValues("lineItems") || []).map((e) => e.id).filter((e) => !S.includes(e));
								f(e ? t : []);
							}
						}) }),
						/* @__PURE__ */ G(y, {
							span: 4,
							children: /* @__PURE__ */ G(v, {
								flexDirection: "column",
								gap: "300",
								children: /* @__PURE__ */ G(El, {
									label: "Custom note",
									name: "customNote",
									componentProps: {
										placeholder: "Enter custom note (optional)",
										tabIndex: 0
									}
								})
							})
						}),
						/* @__PURE__ */ G(y, {
							span: 2,
							children: /* @__PURE__ */ G(_, {
								label: "Details",
								noAlert: !0,
								children: /* @__PURE__ */ G(v, {
									flexDirection: "column",
									gap: "200",
									justifyContent: "end",
									className: rA.boxWrapper,
									children: /* @__PURE__ */ G(Oj, {
										refund: N,
										currencyCode: e.currencyCode,
										refundShipping: p,
										onToggleShipping: m,
										isLoading: ee,
										restockItems: h,
										onToggleRestock: g,
										restockItemsLabel: ae,
										restockDisabled: !E || ee || l,
										canRestock: a
									})
								})
							})
						})
					] })
				})
			}), oe && /* @__PURE__ */ G(z, { error: oe })] }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					type: "submit",
					form: Aj,
					disabled: !E || l || ee || !N || h && (te || !I),
					isLoading: l,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Refund selected",
				confirmOnClick: T.handleSubmit(ie)
			})
		]
	});
}, Mj = { modal: "_modal_al73g_1" }, Nj = ({ order: e, shopifyId: t, orderLink: n, isOpen: r, setIsOpen: i, refetchOrders: a, canRestockOnRefund: o }) => {
	let { useMutation: s, showNotification: c } = B(), { track: l } = Ve(), { id: u, name: d, currencyCode: f } = e, [p, m] = U(!0), [h, g] = U(!1), [_, y] = U(), { suggestedRefund: b, isLoading: S, error: C } = Nk({
		orderId: u,
		suggestFullRefund: !0,
		refundShipping: p,
		skip: !r,
		canReadLocations: o
	}), [w, { loading: T }] = s(WO, {
		onError: (e) => y(e),
		onCompleted: (e) => {
			let t = e.Shopify?.refundCreate?.userErrors;
			if (t && t.length > 0) {
				y(new rt({ graphQLErrors: t.map((e) => ({ message: e.message })) }));
				return;
			}
			c({
				title: "Order refunded",
				text: `You refunded order ${d}`,
				icon: "check-circle-filled",
				severity: "success"
			}), a(), E();
		}
	}), E = () => {
		m(!0), g(!1), y(void 0), i(!1);
	}, M = () => {
		b && (l("shopify:order:refund:confirmed", {
			shopifyId: t,
			orderId: u
		}), w({ variables: { input: yk({
			orderId: u,
			transactions: b.transactions,
			refundLineItems: bk({
				refundLineItems: b.refundLineItems,
				restock: o && h
			}),
			refundShipping: p,
			notify: e.suggestedRefund.notify
		}) } }));
	}, N = (b?.refundLineItems.length ?? 0) > 1 ? "Restock items" : "Restock item", ee = _ ?? C;
	return /* @__PURE__ */ K(D, {
		isOpen: r,
		onClose: E,
		className: Mj.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: `Refund order ${d}`,
				onClose: E
			}),
			/* @__PURE__ */ G(O, { children: /* @__PURE__ */ K(v, {
				flexDirection: "column",
				gap: "300",
				children: [/* @__PURE__ */ G(Oj, {
					refund: b,
					currencyCode: f,
					refundShipping: p,
					onToggleShipping: m,
					isLoading: S,
					restockItems: h,
					onToggleRestock: g,
					restockItemsLabel: N,
					restockDisabled: S || T,
					canRestock: o
				}), ee && /* @__PURE__ */ K(v, {
					flexDirection: "column",
					children: [/* @__PURE__ */ G(z, { error: ee }), /* @__PURE__ */ G(j, {
						variant: "secondary",
						style: {
							color: "var(--dixa-typography-color-link)",
							padding: "var(--dixa-size-spacer-100)"
						},
						navigate: () => window.open(n, "_blank")?.focus(),
						slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
						children: "View order in Shopify"
					})]
				})]
			}) }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !b || S || T,
					isLoading: T || S,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 }),
					tabIndex: 0
				},
				confirmName: "Confirm order refund",
				confirmOnClick: M
			})
		]
	});
}, Pj = ({ order: e, shopifyId: t, orderLink: n, refetchOrders: r, canRestockOnRefund: i }) => {
	let { showModal: o } = B(), { track: s } = Ve(), { suggestedRefund: c, id: l } = e, [u, d] = U(!1), f = parseFloat(String(c?.amount)), p = !isNaN(f) && f > 0;
	return /* @__PURE__ */ K(v, {
		width: "100%",
		children: [/* @__PURE__ */ G(a, {
			variant: "secondary",
			onClick: Ye(() => {
				s("shopify:order:refund:requested", {
					shopifyId: t,
					orderId: l
				}), p ? d(!0) : o({
					headline: `Refund Order ${e.name}`,
					children: /* @__PURE__ */ G(L.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
					confirmLabel: "Close",
					confirmVariant: "secondary",
					onConfirm: () => {}
				});
			}, [
				t,
				l,
				e.name,
				p,
				o,
				s
			]),
			disabled: c?.refundLineItems?.length === 0 || !p,
			slotStart: /* @__PURE__ */ G(x, {
				size: 14,
				name: "undo"
			}),
			className: rA.fullWidth,
			children: "Full refund"
		}), /* @__PURE__ */ G(Nj, {
			order: e,
			shopifyId: t,
			orderLink: n,
			isOpen: u,
			setIsOpen: d,
			refetchOrders: r,
			canRestockOnRefund: i
		})]
	});
}, Fj = { modal: "_modal_al73g_1" }, Ij = ({ orderId: e, tags: t, isOpen: n, setIsOpen: r, refetchOrders: i }) => {
	let { track: a } = Ve(), { useMutation: o, showNotification: s } = B(), [c, l] = U(t), [u, d] = U(!1), f = gl({ defaultValues: { tags: t } });
	H(() => {
		c && f.setValue("tags", c, { shouldDirty: !0 });
	}, [c]);
	let [p, { error: m, reset: h }] = o(KO, {
		onError: () => {
			d(!1), s({
				title: "Something went wrong",
				text: "The tags change was not successful.",
				icon: "exclamation-triangle-filled",
				severity: "warning"
			}), r(!1);
		},
		onCompleted: async () => {
			await i(), d(!1), s({
				title: "Success",
				text: "The tags change was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), a("shopify:order:tags:updated"), r(!1);
		}
	}), g = Ye((t) => {
		d(!0), p({ variables: { input: {
			id: e,
			tags: t.tags
		} } }).then((e) => {
			let n = e.data?.Shopify?.orderUpdate?.order?.tags ?? t.tags;
			f.reset({ tags: n });
		});
	}, [
		e,
		f,
		p
	]), v = () => {
		r(!1), h();
	};
	return /* @__PURE__ */ K(D, {
		isOpen: n,
		onClose: v,
		className: Fj.modal,
		children: [
			/* @__PURE__ */ G(A, {
				title: "Manage tags for order",
				onClose: v
			}),
			/* @__PURE__ */ K(O, { children: [/* @__PURE__ */ G(b, { children: /* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(xc, {
				control: f.control,
				name: "tags",
				render: ({ fieldState: { error: e } }) => /* @__PURE__ */ G(_, {
					label: "Tags",
					meta: { error: e?.message },
					children: /* @__PURE__ */ G(te, {
						placeholder: "Add tags here",
						selectedTags: t,
						onChange: (e) => l(e)
					})
				})
			}) }) }), m && /* @__PURE__ */ G(z, { error: m })] }),
			/* @__PURE__ */ G(k, {
				confirmProps: {
					disabled: !(f.formState.isValid && f.formState.isDirty),
					isLoading: u,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				confirmOnClick: f.handleSubmit(g),
				cancelOnClick: v,
				confirmName: m ? "Close" : "Save",
				cancelName: m ? void 0 : "Cancel"
			})
		]
	});
}, Lj = {
	editIcon: "_editIcon_1yp2k_1",
	copyIcon: "_copyIcon_1yp2k_2"
}, Rj = ({ orderId: e, tags: t, refetchOrders: r }) => {
	let [i, a] = U(!1), { isCopied: o, copy: s } = nk(), c = t.length > 0;
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(v, {
		justifyContent: "space-between",
		children: [/* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: "tag",
				color: "green.500"
			}), /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: "Tags"
				}), /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "row",
					flexWrap: "wrap",
					children: [!c && /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "tertiary",
						children: "No tags here yet"
					}), c && t.map((e, t) => /* @__PURE__ */ G(n, {
						size: "small",
						variant: "primary",
						children: e
					}, t))]
				})]
			})]
		}), /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ G(R, {
				content: "Edit tags",
				children: /* @__PURE__ */ G(x, {
					size: 14,
					name: "pen",
					className: Lj.editIcon,
					onClick: () => a(!0)
				})
			}), c && /* @__PURE__ */ G(R, {
				content: "Copy tags",
				children: /* @__PURE__ */ G(x, {
					size: 14,
					name: o ? "done" : "copy",
					className: Lj.copyIcon,
					onClick: () => s(t.join(", "))
				})
			})]
		})]
	}), /* @__PURE__ */ G(Ij, {
		orderId: e,
		tags: t,
		isOpen: i,
		setIsOpen: a,
		refetchOrders: r
	})] });
}, zj = {
	icon: "_icon_cddi1_1",
	link: "_link_cddi1_6"
}, Bj = ({ trackingInfo: e }) => {
	let { isCopied: t, copy: n } = nk(), { company: r, number: i, url: a } = e;
	return /* @__PURE__ */ G(E.Item, {
		contentLeft: /* @__PURE__ */ G(L.Paragraph, {
			variant: "3",
			children: i
		}),
		title: /* @__PURE__ */ G(L.ExternalLink, {
			href: a,
			target: "_blank",
			rel: "noreferrer",
			className: zj.link,
			children: r
		}),
		contentRight: i && /* @__PURE__ */ G(R, {
			content: "Copy tracking code",
			children: /* @__PURE__ */ G(x, {
				size: 14,
				name: t ? "done" : "copy",
				onClick: () => n(i.toString()),
				className: zj.icon
			})
		})
	});
}, Vj = ({ trackingInfos: e }) => !e || e?.length === 0 ? null : /* @__PURE__ */ K(v, {
	gap: "200",
	flexDirection: "column",
	children: [/* @__PURE__ */ K(v, {
		gap: "250",
		flexDirection: "row",
		children: [/* @__PURE__ */ G(x, {
			size: 14,
			name: "eye",
			color: "green.500"
		}), /* @__PURE__ */ G(L.Paragraph, {
			variant: "3",
			children: "Tracking"
		})]
	}), /* @__PURE__ */ G(E, { children: e.map((e) => /* @__PURE__ */ G(Bj, { trackingInfo: e }, e.number)) })]
}), Hj = {
	copyIcon: "_copyIcon_u5m0p_1",
	strikethrough: "_strikethrough_u5m0p_6",
	order: "_order_u5m0p_10",
	orderIsOpen: "_orderIsOpen_u5m0p_18",
	orderHeader: "_orderHeader_u5m0p_21"
}, Uj = ({ order: e, shopifyId: t, openByDefault: n, customerCountryCodes: r, enableEditShippingAddress: i, displayRefund: o, displayCancel: s, shopifyDomain: c, displayDuplicateOrder: l, displayPartialRefundOrder: u, canRestockOnRefund: d, refetchOrders: f }) => {
	let { track: p } = Ve(), { isCopied: m, copy: h } = nk(), { isCopied: g, copy: _ } = nk(), { isCopied: y, copy: b } = nk(), [C, w] = U(!1), [T, E] = U(!1), [D, O] = U(n), { id: k, name: A, createdAt: M, status: N, currentTotalPriceSet: P, currencyCode: ee, lineItems: F, billingAddress: I, shippingAddress: te, trackingInfos: ne, tags: re, discountCodes: ie, currentTotalDiscountsSet: ae } = e, z = !!te, oe = `https://${c}/admin/orders/${lA(k) ?? ""}`, se = P?.shopMoney?.amount ?? 0, ce = N.includes("cancelled"), le = (e) => new Intl.NumberFormat(void 0, {
		style: "currency",
		currency: ee
	}).format(e), ue = Number(ae?.shopMoney?.amount ?? 0), de = ue > 0, fe = ie?.join(", ") ?? "", pe = le(Number(se)), me = le(Number(se) + ue), he = e?.refunds ? Tj(e) : {}, ge = !!F?.length && F.every((e) => (he[e.id] || 0) >= (e.quantity || 0));
	return /* @__PURE__ */ K(v, {
		className: ht(Hj.order, { [Hj.orderIsOpen]: D }),
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				alignItems: "center",
				className: Hj.orderHeader,
				onClick: () => O(!D),
				children: [/* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [M && /* @__PURE__ */ G(v, {
						alignItems: "center",
						children: /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: yA(M).format("DD MMM YYYY @ HH:mm")
						})
					}), /* @__PURE__ */ K(L.Paragraph, {
						variant: "1",
						children: ["Order ", A]
					})]
				}), /* @__PURE__ */ G(S, {
					variant: "tertiary",
					icon: D ? "angle-down" : "angle-right"
				})]
			}),
			D && /* @__PURE__ */ K(v, {
				gap: "250",
				flexDirection: "column",
				margin: "200 0 0",
				children: [
					/* @__PURE__ */ K(v, {
						gap: "250",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "flex-start",
						children: [/* @__PURE__ */ K(v, {
							gap: "250",
							flexDirection: "row",
							alignItems: "flex-start",
							children: [/* @__PURE__ */ G(x, {
								size: 14,
								name: "info",
								color: "green.500"
							}), /* @__PURE__ */ K(v, {
								gap: "200",
								flexDirection: "column",
								children: [/* @__PURE__ */ G(L.Paragraph, {
									variant: "3",
									children: "Order number"
								}), /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: A.replace("#", "")
								})]
							})]
						}), /* @__PURE__ */ G(R, {
							content: "Copy order number",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: m ? "done" : "copy",
								onClick: () => h(A.replace("#", "")),
								className: Hj.copyIcon
							})
						})]
					}),
					/* @__PURE__ */ K(v, {
						gap: "250",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "flex-start",
						children: [/* @__PURE__ */ K(v, {
							gap: "250",
							flexDirection: "row",
							alignItems: "flex-start",
							children: [/* @__PURE__ */ G(x, {
								size: 14,
								name: "activity",
								color: "green.500"
							}), /* @__PURE__ */ K(v, {
								gap: "200",
								flexDirection: "column",
								children: [/* @__PURE__ */ G(L.Paragraph, {
									variant: "3",
									children: "Order status"
								}), /* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									children: N
								})]
							})]
						}), /* @__PURE__ */ G(R, {
							content: "Copy order status",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: y ? "done" : "copy",
								onClick: () => b(N),
								className: Hj.copyIcon
							})
						})]
					}),
					/* @__PURE__ */ K(v, {
						gap: "250",
						flexDirection: "row",
						justifyContent: "space-between",
						alignItems: "flex-start",
						children: [/* @__PURE__ */ K(v, {
							gap: "250",
							flexDirection: "row",
							alignItems: "flex-start",
							children: [/* @__PURE__ */ G(x, {
								size: 14,
								name: "chart-bar",
								color: "green.500"
							}), /* @__PURE__ */ K(v, {
								gap: "200",
								flexDirection: "column",
								children: [
									/* @__PURE__ */ G(L.Paragraph, {
										variant: "3",
										children: "Order value"
									}),
									de && /* @__PURE__ */ G(L.Paragraph, {
										variant: "4",
										className: Hj.strikethrough,
										children: me
									}),
									/* @__PURE__ */ K(v, {
										gap: "200",
										flexDirection: "row",
										alignItems: "center",
										children: [/* @__PURE__ */ G(L.Paragraph, {
											variant: "4",
											children: pe
										}), fe && /* @__PURE__ */ K(L.Paragraph, {
											variant: "4",
											color: "tertiary",
											children: [
												"(",
												fe,
												")"
											]
										})]
									})
								]
							})]
						}), /* @__PURE__ */ G(R, {
							content: "Copy order value",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: g ? "done" : "copy",
								onClick: () => _(se),
								className: Hj.copyIcon
							})
						})]
					}),
					/* @__PURE__ */ G(Rj, {
						orderId: k,
						tags: re,
						refetchOrders: f
					}),
					/* @__PURE__ */ G(ZA, {
						openByDefault: !z,
						labelText: "Billing address",
						address: I,
						shippingCountryCodes: r,
						refetchOrders: f
					}),
					/* @__PURE__ */ G(ZA, {
						openByDefault: z,
						shopifyId: t,
						orderId: k,
						icon: "map-pin",
						labelText: "Shipping address",
						address: te,
						shippingCountryCodes: r,
						enableEditAddress: i,
						refetchOrders: f
					}),
					/* @__PURE__ */ G(Sj, {
						orderId: k,
						lineItems: F,
						refundedQuantities: he
					}),
					/* @__PURE__ */ G(Vj, { trackingInfos: ne }),
					(o || u) && /* @__PURE__ */ K(v, {
						flexDirection: "row",
						gap: "200",
						children: [o && /* @__PURE__ */ G(Pj, {
							order: e,
							shopifyId: t,
							refetchOrders: f,
							orderLink: oe,
							canRestockOnRefund: d
						}), u && /* @__PURE__ */ G(v, {
							width: "100%",
							children: /* @__PURE__ */ G(a, {
								variant: "secondary",
								icon: "undo",
								onClick: () => E(!0),
								className: rA.fullWidth,
								disabled: ce || ge,
								children: "Partial refund"
							})
						})]
					}),
					(l || s) && /* @__PURE__ */ K(v, {
						flexDirection: "row",
						gap: "200",
						children: [l && /* @__PURE__ */ G(v, {
							width: "100%",
							children: /* @__PURE__ */ G(a, {
								variant: "secondary",
								icon: "plus",
								onClick: () => w(!0),
								className: rA.fullWidth,
								children: "Duplicate"
							})
						}), s && /* @__PURE__ */ G(vj, {
							orderId: k,
							orderName: A,
							disabled: ce,
							refetchOrders: f
						})]
					}),
					/* @__PURE__ */ G(j, {
						variant: "secondary",
						style: {
							color: "var(--dixa-typography-color-link)",
							padding: "var(--dixa-size-spacer-100)"
						},
						navigate: () => window.open(oe, "_blank")?.focus(),
						slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
						onClick: () => p("shopify:view:order:clicked", {
							shopifyId: t,
							orderId: k
						}),
						children: "View order in Shopify"
					})
				]
			}),
			C && /* @__PURE__ */ G(bj, {
				order: e,
				shopifyId: t,
				orderName: A,
				isOpen: C,
				setIsOpen: w,
				refetchOrders: f
			}),
			T && /* @__PURE__ */ G(jj, {
				order: e,
				orderName: A,
				isOpen: T,
				setIsOpen: E,
				canRestockOnRefund: d,
				refetchOrders: () => {
					f();
				}
			})
		]
	});
}, Wj = ({ customerCountryCodes: e, shopifyDomain: t, displayRefund: r, displayCancel: i, displayCreateOrder: o, displayCreateDraftOrder: s, displayDuplicateOrder: c, displayPartialRefundOrder: l, enableEditShippingAddress: u, shopifyCustomer: d, canRestockOnRefund: f }) => {
	let { track: p } = Ve(), [m, h] = U([]), [g, _] = U(!1), y = lA(d?.id), b = `https://${t}/admin/orders?customer_id=${y ?? ""}`, { getCustomerOrders: S, isCustomerOrdersLoading: C, customerOrdersError: w, customerOrders: T, refetchCustomerOrders: E } = tk();
	return H(() => {
		!C && y && S({ variables: { query: `customer_id:${y}` } });
	}, [y]), H(() => {
		let e = T?.Shopify?.orders?.edges;
		e && h(Ck({ ordersData: e }));
	}, [T]), d ? w ? /* @__PURE__ */ G(z, { error: w }) : /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Customer orders"
				}), !C && /* @__PURE__ */ G(n, {
					variant: "success",
					size: "small",
					children: m.length
				})]
			}),
			o && /* @__PURE__ */ G(a, {
				variant: "secondary",
				icon: "plus",
				onClick: () => _(!0),
				children: "Create new order"
			}),
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [
					C && /* @__PURE__ */ G(v, {
						justifyContent: "center",
						margin: "300",
						children: /* @__PURE__ */ G(P, {})
					}),
					!C && m.length === 0 && /* @__PURE__ */ G(v, {
						justifyContent: "center",
						margin: "200 0 300 0",
						children: /* @__PURE__ */ G(L.Paragraph, {
							color: "tertiary",
							children: "No orders found"
						})
					}),
					!C && m.length > 0 && /* @__PURE__ */ G(v, {
						gap: "200",
						flexDirection: "column",
						children: m.map((n, a) => /* @__PURE__ */ G(Uj, {
							order: n,
							openByDefault: a === 0,
							shopifyId: d?.id,
							displayRefund: r,
							displayCancel: i,
							enableEditShippingAddress: u,
							customerCountryCodes: e,
							refetchOrders: E,
							shopifyDomain: t,
							displayDuplicateOrder: c,
							displayPartialRefundOrder: l,
							canRestockOnRefund: f
						}, `${a}-${n.id}`))
					}),
					/* @__PURE__ */ G(j, {
						variant: "secondary",
						style: {
							color: "var(--dixa-typography-color-link)",
							padding: "var(--dixa-size-spacer-100)"
						},
						navigate: () => window.open(b, "_blank")?.focus(),
						slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
						onClick: () => p("shopify:view:all:orders:clicked", { shopifyId: d?.id }),
						children: "View all orders in Shopify"
					})
				]
			}),
			o && /* @__PURE__ */ G(mj, {
				isOpen: g,
				setIsOpen: _,
				shopifyCustomer: d,
				refetchCustomerOrders: E,
				displayCreateDraftOrder: s
			})
		]
	}) : null;
}, Gj = ({ totalOrders: e, amountSpent: t }) => {
	let n = t?.amount ?? 0, r = t?.currencyCode ?? "", i = `${Number.parseFloat(n).toFixed(2)} ${r}`;
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Orders overview"
		}), /* @__PURE__ */ K(E, {
			className: rA.list,
			children: [/* @__PURE__ */ G(E.Text, {
				variant: "dense",
				className: rA.listItem,
				children: /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Total orders"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: e
					})]
				})
			}), /* @__PURE__ */ G(E.Text, {
				variant: "dense",
				className: rA.listItem,
				children: /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Total revenue"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: i
					})]
				})
			})]
		})]
	}) });
}, Kj = { segmentName: "_segmentName_1dkhk_1" }, qj = 100, Jj = 10, Yj = ({ shopifyId: e }) => {
	let { useQuery: t, useLazyQuery: r } = B(), [i, o] = U([]), [s, c] = U(Jj), [l, u] = U(!1), d = Qe(() => i.filter((e) => e.isMember).length, [i]), { loading: f, error: p } = t(RO, {
		skip: !e,
		variables: { first: qj },
		onCompleted: (t) => {
			let n = t?.Shopify?.segments?.edges;
			if (n && n.length > 0) {
				let t = n.map(({ node: e }) => ({
					...e,
					isMember: !1
				})).sort((e, t) => e.name.localeCompare(t.name));
				o(t), m({ variables: {
					customerId: e,
					segmentIds: t.map((e) => e.id)
				} });
			}
		}
	}), [m, { loading: h, error: g }] = r(zO, { onCompleted: (e) => {
		let t = e?.Shopify?.customerSegmentMembership?.memberships;
		if (t && t.length > 0) {
			let e = i.map((e) => {
				let n = t.find((t) => t.segmentId === e.id);
				return {
					...e,
					...n?.isMember && { isMember: n.isMember }
				};
			}).sort((e, t) => e.isMember === t.isMember ? 0 : e.isMember ? -1 : 1);
			o(e);
		}
	} });
	return H(() => {
		c(l ? i.length : Jj);
	}, [l]), e ? /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Segment membership"
				}), !f && /* @__PURE__ */ G(n, {
					variant: "success",
					size: "small",
					children: d
				})]
			}),
			f && /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "300",
				children: /* @__PURE__ */ G(P, {})
			}),
			!f && i.length === 0 && /* @__PURE__ */ G(L.Paragraph, {
				color: "tertiary",
				margin: "200 0 300 0",
				align: "center",
				children: "No segments found"
			}),
			p && /* @__PURE__ */ G(z, { error: p }),
			g && /* @__PURE__ */ G(z, { error: g }),
			!f && i.length > 0 && /* @__PURE__ */ K(E, {
				className: rA.list,
				children: [i.slice(0, s).map(({ id: e, name: t, isMember: n }) => /* @__PURE__ */ G(E.Text, {
					className: rA.listItem,
					children: /* @__PURE__ */ G(R, {
						content: `${n ? "Member of" : "Not a member of"} ${t}`,
						children: /* @__PURE__ */ K(v, {
							justifyContent: "space-between",
							children: [
								/* @__PURE__ */ G(L.Paragraph, {
									variant: "4",
									className: Kj.segmentName,
									children: t
								}),
								h && /* @__PURE__ */ G(P, { size: 12 }),
								!h && /* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(x, {
									color: n ? "green.500" : "neutral.300",
									name: "shopify"
								}) })
							]
						})
					})
				}, e)), i.length > Jj && /* @__PURE__ */ G(v, {
					justifyContent: "center",
					margin: "200 0 0",
					children: /* @__PURE__ */ G(a, {
						variant: "secondary",
						onClick: () => u(!l),
						icon: l ? "angle-up" : "angle-down",
						children: l ? "Show less" : `Show ${i.length - Jj} more`
					})
				})]
			})
		]
	}) : null;
}, Xj = ({ conversationContext: e, settings: t }) => {
	let [n, r] = U(!1);
	H(() => {
		r(!1);
	}, [e.customer?.phone_number, e.customer?.email]);
	let { isCustomerLoading: i, customerError: a, customerData: o, refetchCustomer: s, customerNetworkStatus: c } = ek({
		conversationContext: e,
		forcePhoneLookup: n
	}), [l, u] = U(), [d, f] = U([]), p = t.apiHostName, m = t.displayRefundOrder ?? !1, h = t.displayCancelOrder ?? !1, g = t.enableEditShippingAddress ?? !1, _ = t.displayEmailMarketingConsent ?? !1, y = t.enableEditMarketingConsent ?? !1, b = t.displayOrdersOverview ?? !1, S = t.displaySegmentMembership ?? !1, C = t.displayDiscountCodeCreation ?? !1, w = t.displayDiscountCodes ?? !1, T = t.displayCreateOrder ?? !1, E = t.displayDuplicateOrder ?? !1, D = t.displayCreateDraftOrder ?? !1, O = t.displayPartialRefundOrder ?? !1, k = Sk(o?.Shopify?.currentAppInstallation?.accessScopes.map(({ handle: e }) => e));
	if (H(() => {
		let t = o?.Shopify?.customers?.edges[0]?.node, a = !!e.customer?.phone_number && !!e.customer?.email;
		t && !i ? (f(o?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []), u(t)) : !t && !i && a && !n ? r(!0) : u(void 0);
	}, [o, e]), !i && a) return /* @__PURE__ */ G(z, {
		error: a,
		retry: s
	});
	if (!i && !a && !l) {
		let t = `https://${p}/admin/customers?search=${e.customer?.name || ""}`;
		return /* @__PURE__ */ K(v, {
			margin: "200 0 300",
			gap: "300",
			flexDirection: "column",
			"data-testid": "widget-customer-not-found",
			children: [/* @__PURE__ */ G(L.Paragraph, {
				color: "secondary",
				children: "We cannot find the customer in Shopify."
			}), /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(cA, {
					refetchCustomer: s,
					conversationContext: e
				}), /* @__PURE__ */ G(j, {
					variant: "secondary",
					style: {
						color: "var(--dixa-typography-color-link)",
						padding: "var(--dixa-size-spacer-100)"
					},
					navigate: () => window.open(t, "_blank")?.focus(),
					slotStart: /* @__PURE__ */ G(x, { name: "external-link" }),
					children: "Search customers in Shopify"
				})]
			})]
		});
	}
	return i && c !== st.refetch ? /* @__PURE__ */ G(v, {
		margin: "200 0 300",
		justifyContent: "center",
		children: /* @__PURE__ */ G(P, {})
	}) : /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300",
		"data-testid": "widget-wrapper",
		children: [
			/* @__PURE__ */ G(fA, {
				customer: l,
				shopifyDomain: p,
				refresh: s,
				loading: i,
				networkStatus: c
			}),
			b && /* @__PURE__ */ G(Gj, {
				totalOrders: l?.numberOfOrders,
				amountSpent: l?.amountSpent
			}),
			S && /* @__PURE__ */ G(Yj, { shopifyId: l?.id }),
			_ && /* @__PURE__ */ G(IA, {
				customer: l,
				isEditable: y,
				refetchCustomer: s
			}),
			w && /* @__PURE__ */ G(OA, { displayDiscountCodeCreation: C }),
			/* @__PURE__ */ G(Wj, {
				shopifyCustomer: l,
				shopifyDomain: p,
				displayRefund: m,
				displayCancel: h,
				displayCreateOrder: T,
				displayCreateDraftOrder: D,
				enableEditShippingAddress: g,
				customerCountryCodes: d,
				displayDuplicateOrder: E,
				displayPartialRefundOrder: O,
				canRestockOnRefund: k
			})
		]
	});
}, Zj = [];
for (let e = 0; e < 256; ++e) Zj.push((e + 256).toString(16).slice(1));
function Qj(e, t = 0) {
	return (Zj[e[t + 0]] + Zj[e[t + 1]] + Zj[e[t + 2]] + Zj[e[t + 3]] + "-" + Zj[e[t + 4]] + Zj[e[t + 5]] + "-" + Zj[e[t + 6]] + Zj[e[t + 7]] + "-" + Zj[e[t + 8]] + Zj[e[t + 9]] + "-" + Zj[e[t + 10]] + Zj[e[t + 11]] + Zj[e[t + 12]] + Zj[e[t + 13]] + Zj[e[t + 14]] + Zj[e[t + 15]]).toLowerCase();
}
//#endregion
//#region ../../../node_modules/uuid/dist/rng.js
var $j = /* @__PURE__ */ new Uint8Array(16);
function eM() {
	return crypto.getRandomValues($j);
}
//#endregion
//#region ../../../node_modules/uuid/dist/v4.js
function tM(e, t, n) {
	return !t && !e && crypto.randomUUID ? crypto.randomUUID() : nM(e, t, n);
}
function nM(e, t, n) {
	e ||= {};
	let r = e.random ?? e.rng?.() ?? eM();
	if (r.length < 16) throw Error("Random bytes length must be >= 16");
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		if (n ||= 0, n < 0 || n + 16 > t.length) throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return Qj(r);
}
//#endregion
//#region ../widget-voyado/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:230px;padding:0;overflow-y:auto}._listItem_pn2q5_69{cursor:pointer;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);background-color:#0000}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var rM = /* @__PURE__ */ function(e) {
	return e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e;
}({}), iM = /* @__PURE__ */ function(e) {
	return e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e;
}({}), aM = {
	"\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updatePreferences"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_contactAttributes_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactsV_ContactPatch"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "id"
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "mutation",
			name: {
				kind: "Name",
				value: "updatePoints"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "input"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_AddPointTransactionRequestModel_Input"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "PointTransaction_AddPointTransacion"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "input"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "input"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getContactById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactsV_GetContactById"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "id"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "attributes"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "meta"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "preferences"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "consents"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "date"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "value"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "source"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "comment"
													}
												}
											]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getContactOverviewById"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactOverview_GetContactOverviewAsync"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}]
						}]
					}
				}]
			}
		}]
	},
	"\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getContactId"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "mobilePhone"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "ContactOverview_GetContactIdAsync"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							}, {
								kind: "Argument",
								name: {
									kind: "Name",
									value: "mobilePhone"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "mobilePhone"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Voyado_ContactOverview_GetContactIdAsync_response"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Voyado_String_container"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [{
													kind: "Field",
													name: {
														kind: "Name",
														value: "String"
													}
												}]
											}
										}, {
											kind: "InlineFragment",
											typeCondition: {
												kind: "NamedType",
												name: {
													kind: "Name",
													value: "Voyado_ApiExceptionMultipleMatchesResponse"
												}
											},
											selectionSet: {
												kind: "SelectionSet",
												selections: [
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "errorCode"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "message"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "requestId"
														}
													},
													{
														kind: "Field",
														name: {
															kind: "Name",
															value: "messageDetails"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "multipleMatchesFound"
																}
															}]
														}
													}
												]
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getLatestMessagesByContactId"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "count"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Int"
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "ContactMessage_GetSmsMessagesByContactId"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Voyado_ListResultOfApiMessage"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "count"
												}
											}, {
												kind: "Field",
												name: {
													kind: "Name",
													value: "items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "sendDateTime"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "type"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "source"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "isTransactional"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageLink"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageText"
															}
														}
													]
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "ContactMessage_GetPostalMessagesByContactId"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Voyado_ListResultOfApiMessage"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "count"
												}
											}, {
												kind: "Field",
												name: {
													kind: "Name",
													value: "items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "sendDateTime"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "type"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "source"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "isTransactional"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageLink"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageText"
															}
														}
													]
												}
											}]
										}
									}]
								}
							},
							{
								kind: "Field",
								name: {
									kind: "Name",
									value: "ContactMessage_GetEmailMessagesByContactId"
								},
								arguments: [{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								}, {
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}],
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Voyado_ListResultOfApiMessage"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "count"
												}
											}, {
												kind: "Field",
												name: {
													kind: "Name",
													value: "items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageId"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "sendDateTime"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "type"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "source"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "isTransactional"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "status"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageLink"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "messageText"
															}
														}
													]
												}
											}]
										}
									}]
								}
							}
						]
					}
				}]
			}
		}]
	},
	"\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomerTransactions"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "contactId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Voyado_UUID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "offset"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "count"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "Transactions_GetTransactionsWithArticlesByContactId"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "offset"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "offset"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "count"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "totalCount"
										}
									},
									{
										kind: "Field",
										name: {
											kind: "Name",
											value: "items"
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "id"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "createdDate"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "transactionNumber"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "storeName"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "numberOfItems"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "netPriceSum"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "localNetPriceSum"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "localCurrency"
													}
												},
												{
													kind: "Field",
													name: {
														kind: "Name",
														value: "lineItems"
													},
													selectionSet: {
														kind: "SelectionSet",
														selections: [
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "quantity"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "article"
																},
																selectionSet: {
																	kind: "SelectionSet",
																	selections: [{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "name"
																		}
																	}]
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "localPrice"
																}
															},
															{
																kind: "Field",
																name: {
																	kind: "Name",
																	value: "type"
																}
															}
														]
													}
												}
											]
										}
									}
								]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getOrdersByContactId"
			},
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "contactId"
						}
					},
					type: {
						kind: "NonNullType",
						type: {
							kind: "NamedType",
							name: {
								kind: "Name",
								value: "Voyado_UUID"
							}
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "offset"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				},
				{
					kind: "VariableDefinition",
					variable: {
						kind: "Variable",
						name: {
							kind: "Name",
							value: "count"
						}
					},
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "Orders_GetAllByContact"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "contactId"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "contactId"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "offset"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "offset"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "count"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "count"
										}
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "Field",
									name: {
										kind: "Name",
										value: "totalCount"
									}
								}, {
									kind: "Field",
									name: {
										kind: "Name",
										value: "items"
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "orderId"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "createdAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "lastChangedAt"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "channel"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "externalStatus"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "totalPrice"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "currencyCode"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "lineItems"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "items"
														},
														selectionSet: {
															kind: "SelectionSet",
															selections: [
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "quantity"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "totalPrice"
																	}
																},
																{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "article"
																	},
																	selectionSet: {
																		kind: "SelectionSet",
																		selections: [
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "sku"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "name"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "description"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "imageUri"
																				}
																			},
																			{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "targetUri"
																				}
																			}
																		]
																	}
																}
															]
														}
													}]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getPoints"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "contactId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Voyado_UUID"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "Voyado"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "PointAccountV_GetPointAccounts"
							},
							arguments: [{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "contactId"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "contactId"
									}
								}
							}],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "Voyado_PointAccountModelV3"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "id"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "balance"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function oM(e) {
	return aM[e] ?? {};
}
var sM = oM("\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n"), cM = oM("\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n"), lM = oM("\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n"), uM = oM("\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n"), dM = oM("\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n"), fM = oM("\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), pM = oM("\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n"), mM = oM("\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n"), hM = oM("\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n"), gM = ({ contactId: e }) => {
	let { useQuery: t } = B(), { track: n } = Ve(), [r, i] = U(), [a, o] = U(), [s, c] = U(), { loading: l, error: u, data: d, refetch: f } = t(sM, {
		skip: !e,
		variables: { contactId: e }
	});
	return H(() => {
		let e = d?.Voyado?.ContactsV_GetContactById;
		!l && e && typeof e == "object" && ("id" in e && n("voyado:profile:received", { hasProfile: !0 }), "attributes" in e && i(e.attributes), "preferences" in e && o(e.preferences), "consents" in e && c(e?.consents?.filter((e) => e !== null) || void 0)), !l && (!e || typeof e != "object") && n("voyado:profile:received", { hasProfile: !1 });
	}, [d?.Voyado, l]), Qe(() => ({
		isLoading: l,
		error: u,
		refetch: f,
		attributes: r,
		preferences: a,
		consents: s
	}), [
		u,
		r,
		a,
		s
	]);
};
function _M(e = !1, t) {
	let [n, r] = U(e);
	return H(() => {
		let e = n ? window.setTimeout(() => r(!1), t || 2e3) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}
var vM = {
	count: 0,
	items: []
}, yM = ({ contactId: e }) => {
	let { useQuery: t } = B(), { track: n } = Ve(), [r, i] = U(vM), { loading: a, error: o, data: s } = t(uM, {
		skip: !e,
		variables: {
			contactId: e,
			count: 5
		}
	});
	return H(() => {
		if (!a && (s?.Voyado?.ContactMessage_GetSmsMessagesByContactId || s?.Voyado?.ContactMessage_GetPostalMessagesByContactId || s?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
			let e = s?.Voyado?.ContactMessage_GetEmailMessagesByContactId, t = s?.Voyado?.ContactMessage_GetSmsMessagesByContactId, r = s?.Voyado?.ContactMessage_GetPostalMessagesByContactId, a = {
				count: (t?.count ?? 0) + (r?.count ?? 0) + (e?.count ?? 0),
				items: [
					...t.items ?? [],
					...e.items ?? [],
					...r.items ?? []
				]
			};
			i(a), n("voyado:messages:received", {
				emailsReceived: e.count ?? 0,
				smsReceived: t.count ?? 0,
				postalReceived: r.count ?? 0,
				total: a.count ?? 0
			});
		}
	}, [s?.Voyado, a]), {
		isLoading: a,
		error: o,
		lastMessages: r
	};
}, bM = {
	count: 0,
	totalCount: 0,
	items: []
}, xM = ({ contactId: e }) => {
	let { useQuery: t } = B(), { track: n } = Ve(), [r, i] = U(bM), { loading: a, error: o, data: s } = t(dM, {
		skip: !e,
		variables: {
			contactId: e,
			count: 5
		}
	});
	return H(() => {
		let e = s?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
		if (!a && e) {
			i(e);
			let { count: t } = e;
			t && n("voyado:transactions:received", { count: t });
		}
	}, [s?.Voyado, a]), {
		isLoading: a,
		error: o,
		transactions: r
	};
}, SM = ({ conversationContext: e }) => {
	let { useQuery: t } = B(), [n, r] = U(void 0), [i, a] = U(!1), { customer: o } = e, { loading: s, error: c, data: l, refetch: u } = t(lM, {
		skip: !(o?.email || o?.phone_number),
		variables: {
			email: o?.email ?? "",
			mobilePhone: o?.phone_number ?? ""
		}
	});
	return H(() => {
		let e = l?.Voyado?.ContactOverview_GetContactIdAsync;
		e?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && e?.messageDetails?.multipleMatchesFound && e?.messageDetails?.multipleMatchesFound.length > 0 && (a(!0), r(void 0)), e?.__typename === "Voyado_String_container" && e?.String && (a(!1), r(e.String));
	}, [l?.Voyado, s]), {
		isLoading: s,
		contactId: n,
		hasMultipleContacts: i,
		error: c,
		refetch: u
	};
}, CM = ({ contactId: e, skip: t }) => {
	let { useQuery: n } = B(), [r, i] = U(void 0), { loading: a, error: o, data: s, refetch: c } = n(cM, {
		skip: !e || t,
		variables: { contactId: e }
	});
	return H(() => {
		let e = s?.Voyado?.ContactOverview_GetContactOverviewAsync;
		if (!a && e && Object.hasOwn(e, "memberlevel")) {
			let t = e?.memberlevel;
			i({
				levelName: t?.levelName,
				remainingToUpgrade: t?.remainingToUpgrade,
				basedOnRewardPoints: t?.basedOnRewardPoints,
				levelId: t?.levelId,
				latestChange: t?.latestChange,
				expires: t?.expires
			});
		} else i(void 0);
	}, [s?.Voyado, a]), Qe(() => ({
		isLoading: a,
		error: o,
		memberLevel: r,
		refetch: c
	}), [
		a,
		o,
		r,
		c
	]);
}, wM = {
	pointer: "_pointer_pn2q5_54",
	list: "_list_pn2q5_59",
	listItem: "_listItem_pn2q5_69"
}, TM = { modalBody: "_modalBody_1clhs_1" }, EM = ({ isOpen: e, onClose: t, pointsAccount: n, setHasPointsBeenUpdated: r, refetchPointsQuery: i }) => {
	let { useMutation: a, showNotification: o } = B(), { track: s } = Ve(), c = n?.id, l = n?.balance ?? 0, u = {
		balance: l?.toString() ?? "0",
		description: "",
		transactionType: null
	}, { control: d, setValue: f, reset: p } = gl({
		defaultValues: u,
		mode: "onChange"
	}), m = yc({ control: d }), g = parseInt(m?.balance ?? "0", 10), _ = l === g, v = _ ? "Change the value to update the points" : "", x = g < 0, S = x ? "Points can not be negative" : "", C = m.description === "", w = C ? "Description can not be empty" : "";
	H(() => {
		g > l ? f("transactionType", iM.Addition) : g < l && f("transactionType", iM.Deduction);
	}, [
		l,
		g,
		f
	]);
	let [T, { loading: E, error: j, reset: M }] = a(hM, { onCompleted: () => {
		o({
			title: "Success",
			text: "Points updated successfully",
			icon: "check-circle-filled",
			severity: "success"
		});
	} }), N = () => {
		if (c) {
			let e = tM();
			T({ variables: { input: {
				accountId: c,
				transactionId: e,
				amount: Math.abs(g - l),
				transactionType: m.transactionType,
				description: m.description,
				source: rM.UpdateBalance
			} } }).then(async (e) => {
				e?.errors ? s("voyado:update:points:failed") : (s("voyado:update:points:succeeded"), r(!0), await i(), ee());
			}).catch(() => {
				s("voyado:update:points:failed");
			});
		}
	}, ee = () => {
		p(u), M(), t();
	};
	return /* @__PURE__ */ K(D, {
		isOpen: e,
		onClose: ee,
		"data-testid": "change-points-modal",
		children: [
			/* @__PURE__ */ G(A, {
				title: "Update points balance",
				onClose: ee
			}),
			/* @__PURE__ */ K(O, {
				className: TM.modalBody,
				children: [/* @__PURE__ */ K(b, { children: [/* @__PURE__ */ G(y, {
					span: 6,
					children: /* @__PURE__ */ G(xc, {
						name: "balance",
						control: d,
						render: ({ field: e }) => /* @__PURE__ */ G(h, {
							label: "New points balance",
							type: "number",
							placeholder: "Insert new points",
							min: 0,
							max: 1e5,
							meta: { warning: v || S },
							input: {
								...e,
								value: e.value.toString(),
								onChange: (t) => e.onChange(t)
							}
						})
					})
				}), /* @__PURE__ */ G(y, {
					span: 6,
					children: /* @__PURE__ */ G(xc, {
						name: "description",
						control: d,
						render: ({ field: e }) => /* @__PURE__ */ G(h, {
							required: !0,
							label: "Description",
							placeholder: "Insert a description",
							input: e,
							meta: { warning: w }
						})
					})
				})] }), j && /* @__PURE__ */ G(z, { error: j })]
			}),
			/* @__PURE__ */ G(k, {
				confirmName: "Save",
				confirmOnClick: () => N(),
				confirmProps: {
					isLoading: E,
					disabled: _ || x || C,
					loadingIndicator: /* @__PURE__ */ G(P, { size: 16 })
				},
				cancelOnClick: ee
			})
		]
	});
}, DM = {
	wrapper: "_wrapper_1ge6c_1",
	textVariant: "_textVariant_1ge6c_7",
	block: "_block_1ge6c_12"
}, OM = ({ contactAttributes: e, contactId: t }) => {
	let { useQuery: r } = B(), { isCopied: a, copy: o } = _M(), { isCopied: s, copy: c } = _M(), { isCopied: l, copy: u } = _M(), [d, f] = U(!1), [p, m] = U(), [h, g] = U(!1), { loading: _, data: y, refetch: b } = r(pM, {
		variables: { contactId: t },
		skip: !t
	});
	H(() => {
		if (y) {
			let e = y?.Voyado?.PointAccountV_GetPointAccounts;
			e && e?.length > 0 && m(e[0]);
		}
	}, [y]);
	let S = !!p?.id, C = p?.balance ?? 0;
	if (!e) return null;
	let { firstName: w, lastName: T, street: E, zipCode: D, city: O, country: k, isRegistrationCompleted: A, email: j, mobilePhone: M } = e, N = `${w || ""} ${T || ""}`.trim() || "Anonymous";
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		className: DM.wrapper,
		children: [
			/* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				className: DM.block,
				alignItems: "center",
				children: [
					/* @__PURE__ */ G(L.Heading, {
						variant: "heading-2",
						children: N
					}),
					_ && /* @__PURE__ */ G(P, { size: 12 }),
					S && !_ && /* @__PURE__ */ K(v, {
						gap: "100",
						alignItems: "center",
						children: [
							/* @__PURE__ */ K(n, {
								size: "small",
								variant: "warning",
								children: [C, " points"]
							}),
							/* @__PURE__ */ G(R, {
								content: "Update points balance",
								children: /* @__PURE__ */ G(x, {
									name: "pen",
									size: 12,
									onClick: () => f(!0),
									className: wM.pointer
								})
							}),
							h && /* @__PURE__ */ G(R, {
								content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.",
								children: /* @__PURE__ */ G(x, {
									name: "info",
									size: 12,
									className: wM.pointer
								})
							})
						]
					})
				]
			}),
			(E || O || D || k || M || j) && /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [
					M && /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(v, {
							gap: "200",
							alignItems: "center",
							children: [/* @__PURE__ */ G(x, {
								size: 14,
								name: "phone"
							}), /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: M
							})]
						}), /* @__PURE__ */ G(x, {
							size: 14,
							name: s ? "done" : "copy",
							onClick: () => c(M),
							className: wM.pointer
						})]
					}),
					j && /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(v, {
							gap: "200",
							alignItems: "center",
							children: [/* @__PURE__ */ G(x, {
								size: 14,
								name: "mail"
							}), /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: j
							})]
						}), /* @__PURE__ */ G(x, {
							size: 14,
							name: a ? "done" : "copy",
							onClick: () => o(j),
							className: wM.pointer
						})]
					}),
					(E || O || D || k) && /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(v, {
							gap: "200",
							children: [/* @__PURE__ */ G(x, {
								size: 14,
								name: "home"
							}), /* @__PURE__ */ K(L.Paragraph, {
								as: "div",
								variant: "4",
								color: "secondary",
								children: [
									/* @__PURE__ */ G(i, { children: E }),
									/* @__PURE__ */ K(i, { children: [
										D,
										" ",
										O
									] }),
									/* @__PURE__ */ G(i, { children: k })
								]
							})]
						}), /* @__PURE__ */ G(x, {
							size: 14,
							name: l ? "done" : "copy",
							onClick: () => u(`${E}, ${D} ${O}, ${k}`),
							className: wM.pointer
						})]
					}),
					/* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(v, {
							gap: "200",
							alignItems: "center",
							children: [/* @__PURE__ */ G(x, {
								size: 14,
								name: "sign-in"
							}), /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: "Is registration completed"
							})]
						}), /* @__PURE__ */ G(x, {
							name: A ? "check-circle-filled" : "close-circle-filled",
							color: A ? "green.500" : "neutral.500"
						})]
					})
				]
			}),
			S && /* @__PURE__ */ G(EM, {
				isOpen: d,
				pointsAccount: p,
				onClose: () => f(!1),
				setHasPointsBeenUpdated: g,
				refetchPointsQuery: b
			})
		]
	});
}, kM = Ws, AM = {
	wrapper: "_wrapper_yud4a_1",
	list: "_list_yud4a_7",
	listItem: "_listItem_yud4a_11",
	listItemTooltip: "_listItemTooltip_yud4a_15",
	listItemTimestamp: "_listItemTimestamp_yud4a_18"
}, jM = ({ contactConsents: e }) => !e || e.length === 0 ? null : /* @__PURE__ */ K(v, {
	gap: "200",
	flexDirection: "column",
	children: [/* @__PURE__ */ G(L.Heading, {
		variant: "heading-3",
		children: "Consents"
	}), /* @__PURE__ */ G(E, {
		className: AM.list,
		children: e.map((e, t) => /* @__PURE__ */ G(E.Text, {
			variant: "dense",
			className: AM.listItem,
			children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ G(R, {
					content: e?.comment,
					children: /* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						className: ht({ [AM.listItemTooltip]: e?.comment }),
						children: [
							/* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: e.id
							}),
							/* @__PURE__ */ G(L.Paragraph, {
								className: AM.listItemTimestamp,
								children: kM(e.date).format(he)
							}),
							e?.comment && /* @__PURE__ */ G(x, {
								name: "info",
								color: "neutral.400"
							})
						]
					})
				}), /* @__PURE__ */ G(x, {
					name: e.value ? "check-circle-filled" : "close-circle-filled",
					color: e.value ? "green.500" : "red.500"
				})]
			})
		}, t))
	})]
}), MM = ({ memberLevel: e }) => {
	let t = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? kM(e.latestChange).format(he) : null, o = e?.expires ? `${kM(e.expires).fromNow()} (${kM(e.expires).format(he)})` : null, s = !t && !a && !r && !i && !o;
	return /* @__PURE__ */ G(v, {
		gap: "200",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "column",
			children: [/* @__PURE__ */ K(v, {
				alignItems: "center",
				gap: "100",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Member level"
				}), /* @__PURE__ */ G(R, {
					content: "Voyado updates the member level data in a nightly batch process",
					children: /* @__PURE__ */ G(x, {
						name: "question",
						size: 14,
						className: wM.pointer
					})
				})]
			}), /* @__PURE__ */ G(v, {
				flexDirection: "column",
				children: /* @__PURE__ */ K(E, {
					className: wM.list,
					children: [
						s && /* @__PURE__ */ G(E.Text, {
							variant: "dense",
							className: wM.listItem,
							children: /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								color: "secondary",
								children: "No member level properties found"
							})
						}),
						t && /* @__PURE__ */ G(E.Text, {
							variant: "dense",
							className: wM.listItem,
							children: /* @__PURE__ */ G(R, {
								content: "",
								children: /* @__PURE__ */ K(v, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ G(L.Paragraph, {
										variant: "4",
										children: "Level"
									}), /* @__PURE__ */ G(n, {
										variant: "info",
										size: "small",
										children: e?.levelName ?? ""
									})]
								})
							})
						}),
						i && /* @__PURE__ */ G(E.Text, {
							variant: "dense",
							className: wM.listItem,
							children: /* @__PURE__ */ G(R, {
								content: "Voyado updates the member level data once a day in a nightly job",
								children: /* @__PURE__ */ K(v, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ G(L.Paragraph, {
										variant: "4",
										children: "Based on reward points"
									}), /* @__PURE__ */ G(n, {
										variant: "success",
										size: "small",
										children: i
									})]
								})
							})
						}),
						r && /* @__PURE__ */ G(E.Text, {
							variant: "dense",
							className: wM.listItem,
							children: /* @__PURE__ */ G(R, {
								content: "",
								children: /* @__PURE__ */ K(v, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ G(L.Paragraph, {
										variant: "4",
										children: "Remaining to upgrade"
									}), /* @__PURE__ */ G(n, {
										variant: "success",
										size: "small",
										children: r
									})]
								})
							})
						}),
						a && /* @__PURE__ */ G(E.Text, {
							variant: "dense",
							className: wM.listItem,
							children: /* @__PURE__ */ G(R, {
								content: "",
								children: /* @__PURE__ */ K(v, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ G(L.Paragraph, {
										variant: "4",
										children: "Latest change"
									}), /* @__PURE__ */ G(L.Paragraph, {
										variant: "5",
										color: "secondary",
										children: a
									})]
								})
							})
						}),
						o && /* @__PURE__ */ G(E.Text, {
							variant: "dense",
							className: wM.listItem,
							children: /* @__PURE__ */ G(R, {
								content: "",
								children: /* @__PURE__ */ K(v, {
									justifyContent: "space-between",
									alignItems: "center",
									children: [/* @__PURE__ */ G(L.Paragraph, {
										variant: "4",
										children: "Expires"
									}), /* @__PURE__ */ G(L.Paragraph, {
										variant: "5",
										color: "secondary",
										children: o
									})]
								})
							})
						})
					]
				})
			})]
		})
	});
}, NM = {
	tagHover: "_tagHover_kzbzk_1",
	channelUnsubscribed: "_channelUnsubscribed_kzbzk_6"
}, PM = ({ isSubscribed: e, channelName: t, channelIcon: n, contactId: r, contactPreferences: i, refetchContact: a }) => {
	let { track: o } = Ve(), { useMutation: s } = B(), [c, l] = U(!1), [u, { loading: d }] = s(mM), f = async ({ newPreference: e, isSubscribed: t, channelType: n }) => {
		l(!0), (await u({ variables: {
			contactId: r,
			input: { preferences: {
				...i,
				...e
			} }
		} }))?.data?.Voyado.ContactsV_ContactPatch?.id ? o(t ? "voyado:channel:unsubscribe:succeeded" : "voyado:channel:subscribe:succeeded", { channel: n }) : o(t ? "voyado:channel:unsubscribe:failed" : "voyado:channel:subscribe:failed", { channel: n }), setTimeout(async () => {
			await a().finally(() => l(!1));
		}, 1e3);
	}, p = c || d;
	return /* @__PURE__ */ G(R, {
		content: e ? "Unsubscribe" : "Subscribe",
		children: /* @__PURE__ */ G(I, {
			className: NM.tagHover,
			color: e ? "green.500" : "neutral.200",
			children: /* @__PURE__ */ K(v, {
				"data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
				gap: "200",
				alignItems: "center",
				className: ht({ [NM.channelUnsubscribed]: !e }),
				onClick: () => {
					o(e ? "voyado:channel:unsubscribe:clicked" : "voyado:channel:subscribe:clicked", { channel: t.toUpperCase() }), f({
						newPreference: { [`accepts${t}`]: !e },
						isSubscribed: e,
						channelType: t.toUpperCase()
					});
				},
				children: [p ? /* @__PURE__ */ G(P, { size: 16 }) : /* @__PURE__ */ G(x, {
					size: 16,
					name: n
				}), t]
			})
		})
	});
}, FM = ({ contactPreferences: e, contactId: t, refetchContact: n }) => {
	if (!e || !t) return null;
	let { acceptsEmail: r, acceptsPostal: i, acceptsSms: a } = e;
	return /* @__PURE__ */ G(v, {
		gap: "200",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "column",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Subscriptions"
			}), /* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "row",
				children: [
					/* @__PURE__ */ G(PM, {
						channelName: "Email",
						channelIcon: "mail",
						isSubscribed: r,
						contactId: t,
						contactPreferences: e,
						refetchContact: n
					}),
					/* @__PURE__ */ G(PM, {
						channelName: "Sms",
						channelIcon: "sms",
						isSubscribed: a,
						contactId: t,
						contactPreferences: e,
						refetchContact: n
					}),
					/* @__PURE__ */ G(PM, {
						channelName: "Postal",
						channelIcon: "paper-plane",
						isSubscribed: i,
						contactId: t,
						contactPreferences: e,
						refetchContact: n
					})
				]
			})]
		})
	});
}, IM = ({ contactId: e, settings: t }) => {
	let { showCustomerAttributes: n, showPreferences: r, showAudiences: i, showConsents: a, showMemberLevel: o } = t, { isLoading: s, error: c, refetch: l, attributes: u, preferences: d, consents: f } = gM({ contactId: e }), { isLoading: p, error: m, memberLevel: h } = CM({
		contactId: e,
		skip: !o
	}), g = p || s, _ = Qe(() => f?.filter((e) => e !== null), [f]);
	return c || m ? Se({ errors: c?.graphQLErrors || m?.graphQLErrors || [] }) ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		children: /* @__PURE__ */ G(L.Paragraph, {
			color: "secondary",
			children: "No contact informations found"
		})
	}) : /* @__PURE__ */ G(z, { error: c || m }) : !n && !r && !i && !a && !o ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		children: /* @__PURE__ */ G(L.Paragraph, {
			color: "secondary",
			children: "All contact related features in the settings are disabled."
		})
	}) : g ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ G(P, {})
	}) : /* @__PURE__ */ K(W, { children: [
		n && /* @__PURE__ */ G(OM, {
			contactAttributes: u,
			contactId: e
		}),
		o && /* @__PURE__ */ G(MM, { memberLevel: h }),
		r && /* @__PURE__ */ G(FM, {
			refetchContact: l,
			contactPreferences: d,
			contactId: e
		}),
		a && /* @__PURE__ */ G(jM, { contactConsents: _ })
	] });
}, LM = (e, t) => `${e ? e.toFixed(2) : "0.00"} ${t}`, RM = {
	list: "_list_zu4s7_1",
	listItem: "_listItem_zu4s7_4",
	listSum: "_listSum_zu4s7_7"
}, zM = ({ lineItems: e, localCurrency: t, localNetPriceSum: n }) => /* @__PURE__ */ K(E, {
	className: RM.list,
	children: [e?.map(({ quantity: e, article: n, localPrice: r, type: i }, a) => /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: RM.listItem,
		children: /* @__PURE__ */ G(R, {
			content: i,
			children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				gap: "200",
				children: [
					/* @__PURE__ */ K(v, {
						flex: "0 0 auto",
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: e
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: "×"
						})]
					}),
					/* @__PURE__ */ G(v, {
						flex: "auto",
						children: /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: n?.name
						})
					}),
					r && t && /* @__PURE__ */ G(v, {
						flex: "0 0 auto",
						gap: "100",
						children: /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: LM(r, t)
						})
					})
				]
			})
		})
	}, a)), /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: ht(RM.listItem, RM.listSum),
		children: /* @__PURE__ */ K(v, {
			gap: "100",
			justifyContent: "space-between",
			children: [/* @__PURE__ */ G(L.Paragraph, {
				variant: "3",
				children: "Sum"
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "3",
				children: LM(n, t)
			})]
		})
	}, "theSumOfItAll")]
}), BM = {
	transaction: "_transaction_1kr8d_1",
	transactionIsOpen: "_transactionIsOpen_1kr8d_9",
	transactionHeader: "_transactionHeader_1kr8d_12",
	transactionHeaderSubLine: "_transactionHeaderSubLine_1kr8d_15",
	transactionHeaderAlignItemRight: "_transactionHeaderAlignItemRight_1kr8d_19"
}, VM = ({ transaction: e, openByDefault: t }) => {
	let [r, i] = U(t), { transactionNumber: a, createdDate: o, storeName: s, numberOfItems: c, storeType: u, lineItems: d, localCurrency: f, localNetPriceSum: p } = e, m = f ?? "", h = p ?? 0, g = d?.length ? d : [];
	return /* @__PURE__ */ K(v, {
		className: ht(BM.transaction, { [BM.transactionIsOpen]: r }),
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: BM.transactionHeader,
			onClick: () => i(!r),
			"data-testid": "contact-transaction-header",
			children: [/* @__PURE__ */ K(v, {
				style: { flexGrow: 1 },
				children: [/* @__PURE__ */ K(v, {
					flexDirection: "column",
					gap: "100",
					children: [o && /* @__PURE__ */ G(n, {
						size: "small",
						variant: "info",
						children: kM(o).format(he)
					}), /* @__PURE__ */ K(L.Heading, {
						variant: "heading-4",
						className: BM.transactionHeaderSubLine,
						children: ["ID: ", a]
					})]
				}), /* @__PURE__ */ K(v, {
					flexDirection: "column",
					gap: "100",
					className: BM.transactionHeaderAlignItemRight,
					children: [/* @__PURE__ */ G(L.Heading, {
						variant: "heading-4",
						children: LM(h, m)
					}), /* @__PURE__ */ K(L.Heading, {
						variant: "heading-4",
						className: BM.transactionHeaderSubLine,
						children: [
							c,
							" line ",
							`${c === 1 ? "item" : "items"}`
						]
					})]
				})]
			}), /* @__PURE__ */ G(v, {
				flexDirection: "column",
				children: /* @__PURE__ */ G(S, {
					variant: "tertiary",
					icon: r ? "angle-up" : "angle-down"
				})
			})]
		}), r && /* @__PURE__ */ K(v, {
			gap: "300",
			flexDirection: "column",
			"data-testid": "contact-transaction-content",
			children: [/* @__PURE__ */ G(l, {}), /* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [
					s && /* @__PURE__ */ G(L.Heading, {
						variant: "heading-2",
						children: s
					}),
					u && /* @__PURE__ */ G(I, { children: /* @__PURE__ */ G(v, {
						alignItems: "center",
						children: u
					}) }),
					/* @__PURE__ */ G(zM, {
						lineItems: g,
						localCurrency: m,
						localNetPriceSum: h
					})
				]
			})]
		})]
	});
}, HM = ({ contactId: e }) => {
	let { isLoading: t, error: r, transactions: i } = xM({ contactId: e });
	if (!e) return null;
	let { items: a, totalCount: o } = i, s = o ?? 0;
	return r ? /* @__PURE__ */ G(z, { error: r }) : /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		"data-testid": "contact-transactions-wrapper",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Transactions"
			}), !t && s > 0 && /* @__PURE__ */ G(n, {
				size: "small",
				variant: "success",
				children: s
			})]
		}), t ? /* @__PURE__ */ G(v, {
			justifyContent: "center",
			margin: "300",
			children: /* @__PURE__ */ G(P, {})
		}) : /* @__PURE__ */ K(W, { children: [s === 0 && /* @__PURE__ */ G(v, {
			justifyContent: "center",
			padding: "200",
			children: /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				children: "There are no transactions for this contact"
			})
		}), s > 0 && a?.map((e, t) => /* @__PURE__ */ G(VM, {
			transaction: e,
			openByDefault: t === 0
		}, t))] })]
	});
}, UM = {
	message: "_message_4z55u_54",
	messageIsOpen: "_messageIsOpen_4z55u_62",
	messageHeader: "_messageHeader_4z55u_66",
	messageText: "_messageText_4z55u_70",
	buttonLink: "_buttonLink_4z55u_93"
}, WM = {
	status: {
		Delivered: "check-circle",
		Waiting: "clock",
		Hardbounce: "close-circle-filled",
		Softbounce: "close"
	},
	type: {
		EmailMessage: "mail",
		SmsMessage: "sms",
		PostalMessage: "paper-plane"
	},
	source: {
		Automation: "chat-bot",
		Manual: "user",
		System: "eye"
	}
}, GM = (e, t) => t && e in WM && t in WM[e] ? WM[e][t] : null, KM = ({ message: e, openByDefault: t }) => {
	let [r, i] = U(t), { track: a } = Ve();
	if (!e) return null;
	let { name: o, sendDateTime: s, type: c, source: u, isTransactional: d, status: f, messageLink: p, messageText: m } = e, h = c ? GM("type", c) : null, g = u ? GM("source", u) : null, _ = f ? GM("status", f) : null, y = c?.replace("Message", "");
	return /* @__PURE__ */ K(v, {
		className: ht(UM.message, { [UM.messageIsOpen]: r }),
		gap: "300",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: UM.messageHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [h && /* @__PURE__ */ K(W, { children: [
						/* @__PURE__ */ G(x, {
							name: h,
							size: 16
						}),
						" ",
						y
					] }), s && /* @__PURE__ */ G(n, {
						size: "small",
						variant: "info",
						children: kM(s).format(he)
					})]
				}), o]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: r ? "angle-up" : "angle-down"
			})]
		}), r && /* @__PURE__ */ K(v, {
			gap: "300",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ G(l, {}),
				/* @__PURE__ */ K(v, {
					gap: "200",
					flexDirection: "row",
					flexWrap: "wrap",
					children: [
						_ && /* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
							alignItems: "center",
							gap: "200",
							children: [
								/* @__PURE__ */ G(x, { name: _ }),
								" ",
								f
							]
						}) }),
						g && /* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
							alignItems: "center",
							gap: "200",
							children: [
								/* @__PURE__ */ G(x, { name: g }),
								" ",
								u
							]
						}) }),
						d && /* @__PURE__ */ G(I, { children: /* @__PURE__ */ K(v, {
							alignItems: "center",
							gap: "200",
							children: [/* @__PURE__ */ G(x, { name: "exchange" }), " Transactional"]
						}) })
					]
				}),
				/* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						color: "secondary",
						children: "Message text"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						className: UM.messageText,
						children: m
					})]
				}),
				p && /* @__PURE__ */ G(j, {
					slotEnd: /* @__PURE__ */ G(x, { name: "external-link" }),
					variant: "tertiary",
					className: UM.buttonLink,
					navigate: () => {
						y && a("voyado:message:external-link:opened", { channel: y.toUpperCase() }), window.open(p, "_blank")?.focus();
					},
					children: "Open message in new tab"
				})
			]
		})]
	});
}, qM = ({ contactId: e }) => {
	let { isLoading: t, error: r, lastMessages: i } = yM({ contactId: e });
	if (!e) return null;
	if (r) return /* @__PURE__ */ G(z, { error: r });
	let { count: a, items: o } = i, s = (a && a) ?? 0, c = s > 0;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Last Messages"
			}), !t && c && /* @__PURE__ */ G(n, {
				variant: "success",
				size: "small",
				children: s
			})]
		}), /* @__PURE__ */ G(v, {
			gap: "200",
			flexDirection: "column",
			children: t ? /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "300",
				children: /* @__PURE__ */ G(P, {})
			}) : /* @__PURE__ */ K(W, { children: [c && o?.map((e, t) => /* @__PURE__ */ G(KM, {
				message: e || void 0,
				openByDefault: t === 0
			}, t)), !c && /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "200",
				children: /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					color: "secondary",
					children: "No messages available"
				})
			})] })
		})]
	});
}, JM = ({ value: e, currencyCode: t }) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${t ?? ""}`, YM = ({ labelText: e, address: t, icon: n = "home" }) => {
	let { isCopied: r, copy: i } = _M(), a = [
		t?.title,
		t?.firstname,
		t?.lastname
	].filter(Boolean).join(" "), o = Ye(() => [
		a,
		t?.streetAddress,
		t?.streetAddress2,
		t?.postalCode,
		t?.region,
		t?.city,
		t?.country
	].filter(Boolean).join("\n"), [t, a]);
	return t ? /* @__PURE__ */ K(v, {
		justifyContent: "space-between",
		children: [/* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: n,
				color: "green.500"
			}), /* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: e
				}), /* @__PURE__ */ K(v, {
					gap: "100",
					flexDirection: "column",
					children: [
						a && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: a
						}),
						t?.streetAddress && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.streetAddress
						}),
						t?.streetAddress2 && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.streetAddress2
						}),
						t?.postalCode && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t?.postalCode
						}),
						t?.region && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.region
						}),
						t?.city && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.city
						}),
						t?.country && /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: t.country
						})
					]
				})]
			})]
		}), /* @__PURE__ */ G(R, {
			content: `Copy ${e.toLowerCase()}`,
			children: /* @__PURE__ */ G(x, {
				size: 14,
				name: r ? "done" : "copy",
				onClick: () => i(o()),
				className: wM.pointer
			})
		})]
	}) : null;
}, XM = {
	order: "_order_19t4p_1",
	orderIsOpen: "_orderIsOpen_19t4p_9",
	orderHeader: "_orderHeader_19t4p_12",
	orderIconColor: "_orderIconColor_19t4p_15"
}, ZM = {
	delivery: "_delivery_1m9nb_1",
	deliveryCode: "_deliveryCode_1m9nb_4"
}, QM = ({ delivery: e }) => {
	let { isCopied: t, copy: n } = Re();
	if (!e) return null;
	let { method: r, trackingNumber: i, trackingUri: a, deliveryDate: o } = e;
	return /* @__PURE__ */ K(v, {
		gap: "250",
		flexDirection: "row",
		children: [
			/* @__PURE__ */ G(x, {
				size: 14,
				name: "eye",
				className: XM.orderIconColor
			}),
			/* @__PURE__ */ K(v, {
				flexDirection: "column",
				gap: "200",
				width: "100%",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: "Delivery"
				}), /* @__PURE__ */ G(R, {
					content: /* @__PURE__ */ K(L.Paragraph, {
						variant: "4",
						color: "inherit",
						children: ["Arrives: ", kM(o).format(he)]
					}),
					children: /* @__PURE__ */ K(v, {
						gap: "100",
						flexDirection: "column",
						children: [a ? /* @__PURE__ */ G(L.ExternalLink, {
							href: a,
							target: "_blank",
							rel: "noreferrer",
							children: /* @__PURE__ */ K(v, {
								gap: "100",
								alignItems: "center",
								className: ZM.delivery,
								children: [/* @__PURE__ */ G(x, {
									name: "external-link",
									size: 14
								}), r]
							})
						}) : r, /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							className: ht(ZM.delivery, ZM.deliveryCode),
							children: i
						})]
					})
				})]
			}),
			i && /* @__PURE__ */ G(R, {
				content: "Copy tracking code",
				children: /* @__PURE__ */ G(x, {
					size: 14,
					name: t ? "done" : "copy",
					onClick: () => n(i.toString()),
					className: wM.pointer
				})
			})
		]
	});
}, $M = ({ fees: e, currencyCode: t }) => {
	if (!e) return null;
	let n = e?.items ?? [];
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: "file-text",
				className: XM.orderIconColor
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "3",
				children: "Fees"
			})]
		}), /* @__PURE__ */ G(E, {
			className: wM.list,
			children: n?.map((e, n) => /* @__PURE__ */ G(E.Item, {
				className: wM.listItem,
				children: /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					alignItems: "center",
					width: "100%",
					children: [/* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "100",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							children: e?.type
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: e?.description
						})]
					}), /* @__PURE__ */ G(v, {
						flexDirection: "column",
						gap: "100",
						children: e?.taxes?.items?.map((e, n) => /* @__PURE__ */ K(v, {
							gap: "100",
							flexDirection: "column",
							className: wM.listItemAlignRight,
							children: [/* @__PURE__ */ G(L.Paragraph, {
								variant: "5",
								children: `${e?.description} ${e?.percent}%`
							}), /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: JM({
									value: e?.amount,
									currencyCode: t
								})
							})]
						}, `tax-${n}`))
					})]
				})
			}, `fees-${n}`))
		})]
	});
}, eN = ({ lineItems: e, currencyCode: t }) => {
	if (!e) return null;
	let r = e?.items ?? [];
	return /* @__PURE__ */ K(v, {
		gap: "100",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: "tag",
				className: XM.orderIconColor
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "3",
				children: "Line items"
			})]
		}), /* @__PURE__ */ G(E, {
			className: wM.list,
			children: r?.map((e) => /* @__PURE__ */ G(E.Item, {
				className: wM.listItem,
				contentLeft: /* @__PURE__ */ K(v, {
					gap: "200",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: e?.quantity
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "×"
					})]
				}),
				title: /* @__PURE__ */ G(R, {
					content: /* @__PURE__ */ G(L.Paragraph, {
						variant: "3",
						color: "inherit",
						children: e?.article?.sku
					}),
					children: /* @__PURE__ */ K(v, {
						gap: "100",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: e?.article?.name
						}), /* @__PURE__ */ G(v, { children: /* @__PURE__ */ G(n, {
							size: "small",
							variant: "info",
							children: JM({
								value: e?.totalPrice,
								currencyCode: t
							})
						}) })]
					})
				}),
				contentRight: e?.article?.imageUri && /* @__PURE__ */ G(C, {
					src: e?.article?.imageUri,
					alt: e?.article?.name,
					style: { height: "48px" }
				})
			}, `list-${e?.id}`))
		})]
	});
}, tN = ({ payments: e, currencyCode: t }) => {
	if (!e) return null;
	let n = e?.items ?? [];
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "row",
			children: [/* @__PURE__ */ G(x, {
				size: 14,
				name: "credit-card",
				className: XM.orderIconColor
			}), /* @__PURE__ */ G(L.Paragraph, {
				variant: "3",
				children: "Payment methods"
			})]
		}), /* @__PURE__ */ G(E, {
			className: wM.list,
			children: n?.map((e, n) => /* @__PURE__ */ G(E.Item, {
				className: wM.listItem,
				children: /* @__PURE__ */ K(v, {
					justifyContent: "space-between",
					alignItems: "center",
					width: "100%",
					children: [/* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "100",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							children: e?.description
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: e?.method
						})]
					}), /* @__PURE__ */ K(v, {
						gap: "100",
						flexDirection: "column",
						className: wM.listItemAlignRight,
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "5",
							children: kM(e?.paidAt).format(he)
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: JM({
								value: e?.amount,
								currencyCode: t
							})
						})]
					})]
				})
			}, `payments-${n}`))
		})]
	});
}, nN = ({ order: e, openByDefault: t }) => {
	let [r, i] = U(t);
	if (!e) return null;
	let { orderId: a, status: o, externalStatus: s, currencyCode: c, channel: l, createdAt: u, lastChangedAt: d, lineItems: f, billingAddress: p, deliveryAddress: m, totalPrice: h } = e;
	return /* @__PURE__ */ K(v, {
		className: ht(XM.order, { [XM.orderIsOpen]: r }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: XM.orderHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [u && /* @__PURE__ */ G(v, {
					alignItems: "center",
					children: /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: kM(u).format(he)
					})
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "1",
					children: a
				})]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: r ? "angle-down" : "angle-right"
			})]
		}), r && /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				/* @__PURE__ */ K(v, {
					gap: "250",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "activity",
						className: XM.orderIconColor
					}), /* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Order status"
						}), /* @__PURE__ */ K(v, {
							gap: "100",
							alignItems: "center",
							flexWrap: "wrap",
							children: [
								o && /* @__PURE__ */ G(R, {
									content: "Internal status",
									children: /* @__PURE__ */ G(n, {
										size: "small",
										variant: "info",
										children: /* @__PURE__ */ G(W, { children: o })
									})
								}),
								s && /* @__PURE__ */ G(R, {
									content: "External status",
									children: /* @__PURE__ */ G(n, {
										size: "small",
										variant: "info",
										children: /* @__PURE__ */ G(W, { children: s })
									})
								}),
								/* @__PURE__ */ G(R, {
									content: "Last updated at",
									children: /* @__PURE__ */ G(L.Paragraph, {
										as: "span",
										variant: "5",
										children: kM(d).format(he)
									})
								})
							]
						})]
					})]
				}),
				/* @__PURE__ */ K(v, {
					gap: "250",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "chart-bar",
						className: XM.orderIconColor
					}), /* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Order value"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: JM({
								value: h,
								currencyCode: c
							})
						})]
					})]
				}),
				l && /* @__PURE__ */ K(v, {
					gap: "250",
					children: [/* @__PURE__ */ G(x, {
						size: 14,
						name: "channels",
						className: XM.orderIconColor
					}), /* @__PURE__ */ K(v, {
						flexDirection: "column",
						gap: "200",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Channel"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: /* @__PURE__ */ G(n, {
								size: "small",
								variant: "info",
								children: /* @__PURE__ */ G(W, { children: l })
							})
						})]
					})]
				}),
				/* @__PURE__ */ G(YM, {
					labelText: "Billing address",
					address: p
				}),
				/* @__PURE__ */ G(YM, {
					icon: "map-pin",
					labelText: "Delivery address",
					address: m
				}),
				/* @__PURE__ */ G(QM, { delivery: e.delivery }),
				/* @__PURE__ */ G(eN, {
					lineItems: f,
					currencyCode: c
				}),
				/* @__PURE__ */ G($M, {
					fees: e.fees,
					currencyCode: c
				}),
				/* @__PURE__ */ G(tN, {
					payments: e.payments,
					currencyCode: c
				})
			]
		})]
	});
}, rN = ({ error: e, itemCount: t, children: n }) => e ? t === 0 || Se({ errors: e.graphQLErrors }) ? /* @__PURE__ */ G(v, {
	justifyContent: "center",
	children: /* @__PURE__ */ G(L.Paragraph, {
		variant: "4",
		color: "secondary",
		children: "There are no orders for this contact"
	})
}) : /* @__PURE__ */ G(z, { error: e }) : /* @__PURE__ */ G(W, { children: n }), iN = ({ contactId: e }) => {
	let { useQuery: t } = B(), [r, i] = U([]), { track: a } = Ve(), { loading: o, error: s, data: c } = t(fM, {
		skip: !e,
		variables: { contactId: e }
	});
	return H(() => {
		if (c?.Voyado) {
			let e = c?.Voyado.Orders_GetAllByContact;
			if (!o && e?.items) {
				i(e.items);
				let { totalCount: t } = e;
				t && a("voyado:orders:received", { count: t });
			}
		}
	}, [c?.Voyado]), e ? /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		margin: "200 0 300 0",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			flexDirection: "row",
			alignItems: "center",
			children: [/* @__PURE__ */ G(L.Heading, {
				variant: "heading-3",
				children: "Orders"
			}), r.length > 0 && /* @__PURE__ */ G(n, {
				size: "small",
				variant: "success",
				children: r.length
			})]
		}), o ? /* @__PURE__ */ G(v, {
			justifyContent: "center",
			children: /* @__PURE__ */ G(P, {})
		}) : /* @__PURE__ */ G(rN, {
			error: s,
			itemCount: r.length,
			children: r.map((e, t) => /* @__PURE__ */ G(nN, {
				order: e,
				openByDefault: t === 0
			}, t))
		})]
	}) : null;
}, aN = ({ conversationContext: e, settings: t }) => {
	let { isLoading: n, contactId: r, hasMultipleContacts: i, error: a } = SM({ conversationContext: e }), o = !e?.customer?.email && !e?.customer?.phone_number, s = !!r, { showCustomerAttributes: c, showPreferences: l, showAudiences: u, showConsents: d, showLastMessages: f, showCustomerTransactions: p, showOrders: m } = t;
	return o ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "widget-no-contact-message",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No email nor phone number are available in this conversation to look up a profile."
		})
	}) : i ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "multiple-contacts-found-message",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized."
		})
	}) : a ? Se({ errors: a.graphQLErrors }) ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No profile found"
		})
	}) : /* @__PURE__ */ G(z, { error: a }) : !c && !l && !u && !d && !f && !p ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "All features toggles in the widget settings are disabled."
		})
	}) : n ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ G(P, {})
	}) : /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			/* @__PURE__ */ G(IM, {
				contactId: r,
				settings: t
			}),
			f && /* @__PURE__ */ G(qM, { contactId: r }),
			p && /* @__PURE__ */ G(HM, { contactId: r }),
			m && /* @__PURE__ */ G(iN, { contactId: r }),
			!s && /* @__PURE__ */ G(v, {
				justifyContent: "center",
				padding: "200",
				children: /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					color: "secondary",
					children: "No contact found."
				})
			})
		]
	});
}, oN = [
	{
		key: "voyadoApiKey",
		label: "API key",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "apiHostName",
		label: "API URL",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "showCustomerAttributes",
		label: "Show the customer attributes",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showPreferences",
		label: "Show preferences",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showAudiences",
		label: "Show audiences",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showConsents",
		label: "Show consents",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showLastMessages",
		label: "Show the last 5 messages",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showCustomerTransactions",
		label: "Show customer transactions",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showOrders",
		label: "Show orders by contact",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showMemberLevel",
		label: "Show member level",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], sN = Pe(oN), cN = {
	enabled: !1,
	name: "",
	voyadoApiKey: "",
	apiHostName: "",
	showCustomerAttributes: !0,
	showPreferences: !0,
	showAudiences: !0,
	showConsents: !0,
	showLastMessages: !0,
	showCustomerTransactions: !0,
	showOrders: !0,
	showMemberLevel: !0
}, lN = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r }) => {
	let i = !e, a = gl({
		mode: "onChange",
		defaultValues: cN
	}), { create: o, update: s, remove: c, isLoading: l, error: u, misconfigurationCause: d, setMisconfigurationCause: f } = He({
		integrationId: e,
		integrationType: "VOYADO",
		handleRedirect: t,
		showNotification: n
	}), { isLoading: p, error: m, isWidgetUnknown: h, refetch: g } = Ue({
		integrationId: e,
		fieldDefinitions: oN,
		form: a,
		onMisconfigured: f
	}), v = (e) => ye(e, {
		fieldDefinitions: oN,
		isCreationMode: i,
		create: o,
		update: s
	}), x = a.watch("name");
	return /* @__PURE__ */ K(de, {
		form: a,
		integrationId: e,
		onValidSubmit: v,
		error: m ?? u,
		onRetry: m ? g : void 0,
		isLoading: l || p,
		isWidgetUnknown: h,
		children: [
			d && /* @__PURE__ */ G(se, { cause: d }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: a.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: a.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(ue, {
						name: "voyadoApiKey",
						label: sN.voyadoApiKey,
						control: a.control,
						isCreationMode: i,
						rules: { required: "API key is required" },
						componentProps: {
							placeholder: "API key from Voyado",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "apiHostName",
						label: sN.apiHostName,
						control: a.control,
						rules: { required: "API URL is required" },
						componentProps: {
							placeholder: "The URL of the Voyado API",
							autoComplete: "off",
							prefix: "https://"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showCustomerAttributes,
						children: /* @__PURE__ */ G(X, {
							name: "showCustomerAttributes",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showPreferences,
						children: /* @__PURE__ */ G(X, {
							name: "showPreferences",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showAudiences,
						children: /* @__PURE__ */ G(X, {
							name: "showAudiences",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showConsents,
						children: /* @__PURE__ */ G(X, {
							name: "showConsents",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showLastMessages,
						children: /* @__PURE__ */ G(X, {
							name: "showLastMessages",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showCustomerTransactions,
						children: /* @__PURE__ */ G(X, {
							name: "showCustomerTransactions",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showOrders,
						children: /* @__PURE__ */ G(X, {
							name: "showOrders",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: sN.showMemberLevel,
						children: /* @__PURE__ */ G(X, {
							name: "showMemberLevel",
							control: a.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 })
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: "VOYADO",
				integrationId: e,
				widgetName: x,
				isCreationMode: i,
				isSubmitting: a.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => c()
			})
		]
	});
};
//#endregion
//#region ../widget-woocommerce/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_ow7wi_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_ow7wi_1:hover,._orderIsOpen_ow7wi_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_ow7wi_12{cursor:pointer}._customerNote_ow7wi_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var uN = {
	"\n  query getCustomer($email: WooCommerce_EmailAddress!) {\n    WooCommerce {\n      getCustomers(email: $email, role: \"all\", per_page: 1) {\n        ... on WooCommerce_Customer {\n          id\n          email\n          first_name\n          last_name\n          username\n          role\n          date_created\n          is_paying_customer\n          avatar_url\n          billing {\n            first_name\n            last_name\n            company\n            address_1\n            address_2\n            city\n            state\n            postcode\n            country\n            email\n            phone\n          }\n          shipping {\n            first_name\n            last_name\n            company\n            address_1\n            address_2\n            city\n            state\n            postcode\n            country\n          }\n        }\n        ... on WooCommerce_Error {\n          code\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getCustomer"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "WooCommerce_EmailAddress"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "WooCommerce"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getCustomers"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "email"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "email"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "role"
									},
									value: {
										kind: "StringValue",
										value: "all",
										block: !1
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "per_page"
									},
									value: {
										kind: "IntValue",
										value: "1"
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "WooCommerce_Customer"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "email"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "first_name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "last_name"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "username"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "role"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "date_created"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "is_paying_customer"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "avatar_url"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "billing"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "first_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "last_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "company"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "address_1"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "address_2"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "city"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "state"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "postcode"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "country"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "email"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "phone"
															}
														}
													]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "shipping"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "first_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "last_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "company"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "address_1"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "address_2"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "city"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "state"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "postcode"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "country"
															}
														}
													]
												}
											}
										]
									}
								}, {
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "WooCommerce_Error"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "code"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	},
	"\n  query getOrders($email: String!, $perPage: Int!) {\n    WooCommerce {\n      getOrders(\n        search: $email\n        per_page: $perPage\n        orderby: date\n        order: desc\n      ) {\n        ... on WooCommerce_Order {\n          id\n          number\n          status\n          currency\n          total\n          date_created\n          payment_method_title\n          customer_note\n          billing {\n            email\n          }\n          line_items {\n            id\n            name\n            quantity\n            total\n          }\n        }\n        ... on WooCommerce_Error {\n          code\n          message\n        }\n      }\n    }\n  }\n": {
		kind: "Document",
		definitions: [{
			kind: "OperationDefinition",
			operation: "query",
			name: {
				kind: "Name",
				value: "getOrders"
			},
			variableDefinitions: [{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			}, {
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "perPage"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "Int"
						}
					}
				}
			}],
			selectionSet: {
				kind: "SelectionSet",
				selections: [{
					kind: "Field",
					name: {
						kind: "Name",
						value: "WooCommerce"
					},
					selectionSet: {
						kind: "SelectionSet",
						selections: [{
							kind: "Field",
							name: {
								kind: "Name",
								value: "getOrders"
							},
							arguments: [
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "search"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "email"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "per_page"
									},
									value: {
										kind: "Variable",
										name: {
											kind: "Name",
											value: "perPage"
										}
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "orderby"
									},
									value: {
										kind: "EnumValue",
										value: "date"
									}
								},
								{
									kind: "Argument",
									name: {
										kind: "Name",
										value: "order"
									},
									value: {
										kind: "EnumValue",
										value: "desc"
									}
								}
							],
							selectionSet: {
								kind: "SelectionSet",
								selections: [{
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "WooCommerce_Order"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "id"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "number"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "status"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "currency"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "total"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "date_created"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "payment_method_title"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "customer_note"
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "billing"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [{
														kind: "Field",
														name: {
															kind: "Name",
															value: "email"
														}
													}]
												}
											},
											{
												kind: "Field",
												name: {
													kind: "Name",
													value: "line_items"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "quantity"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "total"
															}
														}
													]
												}
											}
										]
									}
								}, {
									kind: "InlineFragment",
									typeCondition: {
										kind: "NamedType",
										name: {
											kind: "Name",
											value: "WooCommerce_Error"
										}
									},
									selectionSet: {
										kind: "SelectionSet",
										selections: [{
											kind: "Field",
											name: {
												kind: "Name",
												value: "code"
											}
										}, {
											kind: "Field",
											name: {
												kind: "Name",
												value: "message"
											}
										}]
									}
								}]
							}
						}]
					}
				}]
			}
		}]
	}
};
function dN(e) {
	return uN[e] ?? {};
}
var fN = dN("\n  query getCustomer($email: WooCommerce_EmailAddress!) {\n    WooCommerce {\n      getCustomers(email: $email, role: \"all\", per_page: 1) {\n        ... on WooCommerce_Customer {\n          id\n          email\n          first_name\n          last_name\n          username\n          role\n          date_created\n          is_paying_customer\n          avatar_url\n          billing {\n            first_name\n            last_name\n            company\n            address_1\n            address_2\n            city\n            state\n            postcode\n            country\n            email\n            phone\n          }\n          shipping {\n            first_name\n            last_name\n            company\n            address_1\n            address_2\n            city\n            state\n            postcode\n            country\n          }\n        }\n        ... on WooCommerce_Error {\n          code\n          message\n        }\n      }\n    }\n  }\n"), pN = dN("\n  query getOrders($email: String!, $perPage: Int!) {\n    WooCommerce {\n      getOrders(\n        search: $email\n        per_page: $perPage\n        orderby: date\n        order: desc\n      ) {\n        ... on WooCommerce_Order {\n          id\n          number\n          status\n          currency\n          total\n          date_created\n          payment_method_title\n          customer_note\n          billing {\n            email\n          }\n          line_items {\n            id\n            name\n            quantity\n            total\n          }\n        }\n        ... on WooCommerce_Error {\n          code\n          message\n        }\n      }\n    }\n  }\n"), mN = Ws, hN = { copyIcon: "_copyIcon_1dlzg_1" }, gN = (e) => (e ?? "").trim().toLowerCase(), _N = (e, t) => {
	let n = gN(t);
	return (e ?? []).find((e) => e?.__typename === "WooCommerce_Customer" && gN(e.email) === n);
}, vN = (e) => {
	if (!e) return [];
	let t = `${e.first_name ?? ""} ${e.last_name ?? ""}`.trim(), n = [e.postcode, e.city].filter(Boolean).join(" ").trim();
	return [
		t,
		e.company,
		e.address_1,
		e.address_2,
		n,
		e.state,
		e.country
	].map((e) => (e ?? "").trim()).filter(Boolean);
}, yN = 14, bN = ({ address: e, title: t, icon: n }) => {
	let { isCopied: r, copy: a } = Re(), o = vN(e);
	return o.length ? /* @__PURE__ */ K(v, {
		gap: "200",
		justifyContent: "space-between",
		children: [/* @__PURE__ */ K(v, {
			gap: "200",
			children: [/* @__PURE__ */ G(x, {
				size: yN,
				name: n
			}), /* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "3",
					children: t
				}), /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: o.map((e, t) => /* @__PURE__ */ G(i, { children: e }, t))
				})]
			})]
		}), /* @__PURE__ */ G(R, {
			content: `Copy ${t.toLowerCase()}`,
			children: /* @__PURE__ */ G(x, {
				size: yN,
				name: r ? "done" : "copy",
				onClick: () => a(o.join(", ")),
				className: hN.copyIcon
			})
		})]
	}) : null;
}, xN = { wrapper: "_wrapper_1nher_1" }, SN = (e) => [
	`${e.first_name ?? ""} ${e.last_name ?? ""}`,
	`${e.billing?.first_name ?? ""} ${e.billing?.last_name ?? ""}`,
	e.username ?? ""
].map((e) => e.trim()).find(Boolean) ?? "This customer has no name", CN = ({ email: e, billingEmail: t }) => {
	let n = (t ?? "").trim();
	return !n || gN(t) === gN(e) ? null : n;
}, wN = "customer", TN = (e) => {
	let t = (e ?? "").trim();
	if (!t || t === wN) return null;
	let n = t.replaceAll("_", " ").toLowerCase();
	return `${n.charAt(0).toUpperCase()}${n.slice(1)}`;
}, EN = ({ storeHostName: e, customerId: t }) => t == null || We(e) ? null : `https://${e}/wp-admin/user-edit.php?user_id=${t}`, DN = 14, ON = ({ customer: e, storeHostName: t }) => {
	let { isCopied: n, copy: r } = Re(), { isCopied: i, copy: a } = Re(), { isCopied: o, copy: s } = Re(), { id: c, email: l, username: u, role: d, date_created: f, is_paying_customer: p, billing: m, shipping: h } = e, g = SN(e), _ = m?.phone, y = TN(d), b = CN({
		email: l,
		billingEmail: m?.email
	}), S = EN({
		storeHostName: t,
		customerId: c
	});
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		margin: "0 0 300",
		children: /* @__PURE__ */ K(v, {
			className: xN.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ G(L.Heading, {
					variant: "heading-2",
					children: g
				}),
				(f || y) && /* @__PURE__ */ K(v, {
					gap: "200",
					flexDirection: "column",
					margin: "0 0 200",
					children: [f && /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: "Customer since"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: mN(f).format("DD MMM YYYY")
						})]
					}), y && /* @__PURE__ */ K(v, {
						gap: "200",
						justifyContent: "space-between",
						children: [/* @__PURE__ */ K(v, {
							gap: "200",
							alignItems: "center",
							children: [/* @__PURE__ */ G(x, {
								size: DN,
								name: "id-card"
							}), /* @__PURE__ */ G(L.Paragraph, {
								variant: "4",
								children: "Store role"
							})]
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: y
						})]
					})]
				}),
				l && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: DN,
							name: "mail"
						}), /* @__PURE__ */ G(L.ExternalLink, {
							href: `mailto:${l}`,
							children: l
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy email",
						children: /* @__PURE__ */ G(x, {
							size: DN,
							name: n ? "done" : "copy",
							onClick: () => r(l),
							className: hN.copyIcon
						})
					})]
				}),
				b && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(R, {
							content: "The billing address uses a different email than the account",
							children: /* @__PURE__ */ G(x, {
								size: DN,
								name: "mail"
							})
						}), /* @__PURE__ */ G(L.ExternalLink, {
							href: `mailto:${b}`,
							children: b
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy billing email",
						children: /* @__PURE__ */ G(x, {
							size: DN,
							name: i ? "done" : "copy",
							onClick: () => a(b),
							className: hN.copyIcon
						})
					})]
				}),
				_ && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: DN,
							name: "phone"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: _
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ G(x, {
							size: DN,
							name: o ? "done" : "copy",
							onClick: () => s(_),
							className: hN.copyIcon
						})
					})]
				}),
				u && /* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ G(x, {
						size: DN,
						name: "user"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: u
					})]
				}),
				/* @__PURE__ */ G(bN, {
					address: m,
					title: "Billing address",
					icon: "credit-card"
				}),
				/* @__PURE__ */ G(bN, {
					address: h,
					title: "Shipping address",
					icon: "home"
				}),
				/* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: DN,
							name: "cart-shopping"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: "Has placed a paid order"
						})]
					}), /* @__PURE__ */ G(x, {
						size: DN,
						name: p ? "check-circle" : "close-circle-filled",
						color: p ? "green.500" : "red.500"
					})]
				}),
				S && /* @__PURE__ */ K(v, {
					alignItems: "center",
					gap: "200",
					children: [/* @__PURE__ */ G(x, {
						size: DN,
						name: "external-link"
					}), /* @__PURE__ */ G(L.ExternalLink, {
						href: S,
						target: "_blank",
						rel: "noreferrer",
						children: "View customer in WooCommerce"
					})]
				})
			]
		})
	});
}, kN = {
	order: "_order_ow7wi_1",
	orderIsOpen: "_orderIsOpen_ow7wi_9",
	orderHeader: "_orderHeader_ow7wi_12",
	customerNote: "_customerNote_ow7wi_16"
}, AN = (e) => {
	let t = (e ?? "").trim();
	if (!t) return null;
	let n = t.replaceAll("-", " ").replaceAll("_", " ");
	return `${n.charAt(0).toUpperCase()}${n.slice(1).toLowerCase()}`;
}, jN = {
	completed: "success",
	processing: "info",
	pending: "warning",
	"on-hold": "warning",
	cancelled: "error",
	failed: "error",
	refunded: "secondary"
}, MN = (e) => jN[(e ?? "").trim().toLowerCase()] ?? "secondary", NN = ({ total: e, currency: t }) => {
	let n = (e ?? "").trim();
	return n ? [n, (t ?? "").trim()].filter(Boolean).join(" ") : null;
}, PN = (e) => (e ?? []).reduce((e, t) => e + (t?.quantity ?? 0), 0), FN = 14, IN = ({ order: e, isOpenByDefault: t }) => {
	let [r, i] = U(t), { number: a, status: o, total: s, currency: c, date_created: l, payment_method_title: u, customer_note: d, line_items: f } = e, p = AN(o), m = NN({
		total: s,
		currency: c
	}), h = PN(f);
	return /* @__PURE__ */ K(v, {
		className: ht(kN.order, { [kN.orderIsOpen]: r }),
		gap: "200",
		flexDirection: "column",
		children: [/* @__PURE__ */ K(v, {
			justifyContent: "space-between",
			alignItems: "center",
			className: kN.orderHeader,
			onClick: () => i(!r),
			children: [/* @__PURE__ */ K(v, {
				gap: "100",
				flexDirection: "column",
				children: [l && /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: mN(l).format("DD MMM YYYY")
				}), /* @__PURE__ */ K(v, {
					gap: "200",
					alignItems: "center",
					children: [/* @__PURE__ */ K(L.Paragraph, {
						variant: "1",
						children: ["Order #", a]
					}), p && /* @__PURE__ */ G(n, {
						variant: MN(o),
						size: "small",
						children: p
					})]
				})]
			}), /* @__PURE__ */ G(S, {
				variant: "tertiary",
				icon: r ? "angle-down" : "angle-right"
			})]
		}), r && /* @__PURE__ */ K(v, {
			gap: "250",
			flexDirection: "column",
			margin: "200 0 0",
			children: [
				d && /* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					color: "secondary",
					className: kN.customerNote,
					children: d
				}),
				m && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: FN,
						name: "chart-bar"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Order value"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: m
						})]
					})]
				}),
				u && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: FN,
						name: "credit-card"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: "Payment method"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: u
						})]
					})]
				}),
				h > 0 && /* @__PURE__ */ K(v, {
					gap: "250",
					flexDirection: "row",
					children: [/* @__PURE__ */ G(x, {
						size: FN,
						name: "cart-shopping"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [/* @__PURE__ */ G(L.Paragraph, {
							variant: "3",
							children: h === 1 ? "1 item" : `${h} items`
						}), /* @__PURE__ */ G(v, {
							gap: "100",
							flexDirection: "column",
							children: (f ?? []).map((e) => e && /* @__PURE__ */ K(L.Paragraph, {
								variant: "4",
								children: [
									e.quantity,
									" × ",
									e.name
								]
							}, e.id))
						})]
					})]
				})
			]
		})]
	});
}, LN = (e) => e?.__typename === "WooCommerce_Order", RN = (e) => e?.__typename === "WooCommerce_Error", zN = (e) => {
	let t = [], n = [];
	for (let r of e ?? []) LN(r) ? t.push(r) : RN(r) && n.push(r);
	return {
		orders: t,
		errors: n
	};
}, BN = 5, VN = ({ email: e }) => {
	let { useQuery: t } = B(), { loading: r, error: i, data: a } = t(pN, {
		skip: !e,
		variables: {
			email: e,
			perPage: BN
		}
	});
	if (i) return /* @__PURE__ */ G(z, { error: i });
	let { orders: o, errors: s } = zN(a?.WooCommerce?.getOrders), c = !r && !o.length && s.length > 0;
	return /* @__PURE__ */ K(v, {
		gap: "200",
		flexDirection: "column",
		children: [
			/* @__PURE__ */ K(v, {
				gap: "200",
				flexDirection: "row",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "Recent orders"
				}), !r && o.length > 0 && /* @__PURE__ */ G(n, {
					variant: "success",
					size: "small",
					children: o.length
				})]
			}),
			r && /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "300",
				children: /* @__PURE__ */ G(P, {})
			}),
			c && /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "200 0 300 0",
				"data-testid": "widget-orders-error",
				children: /* @__PURE__ */ G(L.Paragraph, {
					color: "secondary",
					variant: "4",
					children: s[0].message ?? "The orders could not be loaded from WooCommerce."
				})
			}),
			!r && !c && o.length === 0 && /* @__PURE__ */ G(v, {
				justifyContent: "center",
				margin: "200 0 300 0",
				"data-testid": "widget-no-orders",
				children: /* @__PURE__ */ G(L.Paragraph, {
					color: "tertiary",
					children: "No orders found"
				})
			}),
			!r && o.length > 0 && /* @__PURE__ */ G(v, {
				gap: "200",
				flexDirection: "column",
				children: o.map((e, t) => /* @__PURE__ */ G(IN, {
					order: e,
					isOpenByDefault: t === 0
				}, e.id))
			})
		]
	});
}, HN = ({ conversationContext: e, settings: t }) => {
	let { useQuery: n } = B(), r = e?.customer?.email, { loading: i, error: a, data: o } = n(fN, {
		skip: !r,
		variables: { email: r }
	});
	if (!r) return /* @__PURE__ */ G(L.Paragraph, {
		margin: "200 0 300 0",
		color: "secondary",
		variant: "4",
		children: "This conversation has no customer email, so the WooCommerce customer cannot be looked up."
	});
	if (a) {
		let e = a.graphQLErrors;
		if (xe({ errors: e })) return /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
		});
		if (be({ errors: e })) return /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against WooCommerce. Please contact your administrator."
		});
		if (!Se({ errors: e })) return /* @__PURE__ */ G(z, { error: a });
	}
	if (i) return /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(P, {})
	});
	let s = _N(o?.WooCommerce?.getCustomers, r);
	return /* @__PURE__ */ K(v, {
		flexDirection: "column",
		gap: "300",
		margin: "200 0 300",
		children: [s ? /* @__PURE__ */ G(ON, {
			customer: s,
			storeHostName: String(t?.apiHostName ?? "")
		}) : /* @__PURE__ */ G(L.Paragraph, {
			color: "secondary",
			variant: "4",
			children: "No WooCommerce account for this email. Any orders below were placed as a guest."
		}), /* @__PURE__ */ G(VN, { email: r })]
	});
}, UN = Gs, WN = (e) => e.type === "checkbox", GN = (e) => e instanceof Date, KN = (e) => e == null, qN = (e) => typeof e == "object", JN = (e) => !KN(e) && !Array.isArray(e) && qN(e) && !GN(e), YN = (e) => JN(e) && e.target ? WN(e.target) ? e.target.checked : e.target.value : e, XN = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, ZN = (e, t) => e.has(XN(t)), QN = (e) => {
	let t = e.constructor && e.constructor.prototype;
	return JN(t) && t.hasOwnProperty("isPrototypeOf");
}, $N = typeof window < "u" && window.HTMLElement !== void 0 && typeof document < "u";
function eP(e) {
	let t, n = Array.isArray(e), r = typeof FileList < "u" && e instanceof FileList;
	if (e instanceof Date) t = new Date(e);
	else if (e instanceof Set) t = new Set(e);
	else if (!($N && (e instanceof Blob || r)) && (n || JN(e))) if (t = n ? [] : {}, !n && !QN(e)) t = e;
	else for (let n in e) e.hasOwnProperty(n) && (t[n] = eP(e[n]));
	else return e;
	return t;
}
var tP = (e) => Array.isArray(e) ? e.filter(Boolean) : [], nP = (e) => e === void 0, $ = (e, t, n) => {
	if (!t || !JN(e)) return n;
	let r = tP(t.split(/[,[\].]+?/)).reduce((e, t) => KN(e) ? e : e[t], e);
	return nP(r) || r === e ? nP(e[t]) ? n : e[t] : r;
}, rP = (e) => typeof e == "boolean", iP = (e) => /^\w*$/.test(e), aP = (e) => tP(e.replace(/["|']|\]/g, "").split(/\.|\[/)), oP = (e, t, n) => {
	let r = -1, i = iP(t) ? [t] : aP(t), a = i.length, o = a - 1;
	for (; ++r < a;) {
		let t = i[r], a = n;
		if (r !== o) {
			let n = e[t];
			a = JN(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
		}
		if (t === "__proto__" || t === "constructor" || t === "prototype") return;
		e[t] = a, e = e[t];
	}
}, sP = {
	BLUR: "blur",
	FOCUS_OUT: "focusout",
	CHANGE: "change"
}, cP = {
	onBlur: "onBlur",
	onChange: "onChange",
	onSubmit: "onSubmit",
	onTouched: "onTouched",
	all: "all"
}, lP = {
	max: "max",
	min: "min",
	maxLength: "maxLength",
	minLength: "minLength",
	pattern: "pattern",
	required: "required",
	validate: "validate"
}, uP = V.createContext(null), dP = () => V.useContext(uP), fP = (e, t, n, r = !0) => {
	let i = { defaultValues: t._defaultValues };
	for (let a in e) Object.defineProperty(i, a, { get: () => {
		let i = a;
		return t._proxyFormState[i] !== cP.all && (t._proxyFormState[i] = !r || cP.all), n && (n[i] = !0), e[i];
	} });
	return i;
};
function pP(e) {
	let t = dP(), { control: n = t.control, disabled: r, name: i, exact: a } = e || {}, [o, s] = V.useState(n._formState), c = V.useRef({
		isDirty: !1,
		isLoading: !1,
		dirtyFields: !1,
		touchedFields: !1,
		validatingFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}), l = V.useRef(i);
	return l.current = i, V.useEffect(() => n._subscribe({
		name: l.current,
		formState: c.current,
		exact: a,
		callback: (e) => {
			!r && s({
				...n._formState,
				...e
			});
		}
	}), [
		n,
		r,
		a
	]), V.useEffect(() => {
		c.current.isValid && n._setValid(!0);
	}, [n]), V.useMemo(() => fP(o, n, c.current, !1), [o, n]);
}
var mP = (e) => typeof e == "string", hP = (e, t, n, r, i) => mP(e) ? (r && t.watch.add(e), $(n, e, i)) : Array.isArray(e) ? e.map((e) => (r && t.watch.add(e), $(n, e))) : (r && (t.watchAll = !0), n);
function gP(e) {
	let t = dP(), { control: n = t.control, name: r, defaultValue: i, disabled: a, exact: o } = e || {}, s = V.useRef(r), c = V.useRef(i);
	s.current = r, V.useEffect(() => n._subscribe({
		name: s.current,
		formState: { values: !0 },
		exact: o,
		callback: (e) => !a && u(hP(s.current, n._names, e.values || n._formValues, !1, c.current))
	}), [
		n,
		a,
		o
	]);
	let [l, u] = V.useState(n._getWatch(r, i));
	return V.useEffect(() => n._removeUnmounted()), l;
}
function _P(e) {
	let t = dP(), { name: n, disabled: r, control: i = t.control, shouldUnregister: a } = e, o = ZN(i._names.array, n), s = gP({
		control: i,
		name: n,
		defaultValue: $(i._formValues, n, $(i._defaultValues, n, e.defaultValue)),
		exact: !0
	}), c = pP({
		control: i,
		name: n,
		exact: !0
	}), l = V.useRef(e), u = V.useRef(i.register(n, {
		...e.rules,
		value: s,
		...rP(e.disabled) ? { disabled: e.disabled } : {}
	})), d = V.useMemo(() => Object.defineProperties({}, {
		invalid: {
			enumerable: !0,
			get: () => !!$(c.errors, n)
		},
		isDirty: {
			enumerable: !0,
			get: () => !!$(c.dirtyFields, n)
		},
		isTouched: {
			enumerable: !0,
			get: () => !!$(c.touchedFields, n)
		},
		isValidating: {
			enumerable: !0,
			get: () => !!$(c.validatingFields, n)
		},
		error: {
			enumerable: !0,
			get: () => $(c.errors, n)
		}
	}), [c, n]), f = V.useCallback((e) => u.current.onChange({
		target: {
			value: YN(e),
			name: n
		},
		type: sP.CHANGE
	}), [n]), p = V.useCallback(() => u.current.onBlur({
		target: {
			value: $(i._formValues, n),
			name: n
		},
		type: sP.BLUR
	}), [n, i._formValues]), m = V.useCallback((e) => {
		let t = $(i._fields, n);
		t && e && (t._f.ref = {
			focus: () => e.focus(),
			select: () => e.select(),
			setCustomValidity: (t) => e.setCustomValidity(t),
			reportValidity: () => e.reportValidity()
		});
	}, [i._fields, n]), h = V.useMemo(() => ({
		name: n,
		value: s,
		...rP(r) || c.disabled ? { disabled: c.disabled || r } : {},
		onChange: f,
		onBlur: p,
		ref: m
	}), [
		n,
		r,
		c.disabled,
		f,
		p,
		m,
		s
	]);
	return V.useEffect(() => {
		let e = i._options.shouldUnregister || a;
		i.register(n, {
			...l.current.rules,
			...rP(l.current.disabled) ? { disabled: l.current.disabled } : {}
		});
		let t = (e, t) => {
			let n = $(i._fields, e);
			n && n._f && (n._f.mount = t);
		};
		if (t(n, !0), e) {
			let e = eP($(i._options.defaultValues, n));
			oP(i._defaultValues, n, e), nP($(i._formValues, n)) && oP(i._formValues, n, e);
		}
		return !o && i.register(n), () => {
			(o ? e && !i._state.action : e) ? i.unregister(n) : t(n, !1);
		};
	}, [
		n,
		i,
		o,
		a
	]), V.useEffect(() => {
		i._setDisabledField({
			disabled: r,
			name: n
		});
	}, [
		r,
		n,
		i
	]), V.useMemo(() => ({
		field: h,
		formState: c,
		fieldState: d
	}), [
		h,
		c,
		d
	]);
}
var vP = (e, t, n, r, i) => t ? {
	...n[e],
	types: {
		...n[e] && n[e].types ? n[e].types : {},
		[r]: i || !0
	}
} : {}, yP = (e) => Array.isArray(e) ? e : [e], bP = () => {
	let e = [];
	return {
		get observers() {
			return e;
		},
		next: (t) => {
			for (let n of e) n.next && n.next(t);
		},
		subscribe: (t) => (e.push(t), { unsubscribe: () => {
			e = e.filter((e) => e !== t);
		} }),
		unsubscribe: () => {
			e = [];
		}
	};
}, xP = (e) => KN(e) || !qN(e);
function SP(e, t) {
	if (xP(e) || xP(t)) return e === t;
	if (GN(e) && GN(t)) return e.getTime() === t.getTime();
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let i of n) {
		let n = e[i];
		if (!r.includes(i)) return !1;
		if (i !== "ref") {
			let e = t[i];
			if (GN(n) && GN(e) || JN(n) && JN(e) || Array.isArray(n) && Array.isArray(e) ? !SP(n, e) : n !== e) return !1;
		}
	}
	return !0;
}
var CP = (e) => JN(e) && !Object.keys(e).length, wP = (e) => e.type === "file", TP = (e) => typeof e == "function", EP = (e) => {
	if (!$N) return !1;
	let t = e ? e.ownerDocument : 0;
	return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, DP = (e) => e.type === "select-multiple", OP = (e) => e.type === "radio", kP = (e) => OP(e) || WN(e), AP = (e) => EP(e) && e.isConnected;
function jP(e, t) {
	let n = t.slice(0, -1).length, r = 0;
	for (; r < n;) e = nP(e) ? r++ : e[t[r++]];
	return e;
}
function MP(e) {
	for (let t in e) if (e.hasOwnProperty(t) && !nP(e[t])) return !1;
	return !0;
}
function NP(e, t) {
	let n = Array.isArray(t) ? t : iP(t) ? [t] : aP(t), r = n.length === 1 ? e : jP(e, n), i = n.length - 1, a = n[i];
	return r && delete r[a], i !== 0 && (JN(r) && CP(r) || Array.isArray(r) && MP(r)) && NP(e, n.slice(0, -1)), e;
}
var PP = (e) => {
	for (let t in e) if (TP(e[t])) return !0;
	return !1;
};
function FP(e, t = {}) {
	let n = Array.isArray(e);
	if (JN(e) || n) for (let n in e) Array.isArray(e[n]) || JN(e[n]) && !PP(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, FP(e[n], t[n])) : KN(e[n]) || (t[n] = !0);
	return t;
}
function IP(e, t, n) {
	let r = Array.isArray(e);
	if (JN(e) || r) for (let r in e) Array.isArray(e[r]) || JN(e[r]) && !PP(e[r]) ? nP(t) || xP(n[r]) ? n[r] = Array.isArray(e[r]) ? FP(e[r], []) : { ...FP(e[r]) } : IP(e[r], KN(t) ? {} : t[r], n[r]) : n[r] = !SP(e[r], t[r]);
	return n;
}
var LP = (e, t) => IP(e, t, FP(t)), RP = {
	value: !1,
	isValid: !1
}, zP = {
	value: !0,
	isValid: !0
}, BP = (e) => {
	if (Array.isArray(e)) {
		if (e.length > 1) {
			let t = e.filter((e) => e && e.checked && !e.disabled).map((e) => e.value);
			return {
				value: t,
				isValid: !!t.length
			};
		}
		return e[0].checked && !e[0].disabled ? e[0].attributes && !nP(e[0].attributes.value) ? nP(e[0].value) || e[0].value === "" ? zP : {
			value: e[0].value,
			isValid: !0
		} : zP : RP;
	}
	return RP;
}, VP = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => nP(e) ? e : t ? e === "" ? NaN : e && +e : n && mP(e) ? new Date(e) : r ? r(e) : e, HP = {
	isValid: !1,
	value: null
}, UP = (e) => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
	isValid: !0,
	value: t.value
} : e, HP) : HP;
function WP(e) {
	let t = e.ref;
	return wP(t) ? t.files : OP(t) ? UP(e.refs).value : DP(t) ? [...t.selectedOptions].map(({ value: e }) => e) : WN(t) ? BP(e.refs).value : VP(nP(t.value) ? e.ref.value : t.value, e);
}
var GP = (e, t, n, r) => {
	let i = {};
	for (let n of e) {
		let e = $(t, n);
		e && oP(i, n, e._f);
	}
	return {
		criteriaMode: n,
		names: [...e],
		fields: i,
		shouldUseNativeValidation: r
	};
}, KP = (e) => e instanceof RegExp, qP = (e) => nP(e) ? e : KP(e) ? e.source : JN(e) ? KP(e.value) ? e.value.source : e.value : e, JP = (e) => ({
	isOnSubmit: !e || e === cP.onSubmit,
	isOnBlur: e === cP.onBlur,
	isOnChange: e === cP.onChange,
	isOnAll: e === cP.all,
	isOnTouch: e === cP.onTouched
}), YP = "AsyncFunction", XP = (e) => !!e && !!e.validate && !!(TP(e.validate) && e.validate.constructor.name === YP || JN(e.validate) && Object.values(e.validate).find((e) => e.constructor.name === YP)), ZP = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), QP = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((t) => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))), $P = (e, t, n, r) => {
	for (let i of n || Object.keys(e)) {
		let n = $(e, i);
		if (n) {
			let { _f: e, ...a } = n;
			if (e) {
				if (e.refs && e.refs[0] && t(e.refs[0], i) && !r || e.ref && t(e.ref, e.name) && !r) return !0;
				if ($P(a, t)) break;
			} else if (JN(a) && $P(a, t)) break;
		}
	}
};
function eF(e, t, n) {
	let r = $(e, n);
	if (r || iP(n)) return {
		error: r,
		name: n
	};
	let i = n.split(".");
	for (; i.length;) {
		let r = i.join("."), a = $(t, r), o = $(e, r);
		if (a && !Array.isArray(a) && n !== r) return { name: n };
		if (o && o.type) return {
			name: r,
			error: o
		};
		i.pop();
	}
	return { name: n };
}
var tF = (e, t, n, r) => {
	n(e);
	let { name: i, ...a } = e;
	return CP(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((e) => t[e] === (!r || cP.all));
}, nF = (e, t, n) => !e || !t || e === t || yP(e).some((e) => e && (n ? e === t : e.startsWith(t) || t.startsWith(e))), rF = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, iF = (e, t) => !tP($(e, t)).length && NP(e, t), aF = (e, t, n) => {
	let r = yP($(e, n));
	return oP(r, "root", t[n]), oP(e, n, r), e;
}, oF = (e) => mP(e);
function sF(e, t, n = "validate") {
	if (oF(e) || Array.isArray(e) && e.every(oF) || rP(e) && !e) return {
		type: n,
		message: oF(e) ? e : "",
		ref: t
	};
}
var cF = (e) => JN(e) && !KP(e) ? e : {
	value: e,
	message: ""
}, lF = async (e, t, n, r, i, a) => {
	let { ref: o, refs: s, required: c, maxLength: l, minLength: u, min: d, max: f, pattern: p, validate: m, name: h, valueAsNumber: g, mount: _ } = e._f, v = $(n, h);
	if (!_ || t.has(h)) return {};
	let y = s ? s[0] : o, b = (e) => {
		i && y.reportValidity && (y.setCustomValidity(rP(e) ? "" : e || ""), y.reportValidity());
	}, x = {}, S = OP(o), C = WN(o), w = S || C, T = (g || wP(o)) && nP(o.value) && nP(v) || EP(o) && o.value === "" || v === "" || Array.isArray(v) && !v.length, E = vP.bind(null, h, r, x), D = (e, t, n, r = lP.maxLength, i = lP.minLength) => {
		let a = e ? t : n;
		x[h] = {
			type: e ? r : i,
			message: a,
			ref: o,
			...E(e ? r : i, a)
		};
	};
	if (a ? !Array.isArray(v) || !v.length : c && (!w && (T || KN(v)) || rP(v) && !v || C && !BP(s).isValid || S && !UP(s).isValid)) {
		let { value: e, message: t } = oF(c) ? {
			value: !!c,
			message: c
		} : cF(c);
		if (e && (x[h] = {
			type: lP.required,
			message: t,
			ref: y,
			...E(lP.required, t)
		}, !r)) return b(t), x;
	}
	if (!T && (!KN(d) || !KN(f))) {
		let e, t, n = cF(f), i = cF(d);
		if (!KN(v) && !isNaN(v)) {
			let r = o.valueAsNumber || v && +v;
			KN(n.value) || (e = r > n.value), KN(i.value) || (t = r < i.value);
		} else {
			let r = o.valueAsDate || new Date(v), a = (e) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + e), s = o.type == "time", c = o.type == "week";
			mP(n.value) && v && (e = s ? a(v) > a(n.value) : c ? v > n.value : r > new Date(n.value)), mP(i.value) && v && (t = s ? a(v) < a(i.value) : c ? v < i.value : r < new Date(i.value));
		}
		if ((e || t) && (D(!!e, n.message, i.message, lP.max, lP.min), !r)) return b(x[h].message), x;
	}
	if ((l || u) && !T && (mP(v) || a && Array.isArray(v))) {
		let e = cF(l), t = cF(u), n = !KN(e.value) && v.length > +e.value, i = !KN(t.value) && v.length < +t.value;
		if ((n || i) && (D(n, e.message, t.message), !r)) return b(x[h].message), x;
	}
	if (p && !T && mP(v)) {
		let { value: e, message: t } = cF(p);
		if (KP(e) && !v.match(e) && (x[h] = {
			type: lP.pattern,
			message: t,
			ref: o,
			...E(lP.pattern, t)
		}, !r)) return b(t), x;
	}
	if (m) {
		if (TP(m)) {
			let e = sF(await m(v, n), y);
			if (e && (x[h] = {
				...e,
				...E(lP.validate, e.message)
			}, !r)) return b(e.message), x;
		} else if (JN(m)) {
			let e = {};
			for (let t in m) {
				if (!CP(e) && !r) break;
				let i = sF(await m[t](v, n), y, t);
				i && (e = {
					...i,
					...E(t, i.message)
				}, b(i.message), r && (x[h] = e));
			}
			if (!CP(e) && (x[h] = {
				ref: y,
				...e
			}, !r)) return x;
		}
	}
	return b(!0), x;
}, uF = {
	mode: cP.onSubmit,
	reValidateMode: cP.onChange,
	shouldFocusError: !0
};
function dF(e = {}) {
	let t = {
		...uF,
		...e
	}, n = {
		submitCount: 0,
		isDirty: !1,
		isLoading: TP(t.defaultValues),
		isValidating: !1,
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		touchedFields: {},
		dirtyFields: {},
		validatingFields: {},
		errors: t.errors || {},
		disabled: t.disabled || !1
	}, r = {}, i = (JN(t.defaultValues) || JN(t.values)) && eP(t.values || t.defaultValues) || {}, a = t.shouldUnregister ? {} : eP(i), o = {
		action: !1,
		mount: !1,
		watch: !1
	}, s = {
		mount: /* @__PURE__ */ new Set(),
		disabled: /* @__PURE__ */ new Set(),
		unMount: /* @__PURE__ */ new Set(),
		array: /* @__PURE__ */ new Set(),
		watch: /* @__PURE__ */ new Set()
	}, c, l = 0, u = {
		isDirty: !1,
		dirtyFields: !1,
		validatingFields: !1,
		touchedFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}, d = { ...u }, f = {
		array: bP(),
		state: bP()
	}, p = JP(t.mode), m = JP(t.reValidateMode), h = t.criteriaMode === cP.all, g = (e) => (t) => {
		clearTimeout(l), l = setTimeout(e, t);
	}, _ = async (e) => {
		if (!t.disabled && (u.isValid || d.isValid || e)) {
			let e = t.resolver ? CP((await T()).errors) : await D(r, !0);
			e !== n.isValid && f.state.next({ isValid: e });
		}
	}, v = (e, r) => {
		!t.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((e || Array.from(s.mount)).forEach((e) => {
			e && (r ? oP(n.validatingFields, e, r) : NP(n.validatingFields, e));
		}), f.state.next({
			validatingFields: n.validatingFields,
			isValidating: !CP(n.validatingFields)
		}));
	}, y = (e, s = [], c, l, p = !0, m = !0) => {
		if (l && c && !t.disabled) {
			if (o.action = !0, m && Array.isArray($(r, e))) {
				let t = c($(r, e), l.argA, l.argB);
				p && oP(r, e, t);
			}
			if (m && Array.isArray($(n.errors, e))) {
				let t = c($(n.errors, e), l.argA, l.argB);
				p && oP(n.errors, e, t), iF(n.errors, e);
			}
			if ((u.touchedFields || d.touchedFields) && m && Array.isArray($(n.touchedFields, e))) {
				let t = c($(n.touchedFields, e), l.argA, l.argB);
				p && oP(n.touchedFields, e, t);
			}
			(u.dirtyFields || d.dirtyFields) && (n.dirtyFields = LP(i, a)), f.state.next({
				name: e,
				isDirty: k(e, s),
				dirtyFields: n.dirtyFields,
				errors: n.errors,
				isValid: n.isValid
			});
		} else oP(a, e, s);
	}, b = (e, t) => {
		oP(n.errors, e, t), f.state.next({ errors: n.errors });
	}, x = (e) => {
		n.errors = e, f.state.next({
			errors: n.errors,
			isValid: !1
		});
	}, S = (e, t, n, s) => {
		let c = $(r, e);
		if (c) {
			let r = $(a, e, nP(n) ? $(i, e) : n);
			nP(r) || s && s.defaultChecked || t ? oP(a, e, t ? r : WP(c._f)) : M(e, r), o.mount && _();
		}
	}, C = (e, r, a, o, s) => {
		let c = !1, l = !1, p = { name: e };
		if (!t.disabled) {
			if (!a || o) {
				(u.isDirty || d.isDirty) && (l = n.isDirty, n.isDirty = p.isDirty = k(), c = l !== p.isDirty);
				let t = SP($(i, e), r);
				l = !!$(n.dirtyFields, e), t ? NP(n.dirtyFields, e) : oP(n.dirtyFields, e, !0), p.dirtyFields = n.dirtyFields, c ||= (u.dirtyFields || d.dirtyFields) && l !== !t;
			}
			if (a) {
				let t = $(n.touchedFields, e);
				t || (oP(n.touchedFields, e, a), p.touchedFields = n.touchedFields, c ||= (u.touchedFields || d.touchedFields) && t !== a);
			}
			c && s && f.state.next(p);
		}
		return c ? p : {};
	}, w = (e, r, i, a) => {
		let o = $(n.errors, e), s = (u.isValid || d.isValid) && rP(r) && n.isValid !== r;
		if (t.delayError && i ? (c = g(() => b(e, i)), c(t.delayError)) : (clearTimeout(l), c = null, i ? oP(n.errors, e, i) : NP(n.errors, e)), (i ? !SP(o, i) : o) || !CP(a) || s) {
			let t = {
				...a,
				...s && rP(r) ? { isValid: r } : {},
				errors: n.errors,
				name: e
			};
			n = {
				...n,
				...t
			}, f.state.next(t);
		}
	}, T = async (e) => {
		v(e, !0);
		let n = await t.resolver(a, t.context, GP(e || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
		return v(e), n;
	}, E = async (e) => {
		let { errors: t } = await T(e);
		if (e) for (let r of e) {
			let e = $(t, r);
			e ? oP(n.errors, r, e) : NP(n.errors, r);
		}
		else n.errors = t;
		return t;
	}, D = async (e, r, i = { valid: !0 }) => {
		for (let o in e) {
			let c = e[o];
			if (c) {
				let { _f: e, ...l } = c;
				if (e) {
					let l = s.array.has(e.name), d = c._f && XP(c._f);
					d && u.validatingFields && v([o], !0);
					let f = await lF(c, s.disabled, a, h, t.shouldUseNativeValidation && !r, l);
					if (d && u.validatingFields && v([o]), f[e.name] && (i.valid = !1, r)) break;
					!r && ($(f, e.name) ? l ? aF(n.errors, f, e.name) : oP(n.errors, e.name, f[e.name]) : NP(n.errors, e.name));
				}
				!CP(l) && await D(l, r, i);
			}
		}
		return i.valid;
	}, O = () => {
		for (let e of s.unMount) {
			let t = $(r, e);
			t && (t._f.refs ? t._f.refs.every((e) => !AP(e)) : !AP(t._f.ref)) && z(e);
		}
		s.unMount = /* @__PURE__ */ new Set();
	}, k = (e, n) => !t.disabled && (e && n && oP(a, e, n), !SP(te(), i)), A = (e, t, n) => hP(e, s, { ...o.mount ? a : nP(t) ? i : mP(e) ? { [e]: t } : t }, n, t), j = (e) => tP($(o.mount ? a : i, e, t.shouldUnregister ? $(i, e, []) : [])), M = (e, t, n = {}) => {
		let i = $(r, e), o = t;
		if (i) {
			let n = i._f;
			n && (!n.disabled && oP(a, e, VP(t, n)), o = EP(n.ref) && KN(t) ? "" : t, DP(n.ref) ? [...n.ref.options].forEach((e) => e.selected = o.includes(e.value)) : n.refs ? WN(n.ref) ? n.refs.length > 1 ? n.refs.forEach((e) => (!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(o) ? !!o.find((t) => t === e.value) : o === e.value)) : n.refs[0] && (n.refs[0].checked = !!o) : n.refs.forEach((e) => e.checked = e.value === o) : wP(n.ref) ? n.ref.value = "" : (n.ref.value = o, n.ref.type || f.state.next({
				name: e,
				values: eP(a)
			})));
		}
		(n.shouldDirty || n.shouldTouch) && C(e, o, n.shouldTouch, n.shouldDirty, !0), n.shouldValidate && I(e);
	}, N = (e, t, n) => {
		for (let i in t) {
			let a = t[i], o = `${e}.${i}`, c = $(r, o);
			(s.array.has(e) || JN(a) || c && !c._f) && !GN(a) ? N(o, a, n) : M(o, a, n);
		}
	}, P = (e, t, c = {}) => {
		let l = $(r, e), p = s.array.has(e), m = eP(t);
		oP(a, e, m), p ? (f.array.next({
			name: e,
			values: eP(a)
		}), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && c.shouldDirty && f.state.next({
			name: e,
			dirtyFields: LP(i, a),
			isDirty: k(e, m)
		})) : l && !l._f && !KN(m) ? N(e, m, c) : M(e, m, c), QP(e, s) && f.state.next({ ...n }), f.state.next({
			name: o.mount ? e : void 0,
			values: eP(a)
		});
	}, ee = async (e) => {
		o.mount = !0;
		let i = e.target, l = i.name, g = !0, y = $(r, l), b = (e) => {
			g = Number.isNaN(e) || GN(e) && isNaN(e.getTime()) || SP(e, $(a, l, e));
		};
		if (y) {
			let o, x, S = i.type ? WP(y._f) : YN(e), E = e.type === sP.BLUR || e.type === sP.FOCUS_OUT, O = !ZP(y._f) && !t.resolver && !$(n.errors, l) && !y._f.deps || rF(E, $(n.touchedFields, l), n.isSubmitted, m, p), k = QP(l, s, E);
			oP(a, l, S), E ? (y._f.onBlur && y._f.onBlur(e), c && c(0)) : y._f.onChange && y._f.onChange(e);
			let A = C(l, S, E), j = !CP(A) || k;
			if (!E && f.state.next({
				name: l,
				type: e.type,
				values: eP(a)
			}), O) return (u.isValid || d.isValid) && (t.mode === "onBlur" ? E && _() : E || _()), j && f.state.next({
				name: l,
				...k ? {} : A
			});
			if (!E && k && f.state.next({ ...n }), t.resolver) {
				let { errors: e } = await T([l]);
				if (b(S), g) {
					let t = eF(n.errors, r, l), i = eF(e, r, t.name || l);
					o = i.error, l = i.name, x = CP(e);
				}
			} else v([l], !0), o = (await lF(y, s.disabled, a, h, t.shouldUseNativeValidation))[l], v([l]), b(S), g && (o ? x = !1 : (u.isValid || d.isValid) && (x = await D(r, !0)));
			g && (y._f.deps && I(y._f.deps), w(l, x, o, A));
		}
	}, F = (e, t) => {
		if ($(n.errors, t) && e.focus) return e.focus(), 1;
	}, I = async (e, i = {}) => {
		let a, o, c = yP(e);
		if (t.resolver) {
			let t = await E(nP(e) ? e : c);
			a = CP(t), o = e ? !c.some((e) => $(t, e)) : a;
		} else e ? (o = (await Promise.all(c.map(async (e) => {
			let t = $(r, e);
			return await D(t && t._f ? { [e]: t } : t);
		}))).every(Boolean), !(!o && !n.isValid) && _()) : o = a = await D(r);
		return f.state.next({
			...!mP(e) || (u.isValid || d.isValid) && a !== n.isValid ? {} : { name: e },
			...t.resolver || !e ? { isValid: a } : {},
			errors: n.errors
		}), i.shouldFocus && !o && $P(r, F, e ? c : s.mount), o;
	}, te = (e) => {
		let t = { ...o.mount ? a : i };
		return nP(e) ? t : mP(e) ? $(t, e) : e.map((e) => $(t, e));
	}, L = (e, t) => ({
		invalid: !!$((t || n).errors, e),
		isDirty: !!$((t || n).dirtyFields, e),
		error: $((t || n).errors, e),
		isValidating: !!$(n.validatingFields, e),
		isTouched: !!$((t || n).touchedFields, e)
	}), ne = (e) => {
		e && yP(e).forEach((e) => NP(n.errors, e)), f.state.next({ errors: e ? n.errors : {} });
	}, re = (e, t, i) => {
		let a = ($(r, e, { _f: {} })._f || {}).ref, { ref: o, message: s, type: c, ...l } = $(n.errors, e) || {};
		oP(n.errors, e, {
			...l,
			...t,
			ref: a
		}), f.state.next({
			name: e,
			errors: n.errors,
			isValid: !1
		}), i && i.shouldFocus && a && a.focus && a.focus();
	}, ie = (e, t) => TP(e) ? f.state.subscribe({ next: (n) => e(A(void 0, t), n) }) : A(e, t, !0), R = (e) => f.state.subscribe({ next: (t) => {
		nF(e.name, t.name, e.exact) && tF(t, e.formState || u, he, e.reRenderRoot) && e.callback({
			values: { ...a },
			...n,
			...t
		});
	} }).unsubscribe, ae = (e) => (o.mount = !0, d = {
		...d,
		...e.formState
	}, R({
		...e,
		formState: d
	})), z = (e, o = {}) => {
		for (let c of e ? yP(e) : s.mount) s.mount.delete(c), s.array.delete(c), o.keepValue || (NP(r, c), NP(a, c)), !o.keepError && NP(n.errors, c), !o.keepDirty && NP(n.dirtyFields, c), !o.keepTouched && NP(n.touchedFields, c), !o.keepIsValidating && NP(n.validatingFields, c), !t.shouldUnregister && !o.keepDefaultValue && NP(i, c);
		f.state.next({ values: eP(a) }), f.state.next({
			...n,
			...o.keepDirty ? { isDirty: k() } : {}
		}), !o.keepIsValid && _();
	}, oe = ({ disabled: e, name: t }) => {
		(rP(e) && o.mount || e || s.disabled.has(t)) && (e ? s.disabled.add(t) : s.disabled.delete(t));
	}, se = (e, n = {}) => {
		let a = $(r, e), c = rP(n.disabled) || rP(t.disabled);
		return oP(r, e, {
			...a || {},
			_f: {
				...a && a._f ? a._f : { ref: { name: e } },
				name: e,
				mount: !0,
				...n
			}
		}), s.mount.add(e), a ? oe({
			disabled: rP(n.disabled) ? n.disabled : t.disabled,
			name: e
		}) : S(e, !0, n.value), {
			...c ? { disabled: n.disabled || t.disabled } : {},
			...t.progressive ? {
				required: !!n.required,
				min: qP(n.min),
				max: qP(n.max),
				minLength: qP(n.minLength),
				maxLength: qP(n.maxLength),
				pattern: qP(n.pattern)
			} : {},
			name: e,
			onChange: ee,
			onBlur: ee,
			ref: (c) => {
				if (c) {
					se(e, n), a = $(r, e);
					let t = nP(c.value) && c.querySelectorAll && c.querySelectorAll("input,select,textarea")[0] || c, o = kP(t), s = a._f.refs || [];
					if (o ? s.find((e) => e === t) : t === a._f.ref) return;
					oP(r, e, { _f: {
						...a._f,
						...o ? {
							refs: [
								...s.filter(AP),
								t,
								...Array.isArray($(i, e)) ? [{}] : []
							],
							ref: {
								type: t.type,
								name: e
							}
						} : { ref: t }
					} }), S(e, !1, void 0, t);
				} else a = $(r, e, {}), a._f && (a._f.mount = !1), (t.shouldUnregister || n.shouldUnregister) && !(ZN(s.array, e) && o.action) && s.unMount.add(e);
			}
		};
	}, ce = () => t.shouldFocusError && $P(r, F, s.mount), le = (e) => {
		rP(e) && (f.state.next({ disabled: e }), $P(r, (t, n) => {
			let i = $(r, n);
			i && (t.disabled = i._f.disabled || e, Array.isArray(i._f.refs) && i._f.refs.forEach((t) => {
				t.disabled = i._f.disabled || e;
			}));
		}, 0, !1));
	}, ue = (e, i) => async (o) => {
		let c;
		o && (o.preventDefault && o.preventDefault(), o.persist && o.persist());
		let l = eP(a);
		if (f.state.next({ isSubmitting: !0 }), t.resolver) {
			let { errors: e, values: t } = await T();
			n.errors = e, l = t;
		} else await D(r);
		if (s.disabled.size) for (let e of s.disabled) oP(l, e, void 0);
		if (NP(n.errors, "root"), CP(n.errors)) {
			f.state.next({ errors: {} });
			try {
				await e(l, o);
			} catch (e) {
				c = e;
			}
		} else i && await i({ ...n.errors }, o), ce(), setTimeout(ce);
		if (f.state.next({
			isSubmitted: !0,
			isSubmitting: !1,
			isSubmitSuccessful: CP(n.errors) && !c,
			submitCount: n.submitCount + 1,
			errors: n.errors
		}), c) throw c;
	}, de = (e, t = {}) => {
		$(r, e) && (nP(t.defaultValue) ? P(e, eP($(i, e))) : (P(e, t.defaultValue), oP(i, e, eP(t.defaultValue))), t.keepTouched || NP(n.touchedFields, e), t.keepDirty || (NP(n.dirtyFields, e), n.isDirty = t.defaultValue ? k(e, eP($(i, e))) : k()), t.keepError || (NP(n.errors, e), u.isValid && _()), f.state.next({ ...n }));
	}, fe = (e, c = {}) => {
		let l = e ? eP(e) : i, d = eP(l), p = CP(e), m = p ? i : d;
		if (c.keepDefaultValues || (i = l), !c.keepValues) {
			if (c.keepDirtyValues) {
				let e = /* @__PURE__ */ new Set([...s.mount, ...Object.keys(LP(i, a))]);
				for (let t of Array.from(e)) $(n.dirtyFields, t) ? oP(m, t, $(a, t)) : P(t, $(m, t));
			} else {
				if ($N && nP(e)) for (let e of s.mount) {
					let t = $(r, e);
					if (t && t._f) {
						let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
						if (EP(e)) {
							let t = e.closest("form");
							if (t) {
								t.reset();
								break;
							}
						}
					}
				}
				for (let e of s.mount) P(e, $(m, e));
			}
			a = eP(m), f.array.next({ values: { ...m } }), f.state.next({ values: { ...m } });
		}
		s = {
			mount: c.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
			unMount: /* @__PURE__ */ new Set(),
			array: /* @__PURE__ */ new Set(),
			disabled: /* @__PURE__ */ new Set(),
			watch: /* @__PURE__ */ new Set(),
			watchAll: !1,
			focus: ""
		}, o.mount = !u.isValid || !!c.keepIsValid || !!c.keepDirtyValues, o.watch = !!t.shouldUnregister, f.state.next({
			submitCount: c.keepSubmitCount ? n.submitCount : 0,
			isDirty: p ? !1 : c.keepDirty ? n.isDirty : !!(c.keepDefaultValues && !SP(e, i)),
			isSubmitted: c.keepIsSubmitted ? n.isSubmitted : !1,
			dirtyFields: p ? {} : c.keepDirtyValues ? c.keepDefaultValues && a ? LP(i, a) : n.dirtyFields : c.keepDefaultValues && e ? LP(i, e) : c.keepDirty ? n.dirtyFields : {},
			touchedFields: c.keepTouched ? n.touchedFields : {},
			errors: c.keepErrors ? n.errors : {},
			isSubmitSuccessful: c.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
			isSubmitting: !1
		});
	}, pe = (e, t) => fe(TP(e) ? e(a) : e, t), me = (e, t = {}) => {
		let n = $(r, e), i = n && n._f;
		if (i) {
			let e = i.refs ? i.refs[0] : i.ref;
			e.focus && (e.focus(), t.shouldSelect && TP(e.select) && e.select());
		}
	}, he = (e) => {
		n = {
			...n,
			...e
		};
	}, ge = {
		control: {
			register: se,
			unregister: z,
			getFieldState: L,
			handleSubmit: ue,
			setError: re,
			_subscribe: R,
			_runSchema: T,
			_getWatch: A,
			_getDirty: k,
			_setValid: _,
			_setFieldArray: y,
			_setDisabledField: oe,
			_setErrors: x,
			_getFieldArray: j,
			_reset: fe,
			_resetDefaultValues: () => TP(t.defaultValues) && t.defaultValues().then((e) => {
				pe(e, t.resetOptions), f.state.next({ isLoading: !1 });
			}),
			_removeUnmounted: O,
			_disableForm: le,
			_subjects: f,
			_proxyFormState: u,
			get _fields() {
				return r;
			},
			get _formValues() {
				return a;
			},
			get _state() {
				return o;
			},
			set _state(e) {
				o = e;
			},
			get _defaultValues() {
				return i;
			},
			get _names() {
				return s;
			},
			set _names(e) {
				s = e;
			},
			get _formState() {
				return n;
			},
			get _options() {
				return t;
			},
			set _options(e) {
				t = {
					...t,
					...e
				};
			}
		},
		subscribe: ae,
		trigger: I,
		register: se,
		handleSubmit: ue,
		watch: ie,
		setValue: P,
		getValues: te,
		reset: pe,
		resetField: de,
		clearErrors: ne,
		unregister: z,
		setError: re,
		setFocus: me,
		getFieldState: L
	};
	return {
		...ge,
		formControl: ge
	};
}
function fF(e = {}) {
	let t = V.useRef(void 0), n = V.useRef(void 0), [r, i] = V.useState({
		isDirty: !1,
		isValidating: !1,
		isLoading: TP(e.defaultValues),
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		submitCount: 0,
		dirtyFields: {},
		touchedFields: {},
		validatingFields: {},
		errors: e.errors || {},
		disabled: e.disabled || !1,
		defaultValues: TP(e.defaultValues) ? void 0 : e.defaultValues
	});
	t.current || (t.current = {
		...e.formControl ? e.formControl : dF(e),
		formState: r
	}, e.formControl && e.defaultValues && !TP(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
	let a = t.current.control;
	return a._options = e, V.useLayoutEffect(() => a._subscribe({
		formState: a._proxyFormState,
		callback: () => i({ ...a._formState }),
		reRenderRoot: !0
	}), [a]), V.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), V.useEffect(() => {
		if (a._proxyFormState.isDirty) {
			let e = a._getDirty();
			e !== r.isDirty && a._subjects.state.next({ isDirty: e });
		}
	}, [a, r.isDirty]), V.useEffect(() => {
		e.values && !SP(e.values, n.current) ? (a._reset(e.values, a._options.resetOptions), n.current = e.values, i((e) => ({ ...e }))) : a._resetDefaultValues();
	}, [e.values, a]), V.useEffect(() => {
		e.errors && !CP(e.errors) && a._setErrors(e.errors);
	}, [e.errors, a]), V.useEffect(() => {
		a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
	}), V.useEffect(() => {
		e.shouldUnregister && a._subjects.state.next({ values: a._getWatch() });
	}, [e.shouldUnregister, a]), t.current.formState = fP(r, a), t.current;
}
var pF = _l;
function mF(e) {
	return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var hF = UN, gF = [
	"control",
	"defaultValue",
	"name",
	"rules",
	"shouldUnregister"
];
function _F(e) {
	let t = hF(e, gF);
	return {
		controller: _P(t),
		controllerProps: t
	};
}
var vF = [
	"className",
	"description",
	"disabled",
	"helpIcon",
	"label",
	"noAlert",
	"noLabel",
	"style"
];
function yF(e) {
	let { controller: t, controllerProps: n } = _F(e);
	return {
		controller: t,
		controllerProps: n,
		fieldWrapperProps: {
			...hF(e, vF),
			required: mF(n.rules?.required),
			meta: {
				touched: t.fieldState.isTouched,
				error: t.fieldState.error?.message,
				success: e.meta?.success,
				warning: e.meta?.warning
			},
			labelFor: n.name,
			noLabel: e.noLabel,
			noAlert: e.noAlert
		}
	};
}
var bF = pF, xF = ({ transformValue: e = bF, label: t, helpIcon: n, className: r, ...i }) => {
	let { controller: { field: a }, controllerProps: { name: o } } = _F(i);
	return /* @__PURE__ */ K(v, {
		gap: "200",
		alignItems: "center",
		className: r,
		children: [/* @__PURE__ */ G(ee, {
			...a,
			id: o,
			checked: e(a.value),
			disabled: i.componentProps?.disabled,
			onChange: (t) => {
				i.componentProps?.onChange?.(t), a.onChange(e(t.target.checked));
			}
		}), t && /* @__PURE__ */ G(p, {
			htmlFor: o,
			helpIcon: n,
			children: t
		})]
	});
}, SF = (e) => {
	let { controller: t, controllerProps: n, fieldWrapperProps: r } = yF(e);
	return /* @__PURE__ */ G(_, {
		...r,
		children: /* @__PURE__ */ G(T, {
			...e.componentProps,
			...t.field,
			value: e.componentProps?.type === "number" && isNaN(t.field.value) ? "" : t.field.value ?? "",
			onBlur: (n) => {
				e.componentProps?.onBlur?.(n), t.field.onBlur();
			},
			onChange: (n) => {
				e.componentProps?.onChange?.(n), t.field.onChange(e.componentProps?.type === "number" ? n.target.valueAsNumber : n);
			},
			id: n.name,
			"aria-disabled": r.disabled,
			disabled: r.disabled,
			"aria-required": r.required,
			required: r.required,
			status: _.getStatus(r.meta)
		})
	});
}, CF = [{
	key: "apiHostName",
	label: "Store host name",
	defaultValue: "",
	secret: !1,
	type: "string"
}, {
	key: "basicAuthorization",
	label: "WooCommerce authorization",
	defaultValue: "",
	secret: !0,
	type: "string"
}], wF = Pe(CF), TF = "WOOCOMMERCE", EF = "WooCommerce", DF = {
	enabled: !1,
	name: "",
	apiHostName: "",
	basicAuthorization: ""
}, OF = ({ integrationId: e, handleRedirect: t, showNotification: n, automationCouplingState: r }) => {
	let i = !e, a = fF({
		mode: "onChange",
		defaultValues: DF
	}), { create: o, update: s, remove: c, isLoading: l, error: u, misconfigurationCause: d, setMisconfigurationCause: f } = He({
		integrationId: e,
		integrationType: TF,
		handleRedirect: t,
		showNotification: n
	}), { isLoading: p, error: m, isWidgetUnknown: h, refetch: g } = Ue({
		integrationId: e,
		fieldDefinitions: CF,
		form: a,
		onMisconfigured: f
	}), S = (e) => ye(e, {
		fieldDefinitions: CF,
		isCreationMode: i,
		create: o,
		update: s
	}), C = a.watch("name");
	return /* @__PURE__ */ K(de, {
		form: a,
		integrationId: e,
		onValidSubmit: S,
		error: m ?? u,
		onRetry: m ? g : void 0,
		isLoading: l || p,
		isWidgetUnknown: h,
		children: [
			d && /* @__PURE__ */ G(se, { cause: d }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(xF, {
						name: "enabled",
						control: a.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(SF, {
						name: "name",
						label: "Widget name",
						control: a.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(SF, {
						name: "apiHostName",
						label: wF.apiHostName,
						control: a.control,
						rules: {
							required: "Store host name is required",
							validate: (e) => We(String(e)) ?? void 0
						},
						componentProps: {
							placeholder: "Host name of your WooCommerce store, e.g. \"my-store.com\"",
							prefix: "https://",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(le, {
						name: "basicAuthorization",
						label: wF.basicAuthorization,
						control: a.control,
						isCreationMode: i,
						rules: { required: "Please insert a value for both fields" },
						usernameLabel: "Consumer key",
						passwordLabel: "Consumer secret",
						usernamePlaceholder: "Insert your consumer key",
						passwordPlaceholder: "Insert your consumer secret"
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 })
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: TF,
				integrationId: e,
				widgetName: C,
				isCreationMode: i,
				isSubmitting: a.formState.isSubmitting,
				automationCouplingState: r,
				onConfirmDelete: () => c(),
				confirmDeleteVariant: "danger",
				deleteConfirmationBody: /* @__PURE__ */ K(v, {
					gap: "400",
					children: [/* @__PURE__ */ G(x, {
						size: 24,
						name: "exclamation-triangle-filled",
						color: "red.500"
					}), /* @__PURE__ */ K(v, {
						gap: "200",
						flexDirection: "column",
						children: [
							/* @__PURE__ */ K(L.Heading, {
								withMarginBottom: !0,
								children: [
									"By deleting the ",
									EF,
									" integration, all links between Dixa and ",
									EF,
									" are also deleted."
								]
							}),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"All data in ",
								EF,
								" stays untouched."
							] }),
							/* @__PURE__ */ K(L.Paragraph, { children: [
								"Are you sure you want to delete the ",
								EF,
								" ",
								"integration \"",
								C,
								"\"?"
							] })
						]
					})]
				})
			})
		]
	});
};
//#endregion
//#region ../widget-yotpo/dist/index.js
(function() {
	try {
		if (typeof document < "u") {
			var e = document.createElement("style");
			e.appendChild(document.createTextNode("._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{background:linear-gradient(var(--dixa-color-neutral-000) 33%, #fff0), linear-gradient(#fff0, var(--dixa-color-neutral-000) 66%) 0 100%, radial-gradient(farthest-side at 50% 0, var(--dixa-color-neutral-200), #0000), radial-gradient(farthest-side at 50% 100%, var(--dixa-color-neutral-200), #0000) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-400), 100% var(--dixa-size-spacer-200), 100% var(--dixa-size-spacer-200);max-height:230px;padding:0;overflow-y:auto}._listItem_1pfts_69{cursor:pointer;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200);background-color:#0000}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);overflow:auto}/*$vite$:1*/")), document.head.appendChild(e);
		}
	} catch (e) {
		console.error("vite-plugin-css-injected-by-js", e);
	}
})();
var kF = { "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": {
	kind: "Document",
	definitions: [{
		kind: "OperationDefinition",
		operation: "query",
		name: {
			kind: "Name",
			value: "getCustomerDetails"
		},
		variableDefinitions: [
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "email"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "phone"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "limit"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "Int"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "externalIds"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "storeId"
					}
				},
				type: {
					kind: "NonNullType",
					type: {
						kind: "NamedType",
						name: {
							kind: "Name",
							value: "String"
						}
					}
				}
			},
			{
				kind: "VariableDefinition",
				variable: {
					kind: "Variable",
					name: {
						kind: "Name",
						value: "expand"
					}
				},
				type: {
					kind: "NamedType",
					name: {
						kind: "Name",
						value: "String"
					}
				}
			}
		],
		selectionSet: {
			kind: "SelectionSet",
			selections: [{
				kind: "Field",
				name: {
					kind: "Name",
					value: "Yotpo"
				},
				selectionSet: {
					kind: "SelectionSet",
					selections: [{
						kind: "Field",
						name: {
							kind: "Name",
							value: "getCustomers"
						},
						arguments: [
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "email"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "email"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "phone_number"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "phone"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "limit"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "limit"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "external_ids"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "externalIds"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "store_id"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "storeId"
									}
								}
							},
							{
								kind: "Argument",
								name: {
									kind: "Name",
									value: "expand"
								},
								value: {
									kind: "Variable",
									name: {
										kind: "Name",
										value: "expand"
									}
								}
							}
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{
								kind: "InlineFragment",
								typeCondition: {
									kind: "NamedType",
									name: {
										kind: "Name",
										value: "Yotpo_getCustomers_response"
									}
								},
								selectionSet: {
									kind: "SelectionSet",
									selections: [{
										kind: "InlineFragment",
										typeCondition: {
											kind: "NamedType",
											name: {
												kind: "Name",
												value: "Yotpo_Customers"
											}
										},
										selectionSet: {
											kind: "SelectionSet",
											selections: [{
												kind: "Field",
												name: {
													kind: "Name",
													value: "customers"
												},
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "external_id"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "email"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "phone_number"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "first_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "last_name"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "gender"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "account_created_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "account_updated_at"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "default_language"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "dafault_currency"
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "lists"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [{
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "id"
																	}
																}, {
																	kind: "Field",
																	name: {
																		kind: "Name",
																		value: "since"
																	}
																}]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "yotpo_ugc"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_reviews"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avg_product_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "avg_site_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_avg_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "sentiment_avg_product"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "sentiment_avg_site"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_avg_sentiment"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "top_topics"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_star_rating"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_review_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_sentiment"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "yotpo_loyalty"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "points_earned"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "points_balance"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "last_seen_at"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_redemptions"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "total_points_redeemed"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "vip_tier_name"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "successful_referrals"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "referrals_made_and_clicked"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "is_referred_by_other_customer"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "points_expire_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "credit_balance_amount"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "credit_balance_customer_currency"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "is_opt_in"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "opt_in_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "opt_out_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "has_store_account"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "referred_by_customer"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "vip_entry_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "vip_expiration_date"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "next_points_expire_on"
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "next_points_expire_amount"
																		}
																	}
																]
															}
														},
														{
															kind: "Field",
															name: {
																kind: "Name",
																value: "yotpo_subscriptions"
															},
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "active_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "paused_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "failed_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "expired_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	},
																	{
																		kind: "Field",
																		name: {
																			kind: "Name",
																			value: "canceled_subscriptions"
																		},
																		selectionSet: {
																			kind: "SelectionSet",
																			selections: [{
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalProductId"
																				}
																			}, {
																				kind: "Field",
																				name: {
																					kind: "Name",
																					value: "externalVariantId"
																				}
																			}]
																		}
																	}
																]
															}
														}
													]
												}
											}]
										}
									}]
								}
							}]
						}
					}]
				}
			}]
		}
	}]
} };
function AF(e) {
	return kF[e] ?? {};
}
var jF = AF("\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"), MF = Ws, NF = {
	copyIcon: "_copyIcon_1pfts_54",
	list: "_list_1pfts_59",
	listItem: "_listItem_1pfts_69",
	listItemHighlighted: "_listItemHighlighted_1pfts_78"
}, PF = {
	wrapper: "_wrapper_1xucg_1",
	externalLink: "_externalLink_1xucg_7"
}, FF = ({ customerDetails: e }) => {
	let { isCopied: t, copy: n } = Re(), { isCopied: r, copy: i } = Re();
	if (!e) return null;
	let { first_name: a, last_name: o, email: s, phone_number: c, yotpo_loyalty: l } = e, u = l?.is_opt_in, d = l?.opt_in_date, f = `${a || ""} ${o || ""}`.trim() || "A customer has no name";
	return /* @__PURE__ */ G(v, {
		gap: "300",
		flexDirection: "column",
		children: /* @__PURE__ */ K(v, {
			className: PF.wrapper,
			gap: "200",
			flexDirection: "column",
			children: [
				/* @__PURE__ */ G(v, {
					justifyContent: "space-between",
					className: PF.block,
					alignItems: "center",
					children: /* @__PURE__ */ G(L.Heading, {
						variant: "heading-2",
						children: f
					})
				}),
				s && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "mail"
						}), /* @__PURE__ */ G("span", {
							className: PF.externalLink,
							children: s
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy email",
						children: /* @__PURE__ */ G(v, {
							alignItems: "center",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: t ? "done" : "copy",
								onClick: () => n(s),
								className: NF.copyIcon
							})
						})
					})]
				}),
				c && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					children: [/* @__PURE__ */ K(v, {
						gap: "200",
						alignItems: "center",
						children: [/* @__PURE__ */ G(x, {
							size: 14,
							name: "phone"
						}), /* @__PURE__ */ G(L.Paragraph, {
							variant: "4",
							children: c
						})]
					}), /* @__PURE__ */ G(R, {
						content: "Copy phone number",
						children: /* @__PURE__ */ G(v, {
							alignItems: "center",
							children: /* @__PURE__ */ G(x, {
								size: 14,
								name: r ? "done" : "copy",
								onClick: () => i(c),
								className: NF.copyIcon
							})
						})
					})]
				}),
				u != null && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					alignItems: "center",
					"data-testid": "customer-details-loyalty-status",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Loyalty status"
					}), ge(u)]
				}),
				d && /* @__PURE__ */ K(v, {
					gap: "200",
					justifyContent: "space-between",
					"data-testid": "customer-details-member-since",
					children: [/* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: "Member since"
					}), /* @__PURE__ */ G(L.Paragraph, {
						variant: "4",
						children: MF(d).format(he)
					})]
				})
			]
		})
	});
}, IF = ({ description: e, content: t, tooltip: n, isHighlighted: r = !1, as: i }) => {
	if (t == null) return null;
	let a = Je(t);
	return /* @__PURE__ */ G(E.Text, {
		variant: "dense",
		className: ht(NF.listItem, { [NF.listItemHighlighted]: r }),
		children: /* @__PURE__ */ G(R, {
			content: n,
			children: /* @__PURE__ */ K(v, {
				justifyContent: "space-between",
				alignItems: "center",
				children: [/* @__PURE__ */ G(L.Paragraph, {
					variant: "4",
					children: e
				}), a ? t : ge(t, i)]
			})
		})
	});
}, LF = ({ loyalty: e }) => /* @__PURE__ */ K(v, {
	gap: "200",
	flexDirection: "column",
	children: [
		/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "Loyalty"
		}),
		!e && /* @__PURE__ */ G(v, {
			justifyContent: "center",
			children: /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				children: "No loyalty data available"
			})
		}),
		e && /* @__PURE__ */ K(E, {
			className: NF.list,
			children: [
				/* @__PURE__ */ G(IF, {
					description: "Opt in",
					tooltip: "Indicates whether the customer has opted into the loyalty program.",
					content: e.is_opt_in
				}),
				/* @__PURE__ */ G(IF, {
					description: "Opt-in date",
					tooltip: "The timestamp for when the customer opted into the loyalty program.",
					content: e.opt_in_date
				}),
				/* @__PURE__ */ G(IF, {
					description: "Opt-out date",
					tooltip: "The timestamp for when the customer opted out of the loyalty program.",
					content: e.opt_out_date
				}),
				/* @__PURE__ */ G(IF, {
					description: "Last seen",
					tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
					content: e.last_seen_at
				}),
				/* @__PURE__ */ G(IF, {
					description: "Points earned",
					tooltip: "The total number of loyalty points earned by the customer.",
					content: e.points_earned
				}),
				/* @__PURE__ */ G(IF, {
					description: "Points balance",
					tooltip: "The current balance of loyalty points for the customer.",
					content: e.points_balance
				}),
				/* @__PURE__ */ G(IF, {
					description: "Points expiry date",
					tooltip: "The timestamp when the customer's loyalty points are set to expire.",
					content: e.next_points_expire_on || e.points_expire_date
				}),
				/* @__PURE__ */ G(IF, {
					description: "Points expiry amount",
					tooltip: "The number of points that are about to expire",
					content: e.next_points_expire_amount
				}),
				/* @__PURE__ */ G(IF, {
					description: "VIP tier",
					tooltip: "The name of the customer's current VIP tier status.",
					content: e.vip_tier_name
				}),
				/* @__PURE__ */ G(IF, {
					description: "VIP entry date",
					tooltip: "The timestamp for when the customer entered the VIP tier.",
					content: e.vip_entry_date
				}),
				/* @__PURE__ */ G(IF, {
					description: "VIP expiration date",
					tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
					content: e.vip_expiration_date
				}),
				/* @__PURE__ */ G(IF, {
					description: "Total redemptions",
					tooltip: "The total number of times the customer has redeemed loyalty points.",
					content: e.total_redemptions
				}),
				/* @__PURE__ */ G(IF, {
					description: "Total points redeemed",
					tooltip: "The total number of loyalty points redeemed by the customer.",
					content: e.total_points_redeemed
				}),
				/* @__PURE__ */ G(IF, {
					isHighlighted: !0,
					description: "Successful referrals",
					tooltip: "The total number of successful referrals made by the customer.",
					content: e.successful_referrals
				}),
				/* @__PURE__ */ G(IF, {
					isHighlighted: !0,
					description: "Referrals made and clicked",
					tooltip: "The total number of referrals made by the customer and clicked on by others.",
					content: e.referrals_made_and_clicked
				}),
				/* @__PURE__ */ G(IF, {
					description: "Referred by other customer",
					tooltip: "Indicates whether the customer was referred by another customer.",
					content: e.is_referred_by_other_customer
				}),
				/* @__PURE__ */ G(IF, {
					description: "Referred by customer",
					tooltip: "The email address of the customer who referred this customer to the loyalty program.",
					content: e.referred_by_customer
				}),
				/* @__PURE__ */ G(IF, {
					description: "Credit balance amount",
					tooltip: "The amount of store credit available to the customer in the default currency of the store.",
					content: e.credit_balance_amount
				}),
				/* @__PURE__ */ G(IF, {
					description: "Credit balance customer currency",
					tooltip: "The store credit amount in the customer's preferred currency.",
					content: e.credit_balance_customer_currency,
					as: "string"
				}),
				/* @__PURE__ */ G(IF, {
					description: "Has store account",
					tooltip: "Indicates whether the customer has a store account.",
					content: e.has_store_account
				})
			]
		})
	]
}), RF = .8, zF = .4, BF = (e) => {
	if (e != null) return e >= RF ? /* @__PURE__ */ G(n, {
		variant: "success",
		size: "small",
		children: "Positive"
	}) : e <= zF ? /* @__PURE__ */ G(n, {
		variant: "error",
		size: "small",
		children: "Negative"
	}) : /* @__PURE__ */ G(n, {
		variant: "warning",
		size: "small",
		children: "Neutral"
	});
}, VF = ({ userGeneratedContent: e }) => /* @__PURE__ */ K(v, {
	gap: "200",
	flexDirection: "column",
	children: [
		/* @__PURE__ */ G(L.Heading, {
			variant: "heading-3",
			children: "User generated content"
		}),
		!e && /* @__PURE__ */ G(v, {
			justifyContent: "center",
			children: /* @__PURE__ */ G(L.Paragraph, {
				variant: "4",
				color: "secondary",
				children: "No user generated content available"
			})
		}),
		e && /* @__PURE__ */ K(E, {
			className: NF.list,
			children: [
				/* @__PURE__ */ G(IF, {
					isHighlighted: !0,
					description: "Total reviews",
					tooltip: "The total number of reviews submitted by the customer.",
					content: e.total_reviews
				}),
				/* @__PURE__ */ G(IF, {
					isHighlighted: !0,
					description: "Total average rating",
					tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
					content: e.total_avg_rating?.toFixed(2)
				}),
				/* @__PURE__ */ G(IF, {
					isHighlighted: !0,
					description: "Total average sentiment score",
					tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
					content: BF(e.total_avg_sentiment)
				}),
				/* @__PURE__ */ G(IF, {
					description: "Average product rating",
					tooltip: "The average product rating given by the customer.",
					content: e.avg_product_rating?.toFixed(2)
				}),
				/* @__PURE__ */ G(IF, {
					description: "Average site rating",
					tooltip: "The average rating of the site/store given by the customer.",
					content: e.avg_site_rating?.toFixed(2)
				}),
				/* @__PURE__ */ G(IF, {
					description: "Last sentiment",
					tooltip: "The sentiment score of the customer's last review.",
					content: BF(e.last_sentiment)
				}),
				/* @__PURE__ */ G(IF, {
					description: "Last star rating",
					tooltip: "The star rating of the customer's last review.",
					content: e.last_star_rating
				}),
				/* @__PURE__ */ G(IF, {
					description: "Last review date",
					tooltip: "The timestamp for when the customer last submitted a review.",
					content: MF(e.last_review_date).format(he)
				}),
				/* @__PURE__ */ G(IF, {
					description: "Topics",
					tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
					content: /* @__PURE__ */ G(v, {
						gap: "100",
						width: "80%",
						flexWrap: "wrap",
						justifyContent: "flex-end",
						children: e.top_topics?.map((e, t) => /* @__PURE__ */ G(n, {
							variant: "info",
							size: "small",
							children: /* @__PURE__ */ G(W, { children: e })
						}, t))
					})
				})
			]
		})
	]
}), HF = ({ conversationContext: e, settings: t }) => {
	let { useQuery: n } = B(), { track: r } = Ve(), [i, a] = U(), [o, s] = U(!1), c = e?.customer?.email, l = e?.customer?.phone_number, u = !c && !l, d = t?.yotpoStoreId, f = t?.showCustomerDetails ?? !1, p = t?.showUserGeneratedContent ?? !1, m = t?.displayLoyalty ?? !1, h = t?.displaySubscriptions ?? !1, g = !d, _ = !f && !p && !m && !h, { loading: y, error: b, data: x } = n(jF, {
		skip: u || g,
		variables: {
			...c && { email: c },
			...!c && l && { phone: l },
			storeId: d,
			expand: "all"
		}
	});
	if (H(() => {
		let e = (x?.Yotpo?.getCustomers)?.customers?.[0];
		e ? (a(e), s(!1), r("yotpo:customer:received")) : s(!b);
	}, [
		x?.Yotpo,
		y,
		b
	]), g) return /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(z, {
			error: new rt({ graphQLErrors: [{ message: "Integration needs to be re-/authorized in the settings." }] }),
			hideCopyButton: !0
		})
	});
	if (u) return /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "widget-no-contact-message",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No email nor phone number are available in this conversation to look up a profile."
		})
	});
	if (_) return /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		"data-testid": "widget-no-features",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "All features toggles in the widget settings are disabled."
		})
	});
	if (y) return /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "300",
		children: /* @__PURE__ */ G(P, {})
	});
	if (b) {
		let e = b.graphQLErrors;
		return xe({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-forbidden-error",
			children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
		}) : be({ errors: e }) ? /* @__PURE__ */ G(L.Paragraph, {
			margin: "200 0 300 0",
			color: "secondary",
			variant: "4",
			"data-testid": "widget-downstream-api-authorization-error",
			children: "The integration could not authorize against Yotpo. Please contact your administrator."
		}) : /* @__PURE__ */ G(z, { error: b });
	}
	return o ? /* @__PURE__ */ G(v, {
		justifyContent: "center",
		margin: "200 0 300 0",
		children: /* @__PURE__ */ G(L.Paragraph, {
			variant: "4",
			color: "secondary",
			children: "No customer profile found."
		})
	}) : /* @__PURE__ */ K(v, {
		gap: "300",
		flexDirection: "column",
		margin: "200 0 300 0",
		"data-testid": "widget-wrapper",
		children: [
			f && /* @__PURE__ */ G(FF, { customerDetails: i }),
			p && /* @__PURE__ */ G(VF, { userGeneratedContent: i?.yotpo_ugc }),
			m && /* @__PURE__ */ G(LF, { loyalty: i?.yotpo_loyalty })
		]
	});
}, UF = {
	settingsWrapper: "_settingsWrapper_1ycvy_1",
	settingsWrapperHeader: "_settingsWrapperHeader_1ycvy_6",
	settingsWrapperContent: "_settingsWrapperContent_1ycvy_10",
	settingsWrapperContentCode: "_settingsWrapperContentCode_1ycvy_18",
	settingsWrapperContentCURL: "_settingsWrapperContentCURL_1ycvy_26"
}, WF = ({ handleChangeText: e }) => {
	let [t, n] = U(!1), { isCopied: i, copy: o } = Re(), { control: s } = gl({
		defaultValues: {
			storeId: "",
			secret: ""
		},
		mode: "onChange"
	}), c = yc({ control: s }), l = c.storeId !== "" && c.secret !== "", u = Ye(() => {
		let e = c.storeId, t = c.secret;
		return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${e || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${t ? ` \\
  --data '{"secret":"${t}"}'` : ""}`;
	}, [c.storeId, c.secret]);
	return /* @__PURE__ */ G(W, { children: /* @__PURE__ */ G(y, {
		span: 6,
		children: /* @__PURE__ */ K(v, {
			flexDirection: "column",
			className: UF.settingsWrapper,
			children: [/* @__PURE__ */ K(v, {
				gap: "200",
				alignItems: "center",
				className: UF.settingsWrapperHeader,
				onClick: () => n(!t),
				children: [/* @__PURE__ */ G(L.Heading, {
					variant: "heading-3",
					children: "How to get the Yotpo access token"
				}), /* @__PURE__ */ G(x, { name: t ? "angle-down" : "angle-right" })]
			}), t && /* @__PURE__ */ K(v, {
				flexDirection: "column",
				className: UF.settingsWrapperContent,
				children: [
					/* @__PURE__ */ G(v, {
						margin: "0 0 400",
						children: /* @__PURE__ */ G(r, {
							variant: "announcement",
							headline: "In order to get the Yotpo access token, you have to follow the steps below",
							description: /* @__PURE__ */ K("ol", { children: [
								/* @__PURE__ */ G("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
								/* @__PURE__ */ G("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
								/* @__PURE__ */ K("li", { children: [
									"The response should look like this",
									" ",
									/* @__PURE__ */ G("span", {
										className: UF.settingsWrapperContentCode,
										children: "{ \"access_token\": \"this-is-your-token\" }"
									})
								] }),
								/* @__PURE__ */ K("li", { children: [
									"Copy the token without quotes and paste it in the",
									" ",
									/* @__PURE__ */ G("i", { children: "Yotpo access token" }),
									" input field below"
								] }),
								/* @__PURE__ */ G("li", { children: "Click the save button" })
							] })
						})
					}),
					/* @__PURE__ */ G(xc, {
						name: "storeId",
						control: s,
						render: ({ field: t }) => /* @__PURE__ */ G(h, {
							label: "Yotpo store ID",
							placeholder: "Please insert the store ID",
							input: {
								...t,
								onChange: (n) => {
									t.onChange(n), e({ target: {
										name: "yotpoStoreId",
										value: n?.target.value ?? ""
									} });
								}
							}
						})
					}),
					/* @__PURE__ */ G(xc, {
						name: "secret",
						control: s,
						render: ({ field: e }) => /* @__PURE__ */ G(h, {
							label: "Yotpo secret",
							placeholder: "Please insert the secret",
							input: e
						})
					}),
					l && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(_, {
						label: "Generated CURL command",
						noAlert: !0,
						children: /* @__PURE__ */ G(v, {
							as: "pre",
							gap: "200",
							margin: "100 0 250",
							className: UF.settingsWrapperContentCURL,
							children: u()
						})
					}), /* @__PURE__ */ G(v, {
						alignContent: "start",
						children: /* @__PURE__ */ G(R, {
							content: i ? "Copied!" : "Copy CURL command",
							children: /* @__PURE__ */ G(a, {
								variant: "secondary",
								icon: i ? "check-circle" : "copy",
								onClick: () => o(u()),
								children: "Copy CURL"
							})
						})
					})] })
				]
			})]
		})
	}) });
}, GF = [
	{
		key: "yotpoStoreId",
		label: "Yotpo store ID",
		type: "string",
		secret: !1,
		defaultValue: ""
	},
	{
		key: "yotpoAccessToken",
		label: "Yotpo access token",
		type: "string",
		secret: !0,
		defaultValue: ""
	},
	{
		key: "showCustomerDetails",
		label: "Show customer details",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "showUserGeneratedContent",
		label: "Show user generated content",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	},
	{
		key: "displayLoyalty",
		label: "Show loyalty data",
		type: "boolean",
		secret: !1,
		defaultValue: !0
	}
], KF = [{
	key: "yotpoStoreId",
	label: "Yotpo store ID",
	placeholder: "",
	readOnly: !0,
	required: !1,
	secret: !1,
	type: "hidden",
	hideOnCreate: !0
}, {
	key: "authorizeWithOauth",
	label: "Authorize with OAuth",
	secret: !1,
	type: "custom",
	hideOnCreate: !0,
	component: ce
}], qF = [
	{
		key: "accessTokenComponent",
		label: "Retrieve Yotpo access token",
		secret: !1,
		type: "custom",
		component: WF
	},
	{
		key: "yotpoStoreId",
		label: "Yotpo store ID",
		placeholder: "See \"How to get the Yotpo access token\" above.",
		readOnly: !0,
		required: !0,
		secret: !1,
		type: "input"
	},
	{
		key: "yotpoAccessToken",
		label: "Yotpo access token",
		placeholder: "Insert the Yotpo access token",
		required: !0,
		secret: !0,
		type: "input"
	}
], JF = Pe(GF), YF = "YOTPO", XF = {
	enabled: !1,
	name: "",
	...Le([], GF)
}, ZF = ({ integrationId: e, configuration: t, handleRedirect: n, showNotification: r, automationCouplingState: i }) => {
	let a = !e, o = gl({
		mode: "onChange",
		defaultValues: XF
	}), { create: s, update: c, remove: l, isLoading: u, error: d, misconfigurationCause: f, setMisconfigurationCause: p } = He({
		integrationId: e,
		integrationType: YF,
		handleRedirect: n,
		showNotification: r
	}), { isLoading: m, error: h, isWidgetUnknown: g, refetch: v, widgetConfiguration: x } = Ue({
		integrationId: e,
		fieldDefinitions: GF,
		form: o,
		onMisconfigured: p
	}), S = a || !!x?.additionalProperties?.isUsingOAuth, C = (e) => ye(e, {
		fieldDefinitions: GF,
		isCreationMode: a,
		create: s,
		update: c
	}), w = o.watch("name");
	return /* @__PURE__ */ K(de, {
		form: o,
		integrationId: e,
		onValidSubmit: C,
		error: h ?? d,
		onRetry: h ? v : void 0,
		isLoading: u || m,
		isWidgetUnknown: g,
		children: [
			f && /* @__PURE__ */ G(se, { cause: f }),
			/* @__PURE__ */ K(b, { children: [
				/* @__PURE__ */ G(y, { children: /* @__PURE__ */ G(_, {
					label: "Show the widget in the conversation sidebar",
					children: /* @__PURE__ */ G(X, {
						name: "enabled",
						control: o.control
					})
				}) }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(El, {
						name: "name",
						label: "Widget name",
						control: o.control,
						rules: { required: "Name is required" },
						componentProps: {
							placeholder: "Insert the name of the widget",
							autoComplete: "off"
						}
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				!S && /* @__PURE__ */ K(W, { children: [
					/* @__PURE__ */ G(WF, { handleChangeText: (e) => o.setValue("yotpoStoreId", e?.target.value ?? "") }),
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(El, {
							name: "yotpoStoreId",
							label: JF.yotpoStoreId,
							control: o.control,
							rules: { required: "Yotpo store ID is required" },
							componentProps: {
								placeholder: "See \"How to get the Yotpo access token\" above.",
								readOnly: !0,
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ G(y, { span: 3 }),
					/* @__PURE__ */ G(y, {
						span: 3,
						children: /* @__PURE__ */ G(ue, {
							name: "yotpoAccessToken",
							label: JF.yotpoAccessToken,
							control: o.control,
							isCreationMode: a,
							rules: { required: "Yotpo access token is required" },
							componentProps: {
								placeholder: "Insert the Yotpo access token",
								autoComplete: "off"
							}
						})
					}),
					/* @__PURE__ */ G(y, { span: 3 })
				] }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: JF.showCustomerDetails,
						children: /* @__PURE__ */ G(X, {
							name: "showCustomerDetails",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: JF.showUserGeneratedContent,
						children: /* @__PURE__ */ G(X, {
							name: "showUserGeneratedContent",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				/* @__PURE__ */ G(y, {
					span: 3,
					children: /* @__PURE__ */ G(_, {
						label: JF.displayLoyalty,
						children: /* @__PURE__ */ G(X, {
							name: "displayLoyalty",
							control: o.control
						})
					})
				}),
				/* @__PURE__ */ G(y, { span: 3 }),
				S && !a && e && /* @__PURE__ */ G(ce, {
					configuration: t,
					integrationId: e,
					integrationType: YF,
					label: "Authorize with OAuth"
				})
			] }),
			/* @__PURE__ */ G(pe, {
				integrationType: YF,
				integrationId: e,
				widgetName: w,
				isCreationMode: a,
				isSubmitting: o.formState.isSubmitting,
				automationCouplingState: i,
				onConfirmDelete: () => l()
			})
		]
	});
}, QF = ({ hasShopifyOAuth: e = !1, isShopifyMarketplaceApp: t = !1, isCreationMode: n = !1 }) => n ? {
	authSettings: vO,
	featureSettings: []
} : t ? {
	authSettings: yO,
	featureSettings: [...xO]
} : e ? {
	authSettings: [...bO, ...gO],
	featureSettings: [...SO]
} : {
	authSettings: [...bO, ..._O],
	featureSettings: [...SO]
}, $F = (e, t) => ({ hasOAuth: n = !1, isCreationMode: r = !1 }) => n || r ? e : t, eI = $F(KF, qF), tI = $F(Up, Wp), nI = () => /* @__PURE__ */ G(sO, {
	label: "Connect your Shopify store",
	bannerVariant: "install"
}), rI = (e = {
	SHOPIFY: {},
	YOTPO: {},
	KLAVIYO: {}
}) => {
	let { SHOPIFY: t, YOTPO: n, KLAVIYO: r } = e, { authSettings: i, featureSettings: a } = QF(t), o = eI(n), s = tI(r);
	return {
		SHOPIFY: {
			widget: Xj,
			icon: "shopify",
			iconColors: {
				contentColor: "rgb(148, 190, 69)",
				backgroundColor: "rgba(148, 190, 69, 0.1)"
			},
			fieldDefinitions: cO,
			WidgetSettings: pO,
			MarketplaceAppSetupBanner: nI,
			settingsConfiguration: [...i, ...a]
		},
		JIRA: {
			widget: xf,
			icon: "jira",
			iconColors: {
				contentColor: "rgb(38, 132, 255)",
				backgroundColor: "rgba(38, 132, 255, 0.075)"
			},
			fieldDefinitions: Sf,
			WidgetSettings: Df
		},
		GITHUB: {
			widget: qu,
			icon: "github",
			iconColors: {
				contentColor: "rgb(87, 96, 106)",
				backgroundColor: "rgba(221, 244, 255, 0.75)"
			},
			fieldDefinitions: Ju,
			WidgetSettings: Qu
		},
		MIUROS: {
			widget: Dw,
			icon: "miuros",
			iconColors: {
				contentColor: "rgb(246, 135, 179)",
				backgroundColor: "rgba(246, 135, 179, 0.15)"
			},
			fieldDefinitions: Ow,
			WidgetSettings: Mw
		},
		KLAVIYO: {
			widget: Vp,
			icon: "klaviyo",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: Hp,
			WidgetSettings: tm,
			settingsConfiguration: [...s]
		},
		LINEAR: {
			widget: bx,
			icon: "linear",
			iconColors: {
				contentColor: "rgb(94, 106, 210)",
				backgroundColor: "rgba(94, 106, 210, 0.15)"
			},
			fieldDefinitions: xx,
			WidgetSettings: Tx
		},
		VOYADO: {
			widget: aN,
			icon: "voyado",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: oN,
			WidgetSettings: lN
		},
		LOYALTYLION: {
			widget: FS,
			icon: "loyaltylion",
			iconColors: {
				contentColor: "rgb(36, 31, 79)",
				backgroundColor: "rgba(36, 31, 79, 0.075)"
			},
			fieldDefinitions: LS,
			WidgetSettings: VS
		},
		RECHARGE: {
			widget: DT,
			icon: "recharge",
			iconColors: {
				contentColor: "rgb(57, 1, 241)",
				backgroundColor: "rgba(57, 1, 241, 0.075)"
			},
			fieldDefinitions: OT,
			WidgetSettings: FT
		},
		BRAZE: {
			widget: Kl,
			icon: "braze",
			iconColors: {
				contentColor: "rgb(48, 2, 102)",
				backgroundColor: "rgba(48, 2, 102, 0.075)"
			},
			fieldDefinitions: ql,
			WidgetSettings: Xl
		},
		YOTPO: {
			widget: HF,
			icon: "yotpo",
			iconColors: {
				contentColor: "rgb(0, 66, 228)",
				backgroundColor: "rgba(0, 66, 228, 0.075)"
			},
			fieldDefinitions: GF,
			WidgetSettings: ZF,
			settingsConfiguration: [...o]
		},
		INGRID: {
			widget: Td,
			icon: "ingrid",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: Ed,
			WidgetSettings: kd
		},
		RIVOLOYALTY: {
			widget: mE,
			icon: "rivoloyalty",
			iconColors: {
				contentColor: "rgb(0, 0, 0)",
				backgroundColor: "rgba(0, 0, 0, 0.075)"
			},
			fieldDefinitions: YD,
			WidgetSettings: eO
		},
		WOOCOMMERCE: {
			widget: HN,
			icon: "woocommerce",
			iconColors: {
				contentColor: "rgb(135, 62, 255)",
				backgroundColor: "rgba(135, 62, 255, 0.075)"
			},
			fieldDefinitions: CF,
			WidgetSettings: OF
		},
		LOOP: {
			widget: tS,
			icon: "loop",
			iconColors: {
				contentColor: "rgb(4, 114, 255)",
				backgroundColor: "rgba(4, 114, 255, 0.075)"
			},
			fieldDefinitions: rS,
			WidgetSettings: uS
		}
	};
}, iI = (e, t) => {
	let n = t.find((t) => t.key === e.key)?.value;
	return e.type === "boolean" ? Fe(n, e.defaultValue) : Ie(n, e.defaultValue);
}, aI = (e, t) => e.map((e) => ({
	key: e.key,
	value: iI(e, t)
})), oI = ({ fieldDefinitions: e }, t) => aI((e ?? []).filter(({ secret: e }) => !e), t), sI = (e, t) => e[t], cI = (e) => {
	let t = rI();
	return e.reduce((e, { id: n, type: r, name: i, settings: a, misconfigured: o, additionalProperties: s, integrationKey: c }) => {
		let l = sI(t, r);
		return l && e.push({
			id: n,
			type: r,
			name: i,
			settings: oI(l, a),
			misconfigured: o,
			additionalProperties: s,
			icon: l.icon,
			iconColors: l.iconColors,
			widget: l.widget,
			integrationKey: c
		}), e;
	}, []);
}, lI = ({ widget: e, index: n, configuration: r, conversationContext: i, showNotification: a, onToggleFn: o, isOpenFn: c, isMinimized: l, renderVisibilityToggleElement: u, renderDragElement: f }) => {
	let { track: p } = Ve(), m = Hs(), h = et(null), g = Qe(() => cI([e])[0], [e]);
	if (!g) return null;
	let { id: _, name: v, type: y, widget: b, settings: x, misconfigured: S, additionalProperties: C, icon: w, iconColors: T, integrationKey: E } = g, D = `partner-integration-${y}`, O = /* @__PURE__ */ G(t, {
		icon: w,
		color: T
	}), k = x?.reduce((e, t) => (e[t.key] = t.value, e), {});
	return l ? /* @__PURE__ */ G("div", {
		className: "icon-holder",
		children: O
	}, `partner-icon-${_}`) : /* @__PURE__ */ K(s, {
		onToggle: () => {
			p(c(E) ? "widget:collapse:closed" : "widget:collapse:opened", {
				widgetId: _,
				widgetType: y.toLowerCase()
			}), o(E);
		},
		isOpen: c(E),
		className: D,
		containerRef: h,
		children: [/* @__PURE__ */ G(s.Header, {
			wrap: "normal",
			avatar: O,
			slotBeforeTitle: f?.(E, n, h),
			slotAfterTitle: /* @__PURE__ */ G(W, { children: u?.(E) }),
			children: v
		}), /* @__PURE__ */ G(s.Content, { children: S ? /* @__PURE__ */ G(z, { isMisconfigured: !0 }) : /* @__PURE__ */ G(d, {
			fallback: /* @__PURE__ */ G(z, {}),
			children: /* @__PURE__ */ G(Bs, {
				integrationId: _,
				type: y,
				configuration: r,
				showNotification: a,
				showModal: m,
				children: qe(b, {
					conversationContext: i,
					settings: k,
					additionalProperties: C
				})
			})
		}) })]
	}, E);
}, uI = ({ configuration: e, integrationId: t, type: n, handleRedirect: r, showNotification: i, automationCouplingState: a, featureFlags: o }) => {
	let s = rI()[n]?.WidgetSettings;
	return /* @__PURE__ */ G(f.Provider, {
		value: { onError: (e, r) => console.warn(`Something went wrong with the partner widget settings of type ${n} and id ${t}`, e, r) },
		children: /* @__PURE__ */ G(Bs, {
			integrationId: t,
			type: n,
			configuration: e,
			showNotification: i,
			children: /* @__PURE__ */ G(W, { children: s && /* @__PURE__ */ G(s, {
				configuration: e,
				integrationId: t,
				handleRedirect: r,
				showNotification: i,
				automationCouplingState: a,
				featureFlags: o
			}) })
		})
	});
}, dI = "__PairingContext__", fI = globalThis[dI] ?? (() => {
	let e = Ke({});
	return globalThis[dI] = e, e;
})(), pI = () => Xe(fI), mI = ({ value: e, children: t }) => /* @__PURE__ */ G(fI.Provider, {
	value: e,
	children: t
}), hI = ut`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`;
function gI(e, { skip: t = !1 } = {}) {
	let [n, r] = U([]), [i, a] = U(!1);
	return H(() => {
		if (t) {
			a(!1);
			return;
		}
		let n = !1;
		return a(!0), Fs(e).query({ query: hI }).then(({ data: e }) => {
			n || (r((e?.Management?.widgetConfigurations ?? []).filter((e) => e != null).map(({ additionalProperties: e, ...t }) => ({
				...t,
				...e && { additionalProperties: e },
				integrationKey: `partner-integration-${t.id}`
			}))), a(!1));
		}).catch(() => {
			n || a(!1);
		}), () => {
			n = !0;
		};
	}, [e, t]), {
		isLoading: i,
		widgets: n
	};
}
//#endregion
//#region src/helpers/initializePartnerEventEmitter/initializePartnerEventEmitter.ts
var _I = (/* @__PURE__ */ Dt(((e, t) => {
	var n = typeof Reflect == "object" ? Reflect : null, r = n && typeof n.apply == "function" ? n.apply : function(e, t, n) {
		return Function.prototype.apply.call(e, t, n);
	}, i = n && typeof n.ownKeys == "function" ? n.ownKeys : Object.getOwnPropertySymbols ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : function(e) {
		return Object.getOwnPropertyNames(e);
	};
	function a(e) {
		console && console.warn && console.warn(e);
	}
	var o = Number.isNaN || function(e) {
		return e !== e;
	};
	function s() {
		s.init.call(this);
	}
	t.exports = s, t.exports.once = y, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
	var c = 10;
	function l(e) {
		if (typeof e != "function") throw TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
	}
	Object.defineProperty(s, "defaultMaxListeners", {
		enumerable: !0,
		get: function() {
			return c;
		},
		set: function(e) {
			if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received " + e + ".");
			c = e;
		}
	}), s.init = function() {
		(this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
	}, s.prototype.setMaxListeners = function(e) {
		if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"n\" is out of range. It must be a non-negative number. Received " + e + ".");
		return this._maxListeners = e, this;
	};
	function u(e) {
		return e._maxListeners === void 0 ? s.defaultMaxListeners : e._maxListeners;
	}
	s.prototype.getMaxListeners = function() {
		return u(this);
	}, s.prototype.emit = function(e) {
		for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
		var i = e === "error", a = this._events;
		if (a !== void 0) i &&= a.error === void 0;
		else if (!i) return !1;
		if (i) {
			var o;
			if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
			var s = /* @__PURE__ */ Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
			throw s.context = o, s;
		}
		var c = a[e];
		if (c === void 0) return !1;
		if (typeof c == "function") r(c, this, t);
		else for (var l = c.length, u = g(c, l), n = 0; n < l; ++n) r(u[n], this, t);
		return !0;
	};
	function d(e, t, n, r) {
		var i, o, s;
		if (l(n), o = e._events, o === void 0 ? (o = e._events = Object.create(null), e._eventsCount = 0) : (o.newListener !== void 0 && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), s = o[t]), s === void 0) s = o[t] = n, ++e._eventsCount;
		else if (typeof s == "function" ? s = o[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), i = u(e), i > 0 && s.length > i && !s.warned) {
			s.warned = !0;
			var c = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
			c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = s.length, a(c);
		}
		return e;
	}
	s.prototype.addListener = function(e, t) {
		return d(this, e, t, !1);
	}, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(e, t) {
		return d(this, e, t, !0);
	};
	function f() {
		if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
	}
	function p(e, t, n) {
		var r = {
			fired: !1,
			wrapFn: void 0,
			target: e,
			type: t,
			listener: n
		}, i = f.bind(r);
		return i.listener = n, r.wrapFn = i, i;
	}
	s.prototype.once = function(e, t) {
		return l(t), this.on(e, p(this, e, t)), this;
	}, s.prototype.prependOnceListener = function(e, t) {
		return l(t), this.prependListener(e, p(this, e, t)), this;
	}, s.prototype.removeListener = function(e, t) {
		var n, r, i, a, o;
		if (l(t), r = this._events, r === void 0 || (n = r[e], n === void 0)) return this;
		if (n === t || n.listener === t) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
		else if (typeof n != "function") {
			for (i = -1, a = n.length - 1; a >= 0; a--) if (n[a] === t || n[a].listener === t) {
				o = n[a].listener, i = a;
				break;
			}
			if (i < 0) return this;
			i === 0 ? n.shift() : _(n, i), n.length === 1 && (r[e] = n[0]), r.removeListener !== void 0 && this.emit("removeListener", e, o || t);
		}
		return this;
	}, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(e) {
		var t, n = this._events, r;
		if (n === void 0) return this;
		if (n.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete n[e]), this;
		if (arguments.length === 0) {
			var i = Object.keys(n), a;
			for (r = 0; r < i.length; ++r) a = i[r], a !== "removeListener" && this.removeAllListeners(a);
			return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
		}
		if (t = n[e], typeof t == "function") this.removeListener(e, t);
		else if (t !== void 0) for (r = t.length - 1; r >= 0; r--) this.removeListener(e, t[r]);
		return this;
	};
	function m(e, t, n) {
		var r = e._events;
		if (r === void 0) return [];
		var i = r[t];
		return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? v(i) : g(i, i.length);
	}
	s.prototype.listeners = function(e) {
		return m(this, e, !0);
	}, s.prototype.rawListeners = function(e) {
		return m(this, e, !1);
	}, s.listenerCount = function(e, t) {
		return typeof e.listenerCount == "function" ? e.listenerCount(t) : h.call(e, t);
	}, s.prototype.listenerCount = h;
	function h(e) {
		var t = this._events;
		if (t !== void 0) {
			var n = t[e];
			if (typeof n == "function") return 1;
			if (n !== void 0) return n.length;
		}
		return 0;
	}
	s.prototype.eventNames = function() {
		return this._eventsCount > 0 ? i(this._events) : [];
	};
	function g(e, t) {
		for (var n = Array(t), r = 0; r < t; ++r) n[r] = e[r];
		return n;
	}
	function _(e, t) {
		for (; t + 1 < e.length; t++) e[t] = e[t + 1];
		e.pop();
	}
	function v(e) {
		for (var t = Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
		return t;
	}
	function y(e, t) {
		return new Promise(function(n, r) {
			function i(n) {
				e.removeListener(t, a), r(n);
			}
			function a() {
				typeof e.removeListener == "function" && e.removeListener("error", i), n([].slice.call(arguments));
			}
			x(e, t, a, { once: !0 }), t !== "error" && b(e, i, { once: !0 });
		});
	}
	function b(e, t, n) {
		typeof e.on == "function" && x(e, "error", t, n);
	}
	function x(e, t, n, r) {
		if (typeof e.on == "function") r.once ? e.once(t, n) : e.on(t, n);
		else if (typeof e.addEventListener == "function") e.addEventListener(t, function i(a) {
			r.once && e.removeEventListener(t, i), n(a);
		});
		else throw TypeError("The \"emitter\" argument must be of type EventEmitter. Received type " + typeof e);
	}
})))();
function vI() {
	let e = new _I.EventEmitter();
	return e && typeof window < "u" ? window._partner = { events: e } : console.warn("Initialization of partner-integration events was not successfull."), e;
}
//#endregion
export { Is as GraphQLClientProvider, fI as PairingContext, mI as PairingProvider, lI as PartnerIntegrationCard, Us as PartnerIntegrationModalProvider, uI as PartnerIntegrationsSettings, rI as getWidgetDefinitions, vI as initializePartnerEventEmitter, pI as usePairing, Hs as usePartnerIntegrationModal, gI as usePartnerIntegrationWidgetConfigurations };
